import React, { useState, useEffect, Fragment, useRef, PureComponent, createElement, Component, Children } from 'react';
import PropTypes, { string, array, arrayOf, func, number, object, oneOf, oneOfType } from 'prop-types';
import styled, { css, keyframes, ThemeProvider, withTheme } from 'styled-components';
import crypto$1 from 'crypto';
import reactDom from 'react-dom';

var Sort = function Sort(_ref) {
    var children = _ref.children,
        by = _ref.by;

    if (!by) {
        return children;
    }
    var compare = function compare(a, b) {
        return b.props[by] - a.props[by];
    };
    return React.Children.toArray(children).sort(compare);
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/**
 *
 * @param Component
 * @return {function(*): *}
 */
var WithClock = function WithClock(Component$$1) {
    return function ClockComponent(props) {
        var _useState = useState(new Date()),
            _useState2 = slicedToArray(_useState, 2),
            date = _useState2[0],
            setDate = _useState2[1];

        useEffect(function () {
            var timerID = setInterval(function () {
                return tick();
            }, 1000);
            return function () {
                clearInterval(timerID);
            };
        }, []);

        var tick = function tick() {
            setDate(new Date());
        };

        return React.createElement(Component$$1, _extends({}, props, { date: date }));
    };
};

var WithTimer = function WithTimer(Component$$1) {
    return function TimerComponent(_ref) {
        var _ref$countFrom = _ref.countFrom,
            countFrom = _ref$countFrom === undefined ? new Date().getTime() : _ref$countFrom,
            props = objectWithoutProperties(_ref, ['countFrom']);


        var now = new Date().getTime();

        var _useState = useState(now - countFrom),
            _useState2 = slicedToArray(_useState, 2),
            passedTime = _useState2[0],
            setPassedTime = _useState2[1];

        var tick = function tick() {
            setPassedTime(new Date().getTime() - countFrom);
        };

        useEffect(function () {
            var timerID = setInterval(function () {
                return tick();
            }, 1000);
            return function () {
                clearInterval(timerID);
            };
        });

        return React.createElement(Component$$1, _extends({
            passedTime: passedTime
        }, props));
    };
};

WithTimer.propTypes = {
    countFrom: PropTypes.number.isRequired,
    setPassedTime: PropTypes.func.isRequired
};

/*
 * re-render component on safari back button
 */
var WithClearSafariPageCache = function WithClearSafariPageCache(Component$$1) {
    return function ClearCacheComponent(props) {
        var _useState = useState(false),
            _useState2 = slicedToArray(_useState, 2),
            update = _useState2[0],
            setUpdate = _useState2[1];

        var eventHandler = function eventHandler(event) {
            if (event.persisted) {
                setUpdate(true);
            }
        };

        useEffect(function () {
            setUpdate(false);
            window.addEventListener('pageshow', eventHandler);
            return function () {
                window.removeEventListener('pageshow', eventHandler);
            };
        }, [update]);

        return React.createElement(Component$$1, _extends({}, props, { key: 'update-component-key-' + update }));
    };
};

var del = "data:image/png;base64,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";

var _templateObject = taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    background-color: #fff;\n    border: solid 1px lightgrey;\n    border-radius: 30px;\n    padding: 15px 15px;\n'], ['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    background-color: #fff;\n    border: solid 1px lightgrey;\n    border-radius: 30px;\n    padding: 15px 15px;\n']),
    _templateObject2 = taggedTemplateLiteral(['\n    width: 100px;\n    height: 90px;\n    background: url(', ') no-repeat center;\n    background-size: cover;\n    border-radius: 25px;\n    border: solid 1px lightgrey;\n    text-align: center;\n    line-height: 90px;\n    font-size: 35px;\n'], ['\n    width: 100px;\n    height: 90px;\n    background: url(', ') no-repeat center;\n    background-size: cover;\n    border-radius: 25px;\n    border: solid 1px lightgrey;\n    text-align: center;\n    line-height: 90px;\n    font-size: 35px;\n']),
    _templateObject3 = taggedTemplateLiteral(['\n    flex-direction: column;\n    justify-content: space-around;\n    flex-basis: 80%;\n    padding: 0 20px;\n'], ['\n    flex-direction: column;\n    justify-content: space-around;\n    flex-basis: 80%;\n    padding: 0 20px;\n']),
    _templateObject4 = taggedTemplateLiteral(['\n    padding: 3px 5px;\n    background-color: red;\n    border-radius: 20px;\n    text-align: center;\n    color: white;\n    font-weight: bold;\n    font-size: 10px;\n'], ['\n    padding: 3px 5px;\n    background-color: red;\n    border-radius: 20px;\n    text-align: center;\n    color: white;\n    font-weight: bold;\n    font-size: 10px;\n']),
    _templateObject5 = taggedTemplateLiteral(['\n    font-size: 20px;\n    color: #404757;\n    font-weight: bold;\n    margin-top: 5px;\n'], ['\n    font-size: 20px;\n    color: #404757;\n    font-weight: bold;\n    margin-top: 5px;\n']),
    _templateObject6 = taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n'], ['\n    display: flex;\n    flex-direction: row;\n']),
    _templateObject7 = taggedTemplateLiteral(['\n    font-size: 16px;\n'], ['\n    font-size: 16px;\n']),
    _templateObject8 = taggedTemplateLiteral(['\n    padding-top: 20px;\n'], ['\n    padding-top: 20px;\n']),
    _templateObject9 = taggedTemplateLiteral(['\n    width: 20px;\n    height: 20px;\n    background: url(', ') no-repeat;\n    background-size: cover;\n    cursor: pointer;\n'], ['\n    width: 20px;\n    height: 20px;\n    background: url(', ') no-repeat;\n    background-size: cover;\n    cursor: pointer;\n']);

var CardWrapper = styled.div(_templateObject);

var Image = styled.div(_templateObject2, function (_ref) {
    var image = _ref.image;
    return image || 'none';
});

var CardContent = styled.div(_templateObject3);

var Flag = styled.span(_templateObject4);

var CardTitle = styled.p(_templateObject5);

var Row = styled.div(_templateObject6);

var Children$1 = styled(Row)(_templateObject7);

var BottomLine = styled(Row)(_templateObject8);

var CloseIcon = styled.div(_templateObject9, del);

var Card = function Card(_ref2) {
    var image = _ref2.image,
        _ref2$flag = _ref2.flag,
        flag = _ref2$flag === undefined ? '' : _ref2$flag,
        _ref2$children = _ref2.children,
        children = _ref2$children === undefined ? '' : _ref2$children,
        _ref2$title = _ref2.title,
        title = _ref2$title === undefined ? '' : _ref2$title,
        _ref2$closable = _ref2.closable,
        closable = _ref2$closable === undefined ? false : _ref2$closable,
        BottomLineContent = _ref2.BottomLineContent,
        _ref2$onClose = _ref2.onClose,
        onClose = _ref2$onClose === undefined ? function () {} : _ref2$onClose,
        _ref2$styled$CardWrap = _ref2.styled.CardWrapper,
        CardWrapper = _ref2$styled$CardWrap === undefined ? CardWrapper : _ref2$styled$CardWrap;

    return React.createElement(
        CardWrapper,
        null,
        React.createElement(
            Image,
            { image: image },
            !image ? title[0] : ''
        ),
        React.createElement(
            CardContent,
            null,
            flag && React.createElement(
                Flag,
                null,
                flag
            ),
            React.createElement(
                CardTitle,
                null,
                title
            ),
            children && React.createElement(
                Children$1,
                null,
                children
            ),
            BottomLineContent && React.createElement(
                BottomLine,
                null,
                React.createElement(BottomLineContent, null)
            )
        ),
        closable && React.createElement(CloseIcon, { onClick: onClose })
    );
};

Card.propTypes = {
    image: PropTypes.string,
    flag: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    BottomLineContent: PropTypes.elementType,
    closable: PropTypes.bool,
    onClose: PropTypes.func
};

var _templateObject$1 = taggedTemplateLiteral(['\n        ', ';\n        ', ';\n        ', ';\n        ', ';\n    '], ['\n        ', ';\n        ', ';\n        ', ';\n        ', ';\n    ']),
    _templateObject2$1 = taggedTemplateLiteral(['\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n'], ['\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n        border-radius: ', ';\n    '], ['\n        border-radius: ', ';\n    ']);

/** Prop passing Shorthands for Styled-components
 * The approach was inspired by Bootstrap 4 spacing https://getbootstrap.com/docs/4.4/utilities/spacing/
 **/

/**
 *
 * @param number {int}
 */
var getSpacingByNumber = function getSpacingByNumber(number$$1) {
    var spacingRange = [0, 1, 2, 3, 4, 5];
    if (!spacingRange.includes(number$$1)) {
        throw new Error('Spacing must be one of numbers ' + spacingRange + ', instead ' + number$$1 + ' type of ' + (typeof number$$1 === 'undefined' ? 'undefined' : _typeof(number$$1)) + ' was supplied');
    }
    switch (number$$1) {
        case 0:
            return 0;
        case 1:
            return 0.25;
        case 2:
            return 0.5;
        case 3:
            return 1;
        case 4:
            return 1.5;
        case 5:
            return 3;
        default:
            return 0;
    }
};

var borderProps = function borderProps(_ref) {
    var bt = _ref.bt,
        br = _ref.br,
        bb = _ref.bb,
        bl = _ref.bl,
        color = _ref.color;

    return css(_templateObject$1, bb && 'border-bottom: ' + (bb || '1px') + ' solid ' + color.border, bt && 'border-top: ' + (bt || '1px') + ' solid ' + color.border, bl && 'border-left: ' + (bl || '1px') + ' solid ' + color.border, br && 'border-right: ' + (br || '1px') + ' solid ' + color.border);
};

var marginProps = function marginProps(props) {
    return css(_templateObject2$1, props.mb && 'margin-bottom: ' + (getSpacingByNumber(props.mb) + 'rem'), props.mt && 'margin-top: ' + (getSpacingByNumber(props.mt) + 'rem'), props.ml && 'margin-left: ' + (getSpacingByNumber(props.ml) + 'rem'), props.mr && 'margin-right: ' + (getSpacingByNumber(props.mr) + 'rem'), props.m && 'margin: ' + (getSpacingByNumber(props.m) + 'rem'), props.mx && 'margin-right: ' + (getSpacingByNumber(props.mx) + 'rem') + ';\n         margin-left: ' + (getSpacingByNumber(props.mx) + 'rem') + ';', props.my && 'margin-top: ' + (getSpacingByNumber(props.my) + 'rem') + ';\n         margin-bottom: ' + (getSpacingByNumber(props.my) + 'rem') + ';');
};

var paddingProps = function paddingProps(props) {
    return css(_templateObject2$1, props.pb && 'padding-bottom: ' + (getSpacingByNumber(props.pb) + 'rem'), props.pt && 'padding-top: ' + (getSpacingByNumber(props.pt) + 'rem'), props.pl && 'padding-left: ' + (getSpacingByNumber(props.pl) + 'rem'), props.pr && 'padding-right: ' + (getSpacingByNumber(props.pr) + 'rem'), props.px && 'padding-right: ' + (getSpacingByNumber(props.px) + 'rem') + ';\n         padding-left: ' + (getSpacingByNumber(props.px) + 'rem') + ';', props.py && 'padding-top: ' + (getSpacingByNumber(props.py) + 'rem') + ';\n         padding-bottom: ' + (getSpacingByNumber(props.py) + 'rem') + ';', props.p && 'padding: ' + (getSpacingByNumber(props.p) + 'rem'));
};

/**
 *
 * @param borderRadius
 * @param round
 * @param bdrs          Emmit style prop
 * @return {[]|null|*}
 */
var borderRadiusProps = function borderRadiusProps(_ref2) {
    var borderRadius = _ref2.borderRadius,
        round = _ref2.round,
        bdrs = _ref2.bdrs;

    var value = borderRadius || round || bdrs || 0;

    return css(_templateObject3$1, typeof value === 'number' ? getSpacingByNumber(value) + 'rem' : 'initial');
};

var spacing = (function (props) {
    return '\n    ' + borderProps(props) + ';\n    ' + marginProps(props) + ';\n    ' + paddingProps(props) + ';\n    ' + borderRadiusProps(props) + ';\n';
});

var _templateObject$2 = taggedTemplateLiteral(['\n    border: none !important;\n    background: none;\n    padding: 0 15px;\n    font-size: 14px;\n    color: ', ';\n    font-weight: normal;\n    text-align: ', ';\n    &::placeholder {\n        color: ', ';\n        font-weight: 900;\n        opacity: 1;\n        transition: opacity 0.3s ease-in-out;\n        &:focus {\n            opacity: 1;\n            transition: opacity 0.3s ease-in-out;\n        }\n    }\n    &:focus::placeholder {\n        opacity: 0;\n        transition: opacity 0.3s ease-in-out;\n    }\n    &:focus {\n        outline: none;\n    }\n    &:-webkit-autofill,\n    &:-webkit-autofill:hover,\n    &:-webkit-autofill:focus,\n    &:-webkit-autofill:active {\n        // -webkit-box-shadow: 0 0 0 30px #eceff5 inset !important; //@TODO use it to disable autocomplete input background\n        -webkit-text-fill-color: ', ';\n    }\n'], ['\n    border: none !important;\n    background: none;\n    padding: 0 15px;\n    font-size: 14px;\n    color: ', ';\n    font-weight: normal;\n    text-align: ', ';\n    &::placeholder {\n        color: ', ';\n        font-weight: 900;\n        opacity: 1;\n        transition: opacity 0.3s ease-in-out;\n        &:focus {\n            opacity: 1;\n            transition: opacity 0.3s ease-in-out;\n        }\n    }\n    &:focus::placeholder {\n        opacity: 0;\n        transition: opacity 0.3s ease-in-out;\n    }\n    &:focus {\n        outline: none;\n    }\n    &:-webkit-autofill,\n    &:-webkit-autofill:hover,\n    &:-webkit-autofill:focus,\n    &:-webkit-autofill:active {\n        // -webkit-box-shadow: 0 0 0 30px #eceff5 inset !important; //@TODO use it to disable autocomplete input background\n        -webkit-text-fill-color: ', ';\n    }\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n    ', ';\n'], ['\n    ', ';\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n    ', ';\n    resize: none;\n'], ['\n    ', ';\n    resize: none;\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n    width: ', ';\n    margin: ', ';\n    height: ', ';\n    background: ', ';\n    color: ', ';\n    border-radius: ', ';\n    display: flex;\n    flex-flow: column;\n    justify-content: center;\n    padding: ', ';\n    text-align: ', ';\n    border: ', ';\n    ', ';\n'], ['\n    width: ', ';\n    margin: ', ';\n    height: ', ';\n    background: ', ';\n    color: ', ';\n    border-radius: ', ';\n    display: flex;\n    flex-flow: column;\n    justify-content: center;\n    padding: ', ';\n    text-align: ', ';\n    border: ', ';\n    ', ';\n']),
    _templateObject5$1 = taggedTemplateLiteral(['\n    color: ', ';\n    font-size: 10px;\n    color: ', ';\n    padding: 0 15px 5px;\n    position: absolute;\n    text-align: ', ';\n    bottom: 0;\n    display: inline-block;\n    width: ', ';\n'], ['\n    color: ', ';\n    font-size: 10px;\n    color: ', ';\n    padding: 0 15px 5px;\n    position: absolute;\n    text-align: ', ';\n    bottom: 0;\n    display: inline-block;\n    width: ', ';\n']),
    _templateObject6$1 = taggedTemplateLiteral(['\n    color: #db1c1b;\n    font-size: 12px;\n    margin: ', ';\n    padding: ', ';\n    font-family: \'Roboto Condensed\', sans-serif;\n    font-weight: 300;\n'], ['\n    color: #db1c1b;\n    font-size: 12px;\n    margin: ', ';\n    padding: ', ';\n    font-family: \'Roboto Condensed\', sans-serif;\n    font-weight: 300;\n']),
    _templateObject7$1 = taggedTemplateLiteral(['\n    color: #9198aa;\n    top: 7px;\n    font-weight: 900;\n    width: auto;\n    height: 10px;\n    padding-bottom: 0;\n'], ['\n    color: #9198aa;\n    top: 7px;\n    font-weight: 900;\n    width: auto;\n    height: 10px;\n    padding-bottom: 0;\n']),
    _templateObject8$1 = taggedTemplateLiteral(['\n    color: #9198aa;\n    cursor: pointer;\n    font-size: 14px;\n    font-family: ', ',\n        sans-serif;\n    font-weight: 300;\n    position: absolute;\n    right: 20px;\n'], ['\n    color: #9198aa;\n    cursor: pointer;\n    font-size: 14px;\n    font-family: ', ',\n        sans-serif;\n    font-weight: 300;\n    position: absolute;\n    right: 20px;\n']);

var CommonInputStyle = css(_templateObject$2, function (_ref) {
    var color = _ref.color;
    return color || '#000';
}, function (props) {
    return !props.align ? 'left' : props.align;
}, function (_ref2) {
    var color = _ref2.color;
    return color || '#d3d3d3';
}, function (_ref3) {
    var color = _ref3.color;
    return color || '#9198aa';
});

var InputControl = styled.input.attrs({
    autoComplete: 'off'
})(_templateObject2$2, CommonInputStyle);

var TextAreaControl = styled.textarea(_templateObject3$2, CommonInputStyle);

var InputWrapper = styled.div(_templateObject4$1, function (_ref4) {
    var width = _ref4.width;
    return width ? width : 'auto';
}, function (_ref5) {
    var margin = _ref5.margin;
    return !margin ? '10px' : margin;
}, function (_ref6) {
    var height = _ref6.height;
    return !height ? '30px' : height;
}, function (_ref7) {
    var bg = _ref7.bg;
    return bg || '#fff';
}, function (_ref8) {
    var color = _ref8.color;
    return color || '#000';
}, function (_ref9) {
    var radius = _ref9.radius;
    return !radius ? '25px' : radius;
}, function (_ref10) {
    var _ref10$padding = _ref10.padding,
        padding = _ref10$padding === undefined ? '10px' : _ref10$padding;
    return padding;
}, function (_ref11) {
    var align = _ref11.align;
    return !align ? 'left' : align;
}, function (props) {
    return props.validationError && props.redBorder ? '1px solid #db1c1b' : 'none';
}, spacing);

var InputSubLabel = styled.small(_templateObject5$1, function (_ref12) {
    var color = _ref12.color;
    return color ? color : '#9198aa';
}, function (_ref13) {
    var color = _ref13.color;
    return color || '#000';
}, function (_ref14) {
    var align = _ref14.align;
    return !align ? 'left' : align;
}, function (_ref15) {
    var _ref15$padding = _ref15.padding,
        padding = _ref15$padding === undefined ? '10px' : _ref15$padding,
        _ref15$margin = _ref15.margin,
        margin = _ref15$margin === undefined ? '10px' : _ref15$margin;
    return 'calc(100% - (' + padding + ' * 2) - (' + margin + ' * 2))';
});

var ErrorUnderInput = styled.p(_templateObject6$1, function (_ref16) {
    var margin = _ref16.margin;
    return !margin ? '0' : margin;
}, function (_ref17) {
    var _ref17$padding = _ref17.padding,
        padding = _ref17$padding === undefined ? '0 8px' : _ref17$padding;
    return padding;
});

var InputTopLabel = styled(InputSubLabel)(_templateObject7$1);

var ShowPasswordButton = styled.span(_templateObject8$1, function (_ref18) {
    var condensed = _ref18.condensed;
    return condensed ? 'Roboto Condensed' : 'inherit';
});

var Input = function (_React$Component) {
    inherits(Input, _React$Component);

    function Input() {
        classCallCheck(this, Input);

        var _this = possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this));

        _this.onInputFocused = function () {
            if (_this.props.value === '') {
                _this.setState({ subLabel: false });
            }

            if (_this.props.onInputFocusedHandler) {
                _this.props.onInputFocusedHandler();
            }
        };

        _this.onInputBluered = function () {
            if (_this.props.value === '') {
                _this.setState({ subLabel: true });
            }

            if (_this.props.onInputBlueredHandler) {
                _this.props.onInputBlueredHandler();
            }
        };

        _this.onInputValueChanged = function (event) {
            event.stopPropagation();
            var value = event.target.value;

            _this.props.onChange && _this.props.onChange(value);
        };

        _this.renderShowPasswordButton = function () {
            var condensed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            return React.createElement(
                ShowPasswordButton,
                {
                    condensed: condensed,
                    onClick: function onClick() {
                        return _this.setState({ passwordShown: !_this.state.passwordShown });
                    }
                },
                _this.state.passwordShown ? 'Skjul' : 'Vis'
            );
        };

        _this.renderSubLabel = function () {
            return !_this.props.validationError ? _this.state.subLabel && _this.props.sublabel ? React.createElement(
                InputSubLabel,
                { align: _this.props.align },
                _this.props.sublabel
            ) : null : !_this.props.showErrorUnderInput && React.createElement(
                InputSubLabel,
                {
                    color: 'red',
                    align: _this.props.align,
                    inputPadding: _this.props.padding
                },
                _this.props.validationError
            );
        };

        _this.state = {
            subLabel: true,
            passwordShown: false
        };
        return _this;
    }

    createClass(Input, [{
        key: 'render',
        value: function render() {
            var inputProps = _extends({}, this.props, {
                innerRef: this.props.inputRef,
                onChange: this.onInputValueChanged,
                onFocus: this.onInputFocused,
                onBlur: this.onInputBluered,
                placeholder: this.props.placeholder,
                align: this.props.align,
                condensed: this.props.condensed,
                type: this.props.type === 'password' && this.state.passwordShown ? 'text' : this.props.type
            });

            var _props = this.props,
                value = _props.value,
                topLabel = _props.topLabel,
                validationError = _props.validationError;


            var input = this.props.type === 'textarea' ? React.createElement(TextAreaControl, _extends({}, inputProps, {
                innerRef: this.props.inputRef ? this.props.inputRef : undefined
            })) : React.createElement(InputControl, _extends({}, inputProps, {
                innerRef: this.props.inputRef ? this.props.inputRef : undefined
            }));

            var InputWrapperComponent = this.props.InputWrapperComponent || InputWrapper;

            return React.createElement(
                Fragment,
                null,
                React.createElement(
                    InputWrapperComponent,
                    this.props,
                    value && topLabel && !validationError && React.createElement(
                        InputTopLabel,
                        null,
                        topLabel
                    ),
                    input,
                    ' ',
                    this.props.type === 'password' && this.renderShowPasswordButton(inputProps.condensed),
                    this.renderSubLabel()
                ),
                this.props.validationError && this.props.showErrorUnderInput && React.createElement(
                    ErrorUnderInput,
                    {
                        align: this.props.align,
                        margin: this.props.margin,
                        padding: this.props.padding
                    },
                    this.props.validationError
                )
            );
        }
    }]);
    return Input;
}(React.Component);

var _templateObject$3 = taggedTemplateLiteral(['\n    ', ';\n    ', ';\n'], ['\n    ', ';\n    ', ';\n']);

var sizing = (function (_ref) {
    var h = _ref.h,
        w = _ref.w;
    return css(_templateObject$3, h ? 'height: ' + h + 'px' : '', w ? 'width: ' + w + 'px' : '');
});

var _templateObject$4 = taggedTemplateLiteral(['\n    ', ';\n    ', ';\n    border: 1px solid #000;\n    display: flex;\n    justify-content: flex-end;\n    flex-flow: row;\n    ', '\n    & > span {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        padding-right: 10px;\n        ', '\n    }\n'], ['\n    ', ';\n    ', ';\n    border: 1px solid #000;\n    display: flex;\n    justify-content: flex-end;\n    flex-flow: row;\n    ', '\n    & > span {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        padding-right: 10px;\n        ', '\n    }\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n    width: 100%;\n    border: 0;\n    -webkit-appearance: none;\n    -moz-appearance: textfield;\n    margin: 0;\n    & > input {\n        text-align: center;\n    }\n    &::placeholder {\n        text-align: center;\n        overflow: visible;\n    }\n    &:placeholder-shown + span {\n        width: 0;\n        visibility: hidden;\n    }\n    &:not(:placeholder-shown) + span {\n        width: auto;\n        visibility: visible;\n    }\n    &:focus + span {\n        width: auto;\n        visibility: visible;\n    }\n    && + span::after {\n        content: \'', '\';\n    }\n'], ['\n    width: 100%;\n    border: 0;\n    -webkit-appearance: none;\n    -moz-appearance: textfield;\n    margin: 0;\n    & > input {\n        text-align: center;\n    }\n    &::placeholder {\n        text-align: center;\n        overflow: visible;\n    }\n    &:placeholder-shown + span {\n        width: 0;\n        visibility: hidden;\n    }\n    &:not(:placeholder-shown) + span {\n        width: auto;\n        visibility: visible;\n    }\n    &:focus + span {\n        width: auto;\n        visibility: visible;\n    }\n    && + span::after {\n        content: \'', '\';\n    }\n']);

var Wrapper = styled.section(_templateObject$4, spacing, sizing, function (_ref) {
    var inputCSS = _ref.inputCSS;
    return inputCSS;
}, function (_ref2) {
    var labelCSS = _ref2.labelCSS;
    return labelCSS;
});

var InputExtended = styled(InputControl)(_templateObject2$3, function (_ref3) {
    var labelText = _ref3.labelText;
    return labelText;
});

var LabeledInput = (function (_ref4) {
    var bdrs = _ref4.bdrs,
        p = _ref4.p,
        h = _ref4.h,
        labelText = _ref4.labelText,
        _ref4$inputCSS = _ref4.inputCSS,
        inputCSS = _ref4$inputCSS === undefined ? '' : _ref4$inputCSS,
        _ref4$labelCSS = _ref4.labelCSS,
        labelCSS = _ref4$labelCSS === undefined ? '' : _ref4$labelCSS,
        onFocus = _ref4.onFocus,
        onBlur = _ref4.onBlur,
        value = _ref4.value,
        onChange = _ref4.onChange,
        _ref4$type = _ref4.type,
        type = _ref4$type === undefined ? 'text' : _ref4$type;

    var onChangeHandler = function onChangeHandler(event) {
        event.stopPropagation();
        var value = event.target.value;
        onChange && onChange(value);
    };

    return React.createElement(
        Wrapper,
        {
            bdrs: bdrs,
            p: p,
            h: h,
            labelCSS: labelCSS,
            inputCSS: inputCSS
        },
        React.createElement(InputExtended, {
            align: 'center',
            labelText: labelText,
            onFocus: onFocus,
            onBlur: onBlur,
            value: value,
            type: type,
            onChange: onChangeHandler
        }),
        React.createElement('span', null)
    );
});

var _templateObject$5 = taggedTemplateLiteral(['\n    padding: 10px;\n    cursor: pointer;\n'], ['\n    padding: 10px;\n    cursor: pointer;\n']),
    _templateObject2$4 = taggedTemplateLiteral(['\n    ', ';\n    vertical-align: middle;\n    ', ';\n    -webkit-mask: url("', '") center center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-size: contain;\n    ', ';\n    background: ', ';\n    transform: ', ';\n    cursor: ', ';\n'], ['\n    ', ';\n    vertical-align: middle;\n    ', ';\n    -webkit-mask: url("', '") center center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-size: contain;\n    ', ';\n    background: ', ';\n    transform: ', ';\n    cursor: ', ';\n']),
    _templateObject3$3 = taggedTemplateLiteral(['\n            width: ', ';\n            height: ', ';\n        '], ['\n            width: ', ';\n            height: ', ';\n        ']);

var sizes = {
    xs: 0.67,
    sm: 0.83,
    md: 1,
    lg: 1.125,
    xl: 1.75,
    xxl: 2.25

    /**
     *
     * @param size {string}
     * @param scale {int} Use this number to increase default dimensions
     * @return {string}
     */
};var getSize = function getSize(_ref) {
    var size = _ref.size,
        _ref$scale = _ref.scale,
        scale = _ref$scale === undefined ? 1 : _ref$scale;

    var dim = scale * sizes[size];

    return '\n        width: ' + dim + 'rem;\n        height: ' + dim + 'rem;\n    ';
};

var Area = styled.span(_templateObject$5);

var Icon = styled.svg(_templateObject2$4, marginProps, function (props) {
    return props.size && getSize(props);
}, function (props) {
    return props.src ? props.src : '';
}, function (props) {
    return !props.size && css(_templateObject3$3, props.width, props.height);
}, function (props) {
    return props.color ? props.color : 'black';
}, function (_ref2) {
    var rotate = _ref2.rotate;
    return rotate ? 'rotate(' + rotate + 'deg)' : '';
}, function (_ref3) {
    var clickable = _ref3.clickable;
    return clickable ? 'pointer' : 'inherit';
});

Icon.propTypes = {
    src: PropTypes.string.isRequired,
    size: PropTypes.string,
    color: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string
};

var spinner = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAWEElEQVR4Xu2dCfxt1RTHf8uUeR7KFCJSZEgKiUaKJKEBRQORSBooVDRpoOKhFBlKQkkUKfWKh4aXJjxzk6TBHBXL5/tvndd59937v/vce86959631+dzP+9f99xz9ll77bXXXuu31jJNObn73SUtI+lpkp4i6fGSHirpIaV/HyzpgZLukHSNpAslnSjpx2b272lmkU3Dy7n7PSTdW9J9JD1a0jMkrShpBUnLS1pa0gMkcV0q/UvSKZIOlnSZmf039YeTdN3ECoC7M+GPkPQoSctJerakVWPiHy7pbjVNxEWSdjKzH9V0v1bdZqIEwN0Z78NCja8s6SUx8U+QdH9JTb3PuZK2MLPrWjV7NQymKYbVMLS7buHu941Vjlp/oaTnxUpn0kdFH5a0z7RtBa0WAHe/X0z0WpJeIOmZsfrHMe4FktYxs6tHJXGjeM44GNn3vdx9KUnPkvQqSWuGEGClj3O8GIVvNrOv9n2BCbpgnAxdjE3ujuHGxG8haT1Jy8beXpdBN8zU/EfSfmbGVjA11BoBcHeMu3dKen0c5Ti2tWZ8km6XxOrfV9LfJN1sZrdNuiS0gsHuvqGkgyQ9WdK9WjbxxRyjAeZIOk/Sk0IzsS3gOLpC0oJJdBqNTQDCeQMj3yVpa0lY+m0mVv0rzOy88C7iTcS7iNNpJUmPlPRLSWeHJxEP4u1m9r82v9TIBSDO8hh0L5e0WzCwioduXPxk5W9gZv/oHEC8E/bKKyS9OLTDBZLOQTNIukXSrWbm4xp8r+eOVABi1eOafSMWdXjx2saTbuP5q6Rtzexr/Qbr7rijcVKxraEd0AA/ja3jV5JubJNWGJkAxNFulTD0WCmc8SeBWPGfl/QeM8MQTKI40TwmvJUIA1vGxbFFXCnpujYIwkgEwN2x6DeW9FZJq0kiQjcJhIHHqj/QzP406IDdnXgFzqx1w9D9naTvIgxmdv2g963jd40LgLsTsNkp1D77ZJuJPfpWSUw2q/Wbks4wsz/XMWh3x1BcXdL6ktYIY/FkbAUzw8gcOTUqAO5OaHYPSW+I+PuoX5D9959hhLGP3yyJybwpJpr4f+eHicDd+wtJv23irB98QRu8KSKaZ0g6QdLlVbaZOpjZmAC4OxG6A8IYYgsYBTHhWNyo7p8Rx2cSJf0xBIGjWfEhvs/1rHr+Lf5GIBo/vrn7PQOvsImkzST9RdKX+ZgZgjoSakQA3B2HDkCKl0nCr9/Ic4JDTBwrmnj9mZLmxYSjyouzeCvBHHF8xP8BjuF9kp4r6VuxcHAsNX5srH1i3B3nCO7SVzY8+UzuT4Jh35OEYYW37o5RMK7O5RknBhbNeyW9Nt5lVzM7q87ndLtXbQIQ0gwyB7VPFA8VVyexGjiGsbJZ6Z+RNLeJPbrOQVe5V5yWMJjfFjbTRyQdbma8cyNUpwA8VtK7Je1Qs1uXiWdlc1xipR8taf60ATOK2Y2F9LrQomgFfBDvl3RDE5qtFgGISN47QgBA29ZFTPy1pRV/6bROfCfD3B0AzMcCBHN6CMQVdZ8ShhaAcH3i1t0r4Nd1TD5GG/i7H0jinHyWmf29jhtP0j3cHQQU2wDYR+ydj4fPgKNtLTSUAERUbANJhwT8uo5Bseo5wn0pYNnXNKH66hjoKO7h7kQa9wkvImFnwuZnmlktQjCsADxH0mcDmVsHP1jlgC6Ok3TBJMbX62BC+R5hEwCGxaGGcX15LLhv18GfgQXA3cmmwUDZqKZzPmHTwyTxYjhyMgUH4pjIdkD4HCEgmPSB2BqTA1TdGDqMAOwZ1mkdQA6cOEj4xXWptmmTnvAcAoffLxDShJg5dV0yjGE8kAC4O2AO1DSBnmGJgMvuAalq3PM17GDH+fvAUxBDwCYgEwqv5/ZmRtxiIKosAOHjZ/JfNGT6FT73L4ZEE3TJk58whWF44yfYX9LjImK56aD8qyQA8fCPStouki0ThrzYJUXI9VhewswI1GSqwIHQBGhNXMcPCu/rh8yMRVWJkgUgrFGw+p8IUEOlBxX2jCQQNqRef8TM/jDITfJvpMBZHAVOMbKeAdaeWNU1XkUASLHGKbFlpGJXnQdWPjDqryOxw+xbVR88rde7O3mSnw5UMnbA28NRlLydJgmAu4PVB7xAyBIo9yDE5J8mCVU1sNEyyIOn+TfuzrzgISRRFhTyDmb2m9R3ThUAHBHs/WwBg0C4ce0SyNndzABpZKqJA5E5jUFIfgVopiOYq1TXeV8BCF//tpI+KInCC4MQcGgks/H49iCDm/TfuPsTcaBJeqqkS/HPmBkBpL6UIgDcFA8dZ/++13d5Iu7dHSUdP4iV2vcN8gUzHHB3eExMhv0f38oeZvb7fuyZdUJj7wfO/ckhVv+BkVW7WEZNv8Hl79M54O4grgHJgDgGO0EW8zFmRnCtJ/UTABwNWP6gegdJ0Wbff0NdsOp0dix5V4arGAzmF6LiGaH0XcyMyGp1AYgABEYfXj/w7FUJlCsZQPPakAFTdfCTeH34BjDW8Qlw6uLU9lkz4++u1FMDuDsJnFiXIH2qElb/oaihbsmUVW+Wr0/jQHgIXx1bNnGa7+MtnE0LzCYAGH+ocAorViGMEKJ7BCkIW2YaIQfcnWKYRAxfE7B48IRH9QKWziYArHzOlFX3fjD6HBk/1ySadYQ8nahHRf1EvLUgh6i68sPIbO7qfOsqALH/47LlBFCFSNLA27dXdvhUYVu917o76ekc3V8aWoDSO8d1O4b3EgDw/cSaq8b7Sapk9X8xr/56J7XK3dwdt/CupLSHi/g71F7qZo/1EgCCCkdWVP+FuxejI+/9VWasgWvdHegYJwIKcpAvub6ZUbVkEVpMAKKQA27FtSuOCxg3+YBzqoYkKz4nX57AgTAGseE4ymPHHWRmwO76CgCBHzDoVSt4UE93ZzObnzC+fEnDHIgjITmaaHNAI+ROPr/TKddNA2wT6VdV/P44Gj4Vxt9U19dveN5qvb274xMgV5MjPVv0W8wMT+FC6iYATCTJiVUI6aKkOieATC3hgLuD3QA1xGmAbeAkMwNP2F0Aojgz3iPq+KQSkkVtPHz+N6T+KF/XPAcCw0l+IeF8qpcxPyua2Y3F0xfRAFHYgf2filapRIrSoWb2odQf5OtGxwF3ByjC0byYU04DeHhnqFMAcB+yR1RJ9kCa3mhm1LnJ1DIOuDvVyT5XculT8JpE3q4CQMIBRwUwgCmE5w8X43pmRhp3ppZxINBCZFiTWsaCpzzdJkWEcKEGCPcviZ5U8UzF/ZGX9hVJ29Sdt94yPk7scALSR/EpcjipzwgU/+Vm9vNFtoBwH1KqDOhXaiFHSpdQQRNocqaWcsDdiQsAGaNsD1v2dmZGR7S7bAB3p6wpASASEFMjgKBQ1zIzOmtlaikH3H2XQHbRaY05ww7ATbyIADxd0jfCd5zqBKIG32oZ8tXSmY9huTtnfwxBjHu0NpFBajktIgCUIeEiCjymEtDjV+X9P5Vd47nO3fHrUFmNKCF2G39vRu5A2QikTw/BHMq7phIlzMhRz9RiDoRHkBgNMD8QW1QZofnFVWUBoJI3wYMqANAdzQzIeKYWcyCKVAPTA+cBkTpGSvklZQHASsRjlAoCQZI2NrNTW/zueWh3Jo1Quo9oLQ0sII6CbzKzuWUBAD0CjDg1/Ytc9Jea2fmZy+3mQCC8yROgqBdEDSZS9U4rCwAeQGBEqXEArMlVMvqn3ZPP6CLIR17m82O0ZA7hvzmhLACofwy61EqfnCdXmMaGyu2f0mojDG8gASDK+kA4g/Y0s6PKAkAKGHYA6JEUIrS4XE78SGHVeK8JmB/AUAJDEBhByvMcUhaAvSPHnPp/KQQGEAHICKAUbo3xmsgVIAhESzuI7ilgBA8oCwDuQoxAkglSiNYry2b4dwqrxnuNu6PVMQIpLQeRt4kGOLgsAFT+IqWYDlcpRFsTBCCnfadwa4zXRNcy8jwoJAExd/ua2eFlAaBpM1GjVE8gUsQWMLL+NmPk4UQ/2t3J76QLWqHdZ9L3zGxOWQDILafAQGoyKKeA5YfppzfRXJ2gwbs7qGCSQormXWzfnAKOLgsA/ewo0Z5aBQwo+LPMjPo/mVrMgSgnB2SPYBDECW43MzuuLACEg8EDIC0p4WA8geuaGaXJMrWYA+5OhRfg4SCDIU5wxHFOLgsAxh9tUmlVkgoIwZ9Mvd9MLeaAu+PjwctbYD3J49jSzOaVBQC4EHgAjMFUTCDlyMg8ydRSDkSKGPNKc0rmlSDeLwPHsaATFk5Fr50roIKPNDPanGVqKQeioReaHScQmp1Engsjknt9pwC8JYpBF3tFv9fCsAARdFu/C/P34+FANPIEFl7YdiCCQHJtDjS8UwAIFvBlYS32G/VVgQnMJd/7cWpM37s7cPA5kgD9Qrjuj4+yMd4pADR/BOGbigrCC0iSARizTC3kgLuD8iLKW/gA8N8cWNhunQJAPgDqgr6/KYQ0UfefqlSZWsaBgIKR7Y0WKAx7fABbFHWbu6WH0wyKY0MKsZ+cFLmBpIllahEHAg1MqZ9VSsP6dSC5ZjqzdRMAIMTgx1LyA5l0Uow2AGHaonfPQ7kTCbR9dHSl5G9B5H6gAWZqCHcTAErDEDkqAIT9mEkw6G1mhibI1BIORF9Hqod3dnjZ28xIAp6hri5fd6cvUGqJWOwA3Iz0u8/HwfYIAJr8cEmrloaED2AjMwMdNKsAYAQSF8A72I/YBqhGuZWZ4WLMNGYOROVwyvx0Nvlg/1+9Z4WQYtyBIwfuTYAohWhMQIWwmYzTTOPlgLuz5+Oix/1bzvTGH0AQaGFTqZ5RP3fnBovVlevxaoSGjw6QAefMTGPiQLT3A/xJjcDyAsbo27Czbc9sAgA+gKpfKXkCSBS9bGkKxQki05g4EL5/4jk0liwH9WgcQZ3ARTqIzCYApIhRLwikUAoBEaMiFV6mbAymcKyBa9yd5A+cPwUAtHgKIFB8PIvQbAKwFDX/Y1JTK4aQfYItkFvDNTC5/W4ZKWCsfHoElAkYOHWc0NJpAsBV7o4UHdNFmnqNBawZFagoQDBrs6J+L5O/r8aB2PspBEVbXiJ/ZaL0D3WcSOerJADs/9SaJ18AjZBCRb+AWZsVpdwoX5POAXcn2ENuR2e9Ruo40l30lG69m2bF/oVU4UigBsBzE4eDLQCwhKrh9AzMNAIOuDsVXtDWnaBeMoK2NbMZ338lDRDbAFqANuVUnEwtIMlegyfxokH72o+AZ1PziHD7MvmbdLwUC5AtuWfnsL7o39ACa0YXsCK/vB/z2P9JMsHyzJlD/bg15PfuDiwPv03nAqWGMy56kkK6Ul8BCC1AbhmWJe5F6sykEJVDKVJ8ppnhg87UAAfcnVAvGA7APGXCIP8AuR5mhh0wuACEENCrntpyOIhSBAfn0HlRioSSJJlq5kAkfeLepcBXJ2GMs/q7dgsrLk6ZyJlrI8CAXwCpSk0gJXnk82ZG4mmmGjkQpeCx+Dmldab0Xx17/5f7ad9kAQghoHoIrWRpUJwCGCleeWvSkGp8/yX+Vu6+edhZS3cwA5QWoI93peRtVhKAEIJ1w9XIcSP196CFsFAvzqeC4WQ3jHL2fY7m/FueA7ZdEFokfiZFZlMncJFRuzuqZ7cKx0IwA9gDlKC5IgvBYEIQFd1pA8c2vGmHFmbyi3jMwamVWwYVAGoIoNLXqfAquCGpKbiHmYEfyFSBA7HyifPj7cOz17nvE4ADnk/5N2yAJBpIAGIrQP0gBKmgEX4GVoA8NVrMJA8y6U2m+KLS5NMCDkO8WyU3XO+APSrVbRxYAEII2NdpE1+lwDTtZckoPiILQZrURokXCnmSutetkCcLC08tQbiFaJ+Uuw8rAOQQUnYcmyDVQcS4EAI0Acml5Kpn6sGBOOuT2cPq75axhX0F9p+SL5XRWEMJQGgBfAIIAGf91LRyfkqdGjTBYVkTdJ/9yOzB4APb16uEL6HeXcxsoPzMOgSAe2CZUmGMrmOpxSV4a4IVHFcoV0L50kzBgej9C7IHz2uvIFzBu4HL9AwtAKEFmHTCxWiCDSvOIqcDcITvMDM6kCzx5O7wElAnofheWpX+jpT4v6xbnD+VibUIQPGwGDi4wDVSB1C6DhVGb9sltv9gnPPp90uyLVq11/yw4gnMnTPM5MP7WgUgtAGQZF4A6a2yHRRbAsBFYtu3VrVoBxC6VvwkJn6ZiJ6Co+jVswGDDy1J8u5X6oDd1S4AIQS4i7EJUGUASqs8B/wAexvpaZfPFspsxewNMYg437O/s1gA3bB46OzVjfDx4+bdP+BdtWAuq0xMpVd1d2rSkJpE1ZFUPGHxDKKIhDGPlUQe22+nrTFVRFdxoq0X5/unzcJgJh+UFdvrqXXyojEBCE0AgghAKYZhat2hMh84KuLe5KhDz5ubpmFbiNQtFgiZu/xLRnYvAkzD5LPyT+8X3q20Siuq5qr3nrne3fES4sigJW1KllHnc2AATY5oa0/Tg7lmRr37iSN3Z59HI25Mkc2E/kxoQoxi4HXnDmvwdWNYoxqgeGA4NAhg4Md+yoAzhxok+5jjD0GlsyehUHUAN5aNwBl7PJk71GPuZyBTd4F8S9y7M31+m6CRCEBoAgIYQJdBsLAKUlLPexlDWMIAHclEmotgmBmrpTUUBRo5yrHHs9opuAF4g3N9P76j8Sju8PWmu7L2G0itDA3DB2Nnq/ikdijrHAcBDyac+DdRRbAGnBzmmxlpUGMjdydUjoAz8fRhBqxJnCTFTc4xj8YOB0k6fxTNOEYqAKEJUH1oA9zG5LHRxGCYccA0qpQw8ZRApbwNBuM8M8OIbJRCxRMPoSLH2hRgiqANhh2wuX6qvhgfATLq91Gy/zej0mjDMH5oxro7uWycEvB+VT0q9ns+k08lcwTiyjhWXjts5nJoMYAZ4CHYzznDo95Z5YPwE02Glc+RGUNvpFvZIAPux/hK38deSUkailGwPVClNHXVpD6LkwQOJlbZAkkgkqiXxxZCQIoP2Hn4gW1SfFjB5ESgxpl0/uVD541hx4kjh3QtVv0nUwCcqS9b5bqxC0DppMC2QEiZ4yJW8rAMrsIHBIQJgR94LvkghE3wh+0K4cNu+XRVBE+Vl0q5tokXTHlu12vCNbqSpNfGXkqaM4KRYkAN/NwR/ZAyOiTIMPFU78afUYs7d5jxt0oAStoAFczkY1QRWcSaxrqeNEHAQMU4ZduhkhqZulj3CEMrqJUCUBIE9mA8iaSlYV1jNOJISs1SHheT2VI4ns4PAw/n1SXYHG1zZbdaAEqCwJ6MG5Uj44olC5zklLYIA74JEjIJYoHM5fTB39ekYvTHIa0TIQBlxkQbVMCRuFc5frE9rByGIxb7KLcJVDmgVlY3nkkmHHc1q/+WJnz3dQvJxAlAF2GgNAoTj42A65Vtgigkf+OMIb5ex7ESgw3ULWnvIHLwz18a+zvduPnu33VH6+qe8M77TbQAdAhD+QiHFiBzBi3B1kG3jOIsz38XXjqEAzsDJxTbDL4CIo0YbgRj8BPgUGJVY8jho+f/s8fzuWMSVvlsQvR/47Ck264mQpUAAAAASUVORK5CYII=";

var _templateObject$6 = taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n'], ['\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject2$5 = taggedTemplateLiteral(['\n    display: inline-block;\n    position: relative;\n    ', ';\n    ', ';\n    border-radius: 50%;\n    animation: ', ' 1.2s linear infinite;\n'], ['\n    display: inline-block;\n    position: relative;\n    ', ';\n    ', ';\n    border-radius: 50%;\n    animation: ', ' 1.2s linear infinite;\n']);

var rotate360 = keyframes(_templateObject$6);

var Spinner = styled(Icon)(_templateObject2$5, spacing, sizing, rotate360);

var Spinner$1 = (function (_ref) {
  var size = _ref.size,
      color = _ref.color,
      m = _ref.m;
  return React.createElement(Spinner, { m: m, src: spinner, size: size, scaleOfSize: 2, color: color });
});

var _templateObject$7 = taggedTemplateLiteral(['\n    width: ', ';\n    max-width: 100%;\n    font-size: ', ';\n\n    ', ';\n\n    padding: ', ';\n    margin: ', ';\n    color: ', ';\n    text-align: ', ';\n    font-weight: ', ';\n    ', ' ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    box-sizing: border-box;\n    text-decoration: ', ';\n'], ['\n    width: ', ';\n    max-width: 100%;\n    font-size: ', ';\n\n    ', ';\n\n    padding: ', ';\n    margin: ', ';\n    color: ', ';\n    text-align: ', ';\n    font-weight: ', ';\n    ', ' ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n    box-sizing: border-box;\n    text-decoration: ', ';\n']),
    _templateObject2$6 = taggedTemplateLiteral(['\n                  @media (min-width: ', ') {\n                      font-size: ', ';\n                  }\n              '], ['\n                  @media (min-width: ', ') {\n                      font-size: ', ';\n                  }\n              ']);

var MEDIAS = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];

var BREAKPOINTS = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
};

var MOB_TEXT_FONT_SIZES = [0.67, 0.83, 1, 1.125, 1.375];
var WEB_TEXT_FONT_SIZES = [0.67, 0.83, 1, 1.125, 1.75];

var getFontSize = function getFontSize() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'md';
    var fontSizes = arguments[1];

    for (var i = 0; i < MEDIAS.length; i++) {
        if (size === MEDIAS[i]) {
            return fontSizes[i];
        }
    }
};

var Text = styled.p(_templateObject$7, function (props) {
    return props.width ? props.width : 'auto';
}, function (props) {
    return props.size ? isNumber(props.size) ? props.size + 'px' : getFontSize(props.size, MOB_TEXT_FONT_SIZES) + 'em' : 'inherit';
}, function (props) {
    return props.size ? css(_templateObject2$6, BREAKPOINTS.lg + 'px', isNumber(props.size) ? props.size + 'px' : getFontSize(props.size, WEB_TEXT_FONT_SIZES) + 'em') : '';
}, function (props) {
    return props.padding ? props.padding : '0px';
}, function (props) {
    return props.margin ? props.margin : null;
}, function (props) {
    return props.color;
}, function (props) {
    return props.align ? props.align : 'left';
}, function (props) {
    var weight = props.bold || props.weight;
    if (weight) {
        return parseInt(weight, 10) > 0 ? weight : '700';
    }
    return 'normal';
}, function (props) {
    return props.block ? 'display: block;' : '';
}, function (props) {
    return props.short ? 'text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: auto;' : '';
}, function (props) {
    return props.shadow ? 'text-shadow: ' + props.shadow + ';' : '';
}, function (props) {
    return props.opacity ? 'opacity: ' + props.opacity + ';' : '';
}, function (props) {
    return props.height ? 'height: ' + props.height + ';' : '';
}, function (props) {
    return props.overflow ? 'overflow: ' + props.overflow + ';' : '';
}, function (props) {
    return props.condensed && 'font-family: Roboto Condensed';
}, function (props) {
    if (props.lineHeight) {
        return 'line-height: ' + props.lineHeight;
    }
}, function (props) {
    return props.strike ? 'line-through' : 'none';
});

var isNumber = function isNumber(value) {
    return typeof value === 'number';
};

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.269 26.751L1.411 6.913a3.9 3.9 0 01-.506-5.5 3.9 3.9 0 015.5-.506l21.279 17.7L47.503 1.078a3.9 3.9 0 015.515.339 3.9 3.9 0 01-.339 5.511L30.353 26.673a3.906 3.906 0 01-5.084.077z",
  fill: "#333"
});

var arrow = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2254%22%20height%3D%2227.653%22%20viewBox%3D%220%200%2054%2027.653%22%3E%3Cdefs%3E%3Cstyle%3E.a%7Bisolation%3Aisolate%3B%7D.b%7Bfill%3A%23333%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20class%3D%22a%22%20transform%3D%22translate%280.019%20-124.432%29%22%3E%3Cpath%20class%3D%22b%22%20d%3D%22M25.25%2C151.183%2C1.392%2C131.345a3.9%2C3.9%2C0%2C0%2C1-.506-5.5h0a3.9%2C3.9%2C0%2C0%2C1%2C5.5-.506l21.279%2C17.7%2C19.819-17.529a3.9%2C3.9%2C0%2C0%2C1%2C5.515.339h0a3.9%2C3.9%2C0%2C0%2C1-.339%2C5.511L30.334%2C151.105a3.906%2C3.906%2C0%2C0%2C1-5.084.077Z%22%20transform%3D%22translate%280%29%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E';

var AnsvarligtSpil = (function () {
    return React.createElement(
        Fragment,
        null,
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "b",
                null,
                "Ansvarligt Spil Politik Hos Bet25 (Bet25 Sport, Bet25 Casino, Bet25 Heste og CasinoGo)"
            )
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "i",
                null,
                "Senest opdateret den 31. oktober 2023"
            )
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "Hos Bet25 er vi meget bevidste om, at spil om penge indeb\xE6rer en risiko for spilafh\xE6ngighed. Derfor har vi lavet en politik for ansvarligt spil, som g\xE6lder p\xE5 tv\xE6rs af vores produkter (Bet25 Sport, Bet25 Casino, Bet25 Heste og CasinoGo), og som har til form\xE5l at forebygge og bek\xE6mpe ludomani.\xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "P\xE5 denne side kan du l\xE6se mere om, hvordan du spiller ansvarligt og f\xE5 information om, hvordan du kan teste dine spilvaner, links til behandlingstilbud og andre ting som er med til at sikre, at spil forbliver underholdning og ikke udvikler sig til afh\xE6ngighed.\xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "b",
                null,
                "1.1 Grundl\xE6ggende principper for ansvarligt spil"
            ),
            React.createElement("br", null),
            "N\xE5r du spiller om penge, opfordrer vi til, at du f\xF8lger en r\xE6kke grundl\xE6ggende principper for ansvarligt spil:\xA0"
        ),
        React.createElement(
            "ul",
            null,
            React.createElement(
                "li",
                null,
                "Husk, at spil er en hobby og ikke en indt\xE6gtskilde.\xA0"
            ),
            React.createElement(
                "li",
                null,
                "Fors\xF8m ikke dine sociale omgivelser og tag r\xE5d og negative reaktioner p\xE5 dit spil fra din familie, venner og arbejdskollegaer meget alvorligt.\xA0"
            ),
            React.createElement(
                "li",
                null,
                "Spil aldrig for mere, end du er villig og har r\xE5d til at tabe.\xA0"
            ),
            React.createElement(
                "li",
                null,
                "Spil aldrig under indtagelse af alkohol eller medicin.\xA0"
            ),
            React.createElement(
                "li",
                null,
                "Optag ikke et l\xE5n for at spille, og spil aldrig for penge du skal bruge til faste udgifter.\xA0"
            )
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "b",
                null,
                "1.2 Aldersgr\xE6nse "
            ),
            React.createElement("br", null),
            "Det er ikke lovligt at deltage i spil her p\xE5 siden, hvis du er under 18 \xE5r.\xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "b",
                null,
                "1.3 Selvudelukkelse"
            ),
            React.createElement("br", null),
            "Du kan til enhver tid v\xE6lge at udelukke dig selv fra at spille et spil p\xE5 hjemmesiden ved at f\xF8lge nedenst\xE5ende anvisninger. Din udelukkelse kan v\xE6re enten permanent eller midlertidig, og i udelukkesperioden kan du hverken \xE5bne eller benytte din konto.\xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "Ved en permanent udelukkelse lukkes din konto, og din tilmelding oph\xF8rer. Du kan f\xF8rst tilmelde dig som kunde igen, n\xE5r din konto har v\xE6ret lukket i \xE9t \xE5r.\xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "Ved en midlertidig udelukkelse kan du v\xE6lge at udelukke dig selv fra at spille direkte p\xE5 siden. Her kan du sp\xE6rre din konto i en af f\xF8lgende, forudbestemte perioder: 24 timer, 1 uge, 1 m\xE5ned eller permanent. \xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "Du kan udelukke dig selv fra spil direkte her p\xE5 siden, n\xE5r du er logget ind. Under dine kontoindstillinger i \xF8verste h\xF8jre hj\xF8rne, skal du blot klikke p\xE5 \u201DSelvudelukkelse\u201D og v\xE6lge i hvilket omfang, du \xF8nkser udelukkelse fra spil. Du kan i \xF8vrigt kontakte vores kundesupport for at v\xE6lge en anden udelukkelsesperiode.\xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "b",
                null,
                "1.4 ROFUS \xA0 "
            ),
            React.createElement("br", null),
            "Ved midlertidig eller permanent udelukkelse f\xE5r du endvidere mulighed for at blive registreret i Spillemyndighedens register, hvilket betyder, at du blokeres og udelukkes fra alle hjemmesider udbudt af autoriserede operat\xF8rer i Danmark (herunder alle Bet25s varem\xE6rker) i den relevante udelukkelsesperiode. Yderligere oplysninger om det nationale register f\xE5r du ved at f\xF8lge dette link::",
            ' ',
            React.createElement(
                "a",
                {
                    href: "https://www.stopspillet.dk/",
                    rel: "nofollow noopener noreferrer",
                    target: "_blank"
                },
                "https://www.stopspillet.dk"
            ),
            ' ',
            "\xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "b",
                null,
                "1.5 StopSpillet: F\xE5 r\xE5d og vejledning, hvis du har mistanke om spilafh\xE6ngighed"
            ),
            React.createElement("br", null),
            "StopSpillet er Spillemyndighedens hj\xE6lpelinje om spilafh\xE6ngighed. StopSpillet er for alle, der har brug for at tale om spilafh\xE6ngighed. Det kan v\xE6re personer, som selv har problemer med spil eller p\xE5r\xF8rende til en person, der har problemer med spil. Du kan l\xE6se mere her:",
            ' ',
            React.createElement(
                "a",
                {
                    href: "https://www.stopspillet.dk/",
                    rel: "nofollow noopener noreferrer",
                    target: "_blank"
                },
                "https://www.stopspillet.dk"
            ),
            ".\xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "StopSpillet kan kontaktes p\xE5 telefonnummer ",
            React.createElement(
                "a",
                { href: "tel:+4570222825" },
                "+ 45 70 22 28 25"
            ),
            ".\xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "Typiske tegn p\xE5 spillafh\xE6ngighed:"
        ),
        React.createElement(
            "ul",
            null,
            React.createElement(
                "li",
                null,
                "Du spiller for mere, end du har planlagt."
            ),
            React.createElement(
                "li",
                null,
                "Du har \xF8konomiske problemer som f\xF8lge af dit pengespil."
            ),
            React.createElement(
                "li",
                null,
                "Du oplever problemer i forhold til andre mennesker pga. pengespil."
            ),
            React.createElement(
                "li",
                null,
                "Dit pengespil g\xE5r ud over din uddannelse eller dit arbejde."
            ),
            React.createElement(
                "li",
                null,
                "Dit hum\xF8r p\xE5virkes af pengespillet.\xA0"
            ),
            React.createElement(
                "li",
                null,
                "Du skammer dig over m\xE5den, du spiller p\xE5, og det der sker, n\xE5r du spiller."
            ),
            React.createElement(
                "li",
                null,
                "Du t\xE6nker meget p\xE5 pengespil, og p\xE5 hvordan du skal skaffe penge til at spille for."
            ),
            React.createElement(
                "li",
                null,
                "Du l\xE5ner penge for at spille eller for at tilbagebetale spilleg\xE6ld."
            ),
            React.createElement(
                "li",
                null,
                "Du spiller for at vinde eventuelle tab tilbage."
            ),
            React.createElement(
                "li",
                null,
                "Du beg\xE5r kriminalitet for at skaffe penge til spil eller spilleg\xE6ld."
            ),
            React.createElement(
                "li",
                null,
                "Dine omgivelser har bem\xE6rket du spiller meget og kommenteret dit spilforbrug."
            )
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "b",
                null,
                "1.6 Hold \xF8je med dit tidsforbrug "
            ),
            React.createElement("br", null),
            "Via et lille ur \xF8verst p\xE5 siden vil du altid kunne holde \xF8je med, hvor l\xE6nge du har spillet i den p\xE5g\xE6ldende session, n\xE5r du er logget ind p\xE5 vores hjemmesider eller apps.    \xA0\xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "b",
                null,
                "1.7 Indbetalingsgr\xE6nse "
            ),
            React.createElement("br", null),
            "Det er et lovkrav, at du fasts\xE6tter en gr\xE6nse for, hvor meget der kan indbetales p\xE5 din spillekonto. Efterf\xF8lgende har du mulighed for at \xE6ndre denne gr\xE6nse for dine indbetalinger i form af en \xF8vre gr\xE6nse for daglige, ugentlige eller m\xE5nedlige indbetalinger. Dette kan du \xE6ndre under dine kontoindstillinger i \xF8verste h\xF8jre hj\xF8rne, n\xE5r du er logget ind.  \xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "En anmodning om at forh\xF8je den eksisterende indbetalingsgr\xE6nse vil f\xF8rst tr\xE6de i kraft 24 timer efter anmodningen. Omvendt vil en anmodning om at s\xE6nke en indbetalingsgr\xE6nse tr\xE6de i kraft med det samme. Den daglige, ugentlige eller m\xE5nedlige periode vil tr\xE6de i kraft og v\xE6re g\xE6ldende fra det minut, du har bestemt dig for den nye indbetalingsgr\xE6nse. \xA0\xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "b",
                null,
                "1.8 Markedsf\xF8ring"
            ),
            React.createElement("br", null),
            "Bet25 f\xF8lger de generelle regler for god og fair markedsf\xF8ring i henhold til den danske Markedsf\xF8ringslov. Du kan altid frabede dig at blive kontaktet af os i markedsf\xF8rings\xF8jemed, selvom du oprindeligt har takket \u201Dja\u201D til at modtage direkte markedsf\xF8ring."
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "b",
                null,
                "1.9 Behandlingstilbud for ludomani"
            ),
            React.createElement("br", null),
            "Ved mistankte om ludomani kan du henvende dig til \u201DCenter for ludomani\u201D p\xE5 telefon: ",
            ' ',
            " ",
            React.createElement(
                "a",
                {
                    href: "tel:+70111810" },
                "+70 11 18 10"
            ),
            ' ',
            " eller e-mail p\xE5",
            React.createElement(
                "a",
                {
                    href: "mailto:info@ludomani.dk",
                    rel: "nofollow noopener noreferrer",
                    target: "_blank"
                },
                ' ',
                "info@ludomani.dk"
            ),
            ' ',
            "eller l\xE6se mere p\xE5",
            ' ',
            React.createElement(
                "a",
                {
                    href: "http://www.ludomani.dk/",
                    rel: "nofollow noopener noreferrer",
                    target: "_blank"
                },
                "www.ludomani.dk"
            ),
            ", hvor du ogs\xE5 kan teste dig selv for ludomani. Desuden henviser vi til f\xF8lgende behandlingscentre i Danmark: \xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "\xB7 ",
            React.createElement(
                "a",
                { href: "https://ludomani.dk/center-for-ludomani-i-kobenhavn/", target: '_blank' },
                "Center for ludomani K\xF8benhavn"
            ),
            " ",
            ' ',
            " - N\xF8rregade 28 D, st., 1165 K\xF8benhavn K."
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "\xB7 ",
            React.createElement(
                "a",
                { href: "https://ludomani.dk/center-for-ludomani-i-odense/", target: '_blank' },
                "Center for ludomani Odense"
            ),
            " ",
            ' ',
            " - \xD8stergade 42, 5000 Odense C"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "\xB7 ",
            React.createElement(
                "a",
                { href: "https://ludomani.dk/center-for-ludomani-i-aarhus/", target: '_blank' },
                " Center for ludomani \xC5rhus"
            ),
            ' ',
            " - Gammel Munkegade 6D, 8000 \xC5rhus C"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "\xB7 ",
            React.createElement(
                "a",
                { href: "https://www.spillemyndigheden.dk/behandlingssted/center-ludomani-esbjerg", target: '_blank' },
                "Center for Ludomani Esbjerg"
            ),
            ' ',
            " - Huset Havnegade 62, 6700 Esbjerg"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "Du kan finde en opdateret liste over samtlige behandlingscentre i Danmark p\xE5 Spillemyndighedens hjemmeside:",
            ' ',
            React.createElement(
                "a",
                {
                    href: "https://www.spillemyndigheden.dk/behandlingssteder",
                    rel: "nofollow noopener noreferrer",
                    target: "_blank"
                },
                "https://www.spillemyndigheden.dk/behandlingssteder"
            )
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "b",
                null,
                "1.10 Interne procedurer for forebyggelse og bek\xE6mpelse af ludomani  \xA0"
            ),
            React.createElement("br", null),
            "Bet25s medarbejdere er tr\xE6net i at finde risikotegn p\xE5 uansvarligt spil blandt vores kunder. Vi foretager l\xF8bende analyser af alle kunders spil og spilm\xF8nstre for at identificere kunder med mulige spilproblemer eller begyndende problemer. \xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "Vi vil tage kontakt til kunder, som vi mener, udviser tegn p\xE5 ludomani eller begyndende ludomani. I nogle tilf\xE6lde vil vi ogs\xE5 s\xE6nke indbetalingsgr\xE6nser eller helt lukke konti."
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "b",
                null,
                "1.11 Blokering af hjemmesider der udbyder spil om penge "
            ),
            React.createElement("br", null),
            "Det er muligt for alle kunder at blokere for hjemmesider, som tilbyder onlinespil for penge ved at installere et eller flere af disse programmer fra blandt andet hjemmesider som:"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "\xB7 \xA0 \xA0 \xA0 \xA0",
            React.createElement(
                "a",
                {
                    href: "https://www.netnanny.com/",
                    rel: "nofollow noopener noreferrer",
                    target: "_blank"
                },
                "www.netnanny.com"
            ),
            React.createElement("br", null),
            "\xB7 \xA0 \xA0 \xA0 \xA0",
            React.createElement(
                "a",
                {
                    href: "https://www.gamblock.com/",
                    rel: "nofollow noopener noreferrer",
                    target: "_blank"
                },
                "www.gamblock.com"
            ),
            React.createElement("br", null),
            "\xB7 \xA0 \xA0 \xA0 \xA0",
            React.createElement(
                "a",
                {
                    href: "http://www.betfilter.com/",
                    rel: "nofollow noopener noreferrer",
                    target: "_blank"
                },
                "www.betfilter.com"
            )
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "b",
                null,
                "1.12 \xC9n spillekonto pr. spiller"
            ),
            React.createElement("br", null),
            "En kontoindehaver v\xE6lger et personligt brugernavn, og kontoindehaveren v\xE6lger selv password. Det er ikke muligt at \xE6ndre brugernavn. En indehaver af en midlertidig konto kan logge ind p\xE5 hjemmesiden med sit brugernavn og password. En indehaver af en permanent konto skal logge ind p\xE5 hjemmesiden ved brug af sit personlige MitID. \xA0"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "Det er kontoindehaverens eget ansvar ikke at dele nogle af disse oplysninger og holde dem hemmelige for alle andre end kontoindehaveren selv. V\xE6lg et brugernavn og password, som er sv\xE6rt at g\xE6tte sig til, og som indeholder b\xE5de sm\xE5 og store bogstaver samt tal. Gem aldrig dine oplysninger p\xE5 en m\xE5de, s\xE5 andre kan finde dem eller g\xE6tte sig til dine login-oplysninger. Hvis kontoindehaveren har grund til at tro, at andre har f\xE5et kendskab til disse oplysninger, b\xF8r kontoindehaveren omg\xE5ende kontakte Bet25s kundeservice. Hvis en kontoindehaver mister, deler eller videregiver sit konto-login, skal Bet25 ikke v\xE6re ansvarlig for og vil ikke blive gjort ansvarlig for krav, der vedr\xF8rer den p\xE5g\xE6ldende konto."
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "For at sikre dig, at din konto ikke har v\xE6ret brugt af andre, kan du, hver gang du logger ind, kontrollere f\xF8lgende:"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "\xB7 \xA0 At \u201DForrige login\u201D under din konto passer med hvorn\xE5r du sidst var p\xE5"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "\xB7 \xA0 At din balance stemmer med din forventning"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "\xB7 \xA0At dine spil stemmer overens med din forventning"
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            "Hvis du har mistanke om at andre har benyttet din konto skal du straks henvende dig til kundesupport."
        ),
        React.createElement(
            "p",
            { className: "intercom-align-left" },
            React.createElement(
                "b",
                null,
                "1.13 Regler og vilk\xE5r."
            ),
            React.createElement("br", null),
            "Alle vores regler og vilk\xE5r stemmer i overens med den danske lovgivning p\xE5 omr\xE5det og kan l\xE6ses lige her:",
            ' ',
            React.createElement("br", null),
            React.createElement(
                "p",
                { className: "intercom-align-left" },
                "\xB7 \xA0 ",
                React.createElement(
                    "b",
                    null,
                    "Bet25 Sport"
                ),
                React.createElement(
                    "a",
                    {
                        href: "https://intercom.help/25syv/da/articles/3493559-vilkar-og-betingelser",
                        rel: "nofollow noopener noreferrer",
                        target: "_blank"
                    },
                    ' ',
                    " - LINK"
                )
            ),
            React.createElement(
                "p",
                { className: "intercom-align-left" },
                "\xB7 \xA0 ",
                React.createElement(
                    "b",
                    null,
                    "Bet25 Casino"
                ),
                React.createElement(
                    "a",
                    {
                        href: "https://intercom.help/25syv/da/articles/3493598-vilkar-og-betingelser",
                        rel: "nofollow noopener noreferrer",
                        target: "_blank"
                    },
                    ' ',
                    " - LINK"
                )
            ),
            React.createElement(
                "p",
                { className: "intercom-align-left" },
                "\xB7 \xA0 ",
                React.createElement(
                    "b",
                    null,
                    "Bet25 Heste"
                ),
                React.createElement(
                    "a",
                    {
                        href: "https://intercom.help/25syv/da/articles/3493016-vilkar-og-betingelser",
                        rel: "nofollow noopener noreferrer",
                        target: "_blank"
                    },
                    ' ',
                    " - LINK"
                )
            ),
            React.createElement(
                "p",
                { className: "intercom-align-left" },
                "\xB7 \xA0 ",
                React.createElement(
                    "b",
                    null,
                    "CasinoGo"
                ),
                React.createElement(
                    "a",
                    {
                        href: "https://intercom.help/casinogo/da/articles/4660397-vilkar-og-betingelser",
                        rel: "nofollow noopener noreferrer",
                        target: "_blank"
                    },
                    ' ',
                    " - LINK"
                )
            ),
            React.createElement("br", null)
        )
    );
});

var argsSeparator = ':';

var check = function check(value) {
    var rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return !rules.some(function (rule) {
        var validatorArgs = rule.split(argsSeparator);
        var ruleName = validatorArgs.shift();
        var validator = validators[ruleName];

        if (!validator) {
            throw Error('Wrong rule: ' + rule + '. Allowed rules: ' + Object.keys(validators));
        }

        return !validator.apply(undefined, [value].concat(toConsumableArray(validatorArgs)));
    });
};

var useFilteredState = (function (defaultValue) {
    var rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var _useState = useState(defaultValue),
        _useState2 = slicedToArray(_useState, 2),
        value = _useState2[0],
        setValue = _useState2[1];

    var setCheckedValue = function setCheckedValue(value) {
        value = (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.target.value.toString() : value.toString();

        if (check(value, rules)) {
            setValue(value);
        }
    };

    return [value, setCheckedValue];
});

var validators = {
    numeric: function numeric(value) {
        return value.match(/^\d*$/);
    },
    maxNumber: function maxNumber(value, maximumNumber) {
        if (isNaN(parseInt(value, 10)) || isNaN(parseInt(maximumNumber, 10))) {
            return true;
        }
        return parseInt(value, 10) <= parseInt(maximumNumber, 10);
    },
    amount: function amount(value, maxAmount) {
        return validators.numeric(value) && validators.maxNumber(value, maxAmount);
    }
};

var thousandsDots = function thousandsDots(value) {
    if (value === undefined || value === null) {
        return value;
    }
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

var numberWithCommasAndDots = function numberWithCommasAndDots(x) {
    var parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (parts[1]) {
        parts[1] = (Math.floor(('1.' + parts[1]) * 100) / 100).toString().split('.')[1];
    }
    return parts.join(',');
};

var numberWithCommasAndDotsIntl = function numberWithCommasAndDotsIntl(x) {
    var allowDecimalZeros = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!x) {
        return allowDecimalZeros ? '0,00' : 0;
    }

    return new Intl.NumberFormat('da-DK', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(x || 0);
};

var stripTrailinSymbol = function stripTrailinSymbol(str, symbol) {
    if (str.substr(-1) === symbol) {
        return str.substr(0, str.length - 1);
    }
    return str;
};

var trimBoth = function trimBoth(str) {
    var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';

    if (str[0] === char) {
        str = str.slice(1);
    }
    if (str[str.length - 1] === char) {
        str = str.slice(0, str.length - 1);
    }
    return str;
};
var saveJSONparsing = function saveJSONparsing(jsonStr, defaultValue) {
    var parsedJson = defaultValue || [];
    if (jsonStr !== 'null' && typeof jsonStr === 'string') {
        try {
            parsedJson = JSON.parse(jsonStr);
        } catch (e) {
            parsedJson = defaultValue || [];
        }
    }

    return parsedJson;
};

var formatDenmarkCurrency = function formatDenmarkCurrency() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var fractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    return new Intl.NumberFormat('da-DK', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    }).format(value || 0);
};

var dateFormatter = function dateFormatter(data) {
    var date = data.split(' ')[0].split('.');
    var time = data.split(' ')[1];
    var formattedDate = date[0] + '/' + date[1] + '-' + date[2] + ' kl.';
    return formattedDate + ' ' + time;
};

var cutWhiteSpaces = function cutWhiteSpaces(value) {
    return value.replace(/\s/g, '');
};

var _templateObject$8 = taggedTemplateLiteral(['\n    transition: transform 400ms ease;\n    ', '\n    ', '\n'], ['\n    transition: transform 400ms ease;\n    ', '\n    ', '\n']),
    _templateObject2$7 = taggedTemplateLiteral(['\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n    & > label {\n        text-align: center;\n    }\n    ', ';\n'], ['\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n    & > label {\n        text-align: center;\n    }\n    ', ';\n']),
    _templateObject3$4 = taggedTemplateLiteral(['\n    padding: 10px 0;\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n'], ['\n    padding: 10px 0;\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n']),
    _templateObject4$2 = taggedTemplateLiteral(['\n    width: 100%;\n    height: 1px;\n    border-bottom: 1px solid #efefef;\n'], ['\n    width: 100%;\n    height: 1px;\n    border-bottom: 1px solid #efefef;\n']),
    _templateObject5$2 = taggedTemplateLiteral(['\n    text-align: center;\n    cursor: pointer;\n    font-weight: bold;\n    font-family: Roboto Condensed;\n    text-decoration: underline;\n'], ['\n    text-align: center;\n    cursor: pointer;\n    font-weight: bold;\n    font-family: Roboto Condensed;\n    text-decoration: underline;\n']),
    _templateObject6$2 = taggedTemplateLiteral(['\n    margin: 0;\n    padding-bottom: 5px;\n    text-align: center;\n'], ['\n    margin: 0;\n    padding-bottom: 5px;\n    text-align: center;\n']);

var MAX_AMOUNT = 50000;

var animation = css(_templateObject$8, function (_ref) {
    var toLeft = _ref.toLeft;
    return toLeft ? 'translateX(-100%)' : '';
}, function (_ref2) {
    var toRight = _ref2.toRight;
    return toRight ? 'translateX(100%)' : '';
});

var Wrapper$1 = styled.div(_templateObject2$7, animation);

var FormRow = styled.div(_templateObject3$4);

var Divider = styled.div(_templateObject4$2);

var Link = styled.span(_templateObject5$2);

var DefaultLabel = styled(Text)(_templateObject6$2);

var FastDepositLimitForm = function FastDepositLimitForm(_ref3) {
    var _ref3$Input = _ref3.Input,
        Input = _ref3$Input === undefined ? LabeledInput : _ref3$Input,
        _ref3$Label = _ref3.Label,
        Label = _ref3$Label === undefined ? DefaultLabel : _ref3$Label,
        MaxAmountButton = _ref3.MaxAmountButton,
        ConfirmationButton = _ref3.ConfirmationButton,
        texts = _ref3.texts,
        inputCSS = _ref3.inputCSS,
        inputLabelCSS = _ref3.inputLabelCSS,
        _ref3$showDivider = _ref3.showDivider,
        showDivider = _ref3$showDivider === undefined ? true : _ref3$showDivider,
        onConfirm = _ref3.onConfirm,
        _ref3$pending = _ref3.pending,
        pending = _ref3$pending === undefined ? false : _ref3$pending;

    var _useState = useState(texts.description),
        _useState2 = slicedToArray(_useState, 2),
        displayedText = _useState2[0],
        setDisplayedText = _useState2[1];

    var showDescriptionText = function showDescriptionText() {
        return setDisplayedText(texts.description);
    };
    var showTermsCondsText = function showTermsCondsText() {
        return setDisplayedText(React.createElement(AnsvarligtSpil, null));
    };

    var _useState3 = useState(false),
        _useState4 = slicedToArray(_useState3, 2),
        termsCondsMode = _useState4[0],
        setTermsCondsMode = _useState4[1];

    var enableTermsCondsMode = function enableTermsCondsMode() {
        showTermsCondsText();
        setTermsCondsMode(true);
    };
    var disableTermsCondsMode = function disableTermsCondsMode() {
        showDescriptionText();
        setTermsCondsMode(false);
    };

    var _useFilteredState = useFilteredState('', ['amount:' + MAX_AMOUNT]),
        _useFilteredState2 = slicedToArray(_useFilteredState, 3),
        limit = _useFilteredState2[0],
        setLimitDraft = _useFilteredState2[1],
        limitDraftValid = _useFilteredState2[2];

    var setLimit = function setLimit(value) {
        return setLimitDraft(value.replace(/\./g, ''));
    };

    var _useState5 = useState(false),
        _useState6 = slicedToArray(_useState5, 2),
        limitValid = _useState6[0],
        setLimitValid = _useState6[1];

    var setMaximumLimit = function setMaximumLimit() {
        return setLimitDraft(MAX_AMOUNT);
    };

    useEffect(function () {
        setLimitValid(limit > 0 && limit <= MAX_AMOUNT);
    }, [limit]);

    var confirm = function confirm() {
        return onConfirm(limit);
    };

    var renderIcon = function renderIcon() {
        return React.createElement(
            Area,
            { onClick: disableTermsCondsMode },
            React.createElement(Icon, { src: arrow, size: 'sm', rotate: 90, clickable: true })
        );
    };

    return React.createElement(
        Wrapper$1,
        null,
        React.createElement(
            Text,
            { size: 'xl', align: 'center', bold: true },
            termsCondsMode ? React.createElement(
                Fragment,
                null,
                renderIcon(),
                texts.termsCondsTitle
            ) : texts.title
        ),
        showDivider && React.createElement(Divider, null),
        termsCondsMode ? displayedText : React.createElement(
            Text,
            null,
            displayedText
        ),
        termsCondsMode ? null : React.createElement(
            Fragment,
            null,
            React.createElement(
                FormRow,
                null,
                React.createElement(
                    Label,
                    { size: 'xs' },
                    texts.inputLabel
                ),
                React.createElement(Input, {
                    bdrs: 1,
                    p: 1,
                    h: 40,
                    labelText: ' kr.',
                    inputCSS: inputCSS,
                    labelCSS: inputLabelCSS,
                    value: thousandsDots(limit),
                    onChange: setLimit,
                    type: 'tel'
                })
            ),
            React.createElement(
                FormRow,
                null,
                React.createElement(
                    Label,
                    { size: 'xs', condensed: true, className: 'maxamount-label' },
                    texts.maxAmountLabel
                ),
                React.createElement(
                    MaxAmountButton,
                    { onClick: setMaximumLimit },
                    texts.maxAmountBtn
                ),
                React.createElement(
                    Label,
                    { size: 'xs', className: 'confirm-label' },
                    texts.confirmBtnLabel
                )
            ),
            React.createElement(
                FormRow,
                null,
                React.createElement(
                    ConfirmationButton,
                    {
                        onClick: confirm,
                        disabled: !limitValid
                    },
                    pending ? React.createElement(Spinner$1, { size: 'sm' }) : texts.confirmBtn
                )
            ),
            React.createElement(
                Text,
                {
                    color: '#333333',
                    align: 'center',
                    size: 'md',
                    className: 'terms-and-conds'
                },
                texts.readMore,
                React.createElement(
                    Link,
                    { onClick: enableTermsCondsMode, bold: true },
                    texts.termsCondsLink
                )
            )
        )
    );
};

FastDepositLimitForm.propTypes = {
    Input: PropTypes.elementType,
    Label: PropTypes.elementType,
    Button: PropTypes.elementType,
    inputCSS: PropTypes.array,
    inputLabelCSS: PropTypes.array,
    texts: PropTypes.object,
    onConfirm: PropTypes.func,
    pending: PropTypes.bool,
    termsAndCondsCSS: PropTypes.array,
    showDivider: PropTypes.bool
};

FastDepositLimitForm.defaults = {
    texts: {
        description: 'Du bedes indtaste en daglig indbetalinsgrænse for dit spil. Dette er et krav fra spillemyndigheden, og det er ikke muligt at spille hos os, uden du har sat en indbetalinsgrænse. Bemærk, at din indbetalingsgraænse er gældende på både Rød25, Derby25 og Bet25.',
        title: 'Title',
        termsCondsTitle: 'Terms&Conditions',
        readMore: 'Læs mere om ',
        termsCondsLink: 'terms&conditions',
        maxAmountLabel: 'Max amount label',
        confirmBtnLabel: 'Ready?',
        confirmBtn: 'Confirm',
        maxAmountBtn: 'Set maximum'
    },
    onConfirm: function onConfirm() {},
    pending: false
};

var bg = "306e979d8f393740.png";

var _ref$1 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "a",
  d: "M9.715 9.718a7.47 7.47 0 001.689 4.7 5.129 5.129 0 008.293 0 7.476 7.476 0 001.683-4.694V8.232a20.137 20.137 0 00.523-4.5 9.831 9.831 0 00-.28-2.661.62.62 0 00-.621-.331 10.214 10.214 0 01-3.186-.329c-1.9-.382-4.05-.813-5.693.327h-.044a2.956 2.956 0 00-2.305 1.038 3.7 3.7 0 00-.809 2.394 28.015 28.015 0 00.75 4.766v.788zm9.233 4.077a4.163 4.163 0 01-6.8 0 6.483 6.483 0 01-1.465-4.075v-.583a8.848 8.848 0 011.113-3.412 15.263 15.263 0 017.957 1.018l.651 1.534v1.444a6.489 6.489 0 01-1.456 4.074zM12.079 1.703a2.294 2.294 0 00.5-.1c1.31-.995 3.21-.613 5.048-.244a14.738 14.738 0 002.8.386q.182 0 .359-.011a16.011 16.011 0 01-.065 4.784l-.137-.323a.486.486 0 00-.214-.236 15.556 15.556 0 00-8.9-1.176.485.485 0 00-.4.242 13.726 13.726 0 00-.82 1.736 16.393 16.393 0 01-.318-2.6 2.185 2.185 0 012.147-2.458z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "a",
  d: "M23.919 17.6l-.032-.008-2.89-.6-.764-1.159-.017-.024a.854.854 0 00-1.224-.149l-.009.008-3.435 2.954-3.437-2.958-.009-.008a.854.854 0 00-1.224.149l-.017.024-.764 1.159-2.89.6-.032.008a3.694 3.694 0 00-2.068 1.507 4.17 4.17 0 00-.725 2.327v.913a1.528 1.528 0 001.591 1.453h19.15a1.528 1.528 0 001.591-1.453v-.913a4.17 4.17 0 00-.725-2.327 3.694 3.694 0 00-2.07-1.503zm-4.411-1.109l.6.914-2.414 3.319-1.434-1.433zm-4.281 5.367h.637l.194.968h-1.024zm.8-1.238c0 .16-.1.266-.162.266h-.648c-.064 0-.162-.106-.162-.266v-.187l.486-.486.486.486v.187zm-4.443-4.129l3.248 2.8-1.437 1.437-2.414-3.319zm-6.236 5.856v-.913a3.017 3.017 0 012.068-2.894l2.762-.578 2.761 3.8a.486.486 0 00.355.2h.038a.486.486 0 00.343-.142l.567-.566a1.238 1.238 0 00.085.136l-.288 1.442H5.971a.571.571 0 01-.623-.485zm20.388 0a.571.571 0 01-.619.482h-8.069l-.288-1.442a1.244 1.244 0 00.085-.136l.567.567a.486.486 0 00.343.142h.038a.486.486 0 00.355-.2l2.761-3.8 2.762.578a3.017 3.017 0 012.068 2.894zM3.897 10.63a4.709 4.709 0 001.131 3.119 3.681 3.681 0 002.783 1.308 3.591 3.591 0 002.2-.763.486.486 0 00-.592-.77 2.628 2.628 0 01-1.609.562 3.234 3.234 0 01-2.943-3.455v-.286a8.011 8.011 0 01.484-2.264 11.378 11.378 0 012.749.158l.087.013a.494.494 0 00.071.005.486.486 0 00.07-.967l-.086-.013a11.566 11.566 0 00-3.3-.13h-.01l-.041.007-.023.006-.022.006-.028.011-.016.006-.028.014-.015.008-.024.015-.016.011-.019.015-.018.015-.015.014-.02.019-.011.013-.019.023-.01.014-.017.024-.012.021-.011.02a.287.287 0 00-.018.04c-.008.022-.043.112-.093.254a7.053 7.053 0 01-.064-.833c0-1.05.507-1.52 1.009-1.52a.49.49 0 00.07-.006.475.475 0 00.363-.093 2.553 2.553 0 011.9-.375.486.486 0 10.1-.967 3.67 3.67 0 00-2.441.47C4.235 4.388 3.428 5.41 3.428 6.87a19.879 19.879 0 00.481 3.236z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "a",
  d: "M3.4 19.429H1.238c-.152 0-.266-.091-.266-.173v-.622a1.9 1.9 0 011.29-1.82l1.769-.37.914 1.318a.487.487 0 10.8-.554l-.91-1.313.269-.407L7 16.903a.486.486 0 00.581-.779L5.5 14.572a.736.736 0 00-1.045.137l-.017.024-.485.736-1.905.4-.032.008A2.882 2.882 0 000 18.634v.622a1.2 1.2 0 001.238 1.145H3.4a.486.486 0 000-.972zM22.824 4.368a16.916 16.916 0 012.268.266c.577.093 1.13.182 1.61.213a34.609 34.609 0 01-.178 3.018l-.023-.016-.011-.007-.013-.007a8 8 0 00-3.6-1.032.486.486 0 00-.073.969 7.2 7.2 0 013.059.829 4.689 4.689 0 01.368 1.747v.286a3.234 3.234 0 01-2.943 3.455 2.628 2.628 0 01-1.609-.562.486.486 0 00-.592.77 3.591 3.591 0 002.2.763 3.681 3.681 0 002.783-1.308 4.71 4.71 0 001.131-3.119v-.525a33.173 33.173 0 00.48-5.614.485.485 0 00-.473-.607h-.04a10.732 10.732 0 01-1.916-.209 17.886 17.886 0 00-2.4-.278.486.486 0 10-.019.971zM29.078 15.875l-.032-.008-1.905-.4-.485-.736-.017-.024a.736.736 0 00-1.045-.137l-2.079 1.553a.486.486 0 00.581.779l1.895-1.415.269.408-.91 1.313a.487.487 0 10.8.554l.914-1.318 1.769.37a1.9 1.9 0 011.29 1.82v.622c0 .082-.114.173-.266.173h-2.163a.486.486 0 000 .972h2.163a1.2 1.2 0 001.238-1.144v-.622a2.882 2.882 0 00-2.017-2.76z"
});

var team = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2231.092%22%20height%3D%2223.8%22%20viewBox%3D%220%200%2031.092%2023.8%22%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill%3A%239198aa%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20transform%3D%22translate%280%200%29%22%3E%3Cpath%20class%3D%22a%22%20d%3D%22M148.373%2C69.757a7.47%2C7.47%2C0%2C0%2C0%2C1.689%2C4.7%2C5.129%2C5.129%2C0%2C0%2C0%2C8.293%2C0%2C7.476%2C7.476%2C0%2C0%2C0%2C1.683-4.694V68.271a20.137%2C20.137%2C0%2C0%2C0%2C.523-4.5%2C9.831%2C9.831%2C0%2C0%2C0-.28-2.661.62.62%2C0%2C0%2C0-.621-.331%2C10.214%2C10.214%2C0%2C0%2C1-3.186-.329c-1.9-.382-4.05-.813-5.693.327l-.044%2C0a2.956%2C2.956%2C0%2C0%2C0-2.305%2C1.038%2C3.7%2C3.7%2C0%2C0%2C0-.809%2C2.394%2C28.015%2C28.015%2C0%2C0%2C0%2C.75%2C4.766v.788Zm9.233%2C4.077a4.163%2C4.163%2C0%2C0%2C1-6.8%2C0%2C6.483%2C6.483%2C0%2C0%2C1-1.465-4.075v-.583a8.848%2C8.848%2C0%2C0%2C1%2C1.113-3.412%2C15.263%2C15.263%2C0%2C0%2C1%2C7.957%2C1.018l.651%2C1.534V69.76A6.489%2C6.489%2C0%2C0%2C1%2C157.606%2C73.834Zm-6.869-12.092a2.294%2C2.294%2C0%2C0%2C0%2C.5-.1c1.31-.995%2C3.21-.613%2C5.048-.244a14.738%2C14.738%2C0%2C0%2C0%2C2.8.386q.182%2C0%2C.359-.011a16.011%2C16.011%2C0%2C0%2C1-.065%2C4.784l-.137-.323a.486.486%2C0%2C0%2C0-.214-.236%2C15.556%2C15.556%2C0%2C0%2C0-8.9-1.176.485.485%2C0%2C0%2C0-.4.242%2C13.726%2C13.726%2C0%2C0%2C0-.82%2C1.736%2C16.393%2C16.393%2C0%2C0%2C1-.318-2.6A2.185%2C2.185%2C0%2C0%2C1%2C150.737%2C61.742Z%22%20transform%3D%22translate%28-138.658%20-60.039%29%22%2F%3E%3Cpath%20class%3D%22a%22%20d%3D%22M91.671%2C316.809l-.032-.008-2.89-.6-.764-1.159-.017-.024a.854.854%2C0%2C0%2C0-1.224-.149l-.009.008L83.3%2C317.831l-3.437-2.958-.009-.008a.854.854%2C0%2C0%2C0-1.224.149l-.017.024-.764%2C1.159-2.89.6-.032.008a3.694%2C3.694%2C0%2C0%2C0-2.068%2C1.507%2C4.17%2C4.17%2C0%2C0%2C0-.725%2C2.327v.913a1.528%2C1.528%2C0%2C0%2C0%2C1.591%2C1.453h19.15a1.528%2C1.528%2C0%2C0%2C0%2C1.591-1.453v-.913a4.17%2C4.17%2C0%2C0%2C0-.725-2.327A3.694%2C3.694%2C0%2C0%2C0%2C91.671%2C316.809ZM87.26%2C315.7l.6.914-2.414%2C3.319L84.012%2C318.5Zm-4.281%2C5.367h.637l.194.968H82.786Zm.8-1.238c0%2C.16-.1.266-.162.266h-.648c-.064%2C0-.162-.106-.162-.266v-.187l.486-.486.486.486v.187ZM79.336%2C315.7l3.248%2C2.8-1.437%2C1.437-2.414-3.319ZM73.1%2C321.556v-.913a3.017%2C3.017%2C0%2C0%2C1%2C2.068-2.894l2.762-.578%2C2.761%2C3.8a.486.486%2C0%2C0%2C0%2C.355.2h.038a.486.486%2C0%2C0%2C0%2C.343-.142l.567-.566a1.238%2C1.238%2C0%2C0%2C0%2C.085.136l-.288%2C1.442H73.723A.571.571%2C0%2C0%2C1%2C73.1%2C321.556Zm20.388%2C0a.571.571%2C0%2C0%2C1-.619.482H84.8l-.288-1.442a1.244%2C1.244%2C0%2C0%2C0%2C.085-.136l.567.567a.486.486%2C0%2C0%2C0%2C.343.142h.038a.486.486%2C0%2C0%2C0%2C.355-.2l2.761-3.8%2C2.762.578a3.017%2C3.017%2C0%2C0%2C1%2C2.068%2C2.894Z%22%20transform%3D%22translate%28-67.752%20-299.209%29%22%2F%3E%3Cpath%20class%3D%22a%22%20d%3D%22M56.731%2C130.733a4.709%2C4.709%2C0%2C0%2C0%2C1.131%2C3.119%2C3.681%2C3.681%2C0%2C0%2C0%2C2.783%2C1.308%2C3.591%2C3.591%2C0%2C0%2C0%2C2.2-.763.486.486%2C0%2C0%2C0-.592-.77%2C2.628%2C2.628%2C0%2C0%2C1-1.609.562%2C3.234%2C3.234%2C0%2C0%2C1-2.943-3.455v-.286a8.011%2C8.011%2C0%2C0%2C1%2C.484-2.264%2C11.378%2C11.378%2C0%2C0%2C1%2C2.749.158l.087.013a.494.494%2C0%2C0%2C0%2C.071.005.486.486%2C0%2C0%2C0%2C.07-.967l-.086-.013a11.566%2C11.566%2C0%2C0%2C0-3.3-.13h-.01l-.041.007-.023.006-.022.006-.028.011-.016.006-.028.014-.015.008-.024.015-.016.011-.019.015-.018.015-.015.014-.02.019-.011.013-.019.023-.01.014-.017.024-.012.021-.011.02c-.007.013-.013.026-.018.04l0%2C0h0v0c-.008.022-.043.112-.093.254a7.053%2C7.053%2C0%2C0%2C1-.064-.833c0-1.05.507-1.52%2C1.009-1.52a.49.49%2C0%2C0%2C0%2C.07-.006.475.475%2C0%2C0%2C0%2C.363-.093%2C2.553%2C2.553%2C0%2C0%2C1%2C1.9-.375.486.486%2C0%2C1%2C0%2C.1-.967%2C3.67%2C3.67%2C0%2C0%2C0-2.441.47c-1.158.009-1.965%2C1.031-1.965%2C2.491a19.879%2C19.879%2C0%2C0%2C0%2C.481%2C3.236Z%22%20transform%3D%22translate%28-52.834%20-120.103%29%22%2F%3E%3Cpath%20class%3D%22a%22%20d%3D%22M3.4%2C302.418H1.238c-.152%2C0-.266-.091-.266-.173v-.622a1.9%2C1.9%2C0%2C0%2C1%2C1.29-1.82l1.769-.37.914%2C1.318a.486.486%2C0%2C1%2C0%2C.8-.554l-.91-1.313.269-.407L7%2C299.892a.486.486%2C0%2C0%2C0%2C.581-.779L5.5%2C297.561a.736.736%2C0%2C0%2C0-1.045.137l-.017.024-.485.736-1.905.4-.032.008A2.882%2C2.882%2C0%2C0%2C0%2C0%2C301.623v.622a1.2%2C1.2%2C0%2C0%2C0%2C1.238%2C1.145H3.4a.486.486%2C0%2C0%2C0%2C0-.972Z%22%20transform%3D%22translate%280%20-282.989%29%22%2F%3E%3Cpath%20class%3D%22a%22%20d%3D%22M345.932%2C116.95a16.916%2C16.916%2C0%2C0%2C1%2C2.268.266c.577.093%2C1.13.182%2C1.61.213-.017%2C1.15-.092%2C2.185-.178%2C3.018l0%2C0-.023-.016-.011-.007-.013-.007h0a8%2C8%2C0%2C0%2C0-3.6-1.032.486.486%2C0%2C0%2C0-.073.969%2C7.2%2C7.2%2C0%2C0%2C1%2C3.059.829%2C4.689%2C4.689%2C0%2C0%2C1%2C.368%2C1.747v.286a3.234%2C3.234%2C0%2C0%2C1-2.943%2C3.455%2C2.628%2C2.628%2C0%2C0%2C1-1.609-.562.486.486%2C0%2C0%2C0-.592.77%2C3.591%2C3.591%2C0%2C0%2C0%2C2.2.763%2C3.681%2C3.681%2C0%2C0%2C0%2C2.783-1.308%2C4.71%2C4.71%2C0%2C0%2C0%2C1.131-3.119v-.525a33.173%2C33.173%2C0%2C0%2C0%2C.48-5.614.485.485%2C0%2C0%2C0-.473-.607h-.04a10.732%2C10.732%2C0%2C0%2C1-1.916-.209%2C17.886%2C17.886%2C0%2C0%2C0-2.4-.278.486.486%2C0%2C1%2C0-.019.971Z%22%20transform%3D%22translate%28-323.108%20-112.582%29%22%2F%3E%3Cpath%20class%3D%22a%22%20d%3D%22M389.759%2C298.863l-.032-.008-1.905-.4-.485-.736-.017-.024a.736.736%2C0%2C0%2C0-1.045-.137l-2.079%2C1.553a.486.486%2C0%2C0%2C0%2C.581.779l1.895-1.415.269.408-.91%2C1.313a.486.486%2C0%2C1%2C0%2C.8.554l.914-1.318%2C1.769.37a1.9%2C1.9%2C0%2C0%2C1%2C1.29%2C1.82v.622c0%2C.082-.114.173-.266.173h-2.163a.486.486%2C0%2C0%2C0%2C0%2C.972h2.163a1.2%2C1.2%2C0%2C0%2C0%2C1.238-1.144v-.622A2.882%2C2.882%2C0%2C0%2C0%2C389.759%2C298.863Z%22%20transform%3D%22translate%28-360.681%20-282.988%29%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E';

var _templateObject$9 = taggedTemplateLiteral(['\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 420px;\n'], ['\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 420px;\n']),
    _templateObject2$8 = taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin: 0px 35px 20px 30px;\n'], ['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin: 0px 35px 20px 30px;\n']),
    _templateObject3$5 = taggedTemplateLiteral(['\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n    width: 355px;\n    background: url(', ');\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-size: 100%;\n    border: solid 1px lightgrey;\n    border-radius: 30px;\n    padding: 20px 30px;\n'], ['\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n    width: 355px;\n    background: url(', ');\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-size: 100%;\n    border: solid 1px lightgrey;\n    border-radius: 30px;\n    padding: 20px 30px;\n']),
    _templateObject4$3 = taggedTemplateLiteral(['\n    margin: 0;\n'], ['\n    margin: 0;\n']),
    _templateObject5$3 = taggedTemplateLiteral(['\n    margin: 2px;\n    font-size: 16px;\n    color: #9198aa;\n    font-weight: bold;\n'], ['\n    margin: 2px;\n    font-size: 16px;\n    color: #9198aa;\n    font-weight: bold;\n']),
    _templateObject6$3 = taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n'], ['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n']),
    _templateObject7$2 = taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding-top: 10px;\n    margin-top: 17px;\n'], ['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding-top: 10px;\n    margin-top: 17px;\n']),
    _templateObject8$2 = taggedTemplateLiteral(['\n    position: absolute;\n    height: 1px;\n    background-color: lightgrey;\n    width: 100%;\n    bottom: 77px;\n    left: 0px;\n'], ['\n    position: absolute;\n    height: 1px;\n    background-color: lightgrey;\n    width: 100%;\n    bottom: 77px;\n    left: 0px;\n']),
    _templateObject9$1 = taggedTemplateLiteral(['\n    position: absolute;\n    top: 20px;\n    left: -10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 3px 7px 3px 7px;\n    background-color: #e22a2a;\n    border-radius: 15px;\n'], ['\n    position: absolute;\n    top: 20px;\n    left: -10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 3px 7px 3px 7px;\n    background-color: #e22a2a;\n    border-radius: 15px;\n']),
    _templateObject10 = taggedTemplateLiteral(['\n    margin: 2px;\n    font-size: 14px;\n    color: #9198aa;\n'], ['\n    margin: 2px;\n    font-size: 14px;\n    color: #9198aa;\n']),
    _templateObject11 = taggedTemplateLiteral(['\n    margin: 2px;\n    font-size: 20px;\n    font-weight: bold;\n    color: #404757;\n'], ['\n    margin: 2px;\n    font-size: 20px;\n    font-weight: bold;\n    color: #404757;\n']),
    _templateObject12 = taggedTemplateLiteral(['\n    background: url(', ');\n    background-repeat: no-repeat;\n    background-size: cover;\n'], ['\n    background: url(', ');\n    background-repeat: no-repeat;\n    background-size: cover;\n']),
    _templateObject13 = taggedTemplateLiteral(['\n    margin: 0;\n    font-size: 10px;\n    color: white;\n    font-weight: bold;\n'], ['\n    margin: 0;\n    font-size: 10px;\n    color: white;\n    font-weight: bold;\n']),
    _templateObject14 = taggedTemplateLiteral(['\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    text-align: center;\n    width: 150px;\n    height: 50px;\n    background-color: #ebcd32;\n    border-radius: 20px;\n'], ['\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    text-align: center;\n    width: 150px;\n    height: 50px;\n    background-color: #ebcd32;\n    border-radius: 20px;\n']),
    _templateObject15 = taggedTemplateLiteral(['\n    color: #404757;\n    font-size: 16px;\n    font-weight: bold;\n    justify-content: space-between;\n    align-items: center;\n'], ['\n    color: #404757;\n    font-size: 16px;\n    font-weight: bold;\n    justify-content: space-between;\n    align-items: center;\n']);

var Wrapper$2 = styled.div(_templateObject$9);

var TextWrapper = styled.div(_templateObject2$8);

var Card$1 = styled.div(_templateObject3$5, bg);

var TextContainer = styled.div(_templateObject4$3);

var MainText = styled.p(_templateObject5$3);

var Row$1 = styled.div(_templateObject6$3);

var RowBottom = styled.div(_templateObject7$2);

var SeparateLine = styled.div(_templateObject8$2);

var Flag$1 = styled.div(_templateObject9$1);

var CardText = styled.p(_templateObject10);

var CardBoldText = styled.p(_templateObject11);

var BackGroundWrapper = styled.div(_templateObject12, bg);

var FlagText = styled.p(_templateObject13);

var Button = styled.a(_templateObject14);

var ButtonText = styled.p(_templateObject15);

var LastGamesCard = function (_React$Component) {
    inherits(LastGamesCard, _React$Component);

    function LastGamesCard() {
        classCallCheck(this, LastGamesCard);
        return possibleConstructorReturn(this, (LastGamesCard.__proto__ || Object.getPrototypeOf(LastGamesCard)).apply(this, arguments));
    }

    createClass(LastGamesCard, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                Wrapper$2,
                null,
                this.props.bottom ? React.createElement(
                    Fragment,
                    null,
                    React.createElement(
                        TextWrapper,
                        null,
                        React.createElement(
                            MainText,
                            null,
                            'Seneste andelsspil:'
                        )
                    ),
                    React.createElement(
                        Card$1,
                        null,
                        React.createElement(
                            Flag$1,
                            null,
                            React.createElement(
                                FlagText,
                                null,
                                'NY!'
                            )
                        ),
                        React.createElement(
                            TextContainer,
                            null,
                            React.createElement(
                                CardText,
                                null,
                                'Facebook gruppe'
                            ),
                            React.createElement(
                                CardBoldText,
                                null,
                                'V75 - Solvalla 21.11.19'
                            )
                        ),
                        React.createElement(
                            Row$1,
                            null,
                            React.createElement(
                                TextContainer,
                                null,
                                React.createElement(
                                    CardText,
                                    null,
                                    'Andelspirs'
                                ),
                                React.createElement(
                                    CardBoldText,
                                    null,
                                    '100,00 kr.'
                                )
                            ),
                            React.createElement(
                                TextContainer,
                                null,
                                React.createElement(
                                    CardText,
                                    null,
                                    'Deadline'
                                ),
                                React.createElement(
                                    CardBoldText,
                                    null,
                                    '12:12:12'
                                )
                            ),
                            React.createElement(
                                TextContainer,
                                null,
                                React.createElement(
                                    CardText,
                                    null,
                                    'Kaptajn afgift'
                                ),
                                React.createElement(
                                    CardBoldText,
                                    null,
                                    '10%'
                                )
                            )
                        ),
                        React.createElement(SeparateLine, null),
                        React.createElement(
                            RowBottom,
                            null,
                            React.createElement(Icon, { src: team, size: 'xxl', clickable: true }),
                            React.createElement(
                                Button,
                                null,
                                React.createElement(
                                    ButtonText,
                                    null,
                                    'SE MERE'
                                )
                            )
                        )
                    )
                ) : React.createElement(
                    Fragment,
                    null,
                    React.createElement(
                        TextWrapper,
                        null,
                        React.createElement(
                            MainText,
                            null,
                            'Seneste andelsspil:'
                        ),
                        React.createElement(
                            MainText,
                            null,
                            'Se alle\u2002>'
                        )
                    ),
                    React.createElement(
                        Card$1,
                        null,
                        React.createElement(
                            Flag$1,
                            null,
                            React.createElement(
                                FlagText,
                                null,
                                'NY!'
                            )
                        ),
                        React.createElement(
                            TextContainer,
                            null,
                            React.createElement(
                                CardText,
                                null,
                                'Facebook gruppe'
                            ),
                            React.createElement(
                                CardBoldText,
                                null,
                                'V75 - Solvalla 21.11.19'
                            )
                        ),
                        React.createElement(
                            Row$1,
                            null,
                            React.createElement(
                                TextContainer,
                                null,
                                React.createElement(
                                    CardText,
                                    null,
                                    'Andelspirs'
                                ),
                                React.createElement(
                                    CardBoldText,
                                    null,
                                    '100,00 kr.'
                                )
                            ),
                            React.createElement(
                                TextContainer,
                                null,
                                React.createElement(
                                    CardText,
                                    null,
                                    'Deadline'
                                ),
                                React.createElement(
                                    CardBoldText,
                                    null,
                                    '12:12:12'
                                )
                            ),
                            React.createElement(
                                TextContainer,
                                null,
                                React.createElement(
                                    CardText,
                                    null,
                                    'Kaptajn afgift'
                                ),
                                React.createElement(
                                    CardBoldText,
                                    null,
                                    '10%'
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return LastGamesCard;
}(React.Component);

var _templateObject$a = taggedTemplateLiteral(['\n    display: flex;\n    ', ';\n    ', ';\n    ', ';\n    width: ', ';\n    height: ', ';\n    flex-flow: ', ';\n    justify-content: ', ';\n    align-items: ', ';\n    background: ', ';\n    flex: ', ';\n    font-size: ', ';\n    cursor: ', ';\n    box-shadow: ', ';\n    background-color: ', ';\n    border-radius: ', ';\n'], ['\n    display: flex;\n    ', ';\n    ', ';\n    ', ';\n    width: ', ';\n    height: ', ';\n    flex-flow: ', ';\n    justify-content: ', ';\n    align-items: ', ';\n    background: ', ';\n    flex: ', ';\n    font-size: ', ';\n    cursor: ', ';\n    box-shadow: ', ';\n    background-color: ', ';\n    border-radius: ', ';\n']);

var Flex = styled.div(_templateObject$a, marginProps, paddingProps, borderProps, function (props) {
    return props.width ? props.width : 'auto';
}, function (props) {
    return props.height ? props.height : 'auto';
}, function (props) {
    return props.direction ? props.direction : 'row';
}, function (props) {
    return props.justify ? props.justify : 'center';
}, function (props) {
    return props.align ? props.align : 'center';
}, function (props) {
    return props.background ? props.background : 'none';
}, function (props) {
    return props.flex ? props.flex : '1 1 auto';
}, function (props) {
    return props.fontSize ? props.fontSize : 'inherit';
}, function (props) {
    return props.cursor ? props.cursor : 'auto';
}, function (props) {
    return props.boxShadow ? props.boxShadow : 'none';
}, function (props) {
    return props.bgColor ? props.bgColor : 'none';
}, function (props) {
    return props.borderRadius ? props.borderRadius : 'none';
});

var _templateObject$b = taggedTemplateLiteral(['\n    display: inline-block;\n    color: ', ';\n    font-size: 12px;\n    @media screen and (max-width: 700px) {\n        font-size: 10px;\n    }\n'], ['\n    display: inline-block;\n    color: ', ';\n    font-size: 12px;\n    @media screen and (max-width: 700px) {\n        font-size: 10px;\n    }\n']),
    _templateObject2$9 = taggedTemplateLiteral(['\n    0% {\n      opacity: 1;\n    }\n\n    50% {\n        opacity: 0;\n    }\n'], ['\n    0% {\n      opacity: 1;\n    }\n\n    50% {\n        opacity: 0;\n    }\n']),
    _templateObject3$6 = taggedTemplateLiteral(['\n    ', ';\n'], ['\n    ', ';\n']),
    _templateObject4$4 = taggedTemplateLiteral(['\n            animation: ', ' 2s steps(1, start) infinite;\n        '], ['\n            animation: ', ' 2s steps(1, start) infinite;\n        ']);

var Wrapper$3 = styled.div(_templateObject$b, function (props) {
    return props.color ? props.color : 'inherit';
});

var FadeAnimation = keyframes(_templateObject2$9);

var Divider$1 = styled.span(_templateObject3$6, function (props) {
    return props.animateDivider && css(_templateObject4$4, FadeAnimation);
});

var DigitalDisplay = function DigitalDisplay(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === undefined ? 'inherit' : _ref$color,
        _ref$hours = _ref.hours,
        hours = _ref$hours === undefined ? '' : _ref$hours,
        _ref$minutes = _ref.minutes,
        minutes = _ref$minutes === undefined ? '' : _ref$minutes,
        _ref$seconds = _ref.seconds,
        seconds = _ref$seconds === undefined ? '' : _ref$seconds,
        _ref$animateDivider = _ref.animateDivider,
        animateDivider = _ref$animateDivider === undefined ? true : _ref$animateDivider;

    return React.createElement(
        Wrapper$3,
        { color: color },
        hours && hours,
        minutes && React.createElement(
            Fragment,
            null,
            React.createElement(
                Divider$1,
                { animateDivider: animateDivider },
                ':'
            ),
            minutes
        ),
        seconds && React.createElement(
            Fragment,
            null,
            React.createElement(
                Divider$1,
                { animateDivider: animateDivider },
                ':'
            ),
            seconds
        )
    );
};

DigitalDisplay.propTypes = {
    color: PropTypes.string,
    hours: PropTypes.string,
    minutes: PropTypes.string,
    seconds: PropTypes.string,
    animateDivider: PropTypes.bool
};

var _templateObject$c = taggedTemplateLiteral(['\n    color: ', ';\n    font-size: inherit;\n'], ['\n    color: ', ';\n    font-size: inherit;\n']);

var Wrapper$4 = styled.div(_templateObject$c, function (props) {
    return props.color ? props.color : 'inherit';
});

var pad = function pad(number$$1) {
    return number$$1 < 10 ? '0' + number$$1 : number$$1 ? number$$1.toString() : '';
};

var DigitalClock = function DigitalClock(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === undefined ? 'inherit' : _ref$color,
        _ref$displayFormat = _ref.displayFormat,
        displayFormat = _ref$displayFormat === undefined ? 'HH:mm' : _ref$displayFormat;

    var now = new Date();

    var hours = now.getHours(),
        minutes = now.getMinutes(),
        seconds = now.getSeconds();
    var ampm = '';

    if (displayFormat.includes('A')) {
        hours = now.getHours();
        minutes = now.getMinutes();
        ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours.toString() : '12';
        minutes = minutes < 10 ? '0' + minutes : minutes.toString();
    }

    return React.createElement(
        Wrapper$4,
        { color: color },
        React.createElement(DigitalDisplay, {
            hours: displayFormat.includes('HH') ? pad(hours) : '',
            minutes: displayFormat.includes('mm') ? pad(minutes) : '',
            seconds: displayFormat.includes('ss') ? pad(seconds) : '',
            color: color
        }),
        ' ' + ampm
    );
};

DigitalClock.propTypes = {
    clockColor: PropTypes.string,
    displayFormat: PropTypes.oneOf(['HH:mm', 'HH:mm:ss', 'HH:mm A', 'HH:mm:ss A'])
};

/**
 *
 * @param number {int}
 * @return {string}
 */
var pad$1 = function pad(number$$1) {
    return number$$1 < 10 ? '0' + number$$1 : number$$1 ? number$$1.toString() : '';
};

var DigitalTimer = function DigitalTimer(_ref) {
    var passedTime = _ref.passedTime,
        _ref$color = _ref.color,
        color = _ref$color === undefined ? 'inherit' : _ref$color,
        _ref$displayFormat = _ref.displayFormat,
        displayFormat = _ref$displayFormat === undefined ? 'HH:mm:ss' : _ref$displayFormat;

    var millisecondsInDay = 60 * 60 * 1000 * 24,
        millisecondsInHour = 60 * 60 * 1000;

    var timeDifference = passedTime,
        hours = Math.floor(timeDifference % millisecondsInDay / millisecondsInHour),
        minutes = Math.floor(timeDifference % millisecondsInDay % millisecondsInHour / (60 * 1000)),
        seconds = Math.floor(timeDifference % millisecondsInDay % millisecondsInHour % (60 * 1000) / 1000);

    return React.createElement(
        'div',
        null,
        React.createElement(DigitalDisplay, {
            hours: displayFormat.includes('HH') ? pad$1(hours) : '',
            minutes: displayFormat.includes('mm') ? pad$1(minutes) : '',
            seconds: displayFormat.includes('ss') ? pad$1(seconds) : '',
            color: color
        })
    );
};

DigitalTimer.propTypes = {
    passedTime: PropTypes.number.isRequired,
    color: PropTypes.string,
    displayFormat: PropTypes.string
};

var _ref$2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "a"
}, React.createElement("rect", {
  "data-name": 2,
  width: 368,
  height: 180,
  rx: 5,
  transform: "translate(.009 -.216)",
  fill: "#db1c1b",
  opacity: 0.004
})), React.createElement("pattern", {
  id: "b",
  width: 1,
  height: 1,
  patternTransform: "matrix(1 0 0 -1 0 385.885)",
  viewBox: "0 0 297.542 192.943"
}, React.createElement("image", {
  preserveAspectRatio: "none",
  width: 297.542,
  height: 192.943,
  xlinkHref: "data:image/png;base64,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"
})));

var _ref2$1 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-.009 .216)",
  clipPath: "url(#a)"
}, React.createElement("path", {
  "data-name": "Image 9",
  transform: "rotate(171 169.386 104.12)",
  fill: "url(#b)",
  d: "M0 0h297.542v192.943H0z"
}));

var rod = '814de696743d62de.svg';

var _ref$3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "a"
}, React.createElement("path", {
  d: "M0 0h200v75H0z"
})));

var _ref2$2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#a)"
}, React.createElement("path", {
  "data-name": "Path 9214",
  d: "M33.976 49.857H22.258c-5.859 0-7.812-.693-7.812-5.481a45.189 45.189 0 01.567-6.237c.945-6.615 1.764-10.332 3.339-11.907 1.386-1.449 3.843-1.638 9.513-1.638h9.324a23.337 23.337 0 00.63-4.6c0-4.725-3.276-6.3-14.238-6.3-17.766 0-19.089 8.5-21.1 23.121a69.342 69.342 0 00-.819 9.576C1.657 55.275 5 60.756 18.667 60.756c12.915 0 14.049-2.016 15.309-10.899zm25.011-11.151h-7.434c-10.143 0-12.726 4.221-13.419 9.891a18.451 18.451 0 00-.126 2.331c0 5.481 2.9 9.639 15.75 9.639a87.357 87.357 0 0013.923-.945l2.457-17.01a49.5 49.5 0 00.63-6.93c0-7.5-3.276-11.088-14.679-11.088-11.718 0-13.23 1.953-14.553 9.576h12.789c3.78 0 4.851.5 4.851 2.583a12.58 12.58 0 01-.189 1.953zm-1.008 6.867l-.879 6.048c-.882.063-1.953.063-3.024.063-3.78 0-4.725-.945-4.725-2.52 0-2.772 1.449-3.591 3.591-3.591zm30.555 5.607h-14.3a15.563 15.563 0 00-.252 2.772c0 5.922 4.536 6.8 13.734 6.8 11.591.004 14.741-3.335 15.497-8.752a18.143 18.143 0 00.126-2.016c0-5.8-3.843-7.938-9.7-10.773-4.977-2.394-5.67-2.52-5.67-3.717 0-1.008.882-1.323 2.331-1.323h14.425a15.3 15.3 0 00.5-3.465c0-5.1-4.284-6.111-13.923-6.111-11.025 0-14.175 3.717-15.183 9.135a15.144 15.144 0 00-.189 2.331c0 3.843 1.89 6.552 8.316 9.324 5.355 2.331 7.245 2.772 7.245 4.221.004 1.194-.626 1.574-2.957 1.574zm23.814-32c0 2.772 1.386 3.087 5.418 3.087 5.8 0 6.174-.5 6.867-5.292a18.03 18.03 0 00.189-2.331c0-2.52-1.26-2.646-5.607-2.646-5.229 0-5.985.189-6.678 4.977a16.37 16.37 0 00-.189 2.201zm-.819 6.174L106.678 60h11.781l4.851-34.65zm18.081.378L124.759 60h11.781l3.528-25.578a31.212 31.212 0 013.654-.252c3.213 0 4.41.756 4.41 3.276a25.4 25.4 0 01-.315 3.276L145.108 60h11.781l2.646-18.963a50.085 50.085 0 00.63-6.615c0-6.426-2.961-9.828-15.246-9.828a96.17 96.17 0 00-15.309 1.134zm34.776 22.55c0 7.749 3.339 12.474 15.246 12.474 14.805 0 16.568-6.111 18.207-18.081a45.539 45.539 0 00.441-5.607c0-7.938-3.528-12.474-15.246-12.474-14.679 0-16.506 5.922-18.207 18.081a36.424 36.424 0 00-.441 5.607zm11.655-.756a39.224 39.224 0 01.5-5.04c.945-6.552 1.071-8.316 5.418-8.316 3.591 0 4.6.945 4.6 3.654a44.933 44.933 0 01-.441 4.914c-.879 6.552-1.068 8.442-5.478 8.442-3.591 0-4.599-.945-4.599-3.654z",
  fill: "#fff"
}));

var rodLogo = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%22200%22%20height%3D%2275%22%20viewBox%3D%220%200%20200%2075%22%3E%20%20%3Cdefs%3E%20%20%20%20%3CclipPath%20id%3D%22clip-Casino%22%3E%20%20%20%20%20%20%3Crect%20width%3D%22200%22%20height%3D%2275%22%2F%3E%20%20%20%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%20%20%3Cg%20id%3D%22Casino%22%20clip-path%3D%22url%28%23clip-Casino%29%22%3E%20%20%20%20%3Cpath%20id%3D%22Path_9214%22%20data-name%3D%22Path%209214%22%20d%3D%22M-66.024-10.143H-77.742c-5.859%2C0-7.812-.693-7.812-5.481a45.189%2C45.189%2C0%2C0%2C1%2C.567-6.237c.945-6.615%2C1.764-10.332%2C3.339-11.907%2C1.386-1.449%2C3.843-1.638%2C9.513-1.638h9.324a23.337%2C23.337%2C0%2C0%2C0%2C.63-4.6c0-4.725-3.276-6.3-14.238-6.3-17.766%2C0-19.089%2C8.5-21.1%2C23.121a69.342%2C69.342%2C0%2C0%2C0-.819%2C9.576C-98.343-4.725-95%2C.756-81.333.756-68.418.756-67.284-1.26-66.024-10.143Zm25.011-11.151h-7.434c-10.143%2C0-12.726%2C4.221-13.419%2C9.891a18.451%2C18.451%2C0%2C0%2C0-.126%2C2.331c0%2C5.481%2C2.9%2C9.639%2C15.75%2C9.639A87.357%2C87.357%2C0%2C0%2C0-32.319-.378l2.457-17.01a49.5%2C49.5%2C0%2C0%2C0%2C.63-6.93c0-7.5-3.276-11.088-14.679-11.088-11.718%2C0-13.23%2C1.953-14.553%2C9.576h12.789c3.78%2C0%2C4.851.5%2C4.851%2C2.583A12.58%2C12.58%2C0%2C0%2C1-41.013-21.294Zm-1.008%2C6.867L-42.9-8.379c-.882.063-1.953.063-3.024.063-3.78%2C0-4.725-.945-4.725-2.52%2C0-2.772%2C1.449-3.591%2C3.591-3.591ZM-11.466-8.82h-14.3a15.563%2C15.563%2C0%2C0%2C0-.252%2C2.772c0%2C5.922%2C4.536%2C6.8%2C13.734%2C6.8C-.693.756%2C2.457-2.583%2C3.213-8a18.143%2C18.143%2C0%2C0%2C0%2C.126-2.016c0-5.8-3.843-7.938-9.7-10.773-4.977-2.394-5.67-2.52-5.67-3.717%2C0-1.008.882-1.323%2C2.331-1.323H4.725a15.3%2C15.3%2C0%2C0%2C0%2C.5-3.465c0-5.1-4.284-6.111-13.923-6.111-11.025%2C0-14.175%2C3.717-15.183%2C9.135a15.144%2C15.144%2C0%2C0%2C0-.189%2C2.331c0%2C3.843%2C1.89%2C6.552%2C8.316%2C9.324%2C5.355%2C2.331%2C7.245%2C2.772%2C7.245%2C4.221C-8.505-9.2-9.135-8.82-11.466-8.82Zm23.814-32c0%2C2.772%2C1.386%2C3.087%2C5.418%2C3.087%2C5.8%2C0%2C6.174-.5%2C6.867-5.292a18.03%2C18.03%2C0%2C0%2C0%2C.189-2.331c0-2.52-1.26-2.646-5.607-2.646-5.229%2C0-5.985.189-6.678%2C4.977A16.37%2C16.37%2C0%2C0%2C0%2C12.348-40.824Zm-.819%2C6.174L6.678%2C0H18.459L23.31-34.65Zm18.081.378L24.759%2C0H36.54l3.528-25.578a31.212%2C31.212%2C0%2C0%2C1%2C3.654-.252c3.213%2C0%2C4.41.756%2C4.41%2C3.276a25.4%2C25.4%2C0%2C0%2C1-.315%2C3.276L45.108%2C0H56.889l2.646-18.963a50.085%2C50.085%2C0%2C0%2C0%2C.63-6.615c0-6.426-2.961-9.828-15.246-9.828A96.17%2C96.17%2C0%2C0%2C0%2C29.61-34.272ZM64.386-11.718C64.386-3.969%2C67.725.756%2C79.632.756%2C94.437.756%2C96.2-5.355%2C97.839-17.325a45.539%2C45.539%2C0%2C0%2C0%2C.441-5.607c0-7.938-3.528-12.474-15.246-12.474-14.679%2C0-16.506%2C5.922-18.207%2C18.081A36.424%2C36.424%2C0%2C0%2C0%2C64.386-11.718Zm11.655-.756a39.224%2C39.224%2C0%2C0%2C1%2C.5-5.04c.945-6.552%2C1.071-8.316%2C5.418-8.316%2C3.591%2C0%2C4.6.945%2C4.6%2C3.654a44.933%2C44.933%2C0%2C0%2C1-.441%2C4.914C85.239-10.71%2C85.05-8.82%2C80.64-8.82%2C77.049-8.82%2C76.041-9.765%2C76.041-12.474Z%22%20transform%3D%22translate%28100%2060%29%22%20fill%3D%22%23fff%22%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E';

var derby = "eee329908911deb0.png";

var _ref$4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "a"
}, React.createElement("path", {
  d: "M0 0h176v75H0z"
})));

var _ref2$3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#a)"
}, React.createElement("path", {
  "data-name": "Path 9216",
  d: "M6.509 14.451L.146 60h12.726l2.52-17.829h12.159L25.095 60H37.82l6.426-45.549H31.458L29 32.028H16.779l2.52-17.577zM76.062 51.18H62.139c-3.717 0-5.1-.693-5.1-3.087a6.479 6.479 0 01.063-1.071h18.963c1.323 0 1.512-.315 1.638-1.071a52.383 52.383 0 001.008-9.072c0-7.749-3.4-12.285-14.868-12.285-13.923 0-16.191 5.985-17.829 18.081a48.488 48.488 0 00-.441 5.67c0 7.875 3.4 12.411 15.5 12.411 10.894 0 13.477-1.386 14.989-9.576zm-9.009-10.9h-9.009c.819-5.922 1.953-6.3 5.229-6.3 2.9 0 4.158.567 4.158 3.15a16.8 16.8 0 01-.378 3.151zm28.665 10.9h-14.3a15.563 15.563 0 00-.252 2.772c-.001 5.922 4.534 6.804 13.734 6.804 11.591 0 14.741-3.339 15.5-8.756a18.143 18.143 0 00.126-2.016c0-5.8-3.843-7.938-9.7-10.773-4.977-2.394-5.67-2.52-5.67-3.717 0-1.008.882-1.323 2.331-1.323h14.422a15.3 15.3 0 00.5-3.465c0-5.1-4.284-6.111-13.923-6.111-11.025 0-14.175 3.717-15.183 9.135a15.144 15.144 0 00-.189 2.331c0 3.843 1.89 6.552 8.316 9.324 5.355 2.331 7.245 2.772 7.245 4.221.004 1.194-.626 1.574-2.957 1.574zm23.877-33.39l-3.528 24.948a89.422 89.422 0 00-.945 9.262c0 5.922 2.268 8.757 11.151 8.757 7.812 0 9.828-1.449 10.71-9.576h-5.8c-2.961 0-3.843-.567-3.843-3.15a38.647 38.647 0 01.441-4.725l1.26-9.135h9.769l1.26-8.82h-9.77l1.134-7.56zm52.227 33.39H157.9c-3.717 0-5.1-.693-5.1-3.087a6.479 6.479 0 01.063-1.071h18.959c1.323 0 1.512-.315 1.638-1.071a52.383 52.383 0 001.008-9.072c0-7.749-3.4-12.285-14.868-12.285-13.923 0-16.191 5.985-17.829 18.081a48.488 48.488 0 00-.441 5.67c0 7.875 3.4 12.411 15.5 12.411 10.897 0 13.48-1.386 14.992-9.576zm-9.009-10.9H153.8c.819-5.922 1.953-6.3 5.229-6.3 2.9 0 4.158.567 4.158 3.15a16.8 16.8 0 01-.374 3.151z",
  fill: "#fff"
}));

var derbyLogo = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%22176%22%20height%3D%2275%22%20viewBox%3D%220%200%20176%2075%22%3E%20%20%3Cdefs%3E%20%20%20%20%3CclipPath%20id%3D%22clip-Heste%22%3E%20%20%20%20%20%20%3Crect%20width%3D%22176%22%20height%3D%2275%22%2F%3E%20%20%20%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%20%20%3Cg%20id%3D%22Heste%22%20clip-path%3D%22url%28%23clip-Heste%29%22%3E%20%20%20%20%3Cpath%20id%3D%22Path_9216%22%20data-name%3D%22Path%209216%22%20d%3D%22M-81.491-45.549-87.854%2C0h12.726l2.52-17.829h12.159L-62.905%2C0H-50.18l6.426-45.549H-56.542L-59-27.972H-71.221l2.52-17.577ZM-11.938-8.82H-25.861c-3.717%2C0-5.1-.693-5.1-3.087a6.479%2C6.479%2C0%2C0%2C1%2C.063-1.071h18.963c1.323%2C0%2C1.512-.315%2C1.638-1.071a52.383%2C52.383%2C0%2C0%2C0%2C1.008-9.072c0-7.749-3.4-12.285-14.868-12.285-13.923%2C0-16.191%2C5.985-17.829%2C18.081a48.488%2C48.488%2C0%2C0%2C0-.441%2C5.67c0%2C7.875%2C3.4%2C12.411%2C15.5%2C12.411C-16.033.756-13.45-.63-11.938-8.82Zm-9.009-10.9h-9.009c.819-5.922%2C1.953-6.3%2C5.229-6.3%2C2.9%2C0%2C4.158.567%2C4.158%2C3.15A16.8%2C16.8%2C0%2C0%2C1-20.947-19.719ZM7.718-8.82h-14.3a15.563%2C15.563%2C0%2C0%2C0-.252%2C2.772C-6.835-.126-2.3.756%2C6.9.756%2C18.491.756%2C21.641-2.583%2C22.4-8a18.143%2C18.143%2C0%2C0%2C0%2C.126-2.016c0-5.8-3.843-7.938-9.7-10.773-4.977-2.394-5.67-2.52-5.67-3.717%2C0-1.008.882-1.323%2C2.331-1.323H23.909a15.3%2C15.3%2C0%2C0%2C0%2C.5-3.465c0-5.1-4.284-6.111-13.923-6.111-11.025%2C0-14.175%2C3.717-15.183%2C9.135a15.144%2C15.144%2C0%2C0%2C0-.189%2C2.331c0%2C3.843%2C1.89%2C6.552%2C8.316%2C9.324%2C5.355%2C2.331%2C7.245%2C2.772%2C7.245%2C4.221C10.679-9.2%2C10.049-8.82%2C7.718-8.82ZM31.595-42.21%2C28.067-17.262A89.422%2C89.422%2C0%2C0%2C0%2C27.122-8c0%2C5.922%2C2.268%2C8.757%2C11.151%2C8.757%2C7.812%2C0%2C9.828-1.449%2C10.71-9.576h-5.8c-2.961%2C0-3.843-.567-3.843-3.15a38.647%2C38.647%2C0%2C0%2C1%2C.441-4.725l1.26-9.135H50.81l1.26-8.82H42.3l1.134-7.56ZM83.822-8.82H69.9c-3.717%2C0-5.1-.693-5.1-3.087a6.479%2C6.479%2C0%2C0%2C1%2C.063-1.071H83.822c1.323%2C0%2C1.512-.315%2C1.638-1.071a52.383%2C52.383%2C0%2C0%2C0%2C1.008-9.072c0-7.749-3.4-12.285-14.868-12.285-13.923%2C0-16.191%2C5.985-17.829%2C18.081a48.488%2C48.488%2C0%2C0%2C0-.441%2C5.67c0%2C7.875%2C3.4%2C12.411%2C15.5%2C12.411C79.727.756%2C82.31-.63%2C83.822-8.82Zm-9.009-10.9H65.8c.819-5.922%2C1.953-6.3%2C5.229-6.3%2C2.9%2C0%2C4.158.567%2C4.158%2C3.15A16.8%2C16.8%2C0%2C0%2C1%2C74.813-19.719Z%22%20transform%3D%22translate%2888%2060%29%22%20fill%3D%22%23fff%22%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E';

var bet = "data:image/png;base64,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";

var _ref$5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "a"
}, React.createElement("path", {
  d: "M0 0h165v75H0z"
})));

var _ref2$4 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#a)"
}, React.createElement("path", {
  "data-name": "Path 9215",
  d: "M14.968 49.857H.163a20.474 20.474 0 00-.252 3.213c0 6.111 3.843 7.686 14.931 7.686 15.12 0 17.514-4.725 18.333-9.639a20.093 20.093 0 00.189-2.646c0-5.859-3.591-9.639-10.206-15.057-4.788-3.906-6.678-4.914-6.678-6.426 0-1.89 1.26-2.394 4.1-2.394H35.7a22.243 22.243 0 00.63-4.473c0-4.851-3.465-6.426-14.868-6.426-14.3 0-16.821 5.229-17.64 10.08a18.994 18.994 0 00-.315 3.087c0 5.607 3.276 8.82 8.946 13.293 5.733 4.536 7.5 5.418 7.5 7.308-.008 2.016-1.268 2.394-4.985 2.394zm26.649-24.129L35.254 70.9h11.718L48.484 60h6.3c13.86 0 14.868-7.5 16.254-17.073a57.25 57.25 0 00.693-7.434c0-6.93-2.9-10.9-14.805-10.9a102.526 102.526 0 00-15.309 1.135zM53.02 51.18h-3.276l2.394-16.821a29.472 29.472 0 013.462-.189c3.15 0 4.095.882 4.095 3.591a43.115 43.115 0 01-.441 4.788c-.942 6.615-1.194 8.631-6.234 8.631zm22.491-2.9c0 7.751 3.339 12.476 15.246 12.476 14.8 0 16.569-6.111 18.207-18.081a45.539 45.539 0 00.441-5.607c0-7.938-3.528-12.474-15.246-12.474-14.679 0-16.506 5.922-18.207 18.081a36.424 36.424 0 00-.441 5.607zm11.655-.756a39.225 39.225 0 01.5-5.04c.945-6.552 1.071-8.316 5.418-8.316 3.591 0 4.6.945 4.6 3.654a44.932 44.932 0 01-.441 4.914c-.879 6.554-1.068 8.444-5.478 8.444-3.591 0-4.599-.945-4.599-3.654zm29.925-21.8L112.24 60h11.781l3.528-25.011a46.033 46.033 0 015.418-.252h4.788a30.267 30.267 0 00.693-5.1c0-3.591-2.016-5.04-9.009-5.04a95.709 95.709 0 00-12.348 1.131zM144.5 17.79l-3.532 24.948a89.422 89.422 0 00-.945 9.262c0 5.922 2.268 8.757 11.151 8.757 7.812-.001 9.826-1.45 10.71-9.577h-5.8c-2.961 0-3.843-.567-3.843-3.15a38.646 38.646 0 01.441-4.725l1.26-9.135h9.765l1.26-8.82h-9.761l1.134-7.56z",
  fill: "#fff"
}));

var betLogo = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%22165%22%20height%3D%2275%22%20viewBox%3D%220%200%20165%2075%22%3E%20%20%3Cdefs%3E%20%20%20%20%3CclipPath%20id%3D%22clip-Sport%22%3E%20%20%20%20%20%20%3Crect%20width%3D%22165%22%20height%3D%2275%22%2F%3E%20%20%20%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%20%20%3Cg%20id%3D%22Sport%22%20clip-path%3D%22url%28%23clip-Sport%29%22%3E%20%20%20%20%3Cpath%20id%3D%22Path_9215%22%20data-name%3D%22Path%209215%22%20d%3D%22M-67.032-10.143H-81.837a20.474%2C20.474%2C0%2C0%2C0-.252%2C3.213c0%2C6.111%2C3.843%2C7.686%2C14.931%2C7.686%2C15.12%2C0%2C17.514-4.725%2C18.333-9.639a20.093%2C20.093%2C0%2C0%2C0%2C.189-2.646c0-5.859-3.591-9.639-10.206-15.057-4.788-3.906-6.678-4.914-6.678-6.426%2C0-1.89%2C1.26-2.394%2C4.1-2.394h15.12a22.243%2C22.243%2C0%2C0%2C0%2C.63-4.473c0-4.851-3.465-6.426-14.868-6.426-14.3%2C0-16.821%2C5.229-17.64%2C10.08a18.994%2C18.994%2C0%2C0%2C0-.315%2C3.087c0%2C5.607%2C3.276%2C8.82%2C8.946%2C13.293%2C5.733%2C4.536%2C7.5%2C5.418%2C7.5%2C7.308C-62.055-10.521-63.315-10.143-67.032-10.143Zm26.649-24.129L-46.746%2C10.9h11.718L-33.516%2C0h6.3c13.86%2C0%2C14.868-7.5%2C16.254-17.073a57.25%2C57.25%2C0%2C0%2C0%2C.693-7.434c0-6.93-2.9-10.9-14.805-10.9A102.526%2C102.526%2C0%2C0%2C0-40.383-34.272ZM-28.98-8.82h-3.276l2.394-16.821A29.472%2C29.472%2C0%2C0%2C1-26.4-25.83c3.15%2C0%2C4.095.882%2C4.095%2C3.591a43.115%2C43.115%2C0%2C0%2C1-.441%2C4.788C-23.688-10.836-23.94-8.82-28.98-8.82Zm22.491-2.9C-6.489-3.969-3.15.756%2C8.757.756c14.8%2C0%2C16.569-6.111%2C18.207-18.081a45.539%2C45.539%2C0%2C0%2C0%2C.441-5.607c0-7.938-3.528-12.474-15.246-12.474-14.679%2C0-16.506%2C5.922-18.207%2C18.081A36.424%2C36.424%2C0%2C0%2C0-6.489-11.718Zm11.655-.756a39.225%2C39.225%2C0%2C0%2C1%2C.5-5.04c.945-6.552%2C1.071-8.316%2C5.418-8.316%2C3.591%2C0%2C4.6.945%2C4.6%2C3.654a44.932%2C44.932%2C0%2C0%2C1-.441%2C4.914C14.364-10.71%2C14.175-8.82%2C9.765-8.82%2C6.174-8.82%2C5.166-9.765%2C5.166-12.474Zm29.925-21.8L30.24%2C0H42.021l3.528-25.011a46.033%2C46.033%2C0%2C0%2C1%2C5.418-.252h4.788a30.267%2C30.267%2C0%2C0%2C0%2C.693-5.1c0-3.591-2.016-5.04-9.009-5.04A95.709%2C95.709%2C0%2C0%2C0%2C35.091-34.272ZM62.5-42.21%2C58.968-17.262A89.422%2C89.422%2C0%2C0%2C0%2C58.023-8c0%2C5.922%2C2.268%2C8.757%2C11.151%2C8.757C76.986.756%2C79-.693%2C79.884-8.82h-5.8c-2.961%2C0-3.843-.567-3.843-3.15a38.646%2C38.646%2C0%2C0%2C1%2C.441-4.725l1.26-9.135h9.765l1.26-8.82H73.206l1.134-7.56Z%22%20transform%3D%22translate%2882%2060%29%22%20fill%3D%22%23fff%22%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E';

var spill = "a41e8086d3c28224.png";

function rng() {
  return crypto$1.randomBytes(16);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4

  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }

  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7.apply(this, arguments);
}

function ownKeys(object$$1, enumerableOnly) {
  var keys = Object.keys(object$$1);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object$$1);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object$$1, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var CONSTANT = {
  GLOBAL: {
    HIDE: '__react_tooltip_hide_event',
    REBUILD: '__react_tooltip_rebuild_event',
    SHOW: '__react_tooltip_show_event'
  }
};

/**
 * Static methods for react-tooltip
 */

var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
  // Compatible with IE
  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
  // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
  var event;

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(eventName, {
      detail: opts
    });
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, false, true, opts);
  }

  window.dispatchEvent(event);
};

function staticMethods (target) {
  /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */
  target.hide = function (target) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
      target: target
    });
  };
  /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */


  target.rebuild = function () {
    dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
  };
  /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */


  target.show = function (target) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
      target: target
    });
  };

  target.prototype.globalRebuild = function () {
    if (this.mount) {
      this.unbindListener();
      this.bindListener();
    }
  };

  target.prototype.globalShow = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false; // Create a fake event, specific show will limit the type to `solid`
      // only `float` type cares e.clientX e.clientY

      this.showTooltip({
        currentTarget: hasTarget && event.detail.target
      }, true);
    }
  };

  target.prototype.globalHide = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false;
      this.hideTooltip({
        currentTarget: hasTarget && event.detail.target
      }, hasTarget);
    }
  };
}

/**
 * Events that should be bound to the window
 */
function windowListener (target) {
  target.prototype.bindWindowEvents = function (resizeHide) {
    // ReactTooltip.hide
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild

    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show

    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize

    if (resizeHide) {
      window.removeEventListener('resize', this.onWindowResize);
      window.addEventListener('resize', this.onWindowResize, false);
    }
  };

  target.prototype.unbindWindowEvents = function () {
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.removeEventListener('resize', this.onWindowResize);
  };
  /**
   * invoked by resize event of window
   */


  target.prototype.onWindowResize = function () {
    if (!this.mount) return;
    this.hideTooltip();
  };
}

/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */
var checkStatus = function checkStatus(dataEventOff, e) {
  var show = this.state.show;
  var id = this.props.id;
  var isCapture = this.isCapture(e.currentTarget);
  var currentItem = e.currentTarget.getAttribute('currentItem');
  if (!isCapture) e.stopPropagation();

  if (show && currentItem === 'true') {
    if (!dataEventOff) this.hideTooltip(e);
  } else {
    e.currentTarget.setAttribute('currentItem', 'true');
    setUntargetItems(e.currentTarget, this.getTargetArray(id));
    this.showTooltip(e);
  }
};

var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
  for (var i = 0; i < targetArray.length; i++) {
    if (currentTarget !== targetArray[i]) {
      targetArray[i].setAttribute('currentItem', 'false');
    } else {
      targetArray[i].setAttribute('currentItem', 'true');
    }
  }
};

var customListeners = {
  id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
  set: function set(target, event, listener) {
    if (this.id in target) {
      var map = target[this.id];
      map[event] = listener;
    } else {
      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
      Object.defineProperty(target, this.id, {
        configurable: true,
        value: _defineProperty({}, event, listener)
      });
    }
  },
  get: function get(target, event) {
    var map = target[this.id];

    if (map !== undefined) {
      return map[event];
    }
  }
};
function customEvent (target) {
  target.prototype.isCustomEvent = function (ele) {
    var event = this.state.event;
    return event || !!ele.getAttribute('data-event');
  };
  /* Bind listener for custom event */


  target.prototype.customBindListener = function (ele) {
    var _this = this;

    var _this$state = this.state,
        event = _this$state.event,
        eventOff = _this$state.eventOff;
    var dataEvent = ele.getAttribute('data-event') || event;
    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
    dataEvent.split(' ').forEach(function (event) {
      ele.removeEventListener(event, customListeners.get(ele, event));
      var customListener = checkStatus.bind(_this, dataEventOff);
      customListeners.set(ele, event, customListener);
      ele.addEventListener(event, customListener, false);
    });

    if (dataEventOff) {
      dataEventOff.split(' ').forEach(function (event) {
        ele.removeEventListener(event, _this.hideTooltip);
        ele.addEventListener(event, _this.hideTooltip, false);
      });
    }
  };
  /* Unbind listener for custom event */


  target.prototype.customUnbindListener = function (ele) {
    var _this$state2 = this.state,
        event = _this$state2.event,
        eventOff = _this$state2.eventOff;
    var dataEvent = event || ele.getAttribute('data-event');
    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
  };
}

/**
 * Util method to judge if it should follow capture model
 */
function isCapture (target) {
  target.prototype.isCapture = function (currentTarget) {
    return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
  };
}

/**
 * Util method to get effect
 */
function getEffect (target) {
  target.prototype.getEffect = function (currentTarget) {
    var dataEffect = currentTarget.getAttribute('data-effect');
    return dataEffect || this.props.effect || 'float';
  };
}

/**
 * Util method to get effect
 */

var makeProxy = function makeProxy(e) {
  var proxy = {};

  for (var key in e) {
    if (typeof e[key] === 'function') {
      proxy[key] = e[key].bind(e);
    } else {
      proxy[key] = e[key];
    }
  }

  return proxy;
};

var bodyListener = function bodyListener(callback, options, e) {
  var _options$respectEffec = options.respectEffect,
      respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec,
      _options$customEvent = options.customEvent,
      customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
  var id = this.props.id;
  var tip = e.target.getAttribute('data-tip') || null;
  var forId = e.target.getAttribute('data-for') || null;
  var target = e.target;

  if (this.isCustomEvent(target) && !customEvent) {
    return;
  }

  var isTargetBelongsToTooltip = id == null && forId == null || forId === id;

  if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
    var proxy = makeProxy(e);
    proxy.currentTarget = target;
    callback(proxy);
  }
};

var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
  var events = {};
  targetArray.forEach(function (target) {
    var event = target.getAttribute(dataAttribute);
    if (event) event.split(' ').forEach(function (event) {
      return events[event] = true;
    });
  });
  return events;
};

var getBody = function getBody() {
  return document.getElementsByTagName('body')[0];
};

function bodyMode (target) {
  target.prototype.isBodyMode = function () {
    return !!this.props.bodyMode;
  };

  target.prototype.bindBodyListener = function (targetArray) {
    var _this = this;

    var _this$state = this.state,
        event = _this$state.event,
        eventOff = _this$state.eventOff,
        possibleCustomEvents = _this$state.possibleCustomEvents,
        possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
    var body = getBody();
    var customEvents = findCustomEvents(targetArray, 'data-event');
    var customEventsOff = findCustomEvents(targetArray, 'data-event-off');
    if (event != null) customEvents[event] = true;
    if (eventOff != null) customEventsOff[eventOff] = true;
    possibleCustomEvents.split(' ').forEach(function (event) {
      return customEvents[event] = true;
    });
    possibleCustomEventsOff.split(' ').forEach(function (event) {
      return customEventsOff[event] = true;
    });
    this.unbindBodyListener(body);
    var listeners = this.bodyModeListeners = {};

    if (event == null) {
      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
        respectEffect: true
      });
      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
    }

    for (var _event in customEvents) {
      listeners[_event] = bodyListener.bind(this, function (e) {
        var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
        checkStatus.call(_this, targetEventOff, e);
      }, {
        customEvent: true
      });
    }

    for (var _event2 in customEventsOff) {
      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
        customEvent: true
      });
    }

    for (var _event3 in listeners) {
      body.addEventListener(_event3, listeners[_event3]);
    }
  };

  target.prototype.unbindBodyListener = function (body) {
    body = body || getBody();
    var listeners = this.bodyModeListeners;

    for (var event in listeners) {
      body.removeEventListener(event, listeners[event]);
    }
  };
}

/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */
// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};

function trackRemoval (target) {
  target.prototype.bindRemovalTracker = function () {
    var _this = this;

    var MutationObserver = getMutationObserverClass();
    if (MutationObserver == null) return;
    var observer = new MutationObserver(function (mutations) {
      for (var m1 = 0; m1 < mutations.length; m1++) {
        var mutation = mutations[m1];

        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
          var element = mutation.removedNodes[m2];

          if (element === _this.state.currentTarget) {
            _this.hideTooltip();

            return;
          }
        }
      }
    });
    observer.observe(window.document, {
      childList: true,
      subtree: true
    });
    this.removalTracker = observer;
  };

  target.prototype.unbindRemovalTracker = function () {
    if (this.removalTracker) {
      this.removalTracker.disconnect();
      this.removalTracker = null;
    }
  };
}

/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */
function getPosition (e, target, node, place, desiredPlace, effect, offset) {
  var _getDimensions = getDimensions(node),
      tipWidth = _getDimensions.width,
      tipHeight = _getDimensions.height;

  var _getDimensions2 = getDimensions(target),
      targetWidth = _getDimensions2.width,
      targetHeight = _getDimensions2.height;

  var _getCurrentOffset = getCurrentOffset(e, target, effect),
      mouseX = _getCurrentOffset.mouseX,
      mouseY = _getCurrentOffset.mouseY;

  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);

  var _calculateOffset = calculateOffset(offset),
      extraOffsetX = _calculateOffset.extraOffsetX,
      extraOffsetY = _calculateOffset.extraOffsetY;

  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;

  var _getParent = getParent(node),
      parentTop = _getParent.parentTop,
      parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip


  var getTipOffsetLeft = function getTipOffsetLeft(place) {
    var offsetX = defaultOffset[place].l;
    return mouseX + offsetX + extraOffsetX;
  };

  var getTipOffsetRight = function getTipOffsetRight(place) {
    var offsetX = defaultOffset[place].r;
    return mouseX + offsetX + extraOffsetX;
  };

  var getTipOffsetTop = function getTipOffsetTop(place) {
    var offsetY = defaultOffset[place].t;
    return mouseY + offsetY + extraOffsetY;
  };

  var getTipOffsetBottom = function getTipOffsetBottom(place) {
    var offsetY = defaultOffset[place].b;
    return mouseY + offsetY + extraOffsetY;
  }; //
  // Functions to test whether the tooltip's sides are inside
  // the client window for a given orientation p
  //
  //  _____________
  // |             | <-- Right side
  // | p = 'left'  |\
  // |             |/  |\
  // |_____________|   |_\  <-- Mouse
  //      / \           |
  //       |
  //       |
  //  Bottom side
  //


  var outsideLeft = function outsideLeft(p) {
    return getTipOffsetLeft(p) < 0;
  };

  var outsideRight = function outsideRight(p) {
    return getTipOffsetRight(p) > windowWidth;
  };

  var outsideTop = function outsideTop(p) {
    return getTipOffsetTop(p) < 0;
  };

  var outsideBottom = function outsideBottom(p) {
    return getTipOffsetBottom(p) > windowHeight;
  }; // Check whether the tooltip with orientation p is completely inside the client window


  var outside = function outside(p) {
    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
  };

  var inside = function inside(p) {
    return !outside(p);
  };

  var placesList = ['top', 'bottom', 'left', 'right'];
  var insideList = [];

  for (var i = 0; i < 4; i++) {
    var p = placesList[i];

    if (inside(p)) {
      insideList.push(p);
    }
  }

  var isNewState = false;
  var newPlace;
  var shouldUpdatePlace = desiredPlace !== place;

  if (inside(desiredPlace) && shouldUpdatePlace) {
    isNewState = true;
    newPlace = desiredPlace;
  } else if (insideList.length > 0 && outside(desiredPlace) && outside(place)) {
    isNewState = true;
    newPlace = insideList[0];
  }

  if (isNewState) {
    return {
      isNewState: true,
      newState: {
        place: newPlace
      }
    };
  }

  return {
    isNewState: false,
    position: {
      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
    }
  };
}

var getDimensions = function getDimensions(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
      height = _node$getBoundingClie.height,
      width = _node$getBoundingClie.width;

  return {
    height: parseInt(height, 10),
    width: parseInt(width, 10)
  };
}; // Get current mouse offset


var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
  var boundingClientRect = currentTarget.getBoundingClientRect();
  var targetTop = boundingClientRect.top;
  var targetLeft = boundingClientRect.left;

  var _getDimensions3 = getDimensions(currentTarget),
      targetWidth = _getDimensions3.width,
      targetHeight = _getDimensions3.height;

  if (effect === 'float') {
    return {
      mouseX: e.clientX,
      mouseY: e.clientY
    };
  }

  return {
    mouseX: targetLeft + targetWidth / 2,
    mouseY: targetTop + targetHeight / 2
  };
}; // List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window


var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
  var top;
  var right;
  var bottom;
  var left;
  var disToMouse = 3;
  var triangleHeight = 2;
  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip

  if (effect === 'float') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(tipHeight + disToMouse + triangleHeight),
      b: -disToMouse
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: disToMouse + cursorHeight,
      b: tipHeight + disToMouse + triangleHeight + cursorHeight
    };
    left = {
      l: -(tipWidth + disToMouse + triangleHeight),
      r: -disToMouse,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: disToMouse,
      r: tipWidth + disToMouse + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  } else if (effect === 'solid') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(targetHeight / 2 + tipHeight + triangleHeight),
      b: -(targetHeight / 2)
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: targetHeight / 2,
      b: targetHeight / 2 + tipHeight + triangleHeight
    };
    left = {
      l: -(tipWidth + targetWidth / 2 + triangleHeight),
      r: -(targetWidth / 2),
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: targetWidth / 2,
      r: tipWidth + targetWidth / 2 + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  }

  return {
    top: top,
    bottom: bottom,
    left: left,
    right: right
  };
}; // Consider additional offset into position calculation


var calculateOffset = function calculateOffset(offset) {
  var extraOffsetX = 0;
  var extraOffsetY = 0;

  if (Object.prototype.toString.apply(offset) === '[object String]') {
    offset = JSON.parse(offset.toString().replace(/'/g, '"'));
  }

  for (var key in offset) {
    if (key === 'top') {
      extraOffsetY -= parseInt(offset[key], 10);
    } else if (key === 'bottom') {
      extraOffsetY += parseInt(offset[key], 10);
    } else if (key === 'left') {
      extraOffsetX -= parseInt(offset[key], 10);
    } else if (key === 'right') {
      extraOffsetX += parseInt(offset[key], 10);
    }
  }

  return {
    extraOffsetX: extraOffsetX,
    extraOffsetY: extraOffsetY
  };
}; // Get the offset of the parent elements


var getParent = function getParent(currentTarget) {
  var currentParent = currentTarget;

  while (currentParent) {
    var computedStyle = window.getComputedStyle(currentParent); // transform and will-change: transform change the containing block
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block

    if (computedStyle.getPropertyValue('transform') !== 'none' || computedStyle.getPropertyValue('will-change') === 'transform') break;
    currentParent = currentParent.parentElement;
  }

  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
  return {
    parentTop: parentTop,
    parentLeft: parentLeft
  };
};

/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */
function getTipContent (tip, children, getContent, multiline) {
  if (children) return children;
  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.

  if (getContent === null) return null; // Tip not exist and children is null or undefined

  var regexp = /<br\s*\/?>/;

  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
    // No trim(), so that user can keep their input
    return tip;
  } // Multiline tooltip content


  return tip.split(regexp).map(function (d, i) {
    return React.createElement("span", {
      key: i,
      className: "multi-line"
    }, d);
  });
}

/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */
function parseAria(props) {
  var ariaObj = {};
  Object.keys(props).filter(function (prop) {
    // aria-xxx and role is acceptable
    return /(^aria-\w+$|^role$)/.test(prop);
  }).forEach(function (prop) {
    ariaObj[prop] = props[prop];
  });
  return ariaObj;
}

/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */
function nodeListToArray (nodeList) {
  var length = nodeList.length;

  if (nodeList.hasOwnProperty) {
    return Array.prototype.slice.call(nodeList);
  }

  return new Array(length).fill().map(function (index) {
    return nodeList[index];
  });
}

function generateUUID() {
  return 't' + v4();
}

var baseCss = ".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}";

/**
 * Default pop-up style values (text color, background color).
 */
var defaultColors = {
  dark: {
    text: '#fff',
    background: '#222',
    border: 'transparent',
    arrow: '#222'
  },
  success: {
    text: '#fff',
    background: '#8DC572',
    border: 'transparent',
    arrow: '#8DC572'
  },
  warning: {
    text: '#fff',
    background: '#F0AD4E',
    border: 'transparent',
    arrow: '#F0AD4E'
  },
  error: {
    text: '#fff',
    background: '#BE6464',
    border: 'transparent',
    arrow: '#BE6464'
  },
  info: {
    text: '#fff',
    background: '#337AB7',
    border: 'transparent',
    arrow: '#337AB7'
  },
  light: {
    text: '#222',
    background: '#fff',
    border: 'transparent',
    arrow: '#fff'
  }
};
function getDefaultPopupColors(type) {
  return defaultColors[type] ? _objectSpread2({}, defaultColors[type]) : undefined;
}

/**
 * Generates the specific tooltip style for use on render.
 */

function generateTooltipStyle(uuid, customColors, type, hasBorder) {
  return generateStyle(uuid, getPopupColors(customColors, type, hasBorder));
}
/**
 * Generates the tooltip style rules based on the element-specified "data-type" property.
 */

function generateStyle(uuid, colors) {
  var textColor = colors.text;
  var backgroundColor = colors.background;
  var borderColor = colors.border;
  var arrowColor = colors.arrow;
  return "\n  \t.".concat(uuid, " {\n\t    color: ").concat(textColor, ";\n\t    background: ").concat(backgroundColor, ";\n\t    border: 1px solid ").concat(borderColor, ";\n  \t}\n\n  \t.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, ".place-top::before {\n        border-top: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-top::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-top-color: ").concat(arrowColor, ";\n        border-top-style: solid;\n        border-top-width: 6px;\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, ".place-bottom::before {\n        border-bottom: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-bottom::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        top: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-bottom-color: ").concat(arrowColor, ";\n        border-bottom-style: solid;\n        border-bottom-width: 6px;\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, ".place-left::before {\n        border-left: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-left::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        right: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-left-color: ").concat(arrowColor, ";\n        border-left-style: solid;\n        border-left-width: 6px;\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, ".place-right::before {\n        border-right: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-right::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        left: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-right-color: ").concat(arrowColor, ";\n        border-right-style: solid;\n        border-right-width: 6px;\n    }\n  ");
}

function getPopupColors(customColors, type, hasBorder) {
  var textColor = customColors.text;
  var backgroundColor = customColors.background;
  var borderColor = customColors.border;
  var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
  var colors = getDefaultPopupColors(type);

  if (textColor) {
    colors.text = textColor;
  }

  if (backgroundColor) {
    colors.background = backgroundColor;
  }

  if (hasBorder) {
    if (borderColor) {
      colors.border = borderColor;
    } else {
      colors.border = type === 'light' ? 'black' : 'white';
    }
  }

  if (arrowColor) {
    colors.arrow = arrowColor;
  }

  return colors;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var check$1 = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check$1(typeof globalThis == 'object' && globalThis) ||
  check$1(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check$1(typeof self == 'object' && self) ||
  check$1(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString$1 = {}.toString;

var classofRaw = function (it) {
  return toString$1.call(it).slice(8, -1);
};

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var hasOwnProperty = {}.hasOwnProperty;

var has = function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};

var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$1 = descriptors ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$1
};

var anObject = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f$2 = descriptors ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f$2
};

var createNonEnumerableProperty = descriptors ? function (object$$1, key, value) {
  return objectDefineProperty.f(object$$1, key, createPropertyDescriptor(1, value));
} : function (object$$1, key, value) {
  object$$1[key] = value;
  return object$$1;
};

var setGlobal = function (key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});

var sharedStore = store;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof sharedStore.inspectSource != 'function') {
  sharedStore.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap = global_1.WeakMap;

var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));

var shared = createCommonjsModule(function (module) {
(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.12.1',
  mode:  'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var postfix = Math.random();

var uid = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap$1 = global_1.WeakMap;
var set$1, get$1, has$1;

var enforce = function (it) {
  return has$1(it) ? get$1(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get$1(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (nativeWeakMap || sharedStore.state) {
  var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$1());
  var wmget = store$1.get;
  var wmhas = store$1.has;
  var wmset = store$1.set;
  set$1 = function (it, metadata) {
    if (wmhas.call(store$1, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store$1, it, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return wmget.call(store$1, it) || {};
  };
  has$1 = function (it) {
    return wmhas.call(store$1, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set$1 = function (it, metadata) {
    if (has(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return has(it, STATE) ? it[STATE] : {};
  };
  has$1 = function (it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get$1,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var redefine = createCommonjsModule(function (module) {
var getInternalState = internalState.get;
var enforceInternalState = internalState.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global_1) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});
});

var path = global_1;

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace])
    : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;


var objectKeysInternal = function (object$$1, names) {
  var O = toIndexedObject(object$$1);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
	f: f$3
};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$4 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$4
};

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source) {
  var keys = ownKeys$1(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string$$1) {
  return String(string$$1).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};

var aFunction$1 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray || function isArray(arg) {
  return classofRaw(arg) == 'Array';
};

var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

var process$1 = global_1.process;
var versions = process$1 && process$1.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

/* eslint-disable es/no-symbol -- required for testing */



// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  return !String(Symbol()) ||
    // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && engineV8Version && engineV8Version < 41;
});

/* eslint-disable es/no-symbol -- required for testing */


var useSymbolAsUid = nativeSymbol
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(nativeSymbol || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (nativeSymbol && has(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod$1(7)
};

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);
  return O;
};

var html = getBuiltIn('document', 'documentElement');

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties(result, Properties);
};

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  objectDefineProperty.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $find = arrayIteration.find;


var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);

var _class, _class2, _temp;

var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ReactTooltip, _React$Component);

  _createClass(ReactTooltip, null, [{
    key: "propTypes",
    get: function get() {
      return {
        uuid: PropTypes.string,
        children: PropTypes.any,
        place: PropTypes.string,
        type: PropTypes.string,
        effect: PropTypes.string,
        offset: PropTypes.object,
        multiline: PropTypes.bool,
        border: PropTypes.bool,
        textColor: PropTypes.string,
        backgroundColor: PropTypes.string,
        borderColor: PropTypes.string,
        arrowColor: PropTypes.string,
        insecure: PropTypes.bool,
        "class": PropTypes.string,
        className: PropTypes.string,
        id: PropTypes.string,
        html: PropTypes.bool,
        delayHide: PropTypes.number,
        delayUpdate: PropTypes.number,
        delayShow: PropTypes.number,
        event: PropTypes.string,
        eventOff: PropTypes.string,
        isCapture: PropTypes.bool,
        globalEventOff: PropTypes.string,
        getContent: PropTypes.any,
        afterShow: PropTypes.func,
        afterHide: PropTypes.func,
        overridePosition: PropTypes.func,
        disable: PropTypes.bool,
        scrollHide: PropTypes.bool,
        resizeHide: PropTypes.bool,
        wrapper: PropTypes.string,
        bodyMode: PropTypes.bool,
        possibleCustomEvents: PropTypes.string,
        possibleCustomEventsOff: PropTypes.string,
        clickable: PropTypes.bool
      };
    }
  }]);

  function ReactTooltip(props) {
    var _this;

    _classCallCheck(this, ReactTooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactTooltip).call(this, props));
    _this.state = {
      uuid: props.uuid || generateUUID(),
      place: props.place || 'top',
      // Direction of tooltip
      desiredPlace: props.place || 'top',
      type: 'dark',
      // Color theme of tooltip
      effect: 'float',
      // float or fixed
      show: false,
      border: false,
      customColors: {},
      offset: {},
      extraClass: '',
      html: false,
      delayHide: 0,
      delayShow: 0,
      event: props.event || null,
      eventOff: props.eventOff || null,
      currentEvent: null,
      // Current mouse event
      currentTarget: null,
      // Current target of mouse event
      ariaProps: parseAria(props),
      // aria- and role attributes
      isEmptyTip: false,
      disable: false,
      possibleCustomEvents: props.possibleCustomEvents || '',
      possibleCustomEventsOff: props.possibleCustomEventsOff || '',
      originTooltip: null,
      isMultiline: false
    };

    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'hideTooltipOnScroll', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize', 'mouseOnToolTip']);

    _this.mount = true;
    _this.delayShowLoop = null;
    _this.delayHideLoop = null;
    _this.delayReshow = null;
    _this.intervalUpdateContent = null;
    return _this;
  }
  /**
   * For unify the bind and unbind listener
   */


  _createClass(ReactTooltip, [{
    key: "bind",
    value: function bind(methodArray) {
      var _this2 = this;

      methodArray.forEach(function (method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          insecure = _this$props.insecure,
          resizeHide = _this$props.resizeHide;
      this.bindListener(); // Bind listener for tooltip

      this.bindWindowEvents(resizeHide); // Bind global event for static method

      this.injectStyles(); // Inject styles for each DOM root having tooltip.
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mount = false;
      this.clearTimer();
      this.unbindListener();
      this.removeScrollListener(this.state.currentTarget);
      this.unbindWindowEvents();
    }
    /* Look for the closest DOM root having tooltip and inject styles. */

  }, {
    key: "injectStyles",
    value: function injectStyles() {
      var tooltipRef = this.tooltipRef;

      if (!tooltipRef) {
        return;
      }

      var parentNode = tooltipRef.parentNode;

      while (parentNode.parentNode) {
        parentNode = parentNode.parentNode;
      }

      var domRoot;

      switch (parentNode.constructor.name) {
        case 'Document':
        case 'HTMLDocument':
        case undefined:
          domRoot = parentNode.head;
          break;

        case 'ShadowRoot':
        default:
          domRoot = parentNode;
          break;
      } // Prevent styles duplication.


      if (!domRoot.querySelector('style[data-react-tooltip]')) {
        var style = document.createElement('style');
        style.textContent = baseCss;
        style.setAttribute('data-react-tooltip', 'true');
        domRoot.appendChild(style);
      }
    }
    /**
     * Return if the mouse is on the tooltip.
     * @returns {boolean} true - mouse is on the tooltip
     */

  }, {
    key: "mouseOnToolTip",
    value: function mouseOnToolTip() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        /* old IE or Firefox work around */
        if (!this.tooltipRef.matches) {
          /* old IE work around */
          if (this.tooltipRef.msMatchesSelector) {
            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
          } else {
            /* old Firefox work around */
            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
          }
        }

        return this.tooltipRef.matches(':hover');
      }

      return false;
    }
    /**
     * Pick out corresponded target elements
     */

  }, {
    key: "getTargetArray",
    value: function getTargetArray(id) {
      var targetArray = [];
      var selector;

      if (!id) {
        selector = '[data-tip]:not([data-for])';
      } else {
        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        selector = "[data-tip][data-for=\"".concat(escaped, "\"]");
      } // Scan document for shadow DOM elements


      nodeListToArray(document.getElementsByTagName('*')).filter(function (element) {
        return element.shadowRoot;
      }).forEach(function (element) {
        targetArray = targetArray.concat(nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
      });
      return targetArray.concat(nodeListToArray(document.querySelectorAll(selector)));
    }
    /**
     * Bind listener to the target elements
     * These listeners used to trigger showing or hiding the tooltip
     */

  }, {
    key: "bindListener",
    value: function bindListener() {
      var _this3 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          globalEventOff = _this$props2.globalEventOff,
          isCapture = _this$props2.isCapture;
      var targetArray = this.getTargetArray(id);
      targetArray.forEach(function (target) {
        if (target.getAttribute('currentItem') === null) {
          target.setAttribute('currentItem', 'false');
        }

        _this3.unbindBasicListener(target);

        if (_this3.isCustomEvent(target)) {
          _this3.customUnbindListener(target);
        }
      });

      if (this.isBodyMode()) {
        this.bindBodyListener(targetArray);
      } else {
        targetArray.forEach(function (target) {
          var isCaptureMode = _this3.isCapture(target);

          var effect = _this3.getEffect(target);

          if (_this3.isCustomEvent(target)) {
            _this3.customBindListener(target);

            return;
          }

          target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
          target.addEventListener('focus', _this3.showTooltip, isCaptureMode);

          if (effect === 'float') {
            target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
          }

          target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
          target.addEventListener('blur', _this3.hideTooltip, isCaptureMode);
        });
      } // Global event to hide tooltip


      if (globalEventOff) {
        window.removeEventListener(globalEventOff, this.hideTooltip);
        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
      } // Track removal of targetArray elements from DOM


      this.bindRemovalTracker();
    }
    /**
     * Unbind listeners on target elements
     */

  }, {
    key: "unbindListener",
    value: function unbindListener() {
      var _this4 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          globalEventOff = _this$props3.globalEventOff;

      if (this.isBodyMode()) {
        this.unbindBodyListener();
      } else {
        var targetArray = this.getTargetArray(id);
        targetArray.forEach(function (target) {
          _this4.unbindBasicListener(target);

          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
        });
      }

      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
      this.unbindRemovalTracker();
    }
    /**
     * Invoke this before bind listener and unmount the component
     * it is necessary to invoke this even when binding custom event
     * so that the tooltip can switch between custom and default listener
     */

  }, {
    key: "unbindBasicListener",
    value: function unbindBasicListener(target) {
      var isCaptureMode = this.isCapture(target);
      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
    }
  }, {
    key: "getTooltipContent",
    value: function getTooltipContent() {
      var _this$props4 = this.props,
          getContent = _this$props4.getContent,
          children = _this$props4.children; // Generate tooltip content

      var content;

      if (getContent) {
        if (Array.isArray(getContent)) {
          content = getContent[0] && getContent[0](this.state.originTooltip);
        } else {
          content = getContent(this.state.originTooltip);
        }
      }

      return getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
    }
  }, {
    key: "isEmptyTip",
    value: function isEmptyTip(placeholder) {
      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
    }
    /**
     * When mouse enter, show the tooltip
     */

  }, {
    key: "showTooltip",
    value: function showTooltip(e, isGlobalCall) {
      if (!this.tooltipRef) {
        return;
      }

      if (isGlobalCall) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement) return;
      } // Get the tooltip content
      // calculate in this phrase so that tip width height can be detected


      var _this$props5 = this.props,
          multiline = _this$props5.multiline,
          getContent = _this$props5.getContent;
      var originTooltip = e.currentTarget.getAttribute('data-tip');
      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect

      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll

      var scrollHide = true;

      if (e.currentTarget.getAttribute('data-scroll-hide')) {
        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
      } else if (this.props.scrollHide != null) {
        scrollHide = this.props.scrollHide;
      } // adding aria-describedby to target to make tooltips read by screen readers


      if (e && e.currentTarget && e.currentTarget.setAttribute) {
        e.currentTarget.setAttribute('aria-describedby', this.state.uuid);
      } // Make sure the correct place is set


      var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
      var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
      var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
      var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);

      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
      }

      var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering

      this.clearTimer();
      var target = e.currentTarget;
      var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
      var self = this;

      var updateState = function updateState() {
        self.setState({
          originTooltip: originTooltip,
          isMultiline: isMultiline,
          desiredPlace: desiredPlace,
          place: place,
          type: target.getAttribute('data-type') || self.props.type || 'dark',
          customColors: {
            text: target.getAttribute('data-text-color') || self.props.textColor || null,
            background: target.getAttribute('data-background-color') || self.props.backgroundColor || null,
            border: target.getAttribute('data-border-color') || self.props.borderColor || null,
            arrow: target.getAttribute('data-arrow-color') || self.props.arrowColor || null
          },
          effect: effect,
          offset: offset,
          html: (target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self.props.html) || false,
          delayShow: target.getAttribute('data-delay-show') || self.props.delayShow || 0,
          delayHide: target.getAttribute('data-delay-hide') || self.props.delayHide || 0,
          delayUpdate: target.getAttribute('data-delay-update') || self.props.delayUpdate || 0,
          border: (target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self.props.border) || false,
          extraClass: target.getAttribute('data-class') || self.props["class"] || self.props.className || '',
          disable: (target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self.props.disable) || false,
          currentTarget: target
        }, function () {
          if (scrollHide) {
            self.addScrollListener(self.state.currentTarget);
          }

          self.updateTooltip(e);

          if (getContent && Array.isArray(getContent)) {
            self.intervalUpdateContent = setInterval(function () {
              if (self.mount) {
                var _getContent = self.props.getContent;
                var placeholder = getTipContent(originTooltip, '', _getContent[0](), isMultiline);
                var isEmptyTip = self.isEmptyTip(placeholder);
                self.setState({
                  isEmptyTip: isEmptyTip
                });
                self.updatePosition();
              }
            }, getContent[1]);
          }
        });
      }; // If there is no delay call immediately, don't allow events to get in first.


      if (reshowDelay) {
        this.delayReshow = setTimeout(updateState, reshowDelay);
      } else {
        updateState();
      }
    }
    /**
     * When mouse hover, update tool tip
     */

  }, {
    key: "updateTooltip",
    value: function updateTooltip(e) {
      var _this5 = this;

      var _this$state = this.state,
          delayShow = _this$state.delayShow,
          disable = _this$state.disable;
      var afterShow = this.props.afterShow;
      var placeholder = this.getTooltipContent();
      var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip

      if (this.mouseOnToolTip()) {
        return;
      } // if the tooltip is empty, disable the tooltip


      if (this.isEmptyTip(placeholder) || disable) {
        return;
      }

      var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;

      var updateState = function updateState() {
        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
          var isInvisible = !_this5.state.show;

          _this5.setState({
            currentEvent: e,
            currentTarget: eventTarget,
            show: true
          }, function () {
            _this5.updatePosition();

            if (isInvisible && afterShow) {
              afterShow(e);
            }
          });
        }
      };

      clearTimeout(this.delayShowLoop);

      if (delayTime) {
        this.delayShowLoop = setTimeout(updateState, delayTime);
      } else {
        updateState();
      }
    }
    /*
     * If we're mousing over the tooltip remove it when we leave.
     */

  }, {
    key: "listenForTooltipExit",
    value: function listenForTooltipExit() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
      }
    }
  }, {
    key: "removeListenerForTooltipExit",
    value: function removeListenerForTooltipExit() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
      }
    }
    /**
     * When mouse leave, hide tooltip
     */

  }, {
    key: "hideTooltip",
    value: function hideTooltip(e, hasTarget) {
      var _this6 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        isScroll: false
      };
      var disable = this.state.disable;
      var isScroll = options.isScroll;
      var delayHide = isScroll ? 0 : this.state.delayHide;
      var afterHide = this.props.afterHide;
      var placeholder = this.getTooltipContent();
      if (!this.mount) return;
      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip

      if (hasTarget) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || !this.state.show) return;
      } // clean up aria-describedby when hiding tooltip


      if (e && e.currentTarget && e.currentTarget.removeAttribute) {
        e.currentTarget.removeAttribute('aria-describedby');
      }

      var resetState = function resetState() {
        var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip

        if (_this6.mouseOnToolTip()) {
          _this6.listenForTooltipExit();

          return;
        }

        _this6.removeListenerForTooltipExit();

        _this6.setState({
          show: false
        }, function () {
          _this6.removeScrollListener(_this6.state.currentTarget);

          if (isVisible && afterHide) {
            afterHide(e);
          }
        });
      };

      this.clearTimer();

      if (delayHide) {
        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
      } else {
        resetState();
      }
    }
    /**
     * When scroll, hide tooltip
     */

  }, {
    key: "hideTooltipOnScroll",
    value: function hideTooltipOnScroll(event, hasTarget) {
      this.hideTooltip(event, hasTarget, {
        isScroll: true
      });
    }
    /**
     * Add scroll event listener when tooltip show
     * automatically hide the tooltip when scrolling
     */

  }, {
    key: "addScrollListener",
    value: function addScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
    }
  }, {
    key: "removeScrollListener",
    value: function removeScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.removeEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
    } // Calculation the position

  }, {
    key: "updatePosition",
    value: function updatePosition() {
      var _this7 = this;

      var _this$state2 = this.state,
          currentEvent = _this$state2.currentEvent,
          currentTarget = _this$state2.currentTarget,
          place = _this$state2.place,
          desiredPlace = _this$state2.desiredPlace,
          effect = _this$state2.effect,
          offset = _this$state2.offset;
      var node = this.tooltipRef;
      var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);

      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
      }

      if (result.isNewState) {
        // Switch to reverse placement
        return this.setState(result.newState, function () {
          _this7.updatePosition();
        });
      } // Set tooltip position


      node.style.left = result.position.left + 'px';
      node.style.top = result.position.top + 'px';
    }
    /**
     * CLear all kinds of timeout of interval
     */

  }, {
    key: "clearTimer",
    value: function clearTimer() {
      clearTimeout(this.delayShowLoop);
      clearTimeout(this.delayHideLoop);
      clearTimeout(this.delayReshow);
      clearInterval(this.intervalUpdateContent);
    }
  }, {
    key: "hasCustomColors",
    value: function hasCustomColors() {
      var _this8 = this;

      return Boolean(Object.keys(this.state.customColors).find(function (color) {
        return color !== 'border' && _this8.state.customColors[color];
      }) || this.state.border && this.state.customColors['border']);
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      var _this$state3 = this.state,
          extraClass = _this$state3.extraClass,
          html = _this$state3.html,
          ariaProps = _this$state3.ariaProps,
          disable = _this$state3.disable,
          uuid = _this$state3.uuid;
      var content = this.getTooltipContent();
      var isEmptyTip = this.isEmptyTip(content);
      var style = generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border);
      var tooltipClass = '__react_component_tooltip' + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? ' show' : '') + (this.state.border ? ' border' : '') + " place-".concat(this.state.place) + // top, bottom, left, right
      " type-".concat(this.hasCustomColors() ? 'custom' : this.state.type) + ( // dark, success, warning, error, info, light, custom
      this.props.delayUpdate ? ' allow_hover' : '') + (this.props.clickable ? ' allow_click' : '');
      var Wrapper = this.props.wrapper;

      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
        Wrapper = ReactTooltip.defaultProps.wrapper;
      }

      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(' ');

      if (html) {
        var htmlContent = "".concat(content, "\n<style aria-hidden=\"true\">").concat(style, "</style>");
        return React.createElement(Wrapper, _extends$7({
          className: "".concat(wrapperClassName),
          id: this.props.id || uuid,
          ref: function ref(_ref) {
            return _this9.tooltipRef = _ref;
          }
        }, ariaProps, {
          "data-id": "tooltip",
          dangerouslySetInnerHTML: {
            __html: htmlContent
          }
        }));
      } else {
        return React.createElement(Wrapper, _extends$7({
          className: "".concat(wrapperClassName),
          id: this.props.id || uuid
        }, ariaProps, {
          ref: function ref(_ref2) {
            return _this9.tooltipRef = _ref2;
          },
          "data-id": "tooltip"
        }), React.createElement("style", {
          dangerouslySetInnerHTML: {
            __html: style
          },
          "aria-hidden": "true"
        }), content);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var ariaProps = prevState.ariaProps;
      var newAriaProps = parseAria(nextProps);
      var isChanged = Object.keys(newAriaProps).some(function (props) {
        return newAriaProps[props] !== ariaProps[props];
      });

      if (!isChanged) {
        return null;
      }

      return _objectSpread2({}, prevState, {
        ariaProps: newAriaProps
      });
    }
  }]);

  return ReactTooltip;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  insecure: true,
  resizeHide: true,
  wrapper: 'div',
  clickable: false
}), _defineProperty(_class2, "supportedWrappers", ['div', 'span']), _defineProperty(_class2, "displayName", 'ReactTooltip'), _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;

var _ref$6 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M45.8 64.2c-11.4 0-21.5 4-28.5 11V33H0v74.3c0 25.9 18.2 44 44.3 44 25.8 0 44.5-18.3 44.5-43.5s-18.1-43.6-43-43.6zm-1.5 16.6c15.9 0 27 11.1 27 27s-11.1 27-27 27-27-11.1-27-27 11.1-27 27-27zM142.4 64.2c-25.8 0-44.5 18.3-44.5 43.5s18.7 43.6 44.5 43.6c18.5 0 34.1-9.7 40.7-25.4l2-4.8h-18.5l-1 1.8c-4.3 7.7-12.5 11.9-23.1 11.9-13.5 0-23.6-7.9-26.3-20.1h70.4v-6.9c-.1-25.3-18.6-43.6-44.2-43.6zm0 16.6c12.7 0 22.1 6.7 25.5 17.6h-51.2c3.4-11 12.9-17.6 25.7-17.6zM248.2 112.6v5.2c0 11.3-5.4 17-16.1 17s-16.1-5.7-16.1-17V82.6h44.8V66.2H216V39.4h-17.3v78.3c0 21 12.5 33.5 33.4 33.5 20.7 0 33.1-12.5 33.1-33.5v-5.2l-17 .1z"
});

var _ref2$5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 380.3,
  cy: 98.8,
  r: 96.8,
  fill: "none",
  stroke: "#fff",
  strokeWidth: 4.02,
  strokeMiterlimit: 10
});

var _ref3$1 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M380.3 2c-53.5 0-96.8 43.4-96.8 96.8s43.4 96.8 96.8 96.8 96.8-43.4 96.8-96.8S433.8 2 380.3 2zm-6.1 131.7V150h-66.5v-13.6l37.7-34.3c8.7-7.8 12.4-14.1 12.4-21.3 0-10.9-6.2-17.7-16.2-17.7-10.4 0-16.7 7-16.7 18.8v5.2h-17.1v-5.2c0-21.5 13.2-35.5 33.7-35.5 19.9 0 33.7 14.1 33.7 34.3 0 13.9-6.8 22.8-17.8 32.7l-22.3 20.1h39.1v.2zm41.7 18.2c-19.7 0-34.4-12.3-36.7-30.7l-.5-4.3h17.2l.6 3.1c1.9 9.4 9.3 15.3 19.5 15.3 11.7 0 19.5-7.9 19.5-19.5v-1c0-11.7-7.9-19.5-19.5-19.5-8.2 0-14.6 3.7-17.6 10.1l-1.4 3.1-14.9-4.7 6.8-55.3h56v16.3h-41.7l-2.3 18.6c4.7-2.7 10.3-4.2 16.7-4.2 20.5 0 35.3 15 35.3 35.6v1c-.1 20.8-15.6 36.1-37 36.1z"
});

var _ref$7 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M122.9 48.5c-5.5 0-10 4.5-10 10v66.1c0 1.4.6 2.7 1.5 3.6l35 34.8c3.9 3.9 10.3 3.9 14.1 0 1.9-1.9 2.9-4.4 2.9-7.1 0-2.7-1.1-5.2-2.9-7.1l-30.6-30.5V58.4c0-5.4-4.5-9.9-10-9.9z"
});

var _ref2$6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M123.1 246.4C55.2 246.4 0 191.2 0 123.2 0 55.3 55.2 0 123.2 0c67.9 0 123.2 55.2 123.2 123.2-.1 68-55.3 123.2-123.3 123.2zm0-230.9c-59.4 0-107.7 48.3-107.7 107.7S63.7 231 123.2 231s107.7-48.3 107.7-107.8c0-59.4-48.3-107.7-107.8-107.7z",
  id: "Ellipse_234"
});

var _ref3$2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M158.3 135.5H119L95.3 81.7c-1.7-3.9.1-8.4 3.9-10.1 3.9-1.7 8.4.1 10.1 3.9l19.6 44.6h29.2c4.3 0 7.7 3.4 7.7 7.7s-3.2 7.7-7.5 7.7z",
  id: "Path_1040"
});

var _ref4$1 =
/*#__PURE__*/
React.createElement("path", {
  d: "M215.6 42.7c-19-22-45.2-36.5-73.7-41l-2.1-.3v-27.7h13c5.5 0 10-4.5 10-10s-4.5-10-10-10H93.3c-5.5 0-10 4.5-10 10s4.5 10 10 10h13V1.3l-2.1.3c-28.5 4.4-54.7 19-73.7 41C11.1 64.9.6 93.2.6 122.6.6 190.1 55.5 245 123 245s122.4-54.9 122.4-122.4c0-29.3-10.6-57.7-29.8-79.9zm-92.5 188c-59.2 0-107.1-48-107.1-107.1S64 16.5 123.1 16.5s107.1 48 107.1 107.1-47.9 107.1-107.1 107.1z"
});

var _ref$8 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M71.4 75.2c-7-7-17.1-11-28.5-11C18 64.2 0 82.5 0 107.7s18.7 43.6 44.4 43.6c26.1 0 44.3-18.1 44.3-44V33H71.4v42.2zm-27 59.5c-15.9 0-27-11.1-27-27s11.1-27 27-27 27 11.1 27 27-11.1 27-27 27zM145.5 64.2c-25.8 0-44.5 18.3-44.5 43.5s18.7 43.6 44.5 43.6c18.5 0 34.1-9.7 40.7-25.4l2-4.8h-18.5l-1 1.8c-4.3 7.7-12.5 11.9-23.1 11.9-13.5 0-23.6-7.9-26.3-20.1h70.4v-6.9c-.1-25.3-18.6-43.6-44.2-43.6zm0 16.6c12.7 0 22.1 6.7 25.5 17.6h-51.2c3.4-11 12.9-17.6 25.7-17.6zM237.4 64.2c-22.2 0-35.5 13.5-35.5 36v49.1h17.3v-49.1c0-12.9 6.1-19.4 18.2-19.4s18.2 6.5 18.2 19.4v4.6h17.2v-4.4c0-22.7-13.2-36.2-35.4-36.2zM332.6 64.2c-11.4 0-21.5 4-28.5 11V33h-17.3v74.3c0 25.9 18.2 44 44.3 44 25.8 0 44.5-18.3 44.5-43.5s-18.1-43.6-43-43.6zM331 80.8c15.9 0 27 11.1 27 27s-11.1 27-27 27-27-11.1-27-27 11.1-27 27-27zM452.6 66.2V109c0 16.1-8.7 25.3-23.8 25.3S405 125.1 405 109V66.2h-17.3V109c0 25.8 15.1 41.8 39.5 41.8 10.2 0 19-3.4 25.3-9.5v2c0 16.2-8.1 24.4-24.2 24.4-8.1 0-18.5-2.3-22.8-13.2l-.9-2.2h-17.4l1.3 4.5c4.9 16.9 19.7 27 39.7 27 26 0 41.5-15.2 41.5-40.8V66.2h-17.1z"
});

var _ref2$7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 584.2,
  cy: 98.8,
  r: 96.8,
  fill: "none",
  stroke: "#fff",
  strokeWidth: 4.02,
  strokeMiterlimit: 10
});

var _ref3$3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M584.2 2c-53.5 0-96.8 43.4-96.8 96.8s43.4 96.8 96.8 96.8S681 152.2 681 98.8 637.7 2 584.2 2zm-6.1 131.7V150h-66.5v-13.6l37.7-34.3c8.7-7.8 12.4-14.1 12.4-21.3 0-10.9-6.2-17.7-16.2-17.7-10.4 0-16.7 7-16.7 18.8v5.2h-17.1v-5.2c0-21.5 13.2-35.5 33.7-35.5 19.9 0 33.7 14.1 33.7 34.3 0 13.9-6.8 22.8-17.8 32.7L539 133.5h39.1v.2zm41.7 18.2c-19.7 0-34.4-12.3-36.7-30.7l-.5-4.3h17.2l.6 3.1c1.9 9.4 9.3 15.3 19.5 15.3 11.7 0 19.5-7.9 19.5-19.5v-1c0-11.7-7.9-19.5-19.5-19.5-8.2 0-14.6 3.7-17.6 10.1l-1.4 3.1-14.9-4.7 6.8-55.3h56v16.3h-41.7l-2.3 18.6c4.7-2.7 10.3-4.2 16.7-4.2 20.5 0 35.3 15 35.3 35.6v1c-.1 20.8-15.6 36.1-37 36.1z"
});

var _ref$9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M11.9 54.5h34c19.2 0 28.2 7.2 28.2 20.2 0 .8 0 2.2-.2 4.1-1.2 9.7-5.9 14.7-14.2 17.5 6.2 2.6 10.8 8.1 10.8 17.2 0 .2 0 1.1-.1 2.5-1.4 16.5-10.9 23.5-33.1 23.5H0l11.9-85zM36 121c7.4 0 10.1-1.5 11.2-7.9.1-.7.2-1.9.2-2.6 0-4.8-3.1-6.1-8.8-6.1h-9.9L26.4 121H36zm2-32.4c9.3 0 11.5-1.9 12.2-7.4.1-.8.1-1.8.1-2.2 0-4.1-2-5.9-8-5.9h-9.2l-2.2 15.5H38zM133.9 123.1c-2.8 15.3-7.7 17.9-28 17.9-22.6 0-28.9-8.5-28.9-23.2 0-3.2.3-6.7.8-10.6 3-22.6 7.2-33.8 33.2-33.8 21.4 0 27.8 8.5 27.8 22.9 0 3.8-.4 7.9-1.9 16.9-.2 1.4-.6 2-3.1 2H98.5c-.1.7-.1 1.4-.1 2 0 4.5 2.6 5.8 9.5 5.8l26 .1zM117 102.7c.5-2.4.7-4.4.7-5.9 0-4.8-2.4-5.9-7.8-5.9-6.1 0-8.2.7-9.8 11.8H117zM152.8 60.7h22.1l-2.1 14.1H191l-2.4 16.5h-18.2l-2.4 17.1c-.5 3.3-.8 6.7-.8 8.8 0 4.8 1.6 5.9 7.2 5.9h10.8c-1.6 15.2-5.4 17.9-20 17.9-16.6 0-20.8-5.3-20.8-16.4 0-3.4.8-10.5 1.8-17.3l6.6-46.6zM308.2 0c-54.8 0-99.3 44.5-99.3 99.3s44.5 99.3 99.3 99.3 99.3-44.5 99.3-99.3S363 0 308.2 0zm-4.9 122c-2 16.5-3.9 17.6-17.5 17.6h-47.1l.9-6.6c2-15.8 2.2-19.2 29.3-34.6 8.5-4.8 15.2-8.6 15.2-14.6 0-4.8-3.9-5.6-9.1-5.6h-28.4c1.5-14.4 4.8-18.9 29-18.9 22.1 0 31.7 6.2 31.7 20.9 0 19-12.3 25-28.2 33-7.8 3.9-12.9 6.8-15.2 8.9h39.4v-.1zm72.1-54c-1.4 10.1-5.7 10.3-17.6 10.3H337l-1.8 12.3h6.2c20.5 0 29.4 7.9 29.4 22.1 0 19.7-10.1 27-32.4 27h-30c2.2-15.2 4.8-17.6 18.4-17.6h12.8c6 0 10.5-.9 10.5-7.7 0-5.1-4.4-6.2-10.9-6.2h-19.6c-3.7 0-4.9-.3-4.9-2.6 0-.4 0-1 .1-1.6l6.1-43.3h55.6l-1.1 7.3z"
});

var _ref2$8 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M485.5 120.8c-2.3 16.5-4.5 20.3-28.5 20.3-25.5 0-31.7-10.2-31.7-26.8 0-5.3.6-11.3 1.5-17.8 3.8-27.2 6.2-43.1 39.3-43.1 20.4 0 26.5 2.9 26.5 11.7 0 2.3-.5 5.3-1.2 8.6H474c-10.6 0-15.1.4-17.7 3-2.9 2.9-4.5 9.9-6.2 22.2-.7 4.8-1.1 8.7-1.1 11.6 0 8.9 3.6 10.2 14.6 10.2l21.9.1zM530.2 100c.2-1.4.3-2.7.3-3.6 0-3.9-2-4.8-9-4.8h-23.8c2.5-14.2 5.3-17.8 27.1-17.8s27.4 6.7 27.4 20.7c0 3.8-.5 8.1-1.2 12.9l-4.6 31.7c-3.5.7-13.6 1.8-25.9 1.8-24 0-29.3-7.7-29.3-18 0-.9 0-2.4.2-4.4 1.3-10.6 6.1-18.4 25-18.4l13.8-.1zm-1.8 12.8H519c-4 0-6.7 1.5-6.7 6.7 0 2.9 1.8 4.7 8.8 4.7 2 0 4 0 5.6-.1l1.7-11.3zM583.4 123.2c4.3 0 5.5-.7 5.5-2.9 0-2.7-3.5-3.5-13.5-7.9-12-5.2-15.5-10.2-15.5-17.4 0-1.2.1-3 .3-4.3 1.9-10.1 7.8-17 28.3-17 18 0 25.9 1.9 25.9 11.4 0 1.9-.3 4-.9 6.5h-26.9c-2.7 0-4.3.6-4.3 2.5 0 2.2 1.3 2.5 10.6 6.9 10.9 5.3 18.1 9.3 18.1 20.1 0 1.2-.1 2.9-.2 3.8-1.4 10.1-7.3 16.3-28.9 16.3-17.1 0-25.6-1.6-25.6-12.7 0-1.5.1-3.2.5-5.2l26.6-.1zM624.4 75.1h22l-9 64.6h-22l9-64.6zm1.9-15.6c1.3-8.9 2.7-9.3 12.5-9.3 8.1 0 10.5.2 10.5 4.9 0 1.2-.1 2.6-.3 4.3-1.3 8.9-2 9.9-12.8 9.9-7.5 0-10.1-.6-10.1-5.7-.2-1.1 0-2.5.2-4.1zM656.2 75.8c1.6-.5 14.7-2.1 28.5-2.1 22.9 0 28.4 6.3 28.4 18.3 0 2.9-.3 6.3-1.2 12.3l-4.9 35.3h-22l5-35.9c.5-3.5.6-4.9.6-6.1 0-4.7-2.2-6.1-8.2-6.1-2.5 0-4.8.2-6.8.5l-6.6 47.7h-22l9.2-63.9zM720 107.4c3.2-22.7 6.6-33.7 33.9-33.7 21.8 0 28.4 8.4 28.4 23.2 0 3.3-.3 6.7-.8 10.4-3 22.3-6.3 33.7-33.9 33.7-22.2 0-28.4-8.8-28.4-23.2 0-3.1.2-6.7.8-10.4zm29.5 15.8c8.2 0 8.6-3.5 10.2-15.7.5-3.8.8-6.9.8-9.2 0-5-1.9-6.8-8.6-6.8-8.1 0-8.3 3.3-10.1 15.5-.6 3.9-.9 7.4-.9 9.4 0 5.1 1.9 6.8 8.6 6.8z"
}));

var rodLogo$1 = 'data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Lag_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20viewBox%3D%220%200%20782.3%20198.6%22%20style%3D%22enable-background%3Anew%200%200%20782.3%20198.6%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23FFFFFF%3B%7D%3C%2Fstyle%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M11.9%2C54.5h34c19.2%2C0%2C28.2%2C7.2%2C28.2%2C20.2c0%2C0.8%2C0%2C2.2-0.2%2C4.1c-1.2%2C9.7-5.9%2C14.7-14.2%2C17.5%20%20%20c6.2%2C2.6%2C10.8%2C8.1%2C10.8%2C17.2c0%2C0.2%2C0%2C1.1-0.1%2C2.5c-1.4%2C16.5-10.9%2C23.5-33.1%2C23.5H0L11.9%2C54.5L11.9%2C54.5z%20M36%2C121%20%20%20c7.4%2C0%2C10.1-1.5%2C11.2-7.9c0.1-0.7%2C0.2-1.9%2C0.2-2.6c0-4.8-3.1-6.1-8.8-6.1h-9.9L26.4%2C121H36L36%2C121z%20M38%2C88.6%20%20%20c9.3%2C0%2C11.5-1.9%2C12.2-7.4c0.1-0.8%2C0.1-1.8%2C0.1-2.2c0-4.1-2-5.9-8-5.9h-9.2l-2.2%2C15.5H38z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M133.9%2C123.1c-2.8%2C15.3-7.7%2C17.9-28%2C17.9c-22.6%2C0-28.9-8.5-28.9-23.2c0-3.2%2C0.3-6.7%2C0.8-10.6%20%20%20C80.8%2C84.6%2C85%2C73.4%2C111%2C73.4c21.4%2C0%2C27.8%2C8.5%2C27.8%2C22.9c0%2C3.8-0.4%2C7.9-1.9%2C16.9c-0.2%2C1.4-0.6%2C2-3.1%2C2H98.5c-0.1%2C0.7-0.1%2C1.4-0.1%2C2%20%20%20c0%2C4.5%2C2.6%2C5.8%2C9.5%2C5.8L133.9%2C123.1L133.9%2C123.1z%20M117%2C102.7c0.5-2.4%2C0.7-4.4%2C0.7-5.9c0-4.8-2.4-5.9-7.8-5.9%20%20%20c-6.1%2C0-8.2%2C0.7-9.8%2C11.8H117L117%2C102.7z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M152.8%2C60.7h22.1l-2.1%2C14.1H191l-2.4%2C16.5h-18.2l-2.4%2C17.1c-0.5%2C3.3-0.8%2C6.7-0.8%2C8.8c0%2C4.8%2C1.6%2C5.9%2C7.2%2C5.9%20%20%20h10.8c-1.6%2C15.2-5.4%2C17.9-20%2C17.9c-16.6%2C0-20.8-5.3-20.8-16.4c0-3.4%2C0.8-10.5%2C1.8-17.3L152.8%2C60.7L152.8%2C60.7z%22%2F%3E%20%3C%2Fg%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M308.2%2C0c-54.8%2C0-99.3%2C44.5-99.3%2C99.3s44.5%2C99.3%2C99.3%2C99.3s99.3-44.5%2C99.3-99.3S363%2C0%2C308.2%2C0L308.2%2C0z%20%20%20M303.3%2C122c-2%2C16.5-3.9%2C17.6-17.5%2C17.6h-47.1l0.9-6.6c2-15.8%2C2.2-19.2%2C29.3-34.6c8.5-4.8%2C15.2-8.6%2C15.2-14.6%20%20c0-4.8-3.9-5.6-9.1-5.6h-28.4c1.5-14.4%2C4.8-18.9%2C29-18.9c22.1%2C0%2C31.7%2C6.2%2C31.7%2C20.9c0%2C19-12.3%2C25-28.2%2C33%20%20c-7.8%2C3.9-12.9%2C6.8-15.2%2C8.9H303.3L303.3%2C122z%20M375.4%2C68c-1.4%2C10.1-5.7%2C10.3-17.6%2C10.3H337l-1.8%2C12.3h6.2%20%20c20.5%2C0%2C29.4%2C7.9%2C29.4%2C22.1c0%2C19.7-10.1%2C27-32.4%2C27h-30c2.2-15.2%2C4.8-17.6%2C18.4-17.6h12.8c6%2C0%2C10.5-0.9%2C10.5-7.7%20%20c0-5.1-4.4-6.2-10.9-6.2h-19.6c-3.7%2C0-4.9-0.3-4.9-2.6c0-0.4%2C0-1%2C0.1-1.6l6.1-43.3h55.6L375.4%2C68L375.4%2C68z%22%2F%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M485.5%2C120.8c-2.3%2C16.5-4.5%2C20.3-28.5%2C20.3c-25.5%2C0-31.7-10.2-31.7-26.8c0-5.3%2C0.6-11.3%2C1.5-17.8%20%20%20c3.8-27.2%2C6.2-43.1%2C39.3-43.1c20.4%2C0%2C26.5%2C2.9%2C26.5%2C11.7c0%2C2.3-0.5%2C5.3-1.2%2C8.6h-17.4c-10.6%2C0-15.1%2C0.4-17.7%2C3%20%20%20c-2.9%2C2.9-4.5%2C9.9-6.2%2C22.2c-0.7%2C4.8-1.1%2C8.7-1.1%2C11.6c0%2C8.9%2C3.6%2C10.2%2C14.6%2C10.2L485.5%2C120.8L485.5%2C120.8z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M530.2%2C100c0.2-1.4%2C0.3-2.7%2C0.3-3.6c0-3.9-2-4.8-9-4.8h-23.8c2.5-14.2%2C5.3-17.8%2C27.1-17.8%20%20%20c21.8%2C0%2C27.4%2C6.7%2C27.4%2C20.7c0%2C3.8-0.5%2C8.1-1.2%2C12.9l-4.6%2C31.7c-3.5%2C0.7-13.6%2C1.8-25.9%2C1.8c-24%2C0-29.3-7.7-29.3-18%20%20%20c0-0.9%2C0-2.4%2C0.2-4.4c1.3-10.6%2C6.1-18.4%2C25-18.4L530.2%2C100L530.2%2C100z%20M528.4%2C112.8H519c-4%2C0-6.7%2C1.5-6.7%2C6.7%20%20%20c0%2C2.9%2C1.8%2C4.7%2C8.8%2C4.7c2%2C0%2C4%2C0%2C5.6-0.1L528.4%2C112.8L528.4%2C112.8z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M583.4%2C123.2c4.3%2C0%2C5.5-0.7%2C5.5-2.9c0-2.7-3.5-3.5-13.5-7.9c-12-5.2-15.5-10.2-15.5-17.4c0-1.2%2C0.1-3%2C0.3-4.3%20%20%20c1.9-10.1%2C7.8-17%2C28.3-17c18%2C0%2C25.9%2C1.9%2C25.9%2C11.4c0%2C1.9-0.3%2C4-0.9%2C6.5h-26.9c-2.7%2C0-4.3%2C0.6-4.3%2C2.5c0%2C2.2%2C1.3%2C2.5%2C10.6%2C6.9%20%20%20c10.9%2C5.3%2C18.1%2C9.3%2C18.1%2C20.1c0%2C1.2-0.1%2C2.9-0.2%2C3.8c-1.4%2C10.1-7.3%2C16.3-28.9%2C16.3c-17.1%2C0-25.6-1.6-25.6-12.7%20%20%20c0-1.5%2C0.1-3.2%2C0.5-5.2L583.4%2C123.2L583.4%2C123.2z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M624.4%2C75.1h22l-9%2C64.6h-22L624.4%2C75.1z%20M626.3%2C59.5c1.3-8.9%2C2.7-9.3%2C12.5-9.3c8.1%2C0%2C10.5%2C0.2%2C10.5%2C4.9%20%20%20c0%2C1.2-0.1%2C2.6-0.3%2C4.3c-1.3%2C8.9-2%2C9.9-12.8%2C9.9c-7.5%2C0-10.1-0.6-10.1-5.7C625.9%2C62.5%2C626.1%2C61.1%2C626.3%2C59.5L626.3%2C59.5z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M656.2%2C75.8c1.6-0.5%2C14.7-2.1%2C28.5-2.1c22.9%2C0%2C28.4%2C6.3%2C28.4%2C18.3c0%2C2.9-0.3%2C6.3-1.2%2C12.3l-4.9%2C35.3h-22%20%20%20l5-35.9c0.5-3.5%2C0.6-4.9%2C0.6-6.1c0-4.7-2.2-6.1-8.2-6.1c-2.5%2C0-4.8%2C0.2-6.8%2C0.5l-6.6%2C47.7h-22L656.2%2C75.8L656.2%2C75.8z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M720%2C107.4c3.2-22.7%2C6.6-33.7%2C33.9-33.7c21.8%2C0%2C28.4%2C8.4%2C28.4%2C23.2c0%2C3.3-0.3%2C6.7-0.8%2C10.4%20%20%20c-3%2C22.3-6.3%2C33.7-33.9%2C33.7c-22.2%2C0-28.4-8.8-28.4-23.2C719.2%2C114.7%2C719.4%2C111.1%2C720%2C107.4L720%2C107.4z%20M749.5%2C123.2%20%20%20c8.2%2C0%2C8.6-3.5%2C10.2-15.7c0.5-3.8%2C0.8-6.9%2C0.8-9.2c0-5-1.9-6.8-8.6-6.8c-8.1%2C0-8.3%2C3.3-10.1%2C15.5c-0.6%2C3.9-0.9%2C7.4-0.9%2C9.4%20%20%20C740.9%2C121.5%2C742.8%2C123.2%2C749.5%2C123.2L749.5%2C123.2z%22%2F%3E%20%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E';

var _ref$a =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.1 97.3c-5.5 0-10 4.5-10 10v66.1c0 1.4.6 2.7 1.5 3.6l35 34.8c3.9 3.9 10.3 3.9 14.1 0 1.9-1.9 2.9-4.4 2.9-7.1 0-2.7-1.1-5.2-2.9-7.1l-30.6-30.5v-59.9c0-5.4-4.5-9.9-10-9.9z"
});

var _ref2$9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.3 295.2C80.4 295.2 25.2 240 25.2 172c0-67.9 55.2-123.2 123.2-123.2 67.9 0 123.2 55.2 123.2 123.2-.1 68-55.3 123.2-123.3 123.2zm0-230.9C88.9 64.3 40.6 112.6 40.6 172c0 59.4 48.3 107.8 107.8 107.8S256.1 231.5 256.1 172c0-59.4-48.3-107.7-107.8-107.7z",
  fill: "#fff",
  id: "Ellipse_234"
});

var _ref3$4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M183.5 184.3h-39.3l-23.7-53.8c-1.7-3.9.1-8.4 3.9-10.1 3.9-1.7 8.4.1 10.1 3.9l19.6 44.6h29.2c4.3 0 7.7 3.4 7.7 7.7s-3.2 7.7-7.5 7.7z",
  fill: "#fff",
  id: "Path_1040"
});

var _ref4$2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M240.8 91.5c-19-22-45.2-36.5-73.7-41l-2.1-.3V22.5h13c5.5 0 10-4.5 10-10s-4.5-10-10-10h-59.5c-5.5 0-10 4.5-10 10s4.5 10 10 10h13v27.6l-2.1.3c-28.5 4.4-54.7 19-73.7 41-19.4 22.3-29.9 50.6-29.9 80 0 67.5 54.9 122.4 122.4 122.4s122.4-54.9 122.4-122.4c0-29.3-10.6-57.7-29.8-79.9zm-92.5 188c-59.2 0-107.1-48-107.1-107.1s48-107.1 107.1-107.1 107.1 48 107.1 107.1-47.9 107.1-107.1 107.1z"
});

var _ref$b =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2$a =
/*#__PURE__*/
React.createElement("path", {
  className: "a",
  d: "M4.673 10.75h6.076a.468.468 0 000-.935H4.673a.468.468 0 100 .935zM16.825 12.619H4.673a.468.468 0 100 .935h12.152a.468.468 0 100-.935zM16.825 15.423H4.673a.468.468 0 000 .935h12.152a.468.468 0 100-.935z"
});

var _ref3$5 =
/*#__PURE__*/
React.createElement("path", {
  className: "a",
  d: "M25.271.035L9.315 0a2.774 2.774 0 00-2.772 2.771v2.395l-3.772.008A2.774 2.774 0 000 7.946v9.881a2.774 2.774 0 002.771 2.771h2.837v4.674a.467.467 0 00.813.315l4.535-4.989 7.77-.032a2.774 2.774 0 002.774-2.773v-.053l2.458 2.7a.467.467 0 00.813-.315v-4.668h.5a2.774 2.774 0 002.771-2.771V2.804A2.775 2.775 0 0025.271.035zm-4.707 17.76a1.839 1.839 0 01-1.839 1.836l-7.978.033a.468.468 0 00-.344.153l-3.86 4.247v-3.935a.467.467 0 00-.467-.467h-3.3a1.839 1.839 0 01-1.841-1.836V7.945a1.839 1.839 0 011.837-1.837L7.01 6.1l11.717-.025a1.839 1.839 0 011.837 1.837v9.881zm6.543-5.108a1.838 1.838 0 01-1.837 1.836h-.97a.467.467 0 00-.467.467v3.932L21.5 16.35V7.912a2.775 2.775 0 00-2.772-2.771l-11.25.023V2.771A1.839 1.839 0 019.314.935L25.27.968a1.839 1.839 0 011.837 1.837v9.88z"
});

var _ref$c =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.458 10.853a1.793 1.793 0 00-.994-3.058l-6.053-.88a.791.791 0 01-.6-.433L14.108.999a1.793 1.793 0 00-3.215 0L8.186 6.484a.791.791 0 01-.6.433l-6.053.88a1.793 1.793 0 00-.99 3.056l4.38 4.269a.793.793 0 01.228.7l-1.034 6.031a1.755 1.755 0 00.391 1.454 1.812 1.812 0 002.21.436l5.413-2.846a.81.81 0 01.737 0l5.414 2.846a1.774 1.774 0 00.834.209 1.8 1.8 0 001.376-.645 1.754 1.754 0 00.391-1.454l-1.034-6.028a.792.792 0 01.228-.7z",
  fill: "#eceff5"
});

var _ref$d =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M11.9 54.5h34c19.2 0 28.2 7.2 28.2 20.2 0 .8 0 2.2-.2 4.1-1.2 9.7-5.9 14.7-14.2 17.5 6.2 2.6 10.8 8.1 10.8 17.2 0 .2 0 1.1-.1 2.5-1.4 16.5-10.9 23.5-33.1 23.5H0l11.9-85zM36 121c7.4 0 10.1-1.5 11.2-7.9.1-.7.2-1.9.2-2.6 0-4.8-3.1-6.1-8.8-6.1h-9.9L26.4 121H36zm2-32.4c9.3 0 11.5-1.9 12.2-7.4.1-.8.1-1.8.1-2.2 0-4.1-2-5.9-8-5.9h-9.2l-2.2 15.5H38zM133.9 123.1c-2.8 15.3-7.7 17.9-28 17.9-22.6 0-28.9-8.5-28.9-23.2 0-3.2.4-6.7.8-10.6 3-22.6 7.2-33.8 33.2-33.8 21.4 0 27.8 8.5 27.8 22.9 0 3.8-.4 7.9-1.9 16.9-.2 1.4-.6 2-3.1 2H98.5c-.1.7-.1 1.4-.1 2 0 4.5 2.6 5.8 9.5 5.8l26 .1zM117 102.7c.5-2.4.7-4.4.7-5.9 0-4.8-2.4-5.9-7.8-5.9-6.1 0-8.2.7-9.8 11.8H117zM152.8 60.7h22.1l-2.1 14.1H191l-2.4 16.5h-18.2l-2.4 17.1c-.5 3.3-.8 6.7-.8 8.8 0 4.8 1.7 5.9 7.2 5.9h10.8c-1.7 15.2-5.4 17.9-20 17.9-16.6 0-20.8-5.3-20.8-16.4 0-3.4.8-10.5 1.8-17.3l6.6-46.6zM308.2 0c-54.8 0-99.3 44.5-99.3 99.3s44.5 99.3 99.3 99.3 99.3-44.5 99.3-99.3S363 0 308.2 0zm-4.9 122c-2 16.5-3.9 17.6-17.5 17.6h-47.1l.9-6.6c2-15.8 2.2-19.2 29.3-34.6 8.5-4.8 15.2-8.6 15.2-14.6 0-4.8-3.9-5.6-9.1-5.6h-28.4c1.5-14.4 4.8-18.9 29-18.9 22.1 0 31.7 6.2 31.7 20.9 0 19-12.3 25-28.2 33-7.8 3.9-12.9 6.8-15.2 8.9h39.4v-.1zm72.1-54c-1.4 10.1-5.7 10.3-17.6 10.3H337l-1.8 12.3h6.2c20.5 0 29.4 7.9 29.4 22.1 0 19.7-10.1 27-32.4 27h-30c2.2-15.2 4.8-17.6 18.4-17.6h12.8c6 0 10.5-.9 10.5-7.7 0-5.1-4.4-6.2-10.9-6.2h-19.6c-3.7 0-4.9-.3-4.9-2.6 0-.4 0-1 .1-1.6l6.1-43.3h55.6l-1.1 7.3z"
});

var bet25MainLogo = 'data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Lag_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20viewBox%3D%220%200%20407.4%20198.6%22%20style%3D%22enable-background%3Anew%200%200%20407.4%20198.6%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23FFFFFF%3B%7D%3C%2Fstyle%3E%3Cg%3E%20%3Cg%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M11.9%2C54.5h34c19.2%2C0%2C28.2%2C7.2%2C28.2%2C20.2c0%2C0.8%2C0%2C2.2-0.2%2C4.1c-1.2%2C9.7-5.9%2C14.7-14.2%2C17.5%20%20%20c6.2%2C2.6%2C10.8%2C8.1%2C10.8%2C17.2c0%2C0.2%2C0%2C1.1-0.1%2C2.5c-1.4%2C16.5-10.9%2C23.5-33.1%2C23.5H0L11.9%2C54.5L11.9%2C54.5z%20M36%2C121%20%20%20c7.4%2C0%2C10.1-1.5%2C11.2-7.9c0.1-0.7%2C0.2-1.9%2C0.2-2.6c0-4.8-3.1-6.1-8.8-6.1h-9.9L26.4%2C121H36L36%2C121z%20M38%2C88.6%20%20%20c9.3%2C0%2C11.5-1.9%2C12.2-7.4c0.1-0.8%2C0.1-1.8%2C0.1-2.2c0-4.1-2-5.9-8-5.9h-9.2l-2.2%2C15.5H38z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M133.9%2C123.1c-2.8%2C15.3-7.7%2C17.9-28%2C17.9c-22.6%2C0-28.9-8.5-28.9-23.2c0-3.2%2C0.4-6.7%2C0.8-10.6%20%20%20C80.8%2C84.6%2C85%2C73.4%2C111%2C73.4c21.4%2C0%2C27.8%2C8.5%2C27.8%2C22.9c0%2C3.8-0.4%2C7.9-1.9%2C16.9c-0.2%2C1.4-0.6%2C2-3.1%2C2H98.5c-0.1%2C0.7-0.1%2C1.4-0.1%2C2%20%20%20c0%2C4.5%2C2.6%2C5.8%2C9.5%2C5.8L133.9%2C123.1L133.9%2C123.1z%20M117%2C102.7c0.5-2.4%2C0.7-4.4%2C0.7-5.9c0-4.8-2.4-5.9-7.8-5.9%20%20%20c-6.1%2C0-8.2%2C0.7-9.8%2C11.8H117L117%2C102.7z%22%2F%3E%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M152.8%2C60.7h22.1l-2.1%2C14.1H191l-2.4%2C16.5h-18.2l-2.4%2C17.1c-0.5%2C3.3-0.8%2C6.7-0.8%2C8.8c0%2C4.8%2C1.7%2C5.9%2C7.2%2C5.9%20%20%20h10.8c-1.7%2C15.2-5.4%2C17.9-20%2C17.9c-16.6%2C0-20.8-5.3-20.8-16.4c0-3.4%2C0.8-10.5%2C1.8-17.3L152.8%2C60.7L152.8%2C60.7z%22%2F%3E%20%3C%2Fg%3E%20%3Cpath%20class%3D%22st0%22%20d%3D%22M308.2%2C0c-54.8%2C0-99.3%2C44.5-99.3%2C99.3s44.5%2C99.3%2C99.3%2C99.3s99.3-44.5%2C99.3-99.3S363%2C0%2C308.2%2C0L308.2%2C0z%20%20%20M303.3%2C122c-2%2C16.5-3.9%2C17.6-17.5%2C17.6h-47.1l0.9-6.6c2-15.8%2C2.2-19.2%2C29.3-34.6c8.5-4.8%2C15.2-8.6%2C15.2-14.6%20%20c0-4.8-3.9-5.6-9.1-5.6h-28.4c1.5-14.4%2C4.8-18.9%2C29-18.9c22.1%2C0%2C31.7%2C6.2%2C31.7%2C20.9c0%2C19-12.3%2C25-28.2%2C33%20%20c-7.8%2C3.9-12.9%2C6.8-15.2%2C8.9H303.3L303.3%2C122z%20M375.4%2C68c-1.4%2C10.1-5.7%2C10.3-17.6%2C10.3H337l-1.8%2C12.3h6.2%20%20c20.5%2C0%2C29.4%2C7.9%2C29.4%2C22.1c0%2C19.7-10.1%2C27-32.4%2C27h-30c2.2-15.2%2C4.8-17.6%2C18.4-17.6h12.8c6%2C0%2C10.5-0.9%2C10.5-7.7%20%20c0-5.1-4.4-6.2-10.9-6.2h-19.6c-3.7%2C0-4.9-0.3-4.9-2.6c0-0.4%2C0-1%2C0.1-1.6l6.1-43.3h55.6L375.4%2C68L375.4%2C68z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E';

var _templateObject$d = taggedTemplateLiteral(['\n    flex-basis: 100%;\n    flex-direction: column;\n'], ['\n    flex-basis: 100%;\n    flex-direction: column;\n']),
    _templateObject2$a = taggedTemplateLiteral(['\n    display: flex;\n    box-sizing: border-box;\n    width: 100%;\n    max-width: 100vw;\n    position: relative;\n    background: ', ';\n    justify-content: space-between;\n    padding: 8px;\n    align-items: center;\n    height: 60px;\n    ', ';\n\n    .tooltip {\n        opacity: 1 !important;\n        font-size: 14px;\n        font-weight: bold;\n        color: #505050;\n    }\n    .mobile-time {\n        display: none;\n    }\n    @media screen and (max-width: 1200px) {\n        .tooltip {\n            display: none !important;\n        }\n    }\n    @media screen and (max-width: 700px) {\n        flex-wrap: wrap;\n        padding: 0 10px;\n        font-size: 10px;\n        height: 80px;\n        border-bottom: none;\n\n        .mobile-time {\n            display: flex;\n            margin: 0 0 0 14px;\n        }\n        .desktop-time {\n            display: none;\n        }\n    }\n'], ['\n    display: flex;\n    box-sizing: border-box;\n    width: 100%;\n    max-width: 100vw;\n    position: relative;\n    background: ', ';\n    justify-content: space-between;\n    padding: 8px;\n    align-items: center;\n    height: 60px;\n    ', ';\n\n    .tooltip {\n        opacity: 1 !important;\n        font-size: 14px;\n        font-weight: bold;\n        color: #505050;\n    }\n    .mobile-time {\n        display: none;\n    }\n    @media screen and (max-width: 1200px) {\n        .tooltip {\n            display: none !important;\n        }\n    }\n    @media screen and (max-width: 700px) {\n        flex-wrap: wrap;\n        padding: 0 10px;\n        font-size: 10px;\n        height: 80px;\n        border-bottom: none;\n\n        .mobile-time {\n            display: flex;\n            margin: 0 0 0 14px;\n        }\n        .desktop-time {\n            display: none;\n        }\n    }\n']),
    _templateObject3$7 = taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    border-radius: 5px;\n    padding: 12px;\n    height: 100%;\n    text-decoration: none;\n    color: white;\n    font-size: 12px;\n    white-space: nowrap;\n\n    img {\n        height: 20px;\n    }\n    &:hover {\n        background: rgba(255, 255, 255, 0.1);\n    }\n    @media screen and (max-width: 1400px) {\n        //1250 (~1200px) as edge case\n        padding: 12px 5px;\n    }\n    @media screen and (max-width: 700px) {\n        padding: 5px 2px;\n        font-size: 10px;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    border-radius: 5px;\n    padding: 12px;\n    height: 100%;\n    text-decoration: none;\n    color: white;\n    font-size: 12px;\n    white-space: nowrap;\n\n    img {\n        height: 20px;\n    }\n    &:hover {\n        background: rgba(255, 255, 255, 0.1);\n    }\n    @media screen and (max-width: 1400px) {\n        //1250 (~1200px) as edge case\n        padding: 12px 5px;\n    }\n    @media screen and (max-width: 700px) {\n        padding: 5px 2px;\n        font-size: 10px;\n    }\n']),
    _templateObject4$5 = taggedTemplateLiteral(['\n    cursor: pointer;\n    display: ', ';\n    @media screen and (max-width: 700px) {\n        display: ', ';\n        margin-right: 50px;\n    }\n'], ['\n    cursor: pointer;\n    display: ', ';\n    @media screen and (max-width: 700px) {\n        display: ', ';\n        margin-right: 50px;\n    }\n']),
    _templateObject5$4 = taggedTemplateLiteral(['\n    display: flex;\n    justify-content: ', ';\n    align-items: center;\n    height: 100%;\n    width: ', ';\n\n    @media screen and (max-width: 1050px) {\n        width: auto;\n    }\n\n    @media screen and (max-width: 700px) {\n        width: 100%;\n        height: 40px;\n        justify-content: space-between;\n    }\n'], ['\n    display: flex;\n    justify-content: ', ';\n    align-items: center;\n    height: 100%;\n    width: ', ';\n\n    @media screen and (max-width: 1050px) {\n        width: auto;\n    }\n\n    @media screen and (max-width: 700px) {\n        width: 100%;\n        height: 40px;\n        justify-content: space-between;\n    }\n']),
    _templateObject6$4 = taggedTemplateLiteral(['\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    justify-content: center;\n    border-radius: 8px;\n    height: 100%;\n    width: 32%;\n    position: relative;\n    padding: 0 15px;\n    transition: all 0.3s ease;\n    background: ', ';\n    &:hover {\n        background: ', ';\n    }\n\n    @media screen and (max-width: 1150px) {\n        ', ';\n    }\n'], ['\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    justify-content: center;\n    border-radius: 8px;\n    height: 100%;\n    width: 32%;\n    position: relative;\n    padding: 0 15px;\n    transition: all 0.3s ease;\n    background: ', ';\n    &:hover {\n        background: ', ';\n    }\n\n    @media screen and (max-width: 1150px) {\n        ', ';\n    }\n']),
    _templateObject7$3 = taggedTemplateLiteral(['\n    height: ', ';\n'], ['\n    height: ', ';\n']),
    _templateObject8$3 = taggedTemplateLiteral(['\n    margin: ', ';\n    height: ', ';\n'], ['\n    margin: ', ';\n    height: ', ';\n']),
    _templateObject9$2 = taggedTemplateLiteral(['\n    position: relative;\n    display: flex;\n    height: 100%;\n    max-height: 43px;\n    width: 480px;\n    justify-content: ', ';\n    align-items: center;\n    margin-right: 15px;\n    @media screen and (max-width: 1150px) {\n        width: 250px;\n        height: 40px;\n\n        ', ' {\n            display: none;\n        }\n        ', ' {\n            position: relative;\n            background: none;\n            justify-content: center;\n        }\n    }\n    @media screen and (max-width: 700px) {\n        width: 100%;\n        ', ';\n    }\n'], ['\n    position: relative;\n    display: flex;\n    height: 100%;\n    max-height: 43px;\n    width: 480px;\n    justify-content: ', ';\n    align-items: center;\n    margin-right: 15px;\n    @media screen and (max-width: 1150px) {\n        width: 250px;\n        height: 40px;\n\n        ', ' {\n            display: none;\n        }\n        ', ' {\n            position: relative;\n            background: none;\n            justify-content: center;\n        }\n    }\n    @media screen and (max-width: 700px) {\n        width: 100%;\n        ', ';\n    }\n']),
    _templateObject10$1 = taggedTemplateLiteral(['\n    font-size: 1rem;\n    width: 33%;\n    justify-content: flex-end;\n    @media screen and (max-width: 1050px) {\n        width: auto;\n    }\n    @media (max-width: 700px) {\n        font-size: 9px;\n        justify-content: space-between;\n        width: 100%;\n    }\n    ', ' {\n        @media screen and (max-width: 374px) {\n            height: 16px;\n            width: 12px;\n        }\n    }\n'], ['\n    font-size: 1rem;\n    width: 33%;\n    justify-content: flex-end;\n    @media screen and (max-width: 1050px) {\n        width: auto;\n    }\n    @media (max-width: 700px) {\n        font-size: 9px;\n        justify-content: space-between;\n        width: 100%;\n    }\n    ', ' {\n        @media screen and (max-width: 374px) {\n            height: 16px;\n            width: 12px;\n        }\n    }\n']);

var Clock = WithClock(DigitalClock);
var Timer = WithTimer(DigitalTimer);

var ToolbarWrapper = styled(Flex)(_templateObject$d);

var ProductsTransitionBarWrapper = styled.div(_templateObject2$a, function (_ref) {
    var background = _ref.background;
    return background ? background : '1C3E60';
}, function (_ref2) {
    var noBorder = _ref2.noBorder;
    return !noBorder && 'border-bottom: 1px solid rgba(255, 255, 255, 0.1)';
});
var ItemWrapper = styled.a(_templateObject3$7);

var ItemLogoWrapper = styled(ItemWrapper)(_templateObject4$5, function (_ref3) {
    var hideOnMob = _ref3.hideOnMob;
    return !hideOnMob ? 'none' : 'flex';
}, function (_ref4) {
    var hideOnMob = _ref4.hideOnMob;
    return hideOnMob ? 'none' : 'flex';
});

var FlexWrapper = styled.div(_templateObject5$4, function (_ref5) {
    var justify = _ref5.justify;
    return justify ? justify : 'flex-start';
}, function (_ref6) {
    var width = _ref6.width;
    return width ? width : 'auto';
});

var LogoWrapper = styled.a(_templateObject6$4, function (_ref7) {
    var bg = _ref7.bg;
    return bg;
}, function (_ref8) {
    var hoverBg = _ref8.hoverBg;
    return hoverBg;
}, function (_ref9) {
    var isActive = _ref9.isActive;
    return isActive ? 'img {opacity: 1};' : 'img {opacity: 0.5};';
});
var StyledIcon = styled.img(_templateObject7$3, function (_ref10) {
    var height = _ref10.height;
    return height || '20px';
});
var ProductImg = styled.img(_templateObject8$3, function (_ref11) {
    var margin = _ref11.margin;
    return margin ? margin : '0';
}, function (_ref12) {
    var height = _ref12.height;
    return height ? height : '120%';
});
var LogosWrapper = styled(FlexWrapper)(_templateObject9$2, function (_ref13) {
    var center = _ref13.center;
    return center ? 'center' : 'space-between';
}, ProductImg, LogoWrapper, function (_ref14) {
    var center = _ref14.center;
    return center && 'justify-content: center;';
});

var TimeWrapper = styled(FlexWrapper)(_templateObject10$1, Icon);

var ProductsTransitionBar = function ProductsTransitionBar(_ref15) {
    var _ref15$simple = _ref15.simple,
        simple = _ref15$simple === undefined ? false : _ref15$simple,
        _ref15$customBetLogo = _ref15.customBetLogo,
        _ref15$rofusLogo = _ref15.rofusLogo,
        rofusLogo = _ref15$rofusLogo === undefined ? spill : _ref15$rofusLogo,
        _ref15$derbyImage = _ref15.derbyImage,
        derbyImage = _ref15$derbyImage === undefined ? derby : _ref15$derbyImage,
        _ref15$betImage = _ref15.betImage,
        betImage = _ref15$betImage === undefined ? bet : _ref15$betImage,
        _ref15$rodImage = _ref15.rodImage,
        rodImage = _ref15$rodImage === undefined ? rod : _ref15$rodImage,
        _ref15$activeProject = _ref15.activeProject,
        activeProject = _ref15$activeProject === undefined ? 'bet' : _ref15$activeProject,
        _ref15$rodLink = _ref15.rodLink,
        rodLink = _ref15$rodLink === undefined ? 'https://www.roed25.dk/' : _ref15$rodLink,
        _ref15$betLink = _ref15.betLink,
        betLink = _ref15$betLink === undefined ? 'https://www.bet25.dk/' : _ref15$betLink,
        _ref15$derbyLink = _ref15.derbyLink,
        derbyLink = _ref15$derbyLink === undefined ? 'https://www.derby25.dk/' : _ref15$derbyLink,
        logoOnClickHandler = _ref15.logoOnClickHandler,
        _ref15$hideMiddlePart = _ref15.hideMiddlePart,
        hideMiddlePart = _ref15$hideMiddlePart === undefined ? false : _ref15$hideMiddlePart,
        props = objectWithoutProperties(_ref15, ['simple', 'customBetLogo', 'rofusLogo', 'derbyImage', 'betImage', 'rodImage', 'activeProject', 'rodLink', 'betLink', 'derbyLink', 'logoOnClickHandler', 'hideMiddlePart']);

    var timePart = function timePart(type) {
        return React.createElement(
            TimeWrapper,
            { className: type },
            React.createElement(
                ItemWrapper,
                {
                    'data-tip': 'StopSpillet',
                    href: 'https://www.stopspillet.dk/',
                    target: '_blank'
                },
                'Hj\xE6lpelinje: StopSpillet'
            ),
            React.createElement(
                ItemWrapper,
                {
                    href: 'https://www.rofus.nu/',
                    target: '_blank',
                    'data-tip': 'Frivilligt udelukkelse via ROFUS'
                },
                'Udeluk dig via ROFUS'
            ),
            React.createElement(
                ItemWrapper,
                {
                    href: 'https://intercom.help/25syv/da/articles/3493600-ansvarligt-spil-25syv',
                    target: '_blank',
                    'data-tip': 'Vejledning om ansvarligt spil'
                },
                'Spil ansvarligt'
            ),
            props.showTimer ? React.createElement(
                Fragment,
                null,
                React.createElement(
                    ItemWrapper,
                    { 'data-tip': 'Mit tidsforbrug' },
                    React.createElement(Timer, {
                        countFrom: props.lastLoginTime,
                        color: props.color,
                        displayFormat: props.timerFormat
                    })
                )
            ) : React.createElement(
                Fragment,
                null,
                React.createElement(
                    ItemWrapper,
                    { 'data-tip': 'Klokken' },
                    React.createElement(Clock, {
                        color: props.color,
                        displayFormat: props.clockFormat
                    })
                )
            )
        );
    };
    return React.createElement(
        ToolbarWrapper,
        { id: 'product-transition-bar' },
        React.createElement(
            ProductsTransitionBarWrapper,
            _extends({}, props, { noBorder: simple }),
            React.createElement(
                FlexWrapper,
                { width: '33.3%' },
                React.createElement(
                    ItemLogoWrapper,
                    {
                        hideOnMob: true,
                        onClick: function onClick() {
                            return logoOnClickHandler ? logoOnClickHandler() : window.location = '/';
                        }
                    },
                    React.createElement('img', {
                        src: bet25MainLogo,
                        alt: 'Bet25',
                        width: '65px',
                        height: '32px'
                    })
                ),
                React.createElement(
                    ItemWrapper,
                    {
                        'data-tip': 'Spillemyndigheden',
                        href: 'https://www.spillemyndigheden.dk/',
                        target: '_blank'
                    },
                    React.createElement('img', {
                        src: rofusLogo,
                        alt: 'rofusLogo',
                        width: '20px',
                        height: '20px'
                    })
                ),
                React.createElement(
                    ItemWrapper,
                    { 'data-tip': 'Aldersgr\xE6nse' },
                    '18+'
                ),
                timePart('mobile-time')
            ),
            !hideMiddlePart ? React.createElement(
                LogosWrapper,
                { center: simple },
                React.createElement(
                    ItemLogoWrapper,
                    {
                        'data-tip': 'Spillemyndigheden',
                        hideOnMob: false,
                        onClick: function onClick() {
                            return logoOnClickHandler ? logoOnClickHandler() : window.location = '/';
                        }
                    },
                    React.createElement('img', {
                        src: bet25MainLogo,
                        alt: 'Bet25',
                        width: '65px',
                        height: '32px'
                    })
                ),
                React.createElement(
                    LogoWrapper,
                    {
                        'data-tip': 'Danmarks nye millionspil: Spil & vind p\xE5 heste',
                        href: derbyLink,
                        isActive: activeProject === 'derby',
                        hoverBg: '#11884D',
                        bg: '#1ABB6D'
                    },
                    React.createElement(StyledIcon, { src: derbyLogo, alt: 'derbyLogo' }),
                    React.createElement(ProductImg, {
                        src: derbyImage,
                        margin: '10px 0 0 0 ',
                        height: '125%'
                    })
                ),
                React.createElement(
                    LogoWrapper,
                    {
                        'data-tip': 'Odds og livebetting i s\xE6rklasse',
                        href: betLink,
                        isActive: activeProject === 'bet',
                        hoverBg: '#20486F',
                        bg: '#112840'
                    },
                    React.createElement(StyledIcon, { src: betLogo, alt: 'betLogo' }),
                    !simple && React.createElement(ProductImg, {
                        src: betImage,
                        margin: '10px 0 0 0 ',
                        height: '120%'
                    })
                ),
                React.createElement(
                    LogoWrapper,
                    {
                        'data-tip': 'Danmarks hyggeligste online casino',
                        href: rodLink,
                        isActive: activeProject === 'rod',
                        hoverBg: '#E63837',
                        bg: '#B81514'
                    },
                    React.createElement(StyledIcon, { src: rodLogo, alt: 'rodLogo' }),
                    React.createElement(ProductImg, {
                        src: rodImage,
                        margin: '11px 0 0 0 ',
                        height: '73%'
                    })
                )
            ) : null,
            timePart('desktop-time'),
            React.createElement(ReactTooltip, {
                border: true,
                borderColor: '#70707033',
                className: 'tooltip',
                type: 'light',
                place: 'bottom',
                effect: 'solid'
            })
        )
    );
};

ProductsTransitionBar.propTypes = {
    betImage: PropTypes.string,
    derbyImage: PropTypes.string,
    rodImage: PropTypes.string,
    rodLink: PropTypes.string,
    betLink: PropTypes.string,
    derbyLink: PropTypes.string,
    activeProject: PropTypes.oneOf(['derby', 'rod', 'bet']),
    background: PropTypes.string,
    color: PropTypes.string,
    clockFormat: PropTypes.string,
    timerFormat: PropTypes.string,
    rofusLogo: PropTypes.string,
    hideMiddlePart: PropTypes.bool,
    logoOnClickHandler: PropTypes.func
};

var _templateObject$e = taggedTemplateLiteral(['\n    ', ';\n    width: ', ';\n    height: ', ';\n'], ['\n    ', ';\n    width: ', ';\n    height: ', ';\n']);

var Img = styled.img.attrs(function (props) {
    return {
        src: props.src,
        alt: props.alt ? props.alt : props.src
    };
})(_templateObject$e, marginProps, function (props) {
    return props.width ? props.width : 'auto';
}, function (props) {
    return props.height ? props.height : 'auto';
});

Img.propTypes = {
    src: PropTypes.string.isRequired,
    width: PropTypes.string,
    height: PropTypes.string
};

Img.defaultProps = {};

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule$1(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var uaParser_min = createCommonjsModule$1(function (module, exports) {
/*!
 * UAParser.js v0.7.21
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */
(function(window,undefined){var LIBVERSION="0.7.21",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i]);}else{mergedRegexes[i]=regexes[i];}}return mergedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match);}else{this[q[0]]=q[1];}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined;}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined;}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined;}}else{this[q]=match?match:undefined;}}}}i+=2;}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,/(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]*)/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i],[NAME,VERSION],[/(konqueror)\/([\w\.]+)/i],[[NAME,"Konqueror"],VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i],[[NAME,"Edge"],VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(Avast)\/([\w\.]+)/i],[[NAME,"Avast Secure Browser"],VERSION],[/(AVG)\/([\w\.]+)/i],[[NAME,"AVG Secure Browser"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/(focus)\/([\w\.]+)/i],[[NAME,"Firefox Focus"],VERSION],[/(opt)\/([\w\.]+)/i],[[NAME,"Opera Touch"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(windowswechat qbcore)\/([\w\.]+)/i],[[NAME,"WeChat(Win) Desktop"],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(brave)\/([\w\.]+)/i],[[NAME,"Brave"],VERSION],[/(qqbrowserlite)\/([\w\.]+)/i],[NAME,VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(baiduboxapp)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i],[NAME],[/(LBBROWSER)/i],[NAME],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/safari\s(line)\/([\w\.]+)/i,/android.+(line)\/([\w\.]+)\/iab/i],[NAME,VERSION],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(sailfishbrowser)\/([\w\.]+)/i],[[NAME,"Sailfish Browser"],VERSION],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/(qihu|qhbrowser|qihoobrowser|360browser)/i],[[NAME,"360 Browser"]],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"],[TYPE,SMARTTV]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/.+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/android.+aft([bms])\sbuild/i],[MODEL,[VENDOR,"Amazon"],[TYPE,SMARTTV]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p|vog-l29|ane-lx1|eml-l29)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/android.+(bah2?-a?[lw]\d{2})/i],[MODEL,[VENDOR,"Huawei"],[TYPE,TABLET]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w*)/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]*)/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w*)/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(lenovo)[_\s-]?([\w-]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"],[TYPE,SMARTTV]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel( [23])?( xl)?)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+;\s(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/(mz)-([\w-]{2,})/i],[[VENDOR,"Meizu"],MODEL,[TYPE,MOBILE]],[/android.+a000(1)\s+build/i,/android.+oneplus\s(a\d{4})[\s)]/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2})\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+;\s(PH-1)\s/i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/[\s\/\(](smart-?tv)[;\)]/i],[[TYPE,SMARTTV]],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9}).+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]*)/i,/(tizen|kaios)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined;}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return {ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};{if(module.exports){exports=module.exports=UAParser;}exports.UAParser=UAParser;}var $=window&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop];}};}})(typeof window==="object"?window:commonjsGlobal$1);
});
var uaParser_min_1 = uaParser_min.UAParser;

var main = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }


var React__default = _interopDefault(React);



var UA = new uaParser_min();
var browser = UA.getBrowser();
var cpu = UA.getCPU();
var device = UA.getDevice();
var engine = UA.getEngine();
var os = UA.getOS();
var ua = UA.getUA();

var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && (nav.platform.includes(type) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object$$1, enumerableOnly) {
  var keys = Object.keys(object$$1);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object$$1);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object$$1, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  SMART_TV: 'smarttv',
  CONSOLE: 'console',
  WEARABLE: 'wearable',
  BROWSER: undefined
};
var BROWSER_TYPES = {
  CHROME: 'Chrome',
  FIREFOX: "Firefox",
  OPERA: "Opera",
  YANDEX: "Yandex",
  SAFARI: "Safari",
  INTERNET_EXPLORER: "Internet Explorer",
  EDGE: "Edge",
  CHROMIUM: "Chromium",
  IE: 'IE',
  MOBILE_SAFARI: "Mobile Safari"
};
var OS_TYPES = {
  IOS: 'iOS',
  ANDROID: "Android",
  WINDOWS_PHONE: "Windows Phone"
};
var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};
var checkType = function checkType(type) {
  switch (type) {
    case DEVICE_TYPES.MOBILE:
      return {
        isMobile: true
      };

    case DEVICE_TYPES.TABLET:
      return {
        isTablet: true
      };

    case DEVICE_TYPES.SMART_TV:
      return {
        isSmartTV: true
      };

    case DEVICE_TYPES.CONSOLE:
      return {
        isConsole: true
      };

    case DEVICE_TYPES.WEARABLE:
      return {
        isWearable: true
      };

    case DEVICE_TYPES.BROWSER:
      return {
        isBrowser: true
      };

    default:
      return initialData;
  }
};
var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

var type = checkType(device.type);

function deviceDetect() {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return broPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return stvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearPayload(isWearable, engine, os, ua);
  }
}

var isMobileType = function isMobileType() {
  return device.type === DEVICE_TYPES.MOBILE;
};

var isTabletType = function isTabletType() {
  return device.type === DEVICE_TYPES.TABLET;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (device.type) {
    case DEVICE_TYPES.MOBILE:
    case DEVICE_TYPES.TABLET:
      return true;

    default:
      return false;
  }
};

var isSmartTVType = function isSmartTVType() {
  return device.type === DEVICE_TYPES.SMART_TV;
};

var isBrowserType = function isBrowserType() {
  return device.type === DEVICE_TYPES.BROWSER;
};

var isWearableType = function isWearableType() {
  return device.type === DEVICE_TYPES.WEARABLE;
};

var isConsoleType = function isConsoleType() {
  return device.type === DEVICE_TYPES.CONSOLE;
};

var isAndroidType = function isAndroidType() {
  return os.name === OS_TYPES.ANDROID;
};

var isWinPhoneType = function isWinPhoneType() {
  return os.name === OS_TYPES.WINDOWS_PHONE;
};

var isIOSType = function isIOSType() {
  return os.name === OS_TYPES.IOS;
};

var isChromeType = function isChromeType() {
  return browser.name === BROWSER_TYPES.CHROME;
};

var isFirefoxType = function isFirefoxType() {
  return browser.name === BROWSER_TYPES.FIREFOX;
};

var isChromiumType = function isChromiumType() {
  return browser.name === BROWSER_TYPES.CHROMIUM;
};

var isEdgeType = function isEdgeType() {
  return browser.name === BROWSER_TYPES.EDGE;
};

var isYandexType = function isYandexType() {
  return browser.name === BROWSER_TYPES.YANDEX;
};

var isSafariType = function isSafariType() {
  return browser.name === BROWSER_TYPES.SAFARI || browser.name === BROWSER_TYPES.MOBILE_SAFARI;
};

var isMobileSafariType = function isMobileSafariType() {
  return browser.name === BROWSER_TYPES.MOBILE_SAFARI;
};

var isOperaType = function isOperaType() {
  return browser.name === BROWSER_TYPES.OPERA;
};

var isIEType = function isIEType() {
  return browser.name === BROWSER_TYPES.INTERNET_EXPLORER || browser.name === BROWSER_TYPES.IE;
};

var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? ua.includes('electron') : false;
};

var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};

var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};

var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};

var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return setDefaults(browser.version);
};

var getBrowserVersion = function getBrowserVersion() {
  return setDefaults(browser.major);
};

var getOsVersion = function getOsVersion() {
  return setDefaults(os.version);
};

var getOsName = function getOsName() {
  return setDefaults(os.name);
};

var getBrowserName = function getBrowserName() {
  return setDefaults(browser.name);
};

var getMobileVendor = function getMobileVendor() {
  return setDefaults(device.vendor);
};

var getMobileModel = function getMobileModel() {
  return setDefaults(device.model);
};

var getEngineName = function getEngineName() {
  return setDefaults(engine.name);
};

var getEngineVersion = function getEngineVersion() {
  return setDefaults(engine.version);
};

var getUseragent = function getUseragent() {
  return setDefaults(ua);
};

var getDeviceType = function getDeviceType() {
  return setDefaults(device.type, 'browser');
};

var isSmartTV = isSmartTVType();
var isConsole = isConsoleType();
var isWearable = isWearableType();
var isMobileSafari = isMobileSafariType();
var isChromium = isChromiumType();
var isMobile = isMobileAndTabletType();
var isMobileOnly = isMobileType();
var isTablet = isTabletType();
var isBrowser = isBrowserType();
var isAndroid = isAndroidType();
var isWinPhone = isWinPhoneType();
var isIOS = isIOSType();
var isChrome = isChromeType();
var isFirefox = isFirefoxType();
var isSafari = isSafariType();
var isOpera = isOperaType();
var isIE = isIEType();
var osVersion = getOsVersion();
var osName = getOsName();
var fullBrowserVersion = getBrowserFullVersion();
var browserVersion = getBrowserVersion();
var browserName = getBrowserName();
var mobileVendor = getMobileVendor();
var mobileModel = getMobileModel();
var engineName = getEngineName();
var engineVersion = getEngineVersion();
var getUA = getUseragent();
var isEdge = isEdgeType();
var isYandex = isYandexType();
var deviceType = getDeviceType();
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      viewClassName = _ref.viewClassName,
      style = _ref.style;
  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      viewClassName = _ref2.viewClassName,
      style = _ref2.style;
  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      viewClassName = _ref3.viewClassName,
      style = _ref3.style;
  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      viewClassName = _ref4.viewClassName,
      style = _ref4.style;
  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      viewClassName = _ref5.viewClassName,
      style = _ref5.style;
  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      viewClassName = _ref6.viewClassName,
      style = _ref6.style;
  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      viewClassName = _ref7.viewClassName,
      style = _ref7.style;
  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style;
  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      viewClassName = _ref9.viewClassName,
      style = _ref9.style;
  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      viewClassName = _ref10.viewClassName,
      style = _ref10.style;
  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      viewClassName = _ref11.viewClassName,
      style = _ref11.style;
  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition;
  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
        _this.isEventListenerAdded = false;
        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
        _this.state = {
          isLandscape: false,
          isPortrait: false
        };
        return _this;
      }

      _createClass(_class, [{
        key: "handleOrientationChange",
        value: function handleOrientationChange() {
          if (!this.isEventListenerAdded) {
            this.isEventListenerAdded = true;
          }

          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: orientation === 0,
            isLandscape: orientation === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function onOrientationChange() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function onPageLoad() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
            if (!this.isEventListenerAdded) {
              this.handleOrientationChange();
              window.addEventListener("load", this.onPageLoad, false);
            } else {
              window.removeEventListener("load", this.onPageLoad, false);
            }

            window.addEventListener("resize", this.onOrientationChange, false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("resize", this.onOrientationChange, false);
        }
      }, {
        key: "render",
        value: function render() {
          return React__default.createElement(WrappedComponent, _extends({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]);

      return _class;
    }(React__default.Component)
  );
}

exports.AndroidView = AndroidView;
exports.BrowserView = BrowserView;
exports.ConsoleView = ConsoleView;
exports.CustomView = CustomView;
exports.IEView = IEView;
exports.IOSView = IOSView;
exports.MobileOnlyView = MobileOnlyView;
exports.MobileView = MobileView;
exports.SmartTVView = SmartTVView;
exports.TabletView = TabletView;
exports.WearableView = WearableView;
exports.WinPhoneView = WinPhoneView;
exports.browserName = browserName;
exports.browserVersion = browserVersion;
exports.deviceDetect = deviceDetect;
exports.deviceType = deviceType;
exports.engineName = engineName;
exports.engineVersion = engineVersion;
exports.fullBrowserVersion = fullBrowserVersion;
exports.getUA = getUA;
exports.isAndroid = isAndroid;
exports.isBrowser = isBrowser;
exports.isChrome = isChrome;
exports.isChromium = isChromium;
exports.isConsole = isConsole;
exports.isEdge = isEdge;
exports.isElectron = isElectron;
exports.isFirefox = isFirefox;
exports.isIE = isIE;
exports.isIOS = isIOS;
exports.isIOS13 = isIOS13;
exports.isIPad13 = isIPad13;
exports.isIPhone13 = isIPhone13;
exports.isIPod13 = isIPod13;
exports.isMobile = isMobile;
exports.isMobileOnly = isMobileOnly;
exports.isMobileSafari = isMobileSafari;
exports.isOpera = isOpera;
exports.isSafari = isSafari;
exports.isSmartTV = isSmartTV;
exports.isTablet = isTablet;
exports.isWearable = isWearable;
exports.isWinPhone = isWinPhone;
exports.isYandex = isYandex;
exports.mobileModel = mobileModel;
exports.mobileVendor = mobileVendor;
exports.osName = osName;
exports.osVersion = osVersion;
exports.withOrientationChange = withOrientationChange;
});

unwrapExports(main);
var main_1 = main.AndroidView;
var main_2 = main.BrowserView;
var main_3 = main.ConsoleView;
var main_4 = main.CustomView;
var main_5 = main.IEView;
var main_6 = main.IOSView;
var main_7 = main.MobileOnlyView;
var main_8 = main.MobileView;
var main_9 = main.SmartTVView;
var main_10 = main.TabletView;
var main_11 = main.WearableView;
var main_12 = main.WinPhoneView;
var main_13 = main.browserName;
var main_14 = main.browserVersion;
var main_15 = main.deviceDetect;
var main_16 = main.deviceType;
var main_17 = main.engineName;
var main_18 = main.engineVersion;
var main_19 = main.fullBrowserVersion;
var main_20 = main.getUA;
var main_21 = main.isAndroid;
var main_22 = main.isBrowser;
var main_23 = main.isChrome;
var main_24 = main.isChromium;
var main_25 = main.isConsole;
var main_26 = main.isEdge;
var main_27 = main.isElectron;
var main_28 = main.isFirefox;
var main_29 = main.isIE;
var main_30 = main.isIOS;
var main_31 = main.isIOS13;
var main_32 = main.isIPad13;
var main_33 = main.isIPhone13;
var main_34 = main.isIPod13;
var main_35 = main.isMobile;
var main_36 = main.isMobileOnly;
var main_37 = main.isMobileSafari;
var main_38 = main.isOpera;
var main_39 = main.isSafari;
var main_40 = main.isSmartTV;
var main_41 = main.isTablet;
var main_42 = main.isWearable;
var main_43 = main.isWinPhone;
var main_44 = main.isYandex;
var main_45 = main.mobileModel;
var main_46 = main.mobileVendor;
var main_47 = main.osName;
var main_48 = main.osVersion;
var main_49 = main.withOrientationChange;

var detectMobile = function detectMobile() {
    return main_35 || main_32;
};

var _ref$e =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
});

var angleLeft = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20256%20512%22%3E%3Cpath%20d%3D%22M31.7%20239l136-136c9.4-9.4%2024.6-9.4%2033.9%200l22.6%2022.6c9.4%209.4%209.4%2024.6%200%2033.9L127.9%20256l96.4%2096.4c9.4%209.4%209.4%2024.6%200%2033.9L201.7%20409c-9.4%209.4-24.6%209.4-33.9%200l-136-136c-9.5-9.4-9.5-24.6-.1-34z%22%2F%3E%3C%2Fsvg%3E';

var _ref$f =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2$b =
/*#__PURE__*/
React.createElement("g", null, React.createElement("circle", {
  cx: 8.207,
  cy: 8.207,
  fill: "none",
  r: 8.207
}), React.createElement("path", {
  className: "b",
  d: "M8.206 16.414a8.207 8.207 0 115.8-2.4 8.207 8.207 0 01-5.8 2.4zm0-14.069a5.862 5.862 0 105.861 5.862 5.868 5.868 0 00-5.861-5.862z"
}));

var _ref3$6 =
/*#__PURE__*/
React.createElement("path", {
  className: "b",
  d: "M15.183 18a1.948 1.948 0 01-1.382-.573l-1.776-1.776a1.954 1.954 0 112.764-2.763l1.775 1.776A1.954 1.954 0 0115.182 18z"
});

var search = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2217.137%22%20height%3D%2218%22%20viewBox%3D%220%200%2017.137%2018%22%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill%3Anone%3B%7D.b%7Bfill%3A%23333%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20transform%3D%22translate%280%200%29%22%3E%3Cellipse%20class%3D%22a%22%20cx%3D%228.207%22%20cy%3D%228.207%22%20rx%3D%228.207%22%20ry%3D%228.207%22%2F%3E%3Cpath%20class%3D%22b%22%20d%3D%22M20.439%2C16.414a8.207%2C8.207%2C0%2C1%2C1%2C5.8-2.4%2C8.207%2C8.207%2C0%2C0%2C1-5.8%2C2.4Zm0-14.069A5.862%2C5.862%2C0%2C1%2C0%2C26.3%2C8.207%2C5.868%2C5.868%2C0%2C0%2C0%2C20.439%2C2.345Z%22%20transform%3D%22translate%28-12.233%200%29%22%2F%3E%3C%2Fg%3E%3Cg%20transform%3D%22translate%2811.453%2012.316%29%22%3E%3Cpath%20class%3D%22b%22%20d%3D%22M340.619%2C354.788a1.948%2C1.948%2C0%2C0%2C1-1.382-.573l-1.776-1.776a1.954%2C1.954%2C0%2C1%2C1%2C2.764-2.763L342%2C351.452a1.954%2C1.954%2C0%2C0%2C1-1.382%2C3.336Z%22%20transform%3D%22translate%28-336.889%20-349.104%29%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E';

var _ref$g =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2$c =
/*#__PURE__*/
React.createElement("path", {
  className: "a",
  d: "M16.772 14.727h-2.863a3.273 3.273 0 010-6.545h2.864a.409.409 0 00.409-.409V6.546a1.633 1.633 0 00-1.506-1.623L13.326.819a1.619 1.619 0 00-2.221-.6l-8.054 4.69H1.636A1.638 1.638 0 00-.003 6.546v9.818A1.638 1.638 0 001.636 18h13.909a1.638 1.638 0 001.636-1.636v-1.228a.409.409 0 00-.409-.409zM13.833 3.352l.891 1.557h-3.565zM4.677 4.909l6.84-3.981a.791.791 0 01.608-.082.8.8 0 01.491.38L6.297 4.909z"
});

var _ref3$7 =
/*#__PURE__*/
React.createElement("path", {
  className: "a",
  d: "M16.772 9h-2.864a2.455 2.455 0 100 4.909h2.864a1.229 1.229 0 001.227-1.227v-2.456A1.229 1.229 0 0016.772 9zm-2.864 3.273a.818.818 0 11.818-.818.819.819 0 01-.817.818z"
});

var walletIcon = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill%3A%23333%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20transform%3D%22translate%280%200%29%22%3E%3Cpath%20class%3D%22a%22%20d%3D%22M16.775%2C14.727H13.912a3.273%2C3.273%2C0%2C0%2C1%2C0-6.545h2.864a.409.409%2C0%2C0%2C0%2C.409-.409V6.546a1.633%2C1.633%2C0%2C0%2C0-1.506-1.623L13.329.819a1.619%2C1.619%2C0%2C0%2C0-2.221-.6L3.054%2C4.909H1.639A1.638%2C1.638%2C0%2C0%2C0%2C0%2C6.546v9.818A1.638%2C1.638%2C0%2C0%2C0%2C1.639%2C18H15.548a1.638%2C1.638%2C0%2C0%2C0%2C1.636-1.636V15.136A.409.409%2C0%2C0%2C0%2C16.775%2C14.727ZM13.836%2C3.352l.891%2C1.557H11.162ZM4.68%2C4.909%2C11.52.928a.791.791%2C0%2C0%2C1%2C.608-.082.8.8%2C0%2C0%2C1%2C.491.38h0L6.3%2C4.909Z%22%20transform%3D%22translate%28-0.003%200%29%22%2F%3E%3Cpath%20class%3D%22a%22%20d%3D%22M303.988%2C234.674h-2.864a2.455%2C2.455%2C0%2C1%2C0%2C0%2C4.909h2.864a1.229%2C1.229%2C0%2C0%2C0%2C1.227-1.227V235.9A1.229%2C1.229%2C0%2C0%2C0%2C303.988%2C234.674Zm-2.864%2C3.273a.818.818%2C0%2C1%2C1%2C.818-.818A.819.819%2C0%2C0%2C1%2C301.125%2C237.947Z%22%20transform%3D%22translate%28-287.216%20-225.674%29%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E';

var _ref$h =
/*#__PURE__*/
React.createElement("path", {
  d: "M254.14 264.91a132.46 132.46 0 10-133.63-131.28 132.82 132.82 0 00133.63 131.28zM482.46 368.76A123 123 0 00469 344.57a164.68 164.68 0 00-114.59-70.73 24.46 24.46 0 00-16.8 4.16A141.21 141.21 0 01171 279.5a21.71 21.71 0 00-16.82-3.89A163.46 163.46 0 0040.87 348.4a141.85 141.85 0 00-13.08 24.42 12.24 12.24 0 00.68 11 230.3 230.3 0 0015.82 23 221 221 0 0026.86 29.84A347.84 347.84 0 0098 459.57a263.84 263.84 0 00314.68-2.79A253.34 253.34 0 00439 433.4a266.29 266.29 0 0026.33-30.31 203.52 203.52 0 0015.42-23.28 9.86 9.86 0 001.71-11.05z"
});

var user = 'data:image/svg+xml,%3Csvg%20id%3D%22Capa_1%22%20data-name%3D%22Capa%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20510.24%20510.24%22%3E%3Ctitle%3Eroed%3C%2Ftitle%3E%3Cg%20id%3D%22User%22%3E%3Cpath%20d%3D%22M254.14%2C264.91A132.46%2C132.46%2C0%2C1%2C0%2C120.51%2C133.63h0A132.82%2C132.82%2C0%2C0%2C0%2C254.14%2C264.91Z%22%2F%3E%3Cpath%20d%3D%22M482.46%2C368.76A123%2C123%2C0%2C0%2C0%2C469%2C344.57a164.68%2C164.68%2C0%2C0%2C0-114.59-70.73A24.46%2C24.46%2C0%2C0%2C0%2C337.61%2C278%2C141.21%2C141.21%2C0%2C0%2C1%2C171%2C279.5a21.71%2C21.71%2C0%2C0%2C0-16.82-3.89A163.46%2C163.46%2C0%2C0%2C0%2C40.87%2C348.4a141.85%2C141.85%2C0%2C0%2C0-13.08%2C24.42%2C12.24%2C12.24%2C0%2C0%2C0%2C.68%2C11%2C230.3%2C230.3%2C0%2C0%2C0%2C15.82%2C23%2C221%2C221%2C0%2C0%2C0%2C26.86%2C29.84A347.84%2C347.84%2C0%2C0%2C0%2C98%2C459.57a263.84%2C263.84%2C0%2C0%2C0%2C314.68-2.79A253.34%2C253.34%2C0%2C0%2C0%2C439%2C433.4a266.29%2C266.29%2C0%2C0%2C0%2C26.33-30.31%2C203.52%2C203.52%2C0%2C0%2C0%2C15.42-23.28A9.86%2C9.86%2C0%2C0%2C0%2C482.46%2C368.76Z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E';

var _templateObject$f = taggedTemplateLiteral(['\n    padding: 5px;\n    box-sizing: border-box;\n    height: 60px;\n    ', ';\n'], ['\n    padding: 5px;\n    box-sizing: border-box;\n    height: 60px;\n    ', ';\n']),
    _templateObject2$b = taggedTemplateLiteral(['\n            position: relative;\n            left: 2px;\n            justify-content: flex-end;\n        '], ['\n            position: relative;\n            left: 2px;\n            justify-content: flex-end;\n        ']),
    _templateObject3$8 = taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    margin-left: 0.5rem;\n    ', ';\n'], ['\n    display: flex;\n    align-items: center;\n    margin-left: 0.5rem;\n    ', ';\n']),
    _templateObject4$6 = taggedTemplateLiteral(['\n            position: absolute;\n            left: 0;\n        '], ['\n            position: absolute;\n            left: 0;\n        ']),
    _templateObject5$5 = taggedTemplateLiteral(['\n    display: flex;\n    ', '\n'], ['\n    display: flex;\n    ', '\n']),
    _templateObject6$5 = taggedTemplateLiteral(['\n              width: 100%;\n          '], ['\n              width: 100%;\n          ']),
    _templateObject7$4 = taggedTemplateLiteral(['\n              width: calc(50vw + 256px);\n              @media (max-width: 1536px) {\n                  width: 66vw;\n              }\n          '], ['\n              width: calc(50vw + 256px);\n              @media (max-width: 1536px) {\n                  width: 66vw;\n              }\n          ']),
    _templateObject8$4 = taggedTemplateLiteral(['\n    display: flex;\n    width: 100%;\n    align-items: center;\n'], ['\n    display: flex;\n    width: 100%;\n    align-items: center;\n']),
    _templateObject9$3 = taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 13px 1rem;\n    border-radius: 5px;\n    cursor: pointer;\n    ', ';\n\n    ', ' {\n        margin: 0;\n        color: white;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 13px 1rem;\n    border-radius: 5px;\n    cursor: pointer;\n    ', ';\n\n    ', ' {\n        margin: 0;\n        color: white;\n    }\n']),
    _templateObject10$2 = taggedTemplateLiteral(['\n              background: rgba(255, 255, 255, 0.1);\n              max-width: 254px;\n              min-width: 140px;\n              box-sizing: border-box;\n              width: 100%;\n              height: 100%;\n              transition: all 0.2s ease;\n\n              ', ' {\n                  opacity: 0.5;\n                  transition: all 0.2s ease;\n              }\n              &:hover {\n                  background: rgba(255, 255, 255, 0.2);\n                  ', ' {\n                      opacity: 1;\n                  }\n              }\n          '], ['\n              background: rgba(255, 255, 255, 0.1);\n              max-width: 254px;\n              min-width: 140px;\n              box-sizing: border-box;\n              width: 100%;\n              height: 100%;\n              transition: all 0.2s ease;\n\n              ', ' {\n                  opacity: 0.5;\n                  transition: all 0.2s ease;\n              }\n              &:hover {\n                  background: rgba(255, 255, 255, 0.2);\n                  ', ' {\n                      opacity: 1;\n                  }\n              }\n          ']),
    _templateObject11$1 = taggedTemplateLiteral(['\n              margin-left: ', ';\n          '], ['\n              margin-left: ', ';\n          ']),
    _templateObject12$1 = taggedTemplateLiteral(['\n    margin-left: auto;\n    margin-right: 0;\n    display: flex;\n'], ['\n    margin-left: auto;\n    margin-right: 0;\n    display: flex;\n']),
    _templateObject13$1 = taggedTemplateLiteral(['\n    display: ', ';\n    align-items: center;\n    margin-left: 0.5rem;\n    ', ';\n'], ['\n    display: ', ';\n    align-items: center;\n    margin-left: 0.5rem;\n    ', ';\n']),
    _templateObject14$1 = taggedTemplateLiteral(['\n            flex-grow: 1;\n            justify-content: flex-end;\n        '], ['\n            flex-grow: 1;\n            justify-content: flex-end;\n        ']),
    _templateObject15$1 = taggedTemplateLiteral(['\n    margin-left: 0.5rem;\n    display: ', ';\n    ', ';\n'], ['\n    margin-left: 0.5rem;\n    display: ', ';\n    ', ';\n']),
    _templateObject16 = taggedTemplateLiteral(['\n    white-space: nowrap;\n    margin: 0;\n    font-size: 14px;\n    font-weight: bold;\n    font-family: \'Roboto Condensed\', sans-serif;\n    color: white;\n\n    @media (max-width: 992px) {\n        margin-right: 5px;\n    }\n'], ['\n    white-space: nowrap;\n    margin: 0;\n    font-size: 14px;\n    font-weight: bold;\n    font-family: \'Roboto Condensed\', sans-serif;\n    color: white;\n\n    @media (max-width: 992px) {\n        margin-right: 5px;\n    }\n']),
    _templateObject17 = taggedTemplateLiteral(['\n    cursor: pointer;\n    width: auto;\n    display: flex;\n    align-items: center;\n    padding: 0.5rem 1rem;\n    box-sizing: border-box;\n    height: 44px;\n    border-radius: 0.25rem;\n    margin: 0 0.5rem 0 0;\n    background: ', ';\n    position: relative;\n\n    @media (max-width: 992px) {\n        padding: 0.4rem;\n    }\n\n    ', ' {\n        margin-left: 0;\n        @media (max-width: 992px) {\n            margin: 0.5rem 0.7rem;\n        }\n    }\n'], ['\n    cursor: pointer;\n    width: auto;\n    display: flex;\n    align-items: center;\n    padding: 0.5rem 1rem;\n    box-sizing: border-box;\n    height: 44px;\n    border-radius: 0.25rem;\n    margin: 0 0.5rem 0 0;\n    background: ', ';\n    position: relative;\n\n    @media (max-width: 992px) {\n        padding: 0.4rem;\n    }\n\n    ', ' {\n        margin-left: 0;\n        @media (max-width: 992px) {\n            margin: 0.5rem 0.7rem;\n        }\n    }\n']),
    _templateObject18 = taggedTemplateLiteral(['\n    display: flex;\n    ', ' {\n        margin: 0 0 0 0.5rem;\n        font-family: \'Roboto Condensed\', sans-serif;\n        font-weight: bold;\n        font-size: 14px;\n    }\n    @media (max-width: 992px) {\n        display: none;\n    }\n'], ['\n    display: flex;\n    ', ' {\n        margin: 0 0 0 0.5rem;\n        font-family: \'Roboto Condensed\', sans-serif;\n        font-weight: bold;\n        font-size: 14px;\n    }\n    @media (max-width: 992px) {\n        display: none;\n    }\n']),
    _templateObject19 = taggedTemplateLiteral(['\n    padding: 1rem 1.6rem;\n    border-radius: 5px;\n    font-size: 1rem;\n    line-height: 1;\n    display: inline-block;\n    border: 1px solid transparent;\n    transition: all 0.3s ease-out;\n    margin-right: 0.5rem;\n    cursor: pointer;\n    background: ', ';\n    color: ', ';\n    font-weight: bold;\n    font-family: \'Roboto Condensed\', sans-serif;\n    @media (max-width: 992px) {\n        padding: 0.8rem;\n    }\n    @media screen and (max-width: 700px) {\n        font-size: 14px;\n        span {\n            display: none;\n        }\n    }\n'], ['\n    padding: 1rem 1.6rem;\n    border-radius: 5px;\n    font-size: 1rem;\n    line-height: 1;\n    display: inline-block;\n    border: 1px solid transparent;\n    transition: all 0.3s ease-out;\n    margin-right: 0.5rem;\n    cursor: pointer;\n    background: ', ';\n    color: ', ';\n    font-weight: bold;\n    font-family: \'Roboto Condensed\', sans-serif;\n    @media (max-width: 992px) {\n        padding: 0.8rem;\n    }\n    @media screen and (max-width: 700px) {\n        font-size: 14px;\n        span {\n            display: none;\n        }\n    }\n']),
    _templateObject20 = taggedTemplateLiteral(['\n    margin: ', ';\n    height: ', ';\n'], ['\n    margin: ', ';\n    height: ', ';\n']),
    _templateObject21 = taggedTemplateLiteral(['\n    width: 12px;\n    height: 12px;\n    border-radius: 100px;\n    border: 2px solid #40b77c;\n    background: #be0000;\n    left: 27px;\n    top: 8px;\n    box-sizing: border-box;\n    position: absolute;\n'], ['\n    width: 12px;\n    height: 12px;\n    border-radius: 100px;\n    border: 2px solid #40b77c;\n    background: #be0000;\n    left: 27px;\n    top: 8px;\n    box-sizing: border-box;\n    position: absolute;\n']);

var Colors = {
    accent: '#FFD804',
    light: '#FFFFFF',
    semiWhite: 'rgba(255,255,255, 0.5)',
    dark: '#000000',
    grey: 'rgb(100, 100, 100)',
    semiDark: 'rgba(0,0,0, 0.6)'
};

var StyledAppNavigation = styled(Flex)(_templateObject$f, !detectMobile() && css(_templateObject2$b));
var LeftArea = styled.div(_templateObject3$8, !detectMobile() && css(_templateObject4$6));
var RightContentWrapper = styled.div(_templateObject5$5, detectMobile() ? css(_templateObject6$5) : css(_templateObject7$4));
var LeftSideWrapper = styled.div(_templateObject8$4);
var SearchButton = styled.div(_templateObject9$3, !detectMobile() ? css(_templateObject10$2, Icon, Icon) : css(_templateObject11$1, function (_ref) {
    var withoutSidebar = _ref.withoutSidebar;
    return withoutSidebar ? '0' : '20px';
}), Text);
var ContentWrapper = styled.div(_templateObject12$1);
var UserAreaWrapper = styled.div(_templateObject13$1, function (_ref2) {
    var userEmail = _ref2.userEmail;
    return userEmail ? 'flex' : 'none';
}, detectMobile() && css(_templateObject14$1));
var LoginWrapper = styled.div(_templateObject15$1, function (_ref3) {
    var userEmail = _ref3.userEmail;
    return !userEmail ? 'flex' : 'none';
}, detectMobile() && css(_templateObject14$1));
var InfoText = styled(Text)(_templateObject16);
var UserAreaButton = styled.div(_templateObject17, function (_ref4) {
    var background = _ref4.background;
    return background || Colors.accent;
}, Icon);
var ShowDesk = styled.div(_templateObject18, Text);
var EnterButton = styled.button(_templateObject19, Colors.accent, Colors.dark);
var ProductImg$1 = styled.img(_templateObject20, function (_ref5) {
    var margin = _ref5.margin;
    return margin ? margin : '0';
}, function (_ref6) {
    var height = _ref6.height;
    return height ? height : '120%';
});

var NotificationIndicator = styled.div(_templateObject21);

var TopBar = function TopBar(_ref7) {
    var onBackButtonClickHandler = _ref7.onBackButtonClickHandler,
        background = _ref7.background,
        searchHandler = _ref7.searchHandler,
        userEmail = _ref7.userEmail,
        balance = _ref7.balance,
        secondColor = _ref7.secondColor,
        bankClickHandler = _ref7.bankClickHandler,
        showUserArea = _ref7.showUserArea,
        signUpHandler = _ref7.signUpHandler,
        showLoginModal = _ref7.showLoginModal,
        afterSearchArea = _ref7.afterSearchArea,
        beforeUserArea = _ref7.beforeUserArea,
        afterUserArea = _ref7.afterUserArea,
        _ref7$withoutSidebar = _ref7.withoutSidebar,
        withoutSidebar = _ref7$withoutSidebar === undefined ? false : _ref7$withoutSidebar,
        _ref7$showBackButton = _ref7.showBackButton,
        showBackButton = _ref7$showBackButton === undefined ? false : _ref7$showBackButton,
        _ref7$isGameRunning = _ref7.isGameRunning,
        isGameRunning = _ref7$isGameRunning === undefined ? false : _ref7$isGameRunning,
        _ref7$isTWA = _ref7.isTWA,
        isTWA = _ref7$isTWA === undefined ? false : _ref7$isTWA,
        _ref7$appLogo = _ref7.appLogo,
        appLogo = _ref7$appLogo === undefined ? '' : _ref7$appLogo,
        _ref7$hasNotification = _ref7.hasNotification,
        hasNotification = _ref7$hasNotification === undefined ? false : _ref7$hasNotification;

    var balanceFormatter = function balanceFormatter(x) {
        if (!x) return;
        return new Intl.NumberFormat('da-DK', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(x || 0);
    };
    return React.createElement(
        StyledAppNavigation,
        {
            background: background,
            justify: 'space-between',
            align: 'center',
            id: 'app-navigation'
        },
        React.createElement(
            LeftArea,
            null,
            isTWA ? React.createElement(ProductImg$1, { src: appLogo, height: '30px' }) : detectMobile() && showBackButton && React.createElement(Icon, {
                ml: 3,
                src: angleLeft,
                color: Colors.light,
                size: showBackButton ? 'xl' : 'lg',
                onClick: onBackButtonClickHandler
            })
        ),
        (searchHandler || afterSearchArea) && React.createElement(
            LeftSideWrapper,
            null,
            searchHandler && React.createElement(
                SearchButton,
                {
                    onClick: searchHandler,
                    withoutSidebar: withoutSidebar
                },
                !detectMobile() && React.createElement(
                    Text,
                    null,
                    'S\xF8g efter spil\u2026'
                ),
                React.createElement(Icon, {
                    src: search,
                    color: Colors.light,
                    size: 'md'
                })
            ),
            afterSearchArea && React.createElement(
                Fragment,
                null,
                afterSearchArea
            )
        ),
        React.createElement(
            RightContentWrapper,
            null,
            React.createElement(
                ContentWrapper,
                null,
                beforeUserArea && React.createElement(
                    Fragment,
                    null,
                    beforeUserArea
                ),
                userEmail && React.createElement(
                    UserAreaWrapper,
                    { userEmail: userEmail },
                    React.createElement(
                        UserAreaButton,
                        {
                            background: Colors.accent,
                            onClick: bankClickHandler
                        },
                        React.createElement(Icon, {
                            size: 'md',
                            src: walletIcon,
                            color: Colors.semiDark,
                            my: 2
                        }),
                        React.createElement(
                            ShowDesk,
                            null,
                            React.createElement(
                                Text,
                                { color: '#333' },
                                'Indbetal'
                            )
                        )
                    ),
                    React.createElement(
                        UserAreaButton,
                        {
                            mx: 1,
                            background: secondColor,
                            borderRadius: 1,
                            onClick: showUserArea
                        },
                        React.createElement(Icon, {
                            size: 'md',
                            src: user,
                            color: Colors.semiWhite,
                            m: !isGameRunning ? 2 : 0
                        }),
                        hasNotification ? React.createElement(NotificationIndicator, null) : null,
                        !isGameRunning && React.createElement(
                            InfoText,
                            null,
                            balanceFormatter(balance ? balance : '0'),
                            ' ',
                            'kr.'
                        )
                    )
                ),
                React.createElement(
                    LoginWrapper,
                    { userEmail: userEmail },
                    React.createElement(
                        EnterButton,
                        { onClick: signUpHandler },
                        'Opret ',
                        React.createElement(
                            'span',
                            null,
                            'konto'
                        )
                    ),
                    React.createElement(
                        EnterButton,
                        {
                            style: {
                                background: secondColor,
                                color: Colors.light
                            },
                            onClick: showLoginModal
                        },
                        'Log ind'
                    )
                ),
                afterUserArea && React.createElement(
                    Fragment,
                    null,
                    afterUserArea
                )
            )
        )
    );
};

TopBar.propTypes = {
    background: PropTypes.string.isRequired,
    sideNavOpen: PropTypes.bool,
    sideNavHandler: PropTypes.func,
    searchHandler: PropTypes.func,
    isGameRunning: PropTypes.bool,
    userEmail: PropTypes.string,
    username: PropTypes.string,
    balance: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    secondColor: PropTypes.string.isRequired,
    bankClickHandler: PropTypes.func.isRequired,
    showUserArea: PropTypes.func.isRequired,
    signUpHandler: PropTypes.func.isRequired,
    showLoginModal: PropTypes.func.isRequired,
    beforeUserArea: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    afterUserArea: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    afterSearchArea: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    isTWA: PropTypes.bool,
    appLogo: PropTypes.string
};

var emailRegEx = /^[a-zA-Z0-9æøåöÆØÅÖ.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
var numericRegEx = /^\d+$/;
var alphabeticRegEx = /^[a-zA-Z æøåöÆØÅÖ]+$/;
var noSpaceRegEx = /^((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).)$/;
var userNameRegEx = /^[a-zA-Z0-9æøåöÆØÅÖ]{6,}$/;
var passwordRegEx = /^(?=.*[A-Za-z])(?=(.*[\d]))(?=.*[A-Z])[A-Za-z0-9]{6,}$/;

var validation = {
    required: 'Skal udfyldes',
    numeric: 'Feltet bør kun indeholde cifre',
    alphabetic: 'Feltet må kun indeholde bogstaver',
    email: 'Ugyldig email',
    min: 'Mindste værdi ',
    max: 'Maksimal værdi ',
    minLength: 'Længde må ikke være mindre end ',
    maxLength: 'Længde må ikke overstige ',
    symbol: 'tegn',
    symbols: 'tegn',
    notValid: 'Ugyldig værdi',
    sameAs: 'Feltet skal bekræftes',
    minNumber: 'Mindste værdi %d',
    maxNumber: 'Maksimal værdi %d'
};

var ValidInput = function ValidInput(_ref) {
    var showErrorOnChange = _ref.showErrorOnChange,
        onChange = _ref.onChange,
        value = _ref.value,
        validate = _ref.validate,
        validationHandler = _ref.validationHandler,
        getValidator = _ref.getValidator,
        placeholder = _ref.placeholder,
        showErrorUnderInput = _ref.showErrorUnderInput,
        props = objectWithoutProperties(_ref, ['showErrorOnChange', 'onChange', 'value', 'validate', 'validationHandler', 'getValidator', 'placeholder', 'showErrorUnderInput']);

    var _useState = useState(null),
        _useState2 = slicedToArray(_useState, 2),
        validationError = _useState2[0],
        setValidationError = _useState2[1];

    var _useState3 = useState([]),
        _useState4 = slicedToArray(_useState3, 2),
        brokenRules = _useState4[0],
        setBrokenRules = _useState4[1];

    var onInputChange = function onInputChange(value) {
        var valid = onValidate(value);

        if (!valid && !showErrorOnChange) {
            // if showing error on change is not enabled
            // the validation error will be reset
            setValidationError(null);
        }

        if (onChange) {
            onChange(value, valid);
        }
    };

    var isValidInput = function isValidInput() {
        onValidate(value);
    };

    var onValidate = function onValidate(value) {
        var inputValidateRules = validate;

        var isValid = true;

        if (inputValidateRules) {
            if (inputValidateRules.required && (
            // deny empty string or just string with empty whitespaces
            value === '' || /^ +$/g.test(value))) {
                setValidationError(inputValidateRules.required.message ? inputValidateRules.required.message : validation.required);
                setBrokenRules([].concat(toConsumableArray(brokenRules), ['required']));

                isValid = false;
            }

            var emptyInput = typeof value === 'undefined' || value === '';
            if (!emptyInput) {
                if (inputValidateRules.numeric && !numericRegEx.test(value)) {
                    setValidationError(inputValidateRules.numeric.message ? inputValidateRules.numeric.message : validation.numeric);
                    setBrokenRules([].concat(toConsumableArray(brokenRules), ['numeric']));

                    isValid = false;
                }

                if (inputValidateRules.alphabetic && !alphabeticRegEx.test(value)) {
                    setValidationError(inputValidateRules.alphabetic.message ? inputValidateRules.alphabetic.message : validation.alphabetic);
                    setBrokenRules([].concat(toConsumableArray(brokenRules), ['alphabetic']));

                    isValid = false;
                }

                if (inputValidateRules.email && !emailRegEx.test(value)) {
                    setValidationError(inputValidateRules.email.message ? inputValidateRules.email.message : validation.email);
                    setBrokenRules([].concat(toConsumableArray(brokenRules), ['email']));

                    isValid = false;
                }

                if (inputValidateRules.withoutSpaces && !noSpaceRegEx.test(value)) {
                    setValidationError(inputValidateRules.withoutSpaces.message ? inputValidateRules.withoutSpaces.message : validation.notValid);
                    setBrokenRules([].concat(toConsumableArray(brokenRules), ['withoutSpaces']));

                    isValid = false;
                }

                if (inputValidateRules.sameAs && value !== inputValidateRules.sameAs.confirmationValue) {
                    setValidationError(inputValidateRules.sameAs.message ? inputValidateRules.sameAs.message : validation.sameAs);
                    setBrokenRules([].concat(toConsumableArray(brokenRules), ['sameAs']));

                    isValid = false;
                }

                if (inputValidateRules.min && value < inputValidateRules.min) {
                    setValidationError(validation.notValid);
                    setBrokenRules([].concat(toConsumableArray(brokenRules), ['min']));

                    isValid = false;
                }

                if (inputValidateRules.max && value > inputValidateRules.max) {
                    setValidationError(validation.notValid);
                    setBrokenRules([].concat(toConsumableArray(brokenRules), ['max']));

                    isValid = false;
                }

                if (inputValidateRules.minLength && value.length < inputValidateRules.minLength) {
                    setValidationError(inputValidateRules.minLengthMessage || validation.notValid);
                    setBrokenRules([].concat(toConsumableArray(brokenRules), ['minLength']));

                    isValid = false;
                }

                if (inputValidateRules.maxLength && value.length > inputValidateRules.maxLength) {
                    setValidationError(validation.notValid);
                    setBrokenRules([].concat(toConsumableArray(brokenRules), ['maxLength']));

                    isValid = false;
                }

                if (inputValidateRules.userName && !userNameRegEx.test(value)) {
                    setValidationError(inputValidateRules.userName.message ? inputValidateRules.userName.message : validation.notValid);
                    setBrokenRules([].concat(toConsumableArray(brokenRules), ['userName']));

                    isValid = false;
                }

                if (inputValidateRules.password && !passwordRegEx.test(value)) {
                    setValidationError(inputValidateRules.password.message ? inputValidateRules.password.message : validation.notValid);
                    setBrokenRules([].concat(toConsumableArray(brokenRules), ['password']));

                    isValid = false;
                }

                if (inputValidateRules.regExp && !inputValidateRules.regExp.test(value)) {
                    setValidationError(validation.notValid);
                    setBrokenRules([].concat(toConsumableArray(brokenRules), ['regExp']));

                    isValid = false;
                }
            }
        }

        if (isValid) {
            setValidationError(null);
        }

        if (validationHandler) {
            validationHandler(isValid);
        }

        return isValid;
    };

    useEffect(function () {
        if (getValidator) {
            getValidator(function () {
                return onValidate(value);
            });
        }
    }, [value]);

    return React.createElement(Input, _extends({}, props, {
        value: value,
        onChange: onInputChange,
        placeholder: placeholder,
        onInputBlueredHandler: isValidInput,
        validationError: !props.onDemand ? validationError : props.showError ? validationError : null,
        disabled: props.disabled,
        type: props.type,
        sublabel: props.sublabel,
        align: props.align,
        showErrorUnderInput: showErrorUnderInput
    }));
};

var _templateObject$g = taggedTemplateLiteral(['\n    0% { transform: translateY(100%); }\n    100% { transform: translateY(0%); }\n'], ['\n    0% { transform: translateY(100%); }\n    100% { transform: translateY(0%); }\n']),
    _templateObject2$c = taggedTemplateLiteral(['\n    0% { transform: translateX(100%); }\n    100% { transform: translateX(0%); }\n'], ['\n    0% { transform: translateX(100%); }\n    100% { transform: translateX(0%); }\n']),
    _templateObject3$9 = taggedTemplateLiteral(['\n    animation-timing-function: cubic-bezier(0.1, -0.6, 0.2, 0);\n    animation-fill-mode: forwards;\n    animation-direction: ', ';\n'], ['\n    animation-timing-function: cubic-bezier(0.1, -0.6, 0.2, 0);\n    animation-fill-mode: forwards;\n    animation-direction: ', ';\n']),
    _templateObject4$7 = taggedTemplateLiteral(['\n    z-index: ', ';\n    margin: 0;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    background: ', ';\n    display: flex;\n    flex-direction: column;\n    animation: ', ' 300ms;\n    ', ';\n\n    @media screen and (min-width: 992px) {\n        animation: ', ' 300ms;\n        ', ';\n        position: absolute;\n        right: 0;\n        width: 400px;\n    }\n    @media screen and (min-width: 376px) {\n        background: ', ';\n    }\n    @media screen and (min-width: 320px) and (max-width: 900px) and (orientation: landscape) {\n        overflow: auto;\n        background: ', ';\n    }\n'], ['\n    z-index: ', ';\n    margin: 0;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    background: ', ';\n    display: flex;\n    flex-direction: column;\n    animation: ', ' 300ms;\n    ', ';\n\n    @media screen and (min-width: 992px) {\n        animation: ', ' 300ms;\n        ', ';\n        position: absolute;\n        right: 0;\n        width: 400px;\n    }\n    @media screen and (min-width: 376px) {\n        background: ', ';\n    }\n    @media screen and (min-width: 320px) and (max-width: 900px) and (orientation: landscape) {\n        overflow: auto;\n        background: ', ';\n    }\n']),
    _templateObject5$6 = taggedTemplateLiteral(['\n    margin: 0;\n    background: none;\n    padding: 0;\n    display: flex;\n    justify-content: center;\n    border-bottom: none;\n    align-items: center;\n    position: relative;\n'], ['\n    margin: 0;\n    background: none;\n    padding: 0;\n    display: flex;\n    justify-content: center;\n    border-bottom: none;\n    align-items: center;\n    position: relative;\n']),
    _templateObject6$6 = taggedTemplateLiteral(['\n    padding: 25px;\n    border-bottom: 2px solid ', ';\n'], ['\n    padding: 25px;\n    border-bottom: 2px solid ', ';\n']),
    _templateObject7$5 = taggedTemplateLiteral(['\n    position: fixed;\n    width: calc(100vw - 30px);\n    top: 15px;\n    left: 15px;\n    z-index: 2;\n'], ['\n    position: fixed;\n    width: calc(100vw - 30px);\n    top: 15px;\n    left: 15px;\n    z-index: 2;\n']),
    _templateObject8$5 = taggedTemplateLiteral(['\n    display: flex;\n    flex-flow: row;\n    align-items: center;\n    flex: 1 1 auto;\n    cursor: auto;\n    width: auto;\n    height: auto;\n    flex-direction: row;\n    justify-content: flex-end;\n'], ['\n    display: flex;\n    flex-flow: row;\n    align-items: center;\n    flex: 1 1 auto;\n    cursor: auto;\n    width: auto;\n    height: auto;\n    flex-direction: row;\n    justify-content: flex-end;\n']),
    _templateObject9$4 = taggedTemplateLiteral(['\n    width: 45px;\n    height: 45px;\n\n    display: flex;\n    align-content: center;\n    justify-content: space-around;\n    align-items: center;\n    border-radius: 5px;\n    cursor: pointer;\n\n    &:hover {\n        background-color: ', ';\n        box-shadow: 4px 4px 8px 0 rgba(34, 60, 80, 0.2);\n    }\n'], ['\n    width: 45px;\n    height: 45px;\n\n    display: flex;\n    align-content: center;\n    justify-content: space-around;\n    align-items: center;\n    border-radius: 5px;\n    cursor: pointer;\n\n    &:hover {\n        background-color: ', ';\n        box-shadow: 4px 4px 8px 0 rgba(34, 60, 80, 0.2);\n    }\n']),
    _templateObject10$3 = taggedTemplateLiteral(['\n    line-height: 1;\n    border: 1px solid transparent;\n    border-radius: 5px;\n    transition: all 0.3s ease-out;\n    text-transform: none;\n    cursor: pointer;\n    background: ', ';\n    color: ', ';\n    font-weight: bold;\n    display: inline-block;\n    font-size: 14px;\n    margin: 0 0 0 auto;\n    font-family: ', ',\n        sans-serif;\n    padding: 15px 31px 14px;\n    box-shadow: 4px 4px 8px 0 rgba(34, 60, 80, 0.2);\n'], ['\n    line-height: 1;\n    border: 1px solid transparent;\n    border-radius: 5px;\n    transition: all 0.3s ease-out;\n    text-transform: none;\n    cursor: pointer;\n    background: ', ';\n    color: ', ';\n    font-weight: bold;\n    display: inline-block;\n    font-size: 14px;\n    margin: 0 0 0 auto;\n    font-family: ', ',\n        sans-serif;\n    padding: 15px 31px 14px;\n    box-shadow: 4px 4px 8px 0 rgba(34, 60, 80, 0.2);\n']),
    _templateObject11$2 = taggedTemplateLiteral(['\n    padding: 45px 25px 115px;\n    flex: 1;\n    color: ', ';\n    overflow-y: scroll;\n    //hide scrollbar\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    &::-webkit-scrollbar {\n        width: 0;\n        height: 0;\n    }\n\n    @media screen and (min-width: 320px) and (max-width: 900px) and (orientation: landscape) {\n        margin-bottom: 70px;\n    }\n'], ['\n    padding: 45px 25px 115px;\n    flex: 1;\n    color: ', ';\n    overflow-y: scroll;\n    //hide scrollbar\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    &::-webkit-scrollbar {\n        width: 0;\n        height: 0;\n    }\n\n    @media screen and (min-width: 320px) and (max-width: 900px) and (orientation: landscape) {\n        margin-bottom: 70px;\n    }\n']),
    _templateObject12$2 = taggedTemplateLiteral(['\n    > h3 {\n        font-size: 24px;\n        padding: 0 0 8px;\n        margin: 0;\n    }\n'], ['\n    > h3 {\n        font-size: 24px;\n        padding: 0 0 8px;\n        margin: 0;\n    }\n']),
    _templateObject13$2 = taggedTemplateLiteral(['\n    position: absolute;\n    font-size: 14px;\n    color: ', ';\n    top: -27px;\n    left: 8px;\n    font-family: ', ',\n        sans-serif;\n'], ['\n    position: absolute;\n    font-size: 14px;\n    color: ', ';\n    top: -27px;\n    left: 8px;\n    font-family: ', ',\n        sans-serif;\n']),
    _templateObject14$2 = taggedTemplateLiteral(['\n    position: relative;\n'], ['\n    position: relative;\n']),
    _templateObject15$2 = taggedTemplateLiteral(['\n    position: relative;\n    margin: 0 auto;\n    &:first-child {\n        margin-bottom: 50px;\n    }\n'], ['\n    position: relative;\n    margin: 0 auto;\n    &:first-child {\n        margin-bottom: 50px;\n    }\n']),
    _templateObject16$1 = taggedTemplateLiteral(['\n    padding: 17px 45px 17px 16px;\n    border-radius: 5px;\n    width: 100%;\n    box-sizing: border-box;\n    background: ', ';\n    position: relative;\n    color: ', ';\n    opacity: 1;\n    font-size: 18px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    -webkit-text-security: none;\n    font-family: ', ',\n        sans-serif;\n    display: flex;\n    height: 57px;\n    margin: 0 auto;\n    outline: none;\n\n    input {\n        top: 0;\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        left: 0;\n        font-family: ', ',\n            sans-serif;\n        &:-webkit-autofill,\n        &:-webkit-autofill:hover,\n        &:-webkit-autofill:focus,\n        &:-webkit-autofill:active {\n            -webkit-box-shadow: 0 0 0 60px #eceff6 inset !important;\n            background-color: #eceff6 !important;\n            background-clip: content-box !important;\n        }\n    }\n'], ['\n    padding: 17px 45px 17px 16px;\n    border-radius: 5px;\n    width: 100%;\n    box-sizing: border-box;\n    background: ', ';\n    position: relative;\n    color: ', ';\n    opacity: 1;\n    font-size: 18px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    -webkit-text-security: none;\n    font-family: ', ',\n        sans-serif;\n    display: flex;\n    height: 57px;\n    margin: 0 auto;\n    outline: none;\n\n    input {\n        top: 0;\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        left: 0;\n        font-family: ', ',\n            sans-serif;\n        &:-webkit-autofill,\n        &:-webkit-autofill:hover,\n        &:-webkit-autofill:focus,\n        &:-webkit-autofill:active {\n            -webkit-box-shadow: 0 0 0 60px #eceff6 inset !important;\n            background-color: #eceff6 !important;\n            background-clip: content-box !important;\n        }\n    }\n']),
    _templateObject17$1 = taggedTemplateLiteral(['\n    margin: 0;\n    position: absolute;\n    top: -27px;\n    right: 8px;\n    font-size: 14px;\n    font-family: ', ',\n        sans-serif;\n    color: ', ';\n    text-decoration: underline;\n    cursor: pointer;\n'], ['\n    margin: 0;\n    position: absolute;\n    top: -27px;\n    right: 8px;\n    font-size: 14px;\n    font-family: ', ',\n        sans-serif;\n    color: ', ';\n    text-decoration: underline;\n    cursor: pointer;\n']),
    _templateObject18$1 = taggedTemplateLiteral(['\n    position: relative;\n    height: 54px;\n    width: 100%;\n    border-radius: 5px;\n    outline: none;\n    border: none;\n    font-size: 16px;\n    font-weight: bold;\n    font-family: \'Roboto Condensed\', sans-serif;\n    transition: all 0.3s ease;\n    background: ', ';\n    border: ', ';\n    cursor: pointer;\n\n    ', ' &:disabled {\n        background: ', ';\n    }\n\n    &:not(:disabled) {\n        p {\n            color: ', ';\n        }\n    }\n'], ['\n    position: relative;\n    height: 54px;\n    width: 100%;\n    border-radius: 5px;\n    outline: none;\n    border: none;\n    font-size: 16px;\n    font-weight: bold;\n    font-family: \'Roboto Condensed\', sans-serif;\n    transition: all 0.3s ease;\n    background: ', ';\n    border: ', ';\n    cursor: pointer;\n\n    ', ' &:disabled {\n        background: ', ';\n    }\n\n    &:not(:disabled) {\n        p {\n            color: ', ';\n        }\n    }\n']),
    _templateObject19$1 = taggedTemplateLiteral(['\n            padding: 0;\n            flex: 0;\n            border: none;\n            margin: 0 !important;\n        '], ['\n            padding: 0;\n            flex: 0;\n            border: none;\n            margin: 0 !important;\n        ']),
    _templateObject20$1 = taggedTemplateLiteral(['\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    margin-top: 15px;\n    flex-direction: column;\n    gap: 10px;\n'], ['\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    margin-top: 15px;\n    flex-direction: column;\n    gap: 10px;\n']),
    _templateObject21$1 = taggedTemplateLiteral(['\n    animation: ', ';\n    animation-direction: alternate;\n    text-shadow: 0 0 1px white;\n    margin: 0;\n    font-family: ', ',\n        sans-serif;\n    font-weight: ', ';\n'], ['\n    animation: ', ';\n    animation-direction: alternate;\n    text-shadow: 0 0 1px white;\n    margin: 0;\n    font-family: ', ',\n        sans-serif;\n    font-weight: ', ';\n']),
    _templateObject22 = taggedTemplateLiteral(['\n    font-size: 12px;\n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n    width: 100%;\n\n    p {\n        margin: 0;\n    }\n'], ['\n    font-size: 12px;\n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n    width: 100%;\n\n    p {\n        margin: 0;\n    }\n']),
    _templateObject23 = taggedTemplateLiteral(['\n    width: 100%;\n    position: absolute;\n    flex-direction: column;\n    bottom: 0;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    background: ', ';\n'], ['\n    width: 100%;\n    position: absolute;\n    flex-direction: column;\n    bottom: 0;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    background: ', ';\n']),
    _templateObject24 = taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    p + svg {\n        position: absolute;\n        right: 20px;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    p + svg {\n        position: absolute;\n        right: 20px;\n    }\n']),
    _templateObject25 = taggedTemplateLiteral(['\n    padding: 15px 0 25px;\n    width: calc(100% - 50px);\n'], ['\n    padding: 15px 0 25px;\n    width: calc(100% - 50px);\n']),
    _templateObject26 = taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    max-width: 100%;\n    border: 1px solid #0000001a;\n    background-color: #2163de;\n    gap: 10px;\n\n    p + svg {\n        position: absolute;\n        right: 20px;\n    }\n\n    ', '\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    max-width: 100%;\n    border: 1px solid #0000001a;\n    background-color: #2163de;\n    gap: 10px;\n\n    p + svg {\n        position: absolute;\n        right: 20px;\n    }\n\n    ', '\n    }\n']),
    _templateObject27 = taggedTemplateLiteral(['\n            padding: 0;\n            flex: 0;\n            border: none;\n        '], ['\n            padding: 0;\n            flex: 0;\n            border: none;\n        ']),
    _templateObject28 = taggedTemplateLiteral(['\n    height: 1px;\n    background-color: ', ';\n    flex: 1;\n'], ['\n    height: 1px;\n    background-color: ', ';\n    flex: 1;\n']);

var slideToTop = keyframes(_templateObject$g);
var slideToLeft = keyframes(_templateObject2$c);

var animationWindow = css(_templateObject3$9, function (_ref) {
    var close = _ref.close;
    return close ? 'reverse' : 'normal';
});

var Wrapper$5 = styled.div(_templateObject4$7, function (_ref2) {
    var zIndex = _ref2.zIndex;
    return zIndex || '10';
}, function (_ref3) {
    var bg = _ref3.bg;
    return bg || 'white';
}, slideToTop, animationWindow, slideToLeft, animationWindow, function (_ref4) {
    var bg = _ref4.bg;
    return bg || 'white';
}, function (_ref5) {
    var bg = _ref5.bg;
    return bg || 'white';
});
var ModalTopBar = styled.div(_templateObject5$6);

var StyledModalTopbar = styled(ModalTopBar)(_templateObject6$6, function (_ref6) {
    var color = _ref6.color;
    return color || '#e9eaee';
});
var MobileModalTopBar = styled(ModalTopBar)(_templateObject7$5);

var FlexContainer = styled.div(_templateObject8$5);
var CloseModalButton = styled.div(_templateObject9$4, function (_ref7) {
    var bgHover = _ref7.bgHover;
    return bgHover || '#eceff6';
});
var OpretBtn = styled.button(_templateObject10$3, function (_ref8) {
    var activeColor = _ref8.activeColor;
    return activeColor || '#fbd600';
}, function (_ref9) {
    var color = _ref9.color;
    return color || '#333333';
}, function (_ref10) {
    var condensed = _ref10.condensed;
    return condensed ? 'Roboto Condensed' : 'inherit';
});
var MiddleWrapper = styled.div(_templateObject11$2, function (_ref11) {
    var color = _ref11.color;
    return color || '#333';
});

var ForgotPassWrapper = styled(MiddleWrapper)(_templateObject12$2);

var FakePlaceholder = styled.span(_templateObject13$2, function (_ref12) {
    var color = _ref12.color;
    return color || '#575c69';
}, function (_ref13) {
    var condensed = _ref13.condensed;
    return condensed ? 'Roboto Condensed' : 'inherit';
});
var InputsWrapper = styled.div(_templateObject14$2);
var InputWrapper$1 = styled.div(_templateObject15$2);
var InputField = styled(ValidInput)(_templateObject16$1, function (_ref14) {
    var bgColor = _ref14.bgColor;
    return bgColor || '#eceff6';
}, function (_ref15) {
    var color = _ref15.color;
    return color || '#575c69';
}, function (_ref16) {
    var condensed = _ref16.condensed;
    return condensed ? 'Roboto Condensed' : 'inherit';
}, function (_ref17) {
    var condensed = _ref17.condensed;
    return condensed ? 'Roboto Condensed' : 'inherit';
});
var ForgetPassword = styled.p(_templateObject17$1, function (_ref18) {
    var condensed = _ref18.condensed;
    return condensed ? 'Roboto Condensed' : 'inherit';
}, function (_ref19) {
    var color = _ref19.color;
    return color || '#575c69';
});
var LoginButton = styled.button(_templateObject18$1, function (_ref20) {
    var activeColor = _ref20.activeColor;
    return activeColor || '#fbd600';
}, function (_ref21) {
    var borderColor = _ref21.borderColor;
    return borderColor ? '1px solid ' + borderColor : '1px solid transparent';
}, function (_ref22) {
    var hide = _ref22.hide;
    return hide && css(_templateObject19$1);
}, function (_ref23) {
    var disableColor = _ref23.disableColor;
    return disableColor || '#fff8cb';
}, function (_ref24) {
    var color = _ref24.color;
    return color || '#333333';
});
var LoginButtonWrapper = styled.div(_templateObject20$1);

var LoginLabel = styled.p(_templateObject21$1, function (props) {
    return props.loading ? props.loading + ' 1.2s infinite 0s ease-in-out' : '';
}, function (_ref25) {
    var condensed = _ref25.condensed;
    return condensed ? 'Roboto Condensed' : 'inherit';
}, function (_ref26) {
    var normal = _ref26.normal;
    return normal ? 'normal' : 'bold';
});

var TextWrapper$1 = styled.div(_templateObject22);

var ButtonsArea = styled(LoginButtonWrapper)(_templateObject23, function (_ref27) {
    var bg = _ref27.bg;
    return bg || '#fff';
});

var AcceptButton = styled(LoginButton)(_templateObject24);

var ButtonWrapper = styled.div(_templateObject25);

var MitIdButton = styled(LoginButton)(_templateObject26, function (_ref28) {
    var hide = _ref28.hide;
    return hide && css(_templateObject27);
});

var Divider$2 = styled.div(_templateObject28, function (_ref29) {
    var color = _ref29.color;
    return color || '#e9eaee';
});

var SERVERS = {
    'bet25.dk': 'prod',
    'bet25test.dk': 'test',
    'bet25dev.dk': 'dev',
    'bet25dev2.dk': 'dev2',
    'bet25dev3.dk': 'dev3',
    localhost: 'dev'
};

var API_PATHS = {
    prod: 'https://api.bet25.dk',
    test: 'https://api.bet25test.dk',
    dev: 'https://api.bet25dev.dk',
    dev2: 'https://api.bet25dev2.dk',
    dev3: 'https://api.bet25dev3.dk'
};

var getApiUrl = function getApiUrl() {
    var host = window.location.hostname;
    var env = SERVERS[host];
    return API_PATHS[env];
};

var jsonSerializer = function jsonSerializer(data) {
    return JSON.stringify(data);
};
var formSerializer = function formSerializer(data) {
    var p = Object.keys(data).map(function (key) {
        return key + '=' + decodeURIComponent(data[key].toString());
    });
    return p.join('&');
};

var dataSerializers = {
    'application/json': jsonSerializer,
    'application/x-www-form-urlencoded': formSerializer,
    'multipart/form-data': jsonSerializer
};

var makeRequest = function makeRequest(requestMethod, url) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var fetchParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var headerParams = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    var params = _extends({
        headers: _extends({
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Cache: 'no-cache'
        }, headerParams),
        credentials: 'include',
        method: requestMethod
    }, fetchParams);

    if (requestMethod === 'post') {
        params['body'] = dataSerializers[params.headers['Content-Type']](data);
    } else if (requestMethod === 'get' && data) {
        var p = Object.keys(data).map(function (key) {
            return key + '=' + decodeURIComponent(data[key]);
        });

        url = url + (p.length ? '?' : '') + p.join('&');
    }

    return fetch(url, params);
};

var LOGIN_TYPES = {
    MIT_ID: 'mitid'
};

function sha512(message) {
    var msgBuffer = new TextEncoder().encode(message);

    return crypto.subtle.digest('SHA-512', msgBuffer).then(function (hashBuffer) {
        var hashArray = Array.from(new Uint8Array(hashBuffer));
        var hashHex = hashArray.map(function (b) {
            return b.toString(16).padStart(2, '0');
        }).join('');
        return hashHex;
    });
}

var login = function login(type) {
    var site = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var loading = arguments[2];
    var setLoading = arguments[3];
    var oldAPI = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var operation = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
    var onError = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function () {};

    if (!loading[type]) {
        setLoading(_extends({}, loading, defineProperty({}, type, true)));
        makeRequest('get', oldAPI ? '/rest/punter/mitidStart/' + type : getApiUrl() + '/punter/mitidStart/' + type, _extends({}, site && { site: site }, operation && { operation: operation })).then(function (res) {
            return res.json();
        }).then(function (result) {
            if (result.success) {
                window.location.href = result.data;
            } else {
                result.errorMessage ? onError(result.errorMessage) : onError('Some error appear');
            }
        }).catch(function (e) {
            setLoading(_extends({}, loading, defineProperty({}, type, true)));
            console.error('MitID failed: ', e);
        });
    }
};

var restorePassword = function restorePassword() {
    var loading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var setLoading = arguments[2];
    var oldAPI = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var newPassword = arguments[4];
    var confirmPassword = arguments[5];
    var successHandler = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function () {};
    var onError = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : function () {};

    if (!loading) {
        setLoading(false);
        makeRequest('post', oldAPI ? '/rest/punter/setPasswordSecure' : getApiUrl() + '/punter/setPasswordSecure', {
            edit: newPassword,
            confirm: confirmPassword
        }).then(function (res) {
            return res.json();
        }).then(function (result) {
            if (result.success) {
                successHandler();
            } else {
                console.log('result', result);
                onError(result);
            }
        }).catch(function (e) {
            setLoading(false);
            console.error('Change password is failed: ', e);
        });
    }
};

var getAccountInformation = function getAccountInformation() {
    return makeRequest('get', getApiUrl() + '/punter/getAccountInformation').then(function (res) {
        return res.json();
    }).then(function (res) {
        if (!res.success) {
            return Promise.reject(res.errorMessage);
        }
        return res.data;
    });
};

var setAccountInformation = function setAccountInformation(_ref) {
    var email = _ref.email,
        phoneNr = _ref.phoneNr;

    return makeRequest('post', getApiUrl() + '/punter/setAccountInformation', { email: email, phoneNr: phoneNr }).then(function (res) {
        return res.json();
    }).then(function (res) {
        if (!res.success) {
            return Promise.reject(res.errorMessage);
        }
        return res.data;
    });
};

var checkExistingEmail = function checkExistingEmail(_ref2) {
    var email = _ref2.email,
        salt = _ref2.salt;

    return sha512(email + salt).then(function (hash) {
        return makeRequest('post', getApiUrl() + '/punter/checkEmail', { email: email, hash: hash });
    }).then(function (res) {
        return res.json();
    });
};

var defaultTheme = {
    name: 'default',
    condensed: true,
    bold: true,
    colors: {
        active: '#0bc628',
        bg: '#ffffff',
        basic: '#333',
        secondary: '#333333',
        link: '#575c69',
        borderColor: '#e9eaee',
        activeBtnColor: '#fbd600',
        disabledBtnColor: '#fff8cb',
        activeLoginColor: '#fbd600',
        disabledLoginColor: '#fff8cb',
        divider: '#e9eaee',
        bgDarker: '#eceff6',
        primary: '#575c69',
        primaryAction: '#9198aa'
    }
};

var dark = {
    name: 'dark',
    condensed: false,
    bold: false,
    colors: {
        active: '#97D800',
        bg: '#121212',
        basic: '#fff',
        secondary: '#BEBEBE',
        link: '#F77705',
        borderColor: '#262626',
        activeBtnColor: '#F77705',
        disabledBtnColor: '#522200',
        activeLoginColor: '#97D800',
        disabledLoginColor: '#2C4000',
        divider: '#818181',
        bgDarker: '#262626',
        primary: '#BEBEBE',
        primaryAction: '#818181'
    }
};

var validators$1 = {};

var UsernameLogin = function UsernameLogin(_ref) {
    var currentTheme = _ref.currentTheme,
        _ref$loginHandler = _ref.loginHandler,
        loginHandler = _ref$loginHandler === undefined ? function () {} : _ref$loginHandler,
        _ref$forgotPassHandle = _ref.forgotPassHandler,
        forgotPassHandler = _ref$forgotPassHandle === undefined ? function () {} : _ref$forgotPassHandle,
        _ref$forgotPassword = _ref.forgotPassword,
        forgotPassword = _ref$forgotPassword === undefined ? function () {} : _ref$forgotPassword,
        _ref$showResetPasswor = _ref.showResetPassword,
        showResetPassword = _ref$showResetPasswor === undefined ? false : _ref$showResetPasswor;

    var _useState = useState(''),
        _useState2 = slicedToArray(_useState, 2),
        userName = _useState2[0],
        setUsername = _useState2[1];

    var _useState3 = useState(''),
        _useState4 = slicedToArray(_useState3, 2),
        password = _useState4[0],
        setPassword = _useState4[1];

    var _useState5 = useState(false),
        _useState6 = slicedToArray(_useState5, 2),
        loading = _useState6[0],
        setLoading = _useState6[1];

    var setValidationHandler = function setValidationHandler(fieldName, validator) {
        validators$1[fieldName] = validator;
    };
    var isFormValid = function isFormValid() {
        return userName && password;
    };
    var keyPressHandler = function keyPressHandler(e) {
        var key = e.charCode || e.keyCode || 0;

        if (key === 13) {
            e.preventDefault();
            loginAction();
        }
    };

    var loginAction = function loginAction() {
        var isValidUsername = validators$1.userName();
        var isValidPassword = validators$1.password();

        if (isValidUsername && isValidPassword) {
            loginHandler(userName, password, function (state) {
                setLoading(state);
            }, function () {
                //success action
            }, function (e) {
                //error action
                //for backward compatibility, should be removed in the next versions
                if (e && e.data === true) {
                    return e.errorMessage;
                } else {
                    console.error('Error during login: ' + e);
                }
            });
        } else {
            loginHandler('', '');
        }
    };

    var forgotPassAction = function forgotPassAction() {
        forgotPassHandler();
    };

    var renderInputs = function renderInputs() {
        return React.createElement(
            InputsWrapper,
            { onKeyDown: keyPressHandler },
            React.createElement(
                InputWrapper$1,
                null,
                React.createElement(
                    FakePlaceholder,
                    {
                        condensed: currentTheme.condensed,
                        color: currentTheme.colors.basic
                    },
                    'Brugernavn eller email'
                ),
                React.createElement(InputField, {
                    redBorder: true,
                    value: userName,
                    onChange: function onChange(value) {
                        return setUsername(value);
                    },
                    validate: { required: true },
                    getValidator: function getValidator(validationHandler) {
                        return setValidationHandler('userName', validationHandler);
                    },
                    showErrorUnderInput: true,
                    bgColor: currentTheme.colors.bgDarker,
                    color: currentTheme.colors.primary,
                    condensed: currentTheme.condensed,
                    autoCapitalize: 'off'
                })
            ),
            React.createElement(
                InputWrapper$1,
                null,
                React.createElement(
                    FakePlaceholder,
                    {
                        condensed: currentTheme.condensed,
                        color: currentTheme.colors.basic
                    },
                    'Kodeord'
                ),
                !showResetPassword && React.createElement(
                    ForgetPassword,
                    {
                        onClick: forgotPassword,
                        color: currentTheme.colors.link,
                        condensed: currentTheme.condensed
                    },
                    'Glemt dit kodeord?'
                ),
                React.createElement(InputField, {
                    redBorder: true,
                    type: 'password',
                    value: password,
                    onChange: function onChange(value) {
                        return setPassword(value);
                    },
                    validate: { required: true },
                    getValidator: function getValidator(validationHandler) {
                        return setValidationHandler('password', validationHandler);
                    },
                    showErrorUnderInput: true,
                    bgColor: currentTheme.colors.bgDarker,
                    color: currentTheme.colors.primary,
                    condensed: currentTheme.condensed,
                    autoCapitalize: 'off'
                })
            )
        );
    };

    return React.createElement(
        Fragment,
        null,
        renderInputs(),
        React.createElement(
            LoginButtonWrapper,
            null,
            React.createElement(
                LoginButton,
                {
                    onClick: loginAction,
                    disabled: !isFormValid(),
                    activeColor: currentTheme.colors.activeLoginColor,
                    disableColor: currentTheme.colors.disabledLoginColor,
                    color: currentTheme.colors.basic
                },
                loading ? React.createElement(Spinner$1, { color: '#9198AA', size: 'md' }) : React.createElement(
                    LoginLabel,
                    {
                        condensed: currentTheme.condensed,
                        normal: !currentTheme.bold
                    },
                    'Log ind'
                )
            ),
            showResetPassword ? React.createElement(
                LoginButton,
                {
                    onClick: forgotPassAction,
                    activeColor: currentTheme.colors.bg,
                    disableColor: currentTheme.colors.disabledLoginColor,
                    color: currentTheme.colors.basic,
                    borderColor: currentTheme.colors.borderColor
                },
                React.createElement(
                    LoginLabel,
                    {
                        condensed: currentTheme.condensed,
                        normal: !currentTheme.bold
                    },
                    'Hj\xE6lp til at logge ind?'
                )
            ) : null
        )
    );
};

UsernameLogin.propTypes = {
    currentTheme: PropTypes.object,
    forgotPassword: PropTypes.func,
    loginHandler: PropTypes.func
};

var _templateObject$h = taggedTemplateLiteral(['\n    0% { transform: translateX(100%); }\n    100% { transform: translateX(0%); }\n'], ['\n    0% { transform: translateX(100%); }\n    100% { transform: translateX(0%); }\n']),
    _templateObject2$d = taggedTemplateLiteral(['\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    background-color: ', ';\n    animation: ', ' 300ms;\n    animation-timing-function: cubic-bezier(0.1, -0.6, 0.2, 0);\n    animation-fill-mode: forwards;\n    animation-direction: ', ';\n    @media screen and (min-width: 992px) {\n        width: 400px;\n    }\n'], ['\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    background-color: ', ';\n    animation: ', ' 300ms;\n    animation-timing-function: cubic-bezier(0.1, -0.6, 0.2, 0);\n    animation-fill-mode: forwards;\n    animation-direction: ', ';\n    @media screen and (min-width: 992px) {\n        width: 400px;\n    }\n']),
    _templateObject3$a = taggedTemplateLiteral(['\n    padding: 25px;\n    border-bottom: 2px solid ', ';\n    margin-bottom: 25px;\n'], ['\n    padding: 25px;\n    border-bottom: 2px solid ', ';\n    margin-bottom: 25px;\n']),
    _templateObject4$8 = taggedTemplateLiteral(['\n    position: absolute;\n    right: 15px;\n    cursor: pointer;\n    display: flex;\n    align-content: center;\n    background-color: transparent;\n    justify-content: space-around;\n    align-items: center;\n    transition: all 0.3s ease-in-out;\n    box-shadow: none;\n    &:hover {\n        background-color: #eceff6;\n    }\n'], ['\n    position: absolute;\n    right: 15px;\n    cursor: pointer;\n    display: flex;\n    align-content: center;\n    background-color: transparent;\n    justify-content: space-around;\n    align-items: center;\n    transition: all 0.3s ease-in-out;\n    box-shadow: none;\n    &:hover {\n        background-color: #eceff6;\n    }\n']),
    _templateObject5$7 = taggedTemplateLiteral(['\n    color: ', ';\n    font-size: 18px;\n    font-weight: 900;\n    font-family: ', ',\n        sans-serif;\n    line-height: normal;\n'], ['\n    color: ', ';\n    font-size: 18px;\n    font-weight: 900;\n    font-family: ', ',\n        sans-serif;\n    line-height: normal;\n']),
    _templateObject6$7 = taggedTemplateLiteral(['\n    padding: 0 15px;\n'], ['\n    padding: 0 15px;\n']),
    _templateObject7$6 = taggedTemplateLiteral(['\n    width: 100%;\n    transition: all 0.3s ease-out;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    margin-top: ', ';\n\n    background: ', ';\n    border: ', ';\n    ', ' p + svg {\n        position: absolute;\n        right: 0;\n    }\n    &:hover {\n        background: ', ';\n    }\n\n    &:not(:disabled) {\n        p {\n            color: ', ';\n        }\n    }\n'], ['\n    width: 100%;\n    transition: all 0.3s ease-out;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    margin-top: ', ';\n\n    background: ', ';\n    border: ', ';\n    ', ' p + svg {\n        position: absolute;\n        right: 0;\n    }\n    &:hover {\n        background: ', ';\n    }\n\n    &:not(:disabled) {\n        p {\n            color: ', ';\n        }\n    }\n']),
    _templateObject8$6 = taggedTemplateLiteral(['\n            opacity: 0;\n            height: 0;\n            border: 0;\n        '], ['\n            opacity: 0;\n            height: 0;\n            border: 0;\n        ']),
    _templateObject9$5 = taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease-in-out;\n\n    svg {\n        width: 17%;\n        margin-right: 10px;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease-in-out;\n\n    svg {\n        width: 17%;\n        margin-right: 10px;\n    }\n']),
    _templateObject10$4 = taggedTemplateLiteral(['\n    margin-top: 50px;\n'], ['\n    margin-top: 50px;\n']);

var slideToLeft$1 = keyframes(_templateObject$h);
var Wrapper$6 = styled.div(_templateObject2$d, function (_ref) {
    var backgroundColor = _ref.backgroundColor;
    return backgroundColor ? backgroundColor : 'white';
}, slideToLeft$1, function (_ref2) {
    var close = _ref2.close;
    return close ? 'reverse' : 'normal';
});
var StyledModalTopbar$1 = styled(ModalTopBar)(_templateObject3$a, function (_ref3) {
    var color = _ref3.color;
    return color || '#e9eaee';
});
var CloseButton = styled(CloseModalButton)(_templateObject4$8);
var Title = styled.span(_templateObject5$7, function (_ref4) {
    var color = _ref4.color;
    return color || '#333333';
}, function (_ref5) {
    var condensed = _ref5.condensed;
    return condensed ? 'Roboto Condensed' : 'inherit';
});
var MethodWrapper = styled.div(_templateObject6$7);
var StyledLoginButton = styled(LoginButton)(_templateObject7$6, function (_ref6) {
    var mitId = _ref6.mitId;
    return mitId ? '25px' : '15px';
}, function (_ref7) {
    var mitId = _ref7.mitId;
    return mitId ? '#1a49d5' : '#e5ebf5';
}, function (_ref8) {
    var mitId = _ref8.mitId;
    return mitId ? '1px solid #1a49d5' : '1px solid #caced6';
}, function (_ref9) {
    var hide = _ref9.hide;
    return hide && css(_templateObject8$6);
}, function (_ref10) {
    var mitId = _ref10.mitId;
    return mitId ? '#1841ba' : '#caced6';
}, function (_ref11) {
    var mitId = _ref11.mitId;
    return mitId ? '#fff' : '#333';
});

var ButtonContent = styled.div(_templateObject9$5);

var LoginWrapper$1 = styled.div(_templateObject10$4);

var _ref$i =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.166 19.297l7.085-7.085A7.156 7.156 0 0026.132 2.097l-7.086 7.084-6.83-6.83a7.156 7.156 0 10-10.119 10.12l6.83 6.826-6.83 6.835a7.156 7.156 0 0010.12 10.12l6.83-6.83 7.085 7.084a7.156 7.156 0 1010.12-10.119z",
  fill: "#333"
});

var cross = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2238.347%22%20height%3D%2238.603%22%20viewBox%3D%220%200%2038.347%2038.603%22%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill%3A%23333%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20transform%3D%22translate%280%200%29%22%3E%3Cpath%20class%3D%22a%22%20d%3D%22M29.169%2C19.3l7.085-7.085A7.156%2C7.156%2C0%2C0%2C0%2C26.135%2C2.1L19.049%2C9.184l-6.83-6.83A7.156%2C7.156%2C0%2C1%2C0%2C2.1%2C12.474L8.93%2C19.3%2C2.1%2C26.135a7.156%2C7.156%2C0%2C0%2C0%2C10.12%2C10.12l6.83-6.83%2C7.085%2C7.084a7.156%2C7.156%2C0%2C1%2C0%2C10.12-10.119Z%22%20transform%3D%22translate%28-0.003%20-0.003%29%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E';

var TopBarLogin = function TopBarLogin(_ref) {
    var title = _ref.title,
        _ref$currentTheme = _ref.currentTheme,
        currentTheme = _ref$currentTheme === undefined ? {} : _ref$currentTheme,
        _ref$showCloseBtn = _ref.showCloseBtn,
        showCloseBtn = _ref$showCloseBtn === undefined ? true : _ref$showCloseBtn,
        _ref$closeAction = _ref.closeAction,
        closeAction = _ref$closeAction === undefined ? function () {} : _ref$closeAction;

    return React.createElement(
        StyledModalTopbar,
        { color: currentTheme.colors.borderColor },
        React.createElement(
            Title,
            {
                color: currentTheme.colors.basic,
                condensed: currentTheme.condensed
            },
            title
        ),
        showCloseBtn && React.createElement(
            CloseButton,
            { onClick: closeAction },
            React.createElement(Icon, { size: 'sm', src: cross, color: '#9198AA' })
        )
    );
};

TopBarLogin.propTypes = {
    title: PropTypes.string.isRequired,
    currentTheme: PropTypes.string,
    showCloseBtn: PropTypes.bool,
    closeAction: PropTypes.func
};

var _ref$j =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "a"
}, React.createElement("path", {
  "data-name": "Rectangle 3302",
  fill: "#fff",
  d: "M0 0h52.113v14H0z"
})));

var _ref2$d =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Group 3273",
  clipPath: "url(#a)",
  fill: "#fff"
}, React.createElement("path", {
  "data-name": "Path 1063",
  d: "M41.915.212h2.273c5.568 0 7.926 3.021 7.926 6.8s-2.358 6.8-7.926 6.8h-2.273z"
}), React.createElement("path", {
  "data-name": "Path 1064",
  d: "M40.216 13.81c-.339-4.193-2.855-5.949-5.949-5.949s-5.61 1.756-5.949 5.949z"
}), React.createElement("path", {
  "data-name": "Path 1065",
  d: "M37.56 3.293a3.293 3.293 0 11-3.293-3.294 3.293 3.293 0 013.293 3.293"
}), React.createElement("path", {
  "data-name": "Path 1066",
  d: "M10.457.704L6.509 6.893 2.539.704H0v13.1h2.668V5.357l3.777 5.634h.085l3.735-5.634v8.451h2.689V.704z"
}), React.createElement("path", {
  "data-name": "Path 1067",
  d: "M20.873 6.402h-1.449V4.268h1.451V1.686H23.5v2.582h2.091v2.134H23.5v4.183a.971.971 0 001.089 1.089 2.269 2.269 0 001.152-.32v2.348a4.013 4.013 0 01-1.707.3c-1.942 0-3.159-.96-3.159-3.073z"
}), React.createElement("path", {
  "data-name": "Path 1068",
  d: "M18.238 1.568a1.569 1.569 0 11-1.569-1.57 1.569 1.569 0 011.569 1.568"
}), React.createElement("path", {
  "data-name": "Rectangle 3301",
  d: "M15.346 4.268h2.646v9.54h-2.646z"
}));

var mitIdLogo = 'data:image/svg+xml,%3Csvg%20id%3D%22Group_3274%22%20data-name%3D%22Group%203274%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2252.113%22%20height%3D%2214%22%20viewBox%3D%220%200%2052.113%2014%22%3E%20%20%3Cdefs%3E%20%20%20%20%3CclipPath%20id%3D%22clip-path%22%3E%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle_3302%22%20data-name%3D%22Rectangle%203302%22%20width%3D%2252.113%22%20height%3D%2214%22%20fill%3D%22%23fff%22%2F%3E%20%20%20%20%3C%2FclipPath%3E%20%20%3C%2Fdefs%3E%20%20%3Cg%20id%3D%22Group_3273%22%20data-name%3D%22Group%203273%22%20clip-path%3D%22url%28%23clip-path%29%22%3E%20%20%20%20%3Cpath%20id%3D%22Path_1063%22%20data-name%3D%22Path%201063%22%20d%3D%22M587.65%2C2.978h2.273c5.568%2C0%2C7.926%2C3.021%2C7.926%2C6.8s-2.358%2C6.8-7.926%2C6.8H587.65Z%22%20transform%3D%22translate%28-545.735%20-2.766%29%22%20fill%3D%22%23fff%22%2F%3E%20%20%20%20%3Cpath%20id%3D%22Path_1064%22%20data-name%3D%22Path%201064%22%20d%3D%22M408.9%2C116.166c-.339-4.193-2.855-5.949-5.949-5.949s-5.61%2C1.756-5.949%2C5.949Z%22%20transform%3D%22translate%28-368.684%20-102.356%29%22%20fill%3D%22%23fff%22%2F%3E%20%20%20%20%3Cpath%20id%3D%22Path_1065%22%20data-name%3D%22Path%201065%22%20d%3D%22M440.825%2C3.294A3.293%2C3.293%2C0%2C1%2C1%2C437.532%2C0a3.293%2C3.293%2C0%2C0%2C1%2C3.293%2C3.293%22%20transform%3D%22translate%28-403.265%20-0.001%29%22%20fill%3D%22%23fff%22%2F%3E%20%20%20%20%3Cpath%20id%3D%22Path_1066%22%20data-name%3D%22Path%201066%22%20d%3D%22M10.457%2C9.875%2C6.509%2C16.064%2C2.539%2C9.875H0v13.1H2.668V14.528l3.777%2C5.634H6.53l3.735-5.634v8.451h2.689V9.875Z%22%20transform%3D%22translate%280%20-9.171%29%22%20fill%3D%22%23fff%22%2F%3E%20%20%20%20%3Cpath%20id%3D%22Path_1067%22%20data-name%3D%22Path%201067%22%20d%3D%22M273.749%2C28.356H272.3V26.222h1.451V23.64h2.625v2.582h2.091v2.134h-2.091v4.183a.971.971%2C0%2C0%2C0%2C1.089%2C1.089%2C2.269%2C2.269%2C0%2C0%2C0%2C1.152-.32v2.348a4.013%2C4.013%2C0%2C0%2C1-1.707.3c-1.942%2C0-3.159-.96-3.159-3.073Z%22%20transform%3D%22translate%28-252.876%20-21.954%29%22%20fill%3D%22%23fff%22%2F%3E%20%20%20%20%3Cpath%20id%3D%22Path_1068%22%20data-name%3D%22Path%201068%22%20d%3D%22M214.841%2C1.57A1.569%2C1.569%2C0%2C1%2C1%2C213.272%2C0a1.569%2C1.569%2C0%2C0%2C1%2C1.569%2C1.568%22%20transform%3D%22translate%28-196.603%20-0.002%29%22%20fill%3D%22%23fff%22%2F%3E%20%20%20%20%3Crect%20id%3D%22Rectangle_3301%22%20data-name%3D%22Rectangle%203301%22%20width%3D%222.646%22%20height%3D%229.54%22%20transform%3D%22translate%2815.346%204.268%29%22%20fill%3D%22%23fff%22%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E';

var ButtonArea = function ButtonArea(_ref) {
    var _ref$title = _ref.title,
        title = _ref$title === undefined ? '' : _ref$title,
        _ref$currentTheme = _ref.currentTheme,
        currentTheme = _ref$currentTheme === undefined ? {} : _ref$currentTheme,
        _ref$btnLoading = _ref.btnLoading,
        btnLoading = _ref$btnLoading === undefined ? {} : _ref$btnLoading,
        _ref$buttonClickHandl = _ref.buttonClickHandler,
        buttonClickHandler = _ref$buttonClickHandl === undefined ? {} : _ref$buttonClickHandl;

    return React.createElement(
        ButtonsArea,
        { bg: currentTheme.colors.bg },
        React.createElement(
            TextWrapper$1,
            null,
            React.createElement(Divider$2, { color: currentTheme.colors.divider }),
            title && React.createElement(
                Text,
                {
                    padding: '0 20px',
                    color: currentTheme.colors.primaryAction || '#9198AA',
                    condensed: currentTheme.condensed
                },
                title
            ),
            React.createElement(Divider$2, { color: currentTheme.colors.divider })
        ),
        React.createElement(
            ButtonWrapper,
            null,
            React.createElement(
                MitIdButton,
                {
                    color: '#fff',
                    hide: true,
                    show: btnLoading[LOGIN_TYPES.MIT_ID],
                    onClick: function onClick() {
                        return buttonClickHandler(LOGIN_TYPES.MIT_ID);
                    }
                },
                React.createElement(Icon, {
                    height: '14px',
                    width: '54px',
                    src: mitIdLogo,
                    color: 'white'
                }),
                React.createElement(
                    Text,
                    {
                        color: 'white',
                        bold: currentTheme.bold,
                        condensed: currentTheme.condensed,
                        align: 'center'
                    },
                    'Log ind med MitID'
                ),
                btnLoading[LOGIN_TYPES.MIT_ID] && React.createElement(Spinner$1, { color: '#fff', size: 'md' })
            )
        )
    );
};

ButtonsArea.propTypes = {
    title: PropTypes.string,
    currentTheme: PropTypes.object,
    btnLoading: PropTypes.func,
    buttonClickHandler: PropTypes.func
};

var themesMap = {
    default: defaultTheme,
    dark: dark

    /**
     * @param isMitIdLogin {boolean} MitID flag active or not
     * @param closeAction {function} close button handler
     * @param loginHandler {function} Login button handler
     * @param forgotPassHandler {function} Forgot Password button handler
     * @param stayOnPrevPage {boolean} should we stay on same page after login
     * @param beforeLogin {function} before login handler function
     * @param theme {string} select theme
     * @param site {string} project name
     * @param oldAPI {boolean} old API path
     * @param showResetPassword {boolean} should we show Forgot Password button
     * */
};var Login = function Login(_ref) {
    var _ref$isMitIdLogin = _ref.isMitIdLogin,
        isMitIdLogin = _ref$isMitIdLogin === undefined ? false : _ref$isMitIdLogin,
        closeAction = _ref.closeAction,
        _ref$loginHandler = _ref.loginHandler,
        loginHandler = _ref$loginHandler === undefined ? function () {} : _ref$loginHandler,
        _ref$forgotPassHandle = _ref.forgotPassHandler,
        forgotPassHandler = _ref$forgotPassHandle === undefined ? function () {} : _ref$forgotPassHandle,
        _ref$stayOnPrevPage = _ref.stayOnPrevPage,
        stayOnPrevPage = _ref$stayOnPrevPage === undefined ? false : _ref$stayOnPrevPage,
        _ref$beforeLogin = _ref.beforeLogin,
        beforeLogin = _ref$beforeLogin === undefined ? function () {} : _ref$beforeLogin,
        _ref$theme = _ref.theme,
        theme = _ref$theme === undefined ? 'default' : _ref$theme,
        _ref$site = _ref.site,
        site = _ref$site === undefined ? '' : _ref$site,
        _ref$oldAPI = _ref.oldAPI,
        oldAPI = _ref$oldAPI === undefined ? false : _ref$oldAPI,
        _ref$showResetPasswor = _ref.showResetPassword,
        showResetPassword = _ref$showResetPasswor === undefined ? false : _ref$showResetPasswor;

    var _useState = useState(defineProperty({}, LOGIN_TYPES.MIT_ID, false)),
        _useState2 = slicedToArray(_useState, 2),
        mitIdLoading = _useState2[0],
        setMitIdLoading = _useState2[1];

    var _useState4 = useState(false),
        _useState5 = slicedToArray(_useState4, 2),
        close = _useState5[0],
        setClose = _useState5[1];

    var currentTheme = themesMap[theme];

    useEffect(function () {
        isMitIdLogin && alternateLogin(LOGIN_TYPES.MIT_ID);
    });

    var onClose = function onClose() {
        setClose(true);
        setTimeout(function () {
            closeAction();
        }, 200);
    };

    var alternateLogin = function alternateLogin(type) {
        beforeLogin(type);

        if (stayOnPrevPage) {
            localStorage.setItem('stay_on_prev_page', window.location.pathname);
        }

        login(type, site, mitIdLoading, function (value) {
            return setMitIdLoading(value);
        }, oldAPI, '');
    };

    var forgotPassword = function forgotPassword() {
        alternateLogin(LOGIN_TYPES.MIT_ID);
    };

    return React.createElement(
        Wrapper$5,
        {
            bg: currentTheme.colors.bg,
            close: close,
            key: 'close-animation-' + close
        },
        React.createElement(TopBarLogin, {
            title: 'Log ind',
            currentTheme: currentTheme,
            closeAction: onClose
        }),
        React.createElement(
            MiddleWrapper,
            null,
            React.createElement(UsernameLogin, {
                currentTheme: currentTheme,
                forgotPassword: forgotPassword,
                loginHandler: loginHandler,
                forgotPassHandler: forgotPassHandler,
                showResetPassword: showResetPassword
            })
        ),
        React.createElement(ButtonArea, {
            title: 'eller',
            currentTheme: currentTheme,
            btnLoading: mitIdLoading,
            buttonClickHandler: alternateLogin
        })
    );
};

Login.propTypes = {
    isMitIdLogin: PropTypes.bool,
    closeAction: PropTypes.func,
    loginHandler: PropTypes.func.isRequired,
    forgotPassHandler: PropTypes.func.isRequired,
    stayOnPrevPage: PropTypes.bool,
    theme: PropTypes.string,
    site: PropTypes.string.isRequired,
    oldAPI: PropTypes.bool,
    showResetPassword: PropTypes.bool
};

var ForgotPasswordText = {
    password: {
        title: 'Hjælp til at logge ind?',
        dontPanic: 'Ingen panik!',
        dontPanicDescription: 'Følg trinene nedenfor for at gendanne adgangen til din konto.',
        step1Title: 'Log ind med MitID.',
        step1Description: 'Brug dit MitID for sikkert at verificere din identitet.',
        step2Title: 'Vælg et nyt kodeord.',
        step2Description: 'Efter verifikation bliver du guidet til at vælge et nyt kodeord.'
    },
    pin: {
        title: 'Hjælp til at logge ind?',
        dontPanic: 'Ingen panik!',
        dontPanicDescription: 'Følg trinene nedenfor for at gendanne adgangen til din konto.',
        step1Title: 'Log ind med MitID.',
        step1Description: 'Brug dit MitID for sikkert at verificere din identitet.',
        step2Title: 'Vælg en ny PIN kode.',
        step2Description: 'Efter verifikation bliver du guidet til at vælge en ny PIN kode.'
    }
};

var _templateObject$i = taggedTemplateLiteral(['\n    width: 100%;\n    text-align: center;\n    margin-bottom: 30px;\n'], ['\n    width: 100%;\n    text-align: center;\n    margin-bottom: 30px;\n']),
    _templateObject2$e = taggedTemplateLiteral(['\n    counter-reset: li;\n    padding: 2.25rem 0 0.25rem 2.75rem;\n\n    li {\n        margin-bottom: 0.375rem;\n\n        h3 {\n            font-size: 24px;\n            color: ', ';\n            padding: 0;\n            margin: 0;\n        }\n\n        small {\n            font-size: 18px;\n            color: ', ';\n            display: block;\n            padding: 0.5rem 0 1.5rem;\n        }\n    }\n    > li {\n        position: relative;\n        counter-increment: li;\n        min-height: 2rem;\n        padding-top: 0.25rem;\n        list-style: none;\n        margin: 0;\n\n        &:before,\n        &:after {\n            position: absolute;\n            display: flex;\n        }\n\n        &:before {\n            content: counter(li);\n            left: -2.75rem;\n            top: 0;\n            height: calc(2rem - 1px);\n            width: calc(2rem - 1px);\n            align-items: center;\n            justify-content: center;\n            border-radius: 50%;\n            border: 1px solid #e6edfb;\n            color: ', ';\n            font-weight: bold;\n            font-size: 18px;\n        }\n\n        &:after {\n            content: \'\';\n            left: -1.75rem;\n            top: calc(2rem + 0.5rem);\n            height: calc(100% - 2rem - 1rem);\n            border-left: 1px solid #e6edfb;\n        }\n\n        &:last-child {\n            &:after {\n                display: none;\n            }\n        }\n    }\n'], ['\n    counter-reset: li;\n    padding: 2.25rem 0 0.25rem 2.75rem;\n\n    li {\n        margin-bottom: 0.375rem;\n\n        h3 {\n            font-size: 24px;\n            color: ', ';\n            padding: 0;\n            margin: 0;\n        }\n\n        small {\n            font-size: 18px;\n            color: ', ';\n            display: block;\n            padding: 0.5rem 0 1.5rem;\n        }\n    }\n    > li {\n        position: relative;\n        counter-increment: li;\n        min-height: 2rem;\n        padding-top: 0.25rem;\n        list-style: none;\n        margin: 0;\n\n        &:before,\n        &:after {\n            position: absolute;\n            display: flex;\n        }\n\n        &:before {\n            content: counter(li);\n            left: -2.75rem;\n            top: 0;\n            height: calc(2rem - 1px);\n            width: calc(2rem - 1px);\n            align-items: center;\n            justify-content: center;\n            border-radius: 50%;\n            border: 1px solid #e6edfb;\n            color: ', ';\n            font-weight: bold;\n            font-size: 18px;\n        }\n\n        &:after {\n            content: \'\';\n            left: -1.75rem;\n            top: calc(2rem + 0.5rem);\n            height: calc(100% - 2rem - 1rem);\n            border-left: 1px solid #e6edfb;\n        }\n\n        &:last-child {\n            &:after {\n                display: none;\n            }\n        }\n    }\n']);

var themesMap$1 = {
    default: defaultTheme,
    dark: dark
};

var IconWrapper = styled.div(_templateObject$i);
var StyledList = styled.ol(_templateObject2$e, function (_ref) {
    var primaryColor = _ref.primaryColor;
    return primaryColor || '#db1c1b';
}, function (_ref2) {
    var textColor = _ref2.textColor;
    return textColor || '#333';
}, function (_ref3) {
    var primaryColor = _ref3.primaryColor;
    return primaryColor || '#db1c1b';
});

/**
 * @param closeAction {function} close button handler
 * @param stayOnPrevPage {bool} should we stay on same page after login
 * @param beforeLogin {function} before login handler function
 // * @param loginHandler {function} Login button handler
 * @param theme {string} select theme
 * @param site {string} project name
 * @param oldAPI {boolean} old API path
 * */
var ForgotPassword = function ForgotPassword(_ref4) {
    var closeAction = _ref4.closeAction,
        _ref4$stayOnPrevPage = _ref4.stayOnPrevPage,
        stayOnPrevPage = _ref4$stayOnPrevPage === undefined ? false : _ref4$stayOnPrevPage,
        _ref4$beforeLogin = _ref4.beforeLogin,
        beforeLogin = _ref4$beforeLogin === undefined ? function () {} : _ref4$beforeLogin,
        _ref4$theme = _ref4.theme,
        theme = _ref4$theme === undefined ? 'default' : _ref4$theme,
        _ref4$site = _ref4.site,
        site = _ref4$site === undefined ? '' : _ref4$site,
        _ref4$oldAPI = _ref4.oldAPI,
        oldAPI = _ref4$oldAPI === undefined ? false : _ref4$oldAPI,
        _ref4$primaryColor = _ref4.primaryColor,
        primaryColor = _ref4$primaryColor === undefined ? '' : _ref4$primaryColor,
        _ref4$productIcon = _ref4.productIcon,
        productIcon = _ref4$productIcon === undefined ? '' : _ref4$productIcon,
        _ref4$isPinLogin = _ref4.isPinLogin,
        isPinLogin = _ref4$isPinLogin === undefined ? false : _ref4$isPinLogin;

    var _useState = useState(defineProperty({}, LOGIN_TYPES.MIT_ID, false)),
        _useState2 = slicedToArray(_useState, 2),
        mitIdLoading = _useState2[0],
        setMitIdLoading = _useState2[1];

    var _useState4 = useState(false),
        _useState5 = slicedToArray(_useState4, 2),
        close = _useState5[0],
        setClose = _useState5[1];

    var currentTheme = themesMap$1[theme];
    var typeOfText = isPinLogin ? 'pin' : 'password';

    var onClose = function onClose() {
        setClose(true);
        setTimeout(function () {
            closeAction();
        }, 200);
    };

    var alternateLogin = function alternateLogin(type) {
        beforeLogin(type);

        if (stayOnPrevPage) {
            localStorage.setItem('stay_on_prev_page', window.location.pathname);
        }
        login(type, site, mitIdLoading, function (value) {
            return setMitIdLoading(value);
        }, oldAPI, isPinLogin ? 'forgotpin' : 'forgotpassword');
    };

    return React.createElement(
        Wrapper$5,
        {
            bg: currentTheme.colors.bg,
            close: close,
            key: 'close-animation-' + close
        },
        React.createElement(TopBarLogin, {
            title: ForgotPasswordText[typeOfText].title,
            currentTheme: currentTheme,
            closeAction: onClose
        }),
        React.createElement(
            ForgotPassWrapper,
            {
                color: currentTheme.colors.basic,
                style: { paddingTop: '25px' }
            },
            productIcon && React.createElement(
                IconWrapper,
                null,
                React.createElement(Img, { src: productIcon, width: '154px', alt: '' })
            ),
            React.createElement(
                'h3',
                null,
                ForgotPasswordText[typeOfText].dontPanic
            ),
            React.createElement(
                Text,
                { size: 'lg', style: { margin: 0 } },
                ForgotPasswordText[typeOfText].dontPanicDescription
            ),
            React.createElement(
                StyledList,
                {
                    primaryColor: primaryColor,
                    textColor: currentTheme.colors.basic
                },
                React.createElement(
                    'li',
                    null,
                    React.createElement(
                        'h3',
                        null,
                        ForgotPasswordText[typeOfText].step1Title
                    ),
                    React.createElement(
                        'small',
                        null,
                        ForgotPasswordText[typeOfText].step1Description
                    )
                ),
                React.createElement(
                    'li',
                    null,
                    React.createElement(
                        'h3',
                        null,
                        ForgotPasswordText[typeOfText].step2Title
                    ),
                    React.createElement(
                        'small',
                        null,
                        ForgotPasswordText[typeOfText].step2Description
                    )
                )
            )
        ),
        React.createElement(ButtonArea, {
            currentTheme: currentTheme,
            btnLoading: mitIdLoading,
            buttonClickHandler: alternateLogin
        })
    );
};

ForgotPassword.propTypes = {
    isMitIdLogin: PropTypes.bool,
    closeAction: PropTypes.func,
    // loginHandler: PropTypes.func.isRequired,
    stayOnPrevPage: PropTypes.bool,
    theme: PropTypes.string,
    site: PropTypes.string.isRequired,
    oldAPI: PropTypes.bool
};

/**
 * react-number-format - 4.9.4
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2022 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */

//     

                                                               

// basic noop function
function noop() {}
function returnTrue() {
  return true;
}

function charIsNumber(char         ) {
  return !!(char || '').match(/\d/);
}

function isNil(val     ) {
  return val === null || val === undefined;
}

function escapeRegExp(str        ) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}

function getThousandsGroupRegex(thousandsGroupStyle        ) {
  switch (thousandsGroupStyle) {
    case 'lakh':
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case 'wan':
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case 'thousand':
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}

function applyThousandSeparator(
  str        ,
  thousandSeparator        ,
  thousandsGroupStyle        
) {
  var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
  var index = str.search(/[1-9]/);
  index = index === -1 ? str.length : index;
  return (
    str.substring(0, index) +
    str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator)
  );
}

//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function splitDecimal(numStr        , allowNegative) {
  if ( allowNegative === void 0 ) allowNegative          = true;

  var hasNagation = numStr[0] === '-';
  var addNegation = hasNagation && allowNegative;
  numStr = numStr.replace('-', '');

  var parts = numStr.split('.');
  var beforeDecimal = parts[0];
  var afterDecimal = parts[1] || '';

  return {
    beforeDecimal: beforeDecimal,
    afterDecimal: afterDecimal,
    hasNagation: hasNagation,
    addNegation: addNegation,
  };
}

function fixLeadingZero(numStr         ) {
  if (!numStr) { return numStr; }
  var isNegative = numStr[0] === '-';
  if (isNegative) { numStr = numStr.substring(1, numStr.length); }
  var parts = numStr.split('.');
  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
  var afterDecimal = parts[1] || '';

  return ("" + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? ("." + afterDecimal) : ''));
}

/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */
function limitToScale(numStr        , scale        , fixedDecimalScale         ) {
  var str = '';
  var filler = fixedDecimalScale ? '0' : '';
  for (var i = 0; i <= scale - 1; i++) {
    str += numStr[i] || filler;
  }
  return str;
}

function repeat(str, count) {
  return Array(count + 1).join(str);
}

function toNumericString(num) {
  num += ''; // typecast number to string

  // store the sign and remove it from the number.
  var sign = num[0] === '-' ? '-' : '';
  if (sign) { num = num.substring(1); }

  // split the number into cofficient and exponent
  var ref = num.split(/[eE]/g);
  var coefficient = ref[0];
  var exponent = ref[1];

  // covert exponent to number;
  exponent = Number(exponent);

  // if there is no exponent part or its 0, return the coffiecient with sign
  if (!exponent) { return sign + coefficient; }

  coefficient = coefficient.replace('.', '');

  /**
   * for scientific notation the current decimal index will be after first number (index 0)
   * So effective decimal index will always be 1 + exponent value
   */
  var decimalIndex = 1 + exponent;

  var coffiecientLn = coefficient.length;

  if (decimalIndex < 0) {
    // if decimal index is less then 0 add preceding 0s
    // add 1 as join will have
    coefficient = '0.' + repeat('0', Math.abs(decimalIndex)) + coefficient;
  } else if (decimalIndex >= coffiecientLn) {
    // if decimal index is less then 0 add leading 0s
    coefficient = coefficient + repeat('0', decimalIndex - coffiecientLn);
  } else {
    // else add decimal point at proper index
    coefficient =
      (coefficient.substring(0, decimalIndex) || '0') + '.' + coefficient.substring(decimalIndex);
  }

  return sign + coefficient;
}

/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */
function roundToPrecision(numStr        , scale        , fixedDecimalScale         ) {
  //if number is empty don't do anything return empty string
  if (['', '-'].indexOf(numStr) !== -1) { return numStr; }

  var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;
  var ref = splitDecimal(numStr);
  var beforeDecimal = ref.beforeDecimal;
  var afterDecimal = ref.afterDecimal;
  var hasNagation = ref.hasNagation;
  var floatValue = parseFloat(("0." + (afterDecimal || '0')));
  var floatValueStr =
    afterDecimal.length <= scale ? ("0." + afterDecimal) : floatValue.toFixed(scale);
  var roundedDecimalParts = floatValueStr.split('.');
  var intPart = beforeDecimal
    .split('')
    .reverse()
    .reduce(function (roundedStr, current, idx) {
      if (roundedStr.length > idx) {
        return (
          (Number(roundedStr[0]) + Number(current)).toString() +
          roundedStr.substring(1, roundedStr.length)
        );
      }
      return current + roundedStr;
    }, roundedDecimalParts[0]);

  var decimalPart = limitToScale(
    roundedDecimalParts[1] || '',
    Math.min(scale, afterDecimal.length),
    fixedDecimalScale
  );
  var negation = hasNagation ? '-' : '';
  var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
  return ("" + negation + intPart + decimalSeparator + decimalPart);
}

/** set the caret positon in an input field **/
function setCaretPosition(el                  , caretPos        ) {
  el.value = el.value;
  // ^ this is used to not only get 'focus', but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)
  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move('character', caretPos);
      range.select();
      return true;
    }
    // (el.selectionStart === 0 added for Firefox bug)
    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    }

    // fail city, fortunately this never happens (as far as I've tested) :)
    el.focus();
    return false;
  }
}

/**
  Given previous value and newValue it returns the index
  start - end to which values have changed.
  This function makes assumption about only consecutive
  characters are changed which is correct assumption for caret input.
*/
function findChangedIndex(prevValue        , newValue        ) {
  var i = 0,
    j = 0;
  var prevLength = prevValue.length;
  var newLength = newValue.length;
  while (prevValue[i] === newValue[i] && i < prevLength) { i++; }

  //check what has been changed from last
  while (
    prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] &&
    newLength - j > i &&
    prevLength - j > i
  ) {
    j++;
  }

  return { start: i, end: prevLength - j };
}

/*
  Returns a number whose value is limited to the given range
*/
function clamp(num        , min        , max        ) {
  return Math.min(Math.max(num, min), max);
}

function getCurrentCaretPosition(el                  ) {
  /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
  return Math.max(el.selectionStart, el.selectionEnd);
}

function addInputMode(format                                   ) {
  return (
    format ||
    (typeof navigator !== 'undefined' &&
      !(navigator.platform && /iPhone|iPod/.test(navigator.platform)))
  );
}

//     
function objectWithoutProperties$1 (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }

var defaultProps = {
  displayType: 'input',
  decimalSeparator: '.',
  thousandsGroupStyle: 'thousand',
  fixedDecimalScale: false,
  prefix: '',
  suffix: '',
  allowNegative: true,
  allowEmptyFormatting: false,
  allowLeadingZeros: false,
  isNumericString: false,
  type: 'text',
  onValueChange: noop,
  onChange: noop,
  onKeyDown: noop,
  onMouseUp: noop,
  onFocus: noop,
  onBlur: noop,
  isAllowed: returnTrue,
};
var NumberFormat = /*@__PURE__*/(function (superclass) {
  function NumberFormat(props        ) {
    superclass.call(this, props);
    var defaultValue = props.defaultValue;

    //validate props
    this.validateProps();

    var formattedValue = this.formatValueProp(defaultValue);

    this.state = {
      value: formattedValue,
      numAsString: this.removeFormatting(formattedValue),
      mounted: false,
    };

    this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0,
    };

    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  if ( superclass ) NumberFormat.__proto__ = superclass;
  NumberFormat.prototype = Object.create( superclass && superclass.prototype );
  NumberFormat.prototype.constructor = NumberFormat;

  NumberFormat.prototype.componentDidMount = function componentDidMount () {
    // set mounted state
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      mounted: true,
    });
  };

  NumberFormat.prototype.componentDidUpdate = function componentDidUpdate (prevProps        ) {
    this.updateValueIfRequired(prevProps);
  };

  NumberFormat.prototype.componentWillUnmount = function componentWillUnmount () {
    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);
  };

  NumberFormat.prototype.updateValueIfRequired = function updateValueIfRequired (prevProps        ) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var focusedElm = ref.focusedElm;
    var stateValue = state.value;
    var lastNumStr = state.numAsString; if ( lastNumStr === void 0 ) lastNumStr = '';

    // If only state changed no need to do any thing
    if (prevProps !== props) {
      //validate props
      this.validateProps();

      var lastValueWithNewFormat = this.formatNumString(lastNumStr);

      var formattedValue = isNil(props.value) ? lastValueWithNewFormat : this.formatValueProp();
      var numAsString = this.removeFormatting(formattedValue);

      var floatValue = parseFloat(numAsString);
      var lastFloatValue = parseFloat(lastNumStr);

      if (
        //while typing set state only when float value changes
        ((!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue) ||
        //can also set state when float value is same and the format props changes
        lastValueWithNewFormat !== stateValue ||
        //set state always when not in focus and formatted value is changed
        (focusedElm === null && formattedValue !== stateValue)
      ) {
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: focusedElm,
          source: 'prop',
          event: null,
        });
      }
    }
  };

  /** Misc methods **/
  NumberFormat.prototype.getFloatString = function getFloatString (num) {
    if ( num === void 0 ) num         = '';

    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var numRegex = this.getNumberRegex(true);

    //remove negation for regex check
    var hasNegation = num[0] === '-';
    if (hasNegation) { num = num.replace('-', ''); }

    //if decimal scale is zero remove decimal and number after decimalSeparator
    if (decimalSeparator && decimalScale === 0) {
      num = num.split(decimalSeparator)[0];
    }

    num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.');

    //remove extra decimals
    var firstDecimalIndex = num.indexOf('.');

    if (firstDecimalIndex !== -1) {
      num = (num.substring(0, firstDecimalIndex)) + "." + (num
        .substring(firstDecimalIndex + 1, num.length)
        .replace(new RegExp(escapeRegExp(decimalSeparator), 'g'), ''));
    }

    //add negation back
    if (hasNegation) { num = '-' + num; }

    return num;
  };

  //returned regex assumes decimalSeparator is as per prop
  NumberFormat.prototype.getNumberRegex = function getNumberRegex (g         , ignoreDecimalSeparator          ) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var customNumerals = ref.customNumerals;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    return new RegExp(
      '[0-9' +
        (customNumerals ? customNumerals.join('') : '') +
        ']' +
        (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format
          ? '|' + escapeRegExp(decimalSeparator)
          : ''),
      g ? 'g' : undefined
    );
  };

  NumberFormat.prototype.getSeparators = function getSeparators () {
    var ref = this.props;
    var decimalSeparator = ref.decimalSeparator;
    var ref$1 = this.props;
    var thousandSeparator = ref$1.thousandSeparator;
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;

    if (thousandSeparator === true) {
      thousandSeparator = ',';
    }
    if (!allowedDecimalSeparators) {
      allowedDecimalSeparators = [decimalSeparator, '.'];
    }

    return {
      decimalSeparator: decimalSeparator,
      thousandSeparator: thousandSeparator,
      allowedDecimalSeparators: allowedDecimalSeparators,
    };
  };

  NumberFormat.prototype.getMaskAtIndex = function getMaskAtIndex (index        ) {
    var ref = this.props;
    var mask = ref.mask; if ( mask === void 0 ) mask = ' ';
    if (typeof mask === 'string') {
      return mask;
    }

    return mask[index] || ' ';
  };

  NumberFormat.prototype.getValueObject = function getValueObject (formattedValue        , numAsString        ) {
    var floatValue = parseFloat(numAsString);

    return {
      formattedValue: formattedValue,
      value: numAsString,
      floatValue: isNaN(floatValue) ? undefined : floatValue,
    };
  };

  NumberFormat.prototype.validateProps = function validateProps () {
    var ref = this.props;
    var mask = ref.mask;

    //validate decimalSeparator and thousandSeparator
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var thousandSeparator = ref$1.thousandSeparator;

    if (decimalSeparator === thousandSeparator) {
      throw new Error(("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: " + thousandSeparator + " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n          decimalSeparator: " + decimalSeparator + " (default value for decimalSeparator is .)\n       "));
    }

    //validate mask
    if (mask) {
      var maskAsStr = mask === 'string' ? mask : mask.toString();
      if (maskAsStr.match(/\d/g)) {
        throw new Error(("\n          Mask " + mask + " should not contain numeric character;\n        "));
      }
    }
  };
  /** Misc methods end **/

  /** caret specific methods **/
  NumberFormat.prototype.setPatchedCaretPosition = function setPatchedCaretPosition (el                  , caretPos        , currentValue        ) {
    /* setting caret position within timeout of 0ms is required for mobile chrome,
    otherwise browser resets the caret position after we set it
    We are also setting it without timeout so that in normal browser we don't see the flickering */
    setCaretPosition(el, caretPos);
    this.caretPositionTimeout = setTimeout(function () {
      if (el.value === currentValue) { setCaretPosition(el, caretPos); }
    }, 0);
  };

  /* This keeps the caret within typing area so people can't type in between prefix or suffix */
  NumberFormat.prototype.correctCaretPosition = function correctCaretPosition (value        , caretPos        , direction         ) {
    var ref = this.props;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;

    //if value is empty return 0
    if (value === '') { return 0; }

    //caret position should be between 0 and value length
    caretPos = clamp(caretPos, 0, value.length);

    //in case of format as number limit between prefix and suffix
    if (!format) {
      var hasNegation = value[0] === '-';
      return clamp(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
    }

    //in case if custom format method don't do anything
    if (typeof format === 'function') { return caretPos; }

    /* in case format is string find the closest # position from the caret position */

    //in case the caretPos have input value on it don't do anything
    if (format[caretPos] === '#' && charIsNumber(value[caretPos])) {
      return caretPos;
    }

    //if caretPos is just after input value don't do anything
    if (format[caretPos - 1] === '#' && charIsNumber(value[caretPos - 1])) {
      return caretPos;
    }

    //find the nearest caret position
    var firstHashPosition = format.indexOf('#');
    var lastHashPosition = format.lastIndexOf('#');

    //limit the cursor between the first # position and the last # position
    caretPos = clamp(caretPos, firstHashPosition, lastHashPosition + 1);

    var nextPos = format.substring(caretPos, format.length).indexOf('#');
    var caretLeftBound = caretPos;
    var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos);

    //get the position where the last number is present
    while (
      caretLeftBound > firstHashPosition &&
      (format[caretLeftBound] !== '#' || !charIsNumber(value[caretLeftBound]))
    ) {
      caretLeftBound -= 1;
    }

    var goToLeft =
      !charIsNumber(value[caretRightBound]) ||
      (direction === 'left' && caretPos !== firstHashPosition) ||
      caretPos - caretLeftBound < caretRightBound - caretPos;

    if (goToLeft) {
      //check if number should be taken after the bound or after it
      //if number preceding a valid number keep it after
      return charIsNumber(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
    }

    return caretRightBound;
  };

  NumberFormat.prototype.getCaretPosition = function getCaretPosition (inputValue        , formattedValue        , caretPos        ) {
    var ref = this.props;
    var format = ref.format;
    var stateValue = this.state.value;
    var numRegex = this.getNumberRegex(true);
    var inputNumber = (inputValue.match(numRegex) || []).join('');
    var formattedNumber = (formattedValue.match(numRegex) || []).join('');
    var j, i;

    j = 0;

    for (i = 0; i < caretPos; i++) {
      var currentInputChar = inputValue[i] || '';
      var currentFormatChar = formattedValue[j] || '';
      //no need to increase new cursor position if formatted value does not have those characters
      //case inputValue = 1a23 and formattedValue =  123
      if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) {
        continue;
      }

      //When we are striping out leading zeros maintain the new cursor position
      //Case inputValue = 00023 and formattedValue = 23;
      if (
        currentInputChar === '0' &&
        currentFormatChar.match(numRegex) &&
        currentFormatChar !== '0' &&
        inputNumber.length !== formattedNumber.length
      ) {
        continue;
      }

      //we are not using currentFormatChar because j can change here
      while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
        j++;
      }
      j++;
    }

    if (typeof format === 'string' && !stateValue) {
      //set it to the maximum value so it goes after the last number
      j = formattedValue.length;
    }

    //correct caret position if its outside of editable area
    j = this.correctCaretPosition(formattedValue, j);

    return j;
  };
  /** caret specific methods ends **/

  /** methods to remove formattting **/
  NumberFormat.prototype.removePrefixAndSuffix = function removePrefixAndSuffix (val        ) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;

    //remove prefix and suffix
    if (!format && val) {
      var isNegative = val[0] === '-';

      //remove negation sign
      if (isNegative) { val = val.substring(1, val.length); }

      //remove prefix
      val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;

      //remove suffix
      var suffixLastIndex = val.lastIndexOf(suffix);
      val =
        suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length
          ? val.substring(0, suffixLastIndex)
          : val;

      //add negation sign back
      if (isNegative) { val = '-' + val; }
    }

    return val;
  };

  NumberFormat.prototype.removePatternFormatting = function removePatternFormatting (val        ) {
    var ref = this.props;
    var format = ref.format;
    var formatArray = format.split('#').filter(function (str) { return str !== ''; });
    var start = 0;
    var numStr = '';

    for (var i = 0, ln = formatArray.length; i <= ln; i++) {
      var part = formatArray[i] || '';

      //if i is the last fragment take the index of end of the value
      //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
      var index = i === ln ? val.length : val.indexOf(part, start);

      /* in any case if we don't find the pattern part in the value assume the val as numeric string
      This will be also in case if user has started typing, in any other case it will not be -1
      unless wrong prop value is provided */
      if (index === -1) {
        numStr = val;
        break;
      } else {
        numStr += val.substring(start, index);
        start = index + part.length;
      }
    }

    return (numStr.match(this.getNumberRegex(true)) || []).join('');
  };

  NumberFormat.prototype.removeFormatting = function removeFormatting (val        ) {
    var ref = this.props;
    var format = ref.format;
    var removeFormatting = ref.removeFormatting;
    if (!val) { return val; }

    if (!format) {
      val = this.removePrefixAndSuffix(val);
      val = this.getFloatString(val);
    } else if (typeof format === 'string') {
      val = this.removePatternFormatting(val);
    } else if (typeof removeFormatting === 'function') {
      //condition need to be handled if format method is provide,
      val = removeFormatting(val);
    } else {
      val = (val.match(this.getNumberRegex(true)) || []).join('');
    }
    return val;
  };
  /** methods to remove formattting end **/

  /*** format specific methods start ***/
  /**
   * Format when # based string is provided
   * @param  {string} numStr Numeric String
   * @return {string}        formatted Value
   */
  NumberFormat.prototype.formatWithPattern = function formatWithPattern (numStr        ) {
    var ref = this.props;
    var format = ref.format;
    var hashCount = 0;
    var formattedNumberAry = format.split('');
    for (var i = 0, ln = format.length; i < ln; i++) {
      if (format[i] === '#') {
        formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
        hashCount += 1;
      }
    }
    return formattedNumberAry.join('');
  };
  /**
   * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
   * @return {string} formatted Value
   */
  NumberFormat.prototype.formatAsNumber = function formatAsNumber (numStr        ) {
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var allowNegative = ref.allowNegative;
    var thousandsGroupStyle = ref.thousandsGroupStyle;
    var ref$1 = this.getSeparators();
    var thousandSeparator = ref$1.thousandSeparator;
    var decimalSeparator = ref$1.decimalSeparator;

    var hasDecimalSeparator = numStr.indexOf('.') !== -1 || (decimalScale && fixedDecimalScale);
    var ref$2 = splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const

    //apply decimal precision if its defined
    if (decimalScale !== undefined) {
      afterDecimal = limitToScale(afterDecimal, decimalScale, fixedDecimalScale);
    }

    if (thousandSeparator) {
      beforeDecimal = applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    }

    //add prefix and suffix
    if (prefix) { beforeDecimal = prefix + beforeDecimal; }
    if (suffix) { afterDecimal = afterDecimal + suffix; }

    //restore negation sign
    if (addNegation) { beforeDecimal = '-' + beforeDecimal; }

    numStr = beforeDecimal + ((hasDecimalSeparator && decimalSeparator) || '') + afterDecimal;

    return numStr;
  };

  NumberFormat.prototype.formatNumString = function formatNumString (numStr) {
    if ( numStr === void 0 ) numStr         = '';

    var ref = this.props;
    var format = ref.format;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var customNumerals = ref.customNumerals;
    var formattedValue = numStr;

    if (customNumerals && customNumerals.length === 10) {
      var customNumeralRegex = new RegExp('[' + customNumerals.join('') + ']', 'g');
      formattedValue = numStr.replace(customNumeralRegex, function (digit) { return customNumerals.indexOf(digit).toString(); }
      );
    }

    if (numStr === '' && !allowEmptyFormatting) {
      formattedValue = '';
    } else if (numStr === '-' && !format) {
      formattedValue = '-';
    } else if (typeof format === 'string') {
      formattedValue = this.formatWithPattern(formattedValue);
    } else if (typeof format === 'function') {
      formattedValue = format(formattedValue);
    } else {
      formattedValue = this.formatAsNumber(formattedValue);
    }

    return formattedValue;
  };

  NumberFormat.prototype.formatValueProp = function formatValueProp (defaultValue                 ) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var ref$1 = this.props;
    var value = ref$1.value;
    var isNumericString = ref$1.isNumericString;

    // if value is undefined or null, use defaultValue instead
    value = isNil(value) ? defaultValue : value;

    var isNonNumericFalsy = !value && value !== 0;

    if (isNonNumericFalsy && allowEmptyFormatting) {
      value = '';
    }

    // if value is not defined return empty string
    if (isNonNumericFalsy && !allowEmptyFormatting) { return ''; }

    if (typeof value === 'number') {
      value = toNumericString(value);
      isNumericString = true;
    }

    //change infinity value to empty string
    if (value === 'Infinity' && isNumericString) {
      value = '';
    }

    //round the number based on decimalScale
    //format only if non formatted value is provided
    if (isNumericString && !format && typeof decimalScale === 'number') {
      value = roundToPrecision(value, decimalScale, fixedDecimalScale);
    }

    var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);

    return formattedValue;
  };

  NumberFormat.prototype.formatNegation = function formatNegation (value) {
    if ( value === void 0 ) value         = '';

    var ref = this.props;
    var allowNegative = ref.allowNegative;
    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)');

    // Check number has '-' value
    var hasNegation = negationRegex.test(value);

    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);

    //remove negation
    value = value.replace(/-/g, '');

    if (hasNegation && !removeNegation && allowNegative) {
      value = '-' + value;
    }

    return value;
  };

  NumberFormat.prototype.formatInput = function formatInput (value) {
    if ( value === void 0 ) value         = '';

    var ref = this.props;
    var format = ref.format;

    //format negation only if we are formatting as number
    if (!format) {
      value = this.removePrefixAndSuffix(value);
      value = this.formatNegation(value);
    }

    //remove formatting from number
    value = this.removeFormatting(value);

    return this.formatNumString(value);
  };

  /*** format specific methods end ***/
  NumberFormat.prototype.isCharacterAFormat = function isCharacterAFormat (caretPos        , value        ) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;

    //check within format pattern
    if (typeof format === 'string' && format[caretPos] !== '#') { return true; }

    //check in number format
    if (
      !format &&
      (caretPos < prefix.length ||
        caretPos >= value.length - suffix.length ||
        (decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator))
    ) {
      return true;
    }

    return false;
  };

  /**
   * This will check if any formatting got removed by the delete or backspace and reset the value
   * It will also work as fallback if android chome keyDown handler does not work
   **/
  NumberFormat.prototype.correctInputValue = function correctInputValue (caretPos        , lastValue        , value        ) {
    var this$1 = this;

    var ref = this.props;
    var format = ref.format;
    var allowNegative = ref.allowNegative;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;
    var decimalSeparator = ref$1.decimalSeparator;
    var lastNumStr = this.state.numAsString || '';
    var ref$2 = this.selectionBeforeInput;
    var selectionStart = ref$2.selectionStart;
    var selectionEnd = ref$2.selectionEnd;
    var ref$3 = findChangedIndex(lastValue, value);
    var start = ref$3.start;
    var end = ref$3.end;

    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */
    if (
      !format &&
      start === end &&
      allowedDecimalSeparators.indexOf(value[selectionStart]) !== -1
    ) {
      var separator = decimalScale === 0 ? '' : decimalSeparator;
      return (
        value.substr(0, selectionStart) + separator + value.substr(selectionStart + 1, value.length)
      );
    }

    var leftBound = !!format ? 0 : prefix.length;
    var rightBound = lastValue.length - (!!format ? 0 : suffix.length);

    if (
      // don't do anything if something got added
      value.length > lastValue.length ||
      // or if the new value is an empty string
      !value.length ||
      // or if nothing has changed, in which case start will be same as end
      start === end ||
      // or in case if whole input is selected and new value is typed
      (selectionStart === 0 && selectionEnd === lastValue.length) ||
      // or in case if the whole content is replaced by browser, example (autocomplete)
      (start === 0 && end === lastValue.length) ||
      // or if charcters between prefix and suffix is selected.
      // For numeric inputs we apply the format so, prefix and suffix can be ignored
      (selectionStart === leftBound && selectionEnd === rightBound)
    ) {
      return value;
    }

    // check whether the deleted portion has a character that is part of a format
    var deletedValues = lastValue.substr(start, end - start);
    var formatGotDeleted = !![].concat( deletedValues ).find(function (deletedVal, idx) { return this$1.isCharacterAFormat(idx + start, lastValue); }
    );

    // if it has, only remove characters that are not part of the format
    if (formatGotDeleted) {
      var deletedValuePortion = lastValue.substr(start);
      var recordIndexOfFormatCharacters = {};
      var resolvedPortion = [];
      [].concat( deletedValuePortion ).forEach(function (currentPortion, idx) {
        if (this$1.isCharacterAFormat(idx + start, lastValue)) {
          recordIndexOfFormatCharacters[idx] = currentPortion;
        } else if (idx > deletedValues.length - 1) {
          resolvedPortion.push(currentPortion);
        }
      });

      Object.keys(recordIndexOfFormatCharacters).forEach(function (idx) {
        if (resolvedPortion.length > idx) {
          resolvedPortion.splice(idx, 0, recordIndexOfFormatCharacters[idx]);
        } else {
          resolvedPortion.push(recordIndexOfFormatCharacters[idx]);
        }
      });

      value = lastValue.substr(0, start) + resolvedPortion.join('');
    }

    //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    if (!format) {
      var numericString = this.removeFormatting(value);
      var ref$4 = splitDecimal(
        numericString,
        allowNegative
      );
      var beforeDecimal = ref$4.beforeDecimal;
      var afterDecimal = ref$4.afterDecimal;
      var addNegation = ref$4.addNegation; // eslint-disable-line prefer-const

      //clear only if something got deleted
      var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;
      if (
        numericString.length < lastNumStr.length &&
        isBeforeDecimalPoint &&
        beforeDecimal === '' &&
        !parseFloat(afterDecimal)
      ) {
        return addNegation ? '-' : '';
      }
    }

    return value;
  };

  /** Update value and caret position */
  NumberFormat.prototype.updateValue = function updateValue (params   
                           
                        
                       
                            
                               
                   
                     
                              
   ) {
    var formattedValue = params.formattedValue;
    var input = params.input;
    var setCaretPosition = params.setCaretPosition; if ( setCaretPosition === void 0 ) setCaretPosition = true;
    var source = params.source;
    var event = params.event;
    var numAsString = params.numAsString;
    var caretPos = params.caretPos;
    var ref = this.props;
    var onValueChange = ref.onValueChange;
    var ref$1 = this.state;
    var lastValue = ref$1.value;

    if (input) {
      //calculate caret position if not defined
      if (caretPos === undefined && setCaretPosition) {
        var inputValue = params.inputValue || input.value;

        var currentCaretPosition = getCurrentCaretPosition(input);

        /**
         * set the value imperatively, this is required for IE fix
         * This is also required as if new caret position is beyond the previous value.
         * Caret position will not be set correctly
         */
        input.value = formattedValue;

        //get the caret position
        caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
      }

      /**
       * set the value imperatively, as we set the caret position as well imperatively.
       * This is to keep value and caret position in sync
       */
      input.value = formattedValue;

      //set caret position, and value imperatively when element is provided
      if (setCaretPosition) {
        //set caret position
        this.setPatchedCaretPosition(input, caretPos, formattedValue);
      }
    }

    //calculate numeric string if not passed
    if (numAsString === undefined) {
      numAsString = this.removeFormatting(formattedValue);
    }

    //update state if value is changed
    if (formattedValue !== lastValue) {
      this.setState({ value: formattedValue, numAsString: numAsString });

      // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
      onValueChange(this.getValueObject(formattedValue, numAsString), { event: event, source: source });
    }
  };

  NumberFormat.prototype.onChange = function onChange (e                     ) {
    var el = e.target;
    var inputValue = el.value;
    var ref = this;
    var state = ref.state;
    var props = ref.props;
    var isAllowed = props.isAllowed;
    var lastValue = state.value || '';

    var currentCaretPosition = getCurrentCaretPosition(el);

    inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);

    var formattedValue = this.formatInput(inputValue) || '';
    var numAsString = this.removeFormatting(formattedValue);

    var valueObj = this.getValueObject(formattedValue, numAsString);
    var isChangeAllowed = isAllowed(valueObj);

    if (!isChangeAllowed) {
      formattedValue = lastValue;
    }

    this.updateValue({
      formattedValue: formattedValue,
      numAsString: numAsString,
      inputValue: inputValue,
      input: el,
      event: e,
      source: 'event',
    });

    if (isChangeAllowed) {
      props.onChange(e);
    }
  };

  NumberFormat.prototype.onBlur = function onBlur (e                     ) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var format = props.format;
    var onBlur = props.onBlur;
    var allowLeadingZeros = props.allowLeadingZeros;
    var numAsString = state.numAsString;
    var lastValue = state.value;
    this.focusedElm = null;

    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);

    if (!format) {
      // if the numAsString is not a valid number reset it to empty
      if (isNaN(parseFloat(numAsString))) {
        numAsString = '';
      }

      if (!allowLeadingZeros) {
        numAsString = fixLeadingZero(numAsString);
      }

      var formattedValue = this.formatNumString(numAsString);

      //change the state
      if (formattedValue !== lastValue) {
        // the event needs to be persisted because its properties can be accessed in an asynchronous way
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: e.target,
          setCaretPosition: false,
          event: e,
          source: 'event',
        });
        onBlur(e);
        return;
      }
    }
    onBlur(e);
  };

  NumberFormat.prototype.onKeyDown = function onKeyDown (e                             ) {
    var el = e.target;
    var key = e.key;
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value; if ( value === void 0 ) value = '';
    var expectedCaretPosition;
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;
    var onKeyDown = ref.onKeyDown;
    var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
    var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
    var negativeRegex = new RegExp('-');
    var isPatternFormat = typeof format === 'string';

    this.selectionBeforeInput = {
      selectionStart: selectionStart,
      selectionEnd: selectionEnd,
    };

    //Handle backspace and delete against non numerical/decimal characters or arrow keys
    if (key === 'ArrowLeft' || key === 'Backspace') {
      expectedCaretPosition = selectionStart - 1;
    } else if (key === 'ArrowRight') {
      expectedCaretPosition = selectionStart + 1;
    } else if (key === 'Delete') {
      expectedCaretPosition = selectionStart;
    }

    //if expectedCaretPosition is not set it means we don't want to Handle keyDown
    //also if multiple characters are selected don't handle
    if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
      onKeyDown(e);
      return;
    }

    var newCaretPosition = expectedCaretPosition;
    var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
    var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

    if (key === 'ArrowLeft' || key === 'ArrowRight') {
      var direction = key === 'ArrowLeft' ? 'left' : 'right';
      newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
    } else if (
      key === 'Delete' &&
      !numRegex.test(value[expectedCaretPosition]) &&
      !negativeRegex.test(value[expectedCaretPosition])
    ) {
      while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
        newCaretPosition++;
      }
    } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition])) {
      /* NOTE: This is special case when backspace is pressed on a
      negative value while the cursor position is after prefix. We can't handle it on onChange because
      we will not have any information of keyPress
      */
      if (selectionStart <= leftBound + 1 && value[0] === '-' && typeof format === 'undefined') {
        var newValue = value.substring(1);
        this.updateValue({
          formattedValue: newValue,
          caretPos: newCaretPosition,
          input: el,
          event: e,
          source: 'event',
        });
      } else if (!negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
          newCaretPosition--;
        }
        newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
      }
    }

    if (
      newCaretPosition !== expectedCaretPosition ||
      expectedCaretPosition < leftBound ||
      expectedCaretPosition > rightBound
    ) {
      e.preventDefault();
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
            Remove this when you find different solution */
    if (e.isUnitTestRun) {
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    onKeyDown(e);
  };

  /** required to handle the caret position when click anywhere within the input **/
  NumberFormat.prototype.onMouseUp = function onMouseUp (e                          ) {
    var el = e.target;

    /**
     * NOTE: we have to give default value for value as in case when custom input is provided
     * value can come as undefined when nothing is provided on value prop.
     */
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value; if ( value === void 0 ) value = '';

    if (selectionStart === selectionEnd) {
      var caretPosition = this.correctCaretPosition(value, selectionStart);
      if (caretPosition !== selectionStart) {
        this.setPatchedCaretPosition(el, caretPosition, value);
      }
    }

    this.props.onMouseUp(e);
  };

  NumberFormat.prototype.onFocus = function onFocus (e                     ) {
    var this$1 = this;

    // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
    // (onFocus event target selectionStart is always 0 before setTimeout)
    e.persist();

    this.focusedElm = e.target;
    this.focusTimeout = setTimeout(function () {
      var el = e.target;
      var selectionStart = el.selectionStart;
      var selectionEnd = el.selectionEnd;
      var value = el.value; if ( value === void 0 ) value = '';

      var caretPosition = this$1.correctCaretPosition(value, selectionStart);

      //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
      if (
        caretPosition !== selectionStart &&
        !(selectionStart === 0 && selectionEnd === value.length)
      ) {
        this$1.setPatchedCaretPosition(el, caretPosition, value);
      }

      this$1.props.onFocus(e);
    }, 0);
  };

  NumberFormat.prototype.render = function render () {
    var ref = this.props;
    var type = ref.type;
    var displayType = ref.displayType;
    var customInput = ref.customInput;
    var renderText = ref.renderText;
    var getInputRef = ref.getInputRef;
    var format = ref.format;
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var thousandsGroupStyle = ref.thousandsGroupStyle;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var removeFormatting = ref.removeFormatting;
    var mask = ref.mask;
    var defaultValue = ref.defaultValue;
    var isNumericString = ref.isNumericString;
    var allowNegative = ref.allowNegative;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var allowLeadingZeros = ref.allowLeadingZeros;
    var onValueChange = ref.onValueChange;
    var isAllowed = ref.isAllowed;
    var customNumerals = ref.customNumerals;
    var onChange = ref.onChange;
    var onKeyDown = ref.onKeyDown;
    var onMouseUp = ref.onMouseUp;
    var onFocus = ref.onFocus;
    var onBlur = ref.onBlur;
    var propValue = ref.value;
    var rest = objectWithoutProperties$1( ref, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "thousandSeparator", "decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "decimalScale", "fixedDecimalScale", "prefix", "suffix", "removeFormatting", "mask", "defaultValue", "isNumericString", "allowNegative", "allowEmptyFormatting", "allowLeadingZeros", "onValueChange", "isAllowed", "customNumerals", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value"] );
    var otherProps = rest;
    var ref$1 = this.state;
    var value = ref$1.value;
    var mounted = ref$1.mounted;

    // add input mode on element based on format prop and device once the component is mounted
    var inputMode = mounted && addInputMode(format) ? 'numeric' : undefined;

    var inputProps = Object.assign({ inputMode: inputMode }, otherProps, {
      type: type,
      value: value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onMouseUp: this.onMouseUp,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
    });

    if (displayType === 'text') {
      return renderText ? (
        renderText(value, otherProps) || null
      ) : (
        React.createElement( 'span', Object.assign({}, otherProps, { ref: getInputRef }),
          value
        )
      );
    } else if (customInput) {
      var CustomInput = customInput;
      return React.createElement( CustomInput, Object.assign({}, inputProps, { ref: getInputRef }));
    }

    return React.createElement( 'input', Object.assign({}, inputProps, { ref: getInputRef }));
  };

  return NumberFormat;
}(React.Component));

NumberFormat.defaultProps = defaultProps;

function styleInject(css$$1, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css$$1 || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css$$1;
  } else {
    style.appendChild(document.createTextNode(css$$1));
  }
}

var css$1 = ":root {\n  --color-brand-heste-50: #fbfefd;\n  --color-brand-heste-100: #eefcf5;\n  --color-brand-heste-200: #d9f9e9;\n  --color-brand-heste-300: #bcf4d8;\n  --color-brand-heste-400: #96eec2;\n  --color-brand-heste-500: #69e7a8;\n  --color-brand-heste-600: #1bba6d;\n  --color-brand-heste-700: #1cab63;\n  --color-brand-heste-800: #16894f;\n  --color-brand-heste-900: #11673b;\n  --color-brand-heste-950: #0b4428;\n  --color-brand-sport-600: #20486f;\n  --color-brand-sport-500: #5893cf;\n  --color-brand-sport-400: #8bb4dd;\n  --color-brand-sport-50: #fafcfe;\n  --color-brand-sport-200: #d5e4f3;\n  --color-brand-sport-700: #1d4063;\n  --color-brand-sport-100: #ecf3fa;\n  --color-brand-sport-950: #0c1a28;\n  --color-brand-sport-800: #17334f;\n  --color-brand-sport-300: #b5cfe9;\n  --color-brand-sport-900: #11263b;\n  --color-brand-casino-950: #570b0b;\n  --color-brand-casino-900: #831010;\n  --color-brand-casino-600: #f44337;\n  --color-brand-casino-500: #ef7a7a;\n  --color-brand-casino-700: #da1b1b;\n  --color-brand-casino-300: #f8c4c4;\n  --color-brand-casino-400: #f4a3a3;\n  --color-brand-casino-200: #fbdede;\n  --color-brand-casino-100: #fdf0f0;\n  --color-brand-casino-800: #ae1616;\n  --color-brand-casino-50: #fffbfb;\n  --color-grey-50: #ffffff;\n  --color-black-50: #0c0c0d0d;\n  --color-black-200: #0c0c0d33;\n  --color-white-50: #ffffff0d;\n  --color-white-100: #ffffff1a;\n  --color-blue-50: #fbfdff;\n  --color-green-50: #fbfffb;\n  --color-slate-50: #fefefe;\n  --color-red-50: #fffbfb;\n  --color-yellow-50: #fffefb;\n  --color-yellow-950: #655602;\n  --color-yellow-900: #988202;\n  --color-yellow-800: #caad03;\n  --color-yellow-700: #fdd804;\n  --color-yellow-600: #fde03e;\n  --color-yellow-500: #fee871;\n  --color-yellow-300: #fef5c0;\n  --color-yellow-200: #fff9db;\n  --color-yellow-100: #fffcef;\n  --color-red-950: #620a0a;\n  --color-red-900: #930e0e;\n  --color-red-800: #c41313;\n  --color-red-700: #f51818;\n  --color-red-600: #f84f4f;\n  --color-red-400: #fba5a5;\n  --color-red-200: #fedfdf;\n  --color-red-300: #fdc5c5;\n  --color-red-100: #fef1f1;\n  --color-yellow-400: #feef9c;\n  --color-red-500: #fa7e7e;\n  --color-green-800: #099e20;\n  --color-green-700: #0bc628;\n  --color-green-900: #077718;\n  --color-green-400: #90f9a0;\n  --color-green-100: #edfef0;\n  --color-green-500: #5ff676;\n  --color-green-600: #25f244;\n  --color-green-300: #b8fbc2;\n  --color-green-200: #d7fddd;\n  --color-green-950: #044f10;\n  --color-blue-700: #186bf5;\n  --color-blue-900: #0e4093;\n  --color-blue-500: #7eadfa;\n  --color-blue-800: #1356c4;\n  --color-blue-100: #f1f6fe;\n  --color-blue-400: #a5c6fb;\n  --color-blue-300: #c5dbfd;\n  --color-blue-200: #dfebfe;\n  --color-blue-600: #4f90f8;\n  --color-blue-950: #0a2b62;\n  --color-black-100: #0c0c0d1a;\n  --color-black-300: #0c0c0d4d;\n  --color-black-400: #0c0c0d66;\n  --color-black-500: #0c0c0d80;\n  --color-black-600: #0c0c0d99;\n  --color-black-700: #0c0c0db3;\n  --color-black-800: #0c0c0dcc;\n  --color-black-900: #0c0c0de6;\n  --color-black-1000: #0c0c0d;\n  --color-white-200: #ffffff33;\n  --color-white-300: #ffffff4d;\n  --color-white-400: #ffffff66;\n  --color-white-500: #ffffff80;\n  --color-white-600: #ffffff99;\n  --color-white-700: #ffffffb3;\n  --color-white-800: #ffffffcc;\n  --color-white-900: #ffffffe6;\n  --color-white-1000: #ffffff;\n  --color-white-950: #fffffff2;\n  --color-white-850: #ffffffd9;\n  --color-black-950: #0c0c0df2;\n  --color-black-850: #0c0c0dd9;\n  --color-grey-950: #111111;\n  --color-grey-800: #2c2c2c;\n  --color-grey-600: #444444;\n  --color-grey-400: #b3b3b3;\n  --color-grey-900: #1e1e1e;\n  --color-grey-700: #383838;\n  --color-grey-500: #757575;\n  --color-grey-300: #d9d9d9;\n  --color-grey-200: #e6e6e6;\n  --color-grey-100: #f5f5f5;\n  --color-slate-600: #8c94a0;\n  --color-slate-100: #f5f8fc;\n  --color-slate-900: #2c3036;\n  --color-slate-500: #bfc9d9;\n  --color-slate-700: #4f555e;\n  --color-slate-400: #dfe5ed;\n  --color-slate-800: #3f454d;\n  --color-slate-300: #e4e9ef;\n  --color-slate-200: #f0f4fa;\n  --color-slate-950: #1e1e1e;\n  --color-orange-50: #fffdfb;\n  --color-orange-950: #643c00;\n  --color-orange-900: #965a00;\n  --color-orange-800: #c87800;\n  --color-orange-700: #fa9600;\n  --color-orange-600: #ffaf38;\n  --color-orange-500: #ffc46d;\n  --color-orange-300: #ffe5be;\n  --color-orange-200: #fff0da;\n  --color-orange-100: #fff8ef;\n  --color-orange-400: #ffd699;\n  --color-brand-go-orange-50: #fffdfb;\n  --color-brand-go-orange-100: #fff6ef;\n  --color-brand-go-orange-200: #feecdb;\n  --color-brand-go-orange-300: #fedcbf;\n  --color-brand-go-orange-400: #fdc99b;\n  --color-brand-go-orange-500: #fcb170;\n  --color-brand-go-orange-600: #fb953c;\n  --color-brand-go-orange-700: #f57505;\n  --color-brand-go-orange-800: #894103;\n  --color-brand-go-orange-900: #482201;\n  --color-brand-go-orange-950: #321801;\n  --color-brand-go-green-50: #fefffa;\n  --color-brand-go-green-100: #f9ffed;\n  --color-brand-go-green-200: #f3ffd5;\n  --color-brand-go-green-300: #e9ffb5;\n  --color-brand-go-green-400: #dcff8b;\n  --color-brand-go-green-500: #cdff59;\n  --color-brand-go-green-600: #bbff1d;\n  --color-brand-go-green-700: #96d600;\n  --color-brand-go-green-800: #567c00;\n  --color-brand-go-green-900: #304500;\n  --color-brand-go-green-950: #243300;\n}";
styleInject(css$1);

var defaultThemeGenerated = {
  "colorBackgroundFillPrimaryDefault": "var(--color-slate-50)",
  "colorBackgroundFillSuccesDefault": "var(--color-green-700)",
  "colorBackgroundUtilitiesOverlayPrimary": "var(--color-black-800)",
  "colorTextUtilitiesLink": "var(--color-blue-700)",
  "colorBackgroundFillSuccesActive": "var(--color-green-500)",
  "colorBackgroundFillSuccesHover": "var(--color-green-600)",
  "colorBackgroundFillWarningActive": "var(--color-orange-500)",
  "colorBackgroundFillWarningHover": "var(--color-orange-600)",
  "colorBackgroundFillWarningDefault": "var(--color-orange-700)",
  "colorBackgroundFillDangerActive": "var(--color-red-500)",
  "colorBackgroundFillDangerHover": "var(--color-red-600)",
  "colorBackgroundFillDangerDefault": "var(--color-red-700)",
  "colorTextPrimaryDefault": "var(--color-slate-950)",
  "colorTextUtilitiesOnOverlay": "var(--color-white-1000)",
  "colorTextSuccessPrimaryDefault": "var(--color-green-800)",
  "colorTextDangerDefault": "var(--color-red-800)",
  "colorTextWarningDefault": "var(--color-orange-800)",
  "colorBorderPrimaryDefault": "var(--color-slate-300)",
  "colorBorderSuccessDefault": "var(--color-green-700)",
  "colorBorderWarningDefault": "var(--color-orange-400)",
  "colorBorderDangerDefault": "var(--color-red-400)",
  "colorIconPrimaryDefault": "var(--color-slate-900)",
  "colorIconBrandDefault": "var(--color-brand-casino-700)",
  "colorIconSuccesDefault": "var(--color-green-900)",
  "colorIconWarningDefault": "var(--color-orange-700)",
  "colorIconDangerDefault": "var(--color-red-700)",
  "colorBackgroundUtilitiesOverlaySeconday": "var(--color-black-500)",
  "colorBackgroundUtilitiesOverlayTertiary": "var(--color-black-200)",
  "colorTextAccentPrimary": "var(--color-yellow-700)",
  "colorTextUtilitiesSeperator": "var(--color-slate-300)",
  "colorIconAccentDefault": "var(--color-yellow-700)",
  "colorIconAccentDisabled": "var(--color-yellow-200)",
  "colorShadowDefault50": "var(--color-black-50)",
  "colorShadowDefault100": "var(--color-black-100)",
  "colorShadowDefault400": "var(--color-black-400)",
  "colorBackgroundFillInfoDefault": "var(--color-blue-700)",
  "colorBackgroundFillInfoHover": "var(--color-blue-600)",
  "colorBackgroundFillInfoActive": "var(--color-blue-500)",
  "colorTextInfoDefault": "var(--color-blue-800)",
  "colorBackgroundSurfaceInverseDefault": "var(--color-slate-950)",
  "colorBackgroundSurfacePrimaryDefault": "var(--color-white-1000)",
  "colorBackgroundSurfaceSecondaryDefault": "var(--color-slate-200)",
  "colorBackgroundSurfaceSecondaryHover": "var(--color-black-50)",
  "colorBackgroundSurfacePrimaryHover": "var(--color-black-50)",
  "colorBackgroundSurfaceInverseHover": "var(--color-white-50)",
  "colorBackgroundSurfaceBrandPrimaryDefault": "var(--color-brand-casino-700)",
  "colorBackgroundSurfaceBrandPrimaryHover": "var(--color-white-100)",
  "colorBackgroundSurfaceOnBrandPrimaryDefault": "var(--color-brand-casino-600)",
  "colorBackgroundSurfaceOnBrandPrimaryHover": "var(--color-white-100)",
  "colorBackgroundDefault": "var(--color-slate-100)",
  "colorBackgroundFillPrimaryHover": "var(--color-black-50)",
  "colorBackgroundFillSecondaryDefault": "var(--color-slate-100)",
  "colorBackgroundFillSecondaryHover": "var(--color-slate-200)",
  "colorBackgroundFillInverseDefault": "var(--color-slate-950)",
  "colorBackgroundFillInverseHover": "var(--color-white-50)",
  "colorBackgroundFillAccentDefault": "var(--color-yellow-700)",
  "colorBackgroundFillAccentHover": "var(--color-yellow-600)",
  "colorBackgroundSurfaceInfoPrimaryActive": "var(--color-blue-300)",
  "colorBackgroundSurfaceInfoDefault": "var(--color-blue-100)",
  "colorBackgroundSurfaceInfoHover": "var(--color-blue-200)",
  "colorBackgroundSurfaceSuccesActive": "var(--color-green-300)",
  "colorBackgroundSurfaceSuccesDefault": "var(--color-green-100)",
  "colorBackgroundSurfaceSuccesHover": "var(--color-green-200)",
  "colorBackgroundSurfaceWarningSecondary": "var(--color-orange-300)",
  "colorBackgroundSurfaceWarningDefault": "var(--color-orange-100)",
  "colorBackgroundSurfaceWarningHover": "var(--color-orange-200)",
  "colorBackgroundSurfaceDangerActive": "var(--color-red-300)",
  "colorBackgroundSurfaceDangerDefault": "var(--color-red-100)",
  "colorBackgroundSurfaceDangerHover": "var(--color-red-200)",
  "colorProductsJackpotUltra": "var(--color-red-700)",
  "colorProductsJackpotSuper": "var(--color-red-600)",
  "colorProductsJackpotWeekly": "var(--color-red-500)",
  "colorProductsVgamesV4": "var(--color-red-700)",
  "colorProductsVgamesV5": "var(--color-red-600)",
  "colorProductsVgamesV64": "var(--color-red-500)",
  "colorProductsVgamesV65": "var(--color-red-700)",
  "colorProductsVgamesV75": "var(--color-red-600)",
  "colorProductsVgamesGs75": "var(--color-red-500)",
  "colorProductsVgamesV85": "var(--color-red-500)",
  "colorProductsVgamesSimples": "var(--color-red-700)",
  "colorProductsJackpotDaily": "var(--color-red-500)",
  "colorProductsSportBig9": "var(--color-red-700)",
  "colorProductsSportDaily5": "var(--color-red-700)",
  "colorTextSecondaryDefault": "var(--color-slate-700)",
  "colorTextPrimaryDisabled": "var(--color-slate-400)",
  "colorTextOnBrandPrimaryDefault": "var(--color-white-1000)",
  "colorTextOnAccentDefault": "var(--color-slate-950)",
  "colorTextSecondaryDisabled": "var(--color-slate-400)",
  "colorTextInverseDefault": "var(--color-white-1000)",
  "colorTextTertiaryDefault": "var(--color-slate-600)",
  "colorTextTertiaryDisabled": "var(--color-slate-400)",
  "colorBorderPrimaryActive": "var(--color-slate-600)",
  "colorBorderInfoDefault": "var(--color-blue-400)",
  "colorIconSecondaryDefault": "var(--color-slate-500)",
  "colorIconTertiaryDefault": "var(--color-slate-400)",
  "colorTextOnBrandDefault": "var(--color-brand-casino-50)",
  "colorTextOnBrandHover": "var(--color-brand-casino-100)",
  "colorTextOnBrandActive": "var(--color-brand-casino-200)",
  "colorIconInverseDefault": "var(--color-white-1000)",
  "colorIconInfoDefault": "var(--color-blue-700)",
  "colorBackgroundSurfaceTertiaryDefault": "var(--color-slate-300)",
  "colorBackgroundSurfaceTertiaryHover": "var(--color-black-50)",
  "colorTextAccentDefault": "var(--color-yellow-800)",
  "colorTextAccentDisabled": "var(--color-grey-300)",
  "colorBackgroundSurfaceBrandSecondaryDefault": "var(--color-brand-casino-800)",
  "colorBackgroundSurfaceBrandSecondaryHover": "var(--color-white-50)",
  "colorBackgroundSurfaceBrandTertiaryDefault": "var(--color-brand-casino-900)",
  "colorBackgroundSurfaceBrandTertiaryHover": "var(--color-white-50)",
  "colorBackgroundSurfaceOnBrandSecondaryDefault": "var(--color-brand-casino-500)",
  "colorBackgroundSurfaceOnBrandSecondaryHover": "var(--color-white-100)",
  "colorBackgroundSurfaceOnBrandTertiaryDefault": "var(--color-brand-casino-400)",
  "colorBackgroundSurfaceOnBrandTertiaryHover": "var(--color-white-100)",
  "colorTextBrandTertiaryDefault": "var(--color-brand-casino-900)",
  "colorTextBrandTertiaryHover": "var(--color-white-50)",
  "colorBackgroundFillOnBrandPrimaryDefault": "var(--color-brand-casino-600)",
  "colorBackgroundFillOnBrandPrimaryHover": "var(--color-white-100)",
  "colorBackgroundFillOnBrandSecondaryDefault": "var(--color-brand-casino-500)",
  "colorBackgroundFillOnBrandSecondaryHover": "var(--color-white-100)",
  "colorBackgroundFillOnBrandTertiaryDefault": "var(--color-brand-casino-400)",
  "colorBackgroundFillOnBrandTertiaryHover": "var(--color-white-100)",
  "colorBackgroundFillBrandPrimaryDefault": "var(--color-brand-casino-700)",
  "colorBackgroundFillBrandPrimaryHover": "var(--color-brand-casino-600)",
  "colorBackgroundFillBrandSecondaryDefault": "var(--color-brand-casino-800)",
  "colorBackgroundFillBrandSecondaryHover": "var(--color-white-50)",
  "colorBackgroundFillBrandTertiaryDefault": "var(--color-brand-casino-900)",
  "colorBackgroundFillBrandTertiaryHover": "var(--color-white-50)",
  "colorTextBrandPrimaryDefault": "var(--color-brand-casino-700)",
  "colorTextBrandPrimaryHover": "var(--color-white-100)",
  "colorTextBrandSecondaryDefault": "var(--color-brand-casino-800)",
  "colorTextBrandSecondaryHover": "var(--color-white-50)",
  "colorTextOnBrandSecondaryDefault": "var(--color-brand-casino-200)",
  "colorTextOnBrandTertiaryDefault": "var(--color-brand-casino-400)",
  "colorBorderPrimaryHover": "var(--color-slate-500)",
  "colorBorderSecondaryDefault": "var(--color-slate-500)",
  "colorBorderSecondaryHover": "var(--color-slate-600)",
  "colorBorderSecondaryActive": "var(--color-slate-700)",
  "colorTextSuccessSecondaryDefault": "var(--color-green-500)",
  "colorBackgroundFillAccentDisabled": "var(--color-yellow-200)",
  "colorTextOnAccentInactive": "var(--color-grey-300)",
  "colorBackgroundFillAccentPressed": "var(--color-yellow-800)",
  "colorBackgroundFillSecondaryPressed": "var(--color-slate-300)",
  "colorBackgroundFillSecondaryDisabled": "var(--color-slate-50)",
  "colorBackgroundFillBrandPrimaryDisabled": "var(--color-brand-casino-100)",
  "colorBackgroundFillBrandPrimaryPressed": "var(--color-brand-casino-800)",
  "colorTextBrandPrimaryDisabled": "var(--color-grey-300)",
  "colorIconPrimaryDisabled": "var(--color-grey-300)",
  "colorTextSecondaryHover": "var(--color-slate-700)",
  "colorTextSecondaryPressed": "var(--color-slate-700)",
  "colorTextOnBrandPrimaryHover": "var(--color-white-1000)",
  "colorTextOnBrandPrimaryPressed": "var(--color-white-1000)",
  "colorTextOnBrandPrimaryDisabled": "var(--color-white-1000)",
  "colorBackgroundMaterial": "var(--color-white-600)"
};

var darkThemeGenerated = {
    colorBackgroundFillPrimaryDefault: 'var(--color-grey-500)',
    colorBackgroundFillSuccesDefault: 'var(--color-green-700)',
    colorBackgroundUtilitiesOverlayPrimary: 'var(--color-black-800)',
    colorTextUtilitiesLink: 'var(--color-brand-go-green-700)',
    colorBackgroundFillSuccesActive: 'var(--color-green-200)',
    colorBackgroundFillSuccesHover: 'var(--color-green-800)',
    colorBackgroundFillWarningActive: 'var(--color-orange-200)',
    colorBackgroundFillWarningHover: 'var(--color-orange-800)',
    colorBackgroundFillWarningDefault: 'var(--color-orange-700)',
    colorBackgroundFillDangerActive: 'var(--color-red-200)',
    colorBackgroundFillDangerHover: 'var(--color-red-800)',
    colorBackgroundFillDangerDefault: 'var(--color-red-700)',
    colorTextPrimaryDefault: 'var(--color-white-1000)',
    colorTextUtilitiesOnOverlay: 'var(--color-white-1000)',
    colorTextSuccessPrimaryDefault: 'var(--color-green-700)',
    colorTextDangerDefault: 'var(--color-red-700)',
    colorTextWarningDefault: 'var(--color-orange-700)',
    colorBorderPrimaryDefault: 'var(--color-grey-800)',
    colorBorderSuccessDefault: 'var(--color-green-800)',
    colorBorderWarningDefault: 'var(--color-orange-800)',
    colorBorderDangerDefault: 'var(--color-red-800)',
    colorIconPrimaryDefault: 'var(--color-white-1000)',
    colorIconBrandDefault: 'var(--color-brand-go-orange-200)',
    colorIconSuccesDefault: 'var(--color-green-900)',
    colorIconWarningDefault: 'var(--color-orange-700)',
    colorIconDangerDefault: 'var(--color-red-700)',
    colorBackgroundUtilitiesOverlaySeconday: 'var(--color-black-500)',
    colorBackgroundUtilitiesOverlayTertiary: 'var(--color-black-200)',
    colorTextAccentPrimary: 'var(--color-brand-go-orange-700)',
    colorTextUtilitiesSeperator: 'var(--color-slate-300)',
    colorIconAccentDefault: 'var(--color-yellow-700)',
    colorIconAccentDisabled: 'var(--color-yellow-200)',
    colorShadowDefault50: 'var(--color-black-50)',
    colorShadowDefault100: 'var(--color-black-100)',
    colorShadowDefault400: 'var(--color-black-400)',
    colorBackgroundFillInfoDefault: 'var(--color-blue-700)',
    colorBackgroundFillInfoHover: 'var(--color-blue-600)',
    colorBackgroundFillInfoActive: 'var(--color-blue-200)',
    colorTextInfoDefault: 'var(--color-blue-700)',
    colorBackgroundSurfaceInverseDefault: 'var(--color-white-1000)',
    colorBackgroundSurfacePrimaryDefault: 'var(--color-grey-900)',
    colorBackgroundSurfaceSecondaryDefault: 'var(--color-grey-800)',
    colorBackgroundSurfaceSecondaryHover: 'var(--color-white-50)',
    colorBackgroundSurfacePrimaryHover: 'var(--color-white-50)',
    colorBackgroundSurfaceInverseHover: 'var(--color-black-50)',
    colorBackgroundSurfaceBrandPrimaryDefault: 'var(--color-grey-950)',
    colorBackgroundSurfaceBrandPrimaryHover: 'var(--color-white-100)',
    colorBackgroundSurfaceOnBrandPrimaryDefault: 'var(--color-brand-go-green-700)',
    colorBackgroundSurfaceOnBrandPrimaryHover: 'var(--color-white-100)',
    colorBackgroundDefault: 'var(--color-grey-950)',
    colorBackgroundFillPrimaryHover: 'var(--color-white-50)',
    colorBackgroundFillSecondaryDefault: 'var(--color-grey-800)',
    colorBackgroundFillSecondaryHover: 'var(--color-grey-700)',
    colorBackgroundFillInverseDefault: 'var(--color-slate-950)',
    colorBackgroundFillInverseHover: 'var(--color-white-50)',
    colorBackgroundFillAccentDefault: 'var(--color-brand-go-orange-700)',
    colorBackgroundFillAccentHover: 'var(--color-brand-go-orange-600)',
    colorBackgroundSurfaceInfoPrimaryActive: 'var(--color-blue-700)',
    colorBackgroundSurfaceInfoDefault: 'var(--color-blue-950)',
    colorBackgroundSurfaceInfoHover: 'var(--color-blue-800)',
    colorBackgroundSurfaceSuccesActive: 'var(--color-green-800)',
    colorBackgroundSurfaceSuccesDefault: 'var(--color-green-950)',
    colorBackgroundSurfaceSuccesHover: 'var(--color-green-900)',
    colorBackgroundSurfaceWarningSecondary: 'var(--color-orange-800)',
    colorBackgroundSurfaceWarningDefault: 'var(--color-orange-950)',
    colorBackgroundSurfaceWarningHover: 'var(--color-orange-900)',
    colorBackgroundSurfaceDangerActive: 'var(--color-red-800)',
    colorBackgroundSurfaceDangerDefault: 'var(--color-red-950)',
    colorBackgroundSurfaceDangerHover: 'var(--color-red-900)',
    colorProductsJackpotUltra: 'var(--color-red-700)',
    colorProductsJackpotSuper: 'var(--color-red-800)',
    colorProductsJackpotWeekly: 'var(--color-red-200)',
    colorProductsVgamesV4: 'var(--color-red-700)',
    colorProductsVgamesV5: 'var(--color-red-800)',
    colorProductsVgamesV64: 'var(--color-red-200)',
    colorProductsVgamesV65: 'var(--color-red-700)',
    colorProductsVgamesV75: 'var(--color-red-800)',
    colorProductsVgamesGs75: 'var(--color-red-200)',
    colorProductsVgamesV85: 'var(--color-red-200)',
    colorProductsVgamesSimples: 'var(--color-red-700)',
    colorProductsJackpotDaily: 'var(--color-red-200)',
    colorProductsSportBig9: 'var(--color-red-700)',
    colorProductsSportDaily5: 'var(--color-red-700)',
    colorTextSecondaryDefault: 'var(--color-grey-50)',
    colorTextPrimaryDisabled: 'var(--color-slate-400)',
    colorTextOnBrandPrimaryDefault: 'var(--color-white-1000)',
    colorTextOnAccentDefault: 'var(--color-white-1000)',
    colorTextSecondaryDisabled: 'var(--color-grey-600)',
    colorTextInverseDefault: 'var(--color-black-1000)',
    colorTextTertiaryDefault: 'var(--color-grey-500)',
    colorTextTertiaryDisabled: 'var(--color-slate-400)',
    colorBorderPrimaryActive: 'var(--color-grey-600)',
    colorBorderInfoDefault: 'var(--color-blue-800)',
    colorIconSecondaryDefault: 'var(--color-grey-300)',
    colorIconTertiaryDefault: 'var(--color-grey-400)',
    colorTextOnBrandDefault: 'var(--color-white-1000)',
    colorTextOnBrandHover: 'var(--color-white-900)',
    colorTextOnBrandActive: 'var(--color-white-800)',
    colorIconInverseDefault: 'var(--color-white-1000)',
    colorIconInfoDefault: 'var(--color-blue-700)',
    colorBackgroundSurfaceTertiaryDefault: 'var(--color-grey-700)',
    colorBackgroundSurfaceTertiaryHover: 'var(--color-white-50)',
    colorTextAccentDefault: 'var(--color-brand-go-orange-800)',
    colorTextAccentDisabled: 'var(--color-brand-go-orange-200)',
    colorBackgroundSurfaceBrandSecondaryDefault: 'var(--color-grey-800)',
    colorBackgroundSurfaceBrandSecondaryHover: 'var(--color-white-50)',
    colorBackgroundSurfaceBrandTertiaryDefault: 'var(--color-grey-800)',
    colorBackgroundSurfaceBrandTertiaryHover: 'var(--color-white-50)',
    colorBackgroundSurfaceOnBrandSecondaryDefault: 'var(--color-brand-go-green-700)',
    colorBackgroundSurfaceOnBrandSecondaryHover: 'var(--color-white-100)',
    colorBackgroundSurfaceOnBrandTertiaryDefault: 'var(--color-brand-go-green-700)',
    colorBackgroundSurfaceOnBrandTertiaryHover: 'var(--color-white-100)',
    colorTextBrandTertiaryDefault: 'var(--color-grey-800)',
    colorTextBrandTertiaryHover: 'var(--color-white-50)',
    colorBackgroundFillOnBrandPrimaryDefault: 'var(--color-grey-800)',
    colorBackgroundFillOnBrandPrimaryHover: 'var(--color-white-100)',
    colorBackgroundFillOnBrandSecondaryDefault: 'var(--color-grey-700)',
    colorBackgroundFillOnBrandSecondaryHover: 'var(--color-white-100)',
    colorBackgroundFillOnBrandTertiaryDefault: 'var(--color-grey-600)',
    colorBackgroundFillOnBrandTertiaryHover: 'var(--color-white-100)',
    colorBackgroundFillBrandPrimaryDefault: 'var(--color-grey-950)',
    colorBackgroundFillBrandPrimaryHover: 'var(--color-grey-800)',
    colorBackgroundFillBrandSecondaryDefault: 'var(--color-grey-800)',
    colorBackgroundFillBrandSecondaryHover: 'var(--color-white-50)',
    colorBackgroundFillBrandTertiaryDefault: 'var(--color-grey-800)',
    colorBackgroundFillBrandTertiaryHover: 'var(--color-white-50)',
    colorTextBrandPrimaryDefault: 'var(--color-grey-950)',
    colorTextBrandPrimaryHover: 'var(--color-white-100)',
    colorTextBrandSecondaryDefault: 'var(--color-grey-800)',
    colorTextBrandSecondaryHover: 'var(--color-white-50)',
    colorTextOnBrandSecondaryDefault: 'var(--color-grey-200)',
    colorTextOnBrandTertiaryDefault: 'var(--color-grey-400)',
    colorBorderPrimaryHover: 'var(--color-grey-700)',
    colorBorderSecondaryDefault: 'var(--color-slate-800)',
    colorBorderSecondaryHover: 'var(--color-grey-300)',
    colorBorderSecondaryActive: 'var(--color-slate-700)',
    colorTextSuccessSecondaryDefault: 'var(--color-green-700)',
    colorBackgroundFillAccentDisabled: 'var(--color-brand-go-orange-900)',
    colorTextOnAccentInactive: 'var(--color-brand-go-orange-950)',
    colorBackgroundFillAccentPressed: 'var(--color-brand-go-orange-800)',
    colorBackgroundFillSecondaryPressed: 'var(--color-grey-600)',
    colorBackgroundFillSecondaryDisabled: 'var(--color-grey-800)',
    colorBackgroundFillBrandPrimaryDisabled: 'var(--color-grey-800)',
    colorBackgroundFillBrandPrimaryPressed: 'var(--color-grey-600)',
    colorTextBrandPrimaryDisabled: 'var(--color-white-100)',
    colorIconPrimaryDisabled: 'var(--color-white-1000)',
    colorTextSecondaryHover: 'var(--color-grey-50)',
    colorTextSecondaryPressed: 'var(--color-grey-50)',
    colorTextOnBrandPrimaryHover: 'var(--color-white-1000)',
    colorTextOnBrandPrimaryPressed: 'var(--color-white-1000)',
    colorTextOnBrandPrimaryDisabled: 'var(--color-grey-600)',
    colorBackgroundMaterial: 'var(--color-black-600)'
};

var defaultTheme$1 = {
    name: 'default',
    condensed: true,
    bold: true,
    fontWeight: 700,
    colors: _extends({
        active: '#0bc628',
        bg: '#ffffff',
        basic: '#333',
        secondary: '#333333',
        link: '#575c69',
        borderColor: '#e9eaee',
        activeBtnColor: '#fbd600',
        disabledBtnColor: '#fff8cb',
        activeLoginColor: '#fbd600',
        disabledLoginColor: '#fff8cb',
        divider: '#e9eaee',
        bgDarker: '#eceff6',
        primary: '#575c69',
        primaryAction: '#9198aa'

    }, defaultThemeGenerated, {

        //colors for backward compatibility, needs to be removed
        placeholder: '#8C94A0',
        stroke_400: '#DFE5ED',
        black_font_900: '#1E1E1E',
        table_tint_300: '#F0F4FA',
        semi_grey_500: '#BFC9D9',
        bg_200: '#F5F8FC',
        bg_300: '#F8F8F8',
        red: '#F51818',
        white_100: '#fff',
        link_blue: '#196bf5'
    })
};

var dark$1 = {
    name: 'dark',
    condensed: false,
    bold: false,
    fontWeight: 400,
    colors: _extends({
        active: '#97D800',
        bg: '#121212',
        basic: '#fff',
        secondary: '#BEBEBE',
        link: '#F77705',
        borderColor: '#262626',
        activeBtnColor: '#F77705',
        disabledBtnColor: '#522200',
        activeLoginColor: '#97D800',
        disabledLoginColor: '#2C4000',
        divider: '#818181',
        bgDarker: '#262626',
        primary: '#BEBEBE',
        primaryAction: '#818181'

    }, darkThemeGenerated, {
        //new colors
        placeholder: '#8C94A0',
        stroke_400: '#DFE5ED',
        red: '#F51818',
        white_100: '#fff',
        link_blue: '#196bf5',
        black_font_900: '#1E1E1E'
    })
};

var BONUSES_TYPE_BY_PRODUCT = {
    heste: 'D',
    sport: 'D',
    casino: 'W',
    casinogo: 'W'

};

var getMaxWidthByProduct = function getMaxWidthByProduct(product) {
    return detectMobile() ? '100%' : product === 'sport' || product === 'heste' ? '330px' : '100%';
};
var getPaddingByProduct = function getPaddingByProduct(product) {
    return detectMobile() || product !== 'sport' && product !== 'heste' ? '20px 16px' : '24px 0 12px';
};
var getPaddingsForButtonsByProduct = function getPaddingsForButtonsByProduct() {
    return detectMobile() ? '16px 23px 50px' : '16px 15px';
};

var exportNumberFromStringWithoutComma = function exportNumberFromStringWithoutComma(string$$1) {
    return string$$1.includes(',') ? Number(string$$1.replace(',', '.')) : Number(string$$1);
};

var _templateObject$j = taggedTemplateLiteral(['\n    margin: ', ';\n    font-size: 12px;\n    line-height: normal;\n    color: ', ';\n'], ['\n    margin: ', ';\n    font-size: 12px;\n    line-height: normal;\n    color: ', ';\n']),
    _templateObject2$f = taggedTemplateLiteral(['\n    margin: 44px auto 0;\n    padding: 0;\n    width: 100%;\n    position: relative;\n    border: none;\n    outline: none;\n    box-shadow: none;\n\n    input {\n        height: ', ';\n        width: 100%;\n        display: block;\n        box-sizing: border-box;\n        padding: 17px 45px 17px 16px;\n        border-radius: 5px;\n        background: ', ';\n        position: relative;\n        box-shadow: none;\n        color: ', ';\n        opacity: 1;\n        font-size: 16px;\n        line-height: 16px;\n        overflow: hidden;\n        outline: none;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        font-family: ', ';\n        ', ';\n\n        &:focus,\n        &:hover {\n            font-size: 16px;\n            ', ';\n            outline: none;\n            box-shadow: none;\n        }\n\n        &:disabled {\n            color: ', ';\n            border: none;\n        }\n\n        &::placeholder {\n            font-size: 16px;\n            line-height: 16px;\n            color: ', ';\n            outline: none;\n            box-shadow: none;\n        }\n\n        &[type=\'password\'] {\n            font-family: ', ';\n            -webkit-text-security: disc;\n            font-size: 16px;\n            line-height: 16px;\n        }\n\n        &-webkit-autofill {\n            -webkit-box-shadow: 0 0 0 1000px white inset !important;\n        }\n    }\n'], ['\n    margin: 44px auto 0;\n    padding: 0;\n    width: 100%;\n    position: relative;\n    border: none;\n    outline: none;\n    box-shadow: none;\n\n    input {\n        height: ', ';\n        width: 100%;\n        display: block;\n        box-sizing: border-box;\n        padding: 17px 45px 17px 16px;\n        border-radius: 5px;\n        background: ', ';\n        position: relative;\n        box-shadow: none;\n        color: ', ';\n        opacity: 1;\n        font-size: 16px;\n        line-height: 16px;\n        overflow: hidden;\n        outline: none;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        font-family: ', ';\n        ', ';\n\n        &:focus,\n        &:hover {\n            font-size: 16px;\n            ', ';\n            outline: none;\n            box-shadow: none;\n        }\n\n        &:disabled {\n            color: ', ';\n            border: none;\n        }\n\n        &::placeholder {\n            font-size: 16px;\n            line-height: 16px;\n            color: ', ';\n            outline: none;\n            box-shadow: none;\n        }\n\n        &[type=\'password\'] {\n            font-family: ', ';\n            -webkit-text-security: disc;\n            font-size: 16px;\n            line-height: 16px;\n        }\n\n        &-webkit-autofill {\n            -webkit-box-shadow: 0 0 0 1000px white inset !important;\n        }\n    }\n']),
    _templateObject3$b = taggedTemplateLiteral(['\n    position: absolute;\n    top: -20px;\n    left: 8px;\n    font-size: 14px;\n    color: ', ';\n    line-height: normal;\n'], ['\n    position: absolute;\n    top: -20px;\n    left: 8px;\n    font-size: 14px;\n    color: ', ';\n    line-height: normal;\n']),
    _templateObject4$9 = taggedTemplateLiteral(['\n    position: absolute;\n    right: 25px;\n    top: 20px;\n    cursor: ', ';\n    color: ', ';\n    font-size: 14px;\n    line-height: normal;\n'], ['\n    position: absolute;\n    right: 25px;\n    top: 20px;\n    cursor: ', ';\n    color: ', ';\n    font-size: 14px;\n    line-height: normal;\n']),
    _templateObject5$8 = taggedTemplateLiteral(['\n    margin-top: 10px;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    height: 6px;\n    box-sizing: border-box;\n'], ['\n    margin-top: 10px;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    height: 6px;\n    box-sizing: border-box;\n']),
    _templateObject6$8 = taggedTemplateLiteral(['\n    background: ', ';\n    width: 32%;\n    height: 100%;\n    border-radius: 3px;\n'], ['\n    background: ', ';\n    width: 32%;\n    height: 100%;\n    border-radius: 3px;\n']),
    _templateObject7$7 = taggedTemplateLiteral(['\n    margin: ', ';\n    font-size: 12px;\n    line-height: normal;\n    color: #db1c1b;\n'], ['\n    margin: ', ';\n    font-size: 12px;\n    line-height: normal;\n    color: #db1c1b;\n']),
    _templateObject8$7 = taggedTemplateLiteral(['\n    width: 100%;\n    border: 1px solid ', ';\n    background: ', ';\n    font-size: 16px;\n    font-weight: 400;\n    color: ', ';\n    text-align: center;\n    border-radius: 8px;\n    outline: none;\n    padding: 16px 0;\n    margin-top: 13px;\n    cursor: pointer;\n    box-shadow: none;\n\n    &:hover {\n        background-color: #dee2ef;\n\n        color: ', ';\n    }\n'], ['\n    width: 100%;\n    border: 1px solid ', ';\n    background: ', ';\n    font-size: 16px;\n    font-weight: 400;\n    color: ', ';\n    text-align: center;\n    border-radius: 8px;\n    outline: none;\n    padding: 16px 0;\n    margin-top: 13px;\n    cursor: pointer;\n    box-shadow: none;\n\n    &:hover {\n        background-color: #dee2ef;\n\n        color: ', ';\n    }\n']),
    _templateObject9$6 = taggedTemplateLiteral(['\n    background: ', ';\n    top: -4px;\n    position: relative;\n    border-width: 0 1px 1px;\n    border-style: solid;\n    ', ';\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    padding: 0 16px;\n    color: ', ';\n'], ['\n    background: ', ';\n    top: -4px;\n    position: relative;\n    border-width: 0 1px 1px;\n    border-style: solid;\n    ', ';\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    padding: 0 16px;\n    color: ', ';\n']);

var REQUIRED = 'required';
var ALPHABETIC = 'alphabetic';
var NO_SPECIAL = 'no-special';
var NUMERIC = 'numeric';
var EMAIL = 'email';
var MIN = 'min';
var MIN_TEXT = 'min-text';
var MININMUM_KR = 'minimum-kr';
var WITHDRAW_MAX_AMOUNT = 'withdraw-max-amount';
var BALANCE = 'balance';
var MIN_NUMBER = 'min-number';
var MAX = 'max';
var MAXIMUM_KR = 'maximum-kr';
var MAX_NUMBER = 'max-number';
var NO_SPACES = 'nospaces';
var PASSWORD = 'password';
var USERNAME = 'username';
var FULL_NAME = 'full-name';
var SAME_AS = 'sameas';

var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var alphabeticRegex = /^[a-zA-Z æøåöÆØÅÖ]+$/;
var alphaNumeric = /^[0-9a-zA-ZæøåöÆØÅÖ ]*$/;
var numericRegex = /^\d+$/;
var passwordRegex = /^(([a-z]?)(?=.*[A-Za-zÀ-ÖØ-öø-ÿ])(?=.*[0-9]))(?=.{10,})/;
var fullNameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿÆØÅæøåœšâáäšĸāēėūīįōăęıńűų'’, -]+$/;
var disallowedChars = /[^!&;%\\]/g;
var cutEmptyValues = function cutEmptyValues(value) {
    return value.replace(/\s/g, '');
};

/**
 * @param state
 * @param focus
 * @param balance {number}
 * @param theme {object}
 * @param successBorderColor {state}
 * @return {string}
 */
var getInputBorderColor = function getInputBorderColor(state, focus, theme, balance, successBorderColor) {
    var result = focus ? theme.colors.primaryAction : theme.colors.colorBorderPrimaryDefault;

    if (balance > 0) {
        result = theme.colors.colorBorderPrimaryDefault;
    }

    if (state === 'error') {
        result = '#DB1C1B';
    } else if (state === 'success') {
        result = successBorderColor || '#31D300';
    }
    return result;
};

var BottomLabel = styled.p(_templateObject$j, function (_ref) {
    var bottomLabelMargin = _ref.bottomLabelMargin;
    return bottomLabelMargin || '10px 0 20px 8px';
}, function (props) {
    return props.theme.colors.primaryAction;
});

var InputWrapper$2 = styled.div(_templateObject2$f, function (props) {
    return props.height ? props.height : 'auto';
}, function (props) {
    return props.bgColor ? props.bgColor : props.theme.colors.bgDarker;
}, function (props) {
    return props.theme.colors.primary;
}, function (props) {
    return props.theme.fontFamily;
}, function (props) {
    return 'border: 1px solid ' + getInputBorderColor(props.borderState, false, props.theme, props.balance, props.successBorderColor);
}, function (props) {
    return ' border: 1px solid ' + getInputBorderColor(props.borderState, true, props.theme, props.balance, props.successBorderColor);
}, function (props) {
    return props.theme.colors.primaryAction;
}, function (props) {
    return props.theme.colors.primary;
}, function (props) {
    return props.theme.fontFamily;
});
var Title$1 = styled.span(_templateObject3$b, function (props) {
    return props.theme.colors.primary;
});
var AltLabel = styled.div(_templateObject4$9, function (_ref2) {
    var cursor = _ref2.cursor;
    return cursor || 'auto';
}, function (props) {
    return props.theme.colors.primaryAction;
});
var PasswordIndicator = styled.div(_templateObject5$8);
var IndicatorElement = styled.div(_templateObject6$8, function (props) {
    return props.active ? props.theme.colors.active : props.theme.colors.bgDarker;
});
var Error$1 = styled.p(_templateObject7$7, function (props) {
    return props.disableErrorBottomMargin ? '10px 0 0 8px' : '10px 0 20px 8px';
});
var InputButton = styled.button(_templateObject8$7, function (props) {
    return props.theme.colors.primaryAction;
}, function (props) {
    return props.theme.colors.bgDarker;
}, function (props) {
    return props.theme.colors.basic;
}, function (props) {
    return props.theme.name === 'default' ? props.theme.colors.basic : props.theme.colors.bg;
});
var InputExpander = styled.div(_templateObject9$6, function (props) {
    return props.theme.colors.bgDarker;
}, function (props) {
    return 'border-color: ' + getInputBorderColor(props.borderState, false, props.theme);
}, function (props) {
    return props.theme.colors.secondary;
});

var themesMap$2 = {
    default: defaultTheme$1,
    dark: dark$1
};

var ValidatingInput = function ValidatingInput(props) {
    var _props$type = props.type,
        type = _props$type === undefined ? 'text' : _props$type,
        title = props.title,
        bottomLabel = props.bottomLabel,
        altLabel = props.altLabel,
        _props$altLabelClickH = props.altLabelClickHandler,
        altLabelClickHandler = _props$altLabelClickH === undefined ? null : _props$altLabelClickH,
        _props$regex = props.regex,
        regex = _props$regex === undefined ? '' : _props$regex,
        _props$placeholder = props.placeholder,
        placeholder = _props$placeholder === undefined ? '' : _props$placeholder,
        _props$passwordStreng = props.passwordStrength,
        passwordStrength = _props$passwordStreng === undefined ? null : _props$passwordStreng,
        _props$onChangeHandle = props.onChangeHandler,
        onChangeHandler = _props$onChangeHandle === undefined ? function () {} : _props$onChangeHandle,
        _props$onCheckValue = props.onCheckValue,
        onCheckValue = _props$onCheckValue === undefined ? null : _props$onCheckValue,
        _props$validate = props.validate,
        validate = _props$validate === undefined ? '' : _props$validate,
        _props$validateOnChan = props.validateOnChange,
        validateOnChange = _props$validateOnChan === undefined ? false : _props$validateOnChan,
        _props$name = props.name,
        name = _props$name === undefined ? '' : _props$name,
        _props$value = props.value,
        value = _props$value === undefined ? '' : _props$value,
        _props$inputButton = props.inputButton,
        inputButton = _props$inputButton === undefined ? null : _props$inputButton,
        _props$inputButtonCli = props.inputButtonClickHandler,
        inputButtonClickHandler = _props$inputButtonCli === undefined ? null : _props$inputButtonCli,
        _props$showInputButto = props.showInputButton,
        showInputButton = _props$showInputButto === undefined ? null : _props$showInputButto,
        _props$autoFocus = props.autoFocus,
        autoFocus = _props$autoFocus === undefined ? false : _props$autoFocus,
        _props$disabled = props.disabled,
        disabled = _props$disabled === undefined ? false : _props$disabled,
        _props$prefix = props.prefix,
        prefix = _props$prefix === undefined ? '' : _props$prefix,
        _props$thousandSepara = props.thousandSeparator,
        thousandSeparator = _props$thousandSepara === undefined ? false : _props$thousandSepara,
        _props$format = props.format,
        format = _props$format === undefined ? null : _props$format,
        _props$isLightInput = props.isLightInput,
        isLightInput = _props$isLightInput === undefined ? false : _props$isLightInput,
        _props$disableErrorBo = props.disableErrorBottomMargin,
        disableErrorBottomMargin = _props$disableErrorBo === undefined ? false : _props$disableErrorBo,
        _props$bottomLabelMar = props.bottomLabelMargin,
        bottomLabelMargin = _props$bottomLabelMar === undefined ? '' : _props$bottomLabelMar,
        _props$mask = props.mask,
        mask = _props$mask === undefined ? '' : _props$mask,
        _props$onFocus = props.onFocus,
        _onFocus = _props$onFocus === undefined ? function () {} : _props$onFocus,
        _props$allowEmptyForm = props.allowEmptyFormatting,
        allowEmptyFormatting = _props$allowEmptyForm === undefined ? false : _props$allowEmptyForm,
        _props$allowFirstZero = props.allowFirstZero,
        allowFirstZero = _props$allowFirstZero === undefined ? true : _props$allowFirstZero,
        _props$min = props.min,
        min = _props$min === undefined ? '' : _props$min,
        _props$max = props.max,
        max = _props$max === undefined ? '' : _props$max,
        _props$minNumber = props.minNumber,
        minNumber = _props$minNumber === undefined ? '' : _props$minNumber,
        _props$maxNumber = props.maxNumber,
        maxNumber = _props$maxNumber === undefined ? '' : _props$maxNumber,
        _props$balance = props.balance,
        balance = _props$balance === undefined ? 0 : _props$balance,
        _props$sameAs = props.sameAs,
        sameAs = _props$sameAs === undefined ? '' : _props$sameAs,
        _props$setValid = props.setValid,
        setValid = _props$setValid === undefined ? '' : _props$setValid,
        _props$numberPassword = props.numberPassword,
        numberPassword = _props$numberPassword === undefined ? false : _props$numberPassword,
        _props$pattern = props.pattern,
        pattern = _props$pattern === undefined ? '' : _props$pattern,
        _props$styles = props.styles,
        styles = _props$styles === undefined ? {
        InputWrapper: {}
    } : _props$styles,
        _props$errorMessage = props.errorMessage,
        errorMessage = _props$errorMessage === undefined ? '' : _props$errorMessage,
        _props$forwardedRef = props.forwardedRef,
        forwardedRef = _props$forwardedRef === undefined ? function () {} : _props$forwardedRef,
        _props$autoComplete = props.autoComplete,
        autoComplete = _props$autoComplete === undefined ? 'false' : _props$autoComplete,
        role = props.role,
        _props$shouldRevalida = props.shouldRevalidateOnBlur,
        shouldRevalidateOnBlur = _props$shouldRevalida === undefined ? function () {
        return true;
    } : _props$shouldRevalida,
        _props$inputExpanderS = props.inputExpanderStates,
        inputExpanderStates = _props$inputExpanderS === undefined ? [] : _props$inputExpanderS,
        _props$inputExpanderC = props.inputExpanderContent,
        inputExpanderContent = _props$inputExpanderC === undefined ? function (borderState) {} : _props$inputExpanderC,
        _props$theme = props.theme,
        theme = _props$theme === undefined ? 'default' : _props$theme,
        successBorderColor = props.successBorderColor;

    var _useState = useState(''),
        _useState2 = slicedToArray(_useState, 2),
        isValid = _useState2[0],
        setIsValid = _useState2[1];

    var _useState3 = useState(''),
        _useState4 = slicedToArray(_useState3, 2),
        error = _useState4[0],
        setError = _useState4[1];

    var inputRef = useRef(null);
    var inputCustomRef = useRef(null);
    var currentTheme = themesMap$2[theme];

    var parseFirstName = function parseFirstName(fullName) {
        fullName = fullName.trim();
        var lastIndex = fullName.lastIndexOf(' ');
        return fullName.substring(0, lastIndex);
    };

    var parseLastName = function parseLastName(fullName) {
        var split = fullName.trim().split(' ');
        return split[split.length - 1];
    };

    useEffect(function () {
        setTimeout(function () {
            if (autoFocus) {
                if (inputCustomRef.current) {
                    inputCustomRef.current.focus();
                } else if (inputRef.current) {
                    inputRef.current.focus();
                }
            }
        }, 500); // makes some delay for animation modal (otherwise autofocus brakes the animation)
        if (value) {
            validateValue(value);
        }
        if (errorMessage.length > 0) {
            setError(errorMessage);
        }
        forwardedRef(inputRef);
        setIsValid(setValid);
    }, []);

    useEffect(function () {
        setIsValid(setValid);
        setError(errorMessage);
    }, [setValid, errorMessage]);

    var validateValue = function validateValue(value) {
        var error = validateInput(value);
        if (onCheckValue && typeof onCheckValue === 'function') {
            onCheckValue(error);
        }
    };

    useEffect(function () {
        validateOnChange && value.length > 0 && validateValue(value);
    }, [value]);

    var validateInput = function validateInput(value) {
        var valid = '';
        if (value !== '') {
            valid = true;
        }
        if (!regex) {
            if (validate.indexOf(PASSWORD) > -1 && !passwordRegex.test(value)) {
                valid = false;
                setError('Kodeord skal minimum indeholde 1 stort bogstav, 1 tal og 10 tegn');
            }
            if (validate.indexOf(PASSWORD) > -1 && value.match(disallowedChars) && value.match(disallowedChars).length !== value.length) {
                valid = false;
                setError('Kodeord må ikke indeholde ! & ; \\ %');
            }
            if (validate.indexOf(USERNAME) > -1 && value.match(disallowedChars) && value.match(disallowedChars).length !== value.length) {
                valid = false;
                setError('Brugernavn må ikke indeholde ! & ; \\ %');
            }
            if (validate.indexOf(ALPHABETIC) > -1 && !alphabeticRegex.test(value)) {
                valid = false;
                setError('Feltet må kun indeholde bogstaver');
            }
            if (validate.indexOf(FULL_NAME) > -1 && !fullNameRegex.test(value)) {
                valid = false;
                setError('Feltet må kun indeholde bogstaver');
            }

            if (validate.indexOf(FULL_NAME) > -1) {
                var fullName = value.trim().split(' ').filter(function (s) {
                    return Boolean(s);
                });

                var firstName = parseFirstName(value);
                var lastName = parseLastName(value);

                if (!fullNameRegex.test(value)) {
                    valid = false;
                    setError('Feltet må kun indeholde bogstaver');
                }

                // first name or last name can contain "-",
                // but it's worth to check if it's not the first or last
                // character in the f / l name. Also checking the
                // f / l name length separately
                // TODO: rework to regex ^[a-zA-zæøåöÆØÅÖ-]{2,} ? [a-zA-zæøåöÆØÅÖ-]{2,} (no fully working)
                if (fullName.length < 2 || // as array
                fullName.length > 4 || firstName.length < 2 || // as string
                lastName.length < 2 || // as string
                firstName[0] === '-' || firstName[firstName.length - 1] === '-' || lastName[0] === '-' || lastName[lastName.length - 1] === '-') {
                    valid = false;
                    setError('Har du husket dit efternavn?');
                }
            }

            if (validate.indexOf(NUMERIC) > -1 && !numericRegex.test(value)) {
                valid = false;
                setError('Feltet bør kun indeholde cifre');
            }
            if (validate.indexOf(NO_SPECIAL) > -1 && !alphaNumeric.test(value)) {
                valid = false;
                setError('Feltet bør kun indeholde bogstaver og cifre');
            }
            if (validate.indexOf(EMAIL) > -1 && !emailRegex.test(value)) {
                valid = false;
                setError('Ugyldig email - har du husket @ og .dk eller .com?');
            }

            if (validate.indexOf(NO_SPACES) > -1 && !emailRegex.test(value)) {
                valid = false;
                setError('Ugyldig værdi');
            }
            if (validate.indexOf(MIN) > -1 && min && value.length < min) {
                valid = false;
                setError('Skal best\xE5 af ' + min + ' tal');
            }
            if (validate.indexOf(MIN_TEXT) > -1 && min && value.length < min) {
                valid = false;
                setError('Minimum ' + min + ' bogstaver');
            }
            if (validate.indexOf(MAX) > -1 && max && value.length > max) {
                valid = false;
                setError('Maximum ' + max + ' tegn');
            }
            if (validate.indexOf(MIN_NUMBER) > -1 && value < minNumber) {
                valid = false;
                setError('Minimum ' + minNumber);
            }
            if (validate.indexOf(MAX_NUMBER) > -1 && value > maxNumber) {
                valid = false;
                setError('Maximum ' + maxNumber);
            }
            if (validate.indexOf(MININMUM_KR) > -1 && exportNumberFromStringWithoutComma(value) < minNumber) {
                valid = false;
                setError('Minimum ' + formatDenmarkCurrency(minNumber, 0) + ' kr.');
            }
            if (validate.indexOf(BALANCE) > -1 && exportNumberFromStringWithoutComma(value) > balance) {
                valid = false;
                setError('Saldoen er for lav');
            }
            if (validate.indexOf(MAXIMUM_KR) > -1 && value > maxNumber) {
                valid = false;
                setError('Maximum ' + formatDenmarkCurrency(maxNumber, 0) + ' kr.');
            }
            if (validate.indexOf(WITHDRAW_MAX_AMOUNT) > -1 && exportNumberFromStringWithoutComma(value) > maxNumber) {
                valid = false;
                setError('Du kan maks. udbetale ' + formatDenmarkCurrency(maxNumber, 0) + ' kr.');
            }
            if (validate.indexOf(REQUIRED) > -1 && value === '') {
                valid = false;
                setError('Skal udfyldes');
            }
            if (valid) {
                setError('');
            }
            if (validate.indexOf(SAME_AS) > -1 && value !== sameAs) {
                valid = false;
                setError('Kodeordene er ikke ens, pr\xF8v venligst igen.');
            }

            setIsValid(valid);
            return { name: name, value: !valid };
        }
    };

    var onBlurHandler = function onBlurHandler(val, e) {
        if (shouldRevalidateOnBlur(e.relatedTarget)) {
            validateValue(val);
        }
    };

    var changeHandler = function changeHandler(value, event) {
        var val = value;

        if (!allowFirstZero) {
            if (/^0/.test(val)) {
                val = val.replace(/^0+/, '');
            }
        }
        if (pattern) {
            val = value.replace(pattern, '');
        }
        if (error) {
            validateValue(val, event);
        }
        onChangeHandler(val);
    };
    var onInputButtonClickHandler = function onInputButtonClickHandler() {
        inputButtonClickHandler();
        inputRef.current && inputRef.current.focus && inputRef.current.focus();
    };

    var showInputExpander = function showInputExpander() {
        var stateToShow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var borderState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        return stateToShow.includes(borderState);
    };

    var getInputByType = function getInputByType() {
        if (type === 'number') {
            return React.createElement(NumberFormat, {
                value: value,
                prefix: prefix,
                format: format,
                onValueChange: function onValueChange(values, _ref3) {
                    var event = _ref3.event;

                    changeHandler(values.value, event);
                },
                onBlur: function onBlur(e) {
                    // for some reasons NumberFormat sometimes triggers double events with no event argument
                    if (e) {
                        onBlurHandler(value, e);
                    }
                },
                placeholder: placeholder,
                thousandSeparator: thousandSeparator,
                allowEmptyFormatting: allowEmptyFormatting,
                type: 'text',
                mask: mask,
                autoComplete: autoComplete,
                role: role,
                getInputRef: inputCustomRef // use getInputRef in order to manage ref()
                , ref: inputRef,
                onFocus: function onFocus(e) {
                    _onFocus(e, validateValue);
                }
            });
        } else {
            return React.createElement('input', {
                disabled: disabled,
                ref: inputRef,
                value: value,
                onChange: function onChange(e) {
                    changeHandler(e.target.value, e);
                },
                onBlur: function onBlur(e) {
                    onBlurHandler(e.target.value, e);
                },
                autoComplete: autoComplete,
                onFocus: function onFocus(e) {
                    _onFocus(e, validateValue);
                },
                role: role,
                placeholder: placeholder,
                type: type
            });
        }
    };
    var borderState = isValid === '' ? '' : isValid ? 'success' : 'error';
    return React.createElement(
        ThemeProvider,
        { theme: currentTheme },
        React.createElement(
            InputWrapper$2,
            {
                borderState: borderState,
                numberPassword: numberPassword,
                style: styles.InputWrapper,
                balance: balance,
                successBorderColor: successBorderColor,
                isLightInput: isLightInput
            },
            title && React.createElement(
                Title$1,
                null,
                title
            ),
            getInputByType(),
            showInputExpander(inputExpanderStates, borderState) && React.createElement(
                InputExpander,
                { borderState: borderState },
                inputExpanderContent(borderState)
            ),
            altLabel && React.createElement(
                AltLabel,
                {
                    cursor: altLabelClickHandler && typeof altLabelClickHandler === 'function' ? 'pointer' : 'auto',
                    onClick: altLabelClickHandler
                },
                altLabel
            ),
            inputButton && showInputButton && React.createElement(
                InputButton,
                { onClick: onInputButtonClickHandler },
                inputButton
            ),
            passwordStrength !== null ? React.createElement(
                PasswordIndicator,
                null,
                Array.from({ length: 3 }).map(function (_, index) {
                    return React.createElement(IndicatorElement, {
                        key: index,
                        active: passwordStrength > 0 && index + 1 <= passwordStrength
                    });
                })
            ) : null,
            error ? React.createElement(
                Error$1,
                { disableErrorBottomMargin: disableErrorBottomMargin },
                error
            ) : React.createElement(
                BottomLabel,
                { bottomLabelMargin: bottomLabelMargin },
                bottomLabel
            )
        )
    );
};

ValidatingInput.propTypes = {
    type: PropTypes.string,
    placeholder: PropTypes.string,
    balance: PropTypes.number,
    title: PropTypes.string,
    bottomLabel: PropTypes.any,
    altLabel: PropTypes.string,
    altLabelClickHandler: PropTypes.func,
    regex: PropTypes.any,
    isValid: PropTypes.bool,
    passwordStrength: PropTypes.number,
    onChangeHandler: PropTypes.func,
    onCheckValue: PropTypes.func,
    validate: PropTypes.string,
    setValid: PropTypes.bool,
    name: PropTypes.string,
    value: PropTypes.any,
    prefix: PropTypes.any,
    format: PropTypes.any,
    mask: PropTypes.any,
    thousandSeparator: PropTypes.bool,
    disableErrorBottomMargin: PropTypes.bool,
    bottomLabelMargin: PropTypes.string,
    autoFocus: PropTypes.bool,
    allowEmptyFormatting: PropTypes.bool,
    allowFirstZero: PropTypes.bool,
    disabled: PropTypes.bool,
    isLightInput: PropTypes.bool,
    min: PropTypes.number,
    max: PropTypes.number,
    minNumber: PropTypes.any,
    maxNumber: PropTypes.any,
    pattern: PropTypes.any,
    errorMessage: PropTypes.string,
    numberBlurRef: PropTypes.func,
    inputExpanderStates: PropTypes.arrayOf(PropTypes.oneOf(['success', 'error', ' '])),
    inputExpanderContent: PropTypes.func,
    successBorderColor: PropTypes.string,
    bgColor: PropTypes.string
};

var themesMap$3 = {
    default: defaultTheme,
    dark: dark

    /**
     * @param theme {string} select theme
     * @param site {string} project name
     * @param oldAPI {boolean} old API path
     * @param closeAction {function} close button handler
     * @param userProfile {object} User data
     * @param successHandler {function} handle success action
     * @param onError {function} handle error action
     * */
};var RestorePassword = function RestorePassword(_ref) {
    var _ref$theme = _ref.theme,
        theme = _ref$theme === undefined ? 'default' : _ref$theme,
        _ref$site = _ref.site,
        site = _ref$site === undefined ? '' : _ref$site,
        _ref$oldAPI = _ref.oldAPI,
        oldAPI = _ref$oldAPI === undefined ? false : _ref$oldAPI,
        closeAction = _ref.closeAction,
        _ref$userProfile = _ref.userProfile,
        userProfile = _ref$userProfile === undefined ? {} : _ref$userProfile,
        successHandler = _ref.successHandler,
        onError = _ref.onError;

    var _useState = useState(userProfile),
        _useState2 = slicedToArray(_useState, 2),
        userData = _useState2[0],
        setUserData = _useState2[1];

    var _useState3 = useState(null),
        _useState4 = slicedToArray(_useState3, 2),
        passwordRef = _useState4[0],
        setPasswordRef = _useState4[1];

    var _useState5 = useState(true),
        _useState6 = slicedToArray(_useState5, 2),
        isPasswordHidden = _useState6[0],
        setIsPasswordHidden = _useState6[1];

    var _useState7 = useState(0),
        _useState8 = slicedToArray(_useState7, 2),
        passwordStrength = _useState8[0],
        setPasswordStrength = _useState8[1];

    var _useState9 = useState('Minimum 10 tegn'),
        _useState10 = slicedToArray(_useState9, 2),
        passwordHint = _useState10[0],
        setPasswordHint = _useState10[1];

    var _useState11 = useState({
        email: '',
        password: false,
        confirmPassword: false
    }),
        _useState12 = slicedToArray(_useState11, 2),
        errors = _useState12[0],
        setErrors = _useState12[1];

    var _useState13 = useState(false),
        _useState14 = slicedToArray(_useState13, 2),
        close = _useState14[0],
        setClose = _useState14[1];

    var _useState15 = useState(false),
        _useState16 = slicedToArray(_useState15, 2),
        loading = _useState16[0],
        setLoading = _useState16[1];

    var currentTheme = themesMap$3[theme];

    var isDataValid = userData.password && userData.confirmPassword && !errors.password && !errors.confirmPassword;

    var checkValue = function checkValue(error) {
        if (error) {
            setErrors(_extends({}, errors, defineProperty({}, error.name, error.value)));
        }
    };

    var showPassword = function showPassword() {
        setIsPasswordHidden(!isPasswordHidden);
    };

    var passwordChangeHandler = function passwordChangeHandler(value) {
        value = cutEmptyValues(value);
        var strength = 0;
        var hasNumber$$1 = /\d/;
        function hasUpperCase(str) {
            return str.toLowerCase() !== str;
        }

        if (value.length < 9) {
            setPasswordHint('Minimum 10 tegn');
        } else if (!hasUpperCase(value)) {
            setPasswordHint('Minimum ét STORT bogstav');
        } else if (!hasNumber$$1.test(value)) {
            setPasswordHint('Minimum ét tal');
        } else {
            setPasswordHint('');
        }

        if (hasNumber$$1.test(value)) strength = strength + 1;
        if (hasUpperCase(value)) strength = strength + 1;
        if (value.length >= 10) strength = strength + 1;

        setPasswordStrength(strength);
        setUserData(_extends({}, userData, { password: value }));
    };

    var onConfirmPasswordChange = function onConfirmPasswordChange(value) {
        setUserData(_extends({}, userData, { confirmPassword: value }));
    };

    var onClose = function onClose(trackAction) {
        setClose(true);
        setTimeout(function () {
            closeAction();
            if (trackAction) {
                window.dataLayer.push({
                    event: 'restorePasswordClose'
                });
            }
        }, 200);
    };

    var buttonClickHandler = function buttonClickHandler() {
        setLoading(true);
        if (isDataValid) {
            restorePassword(site, loading, function (value) {
                return setLoading(value);
            }, oldAPI, userData.password, userData.confirmPassword, function () {
                successHandler();
                onClose();
            }, onError);
        } else {
            setLoading(false);

            passwordRef.current && passwordRef.current.blur && passwordRef.current.blur();
        }
    };

    return React.createElement(
        ThemeProvider,
        { theme: currentTheme },
        React.createElement(
            Wrapper$5,
            {
                bg: currentTheme.colors.bg,
                close: close,
                key: 'close-animation-' + close
            },
            React.createElement(TopBarLogin, {
                title: 'Opret et nyt kodeord',
                currentTheme: currentTheme,
                closeAction: function closeAction() {
                    return onClose(true);
                }
            }),
            React.createElement(
                MiddleWrapper,
                { color: currentTheme.colors.basic },
                React.createElement(
                    Text,
                    { style: { marginTop: 0 } },
                    'Indtast et nyt kodeord for din konto nedenfor. Husk at v\xE6lge en st\xE6rk kode for at beskytte dine oplysninger.'
                ),
                React.createElement(ValidatingInput, {
                    type: 'text',
                    title: 'Brugernavn',
                    name: 'userName',
                    value: userData.userName,
                    disabled: true,
                    theme: theme
                }),
                React.createElement(ValidatingInput, {
                    autoFocus: true,
                    onChangeHandler: passwordChangeHandler,
                    onCheckValue: checkValue,
                    type: isPasswordHidden ? 'password' : 'text',
                    value: userData.password,
                    title: 'Nyt kodeord',
                    autoComplete: 'new-password',
                    validate: 'required, password',
                    min: 10,
                    max: 15,
                    name: 'password',
                    bottomLabel: passwordHint,
                    altLabel: isPasswordHidden ? 'Vis' : 'Skjul',
                    altLabelClickHandler: showPassword,
                    passwordStrength: passwordStrength,
                    forwardedRef: function forwardedRef(ref) {
                        return setPasswordRef(ref);
                    },
                    theme: theme
                }),
                React.createElement(ValidatingInput, {
                    onChangeHandler: onConfirmPasswordChange,
                    onCheckValue: checkValue,
                    type: isPasswordHidden ? 'password' : 'text',
                    value: userData.confirmPassword,
                    title: 'Gentag ny kodeord',
                    autoComplete: 'new-password',
                    validate: 'required, sameas',
                    sameAs: userData.password,
                    min: 10,
                    max: 15,
                    disabled: !!errors.password || !userData.password,
                    name: 'confirmPassword',
                    altLabel: isPasswordHidden ? 'Vis' : 'Skjul',
                    altLabelClickHandler: showPassword,
                    theme: theme
                })
            ),
            React.createElement(
                ButtonsArea,
                { bg: currentTheme.colors.bg },
                React.createElement(
                    TextWrapper$1,
                    null,
                    React.createElement(Divider$2, { color: currentTheme.colors.divider })
                ),
                React.createElement(
                    ButtonWrapper,
                    null,
                    React.createElement(
                        AcceptButton,
                        {
                            color: currentTheme.colors.basic,
                            activeColor: currentTheme.colors.activeLoginColor,
                            disableColor: currentTheme.colors.disabledLoginColor,
                            onClick: function onClick() {
                                return buttonClickHandler();
                            }
                        },
                        React.createElement(
                            Text,
                            {
                                color: currentTheme.colors.basic,
                                bold: currentTheme.bold,
                                condensed: currentTheme.condensed,
                                align: 'center'
                            },
                            'Gem'
                        ),
                        loading && React.createElement(Spinner$1, { color: '#fff', size: 'md' })
                    )
                )
            )
        )
    );
};

RestorePassword.propTypes = {
    theme: PropTypes.string,
    site: PropTypes.string,
    oldAPI: PropTypes.bool,
    closeAction: PropTypes.func,
    userProfile: PropTypes.object,
    successHandler: PropTypes.func,
    onError: PropTypes.func
};

var themesMap$4 = {
    default: defaultTheme,
    dark: dark
    /*
    LoginDesktop is deprecated, please use ./Login instead
     */
};var LoginDesktop = function LoginDesktop(_ref) {
    var _ref$closeAction = _ref.closeAction,
        closeAction = _ref$closeAction === undefined ? function () {} : _ref$closeAction,
        _ref$stayOnPrevPage = _ref.stayOnPrevPage,
        stayOnPrevPage = _ref$stayOnPrevPage === undefined ? false : _ref$stayOnPrevPage,
        _ref$beforeLogin = _ref.beforeLogin,
        beforeLogin = _ref$beforeLogin === undefined ? function () {} : _ref$beforeLogin,
        _ref$theme = _ref.theme,
        theme = _ref$theme === undefined ? 'default' : _ref$theme,
        _ref$site = _ref.site,
        site = _ref$site === undefined ? '' : _ref$site,
        _ref$oldAPI = _ref.oldAPI,
        oldAPI = _ref$oldAPI === undefined ? false : _ref$oldAPI,
        _ref$loginByUsername = _ref.loginByUsername,
        loginByUsername = _ref$loginByUsername === undefined ? function () {} : _ref$loginByUsername,
        _ref$isFirstLogin = _ref.isFirstLogin,
        isFirstLogin = _ref$isFirstLogin === undefined ? true : _ref$isFirstLogin,
        _ref$showResetPasswor = _ref.showResetPassword,
        showResetPassword = _ref$showResetPasswor === undefined ? false : _ref$showResetPasswor;

    var _useState = useState(false),
        _useState2 = slicedToArray(_useState, 2),
        close = _useState2[0],
        setClose = _useState2[1];

    var _useState3 = useState(defineProperty({}, LOGIN_TYPES.MIT_ID, false)),
        _useState4 = slicedToArray(_useState3, 2),
        loading = _useState4[0],
        setLoading = _useState4[1];

    var currentTheme = themesMap$4[theme];

    var loginHandler = function loginHandler(type) {
        beforeLogin(type);

        if (stayOnPrevPage) {
            localStorage.setItem('stay_on_prev_page', window.location.pathname);
        }
        login(type, site, loading, function (value) {
            return setLoading(value);
        }, oldAPI);
    };

    var forgotPassword = function forgotPassword() {
        loginHandler(LOGIN_TYPES.MIT_ID);
    };

    return React.createElement(
        Wrapper$6,
        {
            close: close,
            key: 'close-animation-' + close,
            backgroundColor: currentTheme.colors.bg
        },
        React.createElement(
            StyledModalTopbar$1,
            { color: currentTheme.colors.borderColor },
            React.createElement(
                Title,
                {
                    color: currentTheme.colors.basic,
                    condensed: currentTheme.condensed
                },
                'Log ind'
            ),
            React.createElement(
                CloseButton,
                {
                    onClick: function onClick() {
                        setClose(true);
                        setTimeout(function () {
                            closeAction();
                        }, 200);
                    }
                },
                React.createElement(Icon, { size: 'sm', src: cross, color: '#9198AA' })
            )
        ),
        React.createElement(
            MethodWrapper,
            null,
            !isFirstLogin ? React.createElement(
                Fragment,
                null,
                React.createElement(
                    LoginWrapper$1,
                    { style: { margin: '50px 0 30px' } },
                    React.createElement(UsernameLogin, {
                        currentTheme: currentTheme,
                        forgotPassword: forgotPassword,
                        loginHandler: loginByUsername,
                        showResetPassword: showResetPassword
                    })
                ),
                React.createElement(
                    TextWrapper$1,
                    null,
                    React.createElement(Divider$2, { color: currentTheme.colors.divider }),
                    React.createElement(
                        Text,
                        {
                            padding: '0 20px',
                            color: currentTheme.colors.primaryAction || '#9198AA',
                            condensed: currentTheme.condensed
                        },
                        'Eller log ind med digital signatur'
                    ),
                    React.createElement(Divider$2, { color: currentTheme.colors.divider })
                )
            ) : null,
            React.createElement(
                StyledLoginButton,
                {
                    onClick: function onClick() {
                        return loginHandler(LOGIN_TYPES.MIT_ID);
                    },
                    mitId: true
                },
                React.createElement(
                    ButtonContent,
                    null,
                    React.createElement(Icon, {
                        height: '14px',
                        width: '100%',
                        src: mitIdLogo,
                        color: 'white'
                    }),
                    React.createElement(
                        Text,
                        {
                            color: 'white',
                            bold: currentTheme.bold,
                            condensed: currentTheme.condensed,
                            align: 'center'
                        },
                        'Log ind med MitID'
                    ),
                    loading[LOGIN_TYPES.MIT_ID] && React.createElement(Spinner$1, { color: '#fff', size: 'md' })
                )
            )
        )
    );
};

LoginDesktop.propTypes = {
    closeAction: PropTypes.func.isRequired,
    stayOnPrevPage: PropTypes.bool,
    theme: PropTypes.string,
    site: PropTypes.string.isRequired,
    oldAPI: PropTypes.bool,
    loginByUsername: PropTypes.func.isRequired,
    isFirstLogin: PropTypes.bool,
    showResetPassword: PropTypes.bool
};

var _templateObject$k = taggedTemplateLiteral(['\n    padding: 0 23px;\n'], ['\n    padding: 0 23px;\n']),
    _templateObject2$g = taggedTemplateLiteral(['\n    padding: 25px 0;\n    margin: 0;\n    font-size: 16px;\n    font-family: ', ',\n        sans-serif;\n    color: ', ';\n'], ['\n    padding: 25px 0;\n    margin: 0;\n    font-size: 16px;\n    font-family: ', ',\n        sans-serif;\n    color: ', ';\n']),
    _templateObject3$c = taggedTemplateLiteral(['\n    margin-top: 40px;\n    height: 55px;\n    width: 100%;\n    box-shadow: none;\n    color: ', ';\n    background: ', ';\n    &:disabled {\n        background: ', ';\n        opacity: 0.6;\n        cursor: auto;\n    }\n'], ['\n    margin-top: 40px;\n    height: 55px;\n    width: 100%;\n    box-shadow: none;\n    color: ', ';\n    background: ', ';\n    &:disabled {\n        background: ', ';\n        opacity: 0.6;\n        cursor: auto;\n    }\n']);

var ContentWrapper$1 = styled.div(_templateObject$k);
var Description = styled.p(_templateObject2$g, function (_ref) {
    var condensed = _ref.condensed;
    return condensed ? 'Roboto Condensed' : 'inherit';
}, function (_ref2) {
    var color = _ref2.color;
    return color || '#333';
});

var ConfirmButton = styled(OpretBtn)(_templateObject3$c, function (_ref3) {
    var color = _ref3.color;
    return color || '#333333';
}, function (_ref4) {
    var activeColor = _ref4.activeColor;
    return activeColor || '#fbd600';
}, function (_ref5) {
    var disableColor = _ref5.disableColor;
    return disableColor || '#fff8cb';
});

var _templateObject$l = taggedTemplateLiteral(['\n    margin: 10px 0 20px 8px;\n    font-size: 12px;\n    color: #9198aa;\n'], ['\n    margin: 10px 0 20px 8px;\n    font-size: 12px;\n    color: #9198aa;\n']),
    _templateObject2$h = taggedTemplateLiteral(['\n    margin: 50px auto 0;\n    padding: 0;\n    width: 100%;\n    position: relative;\n\n    input {\n        padding: 17px 45px 17px 16px;\n        border-radius: 5px;\n        width: 100%;\n        box-sizing: border-box;\n        background: ', ';\n        position: relative;\n        ', ';\n        color: ', ';\n        -webkit-text-fill-color: ', ';\n        opacity: 1;\n        font-size: 16px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        &:focus,\n        &:hover {\n            ', ';\n        }\n        &::placeholder {\n            font-size: 16px;\n            color: ', ';\n        }\n    }\n'], ['\n    margin: 50px auto 0;\n    padding: 0;\n    width: 100%;\n    position: relative;\n\n    input {\n        padding: 17px 45px 17px 16px;\n        border-radius: 5px;\n        width: 100%;\n        box-sizing: border-box;\n        background: ', ';\n        position: relative;\n        ', ';\n        color: ', ';\n        -webkit-text-fill-color: ', ';\n        opacity: 1;\n        font-size: 16px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        &:focus,\n        &:hover {\n            ', ';\n        }\n        &::placeholder {\n            font-size: 16px;\n            color: ', ';\n        }\n    }\n']),
    _templateObject3$d = taggedTemplateLiteral(['\n    position: absolute;\n    top: -25px;\n    left: 8px;\n    font-size: 14px;\n    color: ', ';\n    font-family: ', ',\n        sans-serif;\n'], ['\n    position: absolute;\n    top: -25px;\n    left: 8px;\n    font-size: 14px;\n    color: ', ';\n    font-family: ', ',\n        sans-serif;\n']),
    _templateObject4$a = taggedTemplateLiteral(['\n    margin: 10px 0 20px 8px;\n    font-size: 12px;\n    color: #db1c1b;\n'], ['\n    margin: 10px 0 20px 8px;\n    font-size: 12px;\n    color: #db1c1b;\n']);

var REQUIRED$1 = 'required';
var NUMERIC$1 = 'numeric';
var MIN$1 = 'min';
var MAX$1 = 'max';

var numericRegex$1 = /^\d+$/;

/**
 *
 * @param state
 * @param focus
 * @param inputColor
 * @param focusColor
 * @return {string}
 */
var getInputBorderColor$1 = function getInputBorderColor(state) {
    var focus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var inputColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#eceff6';
    var focusColor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '#9198aa';

    var result = focus ? focusColor : inputColor;
    if (state === 'error') {
        result = '#DB1C1B';
    } else if (state === 'success') {
        result = '#31D300';
    }
    return result;
};

var BottomLabel$1 = styled.p(_templateObject$l);
var InputWrapper$3 = styled.div(_templateObject2$h, function (_ref) {
    var inputColor = _ref.inputColor;
    return inputColor || '#eceff6';
}, function (_ref2) {
    var borderState = _ref2.borderState,
        inputColor = _ref2.inputColor;
    return 'border: 1px solid ' + getInputBorderColor$1(borderState, false, inputColor);
}, function (_ref3) {
    var color = _ref3.color;
    return color || '#575c69';
}, function (_ref4) {
    var color = _ref4.color;
    return color || '#575c69';
}, function (_ref5) {
    var borderState = _ref5.borderState,
        inputColor = _ref5.inputColor,
        focusColor = _ref5.focusColor;
    return ' border: 1px solid ' + getInputBorderColor$1(borderState, true, inputColor, focusColor);
}, function (_ref6) {
    var color = _ref6.color;
    return color || '#575c69';
});
var Title$2 = styled.span(_templateObject3$d, function (_ref7) {
    var color = _ref7.color;
    return color || '#575c69';
}, function (_ref8) {
    var condensed = _ref8.condensed;
    return condensed ? 'Roboto Condensed' : 'inherit';
});
var Error$2 = styled.div(_templateObject4$a);
var CPRInput = function CPRInput(_ref9) {
    var title = _ref9.title,
        bottomLabel = _ref9.bottomLabel,
        _ref9$placeholder = _ref9.placeholder,
        placeholder = _ref9$placeholder === undefined ? '' : _ref9$placeholder,
        _ref9$onChangeHandler = _ref9.onChangeHandler,
        onChangeHandler = _ref9$onChangeHandler === undefined ? function () {} : _ref9$onChangeHandler,
        _ref9$onCheckValue = _ref9.onCheckValue,
        onCheckValue = _ref9$onCheckValue === undefined ? null : _ref9$onCheckValue,
        _ref9$validate = _ref9.validate,
        validate = _ref9$validate === undefined ? '' : _ref9$validate,
        _ref9$value = _ref9.value,
        value = _ref9$value === undefined ? '' : _ref9$value,
        _ref9$format = _ref9.format,
        format = _ref9$format === undefined ? null : _ref9$format,
        _ref9$mask = _ref9.mask,
        mask = _ref9$mask === undefined ? '' : _ref9$mask,
        _ref9$allowEmptyForma = _ref9.allowEmptyFormatting,
        allowEmptyFormatting = _ref9$allowEmptyForma === undefined ? false : _ref9$allowEmptyForma,
        _ref9$allowFirstZero = _ref9.allowFirstZero,
        allowFirstZero = _ref9$allowFirstZero === undefined ? true : _ref9$allowFirstZero,
        _ref9$min = _ref9.min,
        min = _ref9$min === undefined ? '' : _ref9$min,
        _ref9$max = _ref9.max,
        max = _ref9$max === undefined ? '' : _ref9$max,
        _ref9$pattern = _ref9.pattern,
        pattern = _ref9$pattern === undefined ? '' : _ref9$pattern,
        _ref9$textColor = _ref9.textColor,
        textColor = _ref9$textColor === undefined ? '#575c69' : _ref9$textColor,
        _ref9$inputColor = _ref9.inputColor,
        inputColor = _ref9$inputColor === undefined ? '#fff' : _ref9$inputColor,
        _ref9$focusColor = _ref9.focusColor,
        focusColor = _ref9$focusColor === undefined ? '#fff' : _ref9$focusColor,
        _ref9$condensed = _ref9.condensed,
        condensed = _ref9$condensed === undefined ? true : _ref9$condensed;

    var _useState = useState(''),
        _useState2 = slicedToArray(_useState, 2),
        isValid = _useState2[0],
        setIsValid = _useState2[1];

    var _useState3 = useState(''),
        _useState4 = slicedToArray(_useState3, 2),
        error = _useState4[0],
        setError = _useState4[1];

    var validateInput = function validateInput(value) {
        var valid = '';
        if (value !== '') {
            valid = true;
        }
        if (validate.indexOf(NUMERIC$1) > -1 && !numericRegex$1.test(value)) {
            valid = false;
            setError('Feltet bør kun indeholde cifre');
        }
        if (validate.indexOf(MIN$1) > -1 && min && value.length < min) {
            valid = false;
            setError('Skal best\xE5 af ' + min + ' tal');
        }
        if (validate.indexOf(MAX$1) > -1 && max && value.length > max) {
            valid = false;
            setError('Maximum ' + max + ' tegn');
        }
        if (validate.indexOf(REQUIRED$1) > -1 && value === '') {
            valid = false;
            setError('Skal udfyldes');
        }
        if (valid) {
            setError('');
        }
        setIsValid(valid);
        return valid;
    };
    var changeHandler = function changeHandler(value) {
        var val = value;
        if (!allowFirstZero) {
            if (/^0/.test(val)) {
                val.replace(/^0/, '');
            }
        }
        if (pattern) {
            val = value.replace(pattern, '');
        }
        var isValid = validateInput(val);
        onCheckValue(isValid);
        onChangeHandler(val);
    };

    return React.createElement(
        InputWrapper$3,
        {
            color: textColor,
            inputColor: inputColor,
            focusColor: focusColor,
            borderState: isValid === false ? 'error' : isValid === true ? 'success' : ''
        },
        title && React.createElement(
            Title$2,
            { color: textColor, condensed: condensed },
            title
        ),
        React.createElement(NumberFormat, {
            value: value,
            format: format,
            onValueChange: function onValueChange(values) {
                changeHandler(values.value);
            },
            placeholder: placeholder,
            allowEmptyFormatting: allowEmptyFormatting,
            type: 'text',
            mask: mask
        }),
        error ? React.createElement(
            Error$2,
            null,
            error
        ) : React.createElement(
            BottomLabel$1,
            null,
            bottomLabel
        )
    );
};

CPRInput.propTypes = {
    placeholder: PropTypes.string,
    title: PropTypes.string,
    bottomLabel: PropTypes.any,
    onChangeHandler: PropTypes.func,
    validate: PropTypes.string,
    value: PropTypes.any,
    format: PropTypes.any,
    mask: PropTypes.any,
    allowEmptyFormatting: PropTypes.bool,
    allowFirstZero: PropTypes.bool,
    min: PropTypes.any,
    max: PropTypes.any,
    pattern: PropTypes.any,
    textColor: PropTypes.string,
    inputColor: PropTypes.string,
    focusColor: PropTypes.string,
    condensed: PropTypes.bool
};

var themesMap$5 = {
    default: defaultTheme,
    dark: dark
};
var CPRConfirmation = function CPRConfirmation(_ref) {
    var onConfirm = _ref.onConfirm,
        onError = _ref.onError,
        _ref$idp = _ref.idp,
        idp = _ref$idp === undefined ? '' : _ref$idp,
        _ref$theme = _ref.theme,
        theme = _ref$theme === undefined ? 'default' : _ref$theme,
        _ref$oldAPI = _ref.oldAPI,
        oldAPI = _ref$oldAPI === undefined ? false : _ref$oldAPI,
        _ref$site = _ref.site,
        site = _ref$site === undefined ? '' : _ref$site;

    var _useState = useState(''),
        _useState2 = slicedToArray(_useState, 2),
        cpr = _useState2[0],
        setCpr = _useState2[1];

    var _useState3 = useState(false),
        _useState4 = slicedToArray(_useState3, 2),
        isValid = _useState4[0],
        setIsValid = _useState4[1];

    var _useState5 = useState(false),
        _useState6 = slicedToArray(_useState5, 2),
        loading = _useState6[0],
        setLoading = _useState6[1];

    var currentTheme = themesMap$5[theme];

    var idpText = {
        mitid: 'MitID',
        nemid: 'NemID'
    };

    var confirm = function confirm() {
        if (!loading) {
            setLoading(true);
            fetch(oldAPI ? '/rest/punter/mitidConfirmLogin' : getApiUrl() + '/punter/mitidConfirmLogin', {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify({ cpr: cpr, idp: idp, site: site }),
                credentials: 'include'
            }).then(function (res) {
                console.log(res, 'FIRST RESULT');
                return res.json();
            }).then(function (result) {
                console.log(result, 'Second RESULT');
                setLoading(false);
                if (result.success) {
                    onConfirm();
                } else {
                    onError(result.errorMessage || 'Something went wrong');
                }
            }).catch(function (e) {
                setLoading(false);
                onError(e);
                console.log(e, 'ERRROR');
            });
        }
    };
    return React.createElement(
        Wrapper$6,
        { backgroundColor: currentTheme.colors.bg },
        React.createElement(
            StyledModalTopbar$1,
            { color: currentTheme.colors.borderColor },
            React.createElement(
                Title,
                { color: currentTheme.colors.basic },
                'Bekr\xE6ft dit CPR-nummer'
            )
        ),
        React.createElement(
            ContentWrapper$1,
            null,
            React.createElement(
                Description,
                {
                    color: currentTheme.colors.basic,
                    condensed: currentTheme.condensed
                },
                'Da det er f\xF8rste gang at du logger ind med',
                ' ',
                idpText[idp] || '',
                ', har vi behov for at bekr\xE6fte dit CPR-nummer.'
            ),
            React.createElement(CPRInput, {
                onChangeHandler: function onChangeHandler(value) {
                    return setCpr(value);
                },
                onCheckValue: function onCheckValue(isValid) {
                    return setIsValid(isValid);
                },
                type: 'number',
                title: 'CPR-nummer',
                validate: 'required, numeric, min, max',
                value: cpr,
                name: 'cpr',
                min: '10',
                max: '10',
                bottomLabel: 'Dit CPR-nummer sikrer os, at du er over 18 \xE5r.',
                format: '###### - ####',
                placeholder: 'DDMM\xC5\xC5 - XXXX',
                allowEmptyFormatting: true,
                mask: ['D', 'D', 'M', 'M', 'Å', 'Å', 'X', 'X', 'X', 'X'],
                textColor: currentTheme.colors.primary,
                inputColor: currentTheme.colors.bgDarker,
                focusColor: currentTheme.colors.primaryAction,
                condensed: currentTheme.condensed
            }),
            React.createElement(
                ConfirmButton,
                {
                    size: 'mdB',
                    active: true,
                    bold: true,
                    onClick: confirm,
                    disabled: !cpr || !isValid,
                    activeColor: currentTheme.colors.activeBtnColor,
                    disableColor: currentTheme.colors.disabledBtnColor,
                    color: currentTheme.colors.basic,
                    condensed: currentTheme.condensed
                },
                loading ? React.createElement(Spinner$1, { size: 'md' }) : 'Bekræft'
            )
        )
    );
};

CPRConfirmation.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onError: PropTypes.func,
    oldAPI: PropTypes.bool
};

var _templateObject$m = taggedTemplateLiteral(['\n    height: auto;\n    width: auto;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n'], ['\n    height: auto;\n    width: auto;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n']);

var boxFlex = styled.div(_templateObject$m);

var _templateObject$n = taggedTemplateLiteral(['\n    height: auto;\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px;\n    border: ', ';\n    border-radius: 4px;\n    background: ', ';\n'], ['\n    height: auto;\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px;\n    border: ', ';\n    border-radius: 4px;\n    background: ', ';\n']),
    _templateObject2$i = taggedTemplateLiteral(['\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center;\n'], ['\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center;\n']),
    _templateObject3$e = taggedTemplateLiteral(['\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: center;\n    text-align: right;\n'], ['\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: center;\n    text-align: right;\n']),
    _templateObject4$b = taggedTemplateLiteral(['\n    height: 36px;\n    width: 36px;\n    margin-right: 16px;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    background-color: ', ';\n'], ['\n    height: 36px;\n    width: 36px;\n    margin-right: 16px;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    background-color: ', ';\n']),
    _templateObject5$9 = taggedTemplateLiteral(['\n    color: ', ';\n'], ['\n    color: ', ';\n']);

var WalletWrapper = styled(boxFlex)(_templateObject$n, function (props) {
    return '1px solid  ' + props.theme.colors.colorBorderPrimaryDefault;
}, function (props) {
    return props.theme.colors.colorBackgroundSurfacePrimaryDefault;
});

var WalletLeft = styled(boxFlex)(_templateObject2$i);
var WalletRight = styled(boxFlex)(_templateObject3$e);
var WalletIconWrapper = styled(boxFlex)(_templateObject4$b, function (props) {
    return props.theme.colors.colorBackgroundSurfaceInfoDefault;
});
var GrayText = styled.span(_templateObject5$9, function (_ref) {
    var color = _ref.color;
    return color || 'gray';
});

var Wallet = function Wallet(_ref) {
    var theme = _ref.theme,
        userData = _ref.userData,
        bonus = _ref.bonus;

    return React.createElement(
        WalletWrapper,
        null,
        React.createElement(
            WalletLeft,
            null,
            React.createElement(
                WalletIconWrapper,
                null,
                React.createElement(Icon, {
                    height: '12px',
                    width: '12px',
                    mt: 0,
                    mb: 0,
                    src: walletIcon,
                    color: theme.colors.colorIconInfoDefault,
                    my: 2
                })
            ),
            React.createElement(
                Text,
                {
                    margin: '0',
                    padding: '0',
                    size: 13,
                    lineHeight: '20px',
                    color: theme.colors.colorTextPrimaryDefault
                },
                React.createElement(
                    'b',
                    null,
                    'Saldo'
                ),
                React.createElement('br', null),
                React.createElement(
                    GrayText,
                    { color: theme.colors.colorTextSecondaryDefault },
                    'Bonus saldo'
                )
            )
        ),
        React.createElement(
            WalletRight,
            null,
            React.createElement(
                Text,
                {
                    margin: '0',
                    padding: '0',
                    size: 13,
                    lineHeight: '20px',
                    align: 'right',
                    color: theme.colors.colorTextPrimaryDefault
                },
                React.createElement(
                    'b',
                    null,
                    ' ',
                    numberWithCommasAndDotsIntl(userData.balance, true),
                    ' ',
                    'kr.'
                ),
                React.createElement('br', null),
                React.createElement(
                    GrayText,
                    { color: theme.colors.colorTextSecondaryDefault },
                    numberWithCommasAndDotsIntl(bonus, true),
                    ' kr.'
                )
            )
        )
    );
};

var _templateObject$o = taggedTemplateLiteral(['\n    display: flex;\n    position: relative;\n    height: 44px;\n    width: 100%;\n    max-width: ', ';\n    border-radius: ', ';\n    outline: none;\n    border: none;\n    font-size: ', ';\n    font-weight: ', ';\n    font-family: ', ';\n    transition: all 0.3s ease-in-out;\n    color: ', ';\n    background: ', ';\n    border: ', ';\n    cursor: pointer;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n\n    &:hover {\n        color: ', ';\n        background: ', ';\n        cursor: pointer;\n    }\n\n    &:disabled {\n        color: ', ';\n        background: ', ';\n        cursor: not-allowed;\n    }\n'], ['\n    display: flex;\n    position: relative;\n    height: 44px;\n    width: 100%;\n    max-width: ', ';\n    border-radius: ', ';\n    outline: none;\n    border: none;\n    font-size: ', ';\n    font-weight: ', ';\n    font-family: ', ';\n    transition: all 0.3s ease-in-out;\n    color: ', ';\n    background: ', ';\n    border: ', ';\n    cursor: pointer;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n\n    &:hover {\n        color: ', ';\n        background: ', ';\n        cursor: pointer;\n    }\n\n    &:disabled {\n        color: ', ';\n        background: ', ';\n        cursor: not-allowed;\n    }\n']);

var Button$1 = styled.button(_templateObject$o, function (props) {
    return props.maxWidth ? props.maxWidth : '100%';
}, function (_ref) {
    var radius = _ref.radius;
    return radius || '8px';
}, function (props) {
    return props.fontSize || props.theme.fontSize;
}, function (props) {
    return props.fontWeight || props.theme.fontWeight;
}, function (props) {
    return props.theme.fontFamily;
}, function (props) {
    return props.color ? props.color : props.theme.colors.colorTextOnAccentDefault;
}, function (props) {
    return props.bgColor ? props.bgColor : props.theme.colors.colorBackgroundFillAccentDefault;
}, function (props) {
    return props.borderColor ? '1px solid ' + props.borderColor : '1px solid transparent';
}, function (props) {
    return props.colorHover ? props.colorHover : props.theme.colors.colorTextOnAccentHover;
}, function (props) {
    return props.bgColorHover ? props.bgColorHover : props.theme.colors.colorBackgroundFillAccentHover;
}, function (props) {
    return props.disabledColor ? props.disabledColor : props.theme.colors.colorTextOnAccentInactive;
}, function (props) {
    return props.bgDisabledColor ? props.bgDisabledColor : props.theme.colors.colorBackgroundFillAccentDisabled;
});

var _templateObject$p = taggedTemplateLiteral(['\n    height: ', ';\n    width: 100%;\n    //max-width: 100%;\n    justify-content: ', ';\n    align-items: center;\n    position: relative;\n    box-sizing: content-box;\n    overflow: hidden;\n    background: ', ';\n    padding-bottom: 72px;\n'], ['\n    height: ', ';\n    width: 100%;\n    //max-width: 100%;\n    justify-content: ', ';\n    align-items: center;\n    position: relative;\n    box-sizing: content-box;\n    overflow: hidden;\n    background: ', ';\n    padding-bottom: 72px;\n']),
    _templateObject2$j = taggedTemplateLiteral(['\n    width: 100%;\n    overflow-y: auto;\n    align-items: center;\n    justify-content: flex-start;\n'], ['\n    width: 100%;\n    overflow-y: auto;\n    align-items: center;\n    justify-content: flex-start;\n']),
    _templateObject3$f = taggedTemplateLiteral(['\n    width: 100%;\n    max-width: ', ';\n    padding: ', ';\n'], ['\n    width: 100%;\n    max-width: ', ';\n    padding: ', ';\n']),
    _templateObject4$c = taggedTemplateLiteral(['\n    height: 72px;\n    width: 100%;\n    padding: ', ';\n    border-top: ', ';\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    background: ', ';\n\n    svg {\n        position: absolute;\n        left: 50%;\n        top: 13px;\n        transform: translate(-50%, -50%);\n        z-index: 2;\n    }\n\n    @media (max-width: 767px) {\n        position: fixed;\n    }\n'], ['\n    height: 72px;\n    width: 100%;\n    padding: ', ';\n    border-top: ', ';\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    background: ', ';\n\n    svg {\n        position: absolute;\n        left: 50%;\n        top: 13px;\n        transform: translate(-50%, -50%);\n        z-index: 2;\n    }\n\n    @media (max-width: 767px) {\n        position: fixed;\n    }\n']),
    _templateObject5$a = taggedTemplateLiteral(['\n    margin: ', ';\n    padding-bottom: 24px;\n\n    p {\n        margin-bottom: 0;\n    }\n'], ['\n    margin: ', ';\n    padding-bottom: 24px;\n\n    p {\n        margin-bottom: 0;\n    }\n']),
    _templateObject6$9 = taggedTemplateLiteral([''], ['']);

var WithdrawWrapper = styled(boxFlex)(_templateObject$p, detectMobile() ? 'calc(100% - 72px)' : 'calc(100% - 56px)', detectMobile() ? 'flex-start' : 'space-between', function (_ref) {
    var bC = _ref.bC;
    return bC || '000';
});

var WithdrawContentWrapper = styled(boxFlex)(_templateObject2$j);

var WithdrawContent = styled(boxFlex)(_templateObject3$f, function (_ref2) {
    var maxWidth = _ref2.maxWidth;
    return maxWidth || '100%';
}, function (_ref3) {
    var padding = _ref3.padding;
    return padding || '0';
});

var WithdrawButtonsArea = styled(boxFlex)(_templateObject4$c, detectMobile() ? '0 23px' : '0 24px', function (_ref4) {
    var borderTopColor = _ref4.borderTopColor;
    return '1px solid  ' + borderTopColor;
}, function (_ref5) {
    var bC = _ref5.bC;
    return bC || '000';
});

var WithdrawBonusesWrapper = styled(boxFlex)(_templateObject5$a, detectMobile() ? '28px 0 0 ' : '24px 0 0');

var ButtonTransferMoney = styled(Button$1)(_templateObject6$9);

var _templateObject$q = taggedTemplateLiteral(['\n    margin: ', ';\n    padding: ', ';\n    border: ', ';\n    background: ', ';\n    flex-direction: ', ';\n    align-items: ', ';\n    justify-content: ', ';\n    border-radius: 4px;\n\n    svg {\n        box-sizing: border-box;\n        display: inline-block;\n    }\n\n    a {\n        text-decoration: underline;\n        text-decoration-color: ', ';\n        color: ', ';\n    }\n'], ['\n    margin: ', ';\n    padding: ', ';\n    border: ', ';\n    background: ', ';\n    flex-direction: ', ';\n    align-items: ', ';\n    justify-content: ', ';\n    border-radius: 4px;\n\n    svg {\n        box-sizing: border-box;\n        display: inline-block;\n    }\n\n    a {\n        text-decoration: underline;\n        text-decoration-color: ', ';\n        color: ', ';\n    }\n']),
    _templateObject2$k = taggedTemplateLiteral(['\n    height: auto;\n    width: 100%;\n    max-width: 100%;\n    display: block;\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n    font-size: 10px;\n    line-height: 16px;\n    color: ', ';\n    list-style-type: none;\n\n    li {\n        padding: 0 0 0 20px;\n        height: auto;\n        width: 100%;\n        max-width: 100%;\n        margin-top: 4px;\n        box-sizing: border-box;\n        position: relative;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: flex-start;\n\n        &:before {\n            content: \'\';\n            height: 2px;\n            width: 2px;\n            border-radius: 100%;\n            background-color: ', ';\n            position: absolute;\n            left: 8px;\n            top: 50%;\n            transform: translateY(-50%);\n        }\n    }\n\n    .pl-5 {\n        padding-left: 5px;\n    }\n\n    img,\n    svg {\n        height: 12px;\n        width: 80px;\n        padding-left: 5px;\n        display: inline-block;\n        box-sizing: border-box;\n    }\n'], ['\n    height: auto;\n    width: 100%;\n    max-width: 100%;\n    display: block;\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n    font-size: 10px;\n    line-height: 16px;\n    color: ', ';\n    list-style-type: none;\n\n    li {\n        padding: 0 0 0 20px;\n        height: auto;\n        width: 100%;\n        max-width: 100%;\n        margin-top: 4px;\n        box-sizing: border-box;\n        position: relative;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: flex-start;\n\n        &:before {\n            content: \'\';\n            height: 2px;\n            width: 2px;\n            border-radius: 100%;\n            background-color: ', ';\n            position: absolute;\n            left: 8px;\n            top: 50%;\n            transform: translateY(-50%);\n        }\n    }\n\n    .pl-5 {\n        padding-left: 5px;\n    }\n\n    img,\n    svg {\n        height: 12px;\n        width: 80px;\n        padding-left: 5px;\n        display: inline-block;\n        box-sizing: border-box;\n    }\n']),
    _templateObject3$g = taggedTemplateLiteral(['\n    margin: 0;\n    padding: 0 0 0 10px;\n    list-style-type: decimal;\n    font-weight: bold;\n    font-size: 10px;\n    line-height: 16px;\n    color: ', ';\n\n    .regular {\n        font-weight: 400;\n    }\n'], ['\n    margin: 0;\n    padding: 0 0 0 10px;\n    list-style-type: decimal;\n    font-weight: bold;\n    font-size: 10px;\n    line-height: 16px;\n    color: ', ';\n\n    .regular {\n        font-weight: 400;\n    }\n']),
    _templateObject4$d = taggedTemplateLiteral(['\n    height: ', ';\n    width: ', ';\n    justify-content: center;\n    margin: ', ';\n'], ['\n    height: ', ';\n    width: ', ';\n    justify-content: center;\n    margin: ', ';\n']),
    _templateObject5$b = taggedTemplateLiteral(['\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n'], ['\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n']);

var InfoBoxWrapper = styled(boxFlex)(_templateObject$q, function (_ref) {
    var margin = _ref.margin;
    return margin || '0';
}, function (_ref2) {
    var type = _ref2.type;
    return type === 'info' ? '12px 16px' : '16px 24px';
}, function (_ref3) {
    var type = _ref3.type,
        theme = _ref3.theme;
    return '1px solid ' + (type === 'info' ? theme.colors.colorBorderInfoDefault : theme.colors.colorBorderPrimaryDefault);
}, function (_ref4) {
    var type = _ref4.type,
        theme = _ref4.theme;
    return type === 'info' ? theme.colors.colorBackgroundSurfaceInfoDefault : theme.colors.colorBackgroundDefault;
}, function (_ref5) {
    var direction = _ref5.direction;
    return direction === 'row' ? 'row' : 'column';
}, function (_ref6) {
    var align = _ref6.align;
    return align || 'flex-start';
}, function (_ref7) {
    var jContent = _ref7.jContent;
    return jContent || 'flex-start';
}, function (props) {
    return props.theme.colors.colorTextUtilitiesLink;
}, function (props) {
    return props.theme.colors.colorTextUtilitiesLink;
});

var InfoList = styled.ul(_templateObject2$k, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.colorTextPrimaryDefault;
}, function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.colorTextPrimaryDefault;
});

var InfoListNumered = styled.ol(_templateObject3$g, function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.colorTextPrimaryDefault;
});

var InfoIconWrapper = styled(boxFlex)(_templateObject4$d, function (_ref11) {
    var height = _ref11.height;
    return height || '18px';
}, function (_ref12) {
    var width = _ref12.width;
    return width || '18px';
}, function (_ref13) {
    var margin = _ref13.margin;
    return margin || '0';
});

var InfoWrapperIconWithText = styled(boxFlex)(_templateObject5$b);

var PaymentTexts = {
    readMore: 'Læs mere',
    readMoreLink: 'https://intercom.help/25syv/da/articles/2188686-information-om-udbetalinger',
    readMoreLinkGo: 'https://intercom.help/casinogo/da/articles/2265920-udbetaling',
    paymentInformation: {
        title: 'Udbetalings information',
        minAmount: 'Min. udbetaling:',
        minAmountValue: '100 kr.',
        fee: 'Udbetalingsgebyr:',
        feeValue: '0 kr.',
        processingTime: 'Behandlingstid:',
        processingTimeValue: '1-2 bankdage',
        paymentMethods: 'Udbetales til: '
    },
    paymentNotPossible: {
        title: 'Udbetaling er ikke mulig',
        text: 'da du har en eller flere aktive bonusser. Du skal først gennemspille din bonus før du kan foretage en udbetaling.'
    },
    verifyYourAccount: {
        title: 'Verificer din konto, før du kan udbetale.',
        text1: 'Vi beder dig om at verificere dine oplysninger, før du kan gennemføre udbetalingen. Det er nemt og hurtigt.',
        list: {
            text1: {
                bold: 'Tag et billede af dit sundhedskort',
                regular: '(fysisk kort eller via Sundhedskortet-appen).'
            },
            text2: {
                bold: 'Send det til os på',
                email: 'dokument@bet25.dk.'
            }
        },
        text2: 'Så snart vi har modtaget dine oplysninger og godkendt dem, vil du have mulighed for at kunne udbetale.'
    },
    remember: {
        title: 'Husk:',
        reg1: 'send dokumentationen',
        bold: 'inden for 30 dage',
        reg2: 'fra kontoen er oprettet for at holde din konto aktiv'
    }
};

var _ref$k =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 3.104h3.366l2.144 3.46c.153.25.341.636.577 1.143a8.489 8.489 0 01-.14-1.637V3.104h2.612v8.793H5.946L3.05 7.293c-.106-.165-.307-.542-.578-1.142.106.542.141 1.072.141 1.624v4.122H0V3.104zM9.56 3.104h7.334V5.48h-4.579v1.011h4.556v1.99h-4.556v1.013h4.544v2.402h-7.3V3.104zM23.238 7.6l1.06-4.497H28.1v8.795h-2.613V7.553c0-.565.048-1.177.153-1.813h-.083l-1.483 6.158H21.92L20.424 5.74h-.07c.105.636.153 1.248.153 1.813v4.345h-2.613V3.105h3.803l1.059 4.498c.095.399.165.858.236 1.388.07-.53.153-.99.248-1.388l-.002-.003z",
  fill: "#fff"
});

var _ref2$e =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.272 7.5a5.586 5.586 0 11-11.172 0 5.586 5.586 0 0111.172 0zm-2.764-2.868a.48.48 0 11-.96 0 .48.48 0 01.96 0zm-6.707 3.182a.48.48 0 100-.96.48.48 0 000 .96zm1.546 0a.48.48 0 100-.961.48.48 0 000 .96zm2.04-.48a.48.48 0 11-.96 0 .48.48 0 01.96 0zm1.08.48a.48.48 0 100-.961.48.48 0 000 .96zm2.041-.48a.48.48 0 11-.96 0 .48.48 0 01.96 0zm1.08.48a.48.48 0 100-.96.48.48 0 000 .96zm-.78-1.35a.48.48 0 100-.96.48.48 0 000 .96zm-.3 3.573a.48.48 0 11-.96 0 .48.48 0 01.96 0zm.3-.872a.48.48 0 100-.96.48.48 0 000 .96z",
  fill: "#fff"
});

var _ref3$8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.273 3.104h2.695V6.47h.635l2.485-3.366h3.238l-3.343 4.32 3.532 4.473H47.1L44.606 8.54h-.636v3.356h-2.695V3.104h-.002zM57.707 11.897h-4.049c-1.413 0-2.144-.789-2.144-2.367V5.48c0-1.611.696-2.376 2.144-2.376h4.049c1.46 0 2.131.753 2.131 2.377V9.53c0 1.576-.718 2.367-2.131 2.367zm-.613-2.402V5.48h-2.826v4.014h2.826zM60.838 3.104h3.366l2.144 3.46c.153.25.34.636.577 1.143a8.49 8.49 0 01-.14-1.637V3.104h2.612v8.793h-2.613l-2.897-4.604c-.105-.165-.306-.542-.577-1.142.106.542.141 1.072.141 1.624v4.122h-2.613V3.104zM73.093 5.48h-2.696V3.105h8.158V5.48h-2.578v6.416h-2.884V5.48zM85.748 11.897h-4.05c-1.412 0-2.143-.789-2.143-2.367V5.48c0-1.611.695-2.376 2.144-2.376h4.049c1.46 0 2.13.753 2.13 2.377V9.53c0 1.576-.717 2.367-2.13 2.367zm-.613-2.402V5.48H82.31v4.014h2.826z",
  fill: "#fff"
});

var NemKontoIcon = 'data:image/svg+xml,%3Csvg%20width%3D%2288%22%20height%3D%2214%22%20viewBox%3D%220%200%2088%2014%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M0%203.10352H3.36621L5.50965%206.56491C5.66276%206.81318%205.85103%207.20008%206.0869%207.70697C5.98138%207.16491%205.94621%206.62491%205.94621%206.07042V3.10352H8.55931V11.8966H5.94621L3.04965%207.29318C2.94414%207.12766%202.74345%206.75111%202.47241%206.15111C2.57793%206.69318%202.6131%207.22284%202.6131%207.77525V11.8966H0V3.10352Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M9.55933%203.10352H16.8938V5.48077H12.3152V6.49249H16.871V8.48284H12.3152V9.49456H16.8586V11.8966H9.55933V3.10352Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M23.2379%207.60046L24.2972%203.10254H28.1V11.8977H25.4869V7.55288C25.4869%206.98805%2025.5345%206.37563%2025.64%205.74046H25.5572L24.0738%2011.8977H21.92L20.4241%205.74046H20.3538C20.4593%206.37563%2020.5069%206.98805%2020.5069%207.55288V11.8977H17.8938V3.10461H21.6966L22.7559%207.60253C22.851%208.00184%2022.9214%208.46115%2022.9917%208.99081C23.0621%208.46115%2023.1448%208.00184%2023.24%207.60253L23.2379%207.60046Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M40.2724%207.50027C40.2724%2010.5854%2037.7714%2013.0865%2034.6862%2013.0865C31.6009%2013.0865%2029.1%2010.5854%2029.1%207.50027C29.1%204.41509%2031.6009%201.91406%2034.6862%201.91406C37.7714%201.91406%2040.2724%204.41509%2040.2724%207.50027ZM37.5085%204.63215C37.5085%204.89745%2037.2933%205.1125%2037.028%205.1125C36.7628%205.1125%2036.5476%204.89745%2036.5476%204.63215C36.5476%204.36686%2036.7628%204.15179%2037.028%204.15179C37.2933%204.15179%2037.5085%204.36686%2037.5085%204.63215ZM30.8009%207.81372C31.0663%207.81372%2031.2813%207.59865%2031.2813%207.33337C31.2813%207.06806%2031.0663%206.85301%2030.8009%206.85301C30.5356%206.85301%2030.3207%207.06806%2030.3207%207.33337C30.3207%207.59865%2030.5356%207.81372%2030.8009%207.81372ZM32.347%207.81372C32.6123%207.81372%2032.8274%207.59865%2032.8274%207.33337C32.8274%207.06806%2032.6123%206.85301%2032.347%206.85301C32.0818%206.85301%2031.8666%207.06806%2031.8666%207.33337C31.8666%207.59865%2032.0818%207.81372%2032.347%207.81372ZM34.387%207.33337C34.387%207.59865%2034.172%207.81372%2033.9068%207.81372C33.6414%207.81372%2033.4264%207.59865%2033.4264%207.33337C33.4264%207.06806%2033.6414%206.85301%2033.9068%206.85301C34.172%206.85301%2034.387%207.06806%2034.387%207.33337ZM35.4664%207.81372C35.7316%207.81372%2035.9468%207.59865%2035.9468%207.33337C35.9468%207.06806%2035.7316%206.85301%2035.4664%206.85301C35.2011%206.85301%2034.986%207.06806%2034.986%207.33337C34.986%207.59865%2035.2011%207.81372%2035.4664%207.81372ZM37.5085%207.33337C37.5085%207.59865%2037.2933%207.81372%2037.028%207.81372C36.7628%207.81372%2036.5476%207.59865%2036.5476%207.33337C36.5476%207.06806%2036.7628%206.85301%2037.028%206.85301C37.2933%206.85301%2037.5085%207.06806%2037.5085%207.33337ZM38.5876%207.81372C38.8531%207.81372%2039.068%207.59865%2039.068%207.33337C39.068%207.06806%2038.8531%206.85301%2038.5876%206.85301C38.3224%206.85301%2038.1074%207.06806%2038.1074%207.33337C38.1074%207.59865%2038.3224%207.81372%2038.5876%207.81372ZM37.8078%206.46405C38.0733%206.46405%2038.2883%206.249%2038.2883%205.9837C38.2883%205.71841%2038.0733%205.50335%2037.8078%205.50335C37.5426%205.50335%2037.3276%205.71841%2037.3276%205.9837C37.3276%206.249%2037.5426%206.46405%2037.8078%206.46405ZM37.5085%2010.0366C37.5085%2010.3019%2037.2933%2010.517%2037.028%2010.517C36.7628%2010.517%2036.5476%2010.3019%2036.5476%2010.0366C36.5476%209.77133%2036.7628%209.55626%2037.028%209.55626C37.2933%209.55626%2037.5085%209.77133%2037.5085%2010.0366ZM37.8078%209.16541C38.0733%209.16541%2038.2883%208.95037%2038.2883%208.68506C38.2883%208.41978%2038.0733%208.20471%2037.8078%208.20471C37.5426%208.20471%2037.3276%208.41978%2037.3276%208.68506C37.3276%208.95037%2037.5426%209.16541%2037.8078%209.16541Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M41.2725%203.10352H43.9683V6.46972H44.6035L47.0883%203.10352H50.3263L46.9828%207.42352L50.5145%2011.8966H47.1007L44.6056%208.54076H43.9704V11.8966H41.2745V3.10352H41.2725Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M57.7069%2011.8966H53.658C52.2449%2011.8966%2051.5145%2011.1083%2051.5145%209.52972V5.48076C51.5145%203.86903%2052.2097%203.10352%2053.658%203.10352H57.7069C59.1676%203.10352%2059.838%203.85662%2059.838%205.48076V9.52972C59.838%2011.1063%2059.12%2011.8966%2057.7069%2011.8966ZM57.0945%209.49455V5.48076H54.2683V9.49455H57.0945Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M60.8379%203.10352H64.2041L66.3475%206.5649C66.5006%206.81317%2066.6889%207.20007%2066.9248%207.70696C66.8193%207.1649%2066.7841%206.6249%2066.7841%206.07041V3.10352H69.3972V11.8966H66.7841L63.8875%207.29317C63.782%207.12765%2063.5813%206.7511%2063.3103%206.1511C63.4158%206.69317%2063.451%207.22283%2063.451%207.77524V11.8966H60.8379V3.10352Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M73.0931%205.48076H70.3972V3.10352H78.5551V5.48076H75.9772V11.8966H73.0931V5.48076Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M85.7476%2011.8966H81.6986C80.2855%2011.8966%2079.5552%2011.1083%2079.5552%209.52972V5.48076C79.5552%203.86903%2080.2503%203.10352%2081.6986%203.10352H85.7476C87.2083%203.10352%2087.8786%203.85662%2087.8786%205.48076V9.52972C87.8786%2011.1063%2087.1607%2011.8966%2085.7476%2011.8966ZM85.1352%209.49455V5.48076H82.309V9.49455H85.1352Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E';

var _ref$l =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 18c-4.915 0-9-4.085-9-9 0-4.924 4.076-9 8.991-9C13.915 0 18 4.076 18 9c0 4.915-4.076 9-9 9zM8.92 5.868a1.18 1.18 0 001.183-1.2c0-.67-.52-1.2-1.182-1.2-.662 0-1.192.53-1.192 1.2 0 .67.53 1.2 1.192 1.2zm-1.508 8.24h3.697c.38 0 .67-.273.67-.652a.654.654 0 00-.67-.644h-1.12V8.197c0-.494-.248-.83-.715-.83H7.562a.652.652 0 00-.662.645c0 .38.291.653.662.653h.97v4.147h-1.12c-.38 0-.67.29-.67.644 0 .38.29.653.67.653z",
  fill: "#186BF5"
});

var InfoIcon = 'data:image/svg+xml,%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M9%2018C4.08529%2018%200%2013.9147%200%209C0%204.07647%204.07647%200%208.99118%200C13.9147%200%2018%204.07647%2018%209C18%2013.9147%2013.9235%2018%209%2018ZM8.92059%205.86765C9.58235%205.86765%2010.1029%205.33824%2010.1029%204.66765C10.1029%203.99706%209.58235%203.46765%208.92059%203.46765C8.25882%203.46765%207.72941%203.99706%207.72941%204.66765C7.72941%205.33824%208.25882%205.86765%208.92059%205.86765ZM7.41177%2014.1088H11.1088C11.4882%2014.1088%2011.7794%2013.8353%2011.7794%2013.4559C11.7794%2013.1029%2011.4882%2012.8118%2011.1088%2012.8118H9.98824V8.19706C9.98824%207.70294%209.74118%207.36765%209.27353%207.36765H7.56177C7.19118%207.36765%206.9%207.65882%206.9%208.01177C6.9%208.39118%207.19118%208.66471%207.56177%208.66471H8.53235V12.8118H7.41177C7.03235%2012.8118%206.74118%2013.1029%206.74118%2013.4559C6.74118%2013.8353%207.03235%2014.1088%207.41177%2014.1088Z%22%20fill%3D%22%23186BF5%22%2F%3E%3C%2Fsvg%3E';

var PRODUCT_NAME = {
    casinogo: 'casinogo',
    casino: 'casino'
};

var InfoPayment = function InfoPayment(_ref) {
    var theme = _ref.theme,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'description' : _ref$type,
        _ref$product = _ref.product,
        product = _ref$product === undefined ? '' : _ref$product;

    var getDetailLink = function getDetailLink() {
        return product === PRODUCT_NAME.casinogo ? PaymentTexts.readMoreLinkGo : PaymentTexts.readMoreLink;
    };

    return React.createElement(
        InfoBoxWrapper,
        { type: type, theme: theme, margin: '32px 0 0' },
        React.createElement(
            InfoWrapperIconWithText,
            null,
            React.createElement(Icon, {
                color: theme.colors.colorIconInfoDefault,
                height: '18px',
                width: '18px',
                src: InfoIcon
            }),
            React.createElement(
                Text,
                {
                    size: 13,
                    lineHeight: '20px',
                    weight: true,
                    margin: '0 0 0 8px',
                    color: theme.colors.colorTextPrimaryDefault
                },
                PaymentTexts.paymentInformation.title
            )
        ),
        React.createElement(
            InfoList,
            null,
            React.createElement(
                'li',
                null,
                PaymentTexts.paymentInformation.minAmount,
                ' ',
                React.createElement(
                    'b',
                    { className: 'pl-5' },
                    PaymentTexts.paymentInformation.minAmountValue
                )
            ),
            React.createElement(
                'li',
                null,
                PaymentTexts.paymentInformation.fee,
                ' ',
                React.createElement(
                    'b',
                    { className: 'pl-5' },
                    PaymentTexts.paymentInformation.feeValue
                )
            ),
            React.createElement(
                'li',
                null,
                PaymentTexts.paymentInformation.processingTime,
                ' ',
                React.createElement(
                    'b',
                    { className: 'pl-5' },
                    PaymentTexts.paymentInformation.processingTimeValue,
                    React.createElement(
                        'a',
                        {
                            href: getDetailLink(),
                            rel: 'nofollow noopener noreferrer',
                            target: '_blank',
                            className: 'pl-5'
                        },
                        PaymentTexts.readMore
                    )
                )
            ),
            React.createElement(
                'li',
                null,
                PaymentTexts.paymentInformation.paymentMethods,
                ' ',
                React.createElement(Icon, {
                    src: NemKontoIcon,
                    width: '88px',
                    height: '13px',
                    color: theme.colors.colorIconPrimaryDefault
                }),
                React.createElement(
                    'b',
                    { className: 'pl-5' },
                    React.createElement(
                        'a',
                        {
                            href: getDetailLink(),
                            rel: 'nofollow noopener noreferrer',
                            target: '_blank'
                        },
                        PaymentTexts.readMore
                    )
                )
            )
        )
    );
};

var themesMap$6 = {
    default: defaultTheme$1,
    dark: dark$1
};

var InfoPaymentNotPossible = function InfoPaymentNotPossible(_ref) {
    var theme = _ref.theme,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'info' : _ref$type;

    return React.createElement(
        InfoBoxWrapper,
        {
            type: type,
            theme: theme,
            direction: 'row',
            align: 'center',
            jContent: 'center',
            margin: '24px 0 0 '
        },
        React.createElement(
            InfoIconWrapper,
            {
                height: '20px',
                width: '20px',
                margin: '0 15px 0 6px'
            },
            React.createElement(Icon, {
                color: theme.colors.colorIconInfoDefault,
                height: '20px',
                width: '20px',
                src: InfoIcon
            })
        ),
        React.createElement(
            Text,
            {
                size: 13,
                lineHeight: '20px',
                margin: '0',
                color: theme.colors.colorTextPrimaryDefault
            },
            React.createElement(
                'b',
                null,
                PaymentTexts.paymentNotPossible.title
            ),
            ' ',
            ' ' + PaymentTexts.paymentNotPossible.text
        )
    );
};

var InfoYourData = function InfoYourData(_ref) {
    var theme = _ref.theme,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'description' : _ref$type;

    return React.createElement(
        InfoBoxWrapper,
        { type: type, theme: theme, margin: '24px 0 0 ' },
        React.createElement(
            Text,
            {
                size: 13,
                lineHeight: '20px',
                margin: '0',
                bold: true,
                color: theme.colors.colorTextPrimaryDefault
            },
            PaymentTexts.verifyYourAccount.title
        ),
        React.createElement(
            Text,
            {
                size: 10,
                lineHeight: '16px',
                margin: '8px 0',
                color: theme.colors.colorTextPrimaryDefault
            },
            PaymentTexts.verifyYourAccount.text1
        ),
        React.createElement(
            InfoListNumered,
            null,
            React.createElement(
                'li',
                null,
                PaymentTexts.verifyYourAccount.list.text1.bold,
                React.createElement(
                    'span',
                    { className: 'regular' },
                    ' ',
                    PaymentTexts.verifyYourAccount.list.text1.regular
                )
            ),
            React.createElement(
                'li',
                null,
                PaymentTexts.verifyYourAccount.list.text2.bold,
                ' ',
                React.createElement(
                    'a',
                    {
                        href: 'mailto:' + PaymentTexts.verifyYourAccount.list.text2.email,
                        rel: 'nofollow noopener noreferrer',
                        target: '_blank',
                        className: 'pl-5 bold'
                    },
                    PaymentTexts.verifyYourAccount.list.text2.email
                )
            )
        ),
        React.createElement(
            Text,
            {
                size: 10,
                lineHeight: '16px',
                margin: '8px 0 0 0 ',
                color: theme.colors.colorTextPrimaryDefault
            },
            PaymentTexts.verifyYourAccount.text2
        )
    );
};

var _ref$m =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.344 20.317C3.884 20.317 3 19.303 3 17.989c0-.403.103-.815.335-1.202l6.664-11.61A2.266 2.266 0 0112 4c.79 0 1.554.395 2.001 1.177l6.664 11.61c.215.378.335.799.335 1.203 0 1.313-.884 2.327-2.345 2.327H5.345zm6.665-5.737c.42 0 .67-.249.678-.713l.129-4.663c.008-.455-.352-.79-.816-.79-.48 0-.816.326-.807.782l.111 4.671c.009.455.258.713.705.713zm0 2.877c.506 0 .953-.404.953-.919 0-.524-.438-.927-.953-.927-.524 0-.962.412-.962.927 0 .507.446.92.962.92z",
  fill: "#186BF5"
});

var AttentionIcon = 'data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M5.34447%2020.3168C3.88454%2020.3168%203%2019.3034%203%2017.9895C3%2017.5859%203.10305%2017.1737%203.33492%2016.7872L9.99905%205.17653C10.437%204.39504%2011.2099%204%2012%204C12.7901%204%2013.5544%204.39504%2014.001%205.17653L20.6651%2016.7872C20.8798%2017.1651%2021%2017.5859%2021%2017.9895C21%2019.3034%2020.1155%2020.3168%2018.6555%2020.3168H5.34447ZM12.0086%2014.5802C12.4294%2014.5802%2012.6784%2014.3311%2012.687%2013.8674L12.8158%209.2042C12.8244%208.74905%2012.4637%208.41412%2012%208.41412C11.5191%208.41412%2011.1842%208.74046%2011.1927%209.19561L11.3044%2013.8674C11.313%2014.3225%2011.562%2014.5802%2012.0086%2014.5802ZM12.0086%2017.4571C12.5153%2017.4571%2012.9618%2017.0534%2012.9618%2016.5382C12.9618%2016.0143%2012.5239%2015.6107%2012.0086%2015.6107C11.4847%2015.6107%2011.0468%2016.0229%2011.0468%2016.5382C11.0468%2017.0448%2011.4933%2017.4571%2012.0086%2017.4571Z%22%20fill%3D%22%23186BF5%22%2F%3E%3C%2Fsvg%3E';

var InfoSendDocs = function InfoSendDocs(_ref) {
    var theme = _ref.theme,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'info' : _ref$type;

    return React.createElement(
        InfoBoxWrapper,
        {
            type: type,
            theme: theme,
            direction: 'row',
            align: 'center',
            jContent: 'flex-start',
            margin: '24px 0 0'
        },
        React.createElement(
            InfoIconWrapper,
            {
                height: '24px',
                width: '24px',
                margin: '0 15px 0 0'
            },
            React.createElement(Icon, {
                color: theme.colors.colorIconInfoDefault,
                height: '24px',
                width: '24px',
                src: AttentionIcon
            })
        ),
        React.createElement(
            Text,
            {
                size: 13,
                margin: '0',
                lineHeight: '20px',
                color: theme.colors.colorTextPrimaryDefault
            },
            React.createElement(
                'b',
                null,
                PaymentTexts.remember.title
            ),
            ' ',
            PaymentTexts.remember.reg1,
            ' ',
            React.createElement(
                'b',
                null,
                PaymentTexts.remember.bold
            ),
            ' ',
            PaymentTexts.remember.reg2
        )
    );
};

var _templateObject$r = taggedTemplateLiteral(['\n    height: auto;\n    border-radius: 4px;\n    border: 1px solid ', ';\n    background: ', ';\n    padding: 16px;\n    box-sizing: border-box;\n    margin-top: 8px;\n    margin-bottom: ', ';\n'], ['\n    height: auto;\n    border-radius: 4px;\n    border: 1px solid ', ';\n    background: ', ';\n    padding: 16px;\n    box-sizing: border-box;\n    margin-top: 8px;\n    margin-bottom: ', ';\n']),
    _templateObject2$l = taggedTemplateLiteral(['\n    position: relative;\n    padding-left: 12px;\n    &:before {\n        content: \'\';\n        height: 2px;\n        width: 2px;\n        border-radius: 100%;\n        background: ', ';\n        position: absolute;\n        left: 5px;\n        top: 50%;\n        transform: translateY(-50%);\n        z-index: 1;\n    }\n'], ['\n    position: relative;\n    padding-left: 12px;\n    &:before {\n        content: \'\';\n        height: 2px;\n        width: 2px;\n        border-radius: 100%;\n        background: ', ';\n        position: absolute;\n        left: 5px;\n        top: 50%;\n        transform: translateY(-50%);\n        z-index: 1;\n    }\n']),
    _templateObject3$h = taggedTemplateLiteral(['\n    width: 100%;\n'], ['\n    width: 100%;\n']),
    _templateObject4$e = taggedTemplateLiteral(['\n    width: 100%;\n    height: 10px;\n    background: ', ';\n    border-radius: 8px;\n'], ['\n    width: 100%;\n    height: 10px;\n    background: ', ';\n    border-radius: 8px;\n']),
    _templateObject5$c = taggedTemplateLiteral(['\n    width: ', ';\n    height: 100%;\n    overflow: hidden;\n    background: ', ';\n    border-radius: 8px;\n'], ['\n    width: ', ';\n    height: 100%;\n    overflow: hidden;\n    background: ', ';\n    border-radius: 8px;\n']),
    _templateObject6$a = taggedTemplateLiteral(['\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    margin: 5px 0 0;\n'], ['\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    margin: 5px 0 0;\n']),
    _templateObject7$8 = taggedTemplateLiteral(['\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n    margin: 15px 0 0;\n'], ['\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n    margin: 15px 0 0;\n']),
    _templateObject8$8 = taggedTemplateLiteral(['\n    color: ', ';\n    font-size: 12px;\n'], ['\n    color: ', ';\n    font-size: 12px;\n']),
    _templateObject9$7 = taggedTemplateLiteral(['\n    height: 40px;\n    font-size: 13px;\n    line-height: 13px;\n    font-weight: bold;\n'], ['\n    height: 40px;\n    font-size: 13px;\n    line-height: 13px;\n    font-weight: bold;\n']),
    _templateObject10$5 = taggedTemplateLiteral(['\n    width: 54px;\n    vertical-align: middle;\n    background: none;\n    margin: 0 0 0 8px;\n    background: transparent;\n    &:hover {\n        background: transparent;\n    }\n'], ['\n    width: 54px;\n    vertical-align: middle;\n    background: none;\n    margin: 0 0 0 8px;\n    background: transparent;\n    &:hover {\n        background: transparent;\n    }\n']);

var BonusWrapper = styled.div(_templateObject$r, function (_ref) {
    var borderColor = _ref.borderColor;
    return borderColor || '#DFE5ED';
}, function (_ref2) {
    var bC = _ref2.bC;
    return bC || '#ffffff';
}, detectMobile() ? '20px' : '0');

var SpanWithDotBefore = styled.span(_templateObject2$l, function (_ref3) {
    var dotColor = _ref3.dotColor;
    return dotColor || '#333333';
});

var StatusBarWrapper = styled.div(_templateObject3$h);

var StatusBarLine = styled.div(_templateObject4$e, function (_ref4) {
    var bC = _ref4.bC;
    return bC || '#F0F4FA';
});

var StatusBarSlider = styled.div(_templateObject5$c, function (props) {
    return props.status ? props.status + '%' : '0';
}, function (_ref5) {
    var bC = _ref5.bC;
    return bC || '#0BC628';
});

var StatusBarValueWrapper = styled.div(_templateObject6$a);

var ButtonWrapper$1 = styled.div(_templateObject7$8);
var StatusBarValue = styled.div(_templateObject8$8, function (_ref6) {
    var color = _ref6.color;
    return color || '#333333';
});

var ButtonGoTo = styled(Button$1)(_templateObject9$7);

var ButtonDelete = styled(Button$1)(_templateObject10$5);

var _ref$n =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.414 3.818h1.433V2.064a.7.7 0 01.218-.539.805.805 0 01.573-.2h2.961a.8.8 0 01.577.2.709.709 0 01.214.539v1.754h1.436V1.987a1.894 1.894 0 00-.568-1.459A2.21 2.21 0 009.693 0H6.539a2.2 2.2 0 00-1.561.528 1.9 1.9 0 00-.564 1.459zm-3.737.789h14.9a.649.649 0 00.479-.2.669.669 0 00.2-.49.656.656 0 00-.2-.48.65.65 0 00-.479-.2H.677a.653.653 0 00-.476.2.65.65 0 00-.2.48.663.663 0 00.2.49.653.653 0 00.476.2zM4.311 18.65h7.638a2.063 2.063 0 001.489-.543 2.093 2.093 0 00.612-1.474l.582-12.185h-1.446l-.56 11.995a.875.875 0 01-.251.6.808.808 0 01-.6.233H4.459a.791.791 0 01-.588-.235.881.881 0 01-.251-.6l-.58-12H1.626l.576 12.2a2.081 2.081 0 00.612 1.47 2.081 2.081 0 001.497.539zm1.356-2.754a.561.561 0 00.4-.145.473.473 0 00.143-.379l-.25-8.794a.516.516 0 00-.158-.373.549.549 0 00-.392-.14.543.543 0 00-.4.144.5.5 0 00-.146.378l.257 8.791a.527.527 0 00.158.382.544.544 0 00.388.136zm2.463 0a.561.561 0 00.4-.144.493.493 0 00.154-.374v-8.8a.493.493 0 00-.153-.376.561.561 0 00-.4-.144.576.576 0 00-.405.147.487.487 0 00-.157.376v8.797a.487.487 0 00.157.374.576.576 0 00.4.144zm2.454 0a.544.544 0 00.389-.14.518.518 0 00.153-.378l.254-8.8a.5.5 0 00-.147-.378.543.543 0 00-.4-.144.549.549 0 00-.392.14.522.522 0 00-.158.381l-.245 8.795a.5.5 0 00.147.379.547.547 0 00.399.145z",
  fill: "#d42c2c"
});

var trashIcon = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216.251%22%20height%3D%2218.65%22%20viewBox%3D%220%200%2016.251%2018.65%22%3E%20%20%3Cpath%20id%3D%22delete%22%20d%3D%22M5.688-12.26H7.121v-1.754a.7.7%2C0%2C0%2C1%2C.218-.539.805.805%2C0%2C0%2C1%2C.573-.2h2.961a.8.8%2C0%2C0%2C1%2C.577.2.709.709%2C0%2C0%2C1%2C.214.539v1.754H13.1v-1.831a1.894%2C1.894%2C0%2C0%2C0-.568-1.459%2C2.21%2C2.21%2C0%2C0%2C0-1.565-.528H7.813a2.2%2C2.2%2C0%2C0%2C0-1.561.528%2C1.9%2C1.9%2C0%2C0%2C0-.564%2C1.459Zm-3.737.789h14.9a.649.649%2C0%2C0%2C0%2C.479-.2.669.669%2C0%2C0%2C0%2C.2-.49.656.656%2C0%2C0%2C0-.2-.48.65.65%2C0%2C0%2C0-.479-.2H1.951a.653.653%2C0%2C0%2C0-.476.2.65.65%2C0%2C0%2C0-.2.48.663.663%2C0%2C0%2C0%2C.2.49A.653.653%2C0%2C0%2C0%2C1.951-11.471ZM5.585%2C2.572h7.638a2.063%2C2.063%2C0%2C0%2C0%2C1.489-.543A2.093%2C2.093%2C0%2C0%2C0%2C15.324.555l.582-12.185H14.46L13.9.365a.875.875%2C0%2C0%2C1-.251.6.808.808%2C0%2C0%2C1-.6.233H5.733A.791.791%2C0%2C0%2C1%2C5.145.963a.881.881%2C0%2C0%2C1-.251-.6l-.58-12H2.9L3.476.563a2.081%2C2.081%2C0%2C0%2C0%2C.612%2C1.47A2.081%2C2.081%2C0%2C0%2C0%2C5.585%2C2.572ZM6.941-.182a.561.561%2C0%2C0%2C0%2C.4-.145.473.473%2C0%2C0%2C0%2C.143-.379L7.234-9.5a.516.516%2C0%2C0%2C0-.158-.373.549.549%2C0%2C0%2C0-.392-.14.543.543%2C0%2C0%2C0-.4.144.5.5%2C0%2C0%2C0-.146.378L6.395-.7a.527.527%2C0%2C0%2C0%2C.158.382A.544.544%2C0%2C0%2C0%2C6.941-.182Zm2.463%2C0a.561.561%2C0%2C0%2C0%2C.4-.144A.493.493%2C0%2C0%2C0%2C9.958-.7V-9.5a.493.493%2C0%2C0%2C0-.153-.376.561.561%2C0%2C0%2C0-.4-.144A.576.576%2C0%2C0%2C0%2C9-9.873a.487.487%2C0%2C0%2C0-.157.376V-.7A.487.487%2C0%2C0%2C0%2C9-.326.576.576%2C0%2C0%2C0%2C9.4-.182Zm2.454%2C0a.544.544%2C0%2C0%2C0%2C.389-.14A.518.518%2C0%2C0%2C0%2C12.4-.7l.254-8.8a.5.5%2C0%2C0%2C0-.147-.378.543.543%2C0%2C0%2C0-.4-.144.549.549%2C0%2C0%2C0-.392.14.522.522%2C0%2C0%2C0-.158.381L11.312-.706a.5.5%2C0%2C0%2C0%2C.147.379A.547.547%2C0%2C0%2C0%2C11.858-.182Z%22%20transform%3D%22translate%28-1.274%2016.078%29%22%20fill%3D%22%23d42c2c%22%2F%3E%3C%2Fsvg%3E';

var _ref$o =
/*#__PURE__*/
React.createElement("path", {
  d: "M49.358 0H0v24h49.358V0z",
  fill: "#fff"
});

var _ref2$f =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#a)",
  fill: "#1E1E1E"
}, React.createElement("path", {
  d: "M1.439 6.583h4.12c2.322 0 3.417.868 3.417 2.449a3.78 3.78 0 01-.028.497 2.3 2.3 0 01-1.724 2.118 2.095 2.095 0 011.315 2.076c0 .028 0 .128-.014.3-.176 1.99-1.325 2.842-4.005 2.842H0L1.439 6.584zm2.921 8.033c.897 0 1.227-.185 1.354-.953.016-.104.026-.208.028-.313 0-.583-.37-.74-1.068-.74H3.477l-.285 2.005H4.36zm.242-3.91c1.125 0 1.396-.227 1.482-.895.01-.09.015-.18.014-.27 0-.498-.243-.711-.97-.711h-1.11l-.27 1.88.854-.004zM16.22 14.874c-.342 1.849-.927 2.162-3.391 2.162-2.736 0-3.506-1.024-3.506-2.798.008-.428.042-.855.1-1.28.37-2.73.883-4.08 4.031-4.08 2.594 0 3.363 1.024 3.363 2.772a11.803 11.803 0 01-.228 2.047c-.028.175-.07.242-.37.242h-4.294c-.011.08-.016.16-.014.242 0 .54.314.7 1.154.7l3.154-.007zm-2.043-2.458a3.79 3.79 0 00.088-.71c0-.584-.285-.711-.94-.711-.742 0-.998.087-1.183 1.421h2.035zM18.513 7.341h2.68l-.258 1.706h2.209l-.285 1.99H20.65l-.284 2.061a8.694 8.694 0 00-.1 1.066c0 .584.2.711.87.711h1.314c-.2 1.837-.656 2.162-2.423 2.162-2.008 0-2.522-.64-2.522-1.976.035-.7.106-1.398.214-2.09l.794-5.63zM37.327 0c-2.378 0-4.704.704-6.681 2.022a12.006 12.006 0 00-4.43 5.386 11.974 11.974 0 002.607 13.076 12.052 12.052 0 0013.107 2.601 12.02 12.02 0 005.397-4.419 11.98 11.98 0 00-1.495-15.151A12.04 12.04 0 0037.326 0zm-.526 14.756c-.242 2.03-.484 2.164-2.154 2.164H28.84l.108-.806c.243-1.95.27-2.366 3.61-4.261 1.052-.591 1.873-1.062 1.873-1.802 0-.59-.485-.685-1.118-.685h-3.506c.188-1.774.593-2.325 3.57-2.325 2.716 0 3.906.766 3.906 2.567 0 2.34-1.523 3.078-3.476 4.06-.66.296-1.288.661-1.872 1.088H36.8zm8.889-6.654c-.175 1.237-.701 1.264-2.17 1.264h-2.572l-.216 1.519h.768c2.533 0 3.624.968 3.624 2.715 0 2.42-1.24 3.322-4.001 3.322h-3.704c.269-1.868.592-2.164 2.262-2.164h1.578c.74 0 1.293-.107 1.293-.94 0-.633-.539-.766-1.347-.766h-2.41c-.459 0-.607-.04-.607-.323a1.157 1.157 0 01.013-.201l.755-5.323h6.857l-.123.897z"
}));

var bet25Icon = 'data:image/svg+xml,%3Csvg%20width%3D%2250%22%20height%3D%2224%22%20viewBox%3D%220%200%2050%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cmask%20id%3D%22mask0_1212_606%22%20style%3D%22mask-type%3Aluminance%22%20maskUnits%3D%22userSpaceOnUse%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2250%22%20height%3D%2224%22%3E%3Cpath%20d%3D%22M49.3585%200H0V24H49.3585V0Z%22%20fill%3D%22white%22%2F%3E%3C%2Fmask%3E%3Cg%20mask%3D%22url%28%23mask0_1212_606%29%22%3E%3Cpath%20d%3D%22M1.43904%206.5835H5.55809C7.88053%206.5835%208.97602%207.45091%208.97602%209.03185C8.97763%209.19813%208.96826%209.36434%208.94798%209.52939C8.92427%2010.0196%208.74425%2010.4894%208.43416%2010.8704C8.12406%2011.2513%207.70011%2011.5235%207.22411%2011.6472C7.63467%2011.8107%207.98291%2012.0995%208.21903%2012.4723C8.45514%2012.8451%208.56704%2013.2829%208.5387%2013.7231C8.5387%2013.7511%208.5387%2013.8507%208.52468%2014.0221C8.3494%2016.0123%207.19957%2016.8648%204.52044%2016.8648H0L1.43904%206.5835ZM4.36006%2014.6158C5.25749%2014.6158%205.58701%2014.4305%205.71409%2013.6627C5.73041%2013.5591%205.73978%2013.4546%205.74213%2013.3497C5.74213%2012.7665%205.37142%2012.6099%204.67381%2012.6099H3.47665L3.19183%2014.615L4.36006%2014.6158ZM4.60194%2010.7064C5.72723%2010.7064%205.99804%2010.479%206.08392%209.81095C6.09467%209.72131%206.09936%209.63104%206.09795%209.54076C6.09795%209.04322%205.85519%208.82986%205.12866%208.82986H4.01827L3.74746%2010.7107L4.60194%2010.7064Z%22%20fill%3D%22%231E1E1E%22%2F%3E%3Cpath%20d%3D%22M16.2194%2014.8743C15.8776%2016.7228%2015.2931%2017.0358%2012.8287%2017.0358C10.0926%2017.0358%209.32309%2016.0119%209.32309%2014.2377C9.33126%2013.8097%209.36461%2013.3825%209.423%2012.9584C9.79371%2010.2285%2010.3064%208.87842%2013.4544%208.87842C16.0477%208.87842%2016.8171%209.90235%2016.8171%2011.6503C16.801%2012.3379%2016.7247%2013.0229%2016.5893%2013.6973C16.5612%2013.8722%2016.5183%2013.9386%2016.2186%2013.9386H11.9251C11.9138%2014.0189%2011.9091%2014.0999%2011.9111%2014.1809C11.9111%2014.7212%2012.2248%2014.8804%2013.0653%2014.8804L16.2194%2014.8743ZM14.1774%2012.4163C14.229%2012.1826%2014.2584%2011.9446%2014.2651%2011.7054C14.2651%2011.1222%2013.9802%2010.9945%2013.3247%2010.9945C12.5833%2010.9945%2012.3274%2011.0819%2012.1416%2012.4163H14.1774Z%22%20fill%3D%22%231E1E1E%22%2F%3E%3Cpath%20d%3D%22M18.513%207.34131H21.1921L20.9353%209.04729H23.1438L22.859%2011.0374H20.6505L20.3657%2013.0984C20.3105%2013.4514%2020.2771%2013.8073%2020.2657%2014.1644C20.2657%2014.7476%2020.4656%2014.8752%2021.1351%2014.8752H22.4497C22.2499%2016.7115%2021.7942%2017.0368%2020.0274%2017.0368C18.0187%2017.0368%2017.5051%2016.3967%2017.5051%2015.0606C17.54%2014.3608%2017.6114%2013.6632%2017.7189%2012.9708L18.513%207.34131Z%22%20fill%3D%22%231E1E1E%22%2F%3E%3Cpath%20d%3D%22M37.3274%200C34.9487%200%2032.6234%200.703762%2030.6456%202.02229C28.6679%203.34082%2027.1264%205.2149%2026.2161%207.40753C25.3058%209.60016%2025.0676%2012.0129%2025.5317%2014.3406C25.9957%2016.6682%2027.1412%2018.8064%2028.8232%2020.4845C30.5051%2022.1627%2032.6481%2023.3056%2034.9811%2023.7686C37.314%2024.2316%2039.7322%2023.9939%2041.9298%2023.0857C44.1274%2022.1775%2046.0057%2020.6395%2047.3272%2018.6662C48.6487%2016.6928%2049.3541%2014.3729%2049.3541%2011.9996C49.3541%208.81708%2048.087%205.76495%2045.8315%203.51459C43.5761%201.26424%2040.5171%200%2037.3274%200ZM36.8015%2014.7557C36.5588%2016.7852%2036.3169%2016.9199%2034.6465%2016.9199H28.8404L28.9482%2016.1137C29.1909%2014.1646%2029.2172%2013.7484%2032.558%2011.8527C33.6097%2011.2616%2034.4309%2010.7911%2034.4309%2010.0514C34.4309%209.46027%2033.9462%209.36583%2033.3126%209.36583H29.807C29.9954%207.59165%2030.3995%207.04077%2033.3766%207.04077C36.0934%207.04077%2037.2827%207.80676%2037.2827%209.60804C37.2827%2011.9471%2035.7604%2012.686%2033.8069%2013.6671C33.1468%2013.9643%2032.5195%2014.3292%2031.9349%2014.7557H36.8015ZM45.6899%208.10231C45.5146%209.33873%2044.9888%209.36583%2043.5208%209.36583H40.9477L40.7321%2010.8847H41.4999C44.0326%2010.8847%2045.1238%2011.8527%2045.1238%2013.5997C45.1238%2016.0192%2043.8845%2016.9225%2041.123%2016.9225H37.4185C37.6875%2015.0539%2038.0109%2014.7583%2039.6813%2014.7583H41.2589C41.9994%2014.7583%2042.5524%2014.6508%2042.5524%2013.8175C42.5524%2013.1853%2042.0134%2013.0515%2041.2054%2013.0515H38.7944C38.3361%2013.0515%2038.188%2013.0113%2038.188%2012.7288C38.1865%2012.6615%2038.1909%2012.5942%2038.2011%2012.5277L38.9557%207.20516H45.8126L45.6899%208.10231Z%22%20fill%3D%22%231E1E1E%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E';

var casinoGoIcon = "data:image/png;base64,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";

var moment = createCommonjsModule$1(function (module, exports) {
(function (global, factory) {
    module.exports = factory();
}(commonjsGlobal$1, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number$$1, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number$$1),
            zerosToFill = targetLength - absNumber.length,
            sign = number$$1 >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func$$1 = callback;
        if (typeof callback === 'string') {
            func$$1 = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func$$1;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func$$1.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func$$1.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array$$1 = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array$$1.length; i < length; i++) {
            if (formatTokenFunctions[array$$1[i]]) {
                array$$1[i] = formatTokenFunctions[array$$1[i]];
            } else {
                array$$1[i] = removeFormattingTokens(array$$1[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array$$1[i])
                    ? array$$1[i].call(mom, format)
                    : array$$1[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number$$1) {
        return this._ordinal.replace('%d', number$$1);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number$$1, withoutSuffix, string$$1, isFuture) {
        var output = this._relativeTime[string$$1];
        return isFunction(output)
            ? output(number$$1, withoutSuffix, string$$1, isFuture)
            : output.replace(/%d/i, number$$1);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number$$1) {
        if (number$$1 < 0) {
            // -0 -> 0
            return Math.ceil(number$$1) || 0;
        } else {
            return Math.floor(number$$1);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func$$1 = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func$$1 = function (input, array$$1) {
                array$$1[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func$$1;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array$$1, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array$$1) {
        array$$1[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array$$1) {
        array$$1[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array$$1) {
        array$$1[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array$$1) {
        array$$1[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array$$1, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array$$1[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array$$1, config) {
        var kInput = toInt(input);
        array$$1[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array$$1, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array$$1, config) {
        array$$1[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array$$1, config) {
        var pos = input.length - 2;
        array$$1[HOUR] = toInt(input.substr(0, pos));
        array$$1[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array$$1, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array$$1[HOUR] = toInt(input.substr(0, pos1));
        array$$1[MINUTE] = toInt(input.substr(pos1, 2));
        array$$1[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array$$1, config) {
        var pos = input.length - 2;
        array$$1[HOUR] = toInt(input.substr(0, pos));
        array$$1[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array$$1, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array$$1[HOUR] = toInt(input.substr(0, pos1));
        array$$1[MINUTE] = toInt(input.substr(pos1, 2));
        array$$1[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string$$1 = config._i,
            match = extendedIsoRegex.exec(string$$1) || basicIsoRegex.exec(string$$1),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string$$1 = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string$$1.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string$$1.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string$$1.substr(0, string$$1.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string$$1 = string$$1.slice(
                    string$$1.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string$$1.length > 0) {
            getParsingFlags(config).unusedInput.push(string$$1);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number$$1) {
        if (number$$1 < 0) {
            return Math.round(-1 * number$$1) * -1;
        } else {
            return Math.round(number$$1);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array$$1, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string$$1) {
        var matches = (string$$1 || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func$$1 = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func$$1 = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func$$1 + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array$$1, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array$$1, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array$$1[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array$$1[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array$$1) {
        array$$1[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array$$1) {
        array$$1[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array$$1, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array$$1) {
        array$$1[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string$$1) {
        return string$$1;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number$$1) {
            var b = number$$1 % 10,
                output =
                    toInt((number$$1 % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number$$1 + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number$$1) {
        if (number$$1 < 0) {
            return Math.floor(number$$1);
        } else {
            return Math.ceil(number$$1);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string$$1, number$$1, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number$$1 || 1, !!withoutSuffix, string$$1, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array$$1, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array$$1, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
});

var ActiveBonuses = function ActiveBonuses(_ref) {
    var _ref$product = _ref.product,
        product = _ref$product === undefined ? '' : _ref$product,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'W' : _ref$type,
        _ref$onRemove = _ref.onRemove,
        onRemove = _ref$onRemove === undefined ? function (activeBonus) {} : _ref$onRemove,
        _ref$activeBonus = _ref.activeBonus,
        activeBonus = _ref$activeBonus === undefined ? 0 : _ref$activeBonus,
        _ref$rollover = _ref.rollover,
        rollover = _ref$rollover === undefined ? 0 : _ref$rollover,
        _ref$initialRollover = _ref.initialRollover,
        initialRollover = _ref$initialRollover === undefined ? 0 : _ref$initialRollover,
        redirectUrl = _ref.redirectUrl,
        _ref$bonusButtonText = _ref.bonusButtonText,
        bonusButtonText = _ref$bonusButtonText === undefined ? '' : _ref$bonusButtonText,
        theme = _ref.theme,
        _ref$expirationDate = _ref.expirationDate,
        expirationDate = _ref$expirationDate === undefined ? 0 : _ref$expirationDate,
        _ref$minOdds = _ref.minOdds,
        minOdds = _ref$minOdds === undefined ? 0 : _ref$minOdds;

    var turnover = Math.round(initialRollover / activeBonus);
    var statusBarPercent = 100 - rollover / initialRollover * 100;

    var darkColor = theme.colors.colorTextPrimaryDefault;
    var grayColor = theme.colors.colorTextTertiaryDefault;
    var logo = type === 'W' ? rodLogo$1 : bet25Icon;
    var logoColor = type === 'W' ? theme.colors.colorBackgroundFillBrandPrimaryDefault : darkColor;

    var onRemoveHandler = function onRemoveHandler(activeBonus) {
        onRemove(activeBonus);
    };

    var getRedirectUrl = function getRedirectUrl() {
        if (window.location.hostname === 'localhost') {
            window.location = window.location.origin;
        }

        window.location.pathname = '/casino';
    };

    return React.createElement(
        BonusWrapper,
        {
            borderColor: theme.colors.colorBorderPrimaryDefault,
            bC: theme.colors.colorBackgroundSurfacePrimaryDefault
        },
        React.createElement(
            Flex,
            { justify: 'space-between' },
            product === PRODUCT_NAME.casinogo ? React.createElement(Img, { src: casinoGoIcon, alt: 'CasinoGO' }) : React.createElement(Icon, {
                src: logo,
                width: type === 'W' ? '100px' : '50px',
                height: '25px',
                color: logoColor
            }),
            expirationDate > 0 && React.createElement(
                Text,
                {
                    size: 10,
                    lineHeigh: '16px',
                    margin: '0',
                    color: grayColor
                },
                'Udl\xF8ber ',
                moment(expirationDate).format('DD. MMMM')
            )
        ),
        React.createElement(
            Text,
            {
                size: 16,
                lineHeight: '24px',
                color: darkColor,
                bold: true,
                style: { margin: '20px 0 0' }
            },
            'Indbetalingsbonus p\xE5 ',
            numberWithCommasAndDotsIntl(activeBonus),
            ' ',
            'kr.'
        ),
        React.createElement(
            Text,
            {
                size: 10,
                lineHeight: '16px',
                color: grayColor,
                style: { margin: '4px 0 16px' }
            },
            turnover,
            'x oms\xE6tningskrav',
            minOdds > 0 && React.createElement(
                SpanWithDotBefore,
                { dotColor: grayColor },
                'Min. odds ',
                numberWithCommasAndDotsIntl(minOdds),
                ' p\xE5 Bet25 Sport'
            )
        ),
        React.createElement(
            StatusBarWrapper,
            null,
            React.createElement(
                StatusBarLine,
                {
                    bC: theme.colors.colorBackgroundFillSecondaryDefault
                },
                React.createElement(StatusBarSlider, {
                    status: statusBarPercent,
                    bC: theme.colors.colorBackgroundFillSuccesDefault
                })
            ),
            React.createElement(
                StatusBarValueWrapper,
                null,
                React.createElement(
                    StatusBarValue,
                    { color: darkColor },
                    React.createElement(
                        'strong',
                        null,
                        numberWithCommasAndDotsIntl(Math.abs(initialRollover - rollover), true)
                    ),
                    ' ',
                    '/ ',
                    numberWithCommasAndDotsIntl(initialRollover, true),
                    ' ',
                    'kr.'
                ),
                React.createElement(
                    StatusBarValue,
                    { color: darkColor },
                    '-',
                    numberWithCommasAndDotsIntl(rollover, true),
                    ' kr.'
                )
            ),
            type === 'W' && React.createElement(
                ButtonWrapper$1,
                null,
                React.createElement(
                    ButtonGoTo,
                    {
                        onClick: function onClick() {
                            typeof redirectUrl === 'function' ? redirectUrl() : getRedirectUrl();
                        }
                    },
                    bonusButtonText ? bonusButtonText : 'Gå til alle spil'
                ),
                React.createElement(
                    ButtonDelete,
                    {
                        onClick: function onClick() {
                            return onRemoveHandler(activeBonus);
                        }
                    },
                    React.createElement(Icon, {
                        src: trashIcon,
                        width: '19px',
                        height: '21px',
                        color: theme.colors.colorIconDangerDefault
                    })
                )
            )
        )
    );
};

ActiveBonuses.propTypes = {
    product: PropTypes.string,
    onRemove: PropTypes.func.isRequired,
    activeBonus: PropTypes.number.isRequired,
    initialRollover: PropTypes.number.isRequired,
    redirectUrl: PropTypes.func,
    bonusButtonText: PropTypes.string
};

var Withdraw = function Withdraw(_ref) {
    var _ref$product = _ref.product,
        product = _ref$product === undefined ? 'sport' : _ref$product,
        _ref$currentTheme = _ref.currentTheme,
        currentTheme = _ref$currentTheme === undefined ? 'default' : _ref$currentTheme,
        _ref$userData = _ref.userData,
        userData = _ref$userData === undefined ? {} : _ref$userData,
        _ref$bonusesData = _ref.bonusesData,
        bonusesData = _ref$bonusesData === undefined ? [] : _ref$bonusesData,
        _ref$onRemove = _ref.onRemove,
        onRemove = _ref$onRemove === undefined ? function (amount) {} : _ref$onRemove,
        _ref$transferMoneyHan = _ref.transferMoneyHandler,
        transferMoneyHandler = _ref$transferMoneyHan === undefined ? function (amount) {} : _ref$transferMoneyHan,
        _ref$redirectUrl = _ref.redirectUrl,
        redirectUrl = _ref$redirectUrl === undefined ? function () {} : _ref$redirectUrl,
        payoutPending = _ref.payoutPending;

    var _React$useState = React.useState([]),
        _React$useState2 = slicedToArray(_React$useState, 2),
        bonusesWithZeroAmount = _React$useState2[0],
        setBonusesWithZeroAmount = _React$useState2[1];

    var _React$useState3 = React.useState(''),
        _React$useState4 = slicedToArray(_React$useState3, 2),
        moneyAmount = _React$useState4[0],
        setMoneyAmount = _React$useState4[1];

    var _React$useState5 = React.useState(0),
        _React$useState6 = slicedToArray(_React$useState5, 2),
        bonusAmount = _React$useState6[0],
        setBonusAmount = _React$useState6[1];

    var theme = themesMap$6[currentTheme];

    var _React$useState7 = React.useState(false),
        _React$useState8 = slicedToArray(_React$useState7, 2),
        error = _React$useState8[0],
        setError = _React$useState8[1];

    useEffect(function () {
        var bonusAmount = 0;
        var zeroAmountBonuses = [];
        bonusesData.forEach(function (item) {
            if ((product === 'sport' || product === 'heste') && item.bonusType === 'D') {
                bonusAmount = item.amount;
            }
            if (item.bonusType === 'W' && (product === 'casino' || product === 'casinogo')) {
                bonusAmount = item.amount;
            }
            if (item.amount === 0) {
                zeroAmountBonuses.push(true);
            }
        });
        setBonusesWithZeroAmount(zeroAmountBonuses);
        setBonusAmount(bonusAmount);
    }, [bonusesData]);

    useEffect(function () {
        return function () {
            setBonusesWithZeroAmount([]);
            setMoneyAmount('');
            setError(false);
        };
    }, []);

    var getInfoBox = function getInfoBox(theme, status, bonusesData) {
        if (userData.status === 'temp') {
            return React.createElement(
                'div',
                null,
                React.createElement(InfoYourData, { theme: theme, type: 'rec' }),
                React.createElement(InfoSendDocs, { theme: theme, type: 'info' })
            );
        } else if (bonusesData.length === 0 || bonusesData.length === bonusesWithZeroAmount.length) {
            return React.createElement(InfoPayment, { theme: theme, product: product });
        } else if (bonusesData.length > 0 && bonusesData.length !== bonusesWithZeroAmount.length) {
            return React.createElement(InfoPaymentNotPossible, { theme: theme, type: 'info' });
        }
    };

    var validateAmountToTransfer = function validateAmountToTransfer(moneyAmount, userData, bonusesData) {
        var balance = userData.balance,
            status = userData.status;

        var amount = exportNumberFromStringWithoutComma(moneyAmount);
        var regex = /^\d+[.,]$/;

        return bonusesData.length > 0 && bonusesData.length !== bonusesWithZeroAmount.length || regex.test(moneyAmount) || moneyAmount[0] === ',' || moneyAmount[0] === '.' || amount > balance || amount < 100 || balance < 100 || status === 'temp';
    };

    var getActiveBonus = function getActiveBonus(product, bonuses, theme) {
        var bonusesData = [];

        bonuses.forEach(function (item) {
            item.bonusType === BONUSES_TYPE_BY_PRODUCT[product] ? bonusesData.unshift(item) : bonusesData.push(item);
        });

        return bonusesData.map(function (item) {
            if (item.amount > 0) {
                return React.createElement(ActiveBonuses, {
                    product: product,
                    onRemove: onRemove,
                    activeBonus: item.amount,
                    initialRollover: item.initRollOver,
                    rollover: item.rollOver,
                    key: 'item_' + item.bonusType,
                    theme: theme,
                    expirationDate: item.expire,
                    type: item.bonusType,
                    minOdds: item.minOdds,
                    redirectUrl: redirectUrl,
                    bonusButtonText: product !== PRODUCT_NAME.casinogo ? 'Gå til Bet25 Casino' : ''
                });
            } else {
                return null;
            }
        });
    };

    var amountChangeHandler = function amountChangeHandler(value) {
        var regex = /^(?!0\d)\d*([.,]\d{0,2})?$/;
        if (regex.test(value)) {
            setMoneyAmount(value);
        }
        if (value === '') {
            setMoneyAmount(value);
        }
    };

    var checkValue = function checkValue(error) {
        setError(error.value);
    };

    return React.createElement(
        ThemeProvider,
        { theme: theme },
        React.createElement(
            WithdrawWrapper,
            { bC: theme.colors.colorBackgroundDefault },
            React.createElement(
                WithdrawContentWrapper,
                null,
                React.createElement(
                    WithdrawContent,
                    {
                        maxWidth: getMaxWidthByProduct(product),
                        padding: getPaddingByProduct(product)
                    },
                    React.createElement(Wallet, {
                        theme: theme,
                        userData: userData,
                        bonus: bonusAmount
                    }),
                    (bonusesData.length === 0 || bonusesData.length === bonusesWithZeroAmount.length) && userData.status !== 'temp' && React.createElement(
                        'div',
                        null,
                        React.createElement(
                            Text,
                            {
                                size: 13,
                                lineHeight: '20px',
                                margin: detectMobile() ? '28px 0 0' : '24px 0 0',
                                color: theme.colors.colorTextPrimaryDefault,
                                bold: true
                            },
                            'Indtast bel\xF8b'
                        ),
                        React.createElement(ValidatingInput, {
                            allowFirstZero: false,
                            disableErrorBottomMargin: true,
                            bottomLabelMargin: '10px 0 0 8px',
                            type: 'text',
                            validate: 'minimum-kr, withdraw-max-amount, balance',
                            value: moneyAmount,
                            maxNumber: 1000000,
                            minNumber: 100,
                            balance: userData.balance,
                            name: 'amount',
                            onCheckValue: checkValue,
                            onChangeHandler: amountChangeHandler,
                            validateOnChange: true,
                            theme: currentTheme,
                            altLabel: 'kr.',
                            bottomLabel: 'Minimum 100 kr.',
                            isLightInput: true,
                            styles: {
                                InputWrapper: { margin: '0' }
                            },
                            bgColor: theme.colors.colorBackgroundSurfacePrimaryDefault
                        })
                    ),
                    getInfoBox(theme, userData.status, bonusesData),
                    bonusesData.length > 0 && bonusesData.length !== bonusesWithZeroAmount.length && userData.status !== 'temp' && React.createElement(
                        WithdrawBonusesWrapper,
                        null,
                        React.createElement(
                            Text,
                            {
                                bold: true,
                                size: 13,
                                lineHeight: '20px',
                                margin: '0',
                                padding: '0',
                                color: theme.colors.colorTextPrimaryDefault
                            },
                            'Aktive bonusser'
                        ),
                        getActiveBonus(product, bonusesData, theme)
                    )
                )
            ),
            React.createElement(
                WithdrawButtonsArea,
                {
                    padding: getPaddingsForButtonsByProduct(product),
                    borderTopColor: theme.colors.colorBorderPrimaryDefault,
                    bC: theme.colors.colorBackgroundDefault
                },
                React.createElement(
                    ButtonTransferMoney,
                    {
                        maxWidth: product === PRODUCT_NAME.casino || product === PRODUCT_NAME.casinogo || detectMobile() ? '100%' : '330px',
                        disabled: validateAmountToTransfer(moneyAmount, userData, bonusesData) || payoutPending || error,
                        radius: '4px',
                        onClick: function onClick() {
                            return transferMoneyHandler(exportNumberFromStringWithoutComma(moneyAmount));
                        }
                    },
                    'Udbetal til Nemkonto',
                    payoutPending && React.createElement(Spinner$1, {
                        color: theme.colors.colorTextPrimaryDefault,
                        size: 'md'
                    })
                )
            )
        )
    );
};

Withdraw.propTypes = {
    currentTheme: PropTypes.string,
    product: PropTypes.string.isRequired,
    userData: PropTypes.object.isRequired,
    bonusesData: PropTypes.array.isRequired,
    onRemove: PropTypes.func.isRequired,
    redirectUrl: PropTypes.func.isRequired,
    transferMoneyHandler: PropTypes.func.isRequired,
    payoutPending: PropTypes.bool.isRequired
};

var _templateObject$s = taggedTemplateLiteral(['\n    width: 100%;\n    max-width: 375px;\n    background: ', ';\n    border-radius: 8px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n'], ['\n    width: 100%;\n    max-width: 375px;\n    background: ', ';\n    border-radius: 8px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n']),
    _templateObject2$m = taggedTemplateLiteral(['\n    text-align: center;\n    padding: 24px 0;\n    color: ', ';\n    font-size: 18px;\n    line-height: 28px;\n    font-weight: bold;\n    position: relative;\n'], ['\n    text-align: center;\n    padding: 24px 0;\n    color: ', ';\n    font-size: 18px;\n    line-height: 28px;\n    font-weight: bold;\n    position: relative;\n']),
    _templateObject3$i = taggedTemplateLiteral(['\n    padding: 0 24px 0;\n    color: ', ';\n    font-size: 13px;\n    line-height: 20px;\n    text-align: center;\n'], ['\n    padding: 0 24px 0;\n    color: ', ';\n    font-size: 13px;\n    line-height: 20px;\n    text-align: center;\n']),
    _templateObject4$f = taggedTemplateLiteral(['\n    margin: 16px 0 0;\n    border: none;\n    outline: none;\n    border-top: ', ';\n    background: none;\n    padding: 0;\n'], ['\n    margin: 16px 0 0;\n    border: none;\n    outline: none;\n    border-top: ', ';\n    background: none;\n    padding: 0;\n']),
    _templateObject5$d = taggedTemplateLiteral(['\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 16px 24px 24px;\n'], ['\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 16px 24px 24px;\n']),
    _templateObject6$b = taggedTemplateLiteral(['\n    background: ', ';\n    color: ', ';\n    font-size: 14px;\n    font-weight: bold;\n    border: ', ';\n    transition: all 0.4s ease-in-out;\n\n    &:hover {\n        background: ', ';\n    }\n'], ['\n    background: ', ';\n    color: ', ';\n    font-size: 14px;\n    font-weight: bold;\n    border: ', ';\n    transition: all 0.4s ease-in-out;\n\n    &:hover {\n        background: ', ';\n    }\n']),
    _templateObject7$9 = taggedTemplateLiteral(['\n    background: ', ';\n    color: ', ';\n    font-size: 14px;\n    font-weight: bold;\n    transition: all 0.4s ease-in-out;\n\n    &:hover {\n        background: ', ';\n        color: ', ';\n    }\n'], ['\n    background: ', ';\n    color: ', ';\n    font-size: 14px;\n    font-weight: bold;\n    transition: all 0.4s ease-in-out;\n\n    &:hover {\n        background: ', ';\n        color: ', ';\n    }\n']);

var Wrapper$7 = styled.div(_templateObject$s, function (_ref) {
    var bg = _ref.bg;
    return bg || '#F5F8FC';
});

var StyledModalTopbar$2 = styled.div(_templateObject2$m, function (_ref2) {
    var color = _ref2.color;
    return color || '#1E1E1E';
});

var ContentWrapper$2 = styled.div(_templateObject3$i, function (_ref3) {
    var color = _ref3.color;
    return color || '#4F555E';
});

var HR = styled.hr(_templateObject4$f, function (_ref4) {
    var color = _ref4.color;
    return '1px solid ' + (color || '#DFE5ED');
});

var ButtonWrapper$2 = styled.div(_templateObject5$d);

var CancelButton = styled(Button$1)(_templateObject6$b, function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.colorBackgroundFillSecondaryDefault;
}, function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.colorTextPrimaryDefault;
}, function (_ref7) {
    var theme = _ref7.theme;
    return '1px solid ' + theme.colors.colorBorderPrimaryDefault;
}, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.colorBackgroundFillSecondaryHover;
});

var ConfirmButton$1 = styled(Button$1)(_templateObject7$9, function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.colorBackgroundSurfaceDangerDefault;
}, function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.colorTextDangerDefault;
}, function (_ref11) {
    var theme = _ref11.theme;
    return theme.colors.colorBackgroundSurfaceDangerHover;
}, function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.colorTextDangerHover;
});

var _ref$p =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 13.4l-4.9 4.9a.948.948 0 01-.7.275.948.948 0 01-.7-.275.948.948 0 01-.275-.7c0-.283.092-.517.275-.7l4.9-4.9-4.9-4.9a.948.948 0 01-.275-.7c0-.283.092-.517.275-.7a.948.948 0 01.7-.275c.283 0 .517.092.7.275l4.9 4.9 4.9-4.9a.948.948 0 01.7-.275c.283 0 .517.092.7.275a.948.948 0 01.275.7.948.948 0 01-.275.7L13.4 12l4.9 4.9a.948.948 0 01.275.7.948.948 0 01-.275.7.948.948 0 01-.7.275.949.949 0 01-.7-.275L12 13.4z",
  fill: "#BFC9D9"
});

var CloseIcon$1 = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M12%2013.4L7.10005%2018.3C6.91672%2018.4833%206.68338%2018.575%206.40005%2018.575C6.11672%2018.575%205.88338%2018.4833%205.70005%2018.3C5.51672%2018.1167%205.42505%2017.8833%205.42505%2017.6C5.42505%2017.3167%205.51672%2017.0833%205.70005%2016.9L10.6%2012L5.70005%207.1C5.51672%206.91667%205.42505%206.68333%205.42505%206.4C5.42505%206.11667%205.51672%205.88333%205.70005%205.7C5.88338%205.51667%206.11672%205.425%206.40005%205.425C6.68338%205.425%206.91672%205.51667%207.10005%205.7L12%2010.6L16.9%205.7C17.0834%205.51667%2017.3167%205.425%2017.6%205.425C17.8834%205.425%2018.1167%205.51667%2018.3%205.7C18.4834%205.88333%2018.575%206.11667%2018.575%206.4C18.575%206.68333%2018.4834%206.91667%2018.3%207.1L13.4%2012L18.3%2016.9C18.4834%2017.0833%2018.575%2017.3167%2018.575%2017.6C18.575%2017.8833%2018.4834%2018.1167%2018.3%2018.3C18.1167%2018.4833%2017.8834%2018.575%2017.6%2018.575C17.3167%2018.575%2017.0834%2018.4833%2016.9%2018.3L12%2013.4Z%22%20fill%3D%22%23BFC9D9%22%2F%3E%3C%2Fsvg%3E';

var _templateObject$t = taggedTemplateLiteral(['\n    height: 24px;\n    width: 24px;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: ', ';\n    transition: all 0.4s ease-in-out;\n    border-radius: 4px;\n    transform: translateY(-50%);\n    position: absolute;\n    top: ', ';\n    right: 24px;\n\n    &:hover {\n        cursor: pointer;\n    }\n'], ['\n    height: 24px;\n    width: 24px;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: ', ';\n    transition: all 0.4s ease-in-out;\n    border-radius: 4px;\n    transform: translateY(-50%);\n    position: absolute;\n    top: ', ';\n    right: 24px;\n\n    &:hover {\n        cursor: pointer;\n    }\n']);

var CloseButtonIconWrapper = styled(boxFlex)(_templateObject$t, function (_ref) {
    var theme = _ref.theme;
    return theme.colors.colorIconPrimaryDefault;
}, function (_ref2) {
    var top = _ref2.top;
    return top || '50%';
});

var CloseButtonIcon = function CloseButtonIcon(_ref) {
    var _ref$click = _ref.click,
        click = _ref$click === undefined ? function () {} : _ref$click,
        top = _ref.top,
        theme = _ref.theme;

    return React.createElement(
        CloseButtonIconWrapper,
        { onClick: click, top: top, theme: theme },
        React.createElement(Icon, {
            height: '20px',
            width: '20px',
            src: CloseIcon$1,
            color: theme.colors.colorBackgroundDefault
        })
    );
};

var CloseButtonIcon$1 = withTheme(CloseButtonIcon);

var ConfirmModal = function ConfirmModal(_ref) {
    var bonusAmount = _ref.bonusAmount,
        onConfirm = _ref.onConfirm,
        onCancel = _ref.onCancel,
        _ref$currentTheme = _ref.currentTheme,
        currentTheme = _ref$currentTheme === undefined ? 'default' : _ref$currentTheme;

    var _useState = useState(false),
        _useState2 = slicedToArray(_useState, 2),
        loading = _useState2[0],
        setLoading = _useState2[1];

    var _useState3 = useState(false),
        _useState4 = slicedToArray(_useState3, 2),
        removeBtnHovered = _useState4[0],
        setRemoveBtnHovered = _useState4[1];

    var confirm = function confirm() {
        if (!loading) {
            setLoading(true);
            onConfirm();
        }
    };

    var theme = themesMap$6[currentTheme];

    return React.createElement(
        Wrapper$7,
        { bg: theme.colors.colorBackgroundDefault },
        React.createElement(
            StyledModalTopbar$2,
            { color: theme.colors.colorTextPrimaryDefault },
            'Fjern bonus p\xE5',
            ' ',
            React.createElement(
                'strong',
                {
                    style: {
                        textDecoration: removeBtnHovered ? 'line-through' : 'none'
                    }
                },
                bonusAmount,
                ' kr.'
            ),
            '?',
            React.createElement(CloseButtonIcon$1, { click: onCancel, theme: theme })
        ),
        React.createElement(
            ContentWrapper$2,
            { color: theme.colors.colorTextSecondaryDefault },
            'Er du sikker p\xE5, at du vil fjerne din bonus? Denne handling kan ikke fortrydes.',
            React.createElement(HR, { color: theme.colors.colorIconTertiaryDefault })
        ),
        React.createElement(
            ButtonWrapper$2,
            null,
            React.createElement(
                CancelButton,
                { onClick: onCancel, theme: theme },
                'Annuller'
            ),
            React.createElement(
                ConfirmButton$1,
                {
                    onClick: confirm,
                    onMouseEnter: function onMouseEnter() {
                        return setRemoveBtnHovered(true);
                    },
                    onMouseLeave: function onMouseLeave() {
                        return setRemoveBtnHovered(false);
                    },
                    theme: theme
                },
                loading ? React.createElement(Spinner$1, { size: 'md' }) : 'Fjern bonus'
            )
        )
    );
};

ConfirmModal.propTypes = {
    bonusAmount: PropTypes.number.isRequired,
    currentTheme: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func
};

var _templateObject$u = taggedTemplateLiteral(['\n    height: auto;\n    width: 100%;\n    max-width: 400px;\n    padding: 42px 24px 36px;\n    background: ', ';\n    border-radius: 8px;\n    position: relative;\n\n    hr {\n        margin: 16px auto;\n        border: none;\n        border-top: 1px solid\n            ', ';\n    }\n'], ['\n    height: auto;\n    width: 100%;\n    max-width: 400px;\n    padding: 42px 24px 36px;\n    background: ', ';\n    border-radius: 8px;\n    position: relative;\n\n    hr {\n        margin: 16px auto;\n        border: none;\n        border-top: 1px solid\n            ', ';\n    }\n']),
    _templateObject2$n = taggedTemplateLiteral(['\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding-bottom: 35px;\n'], ['\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding-bottom: 35px;\n']);

var TransferMoneyModalWrapper = styled(boxFlex)(_templateObject$u, function (_ref) {
    var theme = _ref.theme;
    return theme.colors.colorBackgroundDefault;
}, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.colorBorderPrimaryDefault;
});

var TransferMoneyIconWrapper = styled(boxFlex)(_templateObject2$n);

var _ref$q =
/*#__PURE__*/
React.createElement("path", {
  d: "M71.44 38.32V28.077a7.114 7.114 0 00-6.33-7.073l-9.1-16.643a7.114 7.114 0 00-9.657-2.82L10.847 20.959H7.281a7.114 7.114 0 00-7.114 7.114V68.22a7.114 7.114 0 007.114 7.114h57.045a7.114 7.114 0 007.115-7.114V58.094a5.238 5.238 0 003.393-4.895v-9.997a5.206 5.206 0 00-3.393-4.883zm-2.46 14.257H57.906a4.364 4.364 0 110-8.712h11.076v8.712zm-10.565-31.61h-15.68l12.067-6.603 3.613 6.604zM49.161 6.674a1.244 1.244 0 011.713.502l1.12 2.05L30.54 20.958h-7.492L49.161 6.673zm15.165 62.79H7.281a1.243 1.243 0 01-1.245-1.244V28.073a1.244 1.244 0 011.245-1.244h57.045a1.244 1.244 0 011.245 1.244v9.923h-7.666a10.217 10.217 0 000 20.434h7.683v9.79a1.244 1.244 0 01-1.261 1.244zM57.93 45.75a2.385 2.385 0 110 4.77 2.385 2.385 0 010-4.77z",
  fill: "#1E1E1E"
});

var WalletIcon = 'data:image/svg+xml,%3Csvg%20width%3D%2275%22%20height%3D%2276%22%20viewBox%3D%220%200%2075%2076%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M71.4406%2038.3193V28.0775C71.441%2026.3261%2070.7955%2024.6362%2069.6275%2023.3312C68.4595%2022.0262%2066.8512%2021.1979%2065.1105%2021.0049L56.0094%204.3624C55.1028%202.70781%2053.5761%201.4811%2051.7651%200.952115C49.9541%200.423127%2048.0071%200.635185%2046.3525%201.54164L10.8483%2020.9592H7.28086C5.39408%2020.9592%203.58458%2021.7087%202.25042%2023.0429C0.916268%2024.3771%200.166748%2026.1866%200.166748%2028.0733L0.166748%2068.2193C0.166748%2070.1061%200.916268%2071.9156%202.25042%2073.2497C3.58458%2074.5839%205.39408%2075.3334%207.28086%2075.3334H64.3265C66.2133%2075.3334%2068.0228%2074.5839%2069.3569%2073.2497C70.6911%2071.9156%2071.4406%2070.1061%2071.4406%2068.2193V58.0936C72.4363%2057.7188%2073.2943%2057.0497%2073.9004%2056.1753C74.5065%2055.3009%2074.8321%2054.2627%2074.8338%2053.1988V43.2017C74.8342%2042.1388%2074.5094%2041.1012%2073.9028%2040.2284C73.2962%2039.3556%2072.437%2038.6894%2071.4406%2038.3193ZM68.9807%2052.5766H57.9051C57.3105%2052.6133%2056.7147%2052.5279%2056.1544%2052.3256C55.594%2052.1233%2055.0811%2051.8084%2054.647%2051.4004C54.213%2050.9923%2053.8671%2050.4997%2053.6307%2049.9529C53.3943%2049.4061%2053.2723%2048.8167%2053.2723%2048.221C53.2723%2047.6253%2053.3943%2047.0358%2053.6307%2046.489C53.8671%2045.9422%2054.213%2045.4496%2054.647%2045.0416C55.0811%2044.6335%2055.594%2044.3187%2056.1544%2044.1164C56.7147%2043.9141%2057.3105%2043.8287%2057.9051%2043.8654H68.9807V52.5766ZM58.4153%2020.9675H42.7353L54.8023%2014.3636L58.4153%2020.9675ZM49.1608%206.67293C49.3056%206.59096%2049.4655%206.53889%2049.6309%206.5198C49.7962%206.50071%2049.9637%206.51499%2050.1235%206.56179C50.2832%206.60859%2050.4319%206.68697%2050.5608%206.79227C50.6897%206.89757%2050.7962%207.02767%2050.874%207.17486L51.994%209.22405L30.5396%2020.9592H23.048L49.1608%206.67293ZM64.3265%2069.4638H7.28086C7.11743%2069.4638%206.95561%2069.4316%206.80463%2069.369C6.65364%2069.3065%206.51646%2069.2148%206.4009%2069.0993C6.28534%2068.9837%206.19368%2068.8465%206.13114%2068.6955C6.0686%2068.5446%206.03641%2068.3827%206.03641%2068.2193V28.0733C6.03641%2027.7433%206.16752%2027.4268%206.4009%2027.1934C6.63428%2026.96%206.95081%2026.8289%207.28086%2026.8289H64.3265C64.6565%2026.8289%2064.9731%2026.96%2065.2064%2027.1934C65.4398%2027.4268%2065.5709%2027.7433%2065.5709%2028.0733V37.9958H57.9051C55.1954%2037.9958%2052.5967%2039.0722%2050.6806%2040.9882C48.7646%2042.9043%2047.6882%2045.503%2047.6882%2048.2127C47.6882%2050.9224%2048.7646%2053.5211%2050.6806%2055.4372C52.5967%2057.3532%2055.1954%2058.4296%2057.9051%2058.4296H65.5875V68.2193C65.5875%2068.3841%2065.5548%2068.5473%2065.4912%2068.6994C65.4277%2068.8515%2065.3345%2068.9894%2065.2172%2069.1052C65.0999%2069.221%2064.9607%2069.3123%2064.8078%2069.3738C64.6549%2069.4354%2064.4913%2069.466%2064.3265%2069.4638ZM57.93%2045.7487C58.4018%2045.7487%2058.8629%2045.8886%2059.2551%2046.1507C59.6474%2046.4127%2059.9531%2046.7853%2060.1336%2047.2211C60.3142%2047.6569%2060.3614%2048.1365%2060.2694%2048.5992C60.1773%2049.0619%2059.9502%2049.4869%2059.6166%2049.8205C59.283%2050.154%2058.858%2050.3812%2058.3953%2050.4732C57.9326%2050.5653%2057.4531%2050.518%2057.0172%2050.3375C56.5814%2050.157%2056.2089%2049.8513%2055.9468%2049.459C55.6847%2049.0668%2055.5448%2048.6056%2055.5448%2048.1339C55.5448%2047.5013%2055.7961%2046.8946%2056.2434%2046.4473C56.6907%2046%2057.2974%2045.7487%2057.93%2045.7487Z%22%20fill%3D%22%231E1E1E%22%2F%3E%3C%2Fsvg%3E';

var TransferMoneyModal = function TransferMoneyModal(_ref) {
    var _ref$currentTheme = _ref.currentTheme,
        currentTheme = _ref$currentTheme === undefined ? 'default' : _ref$currentTheme,
        _ref$amount = _ref.amount,
        amount = _ref$amount === undefined ? 0 : _ref$amount,
        _ref$closeModal = _ref.closeModal,
        closeModal = _ref$closeModal === undefined ? function () {} : _ref$closeModal;

    var theme = themesMap$6[currentTheme];

    return React.createElement(
        ThemeProvider,
        { theme: theme },
        React.createElement(
            TransferMoneyModalWrapper,
            null,
            React.createElement(CloseButtonIcon$1, { click: closeModal, top: '36px' }),
            React.createElement(
                TransferMoneyIconWrapper,
                null,
                React.createElement(Icon, {
                    src: WalletIcon,
                    height: '75px',
                    width: '75px',
                    color: theme.colors.colorIconPrimaryDefault
                })
            ),
            React.createElement(
                Text,
                {
                    margin: '0',
                    padding: '0',
                    size: 18,
                    lineHeight: '28px',
                    bold: true,
                    color: theme.colors.colorTextPrimaryDefault,
                    align: 'center'
                },
                'Udbetaling p\xE5 ',
                numberWithCommasAndDots(amount),
                ' kr. Bekr\xE6ftet!'
            ),
            React.createElement(
                Text,
                {
                    size: 13,
                    lineHeight: '20px',
                    margin: '16px 0 0',
                    padding: '0',
                    color: theme.colors.colorTextPrimaryDefault,
                    align: 'center'
                },
                'Vi forventer, at din gevinst er p\xE5 din NemKonto',
                React.createElement('br', null),
                'indenfor 1-2 bankdage.'
            ),
            React.createElement('hr', null),
            React.createElement(
                Button$1,
                { fontWeight: 'bold', radius: '4px', onClick: closeModal },
                'Ok'
            )
        )
    );
};

var _templateObject$v = taggedTemplateLiteral(['\n    background: ', ';\n    height: 32px;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    padding: 2px;\n    position: relative; /* Make it relative for the selector to position within it */\n'], ['\n    background: ', ';\n    height: 32px;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    padding: 2px;\n    position: relative; /* Make it relative for the selector to position within it */\n']),
    _templateObject2$o = taggedTemplateLiteral(['\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    flex: 50%;\n    border: none;\n    background: ', ';\n    color: ', ';\n    cursor: pointer;\n    text-transform: capitalize;\n    position: relative;\n    z-index: 3;\n    height: 100%;\n    border-radius: 8px;\n\n    ', ';\n'], ['\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    flex: 50%;\n    border: none;\n    background: ', ';\n    color: ', ';\n    cursor: pointer;\n    text-transform: capitalize;\n    position: relative;\n    z-index: 3;\n    height: 100%;\n    border-radius: 8px;\n\n    ', ';\n']),
    _templateObject3$j = taggedTemplateLiteral(['\n            font-weight: ', ';\n            color: ', ';\n            background: ', ';\n        '], ['\n            font-weight: ', ';\n            color: ', ';\n            background: ', ';\n        ']),
    _templateObject4$g = taggedTemplateLiteral(['\n    width: 1px;\n    height: 20px;\n    background: #0000000a;\n    z-index: 1;\n    position: relative;\n    left: 1px;\n'], ['\n    width: 1px;\n    height: 20px;\n    background: #0000000a;\n    z-index: 1;\n    position: relative;\n    left: 1px;\n']),
    _templateObject5$e = taggedTemplateLiteral(['\n    position: absolute;\n    z-index: 2;\n    height: calc(100% - 4px);\n    background: ', ';\n    border-radius: 8px;\n    transition: left 0.3s, width 0.3s;\n'], ['\n    position: absolute;\n    z-index: 2;\n    height: calc(100% - 4px);\n    background: ', ';\n    border-radius: 8px;\n    transition: left 0.3s, width 0.3s;\n']);

var StyledFlex = styled(Flex)(_templateObject$v, function (_ref) {
    var background = _ref.background;
    return background;
});

var SwitchButton = styled.button(_templateObject2$o, function (_ref2) {
    var bgColor = _ref2.bgColor;
    return bgColor;
}, function (props) {
    return props.color ? props.color : 'white';
}, function (props) {
    return props.active && css(_templateObject3$j, function (props) {
        return props.theme.fontWeight;
    }, function (_ref3) {
        var activeColor = _ref3.activeColor;
        return activeColor;
    }, function (_ref4) {
        var activeBgColor = _ref4.activeBgColor;
        return activeBgColor;
    });
});

var Divider$3 = styled.div(_templateObject4$g);

var Selector = styled.div(_templateObject5$e, function (props) {
    return props.activeBgColor;
});

var SmallMultiSwitcher = function SmallMultiSwitcher(_ref5) {
    var _ref5$value = _ref5.value,
        value = _ref5$value === undefined ? '' : _ref5$value,
        _ref5$optionList = _ref5.optionList,
        optionList = _ref5$optionList === undefined ? [] : _ref5$optionList,
        _ref5$onChange = _ref5.onChange,
        onChange = _ref5$onChange === undefined ? function (f) {
        return f;
    } : _ref5$onChange,
        _ref5$bgColor = _ref5.bgColor,
        bgColor = _ref5$bgColor === undefined ? 'none' : _ref5$bgColor,
        _ref5$color = _ref5.color,
        color = _ref5$color === undefined ? 'white' : _ref5$color,
        _ref5$activeColor = _ref5.activeColor,
        activeColor = _ref5$activeColor === undefined ? 'white' : _ref5$activeColor,
        _ref5$activeBgColor = _ref5.activeBgColor,
        activeBgColor = _ref5$activeBgColor === undefined ? 'black' : _ref5$activeBgColor,
        _ref5$mainColor = _ref5.mainColor,
        mainColor = _ref5$mainColor === undefined ? '#0000001a' : _ref5$mainColor;

    var switchButtonsRef = useRef([]);
    var selectorRef = useRef(null);

    useEffect(function () {
        var activeIndex = optionList.findIndex(function (option) {
            return option.name === value;
        });
        var activeItem = switchButtonsRef.current[activeIndex];
        if (activeItem && selectorRef.current) {
            var activeWidth = activeItem.offsetWidth;
            var activeLeft = activeItem.offsetLeft;

            selectorRef.current.style.width = activeWidth + 'px';
            selectorRef.current.style.left = activeLeft + 'px';
        }
    }, [value, optionList]);

    return React.createElement(
        StyledFlex,
        { background: mainColor },
        optionList.map(function (option, index) {
            return React.createElement(
                Fragment,
                { key: index },
                React.createElement(
                    SwitchButton,
                    {
                        ref: function ref(el) {
                            return switchButtonsRef.current[index] = el;
                        },
                        bgColor: bgColor,
                        color: color,
                        activeBgColor: activeBgColor,
                        activeColor: activeColor,
                        active: value === option.name,
                        onClick: option.action ? option.action : function () {
                            return onChange(option.name);
                        }
                    },
                    option.title
                ),
                value !== option.name && index < optionList.length - 1 && React.createElement(Divider$3, null)
            );
        }),
        React.createElement(Selector, { activeBgColor: activeBgColor, ref: selectorRef })
    );
};

SmallMultiSwitcher.propTypes = {
    value: PropTypes.string.isRequired,
    optionList: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    bgColor: PropTypes.string,
    color: PropTypes.string,
    activeBgColor: PropTypes.string,
    activeColor: PropTypes.string,
    mainColor: PropTypes.string
};

var _ref$r =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.833 14.667c-.366 0-.68-.13-.941-.392a1.284 1.284 0 01-.392-.941V4c0-.366.13-.68.392-.942.26-.26.575-.391.941-.391H4.5V2c0-.189.064-.347.192-.475a.645.645 0 01.475-.192c.189 0 .347.064.475.192A.645.645 0 015.833 2v.667h5.334V2c0-.189.064-.347.191-.475a.645.645 0 01.475-.192c.19 0 .348.064.475.192A.645.645 0 0112.5 2v.667h.667c.366 0 .68.13.941.392.261.26.392.575.392.941v9.334c0 .366-.13.68-.392.941a1.284 1.284 0 01-.941.392H3.833zm0-1.333h9.334V6.667H3.833v6.667zm0-8h9.334V4H3.833v1.333zm4.667 4a.645.645 0 01-.475-.192.645.645 0 01-.192-.475c0-.19.064-.347.192-.475A.645.645 0 018.5 8c.189 0 .347.064.475.192a.645.645 0 01.192.475.645.645 0 01-.192.475.645.645 0 01-.475.192zm-2.667 0a.645.645 0 01-.475-.192.645.645 0 01-.191-.475c0-.19.064-.347.191-.475A.645.645 0 015.833 8c.19 0 .348.064.475.192a.645.645 0 01.192.475.645.645 0 01-.192.475.645.645 0 01-.475.192zm5.334 0a.645.645 0 01-.475-.192.645.645 0 01-.192-.475c0-.19.064-.347.192-.475A.645.645 0 0111.167 8c.189 0 .347.064.475.192a.645.645 0 01.191.475.645.645 0 01-.191.475.645.645 0 01-.475.192zM8.5 12a.645.645 0 01-.475-.191.645.645 0 01-.192-.475c0-.19.064-.348.192-.476a.645.645 0 01.475-.191c.189 0 .347.064.475.191a.645.645 0 01.192.476.645.645 0 01-.192.475A.645.645 0 018.5 12zm-2.667 0a.645.645 0 01-.475-.191.645.645 0 01-.191-.475c0-.19.064-.348.191-.476a.645.645 0 01.475-.191c.19 0 .348.064.475.191a.645.645 0 01.192.476.645.645 0 01-.192.475.645.645 0 01-.475.191zm5.334 0a.645.645 0 01-.475-.191.645.645 0 01-.192-.475c0-.19.064-.348.192-.476a.645.645 0 01.475-.191c.189 0 .347.064.475.191a.645.645 0 01.191.476.645.645 0 01-.191.475.645.645 0 01-.475.191z",
  fill: "#1E1E1E",
  opacity: 0.8
});

var calendarIcon = 'data:image/svg+xml,%3Csvg%20width%3D%2217%22%20height%3D%2216%22%20viewBox%3D%220%200%2017%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20opacity%3D%220.8%22%3E%3Cpath%20d%3D%22M3.83333%2014.6668C3.46667%2014.6668%203.15278%2014.5363%202.89167%2014.2752C2.63056%2014.0141%202.5%2013.7002%202.5%2013.3335V4.00016C2.5%203.6335%202.63056%203.31961%202.89167%203.0585C3.15278%202.79738%203.46667%202.66683%203.83333%202.66683H4.5V2.00016C4.5%201.81127%204.56389%201.65294%204.69167%201.52516C4.81944%201.39738%204.97778%201.3335%205.16667%201.3335C5.35556%201.3335%205.51389%201.39738%205.64167%201.52516C5.76944%201.65294%205.83333%201.81127%205.83333%202.00016V2.66683H11.1667V2.00016C11.1667%201.81127%2011.2306%201.65294%2011.3583%201.52516C11.4861%201.39738%2011.6444%201.3335%2011.8333%201.3335C12.0222%201.3335%2012.1806%201.39738%2012.3083%201.52516C12.4361%201.65294%2012.5%201.81127%2012.5%202.00016V2.66683H13.1667C13.5333%202.66683%2013.8472%202.79738%2014.1083%203.0585C14.3694%203.31961%2014.5%203.6335%2014.5%204.00016V13.3335C14.5%2013.7002%2014.3694%2014.0141%2014.1083%2014.2752C13.8472%2014.5363%2013.5333%2014.6668%2013.1667%2014.6668H3.83333ZM3.83333%2013.3335H13.1667V6.66683H3.83333V13.3335ZM3.83333%205.3335H13.1667V4.00016H3.83333V5.3335ZM8.5%209.3335C8.31111%209.3335%208.15278%209.26961%208.025%209.14183C7.89722%209.01405%207.83333%208.85572%207.83333%208.66683C7.83333%208.47794%207.89722%208.31961%208.025%208.19183C8.15278%208.06405%208.31111%208.00016%208.5%208.00016C8.68889%208.00016%208.84722%208.06405%208.975%208.19183C9.10278%208.31961%209.16667%208.47794%209.16667%208.66683C9.16667%208.85572%209.10278%209.01405%208.975%209.14183C8.84722%209.26961%208.68889%209.3335%208.5%209.3335ZM5.83333%209.3335C5.64444%209.3335%205.48611%209.26961%205.35833%209.14183C5.23056%209.01405%205.16667%208.85572%205.16667%208.66683C5.16667%208.47794%205.23056%208.31961%205.35833%208.19183C5.48611%208.06405%205.64444%208.00016%205.83333%208.00016C6.02222%208.00016%206.18056%208.06405%206.30833%208.19183C6.43611%208.31961%206.5%208.47794%206.5%208.66683C6.5%208.85572%206.43611%209.01405%206.30833%209.14183C6.18056%209.26961%206.02222%209.3335%205.83333%209.3335ZM11.1667%209.3335C10.9778%209.3335%2010.8194%209.26961%2010.6917%209.14183C10.5639%209.01405%2010.5%208.85572%2010.5%208.66683C10.5%208.47794%2010.5639%208.31961%2010.6917%208.19183C10.8194%208.06405%2010.9778%208.00016%2011.1667%208.00016C11.3556%208.00016%2011.5139%208.06405%2011.6417%208.19183C11.7694%208.31961%2011.8333%208.47794%2011.8333%208.66683C11.8333%208.85572%2011.7694%209.01405%2011.6417%209.14183C11.5139%209.26961%2011.3556%209.3335%2011.1667%209.3335ZM8.5%2012.0002C8.31111%2012.0002%208.15278%2011.9363%208.025%2011.8085C7.89722%2011.6807%207.83333%2011.5224%207.83333%2011.3335C7.83333%2011.1446%207.89722%2010.9863%208.025%2010.8585C8.15278%2010.7307%208.31111%2010.6668%208.5%2010.6668C8.68889%2010.6668%208.84722%2010.7307%208.975%2010.8585C9.10278%2010.9863%209.16667%2011.1446%209.16667%2011.3335C9.16667%2011.5224%209.10278%2011.6807%208.975%2011.8085C8.84722%2011.9363%208.68889%2012.0002%208.5%2012.0002ZM5.83333%2012.0002C5.64444%2012.0002%205.48611%2011.9363%205.35833%2011.8085C5.23056%2011.6807%205.16667%2011.5224%205.16667%2011.3335C5.16667%2011.1446%205.23056%2010.9863%205.35833%2010.8585C5.48611%2010.7307%205.64444%2010.6668%205.83333%2010.6668C6.02222%2010.6668%206.18056%2010.7307%206.30833%2010.8585C6.43611%2010.9863%206.5%2011.1446%206.5%2011.3335C6.5%2011.5224%206.43611%2011.6807%206.30833%2011.8085C6.18056%2011.9363%206.02222%2012.0002%205.83333%2012.0002ZM11.1667%2012.0002C10.9778%2012.0002%2010.8194%2011.9363%2010.6917%2011.8085C10.5639%2011.6807%2010.5%2011.5224%2010.5%2011.3335C10.5%2011.1446%2010.5639%2010.9863%2010.6917%2010.8585C10.8194%2010.7307%2010.9778%2010.6668%2011.1667%2010.6668C11.3556%2010.6668%2011.5139%2010.7307%2011.6417%2010.8585C11.7694%2010.9863%2011.8333%2011.1446%2011.8333%2011.3335C11.8333%2011.5224%2011.7694%2011.6807%2011.6417%2011.8085C11.5139%2011.9363%2011.3556%2012.0002%2011.1667%2012.0002Z%22%20fill%3D%22%231E1E1E%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E';

var _templateObject$w = taggedTemplateLiteral(['\n    width: 100%;\n    flex-direction: row;\n    bottom: 0;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    box-sizing: border-box;\n    background: ', ';\n    display: flex;\n    gap: 16px;\n    padding: ', ';\n    border-top: 1px solid\n        ', ';\n    position: ', ';\n    border-radius: ', ';\n    z-index: ', ';\n    left: 0;\n'], ['\n    width: 100%;\n    flex-direction: row;\n    bottom: 0;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    box-sizing: border-box;\n    background: ', ';\n    display: flex;\n    gap: 16px;\n    padding: ', ';\n    border-top: 1px solid\n        ', ';\n    position: ', ';\n    border-radius: ', ';\n    z-index: ', ';\n    left: 0;\n']);

var APPLY_BUTTON_MAX_WIDTH = '320px';

var ButtonsArea$1 = styled.div(_templateObject$w, function (props) {
    return props.theme.colors.colorBackgroundDefault;
}, detectMobile() ? '16px ' : '16px 40px', function (props) {
    return props.theme.colors.colorBackgroundSurfaceTertiaryDefault;
}, function (_ref) {
    var position = _ref.position;
    return position || 'absolute';
}, function (_ref2) {
    var borderRadius = _ref2.borderRadius;
    return borderRadius || '0';
}, function (_ref3) {
    var zIndex = _ref3.zIndex;
    return zIndex || 2;
});

var ButtonArea$1 = function ButtonArea(_ref) {
    var theme = _ref.theme,
        _ref$openChooseDate = _ref.openChooseDate,
        openChooseDate = _ref$openChooseDate === undefined ? function () {} : _ref$openChooseDate,
        _ref$showClearButton = _ref.showClearButton,
        showClearButton = _ref$showClearButton === undefined ? false : _ref$showClearButton,
        _ref$clearChosenDate = _ref.clearChosenDate,
        clearChosenDate = _ref$clearChosenDate === undefined ? function () {} : _ref$clearChosenDate,
        _ref$chosenDate = _ref.chosenDate,
        chosenDate = _ref$chosenDate === undefined ? '' : _ref$chosenDate,
        _ref$buttonsAreaPosit = _ref.buttonsAreaPosition,
        buttonsAreaPosition = _ref$buttonsAreaPosit === undefined ? null : _ref$buttonsAreaPosit;

    return React.createElement(
        ButtonsArea$1,
        {
            position: buttonsAreaPosition !== null ? buttonsAreaPosition : 'absolute',
            zIndex: 13
        },
        showClearButton && React.createElement(
            Button$1,
            {
                maxWidth: APPLY_BUTTON_MAX_WIDTH,
                borderColor: theme.colors.colorBorderPrimaryDefault,
                bgColor: theme.colors.colorBackgroundSurfacePrimaryDefault,
                bgColorHover: theme.colors.colorBackgroundSurfacePrimaryDefault,
                onClick: clearChosenDate
            },
            React.createElement(
                Text,
                {
                    weight: theme.fontWeight,
                    color: theme.colors.colorTextDangerDefault,
                    align: 'center'
                },
                'Nulstil'
            )
        ),
        React.createElement(
            Button$1,
            {
                maxWidth: APPLY_BUTTON_MAX_WIDTH,
                onClick: openChooseDate,
                bgColor: theme.colors.colorBackgroundFillAccentDefault
            },
            React.createElement(Icon, {
                height: '16px',
                width: '16px',
                src: calendarIcon,
                color: theme.colors.colorTextPrimaryDefault
            }),
            React.createElement(
                Text,
                {
                    weight: theme.fontWeight,
                    color: theme.colors.colorTextPrimaryDefault,
                    align: 'center'
                },
                chosenDate.length && showClearButton > 0 ? chosenDate : 'Vælg periode'
            )
        )
    );
};

ButtonsArea$1.propTypes = {};

var ButtonArea$2 = withTheme(ButtonArea$1);

var lottie_light = createCommonjsModule$1(function (module, exports) {
(typeof navigator !== "undefined") && (function (global, factory) {
  module.exports = factory();
})(commonjsGlobal$1, (function () {
  var svgNS = 'http://www.w3.org/2000/svg';
  var locationHref = '';
  var _useWebWorker = false;
  var initialDefaultFrame = -999999;

  var setWebWorker = function setWebWorker(flag) {
    _useWebWorker = !!flag;
  };

  var getWebWorker = function getWebWorker() {
    return _useWebWorker;
  };

  var setLocationHref = function setLocationHref(value) {
    locationHref = value;
  };

  var getLocationHref = function getLocationHref() {
    return locationHref;
  };

  function createTag(type) {
    // return {appendChild:function(){},setAttribute:function(){},style:{}}
    return document.createElement(type);
  }

  function extendPrototype(sources, destination) {
    var i;
    var len = sources.length;
    var sourcePrototype;

    for (i = 0; i < len; i += 1) {
      sourcePrototype = sources[i].prototype;

      for (var attr in sourcePrototype) {
        if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
      }
    }
  }

  function createProxyFunction(prototype) {
    function ProxyFunction() {}

    ProxyFunction.prototype = prototype;
    return ProxyFunction;
  }

  // import Howl from '../../3rd_party/howler';
  var audioControllerFactory = function () {
    function AudioController(audioFactory) {
      this.audios = [];
      this.audioFactory = audioFactory;
      this._volume = 1;
      this._isMuted = false;
    }

    AudioController.prototype = {
      addAudio: function addAudio(audio) {
        this.audios.push(audio);
      },
      pause: function pause() {
        var i;
        var len = this.audios.length;

        for (i = 0; i < len; i += 1) {
          this.audios[i].pause();
        }
      },
      resume: function resume() {
        var i;
        var len = this.audios.length;

        for (i = 0; i < len; i += 1) {
          this.audios[i].resume();
        }
      },
      setRate: function setRate(rateValue) {
        var i;
        var len = this.audios.length;

        for (i = 0; i < len; i += 1) {
          this.audios[i].setRate(rateValue);
        }
      },
      createAudio: function createAudio(assetPath) {
        if (this.audioFactory) {
          return this.audioFactory(assetPath);
        }

        if (window.Howl) {
          return new window.Howl({
            src: [assetPath]
          });
        }

        return {
          isPlaying: false,
          play: function play() {
            this.isPlaying = true;
          },
          seek: function seek() {
            this.isPlaying = false;
          },
          playing: function playing() {},
          rate: function rate() {},
          setVolume: function setVolume() {}
        };
      },
      setAudioFactory: function setAudioFactory(audioFactory) {
        this.audioFactory = audioFactory;
      },
      setVolume: function setVolume(value) {
        this._volume = value;

        this._updateVolume();
      },
      mute: function mute() {
        this._isMuted = true;

        this._updateVolume();
      },
      unmute: function unmute() {
        this._isMuted = false;

        this._updateVolume();
      },
      getVolume: function getVolume() {
        return this._volume;
      },
      _updateVolume: function _updateVolume() {
        var i;
        var len = this.audios.length;

        for (i = 0; i < len; i += 1) {
          this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }
    };
    return function () {
      return new AudioController();
    };
  }();

  var createTypedArray = function () {
    function createRegularArray(type, len) {
      var i = 0;
      var arr = [];
      var value;

      switch (type) {
        case 'int16':
        case 'uint8c':
          value = 1;
          break;

        default:
          value = 1.1;
          break;
      }

      for (i = 0; i < len; i += 1) {
        arr.push(value);
      }

      return arr;
    }

    function createTypedArrayFactory(type, len) {
      if (type === 'float32') {
        return new Float32Array(len);
      }

      if (type === 'int16') {
        return new Int16Array(len);
      }

      if (type === 'uint8c') {
        return new Uint8ClampedArray(len);
      }

      return createRegularArray(type, len);
    }

    if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
      return createTypedArrayFactory;
    }

    return createRegularArray;
  }();

  function createSizedArray(len) {
    return Array.apply(null, {
      length: len
    });
  }

  function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }
  var subframeEnabled = true;
  var expressionsPlugin = null;
  var expressionsInterfaces = null;
  var idPrefix$1 = '';
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  var bmPow = Math.pow;
  var bmSqrt = Math.sqrt;
  var bmFloor = Math.floor;
  var bmMin = Math.min;
  var BMMath = {};

  (function () {
    var propertyNames = ['abs', 'acos', 'acosh', 'asin', 'asinh', 'atan', 'atanh', 'atan2', 'ceil', 'cbrt', 'expm1', 'clz32', 'cos', 'cosh', 'exp', 'floor', 'fround', 'hypot', 'imul', 'log', 'log1p', 'log2', 'log10', 'max', 'min', 'pow', 'random', 'round', 'sign', 'sin', 'sinh', 'sqrt', 'tan', 'tanh', 'trunc', 'E', 'LN10', 'LN2', 'LOG10E', 'LOG2E', 'PI', 'SQRT1_2', 'SQRT2'];
    var i;
    var len = propertyNames.length;

    for (i = 0; i < len; i += 1) {
      BMMath[propertyNames[i]] = Math[propertyNames[i]];
    }
  })();

  BMMath.random = Math.random;

  BMMath.abs = function (val) {
    var tOfVal = _typeof$3(val);

    if (tOfVal === 'object' && val.length) {
      var absArr = createSizedArray(val.length);
      var i;
      var len = val.length;

      for (i = 0; i < len; i += 1) {
        absArr[i] = Math.abs(val[i]);
      }

      return absArr;
    }

    return Math.abs(val);
  };

  var defaultCurveSegments = 150;
  var degToRads = Math.PI / 180;
  var roundCorner = 0.5519;

  function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
    this.type = type;
    this.currentTime = currentTime;
    this.totalTime = totalTime;
    this.direction = frameMultiplier < 0 ? -1 : 1;
  }

  function BMCompleteEvent(type, frameMultiplier) {
    this.type = type;
    this.direction = frameMultiplier < 0 ? -1 : 1;
  }

  function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
    this.type = type;
    this.currentLoop = currentLoop;
    this.totalLoops = totalLoops;
    this.direction = frameMultiplier < 0 ? -1 : 1;
  }

  function BMSegmentStartEvent(type, firstFrame, totalFrames) {
    this.type = type;
    this.firstFrame = firstFrame;
    this.totalFrames = totalFrames;
  }

  function BMDestroyEvent(type, target) {
    this.type = type;
    this.target = target;
  }

  function BMRenderFrameErrorEvent(nativeError, currentTime) {
    this.type = 'renderFrameError';
    this.nativeError = nativeError;
    this.currentTime = currentTime;
  }

  function BMConfigErrorEvent(nativeError) {
    this.type = 'configError';
    this.nativeError = nativeError;
  }

  var createElementID = function () {
    var _count = 0;
    return function createID() {
      _count += 1;
      return idPrefix$1 + '__lottie_element_' + _count;
    };
  }();

  function HSVtoRGB(h, s, v) {
    var r;
    var g;
    var b;
    var i;
    var f;
    var p;
    var q;
    var t;
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);

    switch (i % 6) {
      case 0:
        r = v;
        g = t;
        b = p;
        break;

      case 1:
        r = q;
        g = v;
        b = p;
        break;

      case 2:
        r = p;
        g = v;
        b = t;
        break;

      case 3:
        r = p;
        g = q;
        b = v;
        break;

      case 4:
        r = t;
        g = p;
        b = v;
        break;

      case 5:
        r = v;
        g = p;
        b = q;
        break;

      default:
        break;
    }

    return [r, g, b];
  }

  function RGBtoHSV(r, g, b) {
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var d = max - min;
    var h;
    var s = max === 0 ? 0 : d / max;
    var v = max / 255;

    switch (max) {
      case min:
        h = 0;
        break;

      case r:
        h = g - b + d * (g < b ? 6 : 0);
        h /= 6 * d;
        break;

      case g:
        h = b - r + d * 2;
        h /= 6 * d;
        break;

      case b:
        h = r - g + d * 4;
        h /= 6 * d;
        break;

      default:
        break;
    }

    return [h, s, v];
  }

  function addSaturationToRGB(color, offset) {
    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[1] += offset;

    if (hsv[1] > 1) {
      hsv[1] = 1;
    } else if (hsv[1] <= 0) {
      hsv[1] = 0;
    }

    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
  }

  function addBrightnessToRGB(color, offset) {
    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[2] += offset;

    if (hsv[2] > 1) {
      hsv[2] = 1;
    } else if (hsv[2] < 0) {
      hsv[2] = 0;
    }

    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
  }

  function addHueToRGB(color, offset) {
    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[0] += offset / 360;

    if (hsv[0] > 1) {
      hsv[0] -= 1;
    } else if (hsv[0] < 0) {
      hsv[0] += 1;
    }

    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
  }

  var rgbToHex = function () {
    var colorMap = [];
    var i;
    var hex;

    for (i = 0; i < 256; i += 1) {
      hex = i.toString(16);
      colorMap[i] = hex.length === 1 ? '0' + hex : hex;
    }

    return function (r, g, b) {
      if (r < 0) {
        r = 0;
      }

      if (g < 0) {
        g = 0;
      }

      if (b < 0) {
        b = 0;
      }

      return '#' + colorMap[r] + colorMap[g] + colorMap[b];
    };
  }();

  var setSubframeEnabled = function setSubframeEnabled(flag) {
    subframeEnabled = !!flag;
  };

  var getSubframeEnabled = function getSubframeEnabled() {
    return subframeEnabled;
  };

  var setExpressionsPlugin = function setExpressionsPlugin(value) {
    expressionsPlugin = value;
  };

  var getExpressionsPlugin = function getExpressionsPlugin() {
    return expressionsPlugin;
  };

  var getExpressionInterfaces = function getExpressionInterfaces() {
    return expressionsInterfaces;
  };

  var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
    defaultCurveSegments = value;
  };

  var getDefaultCurveSegments = function getDefaultCurveSegments() {
    return defaultCurveSegments;
  };

  var setIdPrefix = function setIdPrefix(value) {
    idPrefix$1 = value;
  };

  function createNS(type) {
    // return {appendChild:function(){},setAttribute:function(){},style:{}}
    return document.createElementNS(svgNS, type);
  }

  function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

  var dataManager = function () {
    var _counterId = 1;
    var processes = [];
    var workerFn;
    var workerInstance;
    var workerProxy = {
      onmessage: function onmessage() {},
      postMessage: function postMessage(path) {
        workerFn({
          data: path
        });
      }
    };
    var _workerSelf = {
      postMessage: function postMessage(data) {
        workerProxy.onmessage({
          data: data
        });
      }
    };

    function createWorker(fn) {
      if (window.Worker && window.Blob && getWebWorker()) {
        var blob = new Blob(['var _workerSelf = self; self.onmessage = ', fn.toString()], {
          type: 'text/javascript'
        }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });

        var url = URL.createObjectURL(blob);
        return new Worker(url);
      }

      workerFn = fn;
      return workerProxy;
    }

    function setupWorker() {
      if (!workerInstance) {
        workerInstance = createWorker(function workerStart(e) {
          function dataFunctionManager() {
            function completeLayers(layers, comps) {
              var layerData;
              var i;
              var len = layers.length;
              var j;
              var jLen;
              var k;
              var kLen;

              for (i = 0; i < len; i += 1) {
                layerData = layers[i];

                if ('ks' in layerData && !layerData.completed) {
                  layerData.completed = true;

                  if (layerData.hasMask) {
                    var maskProps = layerData.masksProperties;
                    jLen = maskProps.length;

                    for (j = 0; j < jLen; j += 1) {
                      if (maskProps[j].pt.k.i) {
                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
                      } else {
                        kLen = maskProps[j].pt.k.length;

                        for (k = 0; k < kLen; k += 1) {
                          if (maskProps[j].pt.k[k].s) {
                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                          }

                          if (maskProps[j].pt.k[k].e) {
                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                          }
                        }
                      }
                    }
                  }

                  if (layerData.ty === 0) {
                    layerData.layers = findCompLayers(layerData.refId, comps);
                    completeLayers(layerData.layers, comps);
                  } else if (layerData.ty === 4) {
                    completeShapes(layerData.shapes);
                  } else if (layerData.ty === 5) {
                    completeText(layerData);
                  }
                }
              }
            }

            function completeChars(chars, assets) {
              if (chars) {
                var i = 0;
                var len = chars.length;

                for (i = 0; i < len; i += 1) {
                  if (chars[i].t === 1) {
                    // var compData = findComp(chars[i].data.refId, assets);
                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
                    // chars[i].data.op = 99999;
                    // chars[i].data.st = 0;
                    // chars[i].data.sr = 1;
                    // chars[i].w = compData.w;
                    // chars[i].data.ks = {
                    //   a: { k: [0, 0, 0], a: 0 },
                    //   p: { k: [0, -compData.h, 0], a: 0 },
                    //   r: { k: 0, a: 0 },
                    //   s: { k: [100, 100], a: 0 },
                    //   o: { k: 100, a: 0 },
                    // };

                    completeLayers(chars[i].data.layers, assets);
                  }
                }
              }
            }

            function findComp(id, comps) {
              var i = 0;
              var len = comps.length;

              while (i < len) {
                if (comps[i].id === id) {
                  return comps[i];
                }

                i += 1;
              }

              return null;
            }

            function findCompLayers(id, comps) {
              var comp = findComp(id, comps);

              if (comp) {
                if (!comp.layers.__used) {
                  comp.layers.__used = true;
                  return comp.layers;
                }

                return JSON.parse(JSON.stringify(comp.layers));
              }

              return null;
            }

            function completeShapes(arr) {
              var i;
              var len = arr.length;
              var j;
              var jLen;

              for (i = len - 1; i >= 0; i -= 1) {
                if (arr[i].ty === 'sh') {
                  if (arr[i].ks.k.i) {
                    convertPathsToAbsoluteValues(arr[i].ks.k);
                  } else {
                    jLen = arr[i].ks.k.length;

                    for (j = 0; j < jLen; j += 1) {
                      if (arr[i].ks.k[j].s) {
                        convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                      }

                      if (arr[i].ks.k[j].e) {
                        convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                      }
                    }
                  }
                } else if (arr[i].ty === 'gr') {
                  completeShapes(arr[i].it);
                }
              }
            }

            function convertPathsToAbsoluteValues(path) {
              var i;
              var len = path.i.length;

              for (i = 0; i < len; i += 1) {
                path.i[i][0] += path.v[i][0];
                path.i[i][1] += path.v[i][1];
                path.o[i][0] += path.v[i][0];
                path.o[i][1] += path.v[i][1];
              }
            }

            function checkVersion(minimum, animVersionString) {
              var animVersion = animVersionString ? animVersionString.split('.') : [100, 100, 100];

              if (minimum[0] > animVersion[0]) {
                return true;
              }

              if (animVersion[0] > minimum[0]) {
                return false;
              }

              if (minimum[1] > animVersion[1]) {
                return true;
              }

              if (animVersion[1] > minimum[1]) {
                return false;
              }

              if (minimum[2] > animVersion[2]) {
                return true;
              }

              if (animVersion[2] > minimum[2]) {
                return false;
              }

              return null;
            }

            var checkText = function () {
              var minimumVersion = [4, 4, 14];

              function updateTextLayer(textLayer) {
                var documentData = textLayer.t.d;
                textLayer.t.d = {
                  k: [{
                    s: documentData,
                    t: 0
                  }]
                };
              }

              function iterateLayers(layers) {
                var i;
                var len = layers.length;

                for (i = 0; i < len; i += 1) {
                  if (layers[i].ty === 5) {
                    updateTextLayer(layers[i]);
                  }
                }
              }

              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);

                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;

                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();

            var checkChars = function () {
              var minimumVersion = [4, 7, 99];
              return function (animationData) {
                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                  var i;
                  var len = animationData.chars.length;

                  for (i = 0; i < len; i += 1) {
                    var charData = animationData.chars[i];

                    if (charData.data && charData.data.shapes) {
                      completeShapes(charData.data.shapes);
                      charData.data.ip = 0;
                      charData.data.op = 99999;
                      charData.data.st = 0;
                      charData.data.sr = 1;
                      charData.data.ks = {
                        p: {
                          k: [0, 0],
                          a: 0
                        },
                        s: {
                          k: [100, 100],
                          a: 0
                        },
                        a: {
                          k: [0, 0],
                          a: 0
                        },
                        r: {
                          k: 0,
                          a: 0
                        },
                        o: {
                          k: 100,
                          a: 0
                        }
                      };

                      if (!animationData.chars[i].t) {
                        charData.data.shapes.push({
                          ty: 'no'
                        });
                        charData.data.shapes[0].it.push({
                          p: {
                            k: [0, 0],
                            a: 0
                          },
                          s: {
                            k: [100, 100],
                            a: 0
                          },
                          a: {
                            k: [0, 0],
                            a: 0
                          },
                          r: {
                            k: 0,
                            a: 0
                          },
                          o: {
                            k: 100,
                            a: 0
                          },
                          sk: {
                            k: 0,
                            a: 0
                          },
                          sa: {
                            k: 0,
                            a: 0
                          },
                          ty: 'tr'
                        });
                      }
                    }
                  }
                }
              };
            }();

            var checkPathProperties = function () {
              var minimumVersion = [5, 7, 15];

              function updateTextLayer(textLayer) {
                var pathData = textLayer.t.p;

                if (typeof pathData.a === 'number') {
                  pathData.a = {
                    a: 0,
                    k: pathData.a
                  };
                }

                if (typeof pathData.p === 'number') {
                  pathData.p = {
                    a: 0,
                    k: pathData.p
                  };
                }

                if (typeof pathData.r === 'number') {
                  pathData.r = {
                    a: 0,
                    k: pathData.r
                  };
                }
              }

              function iterateLayers(layers) {
                var i;
                var len = layers.length;

                for (i = 0; i < len; i += 1) {
                  if (layers[i].ty === 5) {
                    updateTextLayer(layers[i]);
                  }
                }
              }

              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);

                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;

                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();

            var checkColors = function () {
              var minimumVersion = [4, 1, 9];

              function iterateShapes(shapes) {
                var i;
                var len = shapes.length;
                var j;
                var jLen;

                for (i = 0; i < len; i += 1) {
                  if (shapes[i].ty === 'gr') {
                    iterateShapes(shapes[i].it);
                  } else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                    if (shapes[i].c.k && shapes[i].c.k[0].i) {
                      jLen = shapes[i].c.k.length;

                      for (j = 0; j < jLen; j += 1) {
                        if (shapes[i].c.k[j].s) {
                          shapes[i].c.k[j].s[0] /= 255;
                          shapes[i].c.k[j].s[1] /= 255;
                          shapes[i].c.k[j].s[2] /= 255;
                          shapes[i].c.k[j].s[3] /= 255;
                        }

                        if (shapes[i].c.k[j].e) {
                          shapes[i].c.k[j].e[0] /= 255;
                          shapes[i].c.k[j].e[1] /= 255;
                          shapes[i].c.k[j].e[2] /= 255;
                          shapes[i].c.k[j].e[3] /= 255;
                        }
                      }
                    } else {
                      shapes[i].c.k[0] /= 255;
                      shapes[i].c.k[1] /= 255;
                      shapes[i].c.k[2] /= 255;
                      shapes[i].c.k[3] /= 255;
                    }
                  }
                }
              }

              function iterateLayers(layers) {
                var i;
                var len = layers.length;

                for (i = 0; i < len; i += 1) {
                  if (layers[i].ty === 4) {
                    iterateShapes(layers[i].shapes);
                  }
                }
              }

              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);

                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;

                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();

            var checkShapes = function () {
              var minimumVersion = [4, 4, 18];

              function completeClosingShapes(arr) {
                var i;
                var len = arr.length;
                var j;
                var jLen;

                for (i = len - 1; i >= 0; i -= 1) {
                  if (arr[i].ty === 'sh') {
                    if (arr[i].ks.k.i) {
                      arr[i].ks.k.c = arr[i].closed;
                    } else {
                      jLen = arr[i].ks.k.length;

                      for (j = 0; j < jLen; j += 1) {
                        if (arr[i].ks.k[j].s) {
                          arr[i].ks.k[j].s[0].c = arr[i].closed;
                        }

                        if (arr[i].ks.k[j].e) {
                          arr[i].ks.k[j].e[0].c = arr[i].closed;
                        }
                      }
                    }
                  } else if (arr[i].ty === 'gr') {
                    completeClosingShapes(arr[i].it);
                  }
                }
              }

              function iterateLayers(layers) {
                var layerData;
                var i;
                var len = layers.length;
                var j;
                var jLen;
                var k;
                var kLen;

                for (i = 0; i < len; i += 1) {
                  layerData = layers[i];

                  if (layerData.hasMask) {
                    var maskProps = layerData.masksProperties;
                    jLen = maskProps.length;

                    for (j = 0; j < jLen; j += 1) {
                      if (maskProps[j].pt.k.i) {
                        maskProps[j].pt.k.c = maskProps[j].cl;
                      } else {
                        kLen = maskProps[j].pt.k.length;

                        for (k = 0; k < kLen; k += 1) {
                          if (maskProps[j].pt.k[k].s) {
                            maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                          }

                          if (maskProps[j].pt.k[k].e) {
                            maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                          }
                        }
                      }
                    }
                  }

                  if (layerData.ty === 4) {
                    completeClosingShapes(layerData.shapes);
                  }
                }
              }

              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);

                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;

                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();

            function completeData(animationData) {
              if (animationData.__complete) {
                return;
              }

              checkColors(animationData);
              checkText(animationData);
              checkChars(animationData);
              checkPathProperties(animationData);
              checkShapes(animationData);
              completeLayers(animationData.layers, animationData.assets);
              completeChars(animationData.chars, animationData.assets);
              animationData.__complete = true;
            }

            function completeText(data) {
              if (data.t.a.length === 0 && !('m' in data.t.p)) ;
            }

            var moduleOb = {};
            moduleOb.completeData = completeData;
            moduleOb.checkColors = checkColors;
            moduleOb.checkChars = checkChars;
            moduleOb.checkPathProperties = checkPathProperties;
            moduleOb.checkShapes = checkShapes;
            moduleOb.completeLayers = completeLayers;
            return moduleOb;
          }

          if (!_workerSelf.dataManager) {
            _workerSelf.dataManager = dataFunctionManager();
          }

          if (!_workerSelf.assetLoader) {
            _workerSelf.assetLoader = function () {
              function formatResponse(xhr) {
                // using typeof doubles the time of execution of this method,
                // so if available, it's better to use the header to validate the type
                var contentTypeHeader = xhr.getResponseHeader('content-type');

                if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) {
                  return xhr.response;
                }

                if (xhr.response && _typeof$2(xhr.response) === 'object') {
                  return xhr.response;
                }

                if (xhr.response && typeof xhr.response === 'string') {
                  return JSON.parse(xhr.response);
                }

                if (xhr.responseText) {
                  return JSON.parse(xhr.responseText);
                }

                return null;
              }

              function loadAsset(path, fullPath, callback, errorCallback) {
                var response;
                var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.

                try {
                  // This crashes on Android WebView prior to KitKat
                  xhr.responseType = 'json';
                } catch (err) {} // eslint-disable-line no-empty


                xhr.onreadystatechange = function () {
                  if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                      response = formatResponse(xhr);
                      callback(response);
                    } else {
                      try {
                        response = formatResponse(xhr);
                        callback(response);
                      } catch (err) {
                        if (errorCallback) {
                          errorCallback(err);
                        }
                      }
                    }
                  }
                };

                try {
                  // Hack to workaround banner validation
                  xhr.open(['G', 'E', 'T'].join(''), path, true);
                } catch (error) {
                  // Hack to workaround banner validation
                  xhr.open(['G', 'E', 'T'].join(''), fullPath + '/' + path, true);
                }

                xhr.send();
              }

              return {
                load: loadAsset
              };
            }();
          }

          if (e.data.type === 'loadAnimation') {
            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
              _workerSelf.dataManager.completeData(data);

              _workerSelf.postMessage({
                id: e.data.id,
                payload: data,
                status: 'success'
              });
            }, function () {
              _workerSelf.postMessage({
                id: e.data.id,
                status: 'error'
              });
            });
          } else if (e.data.type === 'complete') {
            var animation = e.data.animation;

            _workerSelf.dataManager.completeData(animation);

            _workerSelf.postMessage({
              id: e.data.id,
              payload: animation,
              status: 'success'
            });
          } else if (e.data.type === 'loadData') {
            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
              _workerSelf.postMessage({
                id: e.data.id,
                payload: data,
                status: 'success'
              });
            }, function () {
              _workerSelf.postMessage({
                id: e.data.id,
                status: 'error'
              });
            });
          }
        });

        workerInstance.onmessage = function (event) {
          var data = event.data;
          var id = data.id;
          var process = processes[id];
          processes[id] = null;

          if (data.status === 'success') {
            process.onComplete(data.payload);
          } else if (process.onError) {
            process.onError();
          }
        };
      }
    }

    function createProcess(onComplete, onError) {
      _counterId += 1;
      var id = 'processId_' + _counterId;
      processes[id] = {
        onComplete: onComplete,
        onError: onError
      };
      return id;
    }

    function loadAnimation(path, onComplete, onError) {
      setupWorker();
      var processId = createProcess(onComplete, onError);
      workerInstance.postMessage({
        type: 'loadAnimation',
        path: path,
        fullPath: window.location.origin + window.location.pathname,
        id: processId
      });
    }

    function loadData(path, onComplete, onError) {
      setupWorker();
      var processId = createProcess(onComplete, onError);
      workerInstance.postMessage({
        type: 'loadData',
        path: path,
        fullPath: window.location.origin + window.location.pathname,
        id: processId
      });
    }

    function completeAnimation(anim, onComplete, onError) {
      setupWorker();
      var processId = createProcess(onComplete, onError);
      workerInstance.postMessage({
        type: 'complete',
        animation: anim,
        id: processId
      });
    }

    return {
      loadAnimation: loadAnimation,
      loadData: loadData,
      completeAnimation: completeAnimation
    };
  }();

  var ImagePreloader = function () {
    var proxyImage = function () {
      var canvas = createTag('canvas');
      canvas.width = 1;
      canvas.height = 1;
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = 'rgba(0,0,0,0)';
      ctx.fillRect(0, 0, 1, 1);
      return canvas;
    }();

    function imageLoaded() {
      this.loadedAssets += 1;

      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
        if (this.imagesLoadedCb) {
          this.imagesLoadedCb(null);
        }
      }
    }

    function footageLoaded() {
      this.loadedFootagesCount += 1;

      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
        if (this.imagesLoadedCb) {
          this.imagesLoadedCb(null);
        }
      }
    }

    function getAssetsPath(assetData, assetsPath, originalPath) {
      var path = '';

      if (assetData.e) {
        path = assetData.p;
      } else if (assetsPath) {
        var imagePath = assetData.p;

        if (imagePath.indexOf('images/') !== -1) {
          imagePath = imagePath.split('/')[1];
        }

        path = assetsPath + imagePath;
      } else {
        path = originalPath;
        path += assetData.u ? assetData.u : '';
        path += assetData.p;
      }

      return path;
    }

    function testImageLoaded(img) {
      var _count = 0;
      var intervalId = setInterval(function () {
        var box = img.getBBox();

        if (box.width || _count > 500) {
          this._imageLoaded();

          clearInterval(intervalId);
        }

        _count += 1;
      }.bind(this), 50);
    }

    function createImageData(assetData) {
      var path = getAssetsPath(assetData, this.assetsPath, this.path);
      var img = createNS('image');

      if (isSafari) {
        this.testImageLoaded(img);
      } else {
        img.addEventListener('load', this._imageLoaded, false);
      }

      img.addEventListener('error', function () {
        ob.img = proxyImage;

        this._imageLoaded();
      }.bind(this), false);
      img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);

      if (this._elementHelper.append) {
        this._elementHelper.append(img);
      } else {
        this._elementHelper.appendChild(img);
      }

      var ob = {
        img: img,
        assetData: assetData
      };
      return ob;
    }

    function createImgData(assetData) {
      var path = getAssetsPath(assetData, this.assetsPath, this.path);
      var img = createTag('img');
      img.crossOrigin = 'anonymous';
      img.addEventListener('load', this._imageLoaded, false);
      img.addEventListener('error', function () {
        ob.img = proxyImage;

        this._imageLoaded();
      }.bind(this), false);
      img.src = path;
      var ob = {
        img: img,
        assetData: assetData
      };
      return ob;
    }

    function createFootageData(data) {
      var ob = {
        assetData: data
      };
      var path = getAssetsPath(data, this.assetsPath, this.path);
      dataManager.loadData(path, function (footageData) {
        ob.img = footageData;

        this._footageLoaded();
      }.bind(this), function () {
        ob.img = {};

        this._footageLoaded();
      }.bind(this));
      return ob;
    }

    function loadAssets(assets, cb) {
      this.imagesLoadedCb = cb;
      var i;
      var len = assets.length;

      for (i = 0; i < len; i += 1) {
        if (!assets[i].layers) {
          if (!assets[i].t || assets[i].t === 'seq') {
            this.totalImages += 1;
            this.images.push(this._createImageData(assets[i]));
          } else if (assets[i].t === 3) {
            this.totalFootages += 1;
            this.images.push(this.createFootageData(assets[i]));
          }
        }
      }
    }

    function setPath(path) {
      this.path = path || '';
    }

    function setAssetsPath(path) {
      this.assetsPath = path || '';
    }

    function getAsset(assetData) {
      var i = 0;
      var len = this.images.length;

      while (i < len) {
        if (this.images[i].assetData === assetData) {
          return this.images[i].img;
        }

        i += 1;
      }

      return null;
    }

    function destroy() {
      this.imagesLoadedCb = null;
      this.images.length = 0;
    }

    function loadedImages() {
      return this.totalImages === this.loadedAssets;
    }

    function loadedFootages() {
      return this.totalFootages === this.loadedFootagesCount;
    }

    function setCacheType(type, elementHelper) {
      if (type === 'svg') {
        this._elementHelper = elementHelper;
        this._createImageData = this.createImageData.bind(this);
      } else {
        this._createImageData = this.createImgData.bind(this);
      }
    }

    function ImagePreloaderFactory() {
      this._imageLoaded = imageLoaded.bind(this);
      this._footageLoaded = footageLoaded.bind(this);
      this.testImageLoaded = testImageLoaded.bind(this);
      this.createFootageData = createFootageData.bind(this);
      this.assetsPath = '';
      this.path = '';
      this.totalImages = 0;
      this.totalFootages = 0;
      this.loadedAssets = 0;
      this.loadedFootagesCount = 0;
      this.imagesLoadedCb = null;
      this.images = [];
    }

    ImagePreloaderFactory.prototype = {
      loadAssets: loadAssets,
      setAssetsPath: setAssetsPath,
      setPath: setPath,
      loadedImages: loadedImages,
      loadedFootages: loadedFootages,
      destroy: destroy,
      getAsset: getAsset,
      createImgData: createImgData,
      createImageData: createImageData,
      imageLoaded: imageLoaded,
      footageLoaded: footageLoaded,
      setCacheType: setCacheType
    };
    return ImagePreloaderFactory;
  }();

  function BaseEvent() {}

  BaseEvent.prototype = {
    triggerEvent: function triggerEvent(eventName, args) {
      if (this._cbs[eventName]) {
        var callbacks = this._cbs[eventName];

        for (var i = 0; i < callbacks.length; i += 1) {
          callbacks[i](args);
        }
      }
    },
    addEventListener: function addEventListener(eventName, callback) {
      if (!this._cbs[eventName]) {
        this._cbs[eventName] = [];
      }

      this._cbs[eventName].push(callback);

      return function () {
        this.removeEventListener(eventName, callback);
      }.bind(this);
    },
    removeEventListener: function removeEventListener(eventName, callback) {
      if (!callback) {
        this._cbs[eventName] = null;
      } else if (this._cbs[eventName]) {
        var i = 0;
        var len = this._cbs[eventName].length;

        while (i < len) {
          if (this._cbs[eventName][i] === callback) {
            this._cbs[eventName].splice(i, 1);

            i -= 1;
            len -= 1;
          }

          i += 1;
        }

        if (!this._cbs[eventName].length) {
          this._cbs[eventName] = null;
        }
      }
    }
  };

  var markerParser = function () {
    function parsePayloadLines(payload) {
      var lines = payload.split('\r\n');
      var keys = {};
      var line;
      var keysCount = 0;

      for (var i = 0; i < lines.length; i += 1) {
        line = lines[i].split(':');

        if (line.length === 2) {
          keys[line[0]] = line[1].trim();
          keysCount += 1;
        }
      }

      if (keysCount === 0) {
        throw new Error();
      }

      return keys;
    }

    return function (_markers) {
      var markers = [];

      for (var i = 0; i < _markers.length; i += 1) {
        var _marker = _markers[i];
        var markerData = {
          time: _marker.tm,
          duration: _marker.dr
        };

        try {
          markerData.payload = JSON.parse(_markers[i].cm);
        } catch (_) {
          try {
            markerData.payload = parsePayloadLines(_markers[i].cm);
          } catch (__) {
            markerData.payload = {
              name: _markers[i].cm
            };
          }
        }

        markers.push(markerData);
      }

      return markers;
    };
  }();

  var ProjectInterface = function () {
    function registerComposition(comp) {
      this.compositions.push(comp);
    }

    return function () {
      function _thisProjectFunction(name) {
        var i = 0;
        var len = this.compositions.length;

        while (i < len) {
          if (this.compositions[i].data && this.compositions[i].data.nm === name) {
            if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
              this.compositions[i].prepareFrame(this.currentFrame);
            }

            return this.compositions[i].compInterface;
          }

          i += 1;
        }

        return null;
      }

      _thisProjectFunction.compositions = [];
      _thisProjectFunction.currentFrame = 0;
      _thisProjectFunction.registerComposition = registerComposition;
      return _thisProjectFunction;
    };
  }();

  var renderers = {};

  var registerRenderer = function registerRenderer(key, value) {
    renderers[key] = value;
  };

  function getRenderer(key) {
    return renderers[key];
  }

  function getRegisteredRenderer() {
    // Returns canvas by default for compatibility
    if (renderers.canvas) {
      return 'canvas';
    } // Returns any renderer that is registered


    for (var key in renderers) {
      if (renderers[key]) {
        return key;
      }
    }

    return '';
  }

  function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

  var AnimationItem = function AnimationItem() {
    this._cbs = [];
    this.name = '';
    this.path = '';
    this.isLoaded = false;
    this.currentFrame = 0;
    this.currentRawFrame = 0;
    this.firstFrame = 0;
    this.totalFrames = 0;
    this.frameRate = 0;
    this.frameMult = 0;
    this.playSpeed = 1;
    this.playDirection = 1;
    this.playCount = 0;
    this.animationData = {};
    this.assets = [];
    this.isPaused = true;
    this.autoplay = false;
    this.loop = true;
    this.renderer = null;
    this.animationID = createElementID();
    this.assetsPath = '';
    this.timeCompleted = 0;
    this.segmentPos = 0;
    this.isSubframeEnabled = getSubframeEnabled();
    this.segments = [];
    this._idle = true;
    this._completedLoop = false;
    this.projectInterface = ProjectInterface();
    this.imagePreloader = new ImagePreloader();
    this.audioController = audioControllerFactory();
    this.markers = [];
    this.configAnimation = this.configAnimation.bind(this);
    this.onSetupError = this.onSetupError.bind(this);
    this.onSegmentComplete = this.onSegmentComplete.bind(this);
    this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
    this.expressionsPlugin = getExpressionsPlugin();
  };

  extendPrototype([BaseEvent], AnimationItem);

  AnimationItem.prototype.setParams = function (params) {
    if (params.wrapper || params.container) {
      this.wrapper = params.wrapper || params.container;
    }

    var animType = 'svg';

    if (params.animType) {
      animType = params.animType;
    } else if (params.renderer) {
      animType = params.renderer;
    }

    var RendererClass = getRenderer(animType);
    this.renderer = new RendererClass(this, params.rendererSettings);
    this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
    this.renderer.setProjectInterface(this.projectInterface);
    this.animType = animType;

    if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) {
      this.loop = true;
    } else if (params.loop === false) {
      this.loop = false;
    } else {
      this.loop = parseInt(params.loop, 10);
    }

    this.autoplay = 'autoplay' in params ? params.autoplay : true;
    this.name = params.name ? params.name : '';
    this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
    this.assetsPath = params.assetsPath;
    this.initialSegment = params.initialSegment;

    if (params.audioFactory) {
      this.audioController.setAudioFactory(params.audioFactory);
    }

    if (params.animationData) {
      this.setupAnimation(params.animationData);
    } else if (params.path) {
      if (params.path.lastIndexOf('\\') !== -1) {
        this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
      } else {
        this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
      }

      this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
      this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
      dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
    }
  };

  AnimationItem.prototype.onSetupError = function () {
    this.trigger('data_failed');
  };

  AnimationItem.prototype.setupAnimation = function (data) {
    dataManager.completeAnimation(data, this.configAnimation);
  };

  AnimationItem.prototype.setData = function (wrapper, animationData) {
    if (animationData) {
      if (_typeof$1(animationData) !== 'object') {
        animationData = JSON.parse(animationData);
      }
    }

    var params = {
      wrapper: wrapper,
      animationData: animationData
    };
    var wrapperAttributes = wrapper.attributes;
    params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
    params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
    var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';

    if (loop === 'false') {
      params.loop = false;
    } else if (loop === 'true') {
      params.loop = true;
    } else if (loop !== '') {
      params.loop = parseInt(loop, 10);
    }

    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
    params.autoplay = autoplay !== 'false';
    params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';

    if (prerender === 'false') {
      params.prerender = false;
    }

    if (!params.path) {
      this.trigger('destroy');
    } else {
      this.setParams(params);
    }
  };

  AnimationItem.prototype.includeLayers = function (data) {
    if (data.op > this.animationData.op) {
      this.animationData.op = data.op;
      this.totalFrames = Math.floor(data.op - this.animationData.ip);
    }

    var layers = this.animationData.layers;
    var i;
    var len = layers.length;
    var newLayers = data.layers;
    var j;
    var jLen = newLayers.length;

    for (j = 0; j < jLen; j += 1) {
      i = 0;

      while (i < len) {
        if (layers[i].id === newLayers[j].id) {
          layers[i] = newLayers[j];
          break;
        }

        i += 1;
      }
    }

    if (data.chars || data.fonts) {
      this.renderer.globalData.fontManager.addChars(data.chars);
      this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
    }

    if (data.assets) {
      len = data.assets.length;

      for (i = 0; i < len; i += 1) {
        this.animationData.assets.push(data.assets[i]);
      }
    }

    this.animationData.__complete = false;
    dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
  };

  AnimationItem.prototype.onSegmentComplete = function (data) {
    this.animationData = data;
    var expressionsPlugin = getExpressionsPlugin();

    if (expressionsPlugin) {
      expressionsPlugin.initExpressions(this);
    }

    this.loadNextSegment();
  };

  AnimationItem.prototype.loadNextSegment = function () {
    var segments = this.animationData.segments;

    if (!segments || segments.length === 0 || !this.autoloadSegments) {
      this.trigger('data_ready');
      this.timeCompleted = this.totalFrames;
      return;
    }

    var segment = segments.shift();
    this.timeCompleted = segment.time * this.frameRate;
    var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
    this.segmentPos += 1;
    dataManager.loadData(segmentPath, this.includeLayers.bind(this), function () {
      this.trigger('data_failed');
    }.bind(this));
  };

  AnimationItem.prototype.loadSegments = function () {
    var segments = this.animationData.segments;

    if (!segments) {
      this.timeCompleted = this.totalFrames;
    }

    this.loadNextSegment();
  };

  AnimationItem.prototype.imagesLoaded = function () {
    this.trigger('loaded_images');
    this.checkLoaded();
  };

  AnimationItem.prototype.preloadImages = function () {
    this.imagePreloader.setAssetsPath(this.assetsPath);
    this.imagePreloader.setPath(this.path);
    this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
  };

  AnimationItem.prototype.configAnimation = function (animData) {
    if (!this.renderer) {
      return;
    }

    try {
      this.animationData = animData;

      if (this.initialSegment) {
        this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
        this.firstFrame = Math.round(this.initialSegment[0]);
      } else {
        this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
        this.firstFrame = Math.round(this.animationData.ip);
      }

      this.renderer.configAnimation(animData);

      if (!animData.assets) {
        animData.assets = [];
      }

      this.assets = this.animationData.assets;
      this.frameRate = this.animationData.fr;
      this.frameMult = this.animationData.fr / 1000;
      this.renderer.searchExtraCompositions(animData.assets);
      this.markers = markerParser(animData.markers || []);
      this.trigger('config_ready');
      this.preloadImages();
      this.loadSegments();
      this.updaFrameModifier();
      this.waitForFontsLoaded();

      if (this.isPaused) {
        this.audioController.pause();
      }
    } catch (error) {
      this.triggerConfigError(error);
    }
  };

  AnimationItem.prototype.waitForFontsLoaded = function () {
    if (!this.renderer) {
      return;
    }

    if (this.renderer.globalData.fontManager.isLoaded) {
      this.checkLoaded();
    } else {
      setTimeout(this.waitForFontsLoaded.bind(this), 20);
    }
  };

  AnimationItem.prototype.checkLoaded = function () {
    if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
      this.isLoaded = true;
      var expressionsPlugin = getExpressionsPlugin();

      if (expressionsPlugin) {
        expressionsPlugin.initExpressions(this);
      }

      this.renderer.initItems();
      setTimeout(function () {
        this.trigger('DOMLoaded');
      }.bind(this), 0);
      this.gotoFrame();

      if (this.autoplay) {
        this.play();
      }
    }
  };

  AnimationItem.prototype.resize = function (width, height) {
    // Adding this validation for backwards compatibility in case an event object was being passed down
    var _width = typeof width === 'number' ? width : undefined;

    var _height = typeof height === 'number' ? height : undefined;

    this.renderer.updateContainerSize(_width, _height);
  };

  AnimationItem.prototype.setSubframe = function (flag) {
    this.isSubframeEnabled = !!flag;
  };

  AnimationItem.prototype.gotoFrame = function () {
    this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise

    if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) {
      this.currentFrame = this.timeCompleted;
    }

    this.trigger('enterFrame');
    this.renderFrame();
    this.trigger('drawnFrame');
  };

  AnimationItem.prototype.renderFrame = function () {
    if (this.isLoaded === false || !this.renderer) {
      return;
    }

    try {
      if (this.expressionsPlugin) {
        this.expressionsPlugin.resetFrame();
      }

      this.renderer.renderFrame(this.currentFrame + this.firstFrame);
    } catch (error) {
      this.triggerRenderFrameError(error);
    }
  };

  AnimationItem.prototype.play = function (name) {
    if (name && this.name !== name) {
      return;
    }

    if (this.isPaused === true) {
      this.isPaused = false;
      this.trigger('_play');
      this.audioController.resume();

      if (this._idle) {
        this._idle = false;
        this.trigger('_active');
      }
    }
  };

  AnimationItem.prototype.pause = function (name) {
    if (name && this.name !== name) {
      return;
    }

    if (this.isPaused === false) {
      this.isPaused = true;
      this.trigger('_pause');
      this._idle = true;
      this.trigger('_idle');
      this.audioController.pause();
    }
  };

  AnimationItem.prototype.togglePause = function (name) {
    if (name && this.name !== name) {
      return;
    }

    if (this.isPaused === true) {
      this.play();
    } else {
      this.pause();
    }
  };

  AnimationItem.prototype.stop = function (name) {
    if (name && this.name !== name) {
      return;
    }

    this.pause();
    this.playCount = 0;
    this._completedLoop = false;
    this.setCurrentRawFrameValue(0);
  };

  AnimationItem.prototype.getMarkerData = function (markerName) {
    var marker;

    for (var i = 0; i < this.markers.length; i += 1) {
      marker = this.markers[i];

      if (marker.payload && marker.payload.name === markerName) {
        return marker;
      }
    }

    return null;
  };

  AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
    if (name && this.name !== name) {
      return;
    }

    var numValue = Number(value);

    if (isNaN(numValue)) {
      var marker = this.getMarkerData(value);

      if (marker) {
        this.goToAndStop(marker.time, true);
      }
    } else if (isFrame) {
      this.setCurrentRawFrameValue(value);
    } else {
      this.setCurrentRawFrameValue(value * this.frameModifier);
    }

    this.pause();
  };

  AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
    if (name && this.name !== name) {
      return;
    }

    var numValue = Number(value);

    if (isNaN(numValue)) {
      var marker = this.getMarkerData(value);

      if (marker) {
        if (!marker.duration) {
          this.goToAndStop(marker.time, true);
        } else {
          this.playSegments([marker.time, marker.time + marker.duration], true);
        }
      }
    } else {
      this.goToAndStop(numValue, isFrame, name);
    }

    this.play();
  };

  AnimationItem.prototype.advanceTime = function (value) {
    if (this.isPaused === true || this.isLoaded === false) {
      return;
    }

    var nextValue = this.currentRawFrame + value * this.frameModifier;
    var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
    // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.

    if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
      if (!this.loop || this.playCount === this.loop) {
        if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
          _isComplete = true;
          nextValue = this.totalFrames - 1;
        }
      } else if (nextValue >= this.totalFrames) {
        this.playCount += 1;

        if (!this.checkSegments(nextValue % this.totalFrames)) {
          this.setCurrentRawFrameValue(nextValue % this.totalFrames);
          this._completedLoop = true;
          this.trigger('loopComplete');
        }
      } else {
        this.setCurrentRawFrameValue(nextValue);
      }
    } else if (nextValue < 0) {
      if (!this.checkSegments(nextValue % this.totalFrames)) {
        if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
          // eslint-disable-line no-plusplus
          this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);

          if (!this._completedLoop) {
            this._completedLoop = true;
          } else {
            this.trigger('loopComplete');
          }
        } else {
          _isComplete = true;
          nextValue = 0;
        }
      }
    } else {
      this.setCurrentRawFrameValue(nextValue);
    }

    if (_isComplete) {
      this.setCurrentRawFrameValue(nextValue);
      this.pause();
      this.trigger('complete');
    }
  };

  AnimationItem.prototype.adjustSegment = function (arr, offset) {
    this.playCount = 0;

    if (arr[1] < arr[0]) {
      if (this.frameModifier > 0) {
        if (this.playSpeed < 0) {
          this.setSpeed(-this.playSpeed);
        } else {
          this.setDirection(-1);
        }
      }

      this.totalFrames = arr[0] - arr[1];
      this.timeCompleted = this.totalFrames;
      this.firstFrame = arr[1];
      this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
    } else if (arr[1] > arr[0]) {
      if (this.frameModifier < 0) {
        if (this.playSpeed < 0) {
          this.setSpeed(-this.playSpeed);
        } else {
          this.setDirection(1);
        }
      }

      this.totalFrames = arr[1] - arr[0];
      this.timeCompleted = this.totalFrames;
      this.firstFrame = arr[0];
      this.setCurrentRawFrameValue(0.001 + offset);
    }

    this.trigger('segmentStart');
  };

  AnimationItem.prototype.setSegment = function (init, end) {
    var pendingFrame = -1;

    if (this.isPaused) {
      if (this.currentRawFrame + this.firstFrame < init) {
        pendingFrame = init;
      } else if (this.currentRawFrame + this.firstFrame > end) {
        pendingFrame = end - init;
      }
    }

    this.firstFrame = init;
    this.totalFrames = end - init;
    this.timeCompleted = this.totalFrames;

    if (pendingFrame !== -1) {
      this.goToAndStop(pendingFrame, true);
    }
  };

  AnimationItem.prototype.playSegments = function (arr, forceFlag) {
    if (forceFlag) {
      this.segments.length = 0;
    }

    if (_typeof$1(arr[0]) === 'object') {
      var i;
      var len = arr.length;

      for (i = 0; i < len; i += 1) {
        this.segments.push(arr[i]);
      }
    } else {
      this.segments.push(arr);
    }

    if (this.segments.length && forceFlag) {
      this.adjustSegment(this.segments.shift(), 0);
    }

    if (this.isPaused) {
      this.play();
    }
  };

  AnimationItem.prototype.resetSegments = function (forceFlag) {
    this.segments.length = 0;
    this.segments.push([this.animationData.ip, this.animationData.op]);

    if (forceFlag) {
      this.checkSegments(0);
    }
  };

  AnimationItem.prototype.checkSegments = function (offset) {
    if (this.segments.length) {
      this.adjustSegment(this.segments.shift(), offset);
      return true;
    }

    return false;
  };

  AnimationItem.prototype.destroy = function (name) {
    if (name && this.name !== name || !this.renderer) {
      return;
    }

    this.renderer.destroy();
    this.imagePreloader.destroy();
    this.trigger('destroy');
    this._cbs = null;
    this.onEnterFrame = null;
    this.onLoopComplete = null;
    this.onComplete = null;
    this.onSegmentStart = null;
    this.onDestroy = null;
    this.renderer = null;
    this.expressionsPlugin = null;
    this.imagePreloader = null;
    this.projectInterface = null;
  };

  AnimationItem.prototype.setCurrentRawFrameValue = function (value) {
    this.currentRawFrame = value;
    this.gotoFrame();
  };

  AnimationItem.prototype.setSpeed = function (val) {
    this.playSpeed = val;
    this.updaFrameModifier();
  };

  AnimationItem.prototype.setDirection = function (val) {
    this.playDirection = val < 0 ? -1 : 1;
    this.updaFrameModifier();
  };

  AnimationItem.prototype.setLoop = function (isLooping) {
    this.loop = isLooping;
  };

  AnimationItem.prototype.setVolume = function (val, name) {
    if (name && this.name !== name) {
      return;
    }

    this.audioController.setVolume(val);
  };

  AnimationItem.prototype.getVolume = function () {
    return this.audioController.getVolume();
  };

  AnimationItem.prototype.mute = function (name) {
    if (name && this.name !== name) {
      return;
    }

    this.audioController.mute();
  };

  AnimationItem.prototype.unmute = function (name) {
    if (name && this.name !== name) {
      return;
    }

    this.audioController.unmute();
  };

  AnimationItem.prototype.updaFrameModifier = function () {
    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
    this.audioController.setRate(this.playSpeed * this.playDirection);
  };

  AnimationItem.prototype.getPath = function () {
    return this.path;
  };

  AnimationItem.prototype.getAssetsPath = function (assetData) {
    var path = '';

    if (assetData.e) {
      path = assetData.p;
    } else if (this.assetsPath) {
      var imagePath = assetData.p;

      if (imagePath.indexOf('images/') !== -1) {
        imagePath = imagePath.split('/')[1];
      }

      path = this.assetsPath + imagePath;
    } else {
      path = this.path;
      path += assetData.u ? assetData.u : '';
      path += assetData.p;
    }

    return path;
  };

  AnimationItem.prototype.getAssetData = function (id) {
    var i = 0;
    var len = this.assets.length;

    while (i < len) {
      if (id === this.assets[i].id) {
        return this.assets[i];
      }

      i += 1;
    }

    return null;
  };

  AnimationItem.prototype.hide = function () {
    this.renderer.hide();
  };

  AnimationItem.prototype.show = function () {
    this.renderer.show();
  };

  AnimationItem.prototype.getDuration = function (isFrame) {
    return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
  };

  AnimationItem.prototype.updateDocumentData = function (path, documentData, index) {
    try {
      var element = this.renderer.getElementByPath(path);
      element.updateDocumentData(documentData, index);
    } catch (error) {// TODO: decide how to handle catch case
    }
  };

  AnimationItem.prototype.trigger = function (name) {
    if (this._cbs && this._cbs[name]) {
      switch (name) {
        case 'enterFrame':
          this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
          break;

        case 'drawnFrame':
          this.drawnFrameEvent.currentTime = this.currentFrame;
          this.drawnFrameEvent.totalTime = this.totalFrames;
          this.drawnFrameEvent.direction = this.frameModifier;
          this.triggerEvent(name, this.drawnFrameEvent);
          break;

        case 'loopComplete':
          this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
          break;

        case 'complete':
          this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
          break;

        case 'segmentStart':
          this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
          break;

        case 'destroy':
          this.triggerEvent(name, new BMDestroyEvent(name, this));
          break;

        default:
          this.triggerEvent(name);
      }
    }

    if (name === 'enterFrame' && this.onEnterFrame) {
      this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
    }

    if (name === 'loopComplete' && this.onLoopComplete) {
      this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
    }

    if (name === 'complete' && this.onComplete) {
      this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
    }

    if (name === 'segmentStart' && this.onSegmentStart) {
      this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
    }

    if (name === 'destroy' && this.onDestroy) {
      this.onDestroy.call(this, new BMDestroyEvent(name, this));
    }
  };

  AnimationItem.prototype.triggerRenderFrameError = function (nativeError) {
    var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
    this.triggerEvent('error', error);

    if (this.onError) {
      this.onError.call(this, error);
    }
  };

  AnimationItem.prototype.triggerConfigError = function (nativeError) {
    var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
    this.triggerEvent('error', error);

    if (this.onError) {
      this.onError.call(this, error);
    }
  };

  var animationManager = function () {
    var moduleOb = {};
    var registeredAnimations = [];
    var initTime = 0;
    var len = 0;
    var playingAnimationsNum = 0;
    var _stopped = true;
    var _isFrozen = false;

    function removeElement(ev) {
      var i = 0;
      var animItem = ev.target;

      while (i < len) {
        if (registeredAnimations[i].animation === animItem) {
          registeredAnimations.splice(i, 1);
          i -= 1;
          len -= 1;

          if (!animItem.isPaused) {
            subtractPlayingCount();
          }
        }

        i += 1;
      }
    }

    function registerAnimation(element, animationData) {
      if (!element) {
        return null;
      }

      var i = 0;

      while (i < len) {
        if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) {
          return registeredAnimations[i].animation;
        }

        i += 1;
      }

      var animItem = new AnimationItem();
      setupAnimation(animItem, element);
      animItem.setData(element, animationData);
      return animItem;
    }

    function getRegisteredAnimations() {
      var i;
      var lenAnims = registeredAnimations.length;
      var animations = [];

      for (i = 0; i < lenAnims; i += 1) {
        animations.push(registeredAnimations[i].animation);
      }

      return animations;
    }

    function addPlayingCount() {
      playingAnimationsNum += 1;
      activate();
    }

    function subtractPlayingCount() {
      playingAnimationsNum -= 1;
    }

    function setupAnimation(animItem, element) {
      animItem.addEventListener('destroy', removeElement);
      animItem.addEventListener('_active', addPlayingCount);
      animItem.addEventListener('_idle', subtractPlayingCount);
      registeredAnimations.push({
        elem: element,
        animation: animItem
      });
      len += 1;
    }

    function loadAnimation(params) {
      var animItem = new AnimationItem();
      setupAnimation(animItem, null);
      animItem.setParams(params);
      return animItem;
    }

    function setSpeed(val, animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.setSpeed(val, animation);
      }
    }

    function setDirection(val, animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.setDirection(val, animation);
      }
    }

    function play(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.play(animation);
      }
    }

    function resume(nowTime) {
      var elapsedTime = nowTime - initTime;
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.advanceTime(elapsedTime);
      }

      initTime = nowTime;

      if (playingAnimationsNum && !_isFrozen) {
        window.requestAnimationFrame(resume);
      } else {
        _stopped = true;
      }
    }

    function first(nowTime) {
      initTime = nowTime;
      window.requestAnimationFrame(resume);
    }

    function pause(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.pause(animation);
      }
    }

    function goToAndStop(value, isFrame, animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
      }
    }

    function stop(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.stop(animation);
      }
    }

    function togglePause(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.togglePause(animation);
      }
    }

    function destroy(animation) {
      var i;

      for (i = len - 1; i >= 0; i -= 1) {
        registeredAnimations[i].animation.destroy(animation);
      }
    }

    function searchAnimations(animationData, standalone, renderer) {
      var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
      var i;
      var lenAnims = animElements.length;

      for (i = 0; i < lenAnims; i += 1) {
        if (renderer) {
          animElements[i].setAttribute('data-bm-type', renderer);
        }

        registerAnimation(animElements[i], animationData);
      }

      if (standalone && lenAnims === 0) {
        if (!renderer) {
          renderer = 'svg';
        }

        var body = document.getElementsByTagName('body')[0];
        body.innerText = '';
        var div = createTag('div');
        div.style.width = '100%';
        div.style.height = '100%';
        div.setAttribute('data-bm-type', renderer);
        body.appendChild(div);
        registerAnimation(div, animationData);
      }
    }

    function resize() {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.resize();
      }
    }

    function activate() {
      if (!_isFrozen && playingAnimationsNum) {
        if (_stopped) {
          window.requestAnimationFrame(first);
          _stopped = false;
        }
      }
    }

    function freeze() {
      _isFrozen = true;
    }

    function unfreeze() {
      _isFrozen = false;
      activate();
    }

    function setVolume(val, animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.setVolume(val, animation);
      }
    }

    function mute(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.mute(animation);
      }
    }

    function unmute(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.unmute(animation);
      }
    }

    moduleOb.registerAnimation = registerAnimation;
    moduleOb.loadAnimation = loadAnimation;
    moduleOb.setSpeed = setSpeed;
    moduleOb.setDirection = setDirection;
    moduleOb.play = play;
    moduleOb.pause = pause;
    moduleOb.stop = stop;
    moduleOb.togglePause = togglePause;
    moduleOb.searchAnimations = searchAnimations;
    moduleOb.resize = resize; // moduleOb.start = start;

    moduleOb.goToAndStop = goToAndStop;
    moduleOb.destroy = destroy;
    moduleOb.freeze = freeze;
    moduleOb.unfreeze = unfreeze;
    moduleOb.setVolume = setVolume;
    moduleOb.mute = mute;
    moduleOb.unmute = unmute;
    moduleOb.getRegisteredAnimations = getRegisteredAnimations;
    return moduleOb;
  }();

  /* eslint-disable */
  var BezierFactory = function () {
    /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */
    var ob = {};
    ob.getBezierEasing = getBezierEasing;
    var beziers = {};

    function getBezierEasing(a, b, c, d, nm) {
      var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');

      if (beziers[str]) {
        return beziers[str];
      }

      var bezEasing = new BezierEasing([a, b, c, d]);
      beziers[str] = bezEasing;
      return bezEasing;
    } // These values are established by empiricism with tests (tradeoff: performance VS precision)


    var NEWTON_ITERATIONS = 4;
    var NEWTON_MIN_SLOPE = 0.001;
    var SUBDIVISION_PRECISION = 0.0000001;
    var SUBDIVISION_MAX_ITERATIONS = 10;
    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
    var float32ArraySupported = typeof Float32Array === 'function';

    function A(aA1, aA2) {
      return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }

    function B(aA1, aA2) {
      return 3.0 * aA2 - 6.0 * aA1;
    }

    function C(aA1) {
      return 3.0 * aA1;
    } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.


    function calcBezier(aT, aA1, aA2) {
      return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.


    function getSlope(aT, aA1, aA2) {
      return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }

    function binarySubdivide(aX, aA, aB, mX1, mX2) {
      var currentX,
          currentT,
          i = 0;

      do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - aX;

        if (currentX > 0.0) {
          aB = currentT;
        } else {
          aA = currentT;
        }
      } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

      return currentT;
    }

    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
      for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
        var currentSlope = getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
      }

      return aGuessT;
    }
    /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */


    function BezierEasing(points) {
      this._p = points;
      this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
      this._precomputed = false;
      this.get = this.get.bind(this);
    }

    BezierEasing.prototype = {
      get: function get(x) {
        var mX1 = this._p[0],
            mY1 = this._p[1],
            mX2 = this._p[2],
            mY2 = this._p[3];
        if (!this._precomputed) this._precompute();
        if (mX1 === mY1 && mX2 === mY2) return x; // linear
        // Because JavaScript number are imprecise, we should guarantee the extremes are right.

        if (x === 0) return 0;
        if (x === 1) return 1;
        return calcBezier(this._getTForX(x), mY1, mY2);
      },
      // Private part
      _precompute: function _precompute() {
        var mX1 = this._p[0],
            mY1 = this._p[1],
            mX2 = this._p[2],
            mY2 = this._p[3];
        this._precomputed = true;

        if (mX1 !== mY1 || mX2 !== mY2) {
          this._calcSampleValues();
        }
      },
      _calcSampleValues: function _calcSampleValues() {
        var mX1 = this._p[0],
            mX2 = this._p[2];

        for (var i = 0; i < kSplineTableSize; ++i) {
          this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
        }
      },

      /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */
      _getTForX: function _getTForX(aX) {
        var mX1 = this._p[0],
            mX2 = this._p[2],
            mSampleValues = this._mSampleValues;
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = kSplineTableSize - 1;

        for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
          intervalStart += kSampleStepSize;
        }

        --currentSample; // Interpolate to provide an initial guess for t

        var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
        var guessForT = intervalStart + dist * kSampleStepSize;
        var initialSlope = getSlope(guessForT, mX1, mX2);

        if (initialSlope >= NEWTON_MIN_SLOPE) {
          return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        }

        if (initialSlope === 0.0) {
          return guessForT;
        }

        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
      }
    };
    return ob;
  }();

  var pooling = function () {
    function _double(arr) {
      return arr.concat(createSizedArray(arr.length));
    }

    return {
      "double": _double
    };
  }();

  var poolFactory = function () {
    return function (initialLength, _create, _release) {
      var _length = 0;
      var _maxLength = initialLength;
      var pool = createSizedArray(_maxLength);
      var ob = {
        newElement: newElement,
        release: release
      };

      function newElement() {
        var element;

        if (_length) {
          _length -= 1;
          element = pool[_length];
        } else {
          element = _create();
        }

        return element;
      }

      function release(element) {
        if (_length === _maxLength) {
          pool = pooling["double"](pool);
          _maxLength *= 2;
        }

        if (_release) {
          _release(element);
        }

        pool[_length] = element;
        _length += 1;
      }

      return ob;
    };
  }();

  var bezierLengthPool = function () {
    function create() {
      return {
        addedLength: 0,
        percents: createTypedArray('float32', getDefaultCurveSegments()),
        lengths: createTypedArray('float32', getDefaultCurveSegments())
      };
    }

    return poolFactory(8, create);
  }();

  var segmentsLengthPool = function () {
    function create() {
      return {
        lengths: [],
        totalLength: 0
      };
    }

    function release(element) {
      var i;
      var len = element.lengths.length;

      for (i = 0; i < len; i += 1) {
        bezierLengthPool.release(element.lengths[i]);
      }

      element.lengths.length = 0;
    }

    return poolFactory(8, create, release);
  }();

  function bezFunction() {
    var math = Math;

    function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
      var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
      return det1 > -0.001 && det1 < 0.001;
    }

    function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
      if (z1 === 0 && z2 === 0 && z3 === 0) {
        return pointOnLine2D(x1, y1, x2, y2, x3, y3);
      }

      var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
      var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
      var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
      var diffDist;

      if (dist1 > dist2) {
        if (dist1 > dist3) {
          diffDist = dist1 - dist2 - dist3;
        } else {
          diffDist = dist3 - dist2 - dist1;
        }
      } else if (dist3 > dist2) {
        diffDist = dist3 - dist2 - dist1;
      } else {
        diffDist = dist2 - dist1 - dist3;
      }

      return diffDist > -0.0001 && diffDist < 0.0001;
    }

    var getBezierLength = function () {
      return function (pt1, pt2, pt3, pt4) {
        var curveSegments = getDefaultCurveSegments();
        var k;
        var i;
        var len;
        var ptCoord;
        var perc;
        var addedLength = 0;
        var ptDistance;
        var point = [];
        var lastPoint = [];
        var lengthData = bezierLengthPool.newElement();
        len = pt3.length;

        for (k = 0; k < curveSegments; k += 1) {
          perc = k / (curveSegments - 1);
          ptDistance = 0;

          for (i = 0; i < len; i += 1) {
            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
            point[i] = ptCoord;

            if (lastPoint[i] !== null) {
              ptDistance += bmPow(point[i] - lastPoint[i], 2);
            }

            lastPoint[i] = point[i];
          }

          if (ptDistance) {
            ptDistance = bmSqrt(ptDistance);
            addedLength += ptDistance;
          }

          lengthData.percents[k] = perc;
          lengthData.lengths[k] = addedLength;
        }

        lengthData.addedLength = addedLength;
        return lengthData;
      };
    }();

    function getSegmentsLength(shapeData) {
      var segmentsLength = segmentsLengthPool.newElement();
      var closed = shapeData.c;
      var pathV = shapeData.v;
      var pathO = shapeData.o;
      var pathI = shapeData.i;
      var i;
      var len = shapeData._length;
      var lengths = segmentsLength.lengths;
      var totalLength = 0;

      for (i = 0; i < len - 1; i += 1) {
        lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
        totalLength += lengths[i].addedLength;
      }

      if (closed && len) {
        lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
        totalLength += lengths[i].addedLength;
      }

      segmentsLength.totalLength = totalLength;
      return segmentsLength;
    }

    function BezierData(length) {
      this.segmentLength = 0;
      this.points = new Array(length);
    }

    function PointData(partial, point) {
      this.partialLength = partial;
      this.point = point;
    }

    var buildBezierData = function () {
      var storedData = {};
      return function (pt1, pt2, pt3, pt4) {
        var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');

        if (!storedData[bezierName]) {
          var curveSegments = getDefaultCurveSegments();
          var k;
          var i;
          var len;
          var ptCoord;
          var perc;
          var addedLength = 0;
          var ptDistance;
          var point;
          var lastPoint = null;

          if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) {
            curveSegments = 2;
          }

          var bezierData = new BezierData(curveSegments);
          len = pt3.length;

          for (k = 0; k < curveSegments; k += 1) {
            point = createSizedArray(len);
            perc = k / (curveSegments - 1);
            ptDistance = 0;

            for (i = 0; i < len; i += 1) {
              ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
              point[i] = ptCoord;

              if (lastPoint !== null) {
                ptDistance += bmPow(point[i] - lastPoint[i], 2);
              }
            }

            ptDistance = bmSqrt(ptDistance);
            addedLength += ptDistance;
            bezierData.points[k] = new PointData(ptDistance, point);
            lastPoint = point;
          }

          bezierData.segmentLength = addedLength;
          storedData[bezierName] = bezierData;
        }

        return storedData[bezierName];
      };
    }();

    function getDistancePerc(perc, bezierData) {
      var percents = bezierData.percents;
      var lengths = bezierData.lengths;
      var len = percents.length;
      var initPos = bmFloor((len - 1) * perc);
      var lengthPos = perc * bezierData.addedLength;
      var lPerc = 0;

      if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) {
        return percents[initPos];
      }

      var dir = lengths[initPos] > lengthPos ? -1 : 1;
      var flag = true;

      while (flag) {
        if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
          lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
          flag = false;
        } else {
          initPos += dir;
        }

        if (initPos < 0 || initPos >= len - 1) {
          // FIX for TypedArrays that don't store floating point values with enough accuracy
          if (initPos === len - 1) {
            return percents[initPos];
          }

          flag = false;
        }
      }

      return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
    }

    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
      var t1 = getDistancePerc(percent, bezierData);
      var u1 = 1 - t1;
      var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
      var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
      return [ptX, ptY];
    }

    var bezierSegmentPoints = createTypedArray('float32', 8);

    function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
      if (startPerc < 0) {
        startPerc = 0;
      } else if (startPerc > 1) {
        startPerc = 1;
      }

      var t0 = getDistancePerc(startPerc, bezierData);
      endPerc = endPerc > 1 ? 1 : endPerc;
      var t1 = getDistancePerc(endPerc, bezierData);
      var i;
      var len = pt1.length;
      var u0 = 1 - t0;
      var u1 = 1 - t1;
      var u0u0u0 = u0 * u0 * u0;
      var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase

      var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase

      var t0t0t0 = t0 * t0 * t0; //

      var u0u0u1 = u0 * u0 * u1;
      var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase

      var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase

      var t0t0t1 = t0 * t0 * t1; //

      var u0u1u1 = u0 * u1 * u1;
      var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase

      var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase

      var t0t1t1 = t0 * t1 * t1; //

      var u1u1u1 = u1 * u1 * u1;
      var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase

      var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase

      var t1t1t1 = t1 * t1 * t1;

      for (i = 0; i < len; i += 1) {
        bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

        bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

        bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

        bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      }

      return bezierSegmentPoints;
    }

    return {
      getSegmentsLength: getSegmentsLength,
      getNewSegment: getNewSegment,
      getPointInSegment: getPointInSegment,
      buildBezierData: buildBezierData,
      pointOnLine2D: pointOnLine2D,
      pointOnLine3D: pointOnLine3D
    };
  }

  var bez = bezFunction();

  var initFrame = initialDefaultFrame;
  var mathAbs = Math.abs;

  function interpolateValue(frameNum, caching) {
    var offsetTime = this.offsetTime;
    var newValue;

    if (this.propType === 'multidimensional') {
      newValue = createTypedArray('float32', this.pv.length);
    }

    var iterationIndex = caching.lastIndex;
    var i = iterationIndex;
    var len = this.keyframes.length - 1;
    var flag = true;
    var keyData;
    var nextKeyData;
    var keyframeMetadata;

    while (flag) {
      keyData = this.keyframes[i];
      nextKeyData = this.keyframes[i + 1];

      if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
        if (keyData.h) {
          keyData = nextKeyData;
        }

        iterationIndex = 0;
        break;
      }

      if (nextKeyData.t - offsetTime > frameNum) {
        iterationIndex = i;
        break;
      }

      if (i < len - 1) {
        i += 1;
      } else {
        iterationIndex = 0;
        flag = false;
      }
    }

    keyframeMetadata = this.keyframesMetadata[i] || {};
    var k;
    var kLen;
    var perc;
    var jLen;
    var j;
    var fnc;
    var nextKeyTime = nextKeyData.t - offsetTime;
    var keyTime = keyData.t - offsetTime;
    var endValue;

    if (keyData.to) {
      if (!keyframeMetadata.bezierData) {
        keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
      }

      var bezierData = keyframeMetadata.bezierData;

      if (frameNum >= nextKeyTime || frameNum < keyTime) {
        var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
        kLen = bezierData.points[ind].point.length;

        for (k = 0; k < kLen; k += 1) {
          newValue[k] = bezierData.points[ind].point[k];
        } // caching._lastKeyframeIndex = -1;

      } else {
        if (keyframeMetadata.__fnct) {
          fnc = keyframeMetadata.__fnct;
        } else {
          fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
          keyframeMetadata.__fnct = fnc;
        }

        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
        var distanceInLine = bezierData.segmentLength * perc;
        var segmentPerc;
        var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
        j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
        flag = true;
        jLen = bezierData.points.length;

        while (flag) {
          addedLength += bezierData.points[j].partialLength;

          if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
            kLen = bezierData.points[j].point.length;

            for (k = 0; k < kLen; k += 1) {
              newValue[k] = bezierData.points[j].point[k];
            }

            break;
          } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
            segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
            kLen = bezierData.points[j].point.length;

            for (k = 0; k < kLen; k += 1) {
              newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
            }

            break;
          }

          if (j < jLen - 1) {
            j += 1;
          } else {
            flag = false;
          }
        }

        caching._lastPoint = j;
        caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
        caching._lastKeyframeIndex = i;
      }
    } else {
      var outX;
      var outY;
      var inX;
      var inY;
      var keyValue;
      len = keyData.s.length;
      endValue = nextKeyData.s || keyData.e;

      if (this.sh && keyData.h !== 1) {
        if (frameNum >= nextKeyTime) {
          newValue[0] = endValue[0];
          newValue[1] = endValue[1];
          newValue[2] = endValue[2];
        } else if (frameNum <= keyTime) {
          newValue[0] = keyData.s[0];
          newValue[1] = keyData.s[1];
          newValue[2] = keyData.s[2];
        } else {
          var quatStart = createQuaternion(keyData.s);
          var quatEnd = createQuaternion(endValue);
          var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
          quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
        }
      } else {
        for (i = 0; i < len; i += 1) {
          if (keyData.h !== 1) {
            if (frameNum >= nextKeyTime) {
              perc = 1;
            } else if (frameNum < keyTime) {
              perc = 0;
            } else {
              if (keyData.o.x.constructor === Array) {
                if (!keyframeMetadata.__fnct) {
                  keyframeMetadata.__fnct = [];
                }

                if (!keyframeMetadata.__fnct[i]) {
                  outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                  outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                  inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                  inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                  fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                  keyframeMetadata.__fnct[i] = fnc;
                } else {
                  fnc = keyframeMetadata.__fnct[i];
                }
              } else if (!keyframeMetadata.__fnct) {
                outX = keyData.o.x;
                outY = keyData.o.y;
                inX = keyData.i.x;
                inY = keyData.i.y;
                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                keyData.keyframeMetadata = fnc;
              } else {
                fnc = keyframeMetadata.__fnct;
              }

              perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
            }
          }

          endValue = nextKeyData.s || keyData.e;
          keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;

          if (this.propType === 'multidimensional') {
            newValue[i] = keyValue;
          } else {
            newValue = keyValue;
          }
        }
      }
    }

    caching.lastIndex = iterationIndex;
    return newValue;
  } // based on @Toji's https://github.com/toji/gl-matrix/


  function slerp(a, b, t) {
    var out = [];
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    var bx = b[0];
    var by = b[1];
    var bz = b[2];
    var bw = b[3];
    var omega;
    var cosom;
    var sinom;
    var scale0;
    var scale1;
    cosom = ax * bx + ay * by + az * bz + aw * bw;

    if (cosom < 0.0) {
      cosom = -cosom;
      bx = -bx;
      by = -by;
      bz = -bz;
      bw = -bw;
    }

    if (1.0 - cosom > 0.000001) {
      omega = Math.acos(cosom);
      sinom = Math.sin(omega);
      scale0 = Math.sin((1.0 - t) * omega) / sinom;
      scale1 = Math.sin(t * omega) / sinom;
    } else {
      scale0 = 1.0 - t;
      scale1 = t;
    }

    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
  }

  function quaternionToEuler(out, quat) {
    var qx = quat[0];
    var qy = quat[1];
    var qz = quat[2];
    var qw = quat[3];
    var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
    var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
    var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
    out[0] = heading / degToRads;
    out[1] = attitude / degToRads;
    out[2] = bank / degToRads;
  }

  function createQuaternion(values) {
    var heading = values[0] * degToRads;
    var attitude = values[1] * degToRads;
    var bank = values[2] * degToRads;
    var c1 = Math.cos(heading / 2);
    var c2 = Math.cos(attitude / 2);
    var c3 = Math.cos(bank / 2);
    var s1 = Math.sin(heading / 2);
    var s2 = Math.sin(attitude / 2);
    var s3 = Math.sin(bank / 2);
    var w = c1 * c2 * c3 - s1 * s2 * s3;
    var x = s1 * s2 * c3 + c1 * c2 * s3;
    var y = s1 * c2 * c3 + c1 * s2 * s3;
    var z = c1 * s2 * c3 - s1 * c2 * s3;
    return [x, y, z, w];
  }

  function getValueAtCurrentTime() {
    var frameNum = this.comp.renderedFrame - this.offsetTime;
    var initTime = this.keyframes[0].t - this.offsetTime;
    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;

    if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
      if (this._caching.lastFrame >= frameNum) {
        this._caching._lastKeyframeIndex = -1;
        this._caching.lastIndex = 0;
      }

      var renderResult = this.interpolateValue(frameNum, this._caching);
      this.pv = renderResult;
    }

    this._caching.lastFrame = frameNum;
    return this.pv;
  }

  function setVValue(val) {
    var multipliedValue;

    if (this.propType === 'unidimensional') {
      multipliedValue = val * this.mult;

      if (mathAbs(this.v - multipliedValue) > 0.00001) {
        this.v = multipliedValue;
        this._mdf = true;
      }
    } else {
      var i = 0;
      var len = this.v.length;

      while (i < len) {
        multipliedValue = val[i] * this.mult;

        if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
          this.v[i] = multipliedValue;
          this._mdf = true;
        }

        i += 1;
      }
    }
  }

  function processEffectsSequence() {
    if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
      return;
    }

    if (this.lock) {
      this.setVValue(this.pv);
      return;
    }

    this.lock = true;
    this._mdf = this._isFirstFrame;
    var i;
    var len = this.effectsSequence.length;
    var finalValue = this.kf ? this.pv : this.data.k;

    for (i = 0; i < len; i += 1) {
      finalValue = this.effectsSequence[i](finalValue);
    }

    this.setVValue(finalValue);
    this._isFirstFrame = false;
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  }

  function addEffect(effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.container.addDynamicProperty(this);
  }

  function ValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.mult = mult || 1;
    this.data = data;
    this.v = mult ? data.k * mult : data.k;
    this.pv = data.k;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.vel = 0;
    this.effectsSequence = [];
    this._isFirstFrame = true;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.addEffect = addEffect;
  }

  function MultiDimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    this.mult = mult || 1;
    this.data = data;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.frameId = -1;
    var i;
    var len = data.k.length;
    this.v = createTypedArray('float32', len);
    this.pv = createTypedArray('float32', len);
    this.vel = createTypedArray('float32', len);

    for (i = 0; i < len; i += 1) {
      this.v[i] = data.k[i] * this.mult;
      this.pv[i] = data.k[i];
    }

    this._isFirstFrame = true;
    this.effectsSequence = [];
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.addEffect = addEffect;
  }

  function KeyframedValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.keyframes = data.k;
    this.keyframesMetadata = [];
    this.offsetTime = elem.data.st;
    this.frameId = -1;
    this._caching = {
      lastFrame: initFrame,
      lastIndex: 0,
      value: 0,
      _lastKeyframeIndex: -1
    };
    this.k = true;
    this.kf = true;
    this.data = data;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.v = initFrame;
    this.pv = initFrame;
    this._isFirstFrame = true;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.interpolateValue = interpolateValue;
    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
    this.addEffect = addEffect;
  }

  function KeyframedMultidimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    var i;
    var len = data.k.length;
    var s;
    var e;
    var to;
    var ti;

    for (i = 0; i < len - 1; i += 1) {
      if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
        s = data.k[i].s;
        e = data.k[i + 1].s;
        to = data.k[i].to;
        ti = data.k[i].ti;

        if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
          data.k[i].to = null;
          data.k[i].ti = null;
        }

        if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
          if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
            data.k[i].to = null;
            data.k[i].ti = null;
          }
        }
      }
    }

    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
    this.data = data;
    this.keyframes = data.k;
    this.keyframesMetadata = [];
    this.offsetTime = elem.data.st;
    this.k = true;
    this.kf = true;
    this._isFirstFrame = true;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.interpolateValue = interpolateValue;
    this.frameId = -1;
    var arrLen = data.k[0].s.length;
    this.v = createTypedArray('float32', arrLen);
    this.pv = createTypedArray('float32', arrLen);

    for (i = 0; i < arrLen; i += 1) {
      this.v[i] = initFrame;
      this.pv[i] = initFrame;
    }

    this._caching = {
      lastFrame: initFrame,
      lastIndex: 0,
      value: createTypedArray('float32', arrLen)
    };
    this.addEffect = addEffect;
  }

  var PropertyFactory = function () {
    function getProp(elem, data, type, mult, container) {
      if (data.sid) {
        data = elem.globalData.slotManager.getProp(data);
      }

      var p;

      if (!data.k.length) {
        p = new ValueProperty(elem, data, mult, container);
      } else if (typeof data.k[0] === 'number') {
        p = new MultiDimensionalProperty(elem, data, mult, container);
      } else {
        switch (type) {
          case 0:
            p = new KeyframedValueProperty(elem, data, mult, container);
            break;

          case 1:
            p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
            break;

          default:
            break;
        }
      }

      if (p.effectsSequence.length) {
        container.addDynamicProperty(p);
      }

      return p;
    }

    var ob = {
      getProp: getProp
    };
    return ob;
  }();

  function DynamicPropertyContainer() {}

  DynamicPropertyContainer.prototype = {
    addDynamicProperty: function addDynamicProperty(prop) {
      if (this.dynamicProperties.indexOf(prop) === -1) {
        this.dynamicProperties.push(prop);
        this.container.addDynamicProperty(this);
        this._isAnimated = true;
      }
    },
    iterateDynamicProperties: function iterateDynamicProperties() {
      this._mdf = false;
      var i;
      var len = this.dynamicProperties.length;

      for (i = 0; i < len; i += 1) {
        this.dynamicProperties[i].getValue();

        if (this.dynamicProperties[i]._mdf) {
          this._mdf = true;
        }
      }
    },
    initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
      this.container = container;
      this.dynamicProperties = [];
      this._mdf = false;
      this._isAnimated = false;
    }
  };

  var pointPool = function () {
    function create() {
      return createTypedArray('float32', 2);
    }

    return poolFactory(8, create);
  }();

  function ShapePath() {
    this.c = false;
    this._length = 0;
    this._maxLength = 8;
    this.v = createSizedArray(this._maxLength);
    this.o = createSizedArray(this._maxLength);
    this.i = createSizedArray(this._maxLength);
  }

  ShapePath.prototype.setPathData = function (closed, len) {
    this.c = closed;
    this.setLength(len);
    var i = 0;

    while (i < len) {
      this.v[i] = pointPool.newElement();
      this.o[i] = pointPool.newElement();
      this.i[i] = pointPool.newElement();
      i += 1;
    }
  };

  ShapePath.prototype.setLength = function (len) {
    while (this._maxLength < len) {
      this.doubleArrayLength();
    }

    this._length = len;
  };

  ShapePath.prototype.doubleArrayLength = function () {
    this.v = this.v.concat(createSizedArray(this._maxLength));
    this.i = this.i.concat(createSizedArray(this._maxLength));
    this.o = this.o.concat(createSizedArray(this._maxLength));
    this._maxLength *= 2;
  };

  ShapePath.prototype.setXYAt = function (x, y, type, pos, replace) {
    var arr;
    this._length = Math.max(this._length, pos + 1);

    if (this._length >= this._maxLength) {
      this.doubleArrayLength();
    }

    switch (type) {
      case 'v':
        arr = this.v;
        break;

      case 'i':
        arr = this.i;
        break;

      case 'o':
        arr = this.o;
        break;

      default:
        arr = [];
        break;
    }

    if (!arr[pos] || arr[pos] && !replace) {
      arr[pos] = pointPool.newElement();
    }

    arr[pos][0] = x;
    arr[pos][1] = y;
  };

  ShapePath.prototype.setTripleAt = function (vX, vY, oX, oY, iX, iY, pos, replace) {
    this.setXYAt(vX, vY, 'v', pos, replace);
    this.setXYAt(oX, oY, 'o', pos, replace);
    this.setXYAt(iX, iY, 'i', pos, replace);
  };

  ShapePath.prototype.reverse = function () {
    var newPath = new ShapePath();
    newPath.setPathData(this.c, this._length);
    var vertices = this.v;
    var outPoints = this.o;
    var inPoints = this.i;
    var init = 0;

    if (this.c) {
      newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
      init = 1;
    }

    var cnt = this._length - 1;
    var len = this._length;
    var i;

    for (i = init; i < len; i += 1) {
      newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
      cnt -= 1;
    }

    return newPath;
  };

  ShapePath.prototype.length = function () {
    return this._length;
  };

  var shapePool = function () {
    function create() {
      return new ShapePath();
    }

    function release(shapePath) {
      var len = shapePath._length;
      var i;

      for (i = 0; i < len; i += 1) {
        pointPool.release(shapePath.v[i]);
        pointPool.release(shapePath.i[i]);
        pointPool.release(shapePath.o[i]);
        shapePath.v[i] = null;
        shapePath.i[i] = null;
        shapePath.o[i] = null;
      }

      shapePath._length = 0;
      shapePath.c = false;
    }

    function clone(shape) {
      var cloned = factory.newElement();
      var i;
      var len = shape._length === undefined ? shape.v.length : shape._length;
      cloned.setLength(len);
      cloned.c = shape.c;

      for (i = 0; i < len; i += 1) {
        cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
      }

      return cloned;
    }

    var factory = poolFactory(4, create, release);
    factory.clone = clone;
    return factory;
  }();

  function ShapeCollection() {
    this._length = 0;
    this._maxLength = 4;
    this.shapes = createSizedArray(this._maxLength);
  }

  ShapeCollection.prototype.addShape = function (shapeData) {
    if (this._length === this._maxLength) {
      this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
      this._maxLength *= 2;
    }

    this.shapes[this._length] = shapeData;
    this._length += 1;
  };

  ShapeCollection.prototype.releaseShapes = function () {
    var i;

    for (i = 0; i < this._length; i += 1) {
      shapePool.release(this.shapes[i]);
    }

    this._length = 0;
  };

  var shapeCollectionPool = function () {
    var ob = {
      newShapeCollection: newShapeCollection,
      release: release
    };
    var _length = 0;
    var _maxLength = 4;
    var pool = createSizedArray(_maxLength);

    function newShapeCollection() {
      var shapeCollection;

      if (_length) {
        _length -= 1;
        shapeCollection = pool[_length];
      } else {
        shapeCollection = new ShapeCollection();
      }

      return shapeCollection;
    }

    function release(shapeCollection) {
      var i;
      var len = shapeCollection._length;

      for (i = 0; i < len; i += 1) {
        shapePool.release(shapeCollection.shapes[i]);
      }

      shapeCollection._length = 0;

      if (_length === _maxLength) {
        pool = pooling["double"](pool);
        _maxLength *= 2;
      }

      pool[_length] = shapeCollection;
      _length += 1;
    }

    return ob;
  }();

  var ShapePropertyFactory = function () {
    var initFrame = -999999;

    function interpolateShape(frameNum, previousValue, caching) {
      var iterationIndex = caching.lastIndex;
      var keyPropS;
      var keyPropE;
      var isHold;
      var j;
      var k;
      var jLen;
      var kLen;
      var perc;
      var vertexValue;
      var kf = this.keyframes;

      if (frameNum < kf[0].t - this.offsetTime) {
        keyPropS = kf[0].s[0];
        isHold = true;
        iterationIndex = 0;
      } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
        keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
        /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */

        isHold = true;
      } else {
        var i = iterationIndex;
        var len = kf.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;

        while (flag) {
          keyData = kf[i];
          nextKeyData = kf[i + 1];

          if (nextKeyData.t - this.offsetTime > frameNum) {
            break;
          }

          if (i < len - 1) {
            i += 1;
          } else {
            flag = false;
          }
        }

        keyframeMetadata = this.keyframesMetadata[i] || {};
        isHold = keyData.h === 1;
        iterationIndex = i;

        if (!isHold) {
          if (frameNum >= nextKeyData.t - this.offsetTime) {
            perc = 1;
          } else if (frameNum < keyData.t - this.offsetTime) {
            perc = 0;
          } else {
            var fnc;

            if (keyframeMetadata.__fnct) {
              fnc = keyframeMetadata.__fnct;
            } else {
              fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
              keyframeMetadata.__fnct = fnc;
            }

            perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
          }

          keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
        }

        keyPropS = keyData.s[0];
      }

      jLen = previousValue._length;
      kLen = keyPropS.i[0].length;
      caching.lastIndex = iterationIndex;

      for (j = 0; j < jLen; j += 1) {
        for (k = 0; k < kLen; k += 1) {
          vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
          previousValue.i[j][k] = vertexValue;
          vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
          previousValue.o[j][k] = vertexValue;
          vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
          previousValue.v[j][k] = vertexValue;
        }
      }
    }

    function interpolateShapeCurrentTime() {
      var frameNum = this.comp.renderedFrame - this.offsetTime;
      var initTime = this.keyframes[0].t - this.offsetTime;
      var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      var lastFrame = this._caching.lastFrame;

      if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
        /// /
        this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
        this.interpolateShape(frameNum, this.pv, this._caching); /// /
      }

      this._caching.lastFrame = frameNum;
      return this.pv;
    }

    function resetShape() {
      this.paths = this.localShapeCollection;
    }

    function shapesEqual(shape1, shape2) {
      if (shape1._length !== shape2._length || shape1.c !== shape2.c) {
        return false;
      }

      var i;
      var len = shape1._length;

      for (i = 0; i < len; i += 1) {
        if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) {
          return false;
        }
      }

      return true;
    }

    function setVValue(newPath) {
      if (!shapesEqual(this.v, newPath)) {
        this.v = shapePool.clone(newPath);
        this.localShapeCollection.releaseShapes();
        this.localShapeCollection.addShape(this.v);
        this._mdf = true;
        this.paths = this.localShapeCollection;
      }
    }

    function processEffectsSequence() {
      if (this.elem.globalData.frameId === this.frameId) {
        return;
      }

      if (!this.effectsSequence.length) {
        this._mdf = false;
        return;
      }

      if (this.lock) {
        this.setVValue(this.pv);
        return;
      }

      this.lock = true;
      this._mdf = false;
      var finalValue;

      if (this.kf) {
        finalValue = this.pv;
      } else if (this.data.ks) {
        finalValue = this.data.ks.k;
      } else {
        finalValue = this.data.pt.k;
      }

      var i;
      var len = this.effectsSequence.length;

      for (i = 0; i < len; i += 1) {
        finalValue = this.effectsSequence[i](finalValue);
      }

      this.setVValue(finalValue);
      this.lock = false;
      this.frameId = this.elem.globalData.frameId;
    }

    function ShapeProperty(elem, data, type) {
      this.propType = 'shape';
      this.comp = elem.comp;
      this.container = elem;
      this.elem = elem;
      this.data = data;
      this.k = false;
      this.kf = false;
      this._mdf = false;
      var pathData = type === 3 ? data.pt.k : data.ks.k;
      this.v = shapePool.clone(pathData);
      this.pv = shapePool.clone(this.v);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.paths = this.localShapeCollection;
      this.paths.addShape(this.v);
      this.reset = resetShape;
      this.effectsSequence = [];
    }

    function addEffect(effectFunction) {
      this.effectsSequence.push(effectFunction);
      this.container.addDynamicProperty(this);
    }

    ShapeProperty.prototype.interpolateShape = interpolateShape;
    ShapeProperty.prototype.getValue = processEffectsSequence;
    ShapeProperty.prototype.setVValue = setVValue;
    ShapeProperty.prototype.addEffect = addEffect;

    function KeyframedShapeProperty(elem, data, type) {
      this.propType = 'shape';
      this.comp = elem.comp;
      this.elem = elem;
      this.container = elem;
      this.offsetTime = elem.data.st;
      this.keyframes = type === 3 ? data.pt.k : data.ks.k;
      this.keyframesMetadata = [];
      this.k = true;
      this.kf = true;
      var len = this.keyframes[0].s[0].i.length;
      this.v = shapePool.newElement();
      this.v.setPathData(this.keyframes[0].s[0].c, len);
      this.pv = shapePool.clone(this.v);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.paths = this.localShapeCollection;
      this.paths.addShape(this.v);
      this.lastFrame = initFrame;
      this.reset = resetShape;
      this._caching = {
        lastFrame: initFrame,
        lastIndex: 0
      };
      this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
    }

    KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
    KeyframedShapeProperty.prototype.setVValue = setVValue;
    KeyframedShapeProperty.prototype.addEffect = addEffect;

    var EllShapeProperty = function () {
      var cPoint = roundCorner;

      function EllShapePropertyFactory(elem, data) {
        this.v = shapePool.newElement();
        this.v.setPathData(true, 4);
        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
        this.paths = this.localShapeCollection;
        this.localShapeCollection.addShape(this.v);
        this.d = data.d;
        this.elem = elem;
        this.comp = elem.comp;
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);

        if (this.dynamicProperties.length) {
          this.k = true;
        } else {
          this.k = false;
          this.convertEllToPath();
        }
      }

      EllShapePropertyFactory.prototype = {
        reset: resetShape,
        getValue: function getValue() {
          if (this.elem.globalData.frameId === this.frameId) {
            return;
          }

          this.frameId = this.elem.globalData.frameId;
          this.iterateDynamicProperties();

          if (this._mdf) {
            this.convertEllToPath();
          }
        },
        convertEllToPath: function convertEllToPath() {
          var p0 = this.p.v[0];
          var p1 = this.p.v[1];
          var s0 = this.s.v[0] / 2;
          var s1 = this.s.v[1] / 2;

          var _cw = this.d !== 3;

          var _v = this.v;
          _v.v[0][0] = p0;
          _v.v[0][1] = p1 - s1;
          _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
          _v.v[1][1] = p1;
          _v.v[2][0] = p0;
          _v.v[2][1] = p1 + s1;
          _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
          _v.v[3][1] = p1;
          _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
          _v.i[0][1] = p1 - s1;
          _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
          _v.i[1][1] = p1 - s1 * cPoint;
          _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
          _v.i[2][1] = p1 + s1;
          _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
          _v.i[3][1] = p1 + s1 * cPoint;
          _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
          _v.o[0][1] = p1 - s1;
          _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
          _v.o[1][1] = p1 + s1 * cPoint;
          _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
          _v.o[2][1] = p1 + s1;
          _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
          _v.o[3][1] = p1 - s1 * cPoint;
        }
      };
      extendPrototype([DynamicPropertyContainer], EllShapePropertyFactory);
      return EllShapePropertyFactory;
    }();

    var StarShapeProperty = function () {
      function StarShapePropertyFactory(elem, data) {
        this.v = shapePool.newElement();
        this.v.setPathData(true, 0);
        this.elem = elem;
        this.comp = elem.comp;
        this.data = data;
        this.frameId = -1;
        this.d = data.d;
        this.initDynamicPropertyContainer(elem);

        if (data.sy === 1) {
          this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
          this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
          this.convertToPath = this.convertStarToPath;
        } else {
          this.convertToPath = this.convertPolygonToPath;
        }

        this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
        this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
        this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
        this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
        this.localShapeCollection.addShape(this.v);
        this.paths = this.localShapeCollection;

        if (this.dynamicProperties.length) {
          this.k = true;
        } else {
          this.k = false;
          this.convertToPath();
        }
      }

      StarShapePropertyFactory.prototype = {
        reset: resetShape,
        getValue: function getValue() {
          if (this.elem.globalData.frameId === this.frameId) {
            return;
          }

          this.frameId = this.elem.globalData.frameId;
          this.iterateDynamicProperties();

          if (this._mdf) {
            this.convertToPath();
          }
        },
        convertStarToPath: function convertStarToPath() {
          var numPts = Math.floor(this.pt.v) * 2;
          var angle = Math.PI * 2 / numPts;
          /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */

          var longFlag = true;
          var longRad = this.or.v;
          var shortRad = this.ir.v;
          var longRound = this.os.v;
          var shortRound = this.is.v;
          var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
          var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
          var i;
          var rad;
          var roundness;
          var perimSegment;
          var currentAng = -Math.PI / 2;
          currentAng += this.r.v;
          var dir = this.data.d === 3 ? -1 : 1;
          this.v._length = 0;

          for (i = 0; i < numPts; i += 1) {
            rad = longFlag ? longRad : shortRad;
            roundness = longFlag ? longRound : shortRound;
            perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
            var x = rad * Math.cos(currentAng);
            var y = rad * Math.sin(currentAng);
            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
            x += +this.p.v[0];
            y += +this.p.v[1];
            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
            /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */

            longFlag = !longFlag;
            currentAng += angle * dir;
          }
        },
        convertPolygonToPath: function convertPolygonToPath() {
          var numPts = Math.floor(this.pt.v);
          var angle = Math.PI * 2 / numPts;
          var rad = this.or.v;
          var roundness = this.os.v;
          var perimSegment = 2 * Math.PI * rad / (numPts * 4);
          var i;
          var currentAng = -Math.PI * 0.5;
          var dir = this.data.d === 3 ? -1 : 1;
          currentAng += this.r.v;
          this.v._length = 0;

          for (i = 0; i < numPts; i += 1) {
            var x = rad * Math.cos(currentAng);
            var y = rad * Math.sin(currentAng);
            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
            x += +this.p.v[0];
            y += +this.p.v[1];
            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
            currentAng += angle * dir;
          }

          this.paths.length = 0;
          this.paths[0] = this.v;
        }
      };
      extendPrototype([DynamicPropertyContainer], StarShapePropertyFactory);
      return StarShapePropertyFactory;
    }();

    var RectShapeProperty = function () {
      function RectShapePropertyFactory(elem, data) {
        this.v = shapePool.newElement();
        this.v.c = true;
        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
        this.localShapeCollection.addShape(this.v);
        this.paths = this.localShapeCollection;
        this.elem = elem;
        this.comp = elem.comp;
        this.frameId = -1;
        this.d = data.d;
        this.initDynamicPropertyContainer(elem);
        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
        this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);

        if (this.dynamicProperties.length) {
          this.k = true;
        } else {
          this.k = false;
          this.convertRectToPath();
        }
      }

      RectShapePropertyFactory.prototype = {
        convertRectToPath: function convertRectToPath() {
          var p0 = this.p.v[0];
          var p1 = this.p.v[1];
          var v0 = this.s.v[0] / 2;
          var v1 = this.s.v[1] / 2;
          var round = bmMin(v0, v1, this.r.v);
          var cPoint = round * (1 - roundCorner);
          this.v._length = 0;

          if (this.d === 2 || this.d === 1) {
            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);

            if (round !== 0) {
              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
            } else {
              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
            }
          } else {
            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);

            if (round !== 0) {
              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
              this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
            } else {
              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
              this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
            }
          }
        },
        getValue: function getValue() {
          if (this.elem.globalData.frameId === this.frameId) {
            return;
          }

          this.frameId = this.elem.globalData.frameId;
          this.iterateDynamicProperties();

          if (this._mdf) {
            this.convertRectToPath();
          }
        },
        reset: resetShape
      };
      extendPrototype([DynamicPropertyContainer], RectShapePropertyFactory);
      return RectShapePropertyFactory;
    }();

    function getShapeProp(elem, data, type) {
      var prop;

      if (type === 3 || type === 4) {
        var dataProp = type === 3 ? data.pt : data.ks;
        var keys = dataProp.k;

        if (keys.length) {
          prop = new KeyframedShapeProperty(elem, data, type);
        } else {
          prop = new ShapeProperty(elem, data, type);
        }
      } else if (type === 5) {
        prop = new RectShapeProperty(elem, data);
      } else if (type === 6) {
        prop = new EllShapeProperty(elem, data);
      } else if (type === 7) {
        prop = new StarShapeProperty(elem, data);
      }

      if (prop.k) {
        elem.addDynamicProperty(prop);
      }

      return prop;
    }

    function getConstructorFunction() {
      return ShapeProperty;
    }

    function getKeyframedConstructorFunction() {
      return KeyframedShapeProperty;
    }

    var ob = {};
    ob.getShapeProp = getShapeProp;
    ob.getConstructorFunction = getConstructorFunction;
    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
    return ob;
  }();

  /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */

  /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */

  var Matrix = function () {
    var _cos = Math.cos;
    var _sin = Math.sin;
    var _tan = Math.tan;
    var _rnd = Math.round;

    function reset() {
      this.props[0] = 1;
      this.props[1] = 0;
      this.props[2] = 0;
      this.props[3] = 0;
      this.props[4] = 0;
      this.props[5] = 1;
      this.props[6] = 0;
      this.props[7] = 0;
      this.props[8] = 0;
      this.props[9] = 0;
      this.props[10] = 1;
      this.props[11] = 0;
      this.props[12] = 0;
      this.props[13] = 0;
      this.props[14] = 0;
      this.props[15] = 1;
      return this;
    }

    function rotate(angle) {
      if (angle === 0) {
        return this;
      }

      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    function rotateX(angle) {
      if (angle === 0) {
        return this;
      }

      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
    }

    function rotateY(angle) {
      if (angle === 0) {
        return this;
      }

      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
    }

    function rotateZ(angle) {
      if (angle === 0) {
        return this;
      }

      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    function shear(sx, sy) {
      return this._t(1, sy, sx, 1, 0, 0);
    }

    function skew(ax, ay) {
      return this.shear(_tan(ax), _tan(ay));
    }

    function skewFromAxis(ax, angle) {
      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
    }

    function scale(sx, sy, sz) {
      if (!sz && sz !== 0) {
        sz = 1;
      }

      if (sx === 1 && sy === 1 && sz === 1) {
        return this;
      }

      return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
    }

    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
      this.props[0] = a;
      this.props[1] = b;
      this.props[2] = c;
      this.props[3] = d;
      this.props[4] = e;
      this.props[5] = f;
      this.props[6] = g;
      this.props[7] = h;
      this.props[8] = i;
      this.props[9] = j;
      this.props[10] = k;
      this.props[11] = l;
      this.props[12] = m;
      this.props[13] = n;
      this.props[14] = o;
      this.props[15] = p;
      return this;
    }

    function translate(tx, ty, tz) {
      tz = tz || 0;

      if (tx !== 0 || ty !== 0 || tz !== 0) {
        return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
      }

      return this;
    }

    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
      var _p = this.props;

      if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
        // NOTE: commenting this condition because TurboFan deoptimizes code when present
        // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
        _p[12] = _p[12] * a2 + _p[15] * m2;
        _p[13] = _p[13] * f2 + _p[15] * n2;
        _p[14] = _p[14] * k2 + _p[15] * o2;
        _p[15] *= p2; // }

        this._identityCalculated = false;
        return this;
      }

      var a1 = _p[0];
      var b1 = _p[1];
      var c1 = _p[2];
      var d1 = _p[3];
      var e1 = _p[4];
      var f1 = _p[5];
      var g1 = _p[6];
      var h1 = _p[7];
      var i1 = _p[8];
      var j1 = _p[9];
      var k1 = _p[10];
      var l1 = _p[11];
      var m1 = _p[12];
      var n1 = _p[13];
      var o1 = _p[14];
      var p1 = _p[15];
      /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */

      _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
      _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
      _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
      _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
      _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
      _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
      _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
      _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
      _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
      _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
      _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
      _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
      _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
      _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
      _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
      _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
      this._identityCalculated = false;
      return this;
    }

    function multiply(matrix) {
      var matrixProps = matrix.props;
      return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
    }

    function isIdentity() {
      if (!this._identityCalculated) {
        this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
        this._identityCalculated = true;
      }

      return this._identity;
    }

    function equals(matr) {
      var i = 0;

      while (i < 16) {
        if (matr.props[i] !== this.props[i]) {
          return false;
        }

        i += 1;
      }

      return true;
    }

    function clone(matr) {
      var i;

      for (i = 0; i < 16; i += 1) {
        matr.props[i] = this.props[i];
      }

      return matr;
    }

    function cloneFromProps(props) {
      var i;

      for (i = 0; i < 16; i += 1) {
        this.props[i] = props[i];
      }
    }

    function applyToPoint(x, y, z) {
      return {
        x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
        y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
        z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
      };
      /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */
    }

    function applyToX(x, y, z) {
      return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
    }

    function applyToY(x, y, z) {
      return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
    }

    function applyToZ(x, y, z) {
      return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
    }

    function getInverseMatrix() {
      var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
      var a = this.props[5] / determinant;
      var b = -this.props[1] / determinant;
      var c = -this.props[4] / determinant;
      var d = this.props[0] / determinant;
      var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
      var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
      var inverseMatrix = new Matrix();
      inverseMatrix.props[0] = a;
      inverseMatrix.props[1] = b;
      inverseMatrix.props[4] = c;
      inverseMatrix.props[5] = d;
      inverseMatrix.props[12] = e;
      inverseMatrix.props[13] = f;
      return inverseMatrix;
    }

    function inversePoint(pt) {
      var inverseMatrix = this.getInverseMatrix();
      return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
    }

    function inversePoints(pts) {
      var i;
      var len = pts.length;
      var retPts = [];

      for (i = 0; i < len; i += 1) {
        retPts[i] = inversePoint(pts[i]);
      }

      return retPts;
    }

    function applyToTriplePoints(pt1, pt2, pt3) {
      var arr = createTypedArray('float32', 6);

      if (this.isIdentity()) {
        arr[0] = pt1[0];
        arr[1] = pt1[1];
        arr[2] = pt2[0];
        arr[3] = pt2[1];
        arr[4] = pt3[0];
        arr[5] = pt3[1];
      } else {
        var p0 = this.props[0];
        var p1 = this.props[1];
        var p4 = this.props[4];
        var p5 = this.props[5];
        var p12 = this.props[12];
        var p13 = this.props[13];
        arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
        arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
        arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
        arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
        arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
        arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
      }

      return arr;
    }

    function applyToPointArray(x, y, z) {
      var arr;

      if (this.isIdentity()) {
        arr = [x, y, z];
      } else {
        arr = [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12], x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13], x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
      }

      return arr;
    }

    function applyToPointStringified(x, y) {
      if (this.isIdentity()) {
        return x + ',' + y;
      }

      var _p = this.props;
      return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
    }

    function toCSS() {
      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.

      /* if(this.isIdentity()) {
              return '';
          } */
      var i = 0;
      var props = this.props;
      var cssValue = 'matrix3d(';
      var v = 10000;

      while (i < 16) {
        cssValue += _rnd(props[i] * v) / v;
        cssValue += i === 15 ? ')' : ',';
        i += 1;
      }

      return cssValue;
    }

    function roundMatrixProperty(val) {
      var v = 10000;

      if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) {
        return _rnd(val * v) / v;
      }

      return val;
    }

    function to2dCSS() {
      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.

      /* if(this.isIdentity()) {
              return '';
          } */
      var props = this.props;

      var _a = roundMatrixProperty(props[0]);

      var _b = roundMatrixProperty(props[1]);

      var _c = roundMatrixProperty(props[4]);

      var _d = roundMatrixProperty(props[5]);

      var _e = roundMatrixProperty(props[12]);

      var _f = roundMatrixProperty(props[13]);

      return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
    }

    return function () {
      this.reset = reset;
      this.rotate = rotate;
      this.rotateX = rotateX;
      this.rotateY = rotateY;
      this.rotateZ = rotateZ;
      this.skew = skew;
      this.skewFromAxis = skewFromAxis;
      this.shear = shear;
      this.scale = scale;
      this.setTransform = setTransform;
      this.translate = translate;
      this.transform = transform;
      this.multiply = multiply;
      this.applyToPoint = applyToPoint;
      this.applyToX = applyToX;
      this.applyToY = applyToY;
      this.applyToZ = applyToZ;
      this.applyToPointArray = applyToPointArray;
      this.applyToTriplePoints = applyToTriplePoints;
      this.applyToPointStringified = applyToPointStringified;
      this.toCSS = toCSS;
      this.to2dCSS = to2dCSS;
      this.clone = clone;
      this.cloneFromProps = cloneFromProps;
      this.equals = equals;
      this.inversePoints = inversePoints;
      this.inversePoint = inversePoint;
      this.getInverseMatrix = getInverseMatrix;
      this._t = this.transform;
      this.isIdentity = isIdentity;
      this._identity = true;
      this._identityCalculated = false;
      this.props = createTypedArray('float32', 16);
      this.reset();
    };
  }();

  function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
  var lottie = {};
  var renderer = '';

  function setLocation(href) {
    setLocationHref(href);
  }

  function searchAnimations() {
    {
      animationManager.searchAnimations();
    }
  }

  function setSubframeRendering(flag) {
    setSubframeEnabled(flag);
  }

  function setPrefix(prefix) {
    setIdPrefix(prefix);
  }

  function loadAnimation(params) {

    return animationManager.loadAnimation(params);
  }

  function setQuality(value) {
    if (typeof value === 'string') {
      switch (value) {
        case 'high':
          setDefaultCurveSegments(200);
          break;

        default:
        case 'medium':
          setDefaultCurveSegments(50);
          break;

        case 'low':
          setDefaultCurveSegments(10);
          break;
      }
    } else if (!isNaN(value) && value > 1) {
      setDefaultCurveSegments(value);
    }
  }

  function inBrowser() {
    return typeof navigator !== 'undefined';
  }

  function installPlugin(type, plugin) {
    if (type === 'expressions') {
      setExpressionsPlugin(plugin);
    }
  }

  function getFactory(name) {
    switch (name) {
      case 'propertyFactory':
        return PropertyFactory;

      case 'shapePropertyFactory':
        return ShapePropertyFactory;

      case 'matrix':
        return Matrix;

      default:
        return null;
    }
  }

  lottie.play = animationManager.play;
  lottie.pause = animationManager.pause;
  lottie.setLocationHref = setLocation;
  lottie.togglePause = animationManager.togglePause;
  lottie.setSpeed = animationManager.setSpeed;
  lottie.setDirection = animationManager.setDirection;
  lottie.stop = animationManager.stop;
  lottie.searchAnimations = searchAnimations;
  lottie.registerAnimation = animationManager.registerAnimation;
  lottie.loadAnimation = loadAnimation;
  lottie.setSubframeRendering = setSubframeRendering;
  lottie.resize = animationManager.resize; // lottie.start = start;

  lottie.goToAndStop = animationManager.goToAndStop;
  lottie.destroy = animationManager.destroy;
  lottie.setQuality = setQuality;
  lottie.inBrowser = inBrowser;
  lottie.installPlugin = installPlugin;
  lottie.freeze = animationManager.freeze;
  lottie.unfreeze = animationManager.unfreeze;
  lottie.setVolume = animationManager.setVolume;
  lottie.mute = animationManager.mute;
  lottie.unmute = animationManager.unmute;
  lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
  lottie.useWebWorker = setWebWorker;
  lottie.setIDPrefix = setPrefix;
  lottie.__getFactory = getFactory;
  lottie.version = '5.12.2';

  function checkReady() {
    if (document.readyState === 'complete') {
      clearInterval(readyStateCheckInterval);
      searchAnimations();
    }
  }

  function getQueryVariable(variable) {
    var vars = queryString.split('&');

    for (var i = 0; i < vars.length; i += 1) {
      var pair = vars[i].split('=');

      if (decodeURIComponent(pair[0]) == variable) {
        // eslint-disable-line eqeqeq
        return decodeURIComponent(pair[1]);
      }
    }

    return null;
  }

  var queryString = '';

  {
    var scripts = document.getElementsByTagName('script');
    var index = scripts.length - 1;
    var myScript = scripts[index] || {
      src: ''
    };
    queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape

    renderer = getQueryVariable('renderer');
  }

  var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility

  try {
    if (!((_typeof(exports)) === 'object' && 'object' !== 'undefined') && !(typeof undefined === 'function' && undefined.amd) // eslint-disable-line no-undef
    ) {
      window.bodymovin = lottie;
    }
  } catch (err) {//
  }

  var ShapeModifiers = function () {
    var ob = {};
    var modifiers = {};
    ob.registerModifier = registerModifier;
    ob.getModifier = getModifier;

    function registerModifier(nm, factory) {
      if (!modifiers[nm]) {
        modifiers[nm] = factory;
      }
    }

    function getModifier(nm, elem, data) {
      return new modifiers[nm](elem, data);
    }

    return ob;
  }();

  function ShapeModifier() {}

  ShapeModifier.prototype.initModifierProperties = function () {};

  ShapeModifier.prototype.addShapeToModifier = function () {};

  ShapeModifier.prototype.addShape = function (data) {
    if (!this.closed) {
      // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
      data.sh.container.addDynamicProperty(data.sh);
      var shapeData = {
        shape: data.sh,
        data: data,
        localShapeCollection: shapeCollectionPool.newShapeCollection()
      };
      this.shapes.push(shapeData);
      this.addShapeToModifier(shapeData);

      if (this._isAnimated) {
        data.setAsAnimated();
      }
    }
  };

  ShapeModifier.prototype.init = function (elem, data) {
    this.shapes = [];
    this.elem = elem;
    this.initDynamicPropertyContainer(elem);
    this.initModifierProperties(elem, data);
    this.frameId = initialDefaultFrame;
    this.closed = false;
    this.k = false;

    if (this.dynamicProperties.length) {
      this.k = true;
    } else {
      this.getValue(true);
    }
  };

  ShapeModifier.prototype.processKeys = function () {
    if (this.elem.globalData.frameId === this.frameId) {
      return;
    }

    this.frameId = this.elem.globalData.frameId;
    this.iterateDynamicProperties();
  };

  extendPrototype([DynamicPropertyContainer], ShapeModifier);

  function TrimModifier() {}

  extendPrototype([ShapeModifier], TrimModifier);

  TrimModifier.prototype.initModifierProperties = function (elem, data) {
    this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
    this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
    this.sValue = 0;
    this.eValue = 0;
    this.getValue = this.processKeys;
    this.m = data.m;
    this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
  };

  TrimModifier.prototype.addShapeToModifier = function (shapeData) {
    shapeData.pathsData = [];
  };

  TrimModifier.prototype.calculateShapeEdges = function (s, e, shapeLength, addedLength, totalModifierLength) {
    var segments = [];

    if (e <= 1) {
      segments.push({
        s: s,
        e: e
      });
    } else if (s >= 1) {
      segments.push({
        s: s - 1,
        e: e - 1
      });
    } else {
      segments.push({
        s: s,
        e: 1
      });
      segments.push({
        s: 0,
        e: e - 1
      });
    }

    var shapeSegments = [];
    var i;
    var len = segments.length;
    var segmentOb;

    for (i = 0; i < len; i += 1) {
      segmentOb = segments[i];

      if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
        var shapeS;
        var shapeE;

        if (segmentOb.s * totalModifierLength <= addedLength) {
          shapeS = 0;
        } else {
          shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
        }

        if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
          shapeE = 1;
        } else {
          shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
        }

        shapeSegments.push([shapeS, shapeE]);
      }
    }

    if (!shapeSegments.length) {
      shapeSegments.push([0, 0]);
    }

    return shapeSegments;
  };

  TrimModifier.prototype.releasePathsData = function (pathsData) {
    var i;
    var len = pathsData.length;

    for (i = 0; i < len; i += 1) {
      segmentsLengthPool.release(pathsData[i]);
    }

    pathsData.length = 0;
    return pathsData;
  };

  TrimModifier.prototype.processShapes = function (_isFirstFrame) {
    var s;
    var e;

    if (this._mdf || _isFirstFrame) {
      var o = this.o.v % 360 / 360;

      if (o < 0) {
        o += 1;
      }

      if (this.s.v > 1) {
        s = 1 + o;
      } else if (this.s.v < 0) {
        s = 0 + o;
      } else {
        s = this.s.v + o;
      }

      if (this.e.v > 1) {
        e = 1 + o;
      } else if (this.e.v < 0) {
        e = 0 + o;
      } else {
        e = this.e.v + o;
      }

      if (s > e) {
        var _s = s;
        s = e;
        e = _s;
      }

      s = Math.round(s * 10000) * 0.0001;
      e = Math.round(e * 10000) * 0.0001;
      this.sValue = s;
      this.eValue = e;
    } else {
      s = this.sValue;
      e = this.eValue;
    }

    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var pathsData;
    var pathData;
    var totalShapeLength;
    var totalModifierLength = 0;

    if (e === s) {
      for (i = 0; i < len; i += 1) {
        this.shapes[i].localShapeCollection.releaseShapes();
        this.shapes[i].shape._mdf = true;
        this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;

        if (this._mdf) {
          this.shapes[i].pathsData.length = 0;
        }
      }
    } else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
      var segments = [];
      var shapeData;
      var localShapeCollection;

      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used

        if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
          shapeData.shape.paths = shapeData.localShapeCollection;
        } else {
          shapePaths = shapeData.shape.paths;
          jLen = shapePaths._length;
          totalShapeLength = 0;

          if (!shapeData.shape._mdf && shapeData.pathsData.length) {
            totalShapeLength = shapeData.totalShapeLength;
          } else {
            pathsData = this.releasePathsData(shapeData.pathsData);

            for (j = 0; j < jLen; j += 1) {
              pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
              pathsData.push(pathData);
              totalShapeLength += pathData.totalLength;
            }

            shapeData.totalShapeLength = totalShapeLength;
            shapeData.pathsData = pathsData;
          }

          totalModifierLength += totalShapeLength;
          shapeData.shape._mdf = true;
        }
      }

      var shapeS = s;
      var shapeE = e;
      var addedLength = 0;
      var edges;

      for (i = len - 1; i >= 0; i -= 1) {
        shapeData = this.shapes[i];

        if (shapeData.shape._mdf) {
          localShapeCollection = shapeData.localShapeCollection;
          localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group

          if (this.m === 2 && len > 1) {
            edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
            addedLength += shapeData.totalShapeLength;
          } else {
            edges = [[shapeS, shapeE]];
          }

          jLen = edges.length;

          for (j = 0; j < jLen; j += 1) {
            shapeS = edges[j][0];
            shapeE = edges[j][1];
            segments.length = 0;

            if (shapeE <= 1) {
              segments.push({
                s: shapeData.totalShapeLength * shapeS,
                e: shapeData.totalShapeLength * shapeE
              });
            } else if (shapeS >= 1) {
              segments.push({
                s: shapeData.totalShapeLength * (shapeS - 1),
                e: shapeData.totalShapeLength * (shapeE - 1)
              });
            } else {
              segments.push({
                s: shapeData.totalShapeLength * shapeS,
                e: shapeData.totalShapeLength
              });
              segments.push({
                s: 0,
                e: shapeData.totalShapeLength * (shapeE - 1)
              });
            }

            var newShapesData = this.addShapes(shapeData, segments[0]);

            if (segments[0].s !== segments[0].e) {
              if (segments.length > 1) {
                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];

                if (lastShapeInCollection.c) {
                  var lastShape = newShapesData.pop();
                  this.addPaths(newShapesData, localShapeCollection);
                  newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                } else {
                  this.addPaths(newShapesData, localShapeCollection);
                  newShapesData = this.addShapes(shapeData, segments[1]);
                }
              }

              this.addPaths(newShapesData, localShapeCollection);
            }
          }

          shapeData.shape.paths = localShapeCollection;
        }
      }
    } else if (this._mdf) {
      for (i = 0; i < len; i += 1) {
        // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
        // Don't remove this even if it's losing cached info.
        this.shapes[i].pathsData.length = 0;
        this.shapes[i].shape._mdf = true;
      }
    }
  };

  TrimModifier.prototype.addPaths = function (newPaths, localShapeCollection) {
    var i;
    var len = newPaths.length;

    for (i = 0; i < len; i += 1) {
      localShapeCollection.addShape(newPaths[i]);
    }
  };

  TrimModifier.prototype.addSegment = function (pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
    shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
    shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);

    if (newShape) {
      shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
    }

    shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
  };

  TrimModifier.prototype.addSegmentFromArray = function (points, shapePath, pos, newShape) {
    shapePath.setXYAt(points[1], points[5], 'o', pos);
    shapePath.setXYAt(points[2], points[6], 'i', pos + 1);

    if (newShape) {
      shapePath.setXYAt(points[0], points[4], 'v', pos);
    }

    shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
  };

  TrimModifier.prototype.addShapes = function (shapeData, shapeSegment, shapePath) {
    var pathsData = shapeData.pathsData;
    var shapePaths = shapeData.shape.paths.shapes;
    var i;
    var len = shapeData.shape.paths._length;
    var j;
    var jLen;
    var addedLength = 0;
    var currentLengthData;
    var segmentCount;
    var lengths;
    var segment;
    var shapes = [];
    var initPos;
    var newShape = true;

    if (!shapePath) {
      shapePath = shapePool.newElement();
      segmentCount = 0;
      initPos = 0;
    } else {
      segmentCount = shapePath._length;
      initPos = shapePath._length;
    }

    shapes.push(shapePath);

    for (i = 0; i < len; i += 1) {
      lengths = pathsData[i].lengths;
      shapePath.c = shapePaths[i].c;
      jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;

      for (j = 1; j < jLen; j += 1) {
        currentLengthData = lengths[j - 1];

        if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
          addedLength += currentLengthData.addedLength;
          shapePath.c = false;
        } else if (addedLength > shapeSegment.e) {
          shapePath.c = false;
          break;
        } else {
          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
            newShape = false;
          } else {
            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);

            newShape = false;
            shapePath.c = false;
          }

          addedLength += currentLengthData.addedLength;
          segmentCount += 1;
        }
      }

      if (shapePaths[i].c && lengths.length) {
        currentLengthData = lengths[j - 1];

        if (addedLength <= shapeSegment.e) {
          var segmentLength = lengths[j - 1].addedLength;

          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
            newShape = false;
          } else {
            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);

            newShape = false;
            shapePath.c = false;
          }
        } else {
          shapePath.c = false;
        }

        addedLength += currentLengthData.addedLength;
        segmentCount += 1;
      }

      if (shapePath._length) {
        shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
        shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
      }

      if (addedLength > shapeSegment.e) {
        break;
      }

      if (i < len - 1) {
        shapePath = shapePool.newElement();
        newShape = true;
        shapes.push(shapePath);
        segmentCount = 0;
      }
    }

    return shapes;
  };

  function PuckerAndBloatModifier() {}

  extendPrototype([ShapeModifier], PuckerAndBloatModifier);

  PuckerAndBloatModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
    this._isAnimated = !!this.amount.effectsSequence.length;
  };

  PuckerAndBloatModifier.prototype.processPath = function (path, amount) {
    var percent = amount / 100;
    var centerPoint = [0, 0];
    var pathLength = path._length;
    var i = 0;

    for (i = 0; i < pathLength; i += 1) {
      centerPoint[0] += path.v[i][0];
      centerPoint[1] += path.v[i][1];
    }

    centerPoint[0] /= pathLength;
    centerPoint[1] /= pathLength;
    var clonedPath = shapePool.newElement();
    clonedPath.c = path.c;
    var vX;
    var vY;
    var oX;
    var oY;
    var iX;
    var iY;

    for (i = 0; i < pathLength; i += 1) {
      vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
      vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
      oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
      oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
      iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
      iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
      clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
    }

    return clonedPath;
  };

  PuckerAndBloatModifier.prototype.processShapes = function (_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var amount = this.amount.v;

    if (amount !== 0) {
      var shapeData;
      var localShapeCollection;

      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;

        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
          localShapeCollection.releaseShapes();
          shapeData.shape._mdf = true;
          shapePaths = shapeData.shape.paths.shapes;
          jLen = shapeData.shape.paths._length;

          for (j = 0; j < jLen; j += 1) {
            localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
          }
        }

        shapeData.shape.paths = shapeData.localShapeCollection;
      }
    }

    if (!this.dynamicProperties.length) {
      this._mdf = false;
    }
  };

  var TransformPropertyFactory = function () {
    var defaultVector = [0, 0];

    function applyToMatrix(mat) {
      var _mdf = this._mdf;
      this.iterateDynamicProperties();
      this._mdf = this._mdf || _mdf;

      if (this.a) {
        mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
      }

      if (this.s) {
        mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
      }

      if (this.sk) {
        mat.skewFromAxis(-this.sk.v, this.sa.v);
      }

      if (this.r) {
        mat.rotate(-this.r.v);
      } else {
        mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
      }

      if (this.data.p.s) {
        if (this.data.p.z) {
          mat.translate(this.px.v, this.py.v, -this.pz.v);
        } else {
          mat.translate(this.px.v, this.py.v, 0);
        }
      } else {
        mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
    }

    function processKeys(forceRender) {
      if (this.elem.globalData.frameId === this.frameId) {
        return;
      }

      if (this._isDirty) {
        this.precalculateMatrix();
        this._isDirty = false;
      }

      this.iterateDynamicProperties();

      if (this._mdf || forceRender) {
        var frameRate;
        this.v.cloneFromProps(this.pre.props);

        if (this.appliedTransformations < 1) {
          this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
        }

        if (this.appliedTransformations < 2) {
          this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
        }

        if (this.sk && this.appliedTransformations < 3) {
          this.v.skewFromAxis(-this.sk.v, this.sa.v);
        }

        if (this.r && this.appliedTransformations < 4) {
          this.v.rotate(-this.r.v);
        } else if (!this.r && this.appliedTransformations < 4) {
          this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
        }

        if (this.autoOriented) {
          var v1;
          var v2;
          frameRate = this.elem.globalData.frameRate;

          if (this.p && this.p.keyframes && this.p.getValueAtTime) {
            if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
              v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
              v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
            } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
              v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
              v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
            } else {
              v1 = this.p.pv;
              v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
            }
          } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
            v1 = [];
            v2 = [];
            var px = this.px;
            var py = this.py;

            if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
              v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
              v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
              v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
              v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
            } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
              v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
              v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
              v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
              v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
            } else {
              v1 = [px.pv, py.pv];
              v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
              v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
            }
          } else {
            v2 = defaultVector;
            v1 = v2;
          }

          this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
        }

        if (this.data.p && this.data.p.s) {
          if (this.data.p.z) {
            this.v.translate(this.px.v, this.py.v, -this.pz.v);
          } else {
            this.v.translate(this.px.v, this.py.v, 0);
          }
        } else {
          this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
      }

      this.frameId = this.elem.globalData.frameId;
    }

    function precalculateMatrix() {
      this.appliedTransformations = 0;
      this.pre.reset();

      if (!this.a.effectsSequence.length) {
        this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
        this.appliedTransformations = 1;
      } else {
        return;
      }

      if (!this.s.effectsSequence.length) {
        this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
        this.appliedTransformations = 2;
      } else {
        return;
      }

      if (this.sk) {
        if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
          this.pre.skewFromAxis(-this.sk.v, this.sa.v);
          this.appliedTransformations = 3;
        } else {
          return;
        }
      }

      if (this.r) {
        if (!this.r.effectsSequence.length) {
          this.pre.rotate(-this.r.v);
          this.appliedTransformations = 4;
        }
      } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
        this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
        this.appliedTransformations = 4;
      }
    }

    function autoOrient() {//
      // var prevP = this.getValueAtTime();
    }

    function addDynamicProperty(prop) {
      this._addDynamicProperty(prop);

      this.elem.addDynamicProperty(prop);
      this._isDirty = true;
    }

    function TransformProperty(elem, data, container) {
      this.elem = elem;
      this.frameId = -1;
      this.propType = 'transform';
      this.data = data;
      this.v = new Matrix(); // Precalculated matrix with non animated properties

      this.pre = new Matrix();
      this.appliedTransformations = 0;
      this.initDynamicPropertyContainer(container || elem);

      if (data.p && data.p.s) {
        this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
        this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);

        if (data.p.z) {
          this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
        }
      } else {
        this.p = PropertyFactory.getProp(elem, data.p || {
          k: [0, 0, 0]
        }, 1, 0, this);
      }

      if (data.rx) {
        this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
        this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
        this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);

        if (data.or.k[0].ti) {
          var i;
          var len = data.or.k.length;

          for (i = 0; i < len; i += 1) {
            data.or.k[i].to = null;
            data.or.k[i].ti = null;
          }
        }

        this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180

        this.or.sh = true;
      } else {
        this.r = PropertyFactory.getProp(elem, data.r || {
          k: 0
        }, 0, degToRads, this);
      }

      if (data.sk) {
        this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
        this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
      }

      this.a = PropertyFactory.getProp(elem, data.a || {
        k: [0, 0, 0]
      }, 1, 0, this);
      this.s = PropertyFactory.getProp(elem, data.s || {
        k: [100, 100, 100]
      }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.

      if (data.o) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
      } else {
        this.o = {
          _mdf: false,
          v: 1
        };
      }

      this._isDirty = true;

      if (!this.dynamicProperties.length) {
        this.getValue(true);
      }
    }

    TransformProperty.prototype = {
      applyToMatrix: applyToMatrix,
      getValue: processKeys,
      precalculateMatrix: precalculateMatrix,
      autoOrient: autoOrient
    };
    extendPrototype([DynamicPropertyContainer], TransformProperty);
    TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
    TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;

    function getTransformProperty(elem, data, container) {
      return new TransformProperty(elem, data, container);
    }

    return {
      getTransformProperty: getTransformProperty
    };
  }();

  function RepeaterModifier() {}

  extendPrototype([ShapeModifier], RepeaterModifier);

  RepeaterModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
    this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
    this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
    this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
    this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
    this.data = data;

    if (!this.dynamicProperties.length) {
      this.getValue(true);
    }

    this._isAnimated = !!this.dynamicProperties.length;
    this.pMatrix = new Matrix();
    this.rMatrix = new Matrix();
    this.sMatrix = new Matrix();
    this.tMatrix = new Matrix();
    this.matrix = new Matrix();
  };

  RepeaterModifier.prototype.applyTransforms = function (pMatrix, rMatrix, sMatrix, transform, perc, inv) {
    var dir = inv ? -1 : 1;
    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    rMatrix.rotate(-transform.r.v * dir * perc);
    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
  };

  RepeaterModifier.prototype.init = function (elem, arr, pos, elemsData) {
    this.elem = elem;
    this.arr = arr;
    this.pos = pos;
    this.elemsData = elemsData;
    this._currentCopies = 0;
    this._elements = [];
    this._groups = [];
    this.frameId = -1;
    this.initDynamicPropertyContainer(elem);
    this.initModifierProperties(elem, arr[pos]);

    while (pos > 0) {
      pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);

      this._elements.unshift(arr[pos]);
    }

    if (this.dynamicProperties.length) {
      this.k = true;
    } else {
      this.getValue(true);
    }
  };

  RepeaterModifier.prototype.resetElements = function (elements) {
    var i;
    var len = elements.length;

    for (i = 0; i < len; i += 1) {
      elements[i]._processed = false;

      if (elements[i].ty === 'gr') {
        this.resetElements(elements[i].it);
      }
    }
  };

  RepeaterModifier.prototype.cloneElements = function (elements) {
    var newElements = JSON.parse(JSON.stringify(elements));
    this.resetElements(newElements);
    return newElements;
  };

  RepeaterModifier.prototype.changeGroupRender = function (elements, renderFlag) {
    var i;
    var len = elements.length;

    for (i = 0; i < len; i += 1) {
      elements[i]._render = renderFlag;

      if (elements[i].ty === 'gr') {
        this.changeGroupRender(elements[i].it, renderFlag);
      }
    }
  };

  RepeaterModifier.prototype.processShapes = function (_isFirstFrame) {
    var items;
    var itemsTransform;
    var i;
    var dir;
    var cont;
    var hasReloaded = false;

    if (this._mdf || _isFirstFrame) {
      var copies = Math.ceil(this.c.v);

      if (this._groups.length < copies) {
        while (this._groups.length < copies) {
          var group = {
            it: this.cloneElements(this._elements),
            ty: 'gr'
          };
          group.it.push({
            a: {
              a: 0,
              ix: 1,
              k: [0, 0]
            },
            nm: 'Transform',
            o: {
              a: 0,
              ix: 7,
              k: 100
            },
            p: {
              a: 0,
              ix: 2,
              k: [0, 0]
            },
            r: {
              a: 1,
              ix: 6,
              k: [{
                s: 0,
                e: 0,
                t: 0
              }, {
                s: 0,
                e: 0,
                t: 1
              }]
            },
            s: {
              a: 0,
              ix: 3,
              k: [100, 100]
            },
            sa: {
              a: 0,
              ix: 5,
              k: 0
            },
            sk: {
              a: 0,
              ix: 4,
              k: 0
            },
            ty: 'tr'
          });
          this.arr.splice(0, 0, group);

          this._groups.splice(0, 0, group);

          this._currentCopies += 1;
        }

        this.elem.reloadShapes();
        hasReloaded = true;
      }

      cont = 0;
      var renderFlag;

      for (i = 0; i <= this._groups.length - 1; i += 1) {
        renderFlag = cont < copies;
        this._groups[i]._render = renderFlag;
        this.changeGroupRender(this._groups[i].it, renderFlag);

        if (!renderFlag) {
          var elems = this.elemsData[i].it;
          var transformData = elems[elems.length - 1];

          if (transformData.transform.op.v !== 0) {
            transformData.transform.op._mdf = true;
            transformData.transform.op.v = 0;
          } else {
            transformData.transform.op._mdf = false;
          }
        }

        cont += 1;
      }

      this._currentCopies = copies; /// /

      var offset = this.o.v;
      var offsetModulo = offset % 1;
      var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
      var pProps = this.pMatrix.props;
      var rProps = this.rMatrix.props;
      var sProps = this.sMatrix.props;
      this.pMatrix.reset();
      this.rMatrix.reset();
      this.sMatrix.reset();
      this.tMatrix.reset();
      this.matrix.reset();
      var iteration = 0;

      if (offset > 0) {
        while (iteration < roundOffset) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
          iteration += 1;
        }

        if (offsetModulo) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
          iteration += offsetModulo;
        }
      } else if (offset < 0) {
        while (iteration > roundOffset) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
          iteration -= 1;
        }

        if (offsetModulo) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
          iteration -= offsetModulo;
        }
      }

      i = this.data.m === 1 ? 0 : this._currentCopies - 1;
      dir = this.data.m === 1 ? 1 : -1;
      cont = this._currentCopies;
      var j;
      var jLen;

      while (cont) {
        items = this.elemsData[i].it;
        itemsTransform = items[items.length - 1].transform.mProps.v.props;
        jLen = itemsTransform.length;
        items[items.length - 1].transform.mProps._mdf = true;
        items[items.length - 1].transform.op._mdf = true;
        items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));

        if (iteration !== 0) {
          if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) {
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
          }

          this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
          this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
          this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);

          for (j = 0; j < jLen; j += 1) {
            itemsTransform[j] = this.matrix.props[j];
          }

          this.matrix.reset();
        } else {
          this.matrix.reset();

          for (j = 0; j < jLen; j += 1) {
            itemsTransform[j] = this.matrix.props[j];
          }
        }

        iteration += 1;
        cont -= 1;
        i += dir;
      }
    } else {
      cont = this._currentCopies;
      i = 0;
      dir = 1;

      while (cont) {
        items = this.elemsData[i].it;
        itemsTransform = items[items.length - 1].transform.mProps.v.props;
        items[items.length - 1].transform.mProps._mdf = false;
        items[items.length - 1].transform.op._mdf = false;
        cont -= 1;
        i += dir;
      }
    }

    return hasReloaded;
  };

  RepeaterModifier.prototype.addShape = function () {};

  function RoundCornersModifier() {}

  extendPrototype([ShapeModifier], RoundCornersModifier);

  RoundCornersModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
    this._isAnimated = !!this.rd.effectsSequence.length;
  };

  RoundCornersModifier.prototype.processPath = function (path, round) {
    var clonedPath = shapePool.newElement();
    clonedPath.c = path.c;
    var i;
    var len = path._length;
    var currentV;
    var currentI;
    var currentO;
    var closerV;
    var distance;
    var newPosPerc;
    var index = 0;
    var vX;
    var vY;
    var oX;
    var oY;
    var iX;
    var iY;

    for (i = 0; i < len; i += 1) {
      currentV = path.v[i];
      currentO = path.o[i];
      currentI = path.i[i];

      if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
        if ((i === 0 || i === len - 1) && !path.c) {
          clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
          /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */

          index += 1;
        } else {
          if (i === 0) {
            closerV = path.v[len - 1];
          } else {
            closerV = path.v[i - 1];
          }

          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
          iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
          vX = iX;
          iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
          vY = iY;
          oX = vX - (vX - currentV[0]) * roundCorner;
          oY = vY - (vY - currentV[1]) * roundCorner;
          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
          index += 1;

          if (i === len - 1) {
            closerV = path.v[0];
          } else {
            closerV = path.v[i + 1];
          }

          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
          oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
          vX = oX;
          oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
          vY = oY;
          iX = vX - (vX - currentV[0]) * roundCorner;
          iY = vY - (vY - currentV[1]) * roundCorner;
          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
          index += 1;
        }
      } else {
        clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
        index += 1;
      }
    }

    return clonedPath;
  };

  RoundCornersModifier.prototype.processShapes = function (_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var rd = this.rd.v;

    if (rd !== 0) {
      var shapeData;
      var localShapeCollection;

      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;

        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
          localShapeCollection.releaseShapes();
          shapeData.shape._mdf = true;
          shapePaths = shapeData.shape.paths.shapes;
          jLen = shapeData.shape.paths._length;

          for (j = 0; j < jLen; j += 1) {
            localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
          }
        }

        shapeData.shape.paths = shapeData.localShapeCollection;
      }
    }

    if (!this.dynamicProperties.length) {
      this._mdf = false;
    }
  };

  function floatEqual(a, b) {
    return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
  }

  function floatZero(f) {
    return Math.abs(f) <= 0.00001;
  }

  function lerp(p0, p1, amount) {
    return p0 * (1 - amount) + p1 * amount;
  }

  function lerpPoint(p0, p1, amount) {
    return [lerp(p0[0], p1[0], amount), lerp(p0[1], p1[1], amount)];
  }

  function quadRoots(a, b, c) {
    // no root
    if (a === 0) return [];
    var s = b * b - 4 * a * c; // Complex roots

    if (s < 0) return [];
    var singleRoot = -b / (2 * a); // 1 root

    if (s === 0) return [singleRoot];
    var delta = Math.sqrt(s) / (2 * a); // 2 roots

    return [singleRoot - delta, singleRoot + delta];
  }

  function polynomialCoefficients(p0, p1, p2, p3) {
    return [-p0 + 3 * p1 - 3 * p2 + p3, 3 * p0 - 6 * p1 + 3 * p2, -3 * p0 + 3 * p1, p0];
  }

  function singlePoint(p) {
    return new PolynomialBezier(p, p, p, p, false);
  }

  function PolynomialBezier(p0, p1, p2, p3, linearize) {
    if (linearize && pointEqual(p0, p1)) {
      p1 = lerpPoint(p0, p3, 1 / 3);
    }

    if (linearize && pointEqual(p2, p3)) {
      p2 = lerpPoint(p0, p3, 2 / 3);
    }

    var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
    var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
    this.a = [coeffx[0], coeffy[0]];
    this.b = [coeffx[1], coeffy[1]];
    this.c = [coeffx[2], coeffy[2]];
    this.d = [coeffx[3], coeffy[3]];
    this.points = [p0, p1, p2, p3];
  }

  PolynomialBezier.prototype.point = function (t) {
    return [((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0], ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]];
  };

  PolynomialBezier.prototype.derivative = function (t) {
    return [(3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0], (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]];
  };

  PolynomialBezier.prototype.tangentAngle = function (t) {
    var p = this.derivative(t);
    return Math.atan2(p[1], p[0]);
  };

  PolynomialBezier.prototype.normalAngle = function (t) {
    var p = this.derivative(t);
    return Math.atan2(p[0], p[1]);
  };

  PolynomialBezier.prototype.inflectionPoints = function () {
    var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
    if (floatZero(denom)) return [];
    var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
    var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
    if (square < 0) return [];
    var root = Math.sqrt(square);

    if (floatZero(root)) {
      if (root > 0 && root < 1) return [tcusp];
      return [];
    }

    return [tcusp - root, tcusp + root].filter(function (r) {
      return r > 0 && r < 1;
    });
  };

  PolynomialBezier.prototype.split = function (t) {
    if (t <= 0) return [singlePoint(this.points[0]), this];
    if (t >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
    var p10 = lerpPoint(this.points[0], this.points[1], t);
    var p11 = lerpPoint(this.points[1], this.points[2], t);
    var p12 = lerpPoint(this.points[2], this.points[3], t);
    var p20 = lerpPoint(p10, p11, t);
    var p21 = lerpPoint(p11, p12, t);
    var p3 = lerpPoint(p20, p21, t);
    return [new PolynomialBezier(this.points[0], p10, p20, p3, true), new PolynomialBezier(p3, p21, p12, this.points[3], true)];
  };

  function extrema(bez, comp) {
    var min = bez.points[0][comp];
    var max = bez.points[bez.points.length - 1][comp];

    if (min > max) {
      var e = max;
      max = min;
      min = e;
    } // Derivative roots to find min/max


    var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);

    for (var i = 0; i < f.length; i += 1) {
      if (f[i] > 0 && f[i] < 1) {
        var val = bez.point(f[i])[comp];
        if (val < min) min = val;else if (val > max) max = val;
      }
    }

    return {
      min: min,
      max: max
    };
  }

  PolynomialBezier.prototype.bounds = function () {
    return {
      x: extrema(this, 0),
      y: extrema(this, 1)
    };
  };

  PolynomialBezier.prototype.boundingBox = function () {
    var bounds = this.bounds();
    return {
      left: bounds.x.min,
      right: bounds.x.max,
      top: bounds.y.min,
      bottom: bounds.y.max,
      width: bounds.x.max - bounds.x.min,
      height: bounds.y.max - bounds.y.min,
      cx: (bounds.x.max + bounds.x.min) / 2,
      cy: (bounds.y.max + bounds.y.min) / 2
    };
  };

  function intersectData(bez, t1, t2) {
    var box = bez.boundingBox();
    return {
      cx: box.cx,
      cy: box.cy,
      width: box.width,
      height: box.height,
      bez: bez,
      t: (t1 + t2) / 2,
      t1: t1,
      t2: t2
    };
  }

  function splitData(data) {
    var split = data.bez.split(0.5);
    return [intersectData(split[0], data.t1, data.t), intersectData(split[1], data.t, data.t2)];
  }

  function boxIntersect(b1, b2) {
    return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
  }

  function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
    if (!boxIntersect(d1, d2)) return;

    if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
      intersections.push([d1.t, d2.t]);
      return;
    }

    var d1s = splitData(d1);
    var d2s = splitData(d2);
    intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
    intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
    intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
  }

  PolynomialBezier.prototype.intersections = function (other, tolerance, maxRecursion) {
    if (tolerance === undefined) tolerance = 2;
    if (maxRecursion === undefined) maxRecursion = 7;
    var intersections = [];
    intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
    return intersections;
  };

  PolynomialBezier.shapeSegment = function (shapePath, index) {
    var nextIndex = (index + 1) % shapePath.length();
    return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
  };

  PolynomialBezier.shapeSegmentInverted = function (shapePath, index) {
    var nextIndex = (index + 1) % shapePath.length();
    return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
  };

  function crossProduct(a, b) {
    return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
  }

  function lineIntersection(start1, end1, start2, end2) {
    var v1 = [start1[0], start1[1], 1];
    var v2 = [end1[0], end1[1], 1];
    var v3 = [start2[0], start2[1], 1];
    var v4 = [end2[0], end2[1], 1];
    var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
    if (floatZero(r[2])) return null;
    return [r[0] / r[2], r[1] / r[2]];
  }

  function polarOffset(p, angle, length) {
    return [p[0] + Math.cos(angle) * length, p[1] - Math.sin(angle) * length];
  }

  function pointDistance(p1, p2) {
    return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
  }

  function pointEqual(p1, p2) {
    return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
  }

  function ZigZagModifier() {}

  extendPrototype([ShapeModifier], ZigZagModifier);

  ZigZagModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
    this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
    this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
    this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
  };

  function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
    var angO = angle - Math.PI / 2;
    var angI = angle + Math.PI / 2;
    var px = point[0] + Math.cos(angle) * direction * amplitude;
    var py = point[1] - Math.sin(angle) * direction * amplitude;
    outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
  }

  function getPerpendicularVector(pt1, pt2) {
    var vector = [pt2[0] - pt1[0], pt2[1] - pt1[1]];
    var rot = -Math.PI * 0.5;
    var rotatedVector = [Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1], Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]];
    return rotatedVector;
  }

  function getProjectingAngle(path, cur) {
    var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
    var nextIndex = (cur + 1) % path.length();
    var prevPoint = path.v[prevIndex];
    var nextPoint = path.v[nextIndex];
    var pVector = getPerpendicularVector(prevPoint, nextPoint);
    return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
  }

  function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
    var angle = getProjectingAngle(path, cur);
    var point = path.v[cur % path._length];
    var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
    var nextPoint = path.v[(cur + 1) % path._length];
    var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
    var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
    setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
  }

  function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
    for (var i = 0; i < frequency; i += 1) {
      var t = (i + 1) / (frequency + 1);
      var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
      var angle = segment.normalAngle(t);
      var point = segment.point(t);
      setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
      direction = -direction;
    }

    return direction;
  }

  ZigZagModifier.prototype.processPath = function (path, amplitude, frequency, pointType) {
    var count = path._length;
    var clonedPath = shapePool.newElement();
    clonedPath.c = path.c;

    if (!path.c) {
      count -= 1;
    }

    if (count === 0) return clonedPath;
    var direction = -1;
    var segment = PolynomialBezier.shapeSegment(path, 0);
    zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);

    for (var i = 0; i < count; i += 1) {
      direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);

      if (i === count - 1 && !path.c) {
        segment = null;
      } else {
        segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
      }

      zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
    }

    return clonedPath;
  };

  ZigZagModifier.prototype.processShapes = function (_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var amplitude = this.amplitude.v;
    var frequency = Math.max(0, Math.round(this.frequency.v));
    var pointType = this.pointsType.v;

    if (amplitude !== 0) {
      var shapeData;
      var localShapeCollection;

      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;

        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
          localShapeCollection.releaseShapes();
          shapeData.shape._mdf = true;
          shapePaths = shapeData.shape.paths.shapes;
          jLen = shapeData.shape.paths._length;

          for (j = 0; j < jLen; j += 1) {
            localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
          }
        }

        shapeData.shape.paths = shapeData.localShapeCollection;
      }
    }

    if (!this.dynamicProperties.length) {
      this._mdf = false;
    }
  };

  function linearOffset(p1, p2, amount) {
    var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
    return [polarOffset(p1, angle, amount), polarOffset(p2, angle, amount)];
  }

  function offsetSegment(segment, amount) {
    var p0;
    var p1a;
    var p1b;
    var p2b;
    var p2a;
    var p3;
    var e;
    e = linearOffset(segment.points[0], segment.points[1], amount);
    p0 = e[0];
    p1a = e[1];
    e = linearOffset(segment.points[1], segment.points[2], amount);
    p1b = e[0];
    p2b = e[1];
    e = linearOffset(segment.points[2], segment.points[3], amount);
    p2a = e[0];
    p3 = e[1];
    var p1 = lineIntersection(p0, p1a, p1b, p2b);
    if (p1 === null) p1 = p1a;
    var p2 = lineIntersection(p2a, p3, p1b, p2b);
    if (p2 === null) p2 = p2a;
    return new PolynomialBezier(p0, p1, p2, p3);
  }

  function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
    var p0 = seg1.points[3];
    var p1 = seg2.points[0]; // Bevel

    if (lineJoin === 3) return p0; // Connected, they don't need a joint

    if (pointEqual(p0, p1)) return p0; // Round

    if (lineJoin === 2) {
      var angleOut = -seg1.tangentAngle(1);
      var angleIn = -seg2.tangentAngle(0) + Math.PI;
      var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
      var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
      var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
      outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
      tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
      outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
      return p1;
    } // Miter


    var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
    var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
    var intersection = lineIntersection(t0, p0, p1, t1);

    if (intersection && pointDistance(intersection, p0) < miterLimit) {
      outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
      return intersection;
    }

    return p0;
  }

  function getIntersection(a, b) {
    var intersect = a.intersections(b);
    if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
    if (intersect.length) return intersect[0];
    return null;
  }

  function pruneSegmentIntersection(a, b) {
    var outa = a.slice();
    var outb = b.slice();
    var intersect = getIntersection(a[a.length - 1], b[0]);

    if (intersect) {
      outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
      outb[0] = b[0].split(intersect[1])[1];
    }

    if (a.length > 1 && b.length > 1) {
      intersect = getIntersection(a[0], b[b.length - 1]);

      if (intersect) {
        return [[a[0].split(intersect[0])[0]], [b[b.length - 1].split(intersect[1])[1]]];
      }
    }

    return [outa, outb];
  }

  function pruneIntersections(segments) {
    var e;

    for (var i = 1; i < segments.length; i += 1) {
      e = pruneSegmentIntersection(segments[i - 1], segments[i]);
      segments[i - 1] = e[0];
      segments[i] = e[1];
    }

    if (segments.length > 1) {
      e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
      segments[segments.length - 1] = e[0];
      segments[0] = e[1];
    }

    return segments;
  }

  function offsetSegmentSplit(segment, amount) {
    /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
        (A cubic bezier can have none, one, or two inflection points)
    */
    var flex = segment.inflectionPoints();
    var left;
    var right;
    var split;
    var mid;

    if (flex.length === 0) {
      return [offsetSegment(segment, amount)];
    }

    if (flex.length === 1 || floatEqual(flex[1], 1)) {
      split = segment.split(flex[0]);
      left = split[0];
      right = split[1];
      return [offsetSegment(left, amount), offsetSegment(right, amount)];
    }

    split = segment.split(flex[0]);
    left = split[0];
    var t = (flex[1] - flex[0]) / (1 - flex[0]);
    split = split[1].split(t);
    mid = split[0];
    right = split[1];
    return [offsetSegment(left, amount), offsetSegment(mid, amount), offsetSegment(right, amount)];
  }

  function OffsetPathModifier() {}

  extendPrototype([ShapeModifier], OffsetPathModifier);

  OffsetPathModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
    this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
    this.lineJoin = data.lj;
    this._isAnimated = this.amount.effectsSequence.length !== 0;
  };

  OffsetPathModifier.prototype.processPath = function (inputBezier, amount, lineJoin, miterLimit) {
    var outputBezier = shapePool.newElement();
    outputBezier.c = inputBezier.c;
    var count = inputBezier.length();

    if (!inputBezier.c) {
      count -= 1;
    }

    var i;
    var j;
    var segment;
    var multiSegments = [];

    for (i = 0; i < count; i += 1) {
      segment = PolynomialBezier.shapeSegment(inputBezier, i);
      multiSegments.push(offsetSegmentSplit(segment, amount));
    }

    if (!inputBezier.c) {
      for (i = count - 1; i >= 0; i -= 1) {
        segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
        multiSegments.push(offsetSegmentSplit(segment, amount));
      }
    }

    multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints

    var lastPoint = null;
    var lastSeg = null;

    for (i = 0; i < multiSegments.length; i += 1) {
      var multiSegment = multiSegments[i];
      if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
      lastSeg = multiSegment[multiSegment.length - 1];

      for (j = 0; j < multiSegment.length; j += 1) {
        segment = multiSegment[j];

        if (lastPoint && pointEqual(segment.points[0], lastPoint)) {
          outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
        } else {
          outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
        }

        outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
        lastPoint = segment.points[3];
      }
    }

    if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
    return outputBezier;
  };

  OffsetPathModifier.prototype.processShapes = function (_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var amount = this.amount.v;
    var miterLimit = this.miterLimit.v;
    var lineJoin = this.lineJoin;

    if (amount !== 0) {
      var shapeData;
      var localShapeCollection;

      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;

        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
          localShapeCollection.releaseShapes();
          shapeData.shape._mdf = true;
          shapePaths = shapeData.shape.paths.shapes;
          jLen = shapeData.shape.paths._length;

          for (j = 0; j < jLen; j += 1) {
            localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
          }
        }

        shapeData.shape.paths = shapeData.localShapeCollection;
      }
    }

    if (!this.dynamicProperties.length) {
      this._mdf = false;
    }
  };

  function getFontProperties(fontData) {
    var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
    var fWeight = 'normal';
    var fStyle = 'normal';
    var len = styles.length;
    var styleName;

    for (var i = 0; i < len; i += 1) {
      styleName = styles[i].toLowerCase();

      switch (styleName) {
        case 'italic':
          fStyle = 'italic';
          break;

        case 'bold':
          fWeight = '700';
          break;

        case 'black':
          fWeight = '900';
          break;

        case 'medium':
          fWeight = '500';
          break;

        case 'regular':
        case 'normal':
          fWeight = '400';
          break;

        case 'light':
        case 'thin':
          fWeight = '200';
          break;

        default:
          break;
      }
    }

    return {
      style: fStyle,
      weight: fontData.fWeight || fWeight
    };
  }

  var FontManager = function () {
    var maxWaitingTime = 5000;
    var emptyChar = {
      w: 0,
      size: 0,
      shapes: [],
      data: {
        shapes: []
      }
    };
    var combinedCharacters = []; // Hindi characters

    combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
    var BLACK_FLAG_CODE_POINT = 127988;
    var CANCEL_TAG_CODE_POINT = 917631;
    var A_TAG_CODE_POINT = 917601;
    var Z_TAG_CODE_POINT = 917626;
    var VARIATION_SELECTOR_16_CODE_POINT = 65039;
    var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
    var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
    var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
    var surrogateModifiers = ['d83cdffb', 'd83cdffc', 'd83cdffd', 'd83cdffe', 'd83cdfff'];

    function trimFontOptions(font) {
      var familyArray = font.split(',');
      var i;
      var len = familyArray.length;
      var enabledFamilies = [];

      for (i = 0; i < len; i += 1) {
        if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') {
          enabledFamilies.push(familyArray[i]);
        }
      }

      return enabledFamilies.join(',');
    }

    function setUpNode(font, family) {
      var parentNode = createTag('span'); // Node is invisible to screen readers.

      parentNode.setAttribute('aria-hidden', true);
      parentNode.style.fontFamily = family;
      var node = createTag('span'); // Characters that vary significantly among different fonts

      node.innerText = 'giItT1WQy@!-/#'; // Visible - so we can measure it - but not on the screen

      parentNode.style.position = 'absolute';
      parentNode.style.left = '-10000px';
      parentNode.style.top = '-10000px'; // Large font size makes even subtle changes obvious

      parentNode.style.fontSize = '300px'; // Reset any font properties

      parentNode.style.fontVariant = 'normal';
      parentNode.style.fontStyle = 'normal';
      parentNode.style.fontWeight = 'normal';
      parentNode.style.letterSpacing = '0';
      parentNode.appendChild(node);
      document.body.appendChild(parentNode); // Remember width with no applied web font

      var width = node.offsetWidth;
      node.style.fontFamily = trimFontOptions(font) + ', ' + family;
      return {
        node: node,
        w: width,
        parent: parentNode
      };
    }

    function checkLoadedFonts() {
      var i;
      var len = this.fonts.length;
      var node;
      var w;
      var loadedCount = len;

      for (i = 0; i < len; i += 1) {
        if (this.fonts[i].loaded) {
          loadedCount -= 1;
        } else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) {
          this.fonts[i].loaded = true;
        } else {
          node = this.fonts[i].monoCase.node;
          w = this.fonts[i].monoCase.w;

          if (node.offsetWidth !== w) {
            loadedCount -= 1;
            this.fonts[i].loaded = true;
          } else {
            node = this.fonts[i].sansCase.node;
            w = this.fonts[i].sansCase.w;

            if (node.offsetWidth !== w) {
              loadedCount -= 1;
              this.fonts[i].loaded = true;
            }
          }

          if (this.fonts[i].loaded) {
            this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
            this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
          }
        }
      }

      if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) {
        setTimeout(this.checkLoadedFontsBinded, 20);
      } else {
        setTimeout(this.setIsLoadedBinded, 10);
      }
    }

    function createHelper(fontData, def) {
      var engine = document.body && def ? 'svg' : 'canvas';
      var helper;
      var fontProps = getFontProperties(fontData);

      if (engine === 'svg') {
        var tHelper = createNS('text');
        tHelper.style.fontSize = '100px'; // tHelper.style.fontFamily = fontData.fFamily;

        tHelper.setAttribute('font-family', fontData.fFamily);
        tHelper.setAttribute('font-style', fontProps.style);
        tHelper.setAttribute('font-weight', fontProps.weight);
        tHelper.textContent = '1';

        if (fontData.fClass) {
          tHelper.style.fontFamily = 'inherit';
          tHelper.setAttribute('class', fontData.fClass);
        } else {
          tHelper.style.fontFamily = fontData.fFamily;
        }

        def.appendChild(tHelper);
        helper = tHelper;
      } else {
        var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
        tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
        helper = tCanvasHelper;
      }

      function measure(text) {
        if (engine === 'svg') {
          helper.textContent = text;
          return helper.getComputedTextLength();
        }

        return helper.measureText(text).width;
      }

      return {
        measureText: measure
      };
    }

    function addFonts(fontData, defs) {
      if (!fontData) {
        this.isLoaded = true;
        return;
      }

      if (this.chars) {
        this.isLoaded = true;
        this.fonts = fontData.list;
        return;
      }

      if (!document.body) {
        this.isLoaded = true;
        fontData.list.forEach(function (data) {
          data.helper = createHelper(data);
          data.cache = {};
        });
        this.fonts = fontData.list;
        return;
      }

      var fontArr = fontData.list;
      var i;
      var len = fontArr.length;
      var _pendingFonts = len;

      for (i = 0; i < len; i += 1) {
        var shouldLoadFont = true;
        var loadedSelector;
        var j;
        fontArr[i].loaded = false;
        fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
        fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');

        if (!fontArr[i].fPath) {
          fontArr[i].loaded = true;
          _pendingFonts -= 1;
        } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
          loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');

          if (loadedSelector.length > 0) {
            shouldLoadFont = false;
          }

          if (shouldLoadFont) {
            var s = createTag('style');
            s.setAttribute('f-forigin', fontArr[i].fOrigin);
            s.setAttribute('f-origin', fontArr[i].origin);
            s.setAttribute('f-family', fontArr[i].fFamily);
            s.type = 'text/css';
            s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
            defs.appendChild(s);
          }
        } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
          loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');

          for (j = 0; j < loadedSelector.length; j += 1) {
            if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
              // Font is already loaded
              shouldLoadFont = false;
            }
          }

          if (shouldLoadFont) {
            var l = createTag('link');
            l.setAttribute('f-forigin', fontArr[i].fOrigin);
            l.setAttribute('f-origin', fontArr[i].origin);
            l.type = 'text/css';
            l.rel = 'stylesheet';
            l.href = fontArr[i].fPath;
            document.body.appendChild(l);
          }
        } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
          loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');

          for (j = 0; j < loadedSelector.length; j += 1) {
            if (fontArr[i].fPath === loadedSelector[j].src) {
              // Font is already loaded
              shouldLoadFont = false;
            }
          }

          if (shouldLoadFont) {
            var sc = createTag('link');
            sc.setAttribute('f-forigin', fontArr[i].fOrigin);
            sc.setAttribute('f-origin', fontArr[i].origin);
            sc.setAttribute('rel', 'stylesheet');
            sc.setAttribute('href', fontArr[i].fPath);
            defs.appendChild(sc);
          }
        }

        fontArr[i].helper = createHelper(fontArr[i], defs);
        fontArr[i].cache = {};
        this.fonts.push(fontArr[i]);
      }

      if (_pendingFonts === 0) {
        this.isLoaded = true;
      } else {
        // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
        // Adding this timeout seems to fix it
        setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
    }

    function addChars(chars) {
      if (!chars) {
        return;
      }

      if (!this.chars) {
        this.chars = [];
      }

      var i;
      var len = chars.length;
      var j;
      var jLen = this.chars.length;
      var found;

      for (i = 0; i < len; i += 1) {
        j = 0;
        found = false;

        while (j < jLen) {
          if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) {
            found = true;
          }

          j += 1;
        }

        if (!found) {
          this.chars.push(chars[i]);
          jLen += 1;
        }
      }
    }

    function getCharData(_char, style, font) {
      var i = 0;
      var len = this.chars.length;

      while (i < len) {
        if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) {
          return this.chars[i];
        }

        i += 1;
      }

      if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
      && !this._warned) {
        this._warned = true;
        console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
      }

      return emptyChar;
    }

    function measureText(_char2, fontName, size) {
      var fontData = this.getFontByName(fontName); // Using the char instead of char.charCodeAt(0)
      // to avoid collisions between equal chars

      var index = _char2;

      if (!fontData.cache[index]) {
        var tHelper = fontData.helper;

        if (_char2 === ' ') {
          var doubleSize = tHelper.measureText('|' + _char2 + '|');
          var singleSize = tHelper.measureText('||');
          fontData.cache[index] = (doubleSize - singleSize) / 100;
        } else {
          fontData.cache[index] = tHelper.measureText(_char2) / 100;
        }
      }

      return fontData.cache[index] * size;
    }

    function getFontByName(name) {
      var i = 0;
      var len = this.fonts.length;

      while (i < len) {
        if (this.fonts[i].fName === name) {
          return this.fonts[i];
        }

        i += 1;
      }

      return this.fonts[0];
    }

    function getCodePoint(string$$1) {
      var codePoint = 0;
      var first = string$$1.charCodeAt(0);

      if (first >= 0xD800 && first <= 0xDBFF) {
        var second = string$$1.charCodeAt(1);

        if (second >= 0xDC00 && second <= 0xDFFF) {
          codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
        }
      }

      return codePoint;
    } // Skin tone modifiers


    function isModifier(firstCharCode, secondCharCode) {
      var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
      return surrogateModifiers.indexOf(sum) !== -1;
    }

    function isZeroWidthJoiner(charCode) {
      return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
    } // This codepoint may change the appearance of the preceding character.
    // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
    // as a colorful image as compared to a monochrome text variant.


    function isVariationSelector(charCode) {
      return charCode === VARIATION_SELECTOR_16_CODE_POINT;
    } // The regional indicator symbols are a set of 26 alphabetic Unicode
    /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
    // two-letter country codes in a way that allows optional special treatment.


    function isRegionalCode(string$$1) {
      var codePoint = getCodePoint(string$$1);

      if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) {
        return true;
      }

      return false;
    } // Some Emoji implementations represent combinations of
    // two “regional indicator” letters as a single flag symbol.


    function isFlagEmoji(string$$1) {
      return isRegionalCode(string$$1.substr(0, 2)) && isRegionalCode(string$$1.substr(2, 2));
    }

    function isCombinedCharacter(_char3) {
      return combinedCharacters.indexOf(_char3) !== -1;
    } // Regional flags start with a BLACK_FLAG_CODE_POINT
    // folowed by 5 chars in the TAG range
    // and end with a CANCEL_TAG_CODE_POINT


    function isRegionalFlag(text, index) {
      var codePoint = getCodePoint(text.substr(index, 2));

      if (codePoint !== BLACK_FLAG_CODE_POINT) {
        return false;
      }

      var count = 0;
      index += 2;

      while (count < 5) {
        codePoint = getCodePoint(text.substr(index, 2));

        if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) {
          return false;
        }

        count += 1;
        index += 2;
      }

      return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
    }

    function setIsLoaded() {
      this.isLoaded = true;
    }

    var Font = function Font() {
      this.fonts = [];
      this.chars = null;
      this.typekitLoaded = 0;
      this.isLoaded = false;
      this._warned = false;
      this.initTime = Date.now();
      this.setIsLoadedBinded = this.setIsLoaded.bind(this);
      this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
    };

    Font.isModifier = isModifier;
    Font.isZeroWidthJoiner = isZeroWidthJoiner;
    Font.isFlagEmoji = isFlagEmoji;
    Font.isRegionalCode = isRegionalCode;
    Font.isCombinedCharacter = isCombinedCharacter;
    Font.isRegionalFlag = isRegionalFlag;
    Font.isVariationSelector = isVariationSelector;
    Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
    var fontPrototype = {
      addChars: addChars,
      addFonts: addFonts,
      getCharData: getCharData,
      getFontByName: getFontByName,
      measureText: measureText,
      checkLoadedFonts: checkLoadedFonts,
      setIsLoaded: setIsLoaded
    };
    Font.prototype = fontPrototype;
    return Font;
  }();

  function SlotManager(animationData) {
    this.animationData = animationData;
  }

  SlotManager.prototype.getProp = function (data) {
    if (this.animationData.slots && this.animationData.slots[data.sid]) {
      return Object.assign(data, this.animationData.slots[data.sid].p);
    }

    return data;
  };

  function slotFactory(animationData) {
    return new SlotManager(animationData);
  }

  function RenderableElement() {}

  RenderableElement.prototype = {
    initRenderable: function initRenderable() {
      // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
      this.isInRange = false; // layer's display state

      this.hidden = false; // If layer's transparency equals 0, it can be hidden

      this.isTransparent = false; // list of animated components

      this.renderableComponents = [];
    },
    addRenderableComponent: function addRenderableComponent(component) {
      if (this.renderableComponents.indexOf(component) === -1) {
        this.renderableComponents.push(component);
      }
    },
    removeRenderableComponent: function removeRenderableComponent(component) {
      if (this.renderableComponents.indexOf(component) !== -1) {
        this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
      }
    },
    prepareRenderableFrame: function prepareRenderableFrame(num) {
      this.checkLayerLimits(num);
    },
    checkTransparency: function checkTransparency() {
      if (this.finalTransform.mProp.o.v <= 0) {
        if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
          this.isTransparent = true;
          this.hide();
        }
      } else if (this.isTransparent) {
        this.isTransparent = false;
        this.show();
      }
    },

    /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */
    checkLayerLimits: function checkLayerLimits(num) {
      if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
        if (this.isInRange !== true) {
          this.globalData._mdf = true;
          this._mdf = true;
          this.isInRange = true;
          this.show();
        }
      } else if (this.isInRange !== false) {
        this.globalData._mdf = true;
        this.isInRange = false;
        this.hide();
      }
    },
    renderRenderable: function renderRenderable() {
      var i;
      var len = this.renderableComponents.length;

      for (i = 0; i < len; i += 1) {
        this.renderableComponents[i].renderFrame(this._isFirstFrame);
      }
      /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */

    },
    sourceRectAtTime: function sourceRectAtTime() {
      return {
        top: 0,
        left: 0,
        width: 100,
        height: 100
      };
    },
    getLayerSize: function getLayerSize() {
      if (this.data.ty === 5) {
        return {
          w: this.data.textData.width,
          h: this.data.textData.height
        };
      }

      return {
        w: this.data.width,
        h: this.data.height
      };
    }
  };

  var getBlendMode = function () {
    var blendModeEnums = {
      0: 'source-over',
      1: 'multiply',
      2: 'screen',
      3: 'overlay',
      4: 'darken',
      5: 'lighten',
      6: 'color-dodge',
      7: 'color-burn',
      8: 'hard-light',
      9: 'soft-light',
      10: 'difference',
      11: 'exclusion',
      12: 'hue',
      13: 'saturation',
      14: 'color',
      15: 'luminosity'
    };
    return function (mode) {
      return blendModeEnums[mode] || '';
    };
  }();

  function SliderEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function AngleEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function ColorEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
  }

  function PointEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
  }

  function LayerIndexEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function MaskIndexEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function CheckboxEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function NoValueEffect() {
    this.p = {};
  }

  function EffectsManager(data, element) {
    var effects = data.ef || [];
    this.effectElements = [];
    var i;
    var len = effects.length;
    var effectItem;

    for (i = 0; i < len; i += 1) {
      effectItem = new GroupEffect(effects[i], element);
      this.effectElements.push(effectItem);
    }
  }

  function GroupEffect(data, element) {
    this.init(data, element);
  }

  extendPrototype([DynamicPropertyContainer], GroupEffect);
  GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;

  GroupEffect.prototype.init = function (data, element) {
    this.data = data;
    this.effectElements = [];
    this.initDynamicPropertyContainer(element);
    var i;
    var len = this.data.ef.length;
    var eff;
    var effects = this.data.ef;

    for (i = 0; i < len; i += 1) {
      eff = null;

      switch (effects[i].ty) {
        case 0:
          eff = new SliderEffect(effects[i], element, this);
          break;

        case 1:
          eff = new AngleEffect(effects[i], element, this);
          break;

        case 2:
          eff = new ColorEffect(effects[i], element, this);
          break;

        case 3:
          eff = new PointEffect(effects[i], element, this);
          break;

        case 4:
        case 7:
          eff = new CheckboxEffect(effects[i], element, this);
          break;

        case 10:
          eff = new LayerIndexEffect(effects[i], element, this);
          break;

        case 11:
          eff = new MaskIndexEffect(effects[i], element, this);
          break;

        case 5:
          eff = new EffectsManager(effects[i], element, this);
          break;
        // case 6:

        default:
          eff = new NoValueEffect(effects[i], element, this);
          break;
      }

      if (eff) {
        this.effectElements.push(eff);
      }
    }
  };

  function BaseElement() {}

  BaseElement.prototype = {
    checkMasks: function checkMasks() {
      if (!this.data.hasMask) {
        return false;
      }

      var i = 0;
      var len = this.data.masksProperties.length;

      while (i < len) {
        if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) {
          return true;
        }

        i += 1;
      }

      return false;
    },
    initExpressions: function initExpressions() {
      var expressionsInterfaces = getExpressionInterfaces();

      if (!expressionsInterfaces) {
        return;
      }

      var LayerExpressionInterface = expressionsInterfaces('layer');
      var EffectsExpressionInterface = expressionsInterfaces('effects');
      var ShapeExpressionInterface = expressionsInterfaces('shape');
      var TextExpressionInterface = expressionsInterfaces('text');
      var CompExpressionInterface = expressionsInterfaces('comp');
      this.layerInterface = LayerExpressionInterface(this);

      if (this.data.hasMask && this.maskManager) {
        this.layerInterface.registerMaskInterface(this.maskManager);
      }

      var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
      this.layerInterface.registerEffectsInterface(effectsInterface);

      if (this.data.ty === 0 || this.data.xt) {
        this.compInterface = CompExpressionInterface(this);
      } else if (this.data.ty === 4) {
        this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
        this.layerInterface.content = this.layerInterface.shapeInterface;
      } else if (this.data.ty === 5) {
        this.layerInterface.textInterface = TextExpressionInterface(this);
        this.layerInterface.text = this.layerInterface.textInterface;
      }
    },
    setBlendMode: function setBlendMode() {
      var blendModeValue = getBlendMode(this.data.bm);
      var elem = this.baseElement || this.layerElement;
      elem.style['mix-blend-mode'] = blendModeValue;
    },
    initBaseData: function initBaseData(data, globalData, comp) {
      this.globalData = globalData;
      this.comp = comp;
      this.data = data;
      this.layerId = createElementID(); // Stretch factor for old animations missing this property.

      if (!this.data.sr) {
        this.data.sr = 1;
      } // effects manager


      this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
    },
    getType: function getType() {
      return this.type;
    },
    sourceRectAtTime: function sourceRectAtTime() {}
  };

  /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */
  function FrameElement() {}

  FrameElement.prototype = {
    /**
       * @function
       * Initializes frame related properties.
       *
       */
    initFrame: function initFrame() {
      // set to true when inpoint is rendered
      this._isFirstFrame = false; // list of animated properties

      this.dynamicProperties = []; // If layer has been modified in current tick this will be true

      this._mdf = false;
    },

    /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */
    prepareProperties: function prepareProperties(num, isVisible) {
      var i;
      var len = this.dynamicProperties.length;

      for (i = 0; i < len; i += 1) {
        if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
          this.dynamicProperties[i].getValue();

          if (this.dynamicProperties[i]._mdf) {
            this.globalData._mdf = true;
            this._mdf = true;
          }
        }
      }
    },
    addDynamicProperty: function addDynamicProperty(prop) {
      if (this.dynamicProperties.indexOf(prop) === -1) {
        this.dynamicProperties.push(prop);
      }
    }
  };

  function FootageElement(data, globalData, comp) {
    this.initFrame();
    this.initRenderable();
    this.assetData = globalData.getAssetData(data.refId);
    this.footageData = globalData.imageLoader.getAsset(this.assetData);
    this.initBaseData(data, globalData, comp);
  }

  FootageElement.prototype.prepareFrame = function () {};

  extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement);

  FootageElement.prototype.getBaseElement = function () {
    return null;
  };

  FootageElement.prototype.renderFrame = function () {};

  FootageElement.prototype.destroy = function () {};

  FootageElement.prototype.initExpressions = function () {
    var expressionsInterfaces = getExpressionInterfaces();

    if (!expressionsInterfaces) {
      return;
    }

    var FootageInterface = expressionsInterfaces('footage');
    this.layerInterface = FootageInterface(this);
  };

  FootageElement.prototype.getFootageData = function () {
    return this.footageData;
  };

  function AudioElement(data, globalData, comp) {
    this.initFrame();
    this.initRenderable();
    this.assetData = globalData.getAssetData(data.refId);
    this.initBaseData(data, globalData, comp);
    this._isPlaying = false;
    this._canPlay = false;
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    this.audio = this.globalData.audioController.createAudio(assetPath);
    this._currentTime = 0;
    this.globalData.audioController.addAudio(this);
    this._volumeMultiplier = 1;
    this._volume = 1;
    this._previousVolume = null;
    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
      _placeholder: true
    };
    this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
      k: [100]
    }, 1, 0.01, this);
  }

  AudioElement.prototype.prepareFrame = function (num) {
    this.prepareRenderableFrame(num, true);
    this.prepareProperties(num, true);

    if (!this.tm._placeholder) {
      var timeRemapped = this.tm.v;
      this._currentTime = timeRemapped;
    } else {
      this._currentTime = num / this.data.sr;
    }

    this._volume = this.lv.v[0];
    var totalVolume = this._volume * this._volumeMultiplier;

    if (this._previousVolume !== totalVolume) {
      this._previousVolume = totalVolume;
      this.audio.volume(totalVolume);
    }
  };

  extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement);

  AudioElement.prototype.renderFrame = function () {
    if (this.isInRange && this._canPlay) {
      if (!this._isPlaying) {
        this.audio.play();
        this.audio.seek(this._currentTime / this.globalData.frameRate);
        this._isPlaying = true;
      } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) {
        this.audio.seek(this._currentTime / this.globalData.frameRate);
      }
    }
  };

  AudioElement.prototype.show = function () {// this.audio.play()
  };

  AudioElement.prototype.hide = function () {
    this.audio.pause();
    this._isPlaying = false;
  };

  AudioElement.prototype.pause = function () {
    this.audio.pause();
    this._isPlaying = false;
    this._canPlay = false;
  };

  AudioElement.prototype.resume = function () {
    this._canPlay = true;
  };

  AudioElement.prototype.setRate = function (rateValue) {
    this.audio.rate(rateValue);
  };

  AudioElement.prototype.volume = function (volumeValue) {
    this._volumeMultiplier = volumeValue;
    this._previousVolume = volumeValue * this._volume;
    this.audio.volume(this._previousVolume);
  };

  AudioElement.prototype.getBaseElement = function () {
    return null;
  };

  AudioElement.prototype.destroy = function () {};

  AudioElement.prototype.sourceRectAtTime = function () {};

  AudioElement.prototype.initExpressions = function () {};

  function BaseRenderer() {}

  BaseRenderer.prototype.checkLayers = function (num) {
    var i;
    var len = this.layers.length;
    var data;
    this.completeLayers = true;

    for (i = len - 1; i >= 0; i -= 1) {
      if (!this.elements[i]) {
        data = this.layers[i];

        if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) {
          this.buildItem(i);
        }
      }

      this.completeLayers = this.elements[i] ? this.completeLayers : false;
    }

    this.checkPendingElements();
  };

  BaseRenderer.prototype.createItem = function (layer) {
    switch (layer.ty) {
      case 2:
        return this.createImage(layer);

      case 0:
        return this.createComp(layer);

      case 1:
        return this.createSolid(layer);

      case 3:
        return this.createNull(layer);

      case 4:
        return this.createShape(layer);

      case 5:
        return this.createText(layer);

      case 6:
        return this.createAudio(layer);

      case 13:
        return this.createCamera(layer);

      case 15:
        return this.createFootage(layer);

      default:
        return this.createNull(layer);
    }
  };

  BaseRenderer.prototype.createCamera = function () {
    throw new Error('You\'re using a 3d camera. Try the html renderer.');
  };

  BaseRenderer.prototype.createAudio = function (data) {
    return new AudioElement(data, this.globalData, this);
  };

  BaseRenderer.prototype.createFootage = function (data) {
    return new FootageElement(data, this.globalData, this);
  };

  BaseRenderer.prototype.buildAllItems = function () {
    var i;
    var len = this.layers.length;

    for (i = 0; i < len; i += 1) {
      this.buildItem(i);
    }

    this.checkPendingElements();
  };

  BaseRenderer.prototype.includeLayers = function (newLayers) {
    this.completeLayers = false;
    var i;
    var len = newLayers.length;
    var j;
    var jLen = this.layers.length;

    for (i = 0; i < len; i += 1) {
      j = 0;

      while (j < jLen) {
        if (this.layers[j].id === newLayers[i].id) {
          this.layers[j] = newLayers[i];
          break;
        }

        j += 1;
      }
    }
  };

  BaseRenderer.prototype.setProjectInterface = function (pInterface) {
    this.globalData.projectInterface = pInterface;
  };

  BaseRenderer.prototype.initItems = function () {
    if (!this.globalData.progressiveLoad) {
      this.buildAllItems();
    }
  };

  BaseRenderer.prototype.buildElementParenting = function (element, parentName, hierarchy) {
    var elements = this.elements;
    var layers = this.layers;
    var i = 0;
    var len = layers.length;

    while (i < len) {
      if (layers[i].ind == parentName) {
        // eslint-disable-line eqeqeq
        if (!elements[i] || elements[i] === true) {
          this.buildItem(i);
          this.addPendingElement(element);
        } else {
          hierarchy.push(elements[i]);
          elements[i].setAsParent();

          if (layers[i].parent !== undefined) {
            this.buildElementParenting(element, layers[i].parent, hierarchy);
          } else {
            element.setHierarchy(hierarchy);
          }
        }
      }

      i += 1;
    }
  };

  BaseRenderer.prototype.addPendingElement = function (element) {
    this.pendingElements.push(element);
  };

  BaseRenderer.prototype.searchExtraCompositions = function (assets) {
    var i;
    var len = assets.length;

    for (i = 0; i < len; i += 1) {
      if (assets[i].xt) {
        var comp = this.createComp(assets[i]);
        comp.initExpressions();
        this.globalData.projectInterface.registerComposition(comp);
      }
    }
  };

  BaseRenderer.prototype.getElementById = function (ind) {
    var i;
    var len = this.elements.length;

    for (i = 0; i < len; i += 1) {
      if (this.elements[i].data.ind === ind) {
        return this.elements[i];
      }
    }

    return null;
  };

  BaseRenderer.prototype.getElementByPath = function (path) {
    var pathValue = path.shift();
    var element;

    if (typeof pathValue === 'number') {
      element = this.elements[pathValue];
    } else {
      var i;
      var len = this.elements.length;

      for (i = 0; i < len; i += 1) {
        if (this.elements[i].data.nm === pathValue) {
          element = this.elements[i];
          break;
        }
      }
    }

    if (path.length === 0) {
      return element;
    }

    return element.getElementByPath(path);
  };

  BaseRenderer.prototype.setupGlobalData = function (animData, fontsContainer) {
    this.globalData.fontManager = new FontManager();
    this.globalData.slotManager = slotFactory(animData);
    this.globalData.fontManager.addChars(animData.chars);
    this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
    this.globalData.imageLoader = this.animationItem.imagePreloader;
    this.globalData.audioController = this.animationItem.audioController;
    this.globalData.frameId = 0;
    this.globalData.frameRate = animData.fr;
    this.globalData.nm = animData.nm;
    this.globalData.compSize = {
      w: animData.w,
      h: animData.h
    };
  };

  var effectTypes = {
    TRANSFORM_EFFECT: 'transformEFfect'
  };

  function TransformElement() {}

  TransformElement.prototype = {
    initTransform: function initTransform() {
      var mat = new Matrix();
      this.finalTransform = {
        mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
          o: 0
        },
        _matMdf: false,
        _localMatMdf: false,
        _opMdf: false,
        mat: mat,
        localMat: mat,
        localOpacity: 1
      };

      if (this.data.ao) {
        this.finalTransform.mProp.autoOriented = true;
      } // TODO: check TYPE 11: Guided elements


      if (this.data.ty !== 11) ;
    },
    renderTransform: function renderTransform() {
      this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
      this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;

      if (this.hierarchy) {
        var mat;
        var finalMat = this.finalTransform.mat;
        var i = 0;
        var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.

        if (!this.finalTransform._matMdf) {
          while (i < len) {
            if (this.hierarchy[i].finalTransform.mProp._mdf) {
              this.finalTransform._matMdf = true;
              break;
            }

            i += 1;
          }
        }

        if (this.finalTransform._matMdf) {
          mat = this.finalTransform.mProp.v.props;
          finalMat.cloneFromProps(mat);

          for (i = 0; i < len; i += 1) {
            finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
          }
        }
      }

      if (this.finalTransform._matMdf) {
        this.finalTransform._localMatMdf = this.finalTransform._matMdf;
      }

      if (this.finalTransform._opMdf) {
        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
      }
    },
    renderLocalTransform: function renderLocalTransform() {
      if (this.localTransforms) {
        var i = 0;
        var len = this.localTransforms.length;
        this.finalTransform._localMatMdf = this.finalTransform._matMdf;

        if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) {
          while (i < len) {
            if (this.localTransforms[i]._mdf) {
              this.finalTransform._localMatMdf = true;
            }

            if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
              this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
              this.finalTransform._opMdf = true;
            }

            i += 1;
          }
        }

        if (this.finalTransform._localMatMdf) {
          var localMat = this.finalTransform.localMat;
          this.localTransforms[0].matrix.clone(localMat);

          for (i = 1; i < len; i += 1) {
            var lmat = this.localTransforms[i].matrix;
            localMat.multiply(lmat);
          }

          localMat.multiply(this.finalTransform.mat);
        }

        if (this.finalTransform._opMdf) {
          var localOp = this.finalTransform.localOpacity;

          for (i = 0; i < len; i += 1) {
            localOp *= this.localTransforms[i].opacity * 0.01;
          }

          this.finalTransform.localOpacity = localOp;
        }
      }
    },
    searchEffectTransforms: function searchEffectTransforms() {
      if (this.renderableEffectsManager) {
        var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);

        if (transformEffects.length) {
          this.localTransforms = [];
          this.finalTransform.localMat = new Matrix();
          var i = 0;
          var len = transformEffects.length;

          for (i = 0; i < len; i += 1) {
            this.localTransforms.push(transformEffects[i]);
          }
        }
      }
    },
    globalToLocal: function globalToLocal(pt) {
      var transforms = [];
      transforms.push(this.finalTransform);
      var flag = true;
      var comp = this.comp;

      while (flag) {
        if (comp.finalTransform) {
          if (comp.data.hasMask) {
            transforms.splice(0, 0, comp.finalTransform);
          }

          comp = comp.comp;
        } else {
          flag = false;
        }
      }

      var i;
      var len = transforms.length;
      var ptNew;

      for (i = 0; i < len; i += 1) {
        ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);

        pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
      }

      return pt;
    },
    mHelper: new Matrix()
  };

  function MaskElement(data, element, globalData) {
    this.data = data;
    this.element = element;
    this.globalData = globalData;
    this.storedData = [];
    this.masksProperties = this.data.masksProperties || [];
    this.maskElement = null;
    var defs = this.globalData.defs;
    var i;
    var len = this.masksProperties ? this.masksProperties.length : 0;
    this.viewData = createSizedArray(len);
    this.solidPath = '';
    var path;
    var properties = this.masksProperties;
    var count = 0;
    var currentMasks = [];
    var j;
    var jLen;
    var layerId = createElementID();
    var rect;
    var expansor;
    var feMorph;
    var x;
    var maskType = 'clipPath';
    var maskRef = 'clip-path';

    for (i = 0; i < len; i += 1) {
      if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
        maskType = 'mask';
        maskRef = 'mask';
      }

      if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
        rect = createNS('rect');
        rect.setAttribute('fill', '#ffffff');
        rect.setAttribute('width', this.element.comp.data.w || 0);
        rect.setAttribute('height', this.element.comp.data.h || 0);
        currentMasks.push(rect);
      } else {
        rect = null;
      }

      path = createNS('path');

      if (properties[i].mode === 'n') {
        // TODO move this to a factory or to a constructor
        this.viewData[i] = {
          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
          elem: path,
          lastPath: ''
        };
        defs.appendChild(path);
      } else {
        count += 1;
        path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
        path.setAttribute('clip-rule', 'nonzero');
        var filterID;

        if (properties[i].x.k !== 0) {
          maskType = 'mask';
          maskRef = 'mask';
          x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
          filterID = createElementID();
          expansor = createNS('filter');
          expansor.setAttribute('id', filterID);
          feMorph = createNS('feMorphology');
          feMorph.setAttribute('operator', 'erode');
          feMorph.setAttribute('in', 'SourceGraphic');
          feMorph.setAttribute('radius', '0');
          expansor.appendChild(feMorph);
          defs.appendChild(expansor);
          path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
        } else {
          feMorph = null;
          x = null;
        } // TODO move this to a factory or to a constructor


        this.storedData[i] = {
          elem: path,
          x: x,
          expan: feMorph,
          lastPath: '',
          lastOperator: '',
          filterId: filterID,
          lastRadius: 0
        };

        if (properties[i].mode === 'i') {
          jLen = currentMasks.length;
          var g = createNS('g');

          for (j = 0; j < jLen; j += 1) {
            g.appendChild(currentMasks[j]);
          }

          var mask = createNS('mask');
          mask.setAttribute('mask-type', 'alpha');
          mask.setAttribute('id', layerId + '_' + count);
          mask.appendChild(path);
          defs.appendChild(mask);
          g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
          currentMasks.length = 0;
          currentMasks.push(g);
        } else {
          currentMasks.push(path);
        }

        if (properties[i].inv && !this.solidPath) {
          this.solidPath = this.createLayerSolidPath();
        } // TODO move this to a factory or to a constructor


        this.viewData[i] = {
          elem: path,
          lastPath: '',
          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
          invRect: rect
        };

        if (!this.viewData[i].prop.k) {
          this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
        }
      }
    }

    this.maskElement = createNS(maskType);
    len = currentMasks.length;

    for (i = 0; i < len; i += 1) {
      this.maskElement.appendChild(currentMasks[i]);
    }

    if (count > 0) {
      this.maskElement.setAttribute('id', layerId);
      this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
      defs.appendChild(this.maskElement);
    }

    if (this.viewData.length) {
      this.element.addRenderableComponent(this);
    }
  }

  MaskElement.prototype.getMaskProperty = function (pos) {
    return this.viewData[pos].prop;
  };

  MaskElement.prototype.renderFrame = function (isFirstFrame) {
    var finalMat = this.element.finalTransform.mat;
    var i;
    var len = this.masksProperties.length;

    for (i = 0; i < len; i += 1) {
      if (this.viewData[i].prop._mdf || isFirstFrame) {
        this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
      }

      if (this.viewData[i].op._mdf || isFirstFrame) {
        this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
      }

      if (this.masksProperties[i].mode !== 'n') {
        if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) {
          this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
        }

        if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
          var feMorph = this.storedData[i].expan;

          if (this.storedData[i].x.v < 0) {
            if (this.storedData[i].lastOperator !== 'erode') {
              this.storedData[i].lastOperator = 'erode';
              this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
            }

            feMorph.setAttribute('radius', -this.storedData[i].x.v);
          } else {
            if (this.storedData[i].lastOperator !== 'dilate') {
              this.storedData[i].lastOperator = 'dilate';
              this.storedData[i].elem.setAttribute('filter', null);
            }

            this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
          }
        }
      }
    }
  };

  MaskElement.prototype.getMaskelement = function () {
    return this.maskElement;
  };

  MaskElement.prototype.createLayerSolidPath = function () {
    var path = 'M0,0 ';
    path += ' h' + this.globalData.compSize.w;
    path += ' v' + this.globalData.compSize.h;
    path += ' h-' + this.globalData.compSize.w;
    path += ' v-' + this.globalData.compSize.h + ' ';
    return path;
  };

  MaskElement.prototype.drawPath = function (pathData, pathNodes, viewData) {
    var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
    var i;
    var len;
    len = pathNodes._length;

    for (i = 1; i < len; i += 1) {
      // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
    } // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];


    if (pathNodes.c && len > 1) {
      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
    } // pathNodes.__renderedString = pathString;


    if (viewData.lastPath !== pathString) {
      var pathShapeValue = '';

      if (viewData.elem) {
        if (pathNodes.c) {
          pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
        }

        viewData.elem.setAttribute('d', pathShapeValue);
      }

      viewData.lastPath = pathString;
    }
  };

  MaskElement.prototype.destroy = function () {
    this.element = null;
    this.globalData = null;
    this.maskElement = null;
    this.data = null;
    this.masksProperties = null;
  };

  var filtersFactory = function () {
    var ob = {};
    ob.createFilter = createFilter;
    ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;

    function createFilter(filId, skipCoordinates) {
      var fil = createNS('filter');
      fil.setAttribute('id', filId);

      if (skipCoordinates !== true) {
        fil.setAttribute('filterUnits', 'objectBoundingBox');
        fil.setAttribute('x', '0%');
        fil.setAttribute('y', '0%');
        fil.setAttribute('width', '100%');
        fil.setAttribute('height', '100%');
      }

      return fil;
    }

    function createAlphaToLuminanceFilter() {
      var feColorMatrix = createNS('feColorMatrix');
      feColorMatrix.setAttribute('type', 'matrix');
      feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
      feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
      return feColorMatrix;
    }

    return ob;
  }();

  var featureSupport = function () {
    var ob = {
      maskType: true,
      svgLumaHidden: true,
      offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
    };

    if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
      ob.maskType = false;
    }

    if (/firefox/i.test(navigator.userAgent)) {
      ob.svgLumaHidden = false;
    }

    return ob;
  }();

  var registeredEffects = {};
  var idPrefix = 'filter_result_';

  function SVGEffects(elem) {
    var i;
    var source = 'SourceGraphic';
    var len = elem.data.ef ? elem.data.ef.length : 0;
    var filId = createElementID();
    var fil = filtersFactory.createFilter(filId, true);
    var count = 0;
    this.filters = [];
    var filterManager;

    for (i = 0; i < len; i += 1) {
      filterManager = null;
      var type = elem.data.ef[i].ty;

      if (registeredEffects[type]) {
        var Effect = registeredEffects[type].effect;
        filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
        source = idPrefix + count;

        if (registeredEffects[type].countsAsEffect) {
          count += 1;
        }
      }

      if (filterManager) {
        this.filters.push(filterManager);
      }
    }

    if (count) {
      elem.globalData.defs.appendChild(fil);
      elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
    }

    if (this.filters.length) {
      elem.addRenderableComponent(this);
    }
  }

  SVGEffects.prototype.renderFrame = function (_isFirstFrame) {
    var i;
    var len = this.filters.length;

    for (i = 0; i < len; i += 1) {
      this.filters[i].renderFrame(_isFirstFrame);
    }
  };

  SVGEffects.prototype.getEffects = function (type) {
    var i;
    var len = this.filters.length;
    var effects = [];

    for (i = 0; i < len; i += 1) {
      if (this.filters[i].type === type) {
        effects.push(this.filters[i]);
      }
    }

    return effects;
  };

  function SVGBaseElement() {}

  SVGBaseElement.prototype = {
    initRendererElement: function initRendererElement() {
      this.layerElement = createNS('g');
    },
    createContainerElements: function createContainerElements() {
      this.matteElement = createNS('g');
      this.transformedElement = this.layerElement;
      this.maskedElement = this.layerElement;
      this._sizeChanged = false;
      var layerElementParent = null; // If this layer acts as a mask for the following layer

      if (this.data.td) {
        this.matteMasks = {};
        var gg = createNS('g');
        gg.setAttribute('id', this.layerId);
        gg.appendChild(this.layerElement);
        layerElementParent = gg;
        this.globalData.defs.appendChild(gg);
      } else if (this.data.tt) {
        this.matteElement.appendChild(this.layerElement);
        layerElementParent = this.matteElement;
        this.baseElement = this.matteElement;
      } else {
        this.baseElement = this.layerElement;
      }

      if (this.data.ln) {
        this.layerElement.setAttribute('id', this.data.ln);
      }

      if (this.data.cl) {
        this.layerElement.setAttribute('class', this.data.cl);
      } // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped


      if (this.data.ty === 0 && !this.data.hd) {
        var cp = createNS('clipPath');
        var pt = createNS('path');
        pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
        var clipId = createElementID();
        cp.setAttribute('id', clipId);
        cp.appendChild(pt);
        this.globalData.defs.appendChild(cp);

        if (this.checkMasks()) {
          var cpGroup = createNS('g');
          cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
          cpGroup.appendChild(this.layerElement);
          this.transformedElement = cpGroup;

          if (layerElementParent) {
            layerElementParent.appendChild(this.transformedElement);
          } else {
            this.baseElement = this.transformedElement;
          }
        } else {
          this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
        }
      }

      if (this.data.bm !== 0) {
        this.setBlendMode();
      }
    },
    renderElement: function renderElement() {
      if (this.finalTransform._localMatMdf) {
        this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
      }

      if (this.finalTransform._opMdf) {
        this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
      }
    },
    destroyBaseElement: function destroyBaseElement() {
      this.layerElement = null;
      this.matteElement = null;
      this.maskManager.destroy();
    },
    getBaseElement: function getBaseElement() {
      if (this.data.hd) {
        return null;
      }

      return this.baseElement;
    },
    createRenderableComponents: function createRenderableComponents() {
      this.maskManager = new MaskElement(this.data, this, this.globalData);
      this.renderableEffectsManager = new SVGEffects(this);
      this.searchEffectTransforms();
    },
    getMatte: function getMatte(matteType) {
      // This should not be a common case. But for backward compatibility, we'll create the matte object.
      // It solves animations that have two consecutive layers marked as matte masks.
      // Which is an undefined behavior in AE.
      if (!this.matteMasks) {
        this.matteMasks = {};
      }

      if (!this.matteMasks[matteType]) {
        var id = this.layerId + '_' + matteType;
        var filId;
        var fil;
        var useElement;
        var gg;

        if (matteType === 1 || matteType === 3) {
          var masker = createNS('mask');
          masker.setAttribute('id', id);
          masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
          useElement = createNS('use');
          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
          masker.appendChild(useElement);
          this.globalData.defs.appendChild(masker);

          if (!featureSupport.maskType && matteType === 1) {
            masker.setAttribute('mask-type', 'luminance');
            filId = createElementID();
            fil = filtersFactory.createFilter(filId);
            this.globalData.defs.appendChild(fil);
            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
            gg = createNS('g');
            gg.appendChild(useElement);
            masker.appendChild(gg);
            gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
          }
        } else if (matteType === 2) {
          var maskGroup = createNS('mask');
          maskGroup.setAttribute('id', id);
          maskGroup.setAttribute('mask-type', 'alpha');
          var maskGrouper = createNS('g');
          maskGroup.appendChild(maskGrouper);
          filId = createElementID();
          fil = filtersFactory.createFilter(filId); /// /

          var feCTr = createNS('feComponentTransfer');
          feCTr.setAttribute('in', 'SourceGraphic');
          fil.appendChild(feCTr);
          var feFunc = createNS('feFuncA');
          feFunc.setAttribute('type', 'table');
          feFunc.setAttribute('tableValues', '1.0 0.0');
          feCTr.appendChild(feFunc); /// /

          this.globalData.defs.appendChild(fil);
          var alphaRect = createNS('rect');
          alphaRect.setAttribute('width', this.comp.data.w);
          alphaRect.setAttribute('height', this.comp.data.h);
          alphaRect.setAttribute('x', '0');
          alphaRect.setAttribute('y', '0');
          alphaRect.setAttribute('fill', '#ffffff');
          alphaRect.setAttribute('opacity', '0');
          maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
          maskGrouper.appendChild(alphaRect);
          useElement = createNS('use');
          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
          maskGrouper.appendChild(useElement);

          if (!featureSupport.maskType) {
            maskGroup.setAttribute('mask-type', 'luminance');
            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
            gg = createNS('g');
            maskGrouper.appendChild(alphaRect);
            gg.appendChild(this.layerElement);
            maskGrouper.appendChild(gg);
          }

          this.globalData.defs.appendChild(maskGroup);
        }

        this.matteMasks[matteType] = id;
      }

      return this.matteMasks[matteType];
    },
    setMatte: function setMatte(id) {
      if (!this.matteElement) {
        return;
      }

      this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
    }
  };

  /**
   * @file
   * Handles AE's layer parenting property.
   *
   */
  function HierarchyElement() {}

  HierarchyElement.prototype = {
    /**
       * @function
       * Initializes hierarchy properties
       *
       */
    initHierarchy: function initHierarchy() {
      // element's parent list
      this.hierarchy = []; // if element is parent of another layer _isParent will be true

      this._isParent = false;
      this.checkParenting();
    },

    /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */
    setHierarchy: function setHierarchy(hierarchy) {
      this.hierarchy = hierarchy;
    },

    /**
       * @function
       * Sets layer as parent.
       *
       */
    setAsParent: function setAsParent() {
      this._isParent = true;
    },

    /**
       * @function
       * Searches layer's parenting chain
       *
       */
    checkParenting: function checkParenting() {
      if (this.data.parent !== undefined) {
        this.comp.buildElementParenting(this, this.data.parent, []);
      }
    }
  };

  function RenderableDOMElement() {}

  (function () {
    var _prototype = {
      initElement: function initElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
      },
      hide: function hide() {
        // console.log('HIDE', this);
        if (!this.hidden && (!this.isInRange || this.isTransparent)) {
          var elem = this.baseElement || this.layerElement;
          elem.style.display = 'none';
          this.hidden = true;
        }
      },
      show: function show() {
        // console.log('SHOW', this);
        if (this.isInRange && !this.isTransparent) {
          if (!this.data.hd) {
            var elem = this.baseElement || this.layerElement;
            elem.style.display = 'block';
          }

          this.hidden = false;
          this._isFirstFrame = true;
        }
      },
      renderFrame: function renderFrame() {
        // If it is exported as hidden (data.hd === true) no need to render
        // If it is not visible no need to render
        if (this.data.hd || this.hidden) {
          return;
        }

        this.renderTransform();
        this.renderRenderable();
        this.renderLocalTransform();
        this.renderElement();
        this.renderInnerContent();

        if (this._isFirstFrame) {
          this._isFirstFrame = false;
        }
      },
      renderInnerContent: function renderInnerContent() {},
      prepareFrame: function prepareFrame(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        this.checkTransparency();
      },
      destroy: function destroy() {
        this.innerElem = null;
        this.destroyBaseElement();
      }
    };
    extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
  })();

  function IImageElement(data, globalData, comp) {
    this.assetData = globalData.getAssetData(data.refId);

    if (this.assetData && this.assetData.sid) {
      this.assetData = globalData.slotManager.getProp(this.assetData);
    }

    this.initElement(data, globalData, comp);
    this.sourceRect = {
      top: 0,
      left: 0,
      width: this.assetData.w,
      height: this.assetData.h
    };
  }

  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement);

  IImageElement.prototype.createContent = function () {
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    this.innerElem = createNS('image');
    this.innerElem.setAttribute('width', this.assetData.w + 'px');
    this.innerElem.setAttribute('height', this.assetData.h + 'px');
    this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
    this.layerElement.appendChild(this.innerElem);
  };

  IImageElement.prototype.sourceRectAtTime = function () {
    return this.sourceRect;
  };

  function ProcessedElement(element, position) {
    this.elem = element;
    this.pos = position;
  }

  function IShapeElement() {}

  IShapeElement.prototype = {
    addShapeToModifiers: function addShapeToModifiers(data) {
      var i;
      var len = this.shapeModifiers.length;

      for (i = 0; i < len; i += 1) {
        this.shapeModifiers[i].addShape(data);
      }
    },
    isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
      var i = 0;
      var len = this.shapeModifiers.length;

      while (i < len) {
        if (this.shapeModifiers[i].isAnimatedWithShape(data)) {
          return true;
        }
      }

      return false;
    },
    renderModifiers: function renderModifiers() {
      if (!this.shapeModifiers.length) {
        return;
      }

      var i;
      var len = this.shapes.length;

      for (i = 0; i < len; i += 1) {
        this.shapes[i].sh.reset();
      }

      len = this.shapeModifiers.length;
      var shouldBreakProcess;

      for (i = len - 1; i >= 0; i -= 1) {
        shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
        // TODO: find a better solution for this

        if (shouldBreakProcess) {
          break;
        }
      }
    },
    searchProcessedElement: function searchProcessedElement(elem) {
      var elements = this.processedElements;
      var i = 0;
      var len = elements.length;

      while (i < len) {
        if (elements[i].elem === elem) {
          return elements[i].pos;
        }

        i += 1;
      }

      return 0;
    },
    addProcessedElement: function addProcessedElement(elem, pos) {
      var elements = this.processedElements;
      var i = elements.length;

      while (i) {
        i -= 1;

        if (elements[i].elem === elem) {
          elements[i].pos = pos;
          return;
        }
      }

      elements.push(new ProcessedElement(elem, pos));
    },
    prepareFrame: function prepareFrame(num) {
      this.prepareRenderableFrame(num);
      this.prepareProperties(num, this.isInRange);
    }
  };

  var lineCapEnum = {
    1: 'butt',
    2: 'round',
    3: 'square'
  };
  var lineJoinEnum = {
    1: 'miter',
    2: 'round',
    3: 'bevel'
  };

  function SVGShapeData(transformers, level, shape) {
    this.caches = [];
    this.styles = [];
    this.transformers = transformers;
    this.lStr = '';
    this.sh = shape;
    this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
    // For now, since shapes add up with other shapes. They have to be calculated every time.
    // One way of finding out is checking if all styles associated to this shape depend only of this shape

    this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated

    var i = 0;
    var len = transformers.length;

    while (i < len) {
      if (transformers[i].mProps.dynamicProperties.length) {
        this._isAnimated = true;
        break;
      }

      i += 1;
    }
  }

  SVGShapeData.prototype.setAsAnimated = function () {
    this._isAnimated = true;
  };

  function SVGStyleData(data, level) {
    this.data = data;
    this.type = data.ty;
    this.d = '';
    this.lvl = level;
    this._mdf = false;
    this.closed = data.hd === true;
    this.pElem = createNS('path');
    this.msElem = null;
  }

  SVGStyleData.prototype.reset = function () {
    this.d = '';
    this._mdf = false;
  };

  function DashProperty(elem, data, renderer, container) {
    this.elem = elem;
    this.frameId = -1;
    this.dataProps = createSizedArray(data.length);
    this.renderer = renderer;
    this.k = false;
    this.dashStr = '';
    this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
    this.dashoffset = createTypedArray('float32', 1);
    this.initDynamicPropertyContainer(container);
    var i;
    var len = data.length || 0;
    var prop;

    for (i = 0; i < len; i += 1) {
      prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
      this.k = prop.k || this.k;
      this.dataProps[i] = {
        n: data[i].n,
        p: prop
      };
    }

    if (!this.k) {
      this.getValue(true);
    }

    this._isAnimated = this.k;
  }

  DashProperty.prototype.getValue = function (forceRender) {
    if (this.elem.globalData.frameId === this.frameId && !forceRender) {
      return;
    }

    this.frameId = this.elem.globalData.frameId;
    this.iterateDynamicProperties();
    this._mdf = this._mdf || forceRender;

    if (this._mdf) {
      var i = 0;
      var len = this.dataProps.length;

      if (this.renderer === 'svg') {
        this.dashStr = '';
      }

      for (i = 0; i < len; i += 1) {
        if (this.dataProps[i].n !== 'o') {
          if (this.renderer === 'svg') {
            this.dashStr += ' ' + this.dataProps[i].p.v;
          } else {
            this.dashArray[i] = this.dataProps[i].p.v;
          }
        } else {
          this.dashoffset[0] = this.dataProps[i].p.v;
        }
      }
    }
  };

  extendPrototype([DynamicPropertyContainer], DashProperty);

  function SVGStrokeStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
    this.style = styleOb;
    this._isAnimated = !!this._isAnimated;
  }

  extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);

  function SVGFillStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
    this.style = styleOb;
  }

  extendPrototype([DynamicPropertyContainer], SVGFillStyleData);

  function SVGNoStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.style = styleOb;
  }

  extendPrototype([DynamicPropertyContainer], SVGNoStyleData);

  function GradientProperty(elem, data, container) {
    this.data = data;
    this.c = createTypedArray('uint8c', data.p * 4);
    var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
    this.o = createTypedArray('float32', cLength);
    this._cmdf = false;
    this._omdf = false;
    this._collapsable = this.checkCollapsable();
    this._hasOpacity = cLength;
    this.initDynamicPropertyContainer(container);
    this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
    this.k = this.prop.k;
    this.getValue(true);
  }

  GradientProperty.prototype.comparePoints = function (values, points) {
    var i = 0;
    var len = this.o.length / 2;
    var diff;

    while (i < len) {
      diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);

      if (diff > 0.01) {
        return false;
      }

      i += 1;
    }

    return true;
  };

  GradientProperty.prototype.checkCollapsable = function () {
    if (this.o.length / 2 !== this.c.length / 4) {
      return false;
    }

    if (this.data.k.k[0].s) {
      var i = 0;
      var len = this.data.k.k.length;

      while (i < len) {
        if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
          return false;
        }

        i += 1;
      }
    } else if (!this.comparePoints(this.data.k.k, this.data.p)) {
      return false;
    }

    return true;
  };

  GradientProperty.prototype.getValue = function (forceRender) {
    this.prop.getValue();
    this._mdf = false;
    this._cmdf = false;
    this._omdf = false;

    if (this.prop._mdf || forceRender) {
      var i;
      var len = this.data.p * 4;
      var mult;
      var val;

      for (i = 0; i < len; i += 1) {
        mult = i % 4 === 0 ? 100 : 255;
        val = Math.round(this.prop.v[i] * mult);

        if (this.c[i] !== val) {
          this.c[i] = val;
          this._cmdf = !forceRender;
        }
      }

      if (this.o.length) {
        len = this.prop.v.length;

        for (i = this.data.p * 4; i < len; i += 1) {
          mult = i % 2 === 0 ? 100 : 1;
          val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];

          if (this.o[i - this.data.p * 4] !== val) {
            this.o[i - this.data.p * 4] = val;
            this._omdf = !forceRender;
          }
        }
      }

      this._mdf = !forceRender;
    }
  };

  extendPrototype([DynamicPropertyContainer], GradientProperty);

  function SVGGradientFillStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.initGradientData(elem, data, styleOb);
  }

  SVGGradientFillStyleData.prototype.initGradientData = function (elem, data, styleOb) {
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
    this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
    this.h = PropertyFactory.getProp(elem, data.h || {
      k: 0
    }, 0, 0.01, this);
    this.a = PropertyFactory.getProp(elem, data.a || {
      k: 0
    }, 0, degToRads, this);
    this.g = new GradientProperty(elem, data.g, this);
    this.style = styleOb;
    this.stops = [];
    this.setGradientData(styleOb.pElem, data);
    this.setGradientOpacity(data, styleOb);
    this._isAnimated = !!this._isAnimated;
  };

  SVGGradientFillStyleData.prototype.setGradientData = function (pathElement, data) {
    var gradientId = createElementID();
    var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
    gfill.setAttribute('id', gradientId);
    gfill.setAttribute('spreadMethod', 'pad');
    gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
    var stops = [];
    var stop;
    var j;
    var jLen;
    jLen = data.g.p * 4;

    for (j = 0; j < jLen; j += 4) {
      stop = createNS('stop');
      gfill.appendChild(stop);
      stops.push(stop);
    }

    pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
    this.gf = gfill;
    this.cst = stops;
  };

  SVGGradientFillStyleData.prototype.setGradientOpacity = function (data, styleOb) {
    if (this.g._hasOpacity && !this.g._collapsable) {
      var stop;
      var j;
      var jLen;
      var mask = createNS('mask');
      var maskElement = createNS('path');
      mask.appendChild(maskElement);
      var opacityId = createElementID();
      var maskId = createElementID();
      mask.setAttribute('id', maskId);
      var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
      opFill.setAttribute('id', opacityId);
      opFill.setAttribute('spreadMethod', 'pad');
      opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
      jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
      var stops = this.stops;

      for (j = data.g.p * 4; j < jLen; j += 2) {
        stop = createNS('stop');
        stop.setAttribute('stop-color', 'rgb(255,255,255)');
        opFill.appendChild(stop);
        stops.push(stop);
      }

      maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');

      if (data.ty === 'gs') {
        maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
        maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);

        if (data.lj === 1) {
          maskElement.setAttribute('stroke-miterlimit', data.ml);
        }
      }

      this.of = opFill;
      this.ms = mask;
      this.ost = stops;
      this.maskId = maskId;
      styleOb.msElem = maskElement;
    }
  };

  extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);

  function SVGGradientStrokeStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
    this.initGradientData(elem, data, styleOb);
    this._isAnimated = !!this._isAnimated;
  }

  extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);

  function ShapeGroupData() {
    this.it = [];
    this.prevViewData = [];
    this.gr = createNS('g');
  }

  function SVGTransformData(mProps, op, container) {
    this.transform = {
      mProps: mProps,
      op: op,
      container: container
    };
    this.elements = [];
    this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
  }

  var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
    if (length === 0) {
      return '';
    }

    var _o = pathNodes.o;
    var _i = pathNodes.i;
    var _v = pathNodes.v;
    var i;
    var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);

    for (i = 1; i < length; i += 1) {
      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
    }

    if (closed && length) {
      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
      shapeString += 'z';
    }

    return shapeString;
  };

  var SVGElementsRenderer = function () {
    var _identityMatrix = new Matrix();

    var _matrixHelper = new Matrix();

    var ob = {
      createRenderFunction: createRenderFunction
    };

    function createRenderFunction(data) {
      switch (data.ty) {
        case 'fl':
          return renderFill;

        case 'gf':
          return renderGradient;

        case 'gs':
          return renderGradientStroke;

        case 'st':
          return renderStroke;

        case 'sh':
        case 'el':
        case 'rc':
        case 'sr':
          return renderPath;

        case 'tr':
          return renderContentTransform;

        case 'no':
          return renderNoop;

        default:
          return null;
      }
    }

    function renderContentTransform(styleData, itemData, isFirstFrame) {
      if (isFirstFrame || itemData.transform.op._mdf) {
        itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
      }

      if (isFirstFrame || itemData.transform.mProps._mdf) {
        itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
      }
    }

    function renderNoop() {}

    function renderPath(styleData, itemData, isFirstFrame) {
      var j;
      var jLen;
      var pathStringTransformed;
      var redraw;
      var pathNodes;
      var l;
      var lLen = itemData.styles.length;
      var lvl = itemData.lvl;
      var paths;
      var mat;
      var iterations;
      var k;

      for (l = 0; l < lLen; l += 1) {
        redraw = itemData.sh._mdf || isFirstFrame;

        if (itemData.styles[l].lvl < lvl) {
          mat = _matrixHelper.reset();
          iterations = lvl - itemData.styles[l].lvl;
          k = itemData.transformers.length - 1;

          while (!redraw && iterations > 0) {
            redraw = itemData.transformers[k].mProps._mdf || redraw;
            iterations -= 1;
            k -= 1;
          }

          if (redraw) {
            iterations = lvl - itemData.styles[l].lvl;
            k = itemData.transformers.length - 1;

            while (iterations > 0) {
              mat.multiply(itemData.transformers[k].mProps.v);
              iterations -= 1;
              k -= 1;
            }
          }
        } else {
          mat = _identityMatrix;
        }

        paths = itemData.sh.paths;
        jLen = paths._length;

        if (redraw) {
          pathStringTransformed = '';

          for (j = 0; j < jLen; j += 1) {
            pathNodes = paths.shapes[j];

            if (pathNodes && pathNodes._length) {
              pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
            }
          }

          itemData.caches[l] = pathStringTransformed;
        } else {
          pathStringTransformed = itemData.caches[l];
        }

        itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
        itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
      }
    }

    function renderFill(styleData, itemData, isFirstFrame) {
      var styleElem = itemData.style;

      if (itemData.c._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
      }

      if (itemData.o._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
      }
    }

    function renderGradientStroke(styleData, itemData, isFirstFrame) {
      renderGradient(styleData, itemData, isFirstFrame);
      renderStroke(styleData, itemData, isFirstFrame);
    }

    function renderGradient(styleData, itemData, isFirstFrame) {
      var gfill = itemData.gf;
      var hasOpacity = itemData.g._hasOpacity;
      var pt1 = itemData.s.v;
      var pt2 = itemData.e.v;

      if (itemData.o._mdf || isFirstFrame) {
        var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
        itemData.style.pElem.setAttribute(attr, itemData.o.v);
      }

      if (itemData.s._mdf || isFirstFrame) {
        var attr1 = styleData.t === 1 ? 'x1' : 'cx';
        var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
        gfill.setAttribute(attr1, pt1[0]);
        gfill.setAttribute(attr2, pt1[1]);

        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute(attr1, pt1[0]);
          itemData.of.setAttribute(attr2, pt1[1]);
        }
      }

      var stops;
      var i;
      var len;
      var stop;

      if (itemData.g._cmdf || isFirstFrame) {
        stops = itemData.cst;
        var cValues = itemData.g.c;
        len = stops.length;

        for (i = 0; i < len; i += 1) {
          stop = stops[i];
          stop.setAttribute('offset', cValues[i * 4] + '%');
          stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
        }
      }

      if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
        var oValues = itemData.g.o;

        if (itemData.g._collapsable) {
          stops = itemData.cst;
        } else {
          stops = itemData.ost;
        }

        len = stops.length;

        for (i = 0; i < len; i += 1) {
          stop = stops[i];

          if (!itemData.g._collapsable) {
            stop.setAttribute('offset', oValues[i * 2] + '%');
          }

          stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
        }
      }

      if (styleData.t === 1) {
        if (itemData.e._mdf || isFirstFrame) {
          gfill.setAttribute('x2', pt2[0]);
          gfill.setAttribute('y2', pt2[1]);

          if (hasOpacity && !itemData.g._collapsable) {
            itemData.of.setAttribute('x2', pt2[0]);
            itemData.of.setAttribute('y2', pt2[1]);
          }
        }
      } else {
        var rad;

        if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
          rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
          gfill.setAttribute('r', rad);

          if (hasOpacity && !itemData.g._collapsable) {
            itemData.of.setAttribute('r', rad);
          }
        }

        if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
          if (!rad) {
            rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
          }

          var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
          var percent = itemData.h.v;

          if (percent >= 1) {
            percent = 0.99;
          } else if (percent <= -1) {
            percent = -0.99;
          }

          var dist = rad * percent;
          var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
          var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
          gfill.setAttribute('fx', x);
          gfill.setAttribute('fy', y);

          if (hasOpacity && !itemData.g._collapsable) {
            itemData.of.setAttribute('fx', x);
            itemData.of.setAttribute('fy', y);
          }
        } // gfill.setAttribute('fy','200');

      }
    }

    function renderStroke(styleData, itemData, isFirstFrame) {
      var styleElem = itemData.style;
      var d = itemData.d;

      if (d && (d._mdf || isFirstFrame) && d.dashStr) {
        styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
      }

      if (itemData.c && (itemData.c._mdf || isFirstFrame)) {
        styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
      }

      if (itemData.o._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
      }

      if (itemData.w._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('stroke-width', itemData.w.v);

        if (styleElem.msElem) {
          styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
        }
      }
    }

    return ob;
  }();

  function SVGShapeElement(data, globalData, comp) {
    // List of drawable elements
    this.shapes = []; // Full shape data

    this.shapesData = data.shapes; // List of styles that will be applied to shapes

    this.stylesList = []; // List of modifiers that will be applied to shapes

    this.shapeModifiers = []; // List of items in shape tree

    this.itemsData = []; // List of items in previous shape tree

    this.processedElements = []; // List of animated components

    this.animatedContents = [];
    this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    // List of elements that have been created

    this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
  }

  extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement);

  SVGShapeElement.prototype.initSecondaryElement = function () {};

  SVGShapeElement.prototype.identityMatrix = new Matrix();

  SVGShapeElement.prototype.buildExpressionInterface = function () {};

  SVGShapeElement.prototype.createContent = function () {
    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
    this.filterUniqueShapes();
  };
  /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */


  SVGShapeElement.prototype.filterUniqueShapes = function () {
    var i;
    var len = this.shapes.length;
    var shape;
    var j;
    var jLen = this.stylesList.length;
    var style;
    var tempShapes = [];
    var areAnimated = false;

    for (j = 0; j < jLen; j += 1) {
      style = this.stylesList[j];
      areAnimated = false;
      tempShapes.length = 0;

      for (i = 0; i < len; i += 1) {
        shape = this.shapes[i];

        if (shape.styles.indexOf(style) !== -1) {
          tempShapes.push(shape);
          areAnimated = shape._isAnimated || areAnimated;
        }
      }

      if (tempShapes.length > 1 && areAnimated) {
        this.setShapesAsAnimated(tempShapes);
      }
    }
  };

  SVGShapeElement.prototype.setShapesAsAnimated = function (shapes) {
    var i;
    var len = shapes.length;

    for (i = 0; i < len; i += 1) {
      shapes[i].setAsAnimated();
    }
  };

  SVGShapeElement.prototype.createStyleElement = function (data, level) {
    // TODO: prevent drawing of hidden styles
    var elementData;
    var styleOb = new SVGStyleData(data, level);
    var pathElement = styleOb.pElem;

    if (data.ty === 'st') {
      elementData = new SVGStrokeStyleData(this, data, styleOb);
    } else if (data.ty === 'fl') {
      elementData = new SVGFillStyleData(this, data, styleOb);
    } else if (data.ty === 'gf' || data.ty === 'gs') {
      var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
      elementData = new GradientConstructor(this, data, styleOb);
      this.globalData.defs.appendChild(elementData.gf);

      if (elementData.maskId) {
        this.globalData.defs.appendChild(elementData.ms);
        this.globalData.defs.appendChild(elementData.of);
        pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
      }
    } else if (data.ty === 'no') {
      elementData = new SVGNoStyleData(this, data, styleOb);
    }

    if (data.ty === 'st' || data.ty === 'gs') {
      pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
      pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
      pathElement.setAttribute('fill-opacity', '0');

      if (data.lj === 1) {
        pathElement.setAttribute('stroke-miterlimit', data.ml);
      }
    }

    if (data.r === 2) {
      pathElement.setAttribute('fill-rule', 'evenodd');
    }

    if (data.ln) {
      pathElement.setAttribute('id', data.ln);
    }

    if (data.cl) {
      pathElement.setAttribute('class', data.cl);
    }

    if (data.bm) {
      pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
    }

    this.stylesList.push(styleOb);
    this.addToAnimatedContents(data, elementData);
    return elementData;
  };

  SVGShapeElement.prototype.createGroupElement = function (data) {
    var elementData = new ShapeGroupData();

    if (data.ln) {
      elementData.gr.setAttribute('id', data.ln);
    }

    if (data.cl) {
      elementData.gr.setAttribute('class', data.cl);
    }

    if (data.bm) {
      elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
    }

    return elementData;
  };

  SVGShapeElement.prototype.createTransformElement = function (data, container) {
    var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
    var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
    this.addToAnimatedContents(data, elementData);
    return elementData;
  };

  SVGShapeElement.prototype.createShapeElement = function (data, ownTransformers, level) {
    var ty = 4;

    if (data.ty === 'rc') {
      ty = 5;
    } else if (data.ty === 'el') {
      ty = 6;
    } else if (data.ty === 'sr') {
      ty = 7;
    }

    var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
    var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
    this.shapes.push(elementData);
    this.addShapeToModifiers(elementData);
    this.addToAnimatedContents(data, elementData);
    return elementData;
  };

  SVGShapeElement.prototype.addToAnimatedContents = function (data, element) {
    var i = 0;
    var len = this.animatedContents.length;

    while (i < len) {
      if (this.animatedContents[i].element === element) {
        return;
      }

      i += 1;
    }

    this.animatedContents.push({
      fn: SVGElementsRenderer.createRenderFunction(data),
      element: element,
      data: data
    });
  };

  SVGShapeElement.prototype.setElementStyles = function (elementData) {
    var arr = elementData.styles;
    var j;
    var jLen = this.stylesList.length;

    for (j = 0; j < jLen; j += 1) {
      if (!this.stylesList[j].closed) {
        arr.push(this.stylesList[j]);
      }
    }
  };

  SVGShapeElement.prototype.reloadShapes = function () {
    this._isFirstFrame = true;
    var i;
    var len = this.itemsData.length;

    for (i = 0; i < len; i += 1) {
      this.prevViewData[i] = this.itemsData[i];
    }

    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
    this.filterUniqueShapes();
    len = this.dynamicProperties.length;

    for (i = 0; i < len; i += 1) {
      this.dynamicProperties[i].getValue();
    }

    this.renderModifiers();
  };

  SVGShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, container, level, transformers, render) {
    var ownTransformers = [].concat(transformers);
    var i;
    var len = arr.length - 1;
    var j;
    var jLen;
    var ownStyles = [];
    var ownModifiers = [];
    var currentTransform;
    var modifier;
    var processedPos;

    for (i = len; i >= 0; i -= 1) {
      processedPos = this.searchProcessedElement(arr[i]);

      if (!processedPos) {
        arr[i]._render = render;
      } else {
        itemsData[i] = prevViewData[processedPos - 1];
      }

      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
        if (!processedPos) {
          itemsData[i] = this.createStyleElement(arr[i], level);
        } else {
          itemsData[i].style.closed = false;
        }

        if (arr[i]._render) {
          if (itemsData[i].style.pElem.parentNode !== container) {
            container.appendChild(itemsData[i].style.pElem);
          }
        }

        ownStyles.push(itemsData[i].style);
      } else if (arr[i].ty === 'gr') {
        if (!processedPos) {
          itemsData[i] = this.createGroupElement(arr[i]);
        } else {
          jLen = itemsData[i].it.length;

          for (j = 0; j < jLen; j += 1) {
            itemsData[i].prevViewData[j] = itemsData[i].it[j];
          }
        }

        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);

        if (arr[i]._render) {
          if (itemsData[i].gr.parentNode !== container) {
            container.appendChild(itemsData[i].gr);
          }
        }
      } else if (arr[i].ty === 'tr') {
        if (!processedPos) {
          itemsData[i] = this.createTransformElement(arr[i], container);
        }

        currentTransform = itemsData[i].transform;
        ownTransformers.push(currentTransform);
      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
        if (!processedPos) {
          itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
        }

        this.setElementStyles(itemsData[i]);
      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
        if (!processedPos) {
          modifier = ShapeModifiers.getModifier(arr[i].ty);
          modifier.init(this, arr[i]);
          itemsData[i] = modifier;
          this.shapeModifiers.push(modifier);
        } else {
          modifier = itemsData[i];
          modifier.closed = false;
        }

        ownModifiers.push(modifier);
      } else if (arr[i].ty === 'rp') {
        if (!processedPos) {
          modifier = ShapeModifiers.getModifier(arr[i].ty);
          itemsData[i] = modifier;
          modifier.init(this, arr, i, itemsData);
          this.shapeModifiers.push(modifier);
          render = false;
        } else {
          modifier = itemsData[i];
          modifier.closed = true;
        }

        ownModifiers.push(modifier);
      }

      this.addProcessedElement(arr[i], i + 1);
    }

    len = ownStyles.length;

    for (i = 0; i < len; i += 1) {
      ownStyles[i].closed = true;
    }

    len = ownModifiers.length;

    for (i = 0; i < len; i += 1) {
      ownModifiers[i].closed = true;
    }
  };

  SVGShapeElement.prototype.renderInnerContent = function () {
    this.renderModifiers();
    var i;
    var len = this.stylesList.length;

    for (i = 0; i < len; i += 1) {
      this.stylesList[i].reset();
    }

    this.renderShape();

    for (i = 0; i < len; i += 1) {
      if (this.stylesList[i]._mdf || this._isFirstFrame) {
        if (this.stylesList[i].msElem) {
          this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers

          this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
        }

        this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
      }
    }
  };

  SVGShapeElement.prototype.renderShape = function () {
    var i;
    var len = this.animatedContents.length;
    var animatedContent;

    for (i = 0; i < len; i += 1) {
      animatedContent = this.animatedContents[i];

      if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
        animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
      }
    }
  };

  SVGShapeElement.prototype.destroy = function () {
    this.destroyBaseElement();
    this.shapesData = null;
    this.itemsData = null;
  };

  function LetterProps(o, sw, sc, fc, m, p) {
    this.o = o;
    this.sw = sw;
    this.sc = sc;
    this.fc = fc;
    this.m = m;
    this.p = p;
    this._mdf = {
      o: true,
      sw: !!sw,
      sc: !!sc,
      fc: !!fc,
      m: true,
      p: true
    };
  }

  LetterProps.prototype.update = function (o, sw, sc, fc, m, p) {
    this._mdf.o = false;
    this._mdf.sw = false;
    this._mdf.sc = false;
    this._mdf.fc = false;
    this._mdf.m = false;
    this._mdf.p = false;
    var updated = false;

    if (this.o !== o) {
      this.o = o;
      this._mdf.o = true;
      updated = true;
    }

    if (this.sw !== sw) {
      this.sw = sw;
      this._mdf.sw = true;
      updated = true;
    }

    if (this.sc !== sc) {
      this.sc = sc;
      this._mdf.sc = true;
      updated = true;
    }

    if (this.fc !== fc) {
      this.fc = fc;
      this._mdf.fc = true;
      updated = true;
    }

    if (this.m !== m) {
      this.m = m;
      this._mdf.m = true;
      updated = true;
    }

    if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
      this.p = p;
      this._mdf.p = true;
      updated = true;
    }

    return updated;
  };

  function TextProperty(elem, data) {
    this._frameId = initialDefaultFrame;
    this.pv = '';
    this.v = '';
    this.kf = false;
    this._isFirstFrame = true;
    this._mdf = false;

    if (data.d && data.d.sid) {
      data.d = elem.globalData.slotManager.getProp(data.d);
    }

    this.data = data;
    this.elem = elem;
    this.comp = this.elem.comp;
    this.keysIndex = 0;
    this.canResize = false;
    this.minimumFontSize = 1;
    this.effectsSequence = [];
    this.currentData = {
      ascent: 0,
      boxWidth: this.defaultBoxWidth,
      f: '',
      fStyle: '',
      fWeight: '',
      fc: '',
      j: '',
      justifyOffset: '',
      l: [],
      lh: 0,
      lineWidths: [],
      ls: '',
      of: '',
      s: '',
      sc: '',
      sw: 0,
      t: 0,
      tr: 0,
      sz: 0,
      ps: null,
      fillColorAnim: false,
      strokeColorAnim: false,
      strokeWidthAnim: false,
      yOffset: 0,
      finalSize: 0,
      finalText: [],
      finalLineHeight: 0,
      __complete: false
    };
    this.copyData(this.currentData, this.data.d.k[0].s);

    if (!this.searchProperty()) {
      this.completeTextData(this.currentData);
    }
  }

  TextProperty.prototype.defaultBoxWidth = [0, 0];

  TextProperty.prototype.copyData = function (obj, data) {
    for (var s in data) {
      if (Object.prototype.hasOwnProperty.call(data, s)) {
        obj[s] = data[s];
      }
    }

    return obj;
  };

  TextProperty.prototype.setCurrentData = function (data) {
    if (!data.__complete) {
      this.completeTextData(data);
    }

    this.currentData = data;
    this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
    this._mdf = true;
  };

  TextProperty.prototype.searchProperty = function () {
    return this.searchKeyframes();
  };

  TextProperty.prototype.searchKeyframes = function () {
    this.kf = this.data.d.k.length > 1;

    if (this.kf) {
      this.addEffect(this.getKeyframeValue.bind(this));
    }

    return this.kf;
  };

  TextProperty.prototype.addEffect = function (effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.elem.addDynamicProperty(this);
  };

  TextProperty.prototype.getValue = function (_finalValue) {
    if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
      return;
    }

    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
    var currentValue = this.currentData;
    var currentIndex = this.keysIndex;

    if (this.lock) {
      this.setCurrentData(this.currentData);
      return;
    }

    this.lock = true;
    this._mdf = false;
    var i;
    var len = this.effectsSequence.length;
    var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;

    for (i = 0; i < len; i += 1) {
      // Checking if index changed to prevent creating a new object every time the expression updates.
      if (currentIndex !== this.keysIndex) {
        finalValue = this.effectsSequence[i](finalValue, finalValue.t);
      } else {
        finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
      }
    }

    if (currentValue !== finalValue) {
      this.setCurrentData(finalValue);
    }

    this.v = this.currentData;
    this.pv = this.v;
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  };

  TextProperty.prototype.getKeyframeValue = function () {
    var textKeys = this.data.d.k;
    var frameNum = this.elem.comp.renderedFrame;
    var i = 0;
    var len = textKeys.length;

    while (i <= len - 1) {
      if (i === len - 1 || textKeys[i + 1].t > frameNum) {
        break;
      }

      i += 1;
    }

    if (this.keysIndex !== i) {
      this.keysIndex = i;
    }

    return this.data.d.k[this.keysIndex].s;
  };

  TextProperty.prototype.buildFinalText = function (text) {
    var charactersArray = [];
    var i = 0;
    var len = text.length;
    var charCode;
    var secondCharCode;
    var shouldCombine = false;
    var shouldCombineNext = false;
    var currentChars = '';

    while (i < len) {
      shouldCombine = shouldCombineNext;
      shouldCombineNext = false;
      charCode = text.charCodeAt(i);
      currentChars = text.charAt(i);

      if (FontManager.isCombinedCharacter(charCode)) {
        shouldCombine = true; // It's a potential surrogate pair (this is the High surrogate)
      } else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
        if (FontManager.isRegionalFlag(text, i)) {
          currentChars = text.substr(i, 14);
        } else {
          secondCharCode = text.charCodeAt(i + 1); // It's a surrogate pair (this is the Low surrogate)

          if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
            if (FontManager.isModifier(charCode, secondCharCode)) {
              currentChars = text.substr(i, 2);
              shouldCombine = true;
            } else if (FontManager.isFlagEmoji(text.substr(i, 4))) {
              currentChars = text.substr(i, 4);
            } else {
              currentChars = text.substr(i, 2);
            }
          }
        }
      } else if (charCode > 0xDBFF) {
        secondCharCode = text.charCodeAt(i + 1);

        if (FontManager.isVariationSelector(charCode)) {
          shouldCombine = true;
        }
      } else if (FontManager.isZeroWidthJoiner(charCode)) {
        shouldCombine = true;
        shouldCombineNext = true;
      }

      if (shouldCombine) {
        charactersArray[charactersArray.length - 1] += currentChars;
        shouldCombine = false;
      } else {
        charactersArray.push(currentChars);
      }

      i += currentChars.length;
    }

    return charactersArray;
  };

  TextProperty.prototype.completeTextData = function (documentData) {
    documentData.__complete = true;
    var fontManager = this.elem.globalData.fontManager;
    var data = this.data;
    var letters = [];
    var i;
    var len;
    var newLineFlag;
    var index = 0;
    var val;
    var anchorGrouping = data.m.g;
    var currentSize = 0;
    var currentPos = 0;
    var currentLine = 0;
    var lineWidths = [];
    var lineWidth = 0;
    var maxLineWidth = 0;
    var j;
    var jLen;
    var fontData = fontManager.getFontByName(documentData.f);
    var charData;
    var cLength = 0;
    var fontProps = getFontProperties(fontData);
    documentData.fWeight = fontProps.weight;
    documentData.fStyle = fontProps.style;
    documentData.finalSize = documentData.s;
    documentData.finalText = this.buildFinalText(documentData.t);
    len = documentData.finalText.length;
    documentData.finalLineHeight = documentData.lh;
    var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
    var charCode;

    if (documentData.sz) {
      var flag = true;
      var boxWidth = documentData.sz[0];
      var boxHeight = documentData.sz[1];
      var currentHeight;
      var finalText;

      while (flag) {
        finalText = this.buildFinalText(documentData.t);
        currentHeight = 0;
        lineWidth = 0;
        len = finalText.length;
        trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var lastSpaceIndex = -1;

        for (i = 0; i < len; i += 1) {
          charCode = finalText[i].charCodeAt(0);
          newLineFlag = false;

          if (finalText[i] === ' ') {
            lastSpaceIndex = i;
          } else if (charCode === 13 || charCode === 3) {
            lineWidth = 0;
            newLineFlag = true;
            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
          }

          if (fontManager.chars) {
            charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
            cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
          } else {
            // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
            cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
          }

          if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
            if (lastSpaceIndex === -1) {
              len += 1;
            } else {
              i = lastSpaceIndex;
            }

            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
            finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r'); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);

            lastSpaceIndex = -1;
            lineWidth = 0;
          } else {
            lineWidth += cLength;
            lineWidth += trackingOffset;
          }
        }

        currentHeight += fontData.ascent * documentData.finalSize / 100;

        if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
          documentData.finalSize -= 1;
          documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
        } else {
          documentData.finalText = finalText;
          len = documentData.finalText.length;
          flag = false;
        }
      }
    }

    lineWidth = -trackingOffset;
    cLength = 0;
    var uncollapsedSpaces = 0;
    var currentChar;

    for (i = 0; i < len; i += 1) {
      newLineFlag = false;
      currentChar = documentData.finalText[i];
      charCode = currentChar.charCodeAt(0);

      if (charCode === 13 || charCode === 3) {
        uncollapsedSpaces = 0;
        lineWidths.push(lineWidth);
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidth = -2 * trackingOffset;
        val = '';
        newLineFlag = true;
        currentLine += 1;
      } else {
        val = currentChar;
      }

      if (fontManager.chars) {
        charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
      } else {
        // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
        // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
        cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
      } //


      if (currentChar === ' ') {
        uncollapsedSpaces += cLength + trackingOffset;
      } else {
        lineWidth += cLength + trackingOffset + uncollapsedSpaces;
        uncollapsedSpaces = 0;
      }

      letters.push({
        l: cLength,
        an: cLength,
        add: currentSize,
        n: newLineFlag,
        anIndexes: [],
        val: val,
        line: currentLine,
        animatorJustifyOffset: 0
      });

      if (anchorGrouping == 2) {
        // eslint-disable-line eqeqeq
        currentSize += cLength;

        if (val === '' || val === ' ' || i === len - 1) {
          if (val === '' || val === ' ') {
            currentSize -= cLength;
          }

          while (currentPos <= i) {
            letters[currentPos].an = currentSize;
            letters[currentPos].ind = index;
            letters[currentPos].extra = cLength;
            currentPos += 1;
          }

          index += 1;
          currentSize = 0;
        }
      } else if (anchorGrouping == 3) {
        // eslint-disable-line eqeqeq
        currentSize += cLength;

        if (val === '' || i === len - 1) {
          if (val === '') {
            currentSize -= cLength;
          }

          while (currentPos <= i) {
            letters[currentPos].an = currentSize;
            letters[currentPos].ind = index;
            letters[currentPos].extra = cLength;
            currentPos += 1;
          }

          currentSize = 0;
          index += 1;
        }
      } else {
        letters[index].ind = index;
        letters[index].extra = 0;
        index += 1;
      }
    }

    documentData.l = letters;
    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
    lineWidths.push(lineWidth);

    if (documentData.sz) {
      documentData.boxWidth = documentData.sz[0];
      documentData.justifyOffset = 0;
    } else {
      documentData.boxWidth = maxLineWidth;

      switch (documentData.j) {
        case 1:
          documentData.justifyOffset = -documentData.boxWidth;
          break;

        case 2:
          documentData.justifyOffset = -documentData.boxWidth / 2;
          break;

        default:
          documentData.justifyOffset = 0;
      }
    }

    documentData.lineWidths = lineWidths;
    var animators = data.a;
    var animatorData;
    var letterData;
    jLen = animators.length;
    var based;
    var ind;
    var indexes = [];

    for (j = 0; j < jLen; j += 1) {
      animatorData = animators[j];

      if (animatorData.a.sc) {
        documentData.strokeColorAnim = true;
      }

      if (animatorData.a.sw) {
        documentData.strokeWidthAnim = true;
      }

      if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) {
        documentData.fillColorAnim = true;
      }

      ind = 0;
      based = animatorData.s.b;

      for (i = 0; i < len; i += 1) {
        letterData = letters[i];
        letterData.anIndexes[j] = ind;

        if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
          // eslint-disable-line eqeqeq
          if (animatorData.s.rn === 1) {
            indexes.push(ind);
          }

          ind += 1;
        }
      }

      data.a[j].s.totalChars = ind;
      var currentInd = -1;
      var newInd;

      if (animatorData.s.rn === 1) {
        for (i = 0; i < len; i += 1) {
          letterData = letters[i];

          if (currentInd != letterData.anIndexes[j]) {
            // eslint-disable-line eqeqeq
            currentInd = letterData.anIndexes[j];
            newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
          }

          letterData.anIndexes[j] = newInd;
        }
      }
    }

    documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
    documentData.ls = documentData.ls || 0;
    documentData.ascent = fontData.ascent * documentData.finalSize / 100;
  };

  TextProperty.prototype.updateDocumentData = function (newData, index) {
    index = index === undefined ? this.keysIndex : index;
    var dData = this.copyData({}, this.data.d.k[index].s);
    dData = this.copyData(dData, newData);
    this.data.d.k[index].s = dData;
    this.recalculate(index);
    this.setCurrentData(dData);
    this.elem.addDynamicProperty(this);
  };

  TextProperty.prototype.recalculate = function (index) {
    var dData = this.data.d.k[index].s;
    dData.__complete = false;
    this.keysIndex = 0;
    this._isFirstFrame = true;
    this.getValue(dData);
  };

  TextProperty.prototype.canResizeFont = function (_canResize) {
    this.canResize = _canResize;
    this.recalculate(this.keysIndex);
    this.elem.addDynamicProperty(this);
  };

  TextProperty.prototype.setMinimumFontSize = function (_fontValue) {
    this.minimumFontSize = Math.floor(_fontValue) || 1;
    this.recalculate(this.keysIndex);
    this.elem.addDynamicProperty(this);
  };

  var TextSelectorProp = function () {
    var max = Math.max;
    var min = Math.min;
    var floor = Math.floor;

    function TextSelectorPropFactory(elem, data) {
      this._currentTextLength = -1;
      this.k = false;
      this.data = data;
      this.elem = elem;
      this.comp = elem.comp;
      this.finalS = 0;
      this.finalE = 0;
      this.initDynamicPropertyContainer(elem);
      this.s = PropertyFactory.getProp(elem, data.s || {
        k: 0
      }, 0, 0, this);

      if ('e' in data) {
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
      } else {
        this.e = {
          v: 100
        };
      }

      this.o = PropertyFactory.getProp(elem, data.o || {
        k: 0
      }, 0, 0, this);
      this.xe = PropertyFactory.getProp(elem, data.xe || {
        k: 0
      }, 0, 0, this);
      this.ne = PropertyFactory.getProp(elem, data.ne || {
        k: 0
      }, 0, 0, this);
      this.sm = PropertyFactory.getProp(elem, data.sm || {
        k: 100
      }, 0, 0, this);
      this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);

      if (!this.dynamicProperties.length) {
        this.getValue();
      }
    }

    TextSelectorPropFactory.prototype = {
      getMult: function getMult(ind) {
        if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
          this.getValue();
        }

        var x1 = 0;
        var y1 = 0;
        var x2 = 1;
        var y2 = 1;

        if (this.ne.v > 0) {
          x1 = this.ne.v / 100.0;
        } else {
          y1 = -this.ne.v / 100.0;
        }

        if (this.xe.v > 0) {
          x2 = 1.0 - this.xe.v / 100.0;
        } else {
          y2 = 1.0 + this.xe.v / 100.0;
        }

        var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
        var mult = 0;
        var s = this.finalS;
        var e = this.finalE;
        var type = this.data.sh;

        if (type === 2) {
          if (e === s) {
            mult = ind >= e ? 1 : 0;
          } else {
            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
          }

          mult = easer(mult);
        } else if (type === 3) {
          if (e === s) {
            mult = ind >= e ? 0 : 1;
          } else {
            mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
          }

          mult = easer(mult);
        } else if (type === 4) {
          if (e === s) {
            mult = 0;
          } else {
            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));

            if (mult < 0.5) {
              mult *= 2;
            } else {
              mult = 1 - 2 * (mult - 0.5);
            }
          }

          mult = easer(mult);
        } else if (type === 5) {
          if (e === s) {
            mult = 0;
          } else {
            var tot = e - s;
            /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */

            ind = min(max(0, ind + 0.5 - s), e - s);
            var x = -tot / 2 + ind;
            var a = tot / 2;
            mult = Math.sqrt(1 - x * x / (a * a));
          }

          mult = easer(mult);
        } else if (type === 6) {
          if (e === s) {
            mult = 0;
          } else {
            ind = min(max(0, ind + 0.5 - s), e - s);
            mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
          }

          mult = easer(mult);
        } else {
          if (ind >= floor(s)) {
            if (ind - s < 0) {
              mult = max(0, min(min(e, 1) - (s - ind), 1));
            } else {
              mult = max(0, min(e - ind, 1));
            }
          }

          mult = easer(mult);
        } // Smoothness implementation.
        // The smoothness represents a reduced range of the original [0; 1] range.
        // if smoothness is 25%, the new range will be [0.375; 0.625]
        // Steps are:
        // - find the lower value of the new range (threshold)
        // - if multiplier is smaller than that value, floor it to 0
        // - if it is larger,
        //     - subtract the threshold
        //     - divide it by the smoothness (this will return the range to [0; 1])
        // Note: If it doesn't work on some scenarios, consider applying it before the easer.


        if (this.sm.v !== 100) {
          var smoothness = this.sm.v * 0.01;

          if (smoothness === 0) {
            smoothness = 0.00000001;
          }

          var threshold = 0.5 - smoothness * 0.5;

          if (mult < threshold) {
            mult = 0;
          } else {
            mult = (mult - threshold) / smoothness;

            if (mult > 1) {
              mult = 1;
            }
          }
        }

        return mult * this.a.v;
      },
      getValue: function getValue(newCharsFlag) {
        this.iterateDynamicProperties();
        this._mdf = newCharsFlag || this._mdf;
        this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;

        if (newCharsFlag && this.data.r === 2) {
          this.e.v = this._currentTextLength;
        }

        var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
        var o = this.o.v / divisor;
        var s = this.s.v / divisor + o;
        var e = this.e.v / divisor + o;

        if (s > e) {
          var _s = s;
          s = e;
          e = _s;
        }

        this.finalS = s;
        this.finalE = e;
      }
    };
    extendPrototype([DynamicPropertyContainer], TextSelectorPropFactory);

    function getTextSelectorProp(elem, data, arr) {
      return new TextSelectorPropFactory(elem, data, arr);
    }

    return {
      getTextSelectorProp: getTextSelectorProp
    };
  }();

  function TextAnimatorDataProperty(elem, animatorProps, container) {
    var defaultData = {
      propType: false
    };
    var getProp = PropertyFactory.getProp;
    var textAnimatorAnimatables = animatorProps.a;
    this.a = {
      r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
      rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
      ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
      sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
      sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
      s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
      a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
      o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
      p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
      sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
      sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
      fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
      fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
      fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
      fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
      t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
    };
    this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
    this.s.t = animatorProps.s.t;
  }

  function TextAnimatorProperty(textData, renderType, elem) {
    this._isFirstFrame = true;
    this._hasMaskedPath = false;
    this._frameId = -1;
    this._textData = textData;
    this._renderType = renderType;
    this._elem = elem;
    this._animatorsData = createSizedArray(this._textData.a.length);
    this._pathData = {};
    this._moreOptions = {
      alignment: {}
    };
    this.renderedLetters = [];
    this.lettersChangedFlag = false;
    this.initDynamicPropertyContainer(elem);
  }

  TextAnimatorProperty.prototype.searchProperties = function () {
    var i;
    var len = this._textData.a.length;
    var animatorProps;
    var getProp = PropertyFactory.getProp;

    for (i = 0; i < len; i += 1) {
      animatorProps = this._textData.a[i];
      this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
    }

    if (this._textData.p && 'm' in this._textData.p) {
      this._pathData = {
        a: getProp(this._elem, this._textData.p.a, 0, 0, this),
        f: getProp(this._elem, this._textData.p.f, 0, 0, this),
        l: getProp(this._elem, this._textData.p.l, 0, 0, this),
        r: getProp(this._elem, this._textData.p.r, 0, 0, this),
        p: getProp(this._elem, this._textData.p.p, 0, 0, this),
        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
      };
      this._hasMaskedPath = true;
    } else {
      this._hasMaskedPath = false;
    }

    this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
  };

  TextAnimatorProperty.prototype.getMeasures = function (documentData, lettersChangedFlag) {
    this.lettersChangedFlag = lettersChangedFlag;

    if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
      return;
    }

    this._isFirstFrame = false;
    var alignment = this._moreOptions.alignment.v;
    var animators = this._animatorsData;
    var textData = this._textData;
    var matrixHelper = this.mHelper;
    var renderType = this._renderType;
    var renderedLettersCount = this.renderedLetters.length;
    var xPos;
    var yPos;
    var i;
    var len;
    var letters = documentData.l;
    var pathInfo;
    var currentLength;
    var currentPoint;
    var segmentLength;
    var flag;
    var pointInd;
    var segmentInd;
    var prevPoint;
    var points;
    var segments;
    var partialLength;
    var totalLength;
    var perc;
    var tanAngle;
    var mask;

    if (this._hasMaskedPath) {
      mask = this._pathData.m;

      if (!this._pathData.n || this._pathData._mdf) {
        var paths = mask.v;

        if (this._pathData.r.v) {
          paths = paths.reverse();
        } // TODO: release bezier data cached from previous pathInfo: this._pathData.pi


        pathInfo = {
          tLength: 0,
          segments: []
        };
        len = paths._length - 1;
        var bezierData;
        totalLength = 0;

        for (i = 0; i < len; i += 1) {
          bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]);
          pathInfo.tLength += bezierData.segmentLength;
          pathInfo.segments.push(bezierData);
          totalLength += bezierData.segmentLength;
        }

        i = len;

        if (mask.v.c) {
          bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]);
          pathInfo.tLength += bezierData.segmentLength;
          pathInfo.segments.push(bezierData);
          totalLength += bezierData.segmentLength;
        }

        this._pathData.pi = pathInfo;
      }

      pathInfo = this._pathData.pi;
      currentLength = this._pathData.f.v;
      segmentInd = 0;
      pointInd = 1;
      segmentLength = 0;
      flag = true;
      segments = pathInfo.segments;

      if (currentLength < 0 && mask.v.c) {
        if (pathInfo.tLength < Math.abs(currentLength)) {
          currentLength = -Math.abs(currentLength) % pathInfo.tLength;
        }

        segmentInd = segments.length - 1;
        points = segments[segmentInd].points;
        pointInd = points.length - 1;

        while (currentLength < 0) {
          currentLength += points[pointInd].partialLength;
          pointInd -= 1;

          if (pointInd < 0) {
            segmentInd -= 1;
            points = segments[segmentInd].points;
            pointInd = points.length - 1;
          }
        }
      }

      points = segments[segmentInd].points;
      prevPoint = points[pointInd - 1];
      currentPoint = points[pointInd];
      partialLength = currentPoint.partialLength;
    }

    len = letters.length;
    xPos = 0;
    yPos = 0;
    var yOff = documentData.finalSize * 1.2 * 0.714;
    var firstLine = true;
    var animatorProps;
    var animatorSelector;
    var j;
    var jLen;
    var letterValue;
    jLen = animators.length;
    var mult;
    var ind = -1;
    var offf;
    var xPathPos;
    var yPathPos;
    var initPathPos = currentLength;
    var initSegmentInd = segmentInd;
    var initPointInd = pointInd;
    var currentLine = -1;
    var elemOpacity;
    var sc;
    var sw;
    var fc;
    var k;
    var letterSw;
    var letterSc;
    var letterFc;
    var letterM = '';
    var letterP = this.defaultPropsArray;
    var letterO; //

    if (documentData.j === 2 || documentData.j === 1) {
      var animatorJustifyOffset = 0;
      var animatorFirstCharOffset = 0;
      var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
      var lastIndex = 0;
      var isNewLine = true;

      for (i = 0; i < len; i += 1) {
        if (letters[i].n) {
          if (animatorJustifyOffset) {
            animatorJustifyOffset += animatorFirstCharOffset;
          }

          while (lastIndex < i) {
            letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
            lastIndex += 1;
          }

          animatorJustifyOffset = 0;
          isNewLine = true;
        } else {
          for (j = 0; j < jLen; j += 1) {
            animatorProps = animators[j].a;

            if (animatorProps.t.propType) {
              if (isNewLine && documentData.j === 2) {
                animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
              }

              animatorSelector = animators[j].s;
              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

              if (mult.length) {
                animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
              } else {
                animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
              }
            }
          }

          isNewLine = false;
        }
      }

      if (animatorJustifyOffset) {
        animatorJustifyOffset += animatorFirstCharOffset;
      }

      while (lastIndex < i) {
        letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
        lastIndex += 1;
      }
    } //


    for (i = 0; i < len; i += 1) {
      matrixHelper.reset();
      elemOpacity = 1;

      if (letters[i].n) {
        xPos = 0;
        yPos += documentData.yOffset;
        yPos += firstLine ? 1 : 0;
        currentLength = initPathPos;
        firstLine = false;

        if (this._hasMaskedPath) {
          segmentInd = initSegmentInd;
          pointInd = initPointInd;
          points = segments[segmentInd].points;
          prevPoint = points[pointInd - 1];
          currentPoint = points[pointInd];
          partialLength = currentPoint.partialLength;
          segmentLength = 0;
        }

        letterM = '';
        letterFc = '';
        letterSw = '';
        letterO = '';
        letterP = this.defaultPropsArray;
      } else {
        if (this._hasMaskedPath) {
          if (currentLine !== letters[i].line) {
            switch (documentData.j) {
              case 1:
                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                break;

              case 2:
                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                break;

              default:
                break;
            }

            currentLine = letters[i].line;
          }

          if (ind !== letters[i].ind) {
            if (letters[ind]) {
              currentLength += letters[ind].extra;
            }

            currentLength += letters[i].an / 2;
            ind = letters[i].ind;
          }

          currentLength += alignment[0] * letters[i].an * 0.005;
          var animatorOffset = 0;

          for (j = 0; j < jLen; j += 1) {
            animatorProps = animators[j].a;

            if (animatorProps.p.propType) {
              animatorSelector = animators[j].s;
              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

              if (mult.length) {
                animatorOffset += animatorProps.p.v[0] * mult[0];
              } else {
                animatorOffset += animatorProps.p.v[0] * mult;
              }
            }

            if (animatorProps.a.propType) {
              animatorSelector = animators[j].s;
              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

              if (mult.length) {
                animatorOffset += animatorProps.a.v[0] * mult[0];
              } else {
                animatorOffset += animatorProps.a.v[0] * mult;
              }
            }
          }

          flag = true; // Force alignment only works with a single line for now

          if (this._pathData.a.v) {
            currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
            currentLength += this._pathData.f.v;
          }

          while (flag) {
            if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
              perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
              xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
              yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
              matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
              flag = false;
            } else if (points) {
              segmentLength += currentPoint.partialLength;
              pointInd += 1;

              if (pointInd >= points.length) {
                pointInd = 0;
                segmentInd += 1;

                if (!segments[segmentInd]) {
                  if (mask.v.c) {
                    pointInd = 0;
                    segmentInd = 0;
                    points = segments[segmentInd].points;
                  } else {
                    segmentLength -= currentPoint.partialLength;
                    points = null;
                  }
                } else {
                  points = segments[segmentInd].points;
                }
              }

              if (points) {
                prevPoint = currentPoint;
                currentPoint = points[pointInd];
                partialLength = currentPoint.partialLength;
              }
            }
          }

          offf = letters[i].an / 2 - letters[i].add;
          matrixHelper.translate(-offf, 0, 0);
        } else {
          offf = letters[i].an / 2 - letters[i].add;
          matrixHelper.translate(-offf, 0, 0); // Grouping alignment

          matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;

          if (animatorProps.t.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"

            if (xPos !== 0 || documentData.j !== 0) {
              if (this._hasMaskedPath) {
                if (mult.length) {
                  currentLength += animatorProps.t.v * mult[0];
                } else {
                  currentLength += animatorProps.t.v * mult;
                }
              } else if (mult.length) {
                xPos += animatorProps.t.v * mult[0];
              } else {
                xPos += animatorProps.t.v * mult;
              }
            }
          }
        }

        if (documentData.strokeWidthAnim) {
          sw = documentData.sw || 0;
        }

        if (documentData.strokeColorAnim) {
          if (documentData.sc) {
            sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
          } else {
            sc = [0, 0, 0];
          }
        }

        if (documentData.fillColorAnim && documentData.fc) {
          fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;

          if (animatorProps.a.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

            if (mult.length) {
              matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
            } else {
              matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
            }
          }
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;

          if (animatorProps.s.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

            if (mult.length) {
              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
            } else {
              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
            }
          }
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

          if (animatorProps.sk.propType) {
            if (mult.length) {
              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
            } else {
              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
            }
          }

          if (animatorProps.r.propType) {
            if (mult.length) {
              matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
            } else {
              matrixHelper.rotateZ(-animatorProps.r.v * mult);
            }
          }

          if (animatorProps.ry.propType) {
            if (mult.length) {
              matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
            } else {
              matrixHelper.rotateY(animatorProps.ry.v * mult);
            }
          }

          if (animatorProps.rx.propType) {
            if (mult.length) {
              matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
            } else {
              matrixHelper.rotateX(animatorProps.rx.v * mult);
            }
          }

          if (animatorProps.o.propType) {
            if (mult.length) {
              elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
            } else {
              elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
            }
          }

          if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
            if (mult.length) {
              sw += animatorProps.sw.v * mult[0];
            } else {
              sw += animatorProps.sw.v * mult;
            }
          }

          if (documentData.strokeColorAnim && animatorProps.sc.propType) {
            for (k = 0; k < 3; k += 1) {
              if (mult.length) {
                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
              } else {
                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
              }
            }
          }

          if (documentData.fillColorAnim && documentData.fc) {
            if (animatorProps.fc.propType) {
              for (k = 0; k < 3; k += 1) {
                if (mult.length) {
                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                } else {
                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                }
              }
            }

            if (animatorProps.fh.propType) {
              if (mult.length) {
                fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
              } else {
                fc = addHueToRGB(fc, animatorProps.fh.v * mult);
              }
            }

            if (animatorProps.fs.propType) {
              if (mult.length) {
                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
              } else {
                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
              }
            }

            if (animatorProps.fb.propType) {
              if (mult.length) {
                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
              } else {
                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
              }
            }
          }
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;

          if (animatorProps.p.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

            if (this._hasMaskedPath) {
              if (mult.length) {
                matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
              } else {
                matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
              }
            } else if (mult.length) {
              matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
            } else {
              matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
            }
          }
        }

        if (documentData.strokeWidthAnim) {
          letterSw = sw < 0 ? 0 : sw;
        }

        if (documentData.strokeColorAnim) {
          letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
        }

        if (documentData.fillColorAnim && documentData.fc) {
          letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
        }

        if (this._hasMaskedPath) {
          matrixHelper.translate(0, -documentData.ls);
          matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);

          if (this._pathData.p.v) {
            tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
            var rot = Math.atan(tanAngle) * 180 / Math.PI;

            if (currentPoint.point[0] < prevPoint.point[0]) {
              rot += 180;
            }

            matrixHelper.rotate(-rot * Math.PI / 180);
          }

          matrixHelper.translate(xPathPos, yPathPos, 0);
          currentLength -= alignment[0] * letters[i].an * 0.005;

          if (letters[i + 1] && ind !== letters[i + 1].ind) {
            currentLength += letters[i].an / 2;
            currentLength += documentData.tr * 0.001 * documentData.finalSize;
          }
        } else {
          matrixHelper.translate(xPos, yPos, 0);

          if (documentData.ps) {
            // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
            matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
          }

          switch (documentData.j) {
            case 1:
              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
              break;

            case 2:
              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
              break;

            default:
              break;
          }

          matrixHelper.translate(0, -documentData.ls);
          matrixHelper.translate(offf, 0, 0);
          matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
          xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
        }

        if (renderType === 'html') {
          letterM = matrixHelper.toCSS();
        } else if (renderType === 'svg') {
          letterM = matrixHelper.to2dCSS();
        } else {
          letterP = [matrixHelper.props[0], matrixHelper.props[1], matrixHelper.props[2], matrixHelper.props[3], matrixHelper.props[4], matrixHelper.props[5], matrixHelper.props[6], matrixHelper.props[7], matrixHelper.props[8], matrixHelper.props[9], matrixHelper.props[10], matrixHelper.props[11], matrixHelper.props[12], matrixHelper.props[13], matrixHelper.props[14], matrixHelper.props[15]];
        }

        letterO = elemOpacity;
      }

      if (renderedLettersCount <= i) {
        letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
        this.renderedLetters.push(letterValue);
        renderedLettersCount += 1;
        this.lettersChangedFlag = true;
      } else {
        letterValue = this.renderedLetters[i];
        this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
      }
    }
  };

  TextAnimatorProperty.prototype.getValue = function () {
    if (this._elem.globalData.frameId === this._frameId) {
      return;
    }

    this._frameId = this._elem.globalData.frameId;
    this.iterateDynamicProperties();
  };

  TextAnimatorProperty.prototype.mHelper = new Matrix();
  TextAnimatorProperty.prototype.defaultPropsArray = [];
  extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);

  function ITextElement() {}

  ITextElement.prototype.initElement = function (data, globalData, comp) {
    this.lettersChangedFlag = true;
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
    this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
    this.initTransform(data, globalData, comp);
    this.initHierarchy();
    this.initRenderable();
    this.initRendererElement();
    this.createContainerElements();
    this.createRenderableComponents();
    this.createContent();
    this.hide();
    this.textAnimator.searchProperties(this.dynamicProperties);
  };

  ITextElement.prototype.prepareFrame = function (num) {
    this._mdf = false;
    this.prepareRenderableFrame(num);
    this.prepareProperties(num, this.isInRange);
  };

  ITextElement.prototype.createPathShape = function (matrixHelper, shapes) {
    var j;
    var jLen = shapes.length;
    var pathNodes;
    var shapeStr = '';

    for (j = 0; j < jLen; j += 1) {
      if (shapes[j].ty === 'sh') {
        pathNodes = shapes[j].ks.k;
        shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
      }
    }

    return shapeStr;
  };

  ITextElement.prototype.updateDocumentData = function (newData, index) {
    this.textProperty.updateDocumentData(newData, index);
  };

  ITextElement.prototype.canResizeFont = function (_canResize) {
    this.textProperty.canResizeFont(_canResize);
  };

  ITextElement.prototype.setMinimumFontSize = function (_fontSize) {
    this.textProperty.setMinimumFontSize(_fontSize);
  };

  ITextElement.prototype.applyTextPropertiesToMatrix = function (documentData, matrixHelper, lineNumber, xPos, yPos) {
    if (documentData.ps) {
      matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
    }

    matrixHelper.translate(0, -documentData.ls, 0);

    switch (documentData.j) {
      case 1:
        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
        break;

      case 2:
        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
        break;

      default:
        break;
    }

    matrixHelper.translate(xPos, yPos, 0);
  };

  ITextElement.prototype.buildColor = function (colorData) {
    return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
  };

  ITextElement.prototype.emptyProp = new LetterProps();

  ITextElement.prototype.destroy = function () {};

  ITextElement.prototype.validateText = function () {
    if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
      this.buildNewText();
      this.textProperty._isFirstFrame = false;
      this.textProperty._mdf = false;
    }
  };

  var emptyShapeData = {
    shapes: []
  };

  function SVGTextLottieElement(data, globalData, comp) {
    this.textSpans = [];
    this.renderType = 'svg';
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement);

  SVGTextLottieElement.prototype.createContent = function () {
    if (this.data.singleShape && !this.globalData.fontManager.chars) {
      this.textContainer = createNS('text');
    }
  };

  SVGTextLottieElement.prototype.buildTextContents = function (textArray) {
    var i = 0;
    var len = textArray.length;
    var textContents = [];
    var currentTextContent = '';

    while (i < len) {
      if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
        textContents.push(currentTextContent);
        currentTextContent = '';
      } else {
        currentTextContent += textArray[i];
      }

      i += 1;
    }

    textContents.push(currentTextContent);
    return textContents;
  };

  SVGTextLottieElement.prototype.buildShapeData = function (data, scale) {
    // data should probably be cloned to apply scale separately to each instance of a text on different layers
    // but since text internal content gets only rendered once and then it's never rerendered,
    // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
    // Avoiding cloning is preferred since cloning each character shape data is expensive
    if (data.shapes && data.shapes.length) {
      var shape = data.shapes[0];

      if (shape.it) {
        var shapeItem = shape.it[shape.it.length - 1];

        if (shapeItem.s) {
          shapeItem.s.k[0] = scale;
          shapeItem.s.k[1] = scale;
        }
      }
    }

    return data;
  };

  SVGTextLottieElement.prototype.buildNewText = function () {
    this.addDynamicProperty(this);
    var i;
    var len;
    var documentData = this.textProperty.currentData;
    this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);

    if (documentData.fc) {
      this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
    } else {
      this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
    }

    if (documentData.sc) {
      this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
      this.layerElement.setAttribute('stroke-width', documentData.sw);
    }

    this.layerElement.setAttribute('font-size', documentData.finalSize);
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);

    if (fontData.fClass) {
      this.layerElement.setAttribute('class', fontData.fClass);
    } else {
      this.layerElement.setAttribute('font-family', fontData.fFamily);
      var fWeight = documentData.fWeight;
      var fStyle = documentData.fStyle;
      this.layerElement.setAttribute('font-style', fStyle);
      this.layerElement.setAttribute('font-weight', fWeight);
    }

    this.layerElement.setAttribute('aria-label', documentData.t);
    var letters = documentData.l || [];
    var usesGlyphs = !!this.globalData.fontManager.chars;
    len = letters.length;
    var tSpan;
    var matrixHelper = this.mHelper;
    var shapeStr = '';
    var singleShape = this.data.singleShape;
    var xPos = 0;
    var yPos = 0;
    var firstLine = true;
    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;

    if (singleShape && !usesGlyphs && !documentData.sz) {
      var tElement = this.textContainer;
      var justify = 'start';

      switch (documentData.j) {
        case 1:
          justify = 'end';
          break;

        case 2:
          justify = 'middle';
          break;

        default:
          justify = 'start';
          break;
      }

      tElement.setAttribute('text-anchor', justify);
      tElement.setAttribute('letter-spacing', trackingOffset);
      var textContent = this.buildTextContents(documentData.finalText);
      len = textContent.length;
      yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;

      for (i = 0; i < len; i += 1) {
        tSpan = this.textSpans[i].span || createNS('tspan');
        tSpan.textContent = textContent[i];
        tSpan.setAttribute('x', 0);
        tSpan.setAttribute('y', yPos);
        tSpan.style.display = 'inherit';
        tElement.appendChild(tSpan);

        if (!this.textSpans[i]) {
          this.textSpans[i] = {
            span: null,
            glyph: null
          };
        }

        this.textSpans[i].span = tSpan;
        yPos += documentData.finalLineHeight;
      }

      this.layerElement.appendChild(tElement);
    } else {
      var cachedSpansLength = this.textSpans.length;
      var charData;

      for (i = 0; i < len; i += 1) {
        if (!this.textSpans[i]) {
          this.textSpans[i] = {
            span: null,
            childSpan: null,
            glyph: null
          };
        }

        if (!usesGlyphs || !singleShape || i === 0) {
          tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');

          if (cachedSpansLength <= i) {
            tSpan.setAttribute('stroke-linecap', 'butt');
            tSpan.setAttribute('stroke-linejoin', 'round');
            tSpan.setAttribute('stroke-miterlimit', '4');
            this.textSpans[i].span = tSpan;

            if (usesGlyphs) {
              var childSpan = createNS('g');
              tSpan.appendChild(childSpan);
              this.textSpans[i].childSpan = childSpan;
            }

            this.textSpans[i].span = tSpan;
            this.layerElement.appendChild(tSpan);
          }

          tSpan.style.display = 'inherit';
        }

        matrixHelper.reset();

        if (singleShape) {
          if (letters[i].n) {
            xPos = -trackingOffset;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            firstLine = false;
          }

          this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
          xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;

          xPos += trackingOffset;
        }

        if (usesGlyphs) {
          charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
          var glyphElement; // t === 1 means the character has been replaced with an animated shaped

          if (charData.t === 1) {
            glyphElement = new SVGCompElement(charData.data, this.globalData, this);
          } else {
            var data = emptyShapeData;

            if (charData.data && charData.data.shapes) {
              data = this.buildShapeData(charData.data, documentData.finalSize);
            }

            glyphElement = new SVGShapeElement(data, this.globalData, this);
          }

          if (this.textSpans[i].glyph) {
            var glyph = this.textSpans[i].glyph;
            this.textSpans[i].childSpan.removeChild(glyph.layerElement);
            glyph.destroy();
          }

          this.textSpans[i].glyph = glyphElement;
          glyphElement._debug = true;
          glyphElement.prepareFrame(0);
          glyphElement.renderFrame();
          this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
          // this might have issues with strokes and might need a different solution

          if (charData.t === 1) {
            this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
          }
        } else {
          if (singleShape) {
            tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
          }

          tSpan.textContent = letters[i].val;
          tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
        } //

      }

      if (singleShape && tSpan) {
        tSpan.setAttribute('d', shapeStr);
      }
    }

    while (i < this.textSpans.length) {
      this.textSpans[i].span.style.display = 'none';
      i += 1;
    }

    this._sizeChanged = true;
  };

  SVGTextLottieElement.prototype.sourceRectAtTime = function () {
    this.prepareFrame(this.comp.renderedFrame - this.data.st);
    this.renderInnerContent();

    if (this._sizeChanged) {
      this._sizeChanged = false;
      var textBox = this.layerElement.getBBox();
      this.bbox = {
        top: textBox.y,
        left: textBox.x,
        width: textBox.width,
        height: textBox.height
      };
    }

    return this.bbox;
  };

  SVGTextLottieElement.prototype.getValue = function () {
    var i;
    var len = this.textSpans.length;
    var glyphElement;
    this.renderedFrame = this.comp.renderedFrame;

    for (i = 0; i < len; i += 1) {
      glyphElement = this.textSpans[i].glyph;

      if (glyphElement) {
        glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);

        if (glyphElement._mdf) {
          this._mdf = true;
        }
      }
    }
  };

  SVGTextLottieElement.prototype.renderInnerContent = function () {
    this.validateText();

    if (!this.data.singleShape || this._mdf) {
      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);

      if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
        this._sizeChanged = true;
        var i;
        var len;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var textSpan;
        var glyphElement;

        for (i = 0; i < len; i += 1) {
          if (!letters[i].n) {
            renderedLetter = renderedLetters[i];
            textSpan = this.textSpans[i].span;
            glyphElement = this.textSpans[i].glyph;

            if (glyphElement) {
              glyphElement.renderFrame();
            }

            if (renderedLetter._mdf.m) {
              textSpan.setAttribute('transform', renderedLetter.m);
            }

            if (renderedLetter._mdf.o) {
              textSpan.setAttribute('opacity', renderedLetter.o);
            }

            if (renderedLetter._mdf.sw) {
              textSpan.setAttribute('stroke-width', renderedLetter.sw);
            }

            if (renderedLetter._mdf.sc) {
              textSpan.setAttribute('stroke', renderedLetter.sc);
            }

            if (renderedLetter._mdf.fc) {
              textSpan.setAttribute('fill', renderedLetter.fc);
            }
          }
        }
      }
    }
  };

  function ISolidElement(data, globalData, comp) {
    this.initElement(data, globalData, comp);
  }

  extendPrototype([IImageElement], ISolidElement);

  ISolidElement.prototype.createContent = function () {
    var rect = createNS('rect'); /// /rect.style.width = this.data.sw;
    /// /rect.style.height = this.data.sh;
    /// /rect.style.fill = this.data.sc;

    rect.setAttribute('width', this.data.sw);
    rect.setAttribute('height', this.data.sh);
    rect.setAttribute('fill', this.data.sc);
    this.layerElement.appendChild(rect);
  };

  function NullElement(data, globalData, comp) {
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.initFrame();
    this.initTransform(data, globalData, comp);
    this.initHierarchy();
  }

  NullElement.prototype.prepareFrame = function (num) {
    this.prepareProperties(num, true);
  };

  NullElement.prototype.renderFrame = function () {};

  NullElement.prototype.getBaseElement = function () {
    return null;
  };

  NullElement.prototype.destroy = function () {};

  NullElement.prototype.sourceRectAtTime = function () {};

  NullElement.prototype.hide = function () {};

  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);

  function SVGRendererBase() {}

  extendPrototype([BaseRenderer], SVGRendererBase);

  SVGRendererBase.prototype.createNull = function (data) {
    return new NullElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.createShape = function (data) {
    return new SVGShapeElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.createText = function (data) {
    return new SVGTextLottieElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.createImage = function (data) {
    return new IImageElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.createSolid = function (data) {
    return new ISolidElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.configAnimation = function (animData) {
    this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');

    if (this.renderConfig.viewBoxSize) {
      this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
    } else {
      this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
    }

    if (!this.renderConfig.viewBoxOnly) {
      this.svgElement.setAttribute('width', animData.w);
      this.svgElement.setAttribute('height', animData.h);
      this.svgElement.style.width = '100%';
      this.svgElement.style.height = '100%';
      this.svgElement.style.transform = 'translate3d(0,0,0)';
      this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
    }

    if (this.renderConfig.width) {
      this.svgElement.setAttribute('width', this.renderConfig.width);
    }

    if (this.renderConfig.height) {
      this.svgElement.setAttribute('height', this.renderConfig.height);
    }

    if (this.renderConfig.className) {
      this.svgElement.setAttribute('class', this.renderConfig.className);
    }

    if (this.renderConfig.id) {
      this.svgElement.setAttribute('id', this.renderConfig.id);
    }

    if (this.renderConfig.focusable !== undefined) {
      this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
    }

    this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
    // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";

    this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation

    var defs = this.globalData.defs;
    this.setupGlobalData(animData, defs);
    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
    this.data = animData;
    var maskElement = createNS('clipPath');
    var rect = createNS('rect');
    rect.setAttribute('width', animData.w);
    rect.setAttribute('height', animData.h);
    rect.setAttribute('x', 0);
    rect.setAttribute('y', 0);
    var maskId = createElementID();
    maskElement.setAttribute('id', maskId);
    maskElement.appendChild(rect);
    this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
    defs.appendChild(maskElement);
    this.layers = animData.layers;
    this.elements = createSizedArray(animData.layers.length);
  };

  SVGRendererBase.prototype.destroy = function () {
    if (this.animationItem.wrapper) {
      this.animationItem.wrapper.innerText = '';
    }

    this.layerElement = null;
    this.globalData.defs = null;
    var i;
    var len = this.layers ? this.layers.length : 0;

    for (i = 0; i < len; i += 1) {
      if (this.elements[i] && this.elements[i].destroy) {
        this.elements[i].destroy();
      }
    }

    this.elements.length = 0;
    this.destroyed = true;
    this.animationItem = null;
  };

  SVGRendererBase.prototype.updateContainerSize = function () {};

  SVGRendererBase.prototype.findIndexByInd = function (ind) {
    var i = 0;
    var len = this.layers.length;

    for (i = 0; i < len; i += 1) {
      if (this.layers[i].ind === ind) {
        return i;
      }
    }

    return -1;
  };

  SVGRendererBase.prototype.buildItem = function (pos) {
    var elements = this.elements;

    if (elements[pos] || this.layers[pos].ty === 99) {
      return;
    }

    elements[pos] = true;
    var element = this.createItem(this.layers[pos]);
    elements[pos] = element;

    if (getExpressionsPlugin()) {
      if (this.layers[pos].ty === 0) {
        this.globalData.projectInterface.registerComposition(element);
      }

      element.initExpressions();
    }

    this.appendElementInPos(element, pos);

    if (this.layers[pos].tt) {
      var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;

      if (elementIndex === -1) {
        return;
      }

      if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
        this.buildItem(elementIndex);
        this.addPendingElement(element);
      } else {
        var matteElement = elements[elementIndex];
        var matteMask = matteElement.getMatte(this.layers[pos].tt);
        element.setMatte(matteMask);
      }
    }
  };

  SVGRendererBase.prototype.checkPendingElements = function () {
    while (this.pendingElements.length) {
      var element = this.pendingElements.pop();
      element.checkParenting();

      if (element.data.tt) {
        var i = 0;
        var len = this.elements.length;

        while (i < len) {
          if (this.elements[i] === element) {
            var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
            var matteElement = this.elements[elementIndex];
            var matteMask = matteElement.getMatte(this.layers[i].tt);
            element.setMatte(matteMask);
            break;
          }

          i += 1;
        }
      }
    }
  };

  SVGRendererBase.prototype.renderFrame = function (num) {
    if (this.renderedFrame === num || this.destroyed) {
      return;
    }

    if (num === null) {
      num = this.renderedFrame;
    } else {
      this.renderedFrame = num;
    } // console.log('-------');
    // console.log('FRAME ',num);


    this.globalData.frameNum = num;
    this.globalData.frameId += 1;
    this.globalData.projectInterface.currentFrame = num;
    this.globalData._mdf = false;
    var i;
    var len = this.layers.length;

    if (!this.completeLayers) {
      this.checkLayers(num);
    }

    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].prepareFrame(num - this.layers[i].st);
      }
    }

    if (this.globalData._mdf) {
      for (i = 0; i < len; i += 1) {
        if (this.completeLayers || this.elements[i]) {
          this.elements[i].renderFrame();
        }
      }
    }
  };

  SVGRendererBase.prototype.appendElementInPos = function (element, pos) {
    var newElement = element.getBaseElement();

    if (!newElement) {
      return;
    }

    var i = 0;
    var nextElement;

    while (i < pos) {
      if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) {
        nextElement = this.elements[i].getBaseElement();
      }

      i += 1;
    }

    if (nextElement) {
      this.layerElement.insertBefore(newElement, nextElement);
    } else {
      this.layerElement.appendChild(newElement);
    }
  };

  SVGRendererBase.prototype.hide = function () {
    this.layerElement.style.display = 'none';
  };

  SVGRendererBase.prototype.show = function () {
    this.layerElement.style.display = 'block';
  };

  function ICompElement() {}

  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);

  ICompElement.prototype.initElement = function (data, globalData, comp) {
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.initTransform(data, globalData, comp);
    this.initRenderable();
    this.initHierarchy();
    this.initRendererElement();
    this.createContainerElements();
    this.createRenderableComponents();

    if (this.data.xt || !globalData.progressiveLoad) {
      this.buildAllItems();
    }

    this.hide();
  };
  /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */


  ICompElement.prototype.prepareFrame = function (num) {
    this._mdf = false;
    this.prepareRenderableFrame(num);
    this.prepareProperties(num, this.isInRange);

    if (!this.isInRange && !this.data.xt) {
      return;
    }

    if (!this.tm._placeholder) {
      var timeRemapped = this.tm.v;

      if (timeRemapped === this.data.op) {
        timeRemapped = this.data.op - 1;
      }

      this.renderedFrame = timeRemapped;
    } else {
      this.renderedFrame = num / this.data.sr;
    }

    var i;
    var len = this.elements.length;

    if (!this.completeLayers) {
      this.checkLayers(this.renderedFrame);
    } // This iteration needs to be backwards because of how expressions connect between each other


    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);

        if (this.elements[i]._mdf) {
          this._mdf = true;
        }
      }
    }
  };

  ICompElement.prototype.renderInnerContent = function () {
    var i;
    var len = this.layers.length;

    for (i = 0; i < len; i += 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
  };

  ICompElement.prototype.setElements = function (elems) {
    this.elements = elems;
  };

  ICompElement.prototype.getElements = function () {
    return this.elements;
  };

  ICompElement.prototype.destroyElements = function () {
    var i;
    var len = this.layers.length;

    for (i = 0; i < len; i += 1) {
      if (this.elements[i]) {
        this.elements[i].destroy();
      }
    }
  };

  ICompElement.prototype.destroy = function () {
    this.destroyElements();
    this.destroyBaseElement();
  };

  function SVGCompElement(data, globalData, comp) {
    this.layers = data.layers;
    this.supports3d = true;
    this.completeLayers = false;
    this.pendingElements = [];
    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
    this.initElement(data, globalData, comp);
    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
      _placeholder: true
    };
  }

  extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement);

  SVGCompElement.prototype.createComp = function (data) {
    return new SVGCompElement(data, this.globalData, this);
  };

  function SVGRenderer(animationItem, config) {
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.svgElement = createNS('svg');
    var ariaLabel = '';

    if (config && config.title) {
      var titleElement = createNS('title');
      var titleId = createElementID();
      titleElement.setAttribute('id', titleId);
      titleElement.textContent = config.title;
      this.svgElement.appendChild(titleElement);
      ariaLabel += titleId;
    }

    if (config && config.description) {
      var descElement = createNS('desc');
      var descId = createElementID();
      descElement.setAttribute('id', descId);
      descElement.textContent = config.description;
      this.svgElement.appendChild(descElement);
      ariaLabel += ' ' + descId;
    }

    if (ariaLabel) {
      this.svgElement.setAttribute('aria-labelledby', ariaLabel);
    }

    var defs = createNS('defs');
    this.svgElement.appendChild(defs);
    var maskElement = createNS('g');
    this.svgElement.appendChild(maskElement);
    this.layerElement = maskElement;
    this.renderConfig = {
      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
      contentVisibility: config && config.contentVisibility || 'visible',
      progressiveLoad: config && config.progressiveLoad || false,
      hideOnTransparent: !(config && config.hideOnTransparent === false),
      viewBoxOnly: config && config.viewBoxOnly || false,
      viewBoxSize: config && config.viewBoxSize || false,
      className: config && config.className || '',
      id: config && config.id || '',
      focusable: config && config.focusable,
      filterSize: {
        width: config && config.filterSize && config.filterSize.width || '100%',
        height: config && config.filterSize && config.filterSize.height || '100%',
        x: config && config.filterSize && config.filterSize.x || '0%',
        y: config && config.filterSize && config.filterSize.y || '0%'
      },
      width: config && config.width,
      height: config && config.height,
      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
    };
    this.globalData = {
      _mdf: false,
      frameNum: -1,
      defs: defs,
      renderConfig: this.renderConfig
    };
    this.elements = [];
    this.pendingElements = [];
    this.destroyed = false;
    this.rendererType = 'svg';
  }

  extendPrototype([SVGRendererBase], SVGRenderer);

  SVGRenderer.prototype.createComp = function (data) {
    return new SVGCompElement(data, this.globalData, this);
  };

  registerRenderer('svg', SVGRenderer); // Registering shape modifiers

  ShapeModifiers.registerModifier('tm', TrimModifier);
  ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
  ShapeModifiers.registerModifier('rp', RepeaterModifier);
  ShapeModifiers.registerModifier('rd', RoundCornersModifier);
  ShapeModifiers.registerModifier('zz', ZigZagModifier);
  ShapeModifiers.registerModifier('op', OffsetPathModifier);

  return lottie;

}));
});

var react = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }


    if ((a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      for (i of a.entries())
        if (!equal(i[1], b.get(i[0]))) return false;
      return true;
    }

    if ((a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      return true;
    }

    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }


    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        continue;
      }

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

var rfdc_1 = rfdc;

function copyBuffer (cur) {
  if (cur instanceof Buffer) {
    return Buffer.from(cur)
  }

  return new cur.constructor(cur.buffer.slice(), cur.byteOffset, cur.length)
}

function rfdc (opts) {
  opts = opts || {};
  if (opts.circles) return rfdcCircles(opts)

  const constructorHandlers = new Map();
  constructorHandlers.set(Date, (o) => new Date(o));
  constructorHandlers.set(Map, (o, fn) => new Map(cloneArray(Array.from(o), fn)));
  constructorHandlers.set(Set, (o, fn) => new Set(cloneArray(Array.from(o), fn)));
  if (opts.constructorHandlers) {
    for (const handler of opts.constructorHandlers) {
      constructorHandlers.set(handler[0], handler[1]);
    }
  }

  let handler = null;

  return opts.proto ? cloneProto : clone

  function cloneArray (a, fn) {
    const keys = Object.keys(a);
    const a2 = new Array(keys.length);
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];
      const cur = a[k];
      if (typeof cur !== 'object' || cur === null) {
        a2[k] = cur;
      } else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) {
        a2[k] = handler(cur, fn);
      } else if (ArrayBuffer.isView(cur)) {
        a2[k] = copyBuffer(cur);
      } else {
        a2[k] = fn(cur);
      }
    }
    return a2
  }

  function clone (o) {
    if (typeof o !== 'object' || o === null) return o
    if (Array.isArray(o)) return cloneArray(o, clone)
    if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) {
      return handler(o, clone)
    }
    const o2 = {};
    for (const k in o) {
      if (Object.hasOwnProperty.call(o, k) === false) continue
      const cur = o[k];
      if (typeof cur !== 'object' || cur === null) {
        o2[k] = cur;
      } else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) {
        o2[k] = handler(cur, clone);
      } else if (ArrayBuffer.isView(cur)) {
        o2[k] = copyBuffer(cur);
      } else {
        o2[k] = clone(cur);
      }
    }
    return o2
  }

  function cloneProto (o) {
    if (typeof o !== 'object' || o === null) return o
    if (Array.isArray(o)) return cloneArray(o, cloneProto)
    if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) {
      return handler(o, cloneProto)
    }
    const o2 = {};
    for (const k in o) {
      const cur = o[k];
      if (typeof cur !== 'object' || cur === null) {
        o2[k] = cur;
      } else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) {
        o2[k] = handler(cur, cloneProto);
      } else if (ArrayBuffer.isView(cur)) {
        o2[k] = copyBuffer(cur);
      } else {
        o2[k] = cloneProto(cur);
      }
    }
    return o2
  }
}

function rfdcCircles (opts) {
  const refs = [];
  const refsNew = [];

  const constructorHandlers = new Map();
  constructorHandlers.set(Date, (o) => new Date(o));
  constructorHandlers.set(Map, (o, fn) => new Map(cloneArray(Array.from(o), fn)));
  constructorHandlers.set(Set, (o, fn) => new Set(cloneArray(Array.from(o), fn)));
  if (opts.constructorHandlers) {
    for (const handler of opts.constructorHandlers) {
      constructorHandlers.set(handler[0], handler[1]);
    }
  }

  let handler = null;
  return opts.proto ? cloneProto : clone

  function cloneArray (a, fn) {
    const keys = Object.keys(a);
    const a2 = new Array(keys.length);
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];
      const cur = a[k];
      if (typeof cur !== 'object' || cur === null) {
        a2[k] = cur;
      } else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) {
        a2[k] = handler(cur, fn);
      } else if (ArrayBuffer.isView(cur)) {
        a2[k] = copyBuffer(cur);
      } else {
        const index = refs.indexOf(cur);
        if (index !== -1) {
          a2[k] = refsNew[index];
        } else {
          a2[k] = fn(cur);
        }
      }
    }
    return a2
  }

  function clone (o) {
    if (typeof o !== 'object' || o === null) return o
    if (Array.isArray(o)) return cloneArray(o, clone)
    if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) {
      return handler(o, clone)
    }
    const o2 = {};
    refs.push(o);
    refsNew.push(o2);
    for (const k in o) {
      if (Object.hasOwnProperty.call(o, k) === false) continue
      const cur = o[k];
      if (typeof cur !== 'object' || cur === null) {
        o2[k] = cur;
      } else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) {
        o2[k] = handler(cur, clone);
      } else if (ArrayBuffer.isView(cur)) {
        o2[k] = copyBuffer(cur);
      } else {
        const i = refs.indexOf(cur);
        if (i !== -1) {
          o2[k] = refsNew[i];
        } else {
          o2[k] = clone(cur);
        }
      }
    }
    refs.pop();
    refsNew.pop();
    return o2
  }

  function cloneProto (o) {
    if (typeof o !== 'object' || o === null) return o
    if (Array.isArray(o)) return cloneArray(o, cloneProto)
    if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) {
      return handler(o, cloneProto)
    }
    const o2 = {};
    refs.push(o);
    refsNew.push(o2);
    for (const k in o) {
      const cur = o[k];
      if (typeof cur !== 'object' || cur === null) {
        o2[k] = cur;
      } else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) {
        o2[k] = handler(cur, cloneProto);
      } else if (ArrayBuffer.isView(cur)) {
        o2[k] = copyBuffer(cur);
      } else {
        const i = refs.indexOf(cur);
        if (i !== -1) {
          o2[k] = refsNew[i];
        } else {
          o2[k] = cloneProto(cur);
        }
      }
    }
    refs.pop();
    refsNew.pop();
    return o2
  }
}

var _default = rfdc_1();

function _interopDefault$1 (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var lottie = _interopDefault$1(lottie_light);

var React__default = _interopDefault$1(React);
var equal = _interopDefault$1(react);
var clone = _interopDefault$1(_default);

function _extends$u() {
  _extends$u = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$u.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var emptyObject = {};
var noOp = function noOp() {
  return undefined;
};
var makeLottiePlayer = function makeLottiePlayer(_ref) {
  var loadAnimation = _ref.loadAnimation;
  var Lottie = React.memo(React.forwardRef(function (params, forwardedRef) {
    var _params$play = params.play,
      play = _params$play === void 0 ? null : _params$play,
      _params$speed = params.speed,
      speed = _params$speed === void 0 ? 1 : _params$speed,
      _params$direction = params.direction,
      direction = _params$direction === void 0 ? 1 : _params$direction,
      _params$segments = params.segments,
      segmentsIn = _params$segments === void 0 ? null : _params$segments,
      _params$goTo = params.goTo,
      goTo = _params$goTo === void 0 ? null : _params$goTo,
      _params$useSubframes = params.useSubframes,
      useSubframes = _params$useSubframes === void 0 ? true : _params$useSubframes,
      _params$renderer = params.renderer,
      renderer = _params$renderer === void 0 ? 'svg' : _params$renderer,
      _params$loop = params.loop,
      loop = _params$loop === void 0 ? true : _params$loop,
      _params$rendererSetti = params.rendererSettings,
      rendererSettingsIn = _params$rendererSetti === void 0 ? emptyObject : _params$rendererSetti,
      audioFactory = params.audioFactory,
      _params$onLoad = params.onLoad,
      onLoad = _params$onLoad === void 0 ? noOp : _params$onLoad,
      _params$onComplete = params.onComplete,
      onComplete = _params$onComplete === void 0 ? noOp : _params$onComplete,
      _params$onLoopComplet = params.onLoopComplete,
      onLoopComplete = _params$onLoopComplet === void 0 ? noOp : _params$onLoopComplet,
      _params$onEnterFrame = params.onEnterFrame,
      onEnterFrame = _params$onEnterFrame === void 0 ? noOp : _params$onEnterFrame,
      _params$onSegmentStar = params.onSegmentStart,
      onSegmentStart = _params$onSegmentStar === void 0 ? noOp : _params$onSegmentStar,
      props = _objectWithoutPropertiesLoose(params, ["play", "speed", "direction", "segments", "goTo", "useSubframes", "renderer", "loop", "rendererSettings", "audioFactory", "onLoad", "onComplete", "onLoopComplete", "onEnterFrame", "onSegmentStart"]);
    var propsFiltered = props;
    var animationData;
    var path;
    if ('animationData' in props) {
      var _props = props;
      animationData = _props.animationData;
      propsFiltered = _objectWithoutPropertiesLoose(_props, ["animationData"]);
    }
    if ('path' in props) {
      var _props2 = props;
      path = _props2.path;
      propsFiltered = _objectWithoutPropertiesLoose(_props2, ["path"]);
    }
    var animElementRef = React.useRef(null);
    var animRef = React.useRef();
    var getAnim = React.useCallback(function () {
      if (animRef.current == null) throw new Error('Lottie ref is not set');
      return animRef.current;
    }, []);
    var _useState = React.useState(false),
      ready = _useState[0],
      setReady = _useState[1];
    var _useState2 = React.useState(segmentsIn),
      segments = _useState2[0],
      setSegments = _useState2[1];
    React.useEffect(function () {
      if (!equal(segments, segmentsIn)) setSegments(segmentsIn);
    }, [segmentsIn, segments]);
    var _useState3 = React.useState(rendererSettingsIn),
      rendererSettings = _useState3[0],
      setRendererSettings = _useState3[1];
    React.useEffect(function () {
      if (!equal(rendererSettings, rendererSettingsIn)) setRendererSettings(rendererSettingsIn);
    }, [rendererSettingsIn, rendererSettings]);
    React.useEffect(function () {
      return function () {
        return getAnim().removeEventListener('complete', onComplete);
      };
    }, [getAnim, onComplete]);
    React.useEffect(function () {
      return function () {
        return getAnim().removeEventListener('loopComplete', onLoopComplete);
      };
    }, [getAnim, onLoopComplete]);
    React.useEffect(function () {
      return function () {
        return getAnim().removeEventListener('enterFrame', onEnterFrame);
      };
    }, [getAnim, onEnterFrame]);
    React.useEffect(function () {
      return function () {
        return getAnim().removeEventListener('segmentStart', onSegmentStart);
      };
    }, [getAnim, onSegmentStart]);
    React.useEffect(function () {
      return function () {
        return getAnim().removeEventListener('DOMLoaded', onLoad);
      };
    }, [getAnim, onLoad]);
    var setLottieRefs = React.useCallback(function (newRef) {
      animRef.current = newRef;
      if (typeof forwardedRef === 'function') {
        forwardedRef(newRef);
      } else if (forwardedRef !== undefined && forwardedRef !== null) {
        forwardedRef.current = newRef;
      }
    }, [forwardedRef]);
    React.useEffect(function () {
      function parseAnimationData() {
        if (animationData == null || typeof animationData !== 'object') return animationData;
        if ('default' in animationData && typeof animationData["default"] === 'object') {
          return clone(animationData["default"]);
        }
        return clone(animationData);
      }
      if (animElementRef.current == null) throw new Error('animElementRef is not set');
      var lottie = loadAnimation(_extends$u({
        animationData: parseAnimationData(),
        path: path,
        container: animElementRef.current,
        renderer: renderer,
        loop: false,
        autoplay: false,
        rendererSettings: rendererSettings
      }, audioFactory ? {
        audioFactory: audioFactory
      } : {}));
      setLottieRefs(lottie);
      var onDomLoaded = function onDomLoaded() {
        return setReady(true);
      };
      getAnim().addEventListener('DOMLoaded', onDomLoaded);
      return function () {
        getAnim().removeEventListener('DOMLoaded', onDomLoaded);
        setReady(false);
        getAnim().destroy();
        setLottieRefs(undefined);
      };
    }, [loop, renderer, rendererSettings, animationData, path, audioFactory, setLottieRefs, getAnim]);
    React.useEffect(function () {
      getAnim().addEventListener('DOMLoaded', onLoad);
    }, [getAnim, onLoad]);
    React.useEffect(function () {
      getAnim().addEventListener('complete', onComplete);
    }, [getAnim, onComplete]);
    React.useEffect(function () {
      getAnim().addEventListener('loopComplete', onLoopComplete);
    }, [getAnim, onLoopComplete]);
    React.useEffect(function () {
      getAnim().addEventListener('enterFrame', onEnterFrame);
    }, [getAnim, onEnterFrame]);
    React.useEffect(function () {
      getAnim().addEventListener('segmentStart', onSegmentStart);
    }, [getAnim, onSegmentStart]);
    React.useEffect(function () {
      if (!ready) return;
      getAnim().loop = loop;
    }, [ready, loop, getAnim]);
    var wasPlayingSegmentsRef = React.useRef(false);
    React.useEffect(function () {
      if (!ready) return;
      function playReverse(lastFrame) {
        getAnim().goToAndPlay(lastFrame, true);
        getAnim().setDirection(direction);
      }
      if (play === true) {
        var force = true;
        if (segments) {
          getAnim().playSegments(segments, force);
          wasPlayingSegmentsRef.current = true;
          if (direction === -1) {
            var lastFrame = typeof segments[1] === 'number' ? segments[1] : segments[1][1];
            playReverse(lastFrame);
          }
        } else {
          if (wasPlayingSegmentsRef.current) getAnim().resetSegments(force);
          wasPlayingSegmentsRef.current = false;
          if (direction === -1) {
            var _lastFrame = getAnim().getDuration(true);
            playReverse(_lastFrame);
          } else {
            getAnim().play();
          }
        }
      } else if (play === false) {
        getAnim().pause();
      }
    }, [play, segments, ready, direction, getAnim]);
    React.useEffect(function () {
      if (!ready) return;
      if (Number.isNaN(speed)) return;
      getAnim().setSpeed(speed);
    }, [speed, ready, getAnim]);
    React.useEffect(function () {
      if (!ready) return;
      getAnim().setDirection(direction);
    }, [direction, getAnim, ready]);
    React.useEffect(function () {
      if (!ready) return;
      if (goTo == null) return;
      var isFrame = true;
      if (play) getAnim().goToAndPlay(goTo, isFrame);else getAnim().goToAndStop(goTo, isFrame);
    }, [getAnim, goTo, play, ready]);
    React.useEffect(function () {
      if (getAnim().setSubframe) getAnim().setSubframe(useSubframes);
    }, [getAnim, useSubframes]);
    return (
      /*#__PURE__*/
      React__default.createElement("div", _extends$u({}, propsFiltered, {
        ref: animElementRef
      }))
    );
  }));
  return Lottie;
};

var LottiePlayerLight = makeLottiePlayer(lottie);

var LottiePlayerLight_1 = LottiePlayerLight;

var v = "5.12.1";
var fr = 60;
var ip = 70;
var op = 202.5;
var w = 430;
var h = 430;
var nm = "wired-outline-243-glasses";
var ddd = 0;
var assets = [{
	id: "comp_0",
	nm: "in-reveal",
	fr: 60,
	layers: [{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Warstwa 2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [215, 215, 0],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [0, 0, 0],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [420, 420, 100],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [{
			ty: "gr",
			it: [{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 1,
					k: [{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 0,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[0.213, -0.157], [0.238, -0.157]],
							c: false
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 10,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[13.636, -0.158], [14.524, -0.158]],
							c: false
						}]
					}, {
						i: {
							x: 0.31,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 23,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[24.401, -0.167], [29.711, -0.173]],
							c: false
						}]
					}, {
						t: 60,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[38.555, 0.125], [42.555, 0.125]],
							c: false
						}]
					}],
					ix: 2
				},
				nm: "Path 4",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 1,
				ty: "sh",
				ix: 2,
				ks: {
					a: 1,
					k: [{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 0,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-0.003, -0.157], [0.023, -0.157]],
							c: false
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 10,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-14.884, -0.158], [-13.719, -0.158]],
							c: false
						}]
					}, {
						i: {
							x: 0.31,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 23,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-31.009, -0.113], [-24.152, -0.107]],
							c: false
						}]
					}, {
						t: 60,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-42.32, 0.125], [-38.32, 0.125]],
							c: false
						}]
					}],
					ix: 2
				},
				nm: "Path 5",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 2,
				ty: "sh",
				ix: 3,
				ks: {
					a: 1,
					k: [{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 0,
						s: [{
							i: [[-0.018, 0], [0.018, 0], [0.021, 0], [-0.018, 0]],
							o: [[-0.018, 0], [-0.018, 0], [0.021, 0], [0.018, 0]],
							v: [[0.087, -0.157], [0.055, -0.158], [0.023, -0.157], [0.055, -0.157]],
							c: true
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 10,
						s: [{
							i: [[0, 0], [0, 0], [5.717, 0], [0, 0]],
							o: [[0, 0], [0, 0], [5.717, 0], [0, 0]],
							v: [[-0.226, -0.127], [-0.226, -0.128], [-13.712, -0.157], [-0.226, -0.128]],
							c: true
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 18,
						s: [{
							i: [[0, -2.878], [4.017, 0], [6.727, 0], [-4.017, 0]],
							o: [[0, 2.538], [-4.017, 0], [6.727, 0], [4.017, 0]],
							v: [[-0.97, -0.157], [-6.576, 6.828], [-20.131, -0.157], [-6.576, -7.095]],
							c: true
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 23,
						s: [{
							i: [[0, -4.98], [6.258, 0], [7.358, 0], [-6.258, 0]],
							o: [[0, 4.782], [-6.258, 0], [7.358, 0], [6.258, 0]],
							v: [[-1.482, -0.199], [-10.075, 9.37], [-24.144, -0.157], [-10.075, -9.72]],
							c: true
						}]
					}, {
						i: {
							x: 0.31,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 31,
						s: [{
							i: [[0, -7.056], [7.422, 0], [2.738, 4.919], [-7.422, 0]],
							o: [[0, 6.506], [-7.422, 0], [2.619, -4.962], [7.422, 0]],
							v: [[-3.003, -0.206], [-16.442, 13.281], [-29.88, -0.157], [-16.442, -13.596]],
							c: true
						}]
					}, {
						t: 60,
						s: [{
							i: [[0, -9.122], [9.122, 0], [0, 9.122], [-9.122, 0]],
							o: [[0, 9.122], [-9.122, 0], [0, -9.122], [9.122, 0]],
							v: [[-5.224, -0.157], [-21.742, 16.36], [-38.259, -0.157], [-21.742, -16.675]],
							c: true
						}]
					}],
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 3,
				ty: "sh",
				ix: 4,
				ks: {
					a: 1,
					k: [{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 0,
						s: [{
							i: [[-0.014, 0], [0.018, 0], [0.015, 0], [-0.018, 0]],
							o: [[-0.014, 0], [-0.018, 0], [0.015, 0], [0.018, 0]],
							v: [[0.212, -0.157], [0.18, -0.158], [0.148, -0.157], [0.18, -0.157]],
							c: true
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 10,
						s: [{
							i: [[-3.897, 0], [-0.036, 0], [0, 0], [0.036, 0]],
							o: [[-3.805, 0], [0.036, 0], [0, 0], [-0.036, 0]],
							v: [[13.476, -0.157], [-0.262, -0.127], [-0.225, -0.127], [-0.262, -0.128]],
							c: true
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 18,
						s: [{
							i: [[-4.586, 0], [3.514, 0], [0, 3.074], [-3.514, 0]],
							o: [[-4.477, 0], [-3.514, 0], [0, -2.7], [3.514, 0]],
							v: [[20.065, -0.157], [6.312, 6.749], [0.928, -0.157], [6.312, -7.101]],
							c: true
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 23,
						s: [{
							i: [[-5.016, 0], [6.225, 0], [0, 4.529], [-6.225, 0]],
							o: [[-4.897, 0], [-6.225, 0], [0, -4.896], [6.225, 0]],
							v: [[24.183, -0.157], [10.531, 9.294], [1.64, -0.199], [10.531, -9.677]],
							c: true
						}]
					}, {
						i: {
							x: 0.31,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 31,
						s: [{
							i: [[-1.517, -5.676], [7.402, 0], [0, 6.694], [-7.402, 0]],
							o: [[-1.636, 4.919], [-7.402, 0], [0, -7.009], [7.402, 0]],
							v: [[30.089, -0.157], [16.685, 13.246], [3.282, -0.206], [16.685, -13.561]],
							c: true
						}]
					}, {
						t: 60,
						s: [{
							i: [[0, -9.122], [9.122, 0], [0, 9.122], [-9.122, 0]],
							o: [[0, 9.122], [-9.122, 0], [0, -9.122], [9.122, 0]],
							v: [[38.715, -0.157], [22.197, 16.36], [5.68, -0.157], [22.197, -16.675]],
							c: true
						}]
					}],
					ix: 2
				},
				nm: "Path 2",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 4,
				ty: "sh",
				ix: 5,
				ks: {
					a: 1,
					k: [{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 0,
						s: [{
							i: [[0, 0], [-0.013, 0], [-0.007, 0]],
							o: [[0.007, 0], [0.011, 0], [0, 0]],
							v: [[0.087, -0.157], [0.12, -0.157], [0.148, -0.157]],
							c: false
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 10,
						s: [{
							i: [[0, 0], [0, 0], [0, 0]],
							o: [[0, 0], [0, 0], [0, 0]],
							v: [[-0.226, -0.127], [-0.226, -0.127], [-0.225, -0.127]],
							c: false
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 18,
						s: [{
							i: [[-0.103, 0], [-0.379, 0], [-0.43, 0]],
							o: [[0.313, 0], [0.404, 0], [0, 0]],
							v: [[-0.951, -0.15], [-0.066, -0.152], [0.947, -0.15]],
							c: false
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 23,
						s: [{
							i: [[-0.075, 0.023], [-0.599, 0], [-0.455, -0.32]],
							o: [[0.385, -0.434], [0.553, 0], [0, 0]],
							v: [[-1.354, -0.899], [0.075, -1.616], [1.473, -1.096]],
							c: false
						}]
					}, {
						i: {
							x: 0.31,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 31,
						s: [{
							i: [[-0.081, 0.061], [-1.368, 0], [-0.81, -0.831]],
							o: [[0.769, -1.128], [1.174, 0], [0, 0]],
							v: [[-2.955, -2.098], [0.338, -3.959], [3.322, -2.609]],
							c: false
						}]
					}, {
						t: 60,
						s: [{
							i: [[-0.093, 0.107], [-2.601, 0], [-1.387, -1.454]],
							o: [[1.387, -1.974], [2.174, 0], [0, 0]],
							v: [[-5.572, -3.557], [0.71, -6.811], [6.245, -4.451]],
							c: false
						}]
					}],
					ix: 2
				},
				nm: "Path 3",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ty: "st",
				c: {
					a: 0,
					k: [0.875, 0.898, 0.929, 1],
					ix: 3,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('primary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 4
				},
				w: {
					a: 0,
					k: 2.8,
					ix: 5,
					x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-243-glasses').layer('control').effect('stroke')('Menu'));"
				},
				lc: 2,
				lj: 2,
				bm: 0,
				nm: ".primary",
				mn: "ADBE Vector Graphic - Stroke",
				hd: false,
				cl: "primary"
			}, {
				ty: "tr",
				p: {
					a: 0,
					k: [0, 0],
					ix: 2
				},
				a: {
					a: 0,
					k: [0, 0],
					ix: 1
				},
				s: {
					a: 0,
					k: [100, 100],
					ix: 3
				},
				r: {
					a: 0,
					k: 0,
					ix: 6
				},
				o: {
					a: 0,
					k: 100,
					ix: 7
				},
				sk: {
					a: 0,
					k: 0,
					ix: 4
				},
				sa: {
					a: 0,
					k: 0,
					ix: 5
				},
				nm: "Transform"
			}],
			nm: "Group 1",
			np: 6,
			cix: 2,
			bm: 0,
			ix: 1,
			mn: "ADBE Vector Group",
			hd: false
		}],
		ip: 1,
		op: 300,
		st: 0,
		ct: 1,
		bm: 0
	}]
}, {
	id: "comp_1",
	nm: "hover-searching",
	fr: 60,
	layers: [{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Shape Layer 2",
		parent: 3,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [22.197, -0.157, 0],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [-9.5, -0.125, 0],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [100, 100, 100],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [{
			ty: "gr",
			it: [{
				ty: "rc",
				d: 1,
				s: {
					a: 1,
					k: [{
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 0,
						s: [4, 0]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 9,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 14,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 50,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 52.5,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 53,
						s: [4, 2]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 60,
						s: [4, 2]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 62.5,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 65,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 102.5,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 105,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 107.5,
						s: [4, 2]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 112.5,
						s: [4, 2]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 115,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 117.5,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 122.5,
						s: [4, 10]
					}, {
						t: 127.5,
						s: [4, 0]
					}],
					ix: 2
				},
				p: {
					a: 0,
					k: [0, 0],
					ix: 3
				},
				r: {
					a: 0,
					k: 20,
					ix: 4
				},
				nm: "Rectangle Path 1",
				mn: "ADBE Vector Shape - Rect",
				hd: false
			}, {
				ty: "st",
				c: {
					a: 0,
					k: [0.875, 0.898, 0.929, 1],
					ix: 3,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('primary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 4
				},
				w: {
					a: 0,
					k: 0,
					ix: 5,
					x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-243-glasses').layer('control').effect('stroke')('Menu'));"
				},
				lc: 1,
				lj: 1,
				ml: 4,
				bm: 0,
				nm: ".primary",
				mn: "ADBE Vector Graphic - Stroke",
				hd: false,
				cl: "primary"
			}, {
				ty: "fl",
				c: {
					a: 0,
					k: [0.749, 0.788, 0.851, 1],
					ix: 4,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('secondary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: ".secondary",
				mn: "ADBE Vector Graphic - Fill",
				hd: false,
				cl: "secondary"
			}, {
				ty: "tr",
				p: {
					a: 0,
					k: [-9.5, -0.125],
					ix: 2
				},
				a: {
					a: 0,
					k: [0, 0],
					ix: 1
				},
				s: {
					a: 0,
					k: [100, 100],
					ix: 3
				},
				r: {
					a: 0,
					k: 0,
					ix: 6
				},
				o: {
					a: 0,
					k: 100,
					ix: 7
				},
				sk: {
					a: 0,
					k: 0,
					ix: 4
				},
				sa: {
					a: 0,
					k: 0,
					ix: 5
				},
				nm: "Transform"
			}],
			nm: "Rectangle 1",
			np: 3,
			cix: 2,
			bm: 0,
			ix: 1,
			mn: "ADBE Vector Group",
			hd: false
		}],
		ip: 0,
		op: 300,
		st: 0,
		ct: 1,
		bm: 0
	}, {
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "Shape Layer 1",
		parent: 3,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [-21.742, -0.157, 0],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [-9.5, -0.125, 0],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [100, 100, 100],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [{
			ty: "gr",
			it: [{
				ty: "rc",
				d: 1,
				s: {
					a: 1,
					k: [{
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 0,
						s: [4, 0]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 9,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 14,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 50,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 52.5,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 55,
						s: [4, 2]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 60,
						s: [4, 2]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 62.5,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 65,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 102.5,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 105,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 107.5,
						s: [4, 2]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 112.5,
						s: [4, 2]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 115,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 117.5,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 122.5,
						s: [4, 10]
					}, {
						t: 127.5,
						s: [4, 0]
					}],
					ix: 2
				},
				p: {
					a: 0,
					k: [0, 0],
					ix: 3
				},
				r: {
					a: 0,
					k: 20,
					ix: 4
				},
				nm: "Rectangle Path 1",
				mn: "ADBE Vector Shape - Rect",
				hd: false
			}, {
				ty: "st",
				c: {
					a: 0,
					k: [0.875, 0.898, 0.929, 1],
					ix: 3,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('primary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 4
				},
				w: {
					a: 0,
					k: 0,
					ix: 5,
					x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-243-glasses').layer('control').effect('stroke')('Menu'));"
				},
				lc: 1,
				lj: 1,
				ml: 4,
				bm: 0,
				nm: ".primary",
				mn: "ADBE Vector Graphic - Stroke",
				hd: false,
				cl: "primary"
			}, {
				ty: "fl",
				c: {
					a: 0,
					k: [0.749, 0.788, 0.851, 1],
					ix: 4,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('secondary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: ".secondary",
				mn: "ADBE Vector Graphic - Fill",
				hd: false,
				cl: "secondary"
			}, {
				ty: "tr",
				p: {
					a: 0,
					k: [-9.5, -0.125],
					ix: 2
				},
				a: {
					a: 0,
					k: [0, 0],
					ix: 1
				},
				s: {
					a: 0,
					k: [100, 100],
					ix: 3
				},
				r: {
					a: 0,
					k: 0,
					ix: 6
				},
				o: {
					a: 0,
					k: 100,
					ix: 7
				},
				sk: {
					a: 0,
					k: 0,
					ix: 4
				},
				sa: {
					a: 0,
					k: 0,
					ix: 5
				},
				nm: "Transform"
			}],
			nm: "Rectangle 1",
			np: 3,
			cix: 2,
			bm: 0,
			ix: 1,
			mn: "ADBE Vector Group",
			hd: false
		}],
		ip: 0,
		op: 300,
		st: 0,
		ct: 1,
		bm: 0
	}, {
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "Warstwa 3",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [{
					i: {
						x: 0.33,
						y: 1
					},
					o: {
						x: 0.333,
						y: 0
					},
					t: 0,
					s: [215, 215, 0],
					to: [-0.262, -14.788, 0],
					ti: [4.856, 5.075, 0]
				}, {
					i: {
						x: 0.667,
						y: 1
					},
					o: {
						x: 0.333,
						y: 0
					},
					t: 9,
					s: [207.387, 191.113, 0],
					to: [8.006, 7, 0],
					ti: [-8.81, -3.981, 0]
				}, {
					i: {
						x: 0.31,
						y: 0.31
					},
					o: {
						x: 0.333,
						y: 0.333
					},
					t: 21,
					s: [260.25, 215, 0],
					to: [0, 0, 0],
					ti: [0, 0, 0]
				}, {
					i: {
						x: 0.31,
						y: 1
					},
					o: {
						x: 0.69,
						y: 0
					},
					t: 47,
					s: [260.25, 215, 0],
					to: [-15.767, 0.962, 0],
					ti: [15.767, -0.968, 0]
				}, {
					t: 72.5,
					s: [165.65, 220.775, 0],
					h: 1
				}, {
					i: {
						x: 0.343,
						y: 1
					},
					o: {
						x: 0.333,
						y: 0
					},
					t: 95,
					s: [165.65, 220.806, 0],
					to: [35.6, -1.694, 0],
					ti: [-0.131, 13.738, 0]
				}, {
					i: {
						x: 0.667,
						y: 1
					},
					o: {
						x: 0.333,
						y: 0
					},
					t: 115,
					s: [215, 191.113, 0],
					to: [0.131, 8.575, 0],
					ti: [0.224, -2.891, 0]
				}, {
					i: {
						x: 0.667,
						y: 1
					},
					o: {
						x: 0.333,
						y: 0
					},
					t: 122.5,
					s: [215, 222.875, 0],
					to: [-0.748, -4.374, 0],
					ti: [0, 0.438, 0]
				}, {
					t: 132.5,
					s: [215, 215, 0]
				}],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [0, 0, 0],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [420, 420, 100],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [{
			ty: "gr",
			it: [{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 1,
					k: [{
						i: {
							x: 0.33,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 0,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[38.555, 0.125], [42.555, 0.125]],
							c: false
						}]
					}, {
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 9,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[38.555, 0.125], [44.18, 5.625]],
							c: false
						}]
					}, {
						i: {
							x: 0.31,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 21,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[38.555, 0.125], [31.305, -0.125]],
							c: false
						}]
					}, {
						i: {
							x: 0.31,
							y: 1
						},
						o: {
							x: 0.69,
							y: 0
						},
						t: 47,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[38.555, 0.125], [31.305, -0.125]],
							c: false
						}]
					}, {
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.69,
							y: 0
						},
						t: 72.5,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[38.555, 0.125], [54.18, -1.5]],
							c: false
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 95,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[38.555, 0.125], [54.18, -1.5]],
							c: false
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 98,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[38.555, 0.125], [52.937, -1.012]],
							c: false
						}]
					}, {
						i: {
							x: 0.343,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 104,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[38.555, 0.125], [45.456, 1.805]],
							c: false
						}]
					}, {
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 115,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[38.555, 0.125], [42.43, 5.625]],
							c: false
						}]
					}, {
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 122.5,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[38.555, 0.125], [42.485, -1.875]],
							c: false
						}]
					}, {
						t: 132.5,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[38.555, 0.125], [42.555, 0.125]],
							c: false
						}]
					}],
					ix: 2
				},
				nm: "Path 4",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 1,
				ty: "sh",
				ix: 2,
				ks: {
					a: 1,
					k: [{
						i: {
							x: 0.33,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 0,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-42.32, 0.125], [-38.32, 0.125]],
							c: false
						}]
					}, {
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 9,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-40.32, 5.625], [-38.32, 0.125]],
							c: false
						}]
					}, {
						i: {
							x: 0.31,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 21,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-53.32, 0.125], [-38.32, 0.125]],
							c: false
						}]
					}, {
						i: {
							x: 0.31,
							y: 1
						},
						o: {
							x: 0.69,
							y: 0
						},
						t: 47,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-53.32, 0.125], [-38.32, 0.125]],
							c: false
						}]
					}, {
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.69,
							y: 0
						},
						t: 72.5,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-30.82, -1.25], [-38.32, 0.125]],
							c: false
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 95,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-30.82, -1.25], [-38.32, 0.125]],
							c: false
						}]
					}, {
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 98,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-32.019, -0.806], [-38.32, 0.125]],
							c: false
						}]
					}, {
						i: {
							x: 0.343,
							y: 1
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 104,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-39.307, 1.819], [-38.32, 0.125]],
							c: false
						}]
					}, {
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 115,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-42.195, 5.5], [-38.32, 0.125]],
							c: false
						}]
					}, {
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 122.5,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-42.14, -2], [-38.32, 0.125]],
							c: false
						}]
					}, {
						t: 132.5,
						s: [{
							i: [[0, 0], [0, 0]],
							o: [[0, 0], [0, 0]],
							v: [[-42.32, 0.125], [-38.32, 0.125]],
							c: false
						}]
					}],
					ix: 2
				},
				nm: "Path 5",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 2,
				ty: "sh",
				ix: 3,
				ks: {
					a: 0,
					k: {
						i: [[0, -9.122], [9.122, 0], [0, 9.122], [-9.122, 0]],
						o: [[0, 9.122], [-9.122, 0], [0, -9.122], [9.122, 0]],
						v: [[-5.224, -0.157], [-21.742, 16.36], [-38.259, -0.157], [-21.742, -16.675]],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 3,
				ty: "sh",
				ix: 4,
				ks: {
					a: 0,
					k: {
						i: [[0, -9.122], [9.122, 0], [0, 9.122], [-9.122, 0]],
						o: [[0, 9.122], [-9.122, 0], [0, -9.122], [9.122, 0]],
						v: [[38.715, -0.157], [22.197, 16.36], [5.68, -0.157], [22.197, -16.675]],
						c: true
					},
					ix: 2
				},
				nm: "Path 2",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 4,
				ty: "sh",
				ix: 5,
				ks: {
					a: 0,
					k: {
						i: [[-0.093, 0.107], [-2.601, 0], [-1.387, -1.454]],
						o: [[1.387, -1.974], [2.174, 0], [0, 0]],
						v: [[-5.572, -3.557], [0.71, -6.811], [6.245, -4.451]],
						c: false
					},
					ix: 2
				},
				nm: "Path 3",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ty: "st",
				c: {
					a: 0,
					k: [0.875, 0.898, 0.929, 1],
					ix: 3,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('primary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 4
				},
				w: {
					a: 0,
					k: 2.8,
					ix: 5,
					x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-243-glasses').layer('control').effect('stroke')('Menu'));"
				},
				lc: 2,
				lj: 2,
				bm: 0,
				nm: ".primary",
				mn: "ADBE Vector Graphic - Stroke",
				hd: false,
				cl: "primary"
			}, {
				ty: "tr",
				p: {
					a: 0,
					k: [0, 0],
					ix: 2
				},
				a: {
					a: 0,
					k: [0, 0],
					ix: 1
				},
				s: {
					a: 0,
					k: [100, 100],
					ix: 3
				},
				r: {
					a: 0,
					k: 0,
					ix: 6
				},
				o: {
					a: 0,
					k: 100,
					ix: 7
				},
				sk: {
					a: 0,
					k: 0,
					ix: 4
				},
				sa: {
					a: 0,
					k: 0,
					ix: 5
				},
				nm: "Transform"
			}],
			nm: "Group 1",
			np: 6,
			cix: 2,
			bm: 0,
			ix: 1,
			mn: "ADBE Vector Group",
			hd: false
		}],
		ip: 0,
		op: 300,
		st: 0,
		ct: 1,
		bm: 0
	}]
}, {
	id: "comp_2",
	nm: "morph-eyes",
	fr: 60,
	layers: [{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Shape Layer 2",
		parent: 3,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [22.197, -0.157, 0],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [-9.5, -0.125, 0],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [100, 100, 100],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [{
			ty: "gr",
			it: [{
				ty: "rc",
				d: 1,
				s: {
					a: 1,
					k: [{
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 7.5,
						s: [4, 0]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 12.5,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 17.5,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 52.5,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 55,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 57.5,
						s: [4, 2]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 67.5,
						s: [4, 2]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 70,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 72.5,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 110,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 115,
						s: [4, 10]
					}, {
						t: 120,
						s: [4, 0]
					}],
					ix: 2
				},
				p: {
					a: 0,
					k: [0, 0],
					ix: 3
				},
				r: {
					a: 0,
					k: 20,
					ix: 4
				},
				nm: "Rectangle Path 1",
				mn: "ADBE Vector Shape - Rect",
				hd: false
			}, {
				ty: "st",
				c: {
					a: 0,
					k: [0.875, 0.898, 0.929, 1],
					ix: 3,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('primary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 4
				},
				w: {
					a: 0,
					k: 0,
					ix: 5,
					x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-243-glasses').layer('control').effect('stroke')('Menu'));"
				},
				lc: 1,
				lj: 1,
				ml: 4,
				bm: 0,
				nm: ".primary",
				mn: "ADBE Vector Graphic - Stroke",
				hd: false,
				cl: "primary"
			}, {
				ty: "fl",
				c: {
					a: 0,
					k: [0.749, 0.788, 0.851, 1],
					ix: 4,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('secondary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: ".secondary",
				mn: "ADBE Vector Graphic - Fill",
				hd: false,
				cl: "secondary"
			}, {
				ty: "tr",
				p: {
					a: 0,
					k: [-9.5, -0.125],
					ix: 2
				},
				a: {
					a: 0,
					k: [0, 0],
					ix: 1
				},
				s: {
					a: 0,
					k: [100, 100],
					ix: 3
				},
				r: {
					a: 0,
					k: 0,
					ix: 6
				},
				o: {
					a: 0,
					k: 100,
					ix: 7
				},
				sk: {
					a: 0,
					k: 0,
					ix: 4
				},
				sa: {
					a: 0,
					k: 0,
					ix: 5
				},
				nm: "Transform"
			}],
			nm: "Rectangle 1",
			np: 3,
			cix: 2,
			bm: 0,
			ix: 1,
			mn: "ADBE Vector Group",
			hd: false
		}],
		ip: 0,
		op: 300,
		st: 0,
		ct: 1,
		bm: 0
	}, {
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "Shape Layer 1",
		parent: 3,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [-21.742, -0.157, 0],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [-9.5, -0.125, 0],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [100, 100, 100],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [{
			ty: "gr",
			it: [{
				ty: "rc",
				d: 1,
				s: {
					a: 1,
					k: [{
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 7.5,
						s: [4, 0]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 12.5,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 17.5,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 110,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 115,
						s: [4, 10]
					}, {
						t: 120,
						s: [4, 0]
					}],
					ix: 2
				},
				p: {
					a: 0,
					k: [0, 0],
					ix: 3
				},
				r: {
					a: 0,
					k: 20,
					ix: 4
				},
				nm: "Rectangle Path 1",
				mn: "ADBE Vector Shape - Rect",
				hd: false
			}, {
				ty: "st",
				c: {
					a: 0,
					k: [0.875, 0.898, 0.929, 1],
					ix: 3,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('primary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 4
				},
				w: {
					a: 0,
					k: 0,
					ix: 5,
					x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-243-glasses').layer('control').effect('stroke')('Menu'));"
				},
				lc: 1,
				lj: 1,
				ml: 4,
				bm: 0,
				nm: ".primary",
				mn: "ADBE Vector Graphic - Stroke",
				hd: false,
				cl: "primary"
			}, {
				ty: "fl",
				c: {
					a: 0,
					k: [0.749, 0.788, 0.851, 1],
					ix: 4,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('secondary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: ".secondary",
				mn: "ADBE Vector Graphic - Fill",
				hd: false,
				cl: "secondary"
			}, {
				ty: "tr",
				p: {
					a: 0,
					k: [-9.5, -0.125],
					ix: 2
				},
				a: {
					a: 0,
					k: [0, 0],
					ix: 1
				},
				s: {
					a: 0,
					k: [100, 100],
					ix: 3
				},
				r: {
					a: 0,
					k: 0,
					ix: 6
				},
				o: {
					a: 0,
					k: 100,
					ix: 7
				},
				sk: {
					a: 0,
					k: 0,
					ix: 4
				},
				sa: {
					a: 0,
					k: 0,
					ix: 5
				},
				nm: "Transform"
			}],
			nm: "Rectangle 1",
			np: 3,
			cix: 2,
			bm: 0,
			ix: 1,
			mn: "ADBE Vector Group",
			hd: false
		}],
		ip: 0,
		op: 300,
		st: 0,
		ct: 1,
		bm: 0
	}, {
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "Warstwa 2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [{
					i: {
						x: [0.833],
						y: [0.833]
					},
					o: {
						x: [0.167],
						y: [0.167]
					},
					t: 47.5,
					s: [0]
				}, {
					i: {
						x: [0.833],
						y: [0.833]
					},
					o: {
						x: [0.167],
						y: [0.167]
					},
					t: 50,
					s: [-2]
				}, {
					i: {
						x: [0.833],
						y: [0.833]
					},
					o: {
						x: [0.167],
						y: [0.167]
					},
					t: 57.5,
					s: [4]
				}, {
					i: {
						x: [0.833],
						y: [0.833]
					},
					o: {
						x: [0.167],
						y: [0.167]
					},
					t: 67.5,
					s: [4]
				}, {
					i: {
						x: [0.833],
						y: [0.833]
					},
					o: {
						x: [0.167],
						y: [0.167]
					},
					t: 75,
					s: [-2]
				}, {
					t: 77.5,
					s: [0]
				}],
				ix: 10
			},
			p: {
				a: 1,
				k: [{
					i: {
						x: 0.667,
						y: 1
					},
					o: {
						x: 0.167,
						y: 0.167
					},
					t: 0,
					s: [215, 215, 0],
					to: [0, -3.5, 0],
					ti: [0, -1.75, 0]
				}, {
					i: {
						x: 0.667,
						y: 1
					},
					o: {
						x: 0.333,
						y: 0
					},
					t: 5,
					s: [215, 194, 0],
					to: [0, 1.75, 0],
					ti: [0, -2.625, 0]
				}, {
					i: {
						x: 0.667,
						y: 1
					},
					o: {
						x: 0.333,
						y: 0
					},
					t: 15,
					s: [215, 225.5, 0],
					to: [0, 2.625, 0],
					ti: [0, 1.75, 0]
				}, {
					i: {
						x: 0.667,
						y: 1
					},
					o: {
						x: 0.333,
						y: 0
					},
					t: 22.5,
					s: [215, 209.75, 0],
					to: [0, -1.75, 0],
					ti: [0, -0.875, 0]
				}, {
					i: {
						x: 0.833,
						y: 0.833
					},
					o: {
						x: 0.333,
						y: 0.333
					},
					t: 27.5,
					s: [215, 215, 0],
					to: [0, 0, 0],
					ti: [0, 0, 0]
				}, {
					i: {
						x: 0.667,
						y: 1
					},
					o: {
						x: 0.167,
						y: 0.167
					},
					t: 102.5,
					s: [215, 215, 0],
					to: [0, 1.75, 0],
					ti: [0, 0.875, 0]
				}, {
					i: {
						x: 0.667,
						y: 1
					},
					o: {
						x: 0.333,
						y: 0
					},
					t: 107.5,
					s: [215, 225.5, 0],
					to: [0, -0.875, 0],
					ti: [0, 1.75, 0]
				}, {
					i: {
						x: 0.667,
						y: 1
					},
					o: {
						x: 0.333,
						y: 0
					},
					t: 115,
					s: [215, 209.75, 0],
					to: [0, -1.75, 0],
					ti: [0, -0.875, 0]
				}, {
					t: 120,
					s: [215, 215, 0]
				}],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [0, 0, 0],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [420, 420, 100],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [{
			ty: "gr",
			it: [{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 0,
					k: {
						i: [[0, 0], [0, 0]],
						o: [[0, 0], [0, 0]],
						v: [[38.555, 0.125], [42.555, 0.125]],
						c: false
					},
					ix: 2
				},
				nm: "Path 4",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 1,
				ty: "sh",
				ix: 2,
				ks: {
					a: 0,
					k: {
						i: [[0, 0], [0, 0]],
						o: [[0, 0], [0, 0]],
						v: [[-42.32, 0.125], [-38.32, 0.125]],
						c: false
					},
					ix: 2
				},
				nm: "Path 5",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 2,
				ty: "sh",
				ix: 3,
				ks: {
					a: 0,
					k: {
						i: [[0, -9.122], [9.122, 0], [0, 9.122], [-9.122, 0]],
						o: [[0, 9.122], [-9.122, 0], [0, -9.122], [9.122, 0]],
						v: [[-5.224, -0.157], [-21.742, 16.36], [-38.259, -0.157], [-21.742, -16.675]],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 3,
				ty: "sh",
				ix: 4,
				ks: {
					a: 0,
					k: {
						i: [[0, -9.122], [9.122, 0], [0, 9.122], [-9.122, 0]],
						o: [[0, 9.122], [-9.122, 0], [0, -9.122], [9.122, 0]],
						v: [[38.715, -0.157], [22.197, 16.36], [5.68, -0.157], [22.197, -16.675]],
						c: true
					},
					ix: 2
				},
				nm: "Path 2",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 4,
				ty: "sh",
				ix: 5,
				ks: {
					a: 0,
					k: {
						i: [[-0.093, 0.107], [-2.601, 0], [-1.387, -1.454]],
						o: [[1.387, -1.974], [2.174, 0], [0, 0]],
						v: [[-5.572, -3.557], [0.71, -6.811], [6.245, -4.451]],
						c: false
					},
					ix: 2
				},
				nm: "Path 3",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ty: "st",
				c: {
					a: 0,
					k: [0.875, 0.898, 0.929, 1],
					ix: 3,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('primary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 4
				},
				w: {
					a: 0,
					k: 2.8,
					ix: 5,
					x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-243-glasses').layer('control').effect('stroke')('Menu'));"
				},
				lc: 2,
				lj: 2,
				bm: 0,
				nm: ".primary",
				mn: "ADBE Vector Graphic - Stroke",
				hd: false,
				cl: "primary"
			}, {
				ty: "tr",
				p: {
					a: 0,
					k: [0, 0],
					ix: 2
				},
				a: {
					a: 0,
					k: [0, 0],
					ix: 1
				},
				s: {
					a: 0,
					k: [100, 100],
					ix: 3
				},
				r: {
					a: 0,
					k: 0,
					ix: 6
				},
				o: {
					a: 0,
					k: 100,
					ix: 7
				},
				sk: {
					a: 0,
					k: 0,
					ix: 4
				},
				sa: {
					a: 0,
					k: 0,
					ix: 5
				},
				nm: "Transform"
			}],
			nm: "Group 1",
			np: 6,
			cix: 2,
			bm: 0,
			ix: 1,
			mn: "ADBE Vector Group",
			hd: false
		}],
		ip: 0,
		op: 300,
		st: 0,
		ct: 1,
		bm: 0
	}]
}, {
	id: "comp_3",
	nm: "hover-blink",
	fr: 60,
	layers: [{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Shape Layer 2",
		parent: 3,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [22.197, -0.157, 0],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [-9.5, -0.125, 0],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [100, 100, 100],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [{
			ty: "gr",
			it: [{
				ty: "rc",
				d: 1,
				s: {
					a: 1,
					k: [{
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 5,
						s: [4, 9]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 7.5,
						s: [4, 10]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 10,
						s: [4, 2]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 20,
						s: [4, 2]
					}, {
						i: {
							x: [0.833, 0.833],
							y: [0.833, 0.833]
						},
						o: {
							x: [0.167, 0.167],
							y: [0.167, 0.167]
						},
						t: 22.5,
						s: [4, 10]
					}, {
						t: 25,
						s: [4, 9]
					}],
					ix: 2
				},
				p: {
					a: 0,
					k: [0, 0],
					ix: 3
				},
				r: {
					a: 0,
					k: 20,
					ix: 4
				},
				nm: "Rectangle Path 1",
				mn: "ADBE Vector Shape - Rect",
				hd: false
			}, {
				ty: "st",
				c: {
					a: 0,
					k: [0.875, 0.898, 0.929, 1],
					ix: 3,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('primary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 4
				},
				w: {
					a: 0,
					k: 0,
					ix: 5,
					x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-243-glasses').layer('control').effect('stroke')('Menu'));"
				},
				lc: 1,
				lj: 1,
				ml: 4,
				bm: 0,
				nm: ".primary",
				mn: "ADBE Vector Graphic - Stroke",
				hd: false,
				cl: "primary"
			}, {
				ty: "fl",
				c: {
					a: 0,
					k: [0.749, 0.788, 0.851, 1],
					ix: 4,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('secondary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: ".secondary",
				mn: "ADBE Vector Graphic - Fill",
				hd: false,
				cl: "secondary"
			}, {
				ty: "tr",
				p: {
					a: 0,
					k: [-9.5, -0.125],
					ix: 2
				},
				a: {
					a: 0,
					k: [0, 0],
					ix: 1
				},
				s: {
					a: 0,
					k: [100, 100],
					ix: 3
				},
				r: {
					a: 0,
					k: 0,
					ix: 6
				},
				o: {
					a: 0,
					k: 100,
					ix: 7
				},
				sk: {
					a: 0,
					k: 0,
					ix: 4
				},
				sa: {
					a: 0,
					k: 0,
					ix: 5
				},
				nm: "Transform"
			}],
			nm: "Rectangle 1",
			np: 3,
			cix: 2,
			bm: 0,
			ix: 1,
			mn: "ADBE Vector Group",
			hd: false
		}],
		ip: 0,
		op: 300,
		st: 0,
		ct: 1,
		bm: 0
	}, {
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "Shape Layer 1",
		parent: 3,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [-21.742, -0.157, 0],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [-9.5, -0.125, 0],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [100, 100, 100],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [{
			ty: "gr",
			it: [{
				ty: "rc",
				d: 1,
				s: {
					a: 0,
					k: [4, 9],
					ix: 2
				},
				p: {
					a: 0,
					k: [0, 0],
					ix: 3
				},
				r: {
					a: 0,
					k: 20,
					ix: 4
				},
				nm: "Rectangle Path 1",
				mn: "ADBE Vector Shape - Rect",
				hd: false
			}, {
				ty: "st",
				c: {
					a: 0,
					k: [0.875, 0.898, 0.929, 1],
					ix: 3,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('primary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 4
				},
				w: {
					a: 0,
					k: 0,
					ix: 5,
					x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-243-glasses').layer('control').effect('stroke')('Menu'));"
				},
				lc: 1,
				lj: 1,
				ml: 4,
				bm: 0,
				nm: ".primary",
				mn: "ADBE Vector Graphic - Stroke",
				hd: false,
				cl: "primary"
			}, {
				ty: "fl",
				c: {
					a: 0,
					k: [0.749, 0.788, 0.851, 1],
					ix: 4,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('secondary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 5
				},
				r: 1,
				bm: 0,
				nm: ".secondary",
				mn: "ADBE Vector Graphic - Fill",
				hd: false,
				cl: "secondary"
			}, {
				ty: "tr",
				p: {
					a: 0,
					k: [-9.5, -0.125],
					ix: 2
				},
				a: {
					a: 0,
					k: [0, 0],
					ix: 1
				},
				s: {
					a: 0,
					k: [100, 100],
					ix: 3
				},
				r: {
					a: 0,
					k: 0,
					ix: 6
				},
				o: {
					a: 0,
					k: 100,
					ix: 7
				},
				sk: {
					a: 0,
					k: 0,
					ix: 4
				},
				sa: {
					a: 0,
					k: 0,
					ix: 5
				},
				nm: "Transform"
			}],
			nm: "Rectangle 1",
			np: 3,
			cix: 2,
			bm: 0,
			ix: 1,
			mn: "ADBE Vector Group",
			hd: false
		}],
		ip: 0,
		op: 300,
		st: 0,
		ct: 1,
		bm: 0
	}, {
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "Warstwa 2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [{
					i: {
						x: [0.833],
						y: [0.833]
					},
					o: {
						x: [0.167],
						y: [0.167]
					},
					t: 0,
					s: [0]
				}, {
					i: {
						x: [0.833],
						y: [0.833]
					},
					o: {
						x: [0.167],
						y: [0.167]
					},
					t: 2.5,
					s: [-2]
				}, {
					i: {
						x: [0.667],
						y: [1]
					},
					o: {
						x: [0.167],
						y: [0]
					},
					t: 10,
					s: [4]
				}, {
					i: {
						x: [0.667],
						y: [1]
					},
					o: {
						x: [0.333],
						y: [0]
					},
					t: 20,
					s: [4]
				}, {
					t: 30,
					s: [0]
				}],
				ix: 10
			},
			p: {
				a: 0,
				k: [215, 215, 0],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [0, 0, 0],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [420, 420, 100],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [{
			ty: "gr",
			it: [{
				ind: 0,
				ty: "sh",
				ix: 1,
				ks: {
					a: 0,
					k: {
						i: [[0, 0], [0, 0]],
						o: [[0, 0], [0, 0]],
						v: [[38.555, 0.125], [42.555, 0.125]],
						c: false
					},
					ix: 2
				},
				nm: "Path 4",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 1,
				ty: "sh",
				ix: 2,
				ks: {
					a: 0,
					k: {
						i: [[0, 0], [0, 0]],
						o: [[0, 0], [0, 0]],
						v: [[-42.32, 0.125], [-38.32, 0.125]],
						c: false
					},
					ix: 2
				},
				nm: "Path 5",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 2,
				ty: "sh",
				ix: 3,
				ks: {
					a: 0,
					k: {
						i: [[0, -9.122], [9.122, 0], [0, 9.122], [-9.122, 0]],
						o: [[0, 9.122], [-9.122, 0], [0, -9.122], [9.122, 0]],
						v: [[-5.224, -0.157], [-21.742, 16.36], [-38.259, -0.157], [-21.742, -16.675]],
						c: true
					},
					ix: 2
				},
				nm: "Path 1",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 3,
				ty: "sh",
				ix: 4,
				ks: {
					a: 0,
					k: {
						i: [[0, -9.122], [9.122, 0], [0, 9.122], [-9.122, 0]],
						o: [[0, 9.122], [-9.122, 0], [0, -9.122], [9.122, 0]],
						v: [[38.715, -0.157], [22.197, 16.36], [5.68, -0.157], [22.197, -16.675]],
						c: true
					},
					ix: 2
				},
				nm: "Path 2",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ind: 4,
				ty: "sh",
				ix: 5,
				ks: {
					a: 0,
					k: {
						i: [[-0.093, 0.107], [-2.601, 0], [-1.387, -1.454]],
						o: [[1.387, -1.974], [2.174, 0], [0, 0]],
						v: [[-5.572, -3.557], [0.71, -6.811], [6.245, -4.451]],
						c: false
					},
					ix: 2
				},
				nm: "Path 3",
				mn: "ADBE Vector Shape - Group",
				hd: false
			}, {
				ty: "st",
				c: {
					a: 0,
					k: [0.875, 0.898, 0.929, 1],
					ix: 3,
					x: "var $bm_rt;\n$bm_rt = comp('wired-outline-243-glasses').layer('control').effect('primary')('Color');"
				},
				o: {
					a: 0,
					k: 100,
					ix: 4
				},
				w: {
					a: 0,
					k: 2.8,
					ix: 5,
					x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-243-glasses').layer('control').effect('stroke')('Menu'));"
				},
				lc: 2,
				lj: 2,
				bm: 0,
				nm: ".primary",
				mn: "ADBE Vector Graphic - Stroke",
				hd: false,
				cl: "primary"
			}, {
				ty: "tr",
				p: {
					a: 0,
					k: [0, 0],
					ix: 2
				},
				a: {
					a: 0,
					k: [0, 0],
					ix: 1
				},
				s: {
					a: 0,
					k: [100, 100],
					ix: 3
				},
				r: {
					a: 0,
					k: 0,
					ix: 6
				},
				o: {
					a: 0,
					k: 100,
					ix: 7
				},
				sk: {
					a: 0,
					k: 0,
					ix: 4
				},
				sa: {
					a: 0,
					k: 0,
					ix: 5
				},
				nm: "Transform"
			}],
			nm: "Group 1",
			np: 6,
			cix: 2,
			bm: 0,
			ix: 1,
			mn: "ADBE Vector Group",
			hd: false
		}],
		ip: 0,
		op: 300,
		st: 0,
		ct: 1,
		bm: 0
	}]
}];
var layers = [{
	ddd: 0,
	ind: 1,
	ty: 3,
	nm: "control",
	sr: 1,
	ks: {
		o: {
			a: 0,
			k: 0,
			ix: 11
		},
		r: {
			a: 0,
			k: 0,
			ix: 10
		},
		p: {
			a: 0,
			k: [0, 0],
			ix: 2,
			l: 2
		},
		a: {
			a: 0,
			k: [0, 0, 0],
			ix: 1,
			l: 2
		},
		s: {
			a: 0,
			k: [100, 100, 100],
			ix: 6,
			l: 2
		}
	},
	ao: 0,
	ef: [{
		ty: 5,
		nm: "stroke",
		np: 3,
		mn: "Pseudo/@@G3Tcba1ZSbuGFyWE7OY24g",
		ix: 1,
		en: 1,
		ef: [{
			ty: 7,
			nm: "Menu",
			mn: "Pseudo/@@G3Tcba1ZSbuGFyWE7OY24g-0001",
			ix: 1,
			v: {
				a: 0,
				k: 2,
				ix: 1
			}
		}]
	}, {
		ty: 5,
		nm: "primary",
		np: 3,
		mn: "ADBE Color Control",
		ix: 2,
		en: 1,
		ef: [{
			ty: 2,
			nm: "Color",
			mn: "ADBE Color Control-0001",
			ix: 1,
			v: {
				a: 0,
				k: [0.875, 0.898, 0.929],
				ix: 1
			}
		}]
	}, {
		ty: 5,
		nm: "secondary",
		np: 3,
		mn: "ADBE Color Control",
		ix: 3,
		en: 1,
		ef: [{
			ty: 2,
			nm: "Color",
			mn: "ADBE Color Control-0001",
			ix: 1,
			v: {
				a: 0,
				k: [0.749, 0.788, 0.851],
				ix: 1
			}
		}]
	}],
	ip: 0,
	op: 374,
	st: 0,
	bm: 0
}, {
	ddd: 0,
	ind: 2,
	ty: 0,
	nm: "in-reveal",
	refId: "comp_0",
	sr: 1,
	ks: {
		o: {
			a: 0,
			k: 100,
			ix: 11
		},
		r: {
			a: 0,
			k: 0,
			ix: 10
		},
		p: {
			a: 0,
			k: [215, 215, 0],
			ix: 2,
			l: 2
		},
		a: {
			a: 0,
			k: [215, 215, 0],
			ix: 1,
			l: 2
		},
		s: {
			a: 0,
			k: [100, 100, 100],
			ix: 6,
			l: 2
		}
	},
	ao: 0,
	w: 430,
	h: 430,
	ip: 0,
	op: 70,
	st: 0,
	bm: 0
}, {
	ddd: 0,
	ind: 3,
	ty: 0,
	nm: "hover-searching",
	refId: "comp_1",
	sr: 1,
	ks: {
		o: {
			a: 0,
			k: 100,
			ix: 11
		},
		r: {
			a: 0,
			k: 0,
			ix: 10
		},
		p: {
			a: 0,
			k: [215, 215, 0],
			ix: 2,
			l: 2
		},
		a: {
			a: 0,
			k: [215, 215, 0],
			ix: 1,
			l: 2
		},
		s: {
			a: 0,
			k: [100, 100, 100],
			ix: 6,
			l: 2
		}
	},
	ao: 0,
	w: 430,
	h: 430,
	ip: 70,
	op: 212.5,
	st: 70,
	bm: 0
}, {
	ddd: 0,
	ind: 4,
	ty: 0,
	nm: "morph-eyes",
	refId: "comp_2",
	sr: 1,
	ks: {
		o: {
			a: 0,
			k: 100,
			ix: 11
		},
		r: {
			a: 0,
			k: 0,
			ix: 10
		},
		p: {
			a: 0,
			k: [215, 215, 0],
			ix: 2,
			l: 2
		},
		a: {
			a: 0,
			k: [215, 215, 0],
			ix: 1,
			l: 2
		},
		s: {
			a: 0,
			k: [100, 100, 100],
			ix: 6,
			l: 2
		}
	},
	ao: 0,
	w: 430,
	h: 430,
	ip: 212.5,
	op: 342.5,
	st: 212.5,
	bm: 0
}, {
	ddd: 0,
	ind: 5,
	ty: 0,
	nm: "hover-blink",
	refId: "comp_3",
	sr: 1,
	ks: {
		o: {
			a: 0,
			k: 100,
			ix: 11
		},
		r: {
			a: 0,
			k: 0,
			ix: 10
		},
		p: {
			a: 0,
			k: [215, 215, 0],
			ix: 2,
			l: 2
		},
		a: {
			a: 0,
			k: [215, 215, 0],
			ix: 1,
			l: 2
		},
		s: {
			a: 0,
			k: [100, 100, 100],
			ix: 6,
			l: 2
		}
	},
	ao: 0,
	w: 430,
	h: 430,
	ip: 342.5,
	op: 382.5,
	st: 342.5,
	bm: 0
}];
var markers = [{
	tm: 0,
	cm: "in-reveal",
	dr: 60
}, {
	tm: 70,
	cm: "default:hover-searching",
	dr: 132.5
}, {
	tm: 212.5,
	cm: "morph-eyes",
	dr: 120
}, {
	tm: 342.5,
	cm: "hover-blink",
	dr: 30
}];
var props = {};
var notFoundAnimation = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers,
	props: props
};

var _ref$s =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.247 4.786L.904 1.443a.596.596 0 01-.174-.428.58.58 0 01.174-.436A.59.59 0 011.337.4c.169 0 .313.06.432.179l3.688 3.687a.682.682 0 01.21.52.682.682 0 01-.21.52L1.769 8.992a.596.596 0 01-.428.174.58.58 0 01-.437-.174.59.59 0 01-.178-.433c0-.17.06-.313.178-.432l3.343-3.342z",
  fill: "#BFC9D9"
});

var arrowRight = 'data:image/svg+xml,%3Csvg%20width%3D%226%22%20height%3D%2210%22%20viewBox%3D%220%200%206%2010%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M4.24658%204.78557L0.904259%201.44345C0.79075%201.32981%200.732627%201.18696%200.729892%201.01492C0.727294%200.843014%200.785416%200.697571%200.904259%200.578591C1.02324%200.459748%201.16738%200.400326%201.33669%200.400326C1.506%200.400326%201.65014%200.459748%201.76912%200.578591L5.45689%204.26636C5.53361%204.34322%205.58777%204.42425%205.61936%204.50945C5.65095%204.59465%205.66675%204.68669%205.66675%204.78557C5.66675%204.88444%205.65095%204.97648%205.61936%205.06168C5.58777%205.14688%205.53361%205.22791%205.45689%205.30477L1.76912%208.99254C1.65548%209.10605%201.51263%209.16417%201.34059%209.16691C1.16868%209.16951%201.02324%209.11138%200.904259%208.99254C0.785415%208.87356%200.725994%208.72942%200.725994%208.56011C0.725994%208.3908%200.785415%208.24666%200.904259%208.12768L4.24658%204.78557Z%22%20fill%3D%22%23BFC9D9%22%2F%3E%3C%2Fsvg%3E';

var _templateObject$x = taggedTemplateLiteral(['\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n'], ['\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n']),
    _templateObject2$p = taggedTemplateLiteral(['\n    overflow-y: auto;\n    flex-grow: 1;\n    padding-bottom: 10px;\n    padding-top: 80px;\n    text-align: center;\n    /* autoprefixer ignore next */\n    -webkit-overflow-scrolling: touch; //fixes scroll on iOS\n\n    /* Remove Scrolling */\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n        width: 0;\n        height: 0;\n    }\n'], ['\n    overflow-y: auto;\n    flex-grow: 1;\n    padding-bottom: 10px;\n    padding-top: 80px;\n    text-align: center;\n    /* autoprefixer ignore next */\n    -webkit-overflow-scrolling: touch; //fixes scroll on iOS\n\n    /* Remove Scrolling */\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n        width: 0;\n        height: 0;\n    }\n']),
    _templateObject3$k = taggedTemplateLiteral(['\n    color: ', ';\n    font-size: 20px;\n    padding: 0;\n    margin: 0 0 15px;\n    text-align: left;\n    font-weight: ', ';\n'], ['\n    color: ', ';\n    font-size: 20px;\n    padding: 0;\n    margin: 0 0 15px;\n    text-align: left;\n    font-weight: ', ';\n']),
    _templateObject4$h = taggedTemplateLiteral(['\n    display: block;\n    border-radius: 8px;\n    overflow: hidden;\n'], ['\n    display: block;\n    border-radius: 8px;\n    overflow: hidden;\n']),
    _templateObject5$f = taggedTemplateLiteral(['\n    display: flex;\n    background: ', ';\n    color: ', ';\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px;\n    ', ';\n    cursor: pointer;\n    animation: ', ' 300ms ease-out;\n    transition: transform 300ms ease-out;\n    animation-delay: ', 's;\n\n    &:hover {\n        background: ', ';\n    }\n'], ['\n    display: flex;\n    background: ', ';\n    color: ', ';\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px;\n    ', ';\n    cursor: pointer;\n    animation: ', ' 300ms ease-out;\n    transition: transform 300ms ease-out;\n    animation-delay: ', 's;\n\n    &:hover {\n        background: ', ';\n    }\n']),
    _templateObject6$c = taggedTemplateLiteral(['\n    height: auto;\n    text-align: ', ';\n    ', ';\n'], ['\n    height: auto;\n    text-align: ', ';\n    ', ';\n']),
    _templateObject7$a = taggedTemplateLiteral(['\n    font-size: 13px;\n    line-height: normal;\n    color: ', ';\n    margin: 0;\n'], ['\n    font-size: 13px;\n    line-height: normal;\n    color: ', ';\n    margin: 0;\n']),
    _templateObject8$9 = taggedTemplateLiteral(['\n    color: ', ';\n'], ['\n    color: ', ';\n']),
    _templateObject9$8 = taggedTemplateLiteral(['\n    text-align: center;\n    cursor: pointer;\n    font-weight: ', ';\n    text-decoration: underline;\n    color: ', ';\n'], ['\n    text-align: center;\n    cursor: pointer;\n    font-weight: ', ';\n    text-decoration: underline;\n    color: ', ';\n']);

var dissolve = keyframes(_templateObject$x);

var Wrapper$8 = styled.div(_templateObject2$p);
var TransactionsHeading = styled.h5(_templateObject3$k, function (props$$1) {
    return props$$1.theme.colors.colorTextPrimaryDefault;
}, function (props$$1) {
    return props$$1.theme.fontWeight;
});

var TransactionsList = styled.div(_templateObject4$h);

var GroupItem = styled.div(_templateObject5$f, function (props$$1) {
    return props$$1.theme.colors.colorBackgroundSurfacePrimaryDefault;
}, function (props$$1) {
    return props$$1.theme.colors.colorTextPrimaryDefault;
}, function (_ref) {
    var border = _ref.border,
        theme = _ref.theme;
    return border && 'border-bottom: 1px solid ' + theme.colors.colorBackgroundSurfaceTertiaryDefault;
}, dissolve, function (props$$1) {
    return props$$1.delay;
}, function (props$$1) {
    return props$$1.theme.colors.colorBackgroundSurfaceTertiaryHover;
});

var GroupRow = styled.div(_templateObject6$c, function (_ref2) {
    var align = _ref2.align;
    return align ? align : 'left';
}, function (_ref3) {
    var flex = _ref3.flex;
    return 'flex: ' + flex;
});

var StyledText = styled(Text)(_templateObject7$a, function (props$$1) {
    return props$$1.color ? props$$1.color : props$$1.theme.colors.colorTextPrimaryDefault;
});

var TextLabel = styled.span(_templateObject8$9, function (props$$1) {
    return props$$1.color ? props$$1.color : props$$1.theme.colors.colorTextTertiaryDefault;
});

var Link$1 = styled.span(_templateObject9$8, function (props$$1) {
    return props$$1.theme.fontWeight;
}, function (props$$1) {
    return props$$1.theme.colors.colorTextUtilitiesLink;
});

var TransactionList = function TransactionList(_ref4) {
    var _ref4$data = _ref4.data,
        data = _ref4$data === undefined ? [] : _ref4$data,
        theme = _ref4.theme,
        _ref4$groupBy = _ref4.groupBy,
        groupBy = _ref4$groupBy === undefined ? 'MMMM' : _ref4$groupBy,
        loading = _ref4.loading,
        showMore = _ref4.showMore,
        _ref4$periodDate = _ref4.periodDate,
        periodDate = _ref4$periodDate === undefined ? [] : _ref4$periodDate,
        _ref4$transactionData = _ref4.transactionDataFormat,
        transactionDataFormat = _ref4$transactionData === undefined ? 'DDMMYYYY' : _ref4$transactionData,
        _ref4$showDetails = _ref4.showDetails,
        showDetails = _ref4$showDetails === undefined ? function () {} : _ref4$showDetails,
        _ref4$loadMoreHandler = _ref4.loadMoreHandler,
        loadMoreHandler = _ref4$loadMoreHandler === undefined ? function () {} : _ref4$loadMoreHandler,
        _ref4$loadMoreColor = _ref4.loadMoreColor,
        loadMoreColor = _ref4$loadMoreColor === undefined ? '' : _ref4$loadMoreColor,
        _ref4$tab = _ref4.tab,
        tab = _ref4$tab === undefined ? '' : _ref4$tab;

    var _useState = useState(null),
        _useState2 = slicedToArray(_useState, 2),
        sortedData = _useState2[0],
        setSortedData = _useState2[1];

    var _useState3 = useState(''),
        _useState4 = slicedToArray(_useState3, 2),
        periodTitle = _useState4[0],
        setPeriodTitle = _useState4[1];

    var contentRef = useRef(null);

    var handleScroll = function handleScroll() {
        if (contentRef.current) {
            contentRef.current.scrollTop = 0;
        }
    };

    useEffect(function () {
        handleScroll();
    }, [tab]);

    useEffect(function () {
        if (periodDate.length) {
            var fromDate = moment(periodDate[0], transactionDataFormat).format('DD. MMM YYYY');
            var toDate = moment(periodDate[1], transactionDataFormat).format('DD. MMM YYYY');
            setPeriodTitle(fromDate + ' - ' + toDate);
            setSortedData(data);
        } else {
            setPeriodTitle('');
            setSortedData(data);
        }
    }, [periodDate, groupBy, data]);

    var groupItem = function groupItem(transaction) {
        return React.createElement(
            Fragment,
            null,
            React.createElement(
                GroupRow,
                { flex: 6 },
                React.createElement(
                    StyledText,
                    { style: { margin: '0 0 4px' } },
                    transaction.text,
                    ' ',
                    React.createElement(
                        TextLabel,
                        null,
                        transaction.product
                    )
                ),
                React.createElement(
                    StyledText,
                    null,
                    dateFormatter(new Date(transaction.transactionDate).toLocaleString('da-DK', {
                        dateStyle: 'short',
                        timeStyle: 'short'
                    }))
                )
            ),
            React.createElement(
                GroupRow,
                { flex: 3 },
                React.createElement(
                    StyledText,
                    {
                        align: 'right',
                        color: transaction.amount >= 0 ? theme.colors.colorTextSuccessPrimaryDefault : null //--color-text-success-default
                        ,
                        style: { margin: '0 0 4px' }
                    },
                    numberWithCommasAndDotsIntl(transaction.amount),
                    ' kr.'
                ),
                React.createElement(
                    StyledText,
                    { align: 'right' },
                    numberWithCommasAndDotsIntl(transaction.balance),
                    ' kr.'
                )
            ),
            React.createElement(
                GroupRow,
                { flex: 1, align: 'right' },
                React.createElement(Icon, {
                    src: arrowRight,
                    width: '16px',
                    height: '16px',
                    color: theme.colors.colorIconSecondaryDefault
                })
            )
        );
    };

    return React.createElement(
        Wrapper$8,
        { ref: contentRef },
        React.createElement(
            TransactionsHeading,
            null,
            periodTitle ? periodTitle : 'Seneste transaktioner'
        ),
        data.length ? React.createElement(
            Fragment,
            null,
            React.createElement(
                TransactionsList,
                null,
                sortedData && sortedData.sort(function (a, b) {
                    return new Date(b.transactionDate) - new Date(a.transactionDate);
                }).map(function (transaction, index) {
                    return React.createElement(
                        GroupItem,
                        {
                            key: index,
                            border: index < sortedData.length - 1,
                            onClick: function onClick() {
                                return showDetails(transaction);
                            }
                            //delay={index * 0.1}
                        },
                        groupItem(transaction)
                    );
                })
            ),
            showMore && React.createElement(
                Flex,
                { style: { margin: '16px 0' } },
                React.createElement(
                    Button$1,
                    {
                        maxWidth: '352px',
                        bgColor: loadMoreColor || theme.colors.colorBackgroundSurfacePrimaryDefault,
                        bgColorHover: theme.colors.colorBackgroundSurfacePrimaryDefault,
                        bgDisabledColor: theme.colors.colorBackgroundSurfacePrimaryHover,
                        borderColor: theme.colors.colorBorderPrimaryDefault,
                        onClick: loadMoreHandler,
                        disabled: loading
                    },
                    React.createElement(
                        Text,
                        {
                            color: theme.colors.colorTextPrimaryDefault,
                            align: 'center'
                        },
                        'Vis mere'
                    ),
                    loading && React.createElement(Spinner$1, {
                        color: theme.colors.colorTextPrimaryDefault,
                        size: 'md'
                    })
                )
            )
        ) : loading ? React.createElement(Spinner$1, { size: 'md', style: { textAlign: 'center' } }) : React.createElement(
            Flex,
            { direction: 'column', style: { margin: '0 0 32px' } },
            React.createElement(LottiePlayerLight_1, {
                loop: true,
                animationData: notFoundAnimation,
                play: true,
                style: {
                    width: '100px',
                    height: '100px',
                    margin: '0 auto'
                }
            }),
            React.createElement(
                Text,
                { color: theme.colors.colorTextTertiaryDefault },
                'Ingen transaktioner fundet'
            )
        ),
        React.createElement(
            Flex,
            {
                background: theme.colors.colorBackgroundSurfaceSecondaryDefault,
                borderRadius: '8px',
                align: 'baseline',
                justify: 'flex-start',
                direction: 'column',
                style: { padding: '24px', margin: '16px 0' }
            },
            React.createElement(
                Text,
                {
                    size: 18,
                    weight: theme.fontWeight,
                    color: theme.colors.colorTextPrimaryDefault,
                    margin: '0 0 16px 0'
                },
                'Leder du efter noget specifikt?'
            ),
            React.createElement(
                Text,
                {
                    size: 13,
                    lineHeight: '20px',
                    margin: '0',
                    color: theme.colors.colorTextPrimaryDefault
                },
                'For en fuld transaktionsoversigt, eller en liste af transaktioner for et givet tidsrum bedes du rette'
            ),
            React.createElement(
                Text,
                {
                    size: 13,
                    lineHeight: '20px',
                    margin: '0',
                    color: theme.colors.colorTextPrimaryDefault
                },
                'henvendelse til vores',
                ' ',
                React.createElement(
                    Link$1,
                    { onClick: function onClick() {
                            return window.Intercom('show');
                        }, bold: true },
                    'kundeservice'
                )
            )
        )
    );
};

TransactionList.propTypes = {
    data: PropTypes.array.isRequired,
    theme: PropTypes.object,
    groupBy: PropTypes.string,
    loading: PropTypes.bool,
    showMore: PropTypes.bool,
    transactionDataFormat: PropTypes.string,
    periodDate: PropTypes.array,
    showDetails: PropTypes.func,
    loadMoreHandler: PropTypes.func
};

var _templateObject$y = taggedTemplateLiteral(['\n    text-align: center;\n    font-size: 18px;\n    font-weight: ', ';\n    border-bottom: 1px solid\n        ', ';\n    padding: 16px;\n    color: ', ';\n'], ['\n    text-align: center;\n    font-size: 18px;\n    font-weight: ', ';\n    border-bottom: 1px solid\n        ', ';\n    padding: 16px;\n    color: ', ';\n']),
    _templateObject2$q = taggedTemplateLiteral(['\n    padding: 0 24px;\n'], ['\n    padding: 0 24px;\n']),
    _templateObject3$l = taggedTemplateLiteral(['\n    padding: 20px 24px;\n    display: flex;\n    justify-content: space-between;\n    ', ';\n    font-size: 14px;\n'], ['\n    padding: 20px 24px;\n    display: flex;\n    justify-content: space-between;\n    ', ';\n    font-size: 14px;\n']),
    _templateObject4$i = taggedTemplateLiteral(['\n    font-weight: ', ';\n    color: ', ';\n'], ['\n    font-weight: ', ';\n    color: ', ';\n']),
    _templateObject5$g = taggedTemplateLiteral(['\n    color: ', ';\n'], ['\n    color: ', ';\n']),
    _templateObject6$d = taggedTemplateLiteral(['\n    ', '\n    border-top: 1px solid ', ';\n    padding: 24px 16px;\n'], ['\n    ', '\n    border-top: 1px solid ', ';\n    padding: 24px 16px;\n']),
    _templateObject7$b = taggedTemplateLiteral(['\n    padding: 12px;\n    background: ', ';\n    border: 1px solid ', ';\n    border-radius: 8px;\n    font-weight: ', ';\n    font-size: 13px;\n    width: 100%;\n    cursor: pointer;\n    color: ', '; //--color-background-surface-primary-default\n'], ['\n    padding: 12px;\n    background: ', ';\n    border: 1px solid ', ';\n    border-radius: 8px;\n    font-weight: ', ';\n    font-size: 13px;\n    width: 100%;\n    cursor: pointer;\n    color: ', '; //--color-background-surface-primary-default\n']),
    _templateObject8$a = taggedTemplateLiteral(['\n    position: absolute;\n    right: 15px;\n    top: 15px;\n    cursor: pointer;\n'], ['\n    position: absolute;\n    right: 15px;\n    top: 15px;\n    cursor: pointer;\n']);

var Headline = styled.div(_templateObject$y, function (props) {
    return props.theme.fontWeight;
}, function (props) {
    return props.theme.colors.colorBorderPrimaryDefault;
}, function (props) {
    return props.theme.colors.colorTextPrimaryDefault;
});
var Details = styled.div(_templateObject2$q);
var Item = styled.div(_templateObject3$l, function (props) {
    return !props.last && 'border-bottom: 1px solid ' + props.theme.colors.colorBorderPrimaryDefault;
});
var Name = styled.div(_templateObject4$i, function (props) {
    return props.theme.fontWeight;
}, function (props) {
    return props.theme.colors.colorTextPrimaryDefault;
});
var Summary = styled.div(_templateObject5$g, function (props) {
    return props.theme.colors.colorTextTertiaryDefault;
});
var ActionWrapper = styled.div(_templateObject6$d, function (props) {
    return console.log('props', props);
}, function (props) {
    return props.theme.colors.colorBorderPrimaryDefault;
});
var Button$2 = styled.button(_templateObject7$b, function (props) {
    return props.theme.colors.colorBackgroundSurfacePrimaryDefault;
}, function (props) {
    return props.theme.colors.colorBorderPrimaryDefault;
}, function (props) {
    return props.theme.fontWeight;
}, function (props) {
    return props.theme.colors.colorTextPrimaryDefault;
});

var IconWrapper$1 = styled.div(_templateObject8$a);

var _templateObject$z = taggedTemplateLiteral(['\n    background: ', ';\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    max-width: 400px;\n    width: 80%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    ', '\n'], ['\n    background: ', ';\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    max-width: 400px;\n    width: 80%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    ', '\n']),
    _templateObject2$r = taggedTemplateLiteral(['\n            max-width: 100%;\n            width: 100%;\n            position: absolute;\n            bottom: 0;\n            left: 0;\n            top: auto;\n            transform: none;\n            border-bottom-left-radius: 0;\n            border-bottom-right-radius: 0;\n        '], ['\n            max-width: 100%;\n            width: 100%;\n            position: absolute;\n            bottom: 0;\n            left: 0;\n            top: auto;\n            transform: none;\n            border-bottom-left-radius: 0;\n            border-bottom-right-radius: 0;\n        ']),
    _templateObject3$m = taggedTemplateLiteral(['\n    height: auto;\n    width: 100%;\n    max-width: 400px;\n    padding: 42px 24px 36px;\n    background: #f5f8fc;\n    border-radius: 8px;\n    position: relative;\n    hr {\n        margin: 16px auto;\n        border: none;\n        border-top: 1px solid #dfe5ed;\n        width: 100%;\n    }\n    ', '\n'], ['\n    height: auto;\n    width: 100%;\n    max-width: 400px;\n    padding: 42px 24px 36px;\n    background: #f5f8fc;\n    border-radius: 8px;\n    position: relative;\n    hr {\n        margin: 16px auto;\n        border: none;\n        border-top: 1px solid #dfe5ed;\n        width: 100%;\n    }\n    ', '\n']),
    _templateObject4$j = taggedTemplateLiteral(['\n            max-width: 100%;\n        '], ['\n            max-width: 100%;\n        ']),
    _templateObject5$h = taggedTemplateLiteral(['\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding-bottom: 35px;\n'], ['\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding-bottom: 35px;\n']);

var PopupContainer = styled.div(_templateObject$z, function (props) {
    return props.theme.colors.colorBackgroundDefault;
}, detectMobile() && css(_templateObject2$r));

var SuccessPopupContent = styled(boxFlex)(_templateObject3$m, detectMobile() && css(_templateObject4$j));

var SuccessPopupIconBlock = styled(boxFlex)(_templateObject5$h);

var TransactionDetails = function TransactionDetails(_ref) {
    var _ref$currentTheme = _ref.currentTheme,
        currentTheme = _ref$currentTheme === undefined ? 'default' : _ref$currentTheme,
        _ref$data = _ref.data,
        data = _ref$data === undefined ? {} : _ref$data,
        _ref$onClose = _ref.onClose,
        onClose = _ref$onClose === undefined ? function () {} : _ref$onClose;

    var theme = themesMap$6[currentTheme];

    var amount = data.amount,
        transId = data.transId,
        refId = data.refId,
        type = data.text,
        transactionDate = data.transactionDate,
        product = data.product;


    useEffect(function () {
        console.log('props', product);
    }, []);
    return React.createElement(
        ThemeProvider,
        { theme: theme },
        React.createElement(
            PopupContainer,
            {
                onClick: function onClick(e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            React.createElement(
                Headline,
                null,
                type
            ),
            React.createElement(
                IconWrapper$1,
                { onClick: onClose },
                React.createElement(Icon, {
                    height: '24px',
                    width: '24px',
                    src: CloseIcon$1,
                    color: theme.colors.colorIconSecondaryDefault
                })
            ),
            React.createElement(
                Details,
                null,
                React.createElement(
                    Item,
                    null,
                    React.createElement(
                        Name,
                        null,
                        'Detaljer'
                    ),
                    React.createElement(
                        Summary,
                        null,
                        product
                    )
                ),
                React.createElement(
                    Item,
                    null,
                    React.createElement(
                        Name,
                        null,
                        'Transaktions ID'
                    ),
                    React.createElement(
                        Summary,
                        null,
                        transId
                    )
                ),
                React.createElement(
                    Item,
                    null,
                    React.createElement(
                        Name,
                        null,
                        'Reference ID'
                    ),
                    React.createElement(
                        Summary,
                        null,
                        refId
                    )
                ),
                React.createElement(
                    Item,
                    null,
                    React.createElement(
                        Name,
                        null,
                        'Dato'
                    ),
                    React.createElement(
                        Summary,
                        null,
                        dateFormatter(new Date(transactionDate).toLocaleString('da-DK', {
                            dateStyle: 'short',
                            timeStyle: 'short'
                        }))
                    )
                ),
                React.createElement(
                    Item,
                    { last: true },
                    React.createElement(
                        Name,
                        null,
                        'Bel\xF8b'
                    ),
                    React.createElement(
                        Summary,
                        null,
                        numberWithCommasAndDotsIntl(amount),
                        ' kr.'
                    )
                )
            ),
            React.createElement(
                ActionWrapper,
                null,
                React.createElement(
                    Button$2,
                    {
                        bgColor: theme.colors.colorBackgroundSurfacePrimaryDefault,
                        borderColor: theme.colors.colorBorderPrimaryDefault,
                        onClick: onClose
                    },
                    'OK'
                )
            )
        )
    );
};

TransactionDetails.propTypes = {
    data: PropTypes.shape({}),
    onClose: PropTypes.func
};

var _templateObject$A = taggedTemplateLiteral(['\n    position: relative;\n    width: 100%;\n    background: ', ';\n    padding: 0 24px 70px;\n    flex: 1 1 0;\n    display: flex;\n    flex-direction: column;\n    overflow-y: hidden;\n    box-sizing: border-box;\n'], ['\n    position: relative;\n    width: 100%;\n    background: ', ';\n    padding: 0 24px 70px;\n    flex: 1 1 0;\n    display: flex;\n    flex-direction: column;\n    overflow-y: hidden;\n    box-sizing: border-box;\n']),
    _templateObject2$s = taggedTemplateLiteral(['\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 368px;\n    top: 16px;\n    z-index: 5;\n'], ['\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 368px;\n    top: 16px;\n    z-index: 5;\n']);

var Wrapper$9 = styled.div(_templateObject$A, function (props) {
    return props.theme.colors.colorBackgroundDefault;
});

var MultiSwitchWrapper = styled.div(_templateObject2$s);

var ActionList = [{
    name: 'all',
    title: 'Alle',
    groupKey: 2
}, {
    name: 'gameHistory',
    title: 'Spil',
    groupKey: 1
}, {
    name: 'transactionHistory',
    title: 'Ind-/udbetaling',
    groupKey: 0
}];

/**
 * User Transaction History component
 * @param transactions {Array.<Object>}
 * @param currentTheme {string}
 * @param buttonsAreaPosition {string}
 * @param loading {boolean}
 * @param showMore {boolean}
 * @param showDetails {function()} callback
 * @param setTab {function()} callback
 * @param loadMoreHandler {function()} callback
 * @param loadMoreColor {string} bg HEX-color for load more button //need to be changed to theme
 * @param setInitialConfig {function()} callback
 * @param openChooseDate {function()} callback
 * @param resetDateHandler {function()} callback
 * @param currentDate {Object.<dateFrom, dateTo>}
 * @returns {JSX.Element}
 * @constructor
 */
var UserHistory = function UserHistory(_ref) {
    var transactions = _ref.transactions,
        _ref$currentTheme = _ref.currentTheme,
        currentTheme = _ref$currentTheme === undefined ? 'default' : _ref$currentTheme,
        _ref$loading = _ref.loading,
        loading = _ref$loading === undefined ? true : _ref$loading,
        _ref$showMore = _ref.showMore,
        showMore = _ref$showMore === undefined ? false : _ref$showMore,
        _ref$showDetails = _ref.showDetails,
        showDetails = _ref$showDetails === undefined ? function () {} : _ref$showDetails,
        _ref$setTab = _ref.setTab,
        setTab = _ref$setTab === undefined ? function () {} : _ref$setTab,
        _ref$loadMoreHandler = _ref.loadMoreHandler,
        loadMoreHandler = _ref$loadMoreHandler === undefined ? function () {} : _ref$loadMoreHandler,
        _ref$loadMoreColor = _ref.loadMoreColor,
        loadMoreColor = _ref$loadMoreColor === undefined ? '' : _ref$loadMoreColor,
        _ref$setInitialConfig = _ref.setInitialConfig,
        setInitialConfig = _ref$setInitialConfig === undefined ? function () {} : _ref$setInitialConfig,
        _ref$openChooseDate = _ref.openChooseDate,
        _openChooseDate = _ref$openChooseDate === undefined ? function () {} : _ref$openChooseDate,
        _ref$resetDateHandler = _ref.resetDateHandler,
        resetDateHandler = _ref$resetDateHandler === undefined ? function () {
    } : _ref$resetDateHandler,
        _ref$currentDate = _ref.currentDate,
        currentDate = _ref$currentDate === undefined ? {} : _ref$currentDate,
        _ref$buttonsAreaPosit = _ref.buttonsAreaPosition,
        buttonsAreaPosition = _ref$buttonsAreaPosit === undefined ? '' : _ref$buttonsAreaPosit;

    var theme = themesMap$6[currentTheme];
    var transactionDataFormat = 'DDMMYYYY';
    var defaultFromDate = moment().subtract(1, 'year').format(transactionDataFormat);
    var defaultToDate = moment().format(transactionDataFormat);

    var _useState = useState(ActionList[0]),
        _useState2 = slicedToArray(_useState, 2),
        curTab = _useState2[0],
        setCurTab = _useState2[1];

    var contentRef = useRef(null);

    var _useState3 = useState(defaultFromDate),
        _useState4 = slicedToArray(_useState3, 2),
        fromDate = _useState4[0],
        setFromDate = _useState4[1];

    var _useState5 = useState(defaultToDate),
        _useState6 = slicedToArray(_useState5, 2),
        toDate = _useState6[0],
        setToDate = _useState6[1];

    var _useState7 = useState(false),
        _useState8 = slicedToArray(_useState7, 2),
        chosenDate = _useState8[0],
        setChosenDate = _useState8[1];

    var changeTab = function changeTab(tabName) {
        if (tabName !== curTab.name) {
            var selectedTab = ActionList.filter(function (tab) {
                return tab.name === tabName;
            })[0];
            setTab(selectedTab);
            setCurTab(selectedTab);
        }
    };

    useEffect(function () {
        setInitialConfig({
            dateFrom: fromDate,
            dateTo: toDate,
            rowCount: 20
        });
        setTab(curTab);
    }, []);

    useEffect(function () {
        if (currentDate.dateTo && currentDate.dateTo) {
            setFromDate(currentDate.dateFrom);
            setToDate(currentDate.dateTo);
            setChosenDate(currentDate.dateFrom !== defaultFromDate || currentDate.dateTo !== defaultToDate);
        }
    }, [currentDate]);

    return React.createElement(
        ThemeProvider,
        { theme: theme },
        React.createElement(
            Wrapper$9,
            {
                background: theme.colors.colorBackgroundSurfacePrimaryDefault
            },
            React.createElement(
                MultiSwitchWrapper,
                null,
                React.createElement(SmallMultiSwitcher, {
                    onChange: changeTab,
                    value: curTab.name,
                    optionList: ActionList,
                    color: theme.colors.colorTextPrimaryDefault,
                    activeColor: theme.colors.colorTextPrimaryDefault,
                    activeBgColor: theme.colors.colorBackgroundFillPrimaryDefault,
                    mainColor: theme.colors.colorBackgroundSurfaceTertiaryDefault
                })
            ),
            React.createElement(TransactionList, {
                ref: contentRef,
                data: transactions,
                showDetails: showDetails,
                theme: theme,
                loading: loading,
                loadMoreHandler: loadMoreHandler,
                showMore: showMore,
                periodDate: chosenDate ? [fromDate, toDate] : [],
                transactionDataFormat: transactionDataFormat,
                loadMoreColor: loadMoreColor,
                tab: curTab
            })
        ),
        React.createElement(ButtonArea$2, {
            showClearButton: chosenDate,
            clearChosenDate: function clearChosenDate() {
                setFromDate(defaultFromDate);
                setToDate(defaultToDate);
                resetDateHandler({
                    dateFrom: defaultFromDate,
                    dateTo: defaultToDate
                });
            },
            openChooseDate: function openChooseDate() {
                _openChooseDate();
            },
            buttonsAreaPosition: buttonsAreaPosition
        })
    );
};

TransactionDetails.propTypes = {
    transactions: PropTypes.array.isRequired,
    currentTheme: PropTypes.string,
    buttonsAreaPosition: PropTypes.string,
    showMore: PropTypes.bool,
    showDetails: PropTypes.func,
    setTab: PropTypes.func,
    loadMoreHandler: PropTypes.func,
    loadMoreColor: PropTypes.string,
    setInitialConfig: PropTypes.func,
    openChooseDate: PropTypes.func,
    resetDateHandler: PropTypes.func,
    currentDate: PropTypes.shape({
        dateTo: PropTypes.number,
        dateFrom: PropTypes.number
    })
};

var da = createCommonjsModule$1(function (module, exports) {
(function (global, factory) {
   typeof commonjsRequire === 'function' ? factory(moment) :
   factory(global.moment);
}(commonjsGlobal$1, (function (moment$$1) {
    //! moment.js locale configuration

    var da = moment$$1.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));
});

var _templateObject$B = taggedTemplateLiteral(['\n    border-radius: 5px;\n    border: 1px solid ', ';\n    background: #f5f8fc;\n    font-size: 14px;\n    padding: 15px 20px;\n    color: ', ';\n'], ['\n    border-radius: 5px;\n    border: 1px solid ', ';\n    background: #f5f8fc;\n    font-size: 14px;\n    padding: 15px 20px;\n    color: ', ';\n']),
    _templateObject2$t = taggedTemplateLiteral(['\n    font-style: italic;\n    font-size: 10px;\n'], ['\n    font-style: italic;\n    font-size: 10px;\n']);

var ProfileCard = styled.div(_templateObject$B, function (props) {
    return props.theme.colors.colorBorderPrimaryDefault;
}, function (props) {
    return props.theme.colors.colorTextPrimaryDefault;
});

var AddressChangeInfo = styled.div(_templateObject2$t);

var _templateObject$C = taggedTemplateLiteral(['\n    padding: 20px;\n'], ['\n    padding: 20px;\n']);

var Wrapper$a = styled.div(_templateObject$C);

var ProfilePage = function ProfilePage(_ref) {
    var _ref$currentTheme = _ref.currentTheme,
        currentTheme = _ref$currentTheme === undefined ? 'default' : _ref$currentTheme,
        supportEmail = _ref.supportEmail,
        _ref$showSuccess = _ref.showSuccess,
        showSuccess = _ref$showSuccess === undefined ? function () {} : _ref$showSuccess,
        _ref$showError = _ref.showError,
        showError = _ref$showError === undefined ? function () {} : _ref$showError,
        _ref$punterSalt = _ref.punterSalt,
        punterSalt = _ref$punterSalt === undefined ? '' : _ref$punterSalt;

    var _useState = useState(null),
        _useState2 = slicedToArray(_useState, 2),
        profile = _useState2[0],
        setProfileData = _useState2[1];

    var _useState3 = useState(false),
        _useState4 = slicedToArray(_useState3, 2),
        loading = _useState4[0],
        setLoading = _useState4[1];

    var _useState5 = useState(),
        _useState6 = slicedToArray(_useState5, 2),
        email = _useState6[0],
        setEmail = _useState6[1];

    var _useState7 = useState(),
        _useState8 = slicedToArray(_useState7, 2),
        phone = _useState8[0],
        setPhone = _useState8[1];

    var _useState9 = useState(false),
        _useState10 = slicedToArray(_useState9, 2),
        updateLoading = _useState10[0],
        setUpdateLoading = _useState10[1];

    var _useState11 = useState({
        email: false,
        phone: false
    }),
        _useState12 = slicedToArray(_useState11, 2),
        errors = _useState12[0],
        setErrors = _useState12[1];

    var formHasErrors = Object.values(errors).some(function (fieldInvalid) {
        return fieldInvalid;
    });

    var _useState13 = useState(false),
        _useState14 = slicedToArray(_useState13, 2),
        formTouched = _useState14[0],
        setFormTouched = _useState14[1];

    var _useState15 = useState(false),
        _useState16 = slicedToArray(_useState15, 2),
        emailTouched = _useState16[0],
        setEmailTouched = _useState16[1];

    var checkValue = function checkValue(error) {
        if (error) {
            setErrors(_extends({}, errors, defineProperty({}, error.name, error.value)));
        }
    };

    useEffect(function () {
        setLoading(true);

        getAccountInformation().then(function (profileData) {
            setProfileData(profileData);
            setEmail(profileData.email);
            setPhone(profileData.phoneNr ? profileData.phoneNr.substring(0, 8) : '');
        }).catch(function (err) {
            return showError(err.toString());
        }).finally(function () {
            return setLoading(false);
        });
    }, []);

    var disallowFormSubmit = formHasErrors || !formTouched;

    var maybeCheckExistingEmail = function maybeCheckExistingEmail() {
        // should not validate email that user just put by himself and probably saved changes @see https://ecosys.atlassian.net/browse/DER-4451
        if (!emailTouched) {
            return Promise.resolve();
        }

        return checkExistingEmail({ email: email, salt: punterSalt }).then(function (res) {
            return res && res.data && res.data.exist ? Promise.reject('Denne e-mail er allerede i brug.') : Promise.resolve();
        });
    };

    var submitProfile = function submitProfile() {
        if (disallowFormSubmit || updateLoading) {
            return;
        }

        setUpdateLoading(true);

        maybeCheckExistingEmail().then(function () {
            return setAccountInformation({ email: email, phoneNr: phone });
        }).then(function () {
            showSuccess();
            setFormTouched(false);
            setEmailTouched(false);
        }).catch(function (err) {
            return showError(err);
        }).finally(function () {
            return setUpdateLoading(false);
        });
    };

    if (loading) {
        return React.createElement(
            Flex,
            null,
            React.createElement(Spinner$1, { color: '#000', size: 'md' })
        );
    }

    var loginTime = profile && profile.extraInfo && profile.extraInfo.loginTime ? moment(profile.extraInfo.loginTime).locale('da').format('[Sidste log ind:] D. MMMM YYYY, [kl.] HH:mm:ss') : '';

    var handleChangeEmail = function handleChangeEmail(value) {
        setFormTouched(true);
        setEmailTouched(true);
        setEmail(cutWhiteSpaces(value));
    };

    var handleChangePhone = function handleChangePhone(value) {
        setFormTouched(true);
        setPhone(value);
    };

    var theme = themesMap$6[currentTheme];

    return React.createElement(
        ThemeProvider,
        { theme: theme },
        React.createElement(
            Wrapper$a,
            null,
            React.createElement(
                Text,
                { size: 18, weight: '900', padding: '5px 0 5px 5px', margin: '0' },
                profile && profile.firstName,
                ' ',
                profile && profile.lastName
            ),
            React.createElement(
                Text,
                {
                    size: 14,
                    color: theme.colors.colorTextSecondaryDefault,
                    padding: '5px 0 5px 5px',
                    margin: '0'
                },
                loginTime
            ),
            React.createElement(ValidatingInput, {
                autoFocus: true,
                type: 'text',
                title: 'Email',
                name: 'email',
                autoComplete: 'new-email',
                onCheckValue: checkValue,
                validate: 'required, email',
                value: email,
                onChangeHandler: handleChangeEmail,
                validateOnChange: true,
                successBorderColor: theme.colors.colorBorderSecondaryHover,
                disabled: loading
            }),
            React.createElement(ValidatingInput, {
                onChangeHandler: handleChangePhone,
                onCheckValue: checkValue,
                type: 'number',
                title: 'Telefonnummer',
                validate: 'required, min, max, numeric',
                min: 8,
                max: 8,
                value: phone,
                name: 'phone',
                placeholder: '+45',
                autoComplete: 'new-phone-number',
                allowEmptyFormatting: true,
                format: '+45 ## ## ## ##',
                validateOnChange: true,
                successBorderColor: theme.colors.colorBorderSecondaryHover,
                disabled: loading
            }),
            React.createElement(
                ProfileCard,
                null,
                React.createElement(
                    'div',
                    { className: 'pb-5' },
                    'Navn: ',
                    profile && profile.firstName,
                    ' ',
                    profile && profile.lastName
                ),
                React.createElement(
                    'div',
                    { className: 'pb-5' },
                    'Adresse: ',
                    profile && profile.address,
                    ',',
                    ' ',
                    profile && profile.zip,
                    ' ',
                    profile && profile.city
                ),
                React.createElement(
                    'div',
                    { className: 'pb-5' },
                    'Brugernavn: ',
                    profile && profile.userName
                ),
                React.createElement(
                    AddressChangeInfo,
                    null,
                    'Har du \xE6ndret navn eller adresse bedes du kontakte vores',
                    ' ',
                    React.createElement(
                        Link$1,
                        { onClick: function onClick() {
                                return window.Intercom('show');
                            }, bold: true },
                        'support'
                    ),
                    ' ',
                    'for at \xE6ndre dette.'
                )
            ),
            React.createElement(
                ButtonsArea$1,
                null,
                React.createElement(
                    Button$1,
                    {
                        maxWidth: APPLY_BUTTON_MAX_WIDTH,
                        disabled: disallowFormSubmit,
                        onClick: submitProfile,
                        fontSize: '13px',
                        fontWeight: 700
                    },
                    updateLoading ? React.createElement(Spinner$1, { color: '#000', size: 'md' }) : 'Gem og forsæt'
                )
            )
        )
    );
};

var getDisplayName_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

exports.default = getDisplayName;
});

unwrapExports(getDisplayName_1);

var wrapDisplayName_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;



var _getDisplayName2 = _interopRequireDefault(getDisplayName_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;
});

unwrapExports(wrapDisplayName_1);

var createHelper_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
var createHelper = function createHelper(func$$1, helperName) {
  var setDisplayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var noArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (process.env.NODE_ENV !== 'production' && setDisplayName) {
    var _ret = function () {
      /* eslint-disable global-require */
      var wrapDisplayName = wrapDisplayName_1.default;
      /* eslint-enable global-require */

      if (noArgs) {
        return {
          v: function v(BaseComponent) {
            var Component$$1 = func$$1(BaseComponent);
            Component$$1.displayName = wrapDisplayName(BaseComponent, helperName);
            return Component$$1;
          }
        };
      }

      return {
        v: function v() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return function (BaseComponent) {
            var Component$$1 = func$$1.apply(undefined, args)(BaseComponent);
            Component$$1.displayName = wrapDisplayName(BaseComponent, helperName);
            return Component$$1;
          };
        }
      };
    }();

    if (typeof _ret === "object") return _ret.v;
  }

  return func$$1;
};

exports.default = createHelper;
});

unwrapExports(createHelper_1);

var createEagerElementUtil_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
  if (!hasKey && isReferentiallyTransparent) {
    if (children) {
      return type(_extends({}, props, { children: children }));
    }
    return type(props);
  }

  var Component$$1 = type;

  if (children) {
    return _react2.default.createElement(
      Component$$1,
      props,
      children
    );
  }

  return _react2.default.createElement(Component$$1, props);
};

exports.default = createEagerElementUtil;
});

unwrapExports(createEagerElementUtil_1);

var isClassComponent_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.isReactComponent === 'object');
};

exports.default = isClassComponent;
});

unwrapExports(isClassComponent_1);

var isReferentiallyTransparentFunctionComponent_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;



var _isClassComponent2 = _interopRequireDefault(isClassComponent_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component$$1) {
  return Boolean(typeof Component$$1 === 'function' && !(0, _isClassComponent2.default)(Component$$1) && !Component$$1.defaultProps && !Component$$1.contextTypes && (process.env.NODE_ENV === 'production' || !Component$$1.propTypes));
};

exports.default = isReferentiallyTransparentFunctionComponent;
});

unwrapExports(isReferentiallyTransparentFunctionComponent_1);

var createEagerFactory = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;



var _createEagerElementUtil2 = _interopRequireDefault(createEagerElementUtil_1);



var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(isReferentiallyTransparentFunctionComponent_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createFactory = function createFactory(type) {
  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
  return function (p, c) {
    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
  };
};

exports.default = createFactory;
});

unwrapExports(createEagerFactory);

var defaultProps_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;



var _createHelper2 = _interopRequireDefault(createHelper_1);



var _createEagerFactory2 = _interopRequireDefault(createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    return DefaultProps;
  };
};

exports.default = (0, _createHelper2.default)(defaultProps, 'defaultProps');
});

var _defaultProps = unwrapExports(defaultProps_1);

var classnames = createCommonjsModule$1(function (module) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var pick_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

exports.default = pick;
});

unwrapExports(pick_1);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

var hasOwnProperty$1 = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty$1.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

var shallowEqual_1 = shallowEqual;

var shallowEqual$1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;



var _shallowEqual2 = _interopRequireDefault(shallowEqual_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;
});

unwrapExports(shallowEqual$1);

var withPropsOnChange_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var _pick2 = _interopRequireDefault(pick_1);



var _shallowEqual2 = _interopRequireDefault(shallowEqual$1);



var _createHelper2 = _interopRequireDefault(createHelper_1);



var _createEagerFactory2 = _interopRequireDefault(createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !(0, _shallowEqual2.default)((0, _pick2.default)(props, shouldMapOrKeys), (0, _pick2.default)(nextProps, shouldMapOrKeys));
    };

    return function (_Component) {
      _inherits(_class2, _Component);

      function _class2() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
      }

      _class2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      _class2.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return _class2;
    }(React.Component);
  };
};

exports.default = (0, _createHelper2.default)(withPropsOnChange, 'withPropsOnChange');
});

var _withPropsOnChange = unwrapExports(withPropsOnChange_1);

var interopRequireDefault$1 = createCommonjsModule$1(function (module) {
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(interopRequireDefault$1);

var inDOM = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(inDOM);

var scrollbarSize_1 = createCommonjsModule$1(function (module, exports) {



exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = interopRequireDefault$1(inDOM);

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];
});

var getScrollbarSize = unwrapExports(scrollbarSize_1);

var MILLISECONDS_IN_MINUTE = 60000;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
var getTimezoneOffsetInMilliseconds = function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = date.getTimezoneOffset();
  date.setSeconds(0, 0);
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
};

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

var is_date = isDate;

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE$1 = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;

var parseTokenDateTimeDelimeter = /[T ]/;
var parseTokenPlainTime = /:/;

// year tokens
var parseTokenYY = /^(\d{2})$/;
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
];

var parseTokenYYYY = /^(\d{4})/;
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
];

// date tokens
var parseTokenMM = /^-(\d{2})$/;
var parseTokenDDD = /^-?(\d{3})$/;
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/;
var parseTokenWww = /^-?W(\d{2})$/;
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/;

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/;
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/;
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/;

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/;
var parseTokenTimezoneZ = /^(Z)$/;
var parseTokenTimezoneHH = /^([+-])(\d{2})$/;
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/;

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (is_date(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits;
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS;
  } else {
    additionalDigits = Number(additionalDigits);
  }

  var dateStrings = splitDateString(argument);

  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;

  var date = parseDate(restDateString, year);

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE$1;
    } else {
      var fullTime = timestamp + time;
      var fullTimeDate = new Date(fullTime);

      offset = getTimezoneOffsetInMilliseconds(fullTimeDate);

      // Adjust time when it's coming from DST
      var fullTimeDateNextDay = new Date(fullTime);
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1);
      var offsetDiff =
        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
        getTimezoneOffsetInMilliseconds(fullTimeDate);
      if (offsetDiff > 0) {
        offset += offsetDiff;
      }
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {};
  var array$$1 = dateString.split(parseTokenDateTimeDelimeter);
  var timeString;

  if (parseTokenPlainTime.test(array$$1[0])) {
    dateStrings.date = null;
    timeString = array$$1[0];
  } else {
    dateStrings.date = array$$1[0];
    timeString = array$$1[1];
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits];
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits];

  var token;

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString);
  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString);
  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token;
  var date;
  var month;
  var week;

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    date.setUTCFullYear(year, month);
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString);
  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);
    date.setUTCFullYear(year, 0, dayOfYear);
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);
    date.setUTCFullYear(year, month, day);
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token;
  var hours;
  var minutes;

  // hh
  token = parseTokenHH.exec(timeString);
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE$1
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE$1 +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token;
  var absoluteOffset;

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString);
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString);
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60;
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString);
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

var parse_1 = parse;

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse_1(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate()
}

var get_days_in_month = getDaysInMonth;

/**
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of week
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate) {
  var date = parse_1(dirtyDate);
  var day = date.getDay();
  return day
}

var get_day = getDay;

/**
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare) {
  var date = parse_1(dirtyDate);
  var dateToCompare = parse_1(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime()
}

var is_after = isAfter;

/**
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare) {
  var date = parse_1(dirtyDate);
  var dateToCompare = parse_1(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime()
}

var is_before = isBefore;

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse_1(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date
}

var start_of_day = startOfDay;

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = start_of_day(dirtyDateLeft);
  var dateRightStartOfDay = start_of_day(dirtyDateRight);

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

var is_same_day = isSameDay;

/**
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay (dirtyDate) {
  var date = parse_1(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date
}

var end_of_day = endOfDay;

function easing(time) {
  return 1 - --time * time * time * time;
}
/**
 * Given a start/end point of a scroll and time elapsed, calculate the scroll position we should be at
 * @param {Number} start - the initial value
 * @param {Number} stop - the final desired value
 * @param {Number} elapsed - the amount of time elapsed since we started animating
 * @param {Number} - duration - the duration of the animation
 * @return {Number} - The value we should use on the next tick
 */
function getValue(start, end, elapsed, duration) {
  if (elapsed > duration) return end;
  return start + (end - start) * easing(elapsed / duration);
}
/**
 * Smoothly animate between two values
 * @param {Number} fromValue - the initial value
 * @param {Function} onUpdate - A function that is called on each tick
 * @param {Function} onComplete - A callback that is fired once the scroll animation ends
 * @param {Number} duration - the desired duration of the scroll animation
 */
function animate(_ref) {
  var fromValue = _ref.fromValue,
      toValue = _ref.toValue,
      onUpdate = _ref.onUpdate,
      onComplete = _ref.onComplete,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 600 : _ref$duration;

  var startTime = performance.now();

  var tick = function tick() {
    var elapsed = performance.now() - startTime;

    window.requestAnimationFrame(function () {
      return onUpdate(getValue(fromValue, toValue, elapsed, duration),
      // Callback
      elapsed <= duration ? tick : onComplete);
    });
  };

  tick();
}

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


var keyCodes = {
  command: 91,
  control: 17,
  down: 40,
  enter: 13,
  escape: 27,
  left: 37,
  right: 39,
  shift: 16,
  up: 38
};

/**
 * Given a year and a month, returns the rows for that month to be iterated over
 * @param {Number} year - the year number
 * @param {Number} month - the index of the month
 * @param {Number} weekStartsOn - the index of the first day of the week (from 0 to 6)
 * @return {Object} - Returns the first day of the month and the rows of that month
 */
function getMonth(year, month, weekStartsOn) {
  var rows = [];
  var monthDate = new Date(year, month, 1);
  var daysInMonth = get_days_in_month(monthDate);
  var weekEndsOn = getEndOfWeekIndex(weekStartsOn);

  var dow = get_day(new Date(year, month, 1));
  var week = 0;

  for (var day = 1; day <= daysInMonth; day++) {
    if (!rows[week]) {
      rows[week] = [];
    }

    rows[week].push(day);

    if (dow === weekEndsOn) {
      week++;
    }

    dow = dow < 6 ? dow + 1 : 0;
  }

  return {
    date: monthDate,
    rows: rows
  };
}

function getWeek(yearStart, date, weekStartsOn) {
  var yearStartDate = typeof yearStart === 'number' ? new Date(yearStart, 0, 1) // 1st Jan of the Year
  : yearStart;

  return Math.ceil((Math.round((date - yearStartDate) / (60 * 60 * 24 * 1000)) + yearStartDate.getDay() + 1 - weekStartsOn) / 7);
}

/**
 * Get the number of weeks in a given month to be able to calculate the height of that month
 * @param {Number} year - the year number
 * @param {Number} month - the index of the month
 * @param {Number} weekStartsOn - the index of the first day of the week (from 0 to 6)
 * @return {Number} - Returns the number of weeks for the given month
 */
function getWeeksInMonth(month) {
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date().getFullYear();
  var weekStartsOn = arguments[2];
  var isLastDisplayedMonth = arguments[3];

  var weekEndsOn = getEndOfWeekIndex(weekStartsOn);

  var firstOfMonth = new Date(year, month, 1);
  var firstWeekNumber = getWeek(year, firstOfMonth, weekStartsOn);

  var lastOfMonth = new Date(year, month + 1, 0); // Last date of the Month
  var lastWeekNumber = getWeek(year, lastOfMonth, weekStartsOn);

  var rowCount = lastWeekNumber - firstWeekNumber;

  // If the last week contains 7 days, we need to add an extra row
  if (lastOfMonth.getDay() === weekEndsOn || isLastDisplayedMonth) {
    rowCount++;
  }

  return rowCount;
}

/**
 * Helper to find out what day the week ends on given the localized start of the week
 * @param {Number} weekStartsOn - the index of the first day of the week (from 0 to 6)
 * @return {Number} - Returns the index of the day the week ends on
 */
function getEndOfWeekIndex(weekStartsOn) {
  var weekEndsOn = weekStartsOn === 0 ? 6 : weekStartsOn - 1;

  return weekEndsOn;
}

var ScrollSpeed = function () {
  function ScrollSpeed() {
    var _this = this;

    _classCallCheck$1(this, ScrollSpeed);

    this.clear = function () {
      _this.lastPosition = null;
      _this.delta = 0;
    };
  }

  ScrollSpeed.prototype.getScrollSpeed = function getScrollSpeed(scrollOffset) {
    if (this.lastPosition != null) {
      this.delta = scrollOffset - this.lastPosition;
    }
    this.lastPosition = scrollOffset;

    clearTimeout(this._timeout);
    this._timeout = setTimeout(this.clear, 50);

    return this.delta;
  };

  return ScrollSpeed;
}();

var scrollbarSize = getScrollbarSize();

function emptyFn() {
  /* no-op */
}

function sanitizeDate(date, _ref) {
  var _ref$disabledDates = _ref.disabledDates,
      disabledDates = _ref$disabledDates === undefined ? [] : _ref$disabledDates,
      _ref$disabledDays = _ref.disabledDays,
      disabledDays = _ref$disabledDays === undefined ? [] : _ref$disabledDays,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate;

  // Selected date should not be disabled or outside the selectable range
  if (!date || disabledDates.some(function (disabledDate) {
    return is_same_day(disabledDate, date);
  }) || disabledDays && disabledDays.indexOf(get_day(date)) !== -1 || minDate && is_before(date, start_of_day(minDate)) || maxDate && is_after(date, end_of_day(maxDate))) {
    return null;
  }

  return date;
}

function getDateString(year, month, date) {
  return year + '-' + ('0' + (month + 1)).slice(-2) + '-' + ('0' + date).slice(-2);
}

function getMonthsForYear(year) {
  var day = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return Array.apply(null, Array(12)).map(function (val, index) {
    return new Date(year, index, day);
  });
}

var withImmutableProps = function withImmutableProps(props) {
  return _withPropsOnChange(function () {
    return false;
  }, props);
};

function debounce(callback, wait) {
  var _this2 = this;

  var timeout = null;
  var callbackArgs = null;

  var later = function later() {
    return callback.apply(_this2, callbackArgs);
  };

  return function () {
    callbackArgs = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function range(start, stop) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var length = Math.max(Math.ceil((stop - start) / step), 0);
  var range = Array(length);

  for (var i = 0; i < length; i++, start += step) {
    range[i] = start;
  }

  return range;
}

var defaultDisplayOptions = {
  hideYearsOnSelect: true,
  layout: 'portrait',
  overscanMonthCount: 2,
  shouldHeaderAnimate: true,
  showHeader: true,
  showMonthsForYears: true,
  showOverlay: true,
  showTodayHelper: true,
  showWeekdays: true,
  todayHelperRowOffset: 4
};

var defaultLocale = {
  blank: 'Select a date...',
  headerFormat: 'ddd, MMM Do',
  todayLabel: {
    long: 'Today'
  },
  weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  weekStartsOn: 0
};

var defaultTheme$2 = {
  accentColor: '#448AFF',
  floatingNav: {
    background: 'rgba(56, 87, 138, 0.94)',
    chevron: '#FFA726',
    color: '#FFF'
  },
  headerColor: '#448AFF',
  selectionColor: '#559FFF',
  textColor: {
    active: '#FFF',
    default: '#333'
  },
  todayColor: '#FFA726',
  weekdayColor: '#559FFF'
};

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var styles = {
  'root': 'Cal__Today__root',
  'show': 'Cal__Today__show',
  'chevron': 'Cal__Today__chevron',
  'chevronUp': 'Cal__Today__chevronUp',
  'chevronDown': 'Cal__Today__chevronDown'
};


var DIRECTION_UP = 1;
var DIRECTION_DOWN = -1;
var CHEVRON = 'M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9 c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3 z';

var Today = function (_PureComponent) {
  _inherits$1(Today, _PureComponent);

  function Today() {
    var _temp, _this, _ret;

    _classCallCheck$2(this, Today);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$1(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.scrollToToday = function () {
      var scrollToDate = _this.props.scrollToDate;


      scrollToDate(new Date(), -40, true);
    }, _temp), _possibleConstructorReturn$1(_this, _ret);
  }

  Today.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        todayLabel = _props.todayLabel,
        show = _props.show,
        theme = _props.theme;

    return React.createElement(
      'div',
      {
        className: classnames(styles.root, (_classNames = {}, _classNames[styles.show] = show, _classNames[styles.chevronUp] = show === DIRECTION_UP, _classNames[styles.chevronDown] = show === DIRECTION_DOWN, _classNames)),
        style: {
          backgroundColor: theme.floatingNav.background,
          color: theme.floatingNav.color
        },
        onClick: this.scrollToToday,
        ref: 'node'
      },
      todayLabel,
      React.createElement(
        'svg',
        {
          className: styles.chevron,
          x: '0px',
          y: '0px',
          width: '14px',
          height: '14px',
          viewBox: '0 0 512 512'
        },
        React.createElement('path', {
          fill: theme.floatingNav.chevron || theme.floatingNav.color,
          d: CHEVRON
        })
      )
    );
  };

  return Today;
}(PureComponent);
process.env.NODE_ENV !== "production" ? Today.propTypes = {
  scrollToDate: PropTypes.func,
  show: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  theme: PropTypes.object,
  todayLabel: PropTypes.string
} : void 0;

var chainFunction = function chain(){
  var len = arguments.length;
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i];

  args = args.filter(function(fn){ return fn != null });

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
};

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

var warning_1 = warning;

var ChildMapping = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;



/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  React.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}
});

unwrapExports(ChildMapping);
var ChildMapping_1 = ChildMapping.getChildMapping;
var ChildMapping_2 = ChildMapping.mergeChildMappings;

var TransitionGroup_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _chainFunction2 = _interopRequireDefault(chainFunction);



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _warning2 = _interopRequireDefault(warning_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

        process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];
});

unwrapExports(TransitionGroup_1);

var hasClass_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];
});

unwrapExports(hasClass_1);

var addClass_1 = createCommonjsModule$1(function (module, exports) {



exports.__esModule = true;
exports.default = addClass;

var _hasClass = interopRequireDefault$1(hasClass_1);

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];
});

unwrapExports(addClass_1);

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

var removeClass = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

var requestAnimationFrame = createCommonjsModule$1(function (module, exports) {



exports.__esModule = true;
exports.default = void 0;

var _inDOM = interopRequireDefault$1(inDOM);

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(requestAnimationFrame);

var properties = createCommonjsModule$1(function (module, exports) {



exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = interopRequireDefault$1(inDOM);

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}
});

unwrapExports(properties);
var properties_1 = properties.animationEnd;
var properties_2 = properties.animationDelay;
var properties_3 = properties.animationTiming;
var properties_4 = properties.animationDuration;
var properties_5 = properties.animationName;
var properties_6 = properties.transitionEnd;
var properties_7 = properties.transitionDuration;
var properties_8 = properties.transitionDelay;
var properties_9 = properties.transitionTiming;
var properties_10 = properties.transitionProperty;
var properties_11 = properties.transform;

var PropTypes$1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);
});

unwrapExports(PropTypes$1);
var PropTypes_1 = PropTypes$1.nameShape;
var PropTypes_2 = PropTypes$1.transitionTimeout;

var CSSTransitionGroupChild_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _addClass2 = _interopRequireDefault(addClass_1);



var _removeClass2 = _interopRequireDefault(removeClass);



var _requestAnimationFrame2 = _interopRequireDefault(requestAnimationFrame);





var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (properties.transitionEnd) events.push(properties.transitionEnd);
if (properties.animationEnd) events.push(properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: PropTypes$1.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];
});

unwrapExports(CSSTransitionGroupChild_1);

var CSSTransitionGroup_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _TransitionGroup2 = _interopRequireDefault(TransitionGroup_1);



var _CSSTransitionGroupChild2 = _interopRequireDefault(CSSTransitionGroupChild_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: PropTypes$1.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, PropTypes$1.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, PropTypes$1.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, PropTypes$1.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];
});

var CSSTransitionGroup = unwrapExports(CSSTransitionGroup_1);

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse_1(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date
}

var start_of_year = startOfYear;

var MILLISECONDS_IN_MINUTE$2 = 60000;
var MILLISECONDS_IN_DAY = 86400000;

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = start_of_day(dirtyDateLeft);
  var startOfDayRight = start_of_day(dirtyDateRight);

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$2;
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$2;

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

var difference_in_calendar_days = differenceInCalendarDays;

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse_1(dirtyDate);
  var diff = difference_in_calendar_days(date, start_of_year(date));
  var dayOfYear = diff + 1;
  return dayOfYear
}

var get_day_of_year = getDayOfYear;

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0;

  var date = parse_1(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date
}

var start_of_week = startOfWeek;

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return start_of_week(dirtyDate, {weekStartsOn: 1})
}

var start_of_iso_week = startOfISOWeek;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse_1(dirtyDate);
  var year = date.getFullYear();

  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = start_of_iso_week(fourthOfJanuaryOfNextYear);

  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = start_of_iso_week(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

var get_iso_year = getISOYear;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = get_iso_year(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = start_of_iso_week(fourthOfJanuary);
  return date
}

var start_of_iso_year = startOfISOYear;

var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse_1(dirtyDate);
  var diff = start_of_iso_week(date).getTime() - start_of_iso_year(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

var get_iso_week = getISOWeek;

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (is_date(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

var is_valid = isValid;

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  };

  function localize (token, count, options) {
    options = options || {};

    var result;
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token];
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one;
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count);
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

var build_distance_in_words_locale = buildDistanceInWordsLocale;

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
];

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = [];
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key);
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse();
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  );

  return formattingTokensRegExp
}

var build_formatting_tokens_reg_exp = buildFormattingTokensRegExp;

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var meridiemUppercase = ['AM', 'PM'];
  var meridiemLowercase = ['am', 'pm'];
  var meridiemFull = ['a.m.', 'p.m.'];

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  };

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W'];
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    };
  });

  return {
    formatters: formatters,
    formattingTokensRegExp: build_formatting_tokens_reg_exp(formatters)
  }
}

function ordinal (number$$1) {
  var rem100 = number$$1 % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number$$1 + 'st'
      case 2:
        return number$$1 + 'nd'
      case 3:
        return number$$1 + 'rd'
    }
  }
  return number$$1 + 'th'
}

var build_format_locale = buildFormatLocale;

/**
 * @category Locales
 * @summary English locale.
 */
var en = {
  distanceInWords: build_distance_in_words_locale(),
  format: build_format_locale()
};

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ';
  var options = dirtyOptions || {};

  var locale = options.locale;
  var localeFormatters = en.format.formatters;
  var formattingTokensRegExp = en.format.formattingTokensRegExp;
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters;

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp;
    }
  }

  var date = parse_1(dirtyDate);

  if (!is_valid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp);

  return formatFn(date)
}

var formatters$1 = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return get_day_of_year(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(get_day_of_year(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return get_iso_week(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(get_iso_week(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(get_iso_year(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return get_iso_year(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours();
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters$1['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
};

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array$$1 = formatStr.match(formattingTokensRegExp);
  var length = array$$1.length;

  var i;
  var formatter;
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array$$1[i]] || formatters$1[array$$1[i]];
    if (formatter) {
      array$$1[i] = formatter;
    } else {
      array$$1[i] = removeFormattingTokens(array$$1[i]);
    }
  }

  return function (date) {
    var output = '';
    for (var i = 0; i < length; i++) {
      if (array$$1[i] instanceof Function) {
        output += array$$1[i](date, formatters$1);
      } else {
        output += array$$1[i];
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number$$1, targetLength) {
  var output = Math.abs(number$$1).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return output
}

var format_1 = format;

var styles$1 = {
  'root': 'Cal__Header__root',
  'landscape': 'Cal__Header__landscape',
  'dateWrapper': 'Cal__Header__dateWrapper',
  'day': 'Cal__Header__day',
  'wrapper': 'Cal__Header__wrapper',
  'blank': 'Cal__Header__blank',
  'active': 'Cal__Header__active',
  'year': 'Cal__Header__year',
  'date': 'Cal__Header__date',
  'range': 'Cal__Header__range'
};
var animation$1 = {
  'enter': 'Cal__Animation__enter',
  'enterActive': 'Cal__Animation__enterActive',
  'leave': 'Cal__Animation__leave',
  'leaveActive': 'Cal__Animation__leaveActive'
};


function defaultSelectionRenderer(value, _ref) {
  var display = _ref.display,
      key = _ref.key,
      locale = _ref.locale.locale,
      dateFormat = _ref.dateFormat,
      onYearClick = _ref.onYearClick,
      scrollToDate = _ref.scrollToDate,
      setDisplay = _ref.setDisplay,
      shouldAnimate = _ref.shouldAnimate;

  var date = parse_1(value);
  var values = date && [{
    active: display === 'years',
    handleClick: function handleClick(e) {
      onYearClick(date, e, key);
      setDisplay('years');
    },
    item: 'year',
    title: display === 'days' ? 'Change year' : null,
    value: date.getFullYear()
  }, {
    active: display === 'days',
    handleClick: function handleClick(e) {
      if (display !== 'days') {
        setDisplay('days');
      } else if (date) {
        scrollToDate(date, -40, true);
      }
    },
    item: 'day',
    title: display === 'days' ? 'Scroll to ' + format_1(date, dateFormat, { locale: locale }) : null,
    value: format_1(date, dateFormat, { locale: locale })
  }];

  return React.createElement(
    'div',
    {
      key: key,
      className: styles$1.wrapper,
      'aria-label': format_1(date, dateFormat + ' YYYY', { locale: locale })
    },
    values.map(function (_ref2) {
      var _classNames;

      var handleClick = _ref2.handleClick,
          item = _ref2.item,
          key = _ref2.key,
          value = _ref2.value,
          active = _ref2.active,
          title = _ref2.title;

      return React.createElement(
        'div',
        {
          key: item,
          className: classnames(styles$1.dateWrapper, styles$1[item], (_classNames = {}, _classNames[styles$1.active] = active, _classNames)),
          title: title
        },
        React.createElement(
          CSSTransitionGroup,
          {
            transitionName: animation$1,
            transitionEnterTimeout: 250,
            transitionLeaveTimeout: 250,
            transitionEnter: shouldAnimate,
            transitionLeave: shouldAnimate
          },
          React.createElement(
            'span',
            {
              key: item + '-' + value,
              className: styles$1.date,
              'aria-hidden': true,
              onClick: handleClick
            },
            value
          )
        )
      );
    })
  );
}

var _class$1, _temp$1;

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var styles$2 = {
  'root': 'Cal__Header__root',
  'landscape': 'Cal__Header__landscape',
  'dateWrapper': 'Cal__Header__dateWrapper',
  'day': 'Cal__Header__day',
  'wrapper': 'Cal__Header__wrapper',
  'blank': 'Cal__Header__blank',
  'active': 'Cal__Header__active',
  'year': 'Cal__Header__year',
  'date': 'Cal__Header__date',
  'range': 'Cal__Header__range'
};
var Header = (_temp$1 = _class$1 = function (_PureComponent) {
  _inherits$2(Header, _PureComponent);

  function Header() {
    _classCallCheck$3(this, Header);

    return _possibleConstructorReturn$2(this, _PureComponent.apply(this, arguments));
  }

  Header.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        layout = _props.layout,
        blank = _props.locale.blank,
        selected = _props.selected,
        renderSelection = _props.renderSelection,
        theme = _props.theme;


    return React.createElement(
      'div',
      {
        className: classnames(styles$2.root, (_classNames = {}, _classNames[styles$2.landscape] = layout === 'landscape', _classNames)),
        style: {
          backgroundColor: theme.headerColor,
          color: theme.textColor.active
        }
      },
      selected && renderSelection(selected, this.props) || React.createElement(
        'div',
        { className: classnames(styles$2.wrapper, styles$2.blank) },
        blank
      )
    );
  };

  return Header;
}(PureComponent), _class$1.defaultProps = {
  onYearClick: emptyFn,
  renderSelection: defaultSelectionRenderer
}, _temp$1);
process.env.NODE_ENV !== "production" ? Header.propTypes = {
  dateFormat: PropTypes.string,
  display: PropTypes.string,
  layout: PropTypes.string,
  locale: PropTypes.object,
  onYearClick: PropTypes.func,
  selected: PropTypes.any,
  shouldAnimate: PropTypes.bool,
  theme: PropTypes.object
} : void 0;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var ALIGNMENT;
(function (ALIGNMENT) {
    ALIGNMENT["AUTO"] = "auto";
    ALIGNMENT["START"] = "start";
    ALIGNMENT["CENTER"] = "center";
    ALIGNMENT["END"] = "end";
})(ALIGNMENT || (ALIGNMENT = {}));
var DIRECTION;
(function (DIRECTION) {
    DIRECTION["HORIZONTAL"] = "horizontal";
    DIRECTION["VERTICAL"] = "vertical";
})(DIRECTION || (DIRECTION = {}));
var SCROLL_CHANGE_REASON;
(function (SCROLL_CHANGE_REASON) {
    SCROLL_CHANGE_REASON["OBSERVED"] = "observed";
    SCROLL_CHANGE_REASON["REQUESTED"] = "requested";
})(SCROLL_CHANGE_REASON || (SCROLL_CHANGE_REASON = {}));
var scrollProp = (_a = {}, _a[DIRECTION.VERTICAL] = 'scrollTop', _a[DIRECTION.HORIZONTAL] = 'scrollLeft', _a);
var sizeProp = (_b = {}, _b[DIRECTION.VERTICAL] = 'height', _b[DIRECTION.HORIZONTAL] = 'width', _b);
var positionProp = (_c = {}, _c[DIRECTION.VERTICAL] = 'top', _c[DIRECTION.HORIZONTAL] = 'left', _c);
var marginProp = (_d = {}, _d[DIRECTION.VERTICAL] = 'marginTop', _d[DIRECTION.HORIZONTAL] = 'marginLeft', _d);
var oppositeMarginProp = (_e = {}, _e[DIRECTION.VERTICAL] = 'marginBottom', _e[DIRECTION.HORIZONTAL] = 'marginRight', _e);
var _a;
var _b;
var _c;
var _d;
var _e;

/* Forked from react-virtualized 💖 */
var SizeAndPositionManager = /** @class */function () {
    function SizeAndPositionManager(_a) {
        var itemCount = _a.itemCount,
            itemSizeGetter = _a.itemSizeGetter,
            estimatedItemSize = _a.estimatedItemSize;
        this.itemSizeGetter = itemSizeGetter;
        this.itemCount = itemCount;
        this.estimatedItemSize = estimatedItemSize;
        // Cache of size and position data for items, mapped by item index.
        this.itemSizeAndPositionData = {};
        // Measurements for items up to this index can be trusted; items afterward should be estimated.
        this.lastMeasuredIndex = -1;
    }
    SizeAndPositionManager.prototype.updateConfig = function (_a) {
        var itemCount = _a.itemCount,
            itemSizeGetter = _a.itemSizeGetter,
            estimatedItemSize = _a.estimatedItemSize;
        if (itemCount != null) {
            this.itemCount = itemCount;
        }
        if (estimatedItemSize != null) {
            this.estimatedItemSize = estimatedItemSize;
        }
        if (itemSizeGetter != null) {
            this.itemSizeGetter = itemSizeGetter;
        }
    };
    SizeAndPositionManager.prototype.getLastMeasuredIndex = function () {
        return this.lastMeasuredIndex;
    };
    /**
     * This method returns the size and position for the item at the specified index.
     * It just-in-time calculates (or used cached values) for items leading up to the index.
     */
    SizeAndPositionManager.prototype.getSizeAndPositionForIndex = function (index) {
        if (index < 0 || index >= this.itemCount) {
            throw Error("Requested index " + index + " is outside of range 0.." + this.itemCount);
        }
        if (index > this.lastMeasuredIndex) {
            var lastMeasuredSizeAndPosition = this.getSizeAndPositionOfLastMeasuredItem();
            var offset = lastMeasuredSizeAndPosition.offset + lastMeasuredSizeAndPosition.size;
            for (var i = this.lastMeasuredIndex + 1; i <= index; i++) {
                var size = this.itemSizeGetter(i);
                if (size == null || isNaN(size)) {
                    throw Error("Invalid size returned for index " + i + " of value " + size);
                }
                this.itemSizeAndPositionData[i] = {
                    offset: offset,
                    size: size
                };
                offset += size;
            }
            this.lastMeasuredIndex = index;
        }
        return this.itemSizeAndPositionData[index];
    };
    SizeAndPositionManager.prototype.getSizeAndPositionOfLastMeasuredItem = function () {
        return this.lastMeasuredIndex >= 0 ? this.itemSizeAndPositionData[this.lastMeasuredIndex] : { offset: 0, size: 0 };
    };
    /**
     * Total size of all items being measured.
     * This value will be completedly estimated initially.
     * As items as measured the estimate will be updated.
     */
    SizeAndPositionManager.prototype.getTotalSize = function () {
        var lastMeasuredSizeAndPosition = this.getSizeAndPositionOfLastMeasuredItem();
        return lastMeasuredSizeAndPosition.offset + lastMeasuredSizeAndPosition.size + (this.itemCount - this.lastMeasuredIndex - 1) * this.estimatedItemSize;
    };
    /**
     * Determines a new offset that ensures a certain item is visible, given the alignment.
     *
     * @param align Desired alignment within container; one of "start" (default), "center", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @return Offset to use to ensure the specified item is visible
     */
    SizeAndPositionManager.prototype.getUpdatedOffsetForIndex = function (_a) {
        var _b = _a.align,
            align = _b === void 0 ? ALIGNMENT.START : _b,
            containerSize = _a.containerSize,
            currentOffset = _a.currentOffset,
            targetIndex = _a.targetIndex;
        if (containerSize <= 0) {
            return 0;
        }
        var datum = this.getSizeAndPositionForIndex(targetIndex);
        var maxOffset = datum.offset;
        var minOffset = maxOffset - containerSize + datum.size;
        var idealOffset;
        switch (align) {
            case ALIGNMENT.END:
                idealOffset = minOffset;
                break;
            case ALIGNMENT.CENTER:
                idealOffset = maxOffset - (containerSize - datum.size) / 2;
                break;
            case ALIGNMENT.START:
                idealOffset = maxOffset;
                break;
            default:
                idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
        }
        var totalSize = this.getTotalSize();
        return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    };
    SizeAndPositionManager.prototype.getVisibleRange = function (_a) {
        var containerSize = _a.containerSize,
            offset = _a.offset,
            overscanCount = _a.overscanCount;
        var totalSize = this.getTotalSize();
        if (totalSize === 0) {
            return {};
        }
        var maxOffset = offset + containerSize;
        var start = this.findNearestItem(offset);
        if (typeof start === 'undefined') {
            throw Error("Invalid offset " + offset + " specified");
        }
        var datum = this.getSizeAndPositionForIndex(start);
        offset = datum.offset + datum.size;
        var stop = start;
        while (offset < maxOffset && stop < this.itemCount - 1) {
            stop++;
            offset += this.getSizeAndPositionForIndex(stop).size;
        }
        if (overscanCount) {
            start = Math.max(0, start - overscanCount);
            stop = Math.min(stop + overscanCount, this.itemCount - 1);
        }
        return {
            start: start,
            stop: stop
        };
    };
    /**
     * Clear all cached values for items after the specified index.
     * This method should be called for any item that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionForIndex() is called.
     */
    SizeAndPositionManager.prototype.resetItem = function (index) {
        this.lastMeasuredIndex = Math.min(this.lastMeasuredIndex, index - 1);
    };
    /**
     * Searches for the item (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest item index will be returned.
     * This allows partially visible items (with offsets just before/above the fold) to be visible.
     */
    SizeAndPositionManager.prototype.findNearestItem = function (offset) {
        if (isNaN(offset)) {
            throw Error("Invalid offset " + offset + " specified");
        }
        // Our search algorithms find the nearest match at or below the specified offset.
        // So make sure the offset is at least 0 or no match will be found.
        offset = Math.max(0, offset);
        var lastMeasuredSizeAndPosition = this.getSizeAndPositionOfLastMeasuredItem();
        var lastMeasuredIndex = Math.max(0, this.lastMeasuredIndex);
        if (lastMeasuredSizeAndPosition.offset >= offset) {
            // If we've already measured items within this range just use a binary search as it's faster.
            return this.binarySearch({
                high: lastMeasuredIndex,
                low: 0,
                offset: offset
            });
        } else {
            // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
            // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
            // The overall complexity for this approach is O(log n).
            return this.exponentialSearch({
                index: lastMeasuredIndex,
                offset: offset
            });
        }
    };
    SizeAndPositionManager.prototype.binarySearch = function (_a) {
        var low = _a.low,
            high = _a.high,
            offset = _a.offset;
        var middle = 0;
        var currentOffset = 0;
        while (low <= high) {
            middle = low + Math.floor((high - low) / 2);
            currentOffset = this.getSizeAndPositionForIndex(middle).offset;
            if (currentOffset === offset) {
                return middle;
            } else if (currentOffset < offset) {
                low = middle + 1;
            } else if (currentOffset > offset) {
                high = middle - 1;
            }
        }
        if (low > 0) {
            return low - 1;
        }
        return 0;
    };
    SizeAndPositionManager.prototype.exponentialSearch = function (_a) {
        var index = _a.index,
            offset = _a.offset;
        var interval = 1;
        while (index < this.itemCount && this.getSizeAndPositionForIndex(index).offset < offset) {
            index += interval;
            interval *= 2;
        }
        return this.binarySearch({
            high: Math.min(index, this.itemCount - 1),
            low: Math.floor(index / 2),
            offset: offset
        });
    };
    return SizeAndPositionManager;
}();

var STYLE_WRAPPER = {
    overflow: 'auto',
    willChange: 'transform',
    WebkitOverflowScrolling: 'touch'
};
var STYLE_INNER = {
    position: 'relative',
    width: '100%',
    minHeight: '100%'
};
var STYLE_ITEM = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%'
};
var STYLE_STICKY_ITEM = __assign({}, STYLE_ITEM, { position: 'sticky' });
var VirtualList = /** @class */function (_super) {
    __extends(VirtualList, _super);
    function VirtualList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itemSizeGetter = function (itemSize) {
            return function (index) {
                return _this.getSize(index, itemSize);
            };
        };
        _this.sizeAndPositionManager = new SizeAndPositionManager({
            itemCount: _this.props.itemCount,
            itemSizeGetter: _this.itemSizeGetter(_this.props.itemSize),
            estimatedItemSize: _this.getEstimatedItemSize()
        });
        _this.state = {
            offset: _this.props.scrollOffset || _this.props.scrollToIndex != null && _this.getOffsetForIndex(_this.props.scrollToIndex) || 0,
            scrollChangeReason: SCROLL_CHANGE_REASON.REQUESTED
        };
        _this.styleCache = {};
        _this.getRef = function (node) {
            _this.rootNode = node;
        };
        _this.handleScroll = function (event) {
            var onScroll = _this.props.onScroll;
            var offset = _this.getNodeOffset();
            if (offset < 0 || _this.state.offset === offset || event.target !== _this.rootNode) {
                return;
            }
            _this.setState({
                offset: offset,
                scrollChangeReason: SCROLL_CHANGE_REASON.OBSERVED
            });
            if (typeof onScroll === 'function') {
                onScroll(offset, event);
            }
        };
        return _this;
    }
    VirtualList.prototype.componentDidMount = function () {
        var _a = this.props,
            scrollOffset = _a.scrollOffset,
            scrollToIndex = _a.scrollToIndex;
        this.rootNode.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        if (scrollOffset != null) {
            this.scrollTo(scrollOffset);
        } else if (scrollToIndex != null) {
            this.scrollTo(this.getOffsetForIndex(scrollToIndex));
        }
    };
    VirtualList.prototype.componentWillReceiveProps = function (nextProps) {
        var _a = this.props,
            estimatedItemSize = _a.estimatedItemSize,
            itemCount = _a.itemCount,
            itemSize = _a.itemSize,
            scrollOffset = _a.scrollOffset,
            scrollToAlignment = _a.scrollToAlignment,
            scrollToIndex = _a.scrollToIndex;
        var scrollPropsHaveChanged = nextProps.scrollToIndex !== scrollToIndex || nextProps.scrollToAlignment !== scrollToAlignment;
        var itemPropsHaveChanged = nextProps.itemCount !== itemCount || nextProps.itemSize !== itemSize || nextProps.estimatedItemSize !== estimatedItemSize;
        if (nextProps.itemSize !== itemSize) {
            this.sizeAndPositionManager.updateConfig({
                itemSizeGetter: this.itemSizeGetter(nextProps.itemSize)
            });
        }
        if (nextProps.itemCount !== itemCount || nextProps.estimatedItemSize !== estimatedItemSize) {
            this.sizeAndPositionManager.updateConfig({
                itemCount: nextProps.itemCount,
                estimatedItemSize: this.getEstimatedItemSize(nextProps)
            });
        }
        if (itemPropsHaveChanged) {
            this.recomputeSizes();
        }
        if (nextProps.scrollOffset !== scrollOffset) {
            this.setState({
                offset: nextProps.scrollOffset || 0,
                scrollChangeReason: SCROLL_CHANGE_REASON.REQUESTED
            });
        } else if (typeof nextProps.scrollToIndex === 'number' && (scrollPropsHaveChanged || itemPropsHaveChanged)) {
            this.setState({
                offset: this.getOffsetForIndex(nextProps.scrollToIndex, nextProps.scrollToAlignment, nextProps.itemCount),
                scrollChangeReason: SCROLL_CHANGE_REASON.REQUESTED
            });
        }
    };
    VirtualList.prototype.componentDidUpdate = function (_, prevState) {
        var _a = this.state,
            offset = _a.offset,
            scrollChangeReason = _a.scrollChangeReason;
        if (prevState.offset !== offset && scrollChangeReason === SCROLL_CHANGE_REASON.REQUESTED) {
            this.scrollTo(offset);
        }
    };
    VirtualList.prototype.componentWillUnmount = function () {
        this.rootNode.removeEventListener('scroll', this.handleScroll);
    };
    VirtualList.prototype.scrollTo = function (value) {
        var _a = this.props.scrollDirection,
            scrollDirection = _a === void 0 ? DIRECTION.VERTICAL : _a;
        this.rootNode[scrollProp[scrollDirection]] = value;
    };
    VirtualList.prototype.getOffsetForIndex = function (index, scrollToAlignment, itemCount) {
        if (scrollToAlignment === void 0) {
            scrollToAlignment = this.props.scrollToAlignment;
        }
        if (itemCount === void 0) {
            itemCount = this.props.itemCount;
        }
        var _a = this.props.scrollDirection,
            scrollDirection = _a === void 0 ? DIRECTION.VERTICAL : _a;
        if (index < 0 || index >= itemCount) {
            index = 0;
        }
        return this.sizeAndPositionManager.getUpdatedOffsetForIndex({
            align: scrollToAlignment,
            containerSize: this.props[sizeProp[scrollDirection]],
            currentOffset: this.state && this.state.offset || 0,
            targetIndex: index
        });
    };
    VirtualList.prototype.recomputeSizes = function (startIndex) {
        if (startIndex === void 0) {
            startIndex = 0;
        }
        this.styleCache = {};
        this.sizeAndPositionManager.resetItem(startIndex);
    };
    VirtualList.prototype.render = function () {
        var _this = this;
        var _a = this.props,
            estimatedItemSize = _a.estimatedItemSize,
            height = _a.height,
            _b = _a.overscanCount,
            overscanCount = _b === void 0 ? 3 : _b,
            renderItem = _a.renderItem,
            itemCount = _a.itemCount,
            itemSize = _a.itemSize,
            onItemsRendered = _a.onItemsRendered,
            onScroll = _a.onScroll,
            _c = _a.scrollDirection,
            scrollDirection = _c === void 0 ? DIRECTION.VERTICAL : _c,
            scrollOffset = _a.scrollOffset,
            scrollToIndex = _a.scrollToIndex,
            scrollToAlignment = _a.scrollToAlignment,
            stickyIndices = _a.stickyIndices,
            style = _a.style,
            width = _a.width,
            props = __rest(_a, ["estimatedItemSize", "height", "overscanCount", "renderItem", "itemCount", "itemSize", "onItemsRendered", "onScroll", "scrollDirection", "scrollOffset", "scrollToIndex", "scrollToAlignment", "stickyIndices", "style", "width"]);
        var offset = this.state.offset;
        var _d = this.sizeAndPositionManager.getVisibleRange({
            containerSize: this.props[sizeProp[scrollDirection]] || 0,
            offset: offset,
            overscanCount: overscanCount
        }),
            start = _d.start,
            stop = _d.stop;
        var items = [];
        var wrapperStyle = __assign({}, STYLE_WRAPPER, style, { height: height, width: width });
        var innerStyle = __assign({}, STYLE_INNER, (_e = {}, _e[sizeProp[scrollDirection]] = this.sizeAndPositionManager.getTotalSize(), _e));
        if (stickyIndices != null && stickyIndices.length !== 0) {
            stickyIndices.forEach(function (index) {
                return items.push(renderItem({
                    index: index,
                    style: _this.getStyle(index, true)
                }));
            });
            if (scrollDirection === DIRECTION.HORIZONTAL) {
                innerStyle.display = 'flex';
            }
        }
        if (typeof start !== 'undefined' && typeof stop !== 'undefined') {
            for (var index = start; index <= stop; index++) {
                if (stickyIndices != null && stickyIndices.includes(index)) {
                    continue;
                }
                items.push(renderItem({
                    index: index,
                    style: this.getStyle(index, false)
                }));
            }
            if (typeof onItemsRendered === 'function') {
                onItemsRendered({
                    startIndex: start,
                    stopIndex: stop
                });
            }
        }
        return createElement("div", __assign({ ref: this.getRef }, props, { style: wrapperStyle }), createElement("div", { style: innerStyle }, items));
        var _e;
    };
    VirtualList.prototype.getNodeOffset = function () {
        var _a = this.props.scrollDirection,
            scrollDirection = _a === void 0 ? DIRECTION.VERTICAL : _a;
        return this.rootNode[scrollProp[scrollDirection]];
    };
    VirtualList.prototype.getEstimatedItemSize = function (props) {
        if (props === void 0) {
            props = this.props;
        }
        return props.estimatedItemSize || typeof props.itemSize === 'number' && props.itemSize || 50;
    };
    VirtualList.prototype.getSize = function (index, itemSize) {
        if (typeof itemSize === 'function') {
            return itemSize(index);
        }
        return Array.isArray(itemSize) ? itemSize[index] : itemSize;
    };
    VirtualList.prototype.getStyle = function (index, sticky) {
        var style = this.styleCache[index];
        if (style) {
            return style;
        }
        var _a = this.props.scrollDirection,
            scrollDirection = _a === void 0 ? DIRECTION.VERTICAL : _a;
        var _b = this.sizeAndPositionManager.getSizeAndPositionForIndex(index),
            size = _b.size,
            offset = _b.offset;
        return this.styleCache[index] = sticky ? __assign({}, STYLE_STICKY_ITEM, (_c = {}, _c[sizeProp[scrollDirection]] = size, _c[marginProp[scrollDirection]] = offset, _c[oppositeMarginProp[scrollDirection]] = -(offset + size), _c.zIndex = 1, _c)) : __assign({}, STYLE_ITEM, (_d = {}, _d[sizeProp[scrollDirection]] = size, _d[positionProp[scrollDirection]] = offset, _d));
        var _c, _d;
    };
    VirtualList.defaultProps = {
        overscanCount: 3,
        scrollDirection: DIRECTION.VERTICAL,
        width: '100%'
    };
    VirtualList.propTypes = {
        estimatedItemSize: number,
        height: oneOfType([number, string]).isRequired,
        itemCount: number.isRequired,
        itemSize: oneOfType([number, array, func]).isRequired,
        onScroll: func,
        onItemsRendered: func,
        overscanCount: number,
        renderItem: func.isRequired,
        scrollOffset: number,
        scrollToIndex: number,
        scrollToAlignment: oneOf([ALIGNMENT.AUTO, ALIGNMENT.START, ALIGNMENT.CENTER, ALIGNMENT.END]),
        scrollDirection: oneOf([DIRECTION.HORIZONTAL, DIRECTION.VERTICAL]),
        stickyIndices: arrayOf(number),
        style: object,
        width: oneOfType([number, string])
    };
    return VirtualList;
}(PureComponent);

/**
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate) {
  var date = parse_1(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date
}

var start_of_month = startOfMonth;

/**
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse_1(dirtyDateLeft);
  var dateRight = parse_1(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear()
}

var is_same_year = isSameYear;

var _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$3(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var styles$3 = {
  'rows': 'Cal__Month__rows',
  'row': 'Cal__Month__row',
  'partial': 'Cal__Month__partial',
  'label': 'Cal__Month__label',
  'partialFirstRow': 'Cal__Month__partialFirstRow'
};

var Month = function (_PureComponent) {
  _inherits$3(Month, _PureComponent);

  function Month() {
    _classCallCheck$4(this, Month);

    return _possibleConstructorReturn$3(this, _PureComponent.apply(this, arguments));
  }

  Month.prototype.renderRows = function renderRows() {
    var _props = this.props,
        DayComponent = _props.DayComponent,
        disabledDates = _props.disabledDates,
        disabledDays = _props.disabledDays,
        monthDate = _props.monthDate,
        locale = _props.locale,
        maxDate = _props.maxDate,
        minDate = _props.minDate,
        rowHeight = _props.rowHeight,
        rows = _props.rows,
        selected = _props.selected,
        today = _props.today,
        theme = _props.theme,
        passThrough = _props.passThrough;

    var currentYear = today.getFullYear();
    var year = monthDate.getFullYear();
    var month = monthDate.getMonth();
    var monthShort = format_1(monthDate, 'MMM', { locale: locale.locale });
    var monthRows = [];
    var day = 0;
    var isDisabled = false;
    var isToday = false;
    var date = void 0,
        days = void 0,
        dow = void 0,
        row = void 0;

    // Used for faster comparisons
    var _today = format_1(today, 'YYYY-MM-DD');
    var _minDate = format_1(minDate, 'YYYY-MM-DD');
    var _maxDate = format_1(maxDate, 'YYYY-MM-DD');

    // Oh the things we do in the name of performance...
    for (var i = 0, len = rows.length; i < len; i++) {
      var _classNames;

      row = rows[i];
      days = [];
      dow = get_day(new Date(year, month, row[0]));

      for (var k = 0, _len = row.length; k < _len; k++) {
        day = row[k];

        date = getDateString(year, month, day);
        isToday = date === _today;

        isDisabled = minDate && date < _minDate || maxDate && date > _maxDate || disabledDays && disabledDays.length && disabledDays.indexOf(dow) !== -1 || disabledDates && disabledDates.length && disabledDates.indexOf(date) !== -1;

        days[k] = React.createElement(DayComponent, _extends$w({
          key: 'day-' + day,
          currentYear: currentYear,
          date: date,
          day: day,
          selected: selected,
          isDisabled: isDisabled,
          isToday: isToday,
          locale: locale,
          month: month,
          monthShort: monthShort,
          theme: theme,
          year: year
        }, passThrough.Day));

        dow += 1;
      }
      monthRows[i] = React.createElement(
        'ul',
        {
          key: 'Row-' + i,
          className: classnames(styles$3.row, (_classNames = {}, _classNames[styles$3.partial] = row.length !== 7, _classNames)),
          style: { height: rowHeight },
          role: 'row',
          'aria-label': 'Week ' + (i + 1)
        },
        days
      );
    }

    return monthRows;
  };

  Month.prototype.render = function render() {
    var _classNames2;

    var _props2 = this.props,
        locale = _props2.locale.locale,
        monthDate = _props2.monthDate,
        today = _props2.today,
        rows = _props2.rows,
        rowHeight = _props2.rowHeight,
        showOverlay = _props2.showOverlay,
        style = _props2.style,
        theme = _props2.theme;

    var dateFormat = is_same_year(monthDate, today) ? 'MMMM' : 'MMMM YYYY';

    return React.createElement(
      'div',
      { className: styles$3.root, style: _extends$w({}, style, { lineHeight: rowHeight + 'px' }) },
      React.createElement(
        'div',
        { className: styles$3.rows },
        this.renderRows(),
        showOverlay && React.createElement(
          'label',
          {
            className: classnames(styles$3.label, (_classNames2 = {}, _classNames2[styles$3.partialFirstRow] = rows[0].length !== 7, _classNames2)),
            style: { backgroundColor: theme.overlayColor }
          },
          React.createElement(
            'span',
            null,
            format_1(monthDate, dateFormat, { locale: locale })
          )
        )
      )
    );
  };

  return Month;
}(PureComponent);

var _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$4(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var styles$4 = {
  'root': 'Cal__MonthList__root',
  'scrolling': 'Cal__MonthList__scrolling'
};


var AVERAGE_ROWS_PER_MONTH = 5;

var MonthList = function (_Component) {
  _inherits$4(MonthList, _Component);

  function MonthList() {
    var _temp, _this, _ret;

    _classCallCheck$5(this, MonthList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$4(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      scrollTop: _this.getDateOffset(_this.props.scrollDate)
    }, _this.cache = {}, _this.memoize = function (param) {
      if (!this.cache[param]) {
        var weekStartsOn = this.props.locale.weekStartsOn;

        var _param$split = param.split(':'),
            year = _param$split[0],
            month = _param$split[1];

        var result = getMonth(year, month, weekStartsOn);
        this.cache[param] = result;
      }
      return this.cache[param];
    }, _this.monthHeights = [], _this._getRef = function (instance) {
      _this.VirtualList = instance;
    }, _this.getMonthHeight = function (index) {
      if (!_this.monthHeights[index]) {
        var _this$props = _this.props,
            weekStartsOn = _this$props.locale.weekStartsOn,
            months = _this$props.months,
            rowHeight = _this$props.rowHeight;
        var _months$index = months[index],
            month = _months$index.month,
            year = _months$index.year;

        var weeks = getWeeksInMonth(month, year, weekStartsOn, index === months.length - 1);
        var height = weeks * rowHeight;
        _this.monthHeights[index] = height;
      }

      return _this.monthHeights[index];
    }, _this.scrollToDate = function (date) {
      for (var _len2 = arguments.length, rest = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        rest[_key2 - 2] = arguments[_key2];
      }

      var _this2;

      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var offsetTop = _this.getDateOffset(date);
      (_this2 = _this).scrollTo.apply(_this2, [offsetTop + offset].concat(rest));
    }, _this.scrollTo = function () {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var shouldAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var onScrollEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : emptyFn;

      var onComplete = function onComplete() {
        return setTimeout(function () {
          _this.scrollEl.style.overflowY = 'auto';
          onScrollEnd();
        });
      };

      // Interrupt iOS Momentum scroll
      _this.scrollEl.style.overflowY = 'hidden';

      if (shouldAnimate) {
        /* eslint-disable sort-keys */
        animate({
          fromValue: _this.scrollEl.scrollTop,
          toValue: scrollTop,
          onUpdate: function onUpdate(scrollTop, callback) {
            return _this.setState({ scrollTop: scrollTop }, callback);
          },
          onComplete: onComplete
        });
      } else {
        window.requestAnimationFrame(function () {
          _this.scrollEl.scrollTop = scrollTop;
          onComplete();
        });
      }
    }, _this.renderMonth = function (_ref) {
      var index = _ref.index,
          style = _ref.style;
      var _this$props2 = _this.props,
          DayComponent = _this$props2.DayComponent,
          disabledDates = _this$props2.disabledDates,
          disabledDays = _this$props2.disabledDays,
          locale = _this$props2.locale,
          maxDate = _this$props2.maxDate,
          minDate = _this$props2.minDate,
          months = _this$props2.months,
          passThrough = _this$props2.passThrough,
          rowHeight = _this$props2.rowHeight,
          selected = _this$props2.selected,
          showOverlay = _this$props2.showOverlay,
          theme = _this$props2.theme,
          today = _this$props2.today;
      var _months$index2 = months[index],
          month = _months$index2.month,
          year = _months$index2.year;

      var key = year + ':' + month;

      var _this$memoize = _this.memoize(key),
          date = _this$memoize.date,
          rows = _this$memoize.rows;

      return React.createElement(Month, _extends$x({
        key: key,
        selected: selected,
        DayComponent: DayComponent,
        monthDate: date,
        disabledDates: disabledDates,
        disabledDays: disabledDays,
        maxDate: maxDate,
        minDate: minDate,
        rows: rows,
        rowHeight: rowHeight,
        isScrolling: false,
        showOverlay: showOverlay,
        today: today,
        theme: theme,
        style: style,
        locale: locale,
        passThrough: passThrough
      }, passThrough.Month));
    }, _temp), _possibleConstructorReturn$4(_this, _ret);
  }

  MonthList.prototype.componentDidMount = function componentDidMount() {
    this.scrollEl = this.VirtualList.rootNode;
  };

  MonthList.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {
    var scrollDate = _ref2.scrollDate;

    if (scrollDate !== this.props.scrollDate) {
      this.setState({
        scrollTop: this.getDateOffset(scrollDate)
      });
    }
  };

  MonthList.prototype.getDateOffset = function getDateOffset(date) {
    var _props = this.props,
        min = _props.min,
        rowHeight = _props.rowHeight,
        weekStartsOn = _props.locale.weekStartsOn,
        height = _props.height;

    var weeks = getWeek(start_of_month(min), parse_1(date), weekStartsOn);

    return weeks * rowHeight - (height - rowHeight / 2) / 2;
  };

  MonthList.prototype.render = function render() {
    var _classNames;

    var _props2 = this.props,
        height = _props2.height,
        isScrolling = _props2.isScrolling,
        onScroll = _props2.onScroll,
        overscanMonthCount = _props2.overscanMonthCount,
        months = _props2.months,
        rowHeight = _props2.rowHeight,
        width = _props2.width;
    var scrollTop = this.state.scrollTop;


    return React.createElement(VirtualList, {
      ref: this._getRef,
      width: width,
      height: height,
      itemCount: months.length,
      itemSize: this.getMonthHeight,
      estimatedItemSize: rowHeight * AVERAGE_ROWS_PER_MONTH,
      renderItem: this.renderMonth,
      onScroll: onScroll,
      scrollOffset: scrollTop,
      className: classnames(styles$4.root, (_classNames = {}, _classNames[styles$4.scrolling] = isScrolling, _classNames)),
      style: { lineHeight: rowHeight + 'px' },
      overscanCount: overscanMonthCount
    });
  };

  return MonthList;
}(Component);
process.env.NODE_ENV !== "production" ? MonthList.propTypes = {
  disabledDates: PropTypes.arrayOf(PropTypes.string),
  disabledDays: PropTypes.arrayOf(PropTypes.number),
  height: PropTypes.number,
  isScrolling: PropTypes.bool,
  locale: PropTypes.object,
  maxDate: PropTypes.instanceOf(Date),
  min: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  months: PropTypes.arrayOf(PropTypes.object),
  onDaySelect: PropTypes.func,
  onScroll: PropTypes.func,
  overscanMonthCount: PropTypes.number,
  rowHeight: PropTypes.number,
  selectedDate: PropTypes.instanceOf(Date),
  showOverlay: PropTypes.bool,
  theme: PropTypes.object,
  today: PropTypes.instanceOf(Date),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : void 0;

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$5(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var styles$5 = {
  'root': 'Cal__Weekdays__root',
  'day': 'Cal__Weekdays__day'
};

var Weekdays = function (_PureComponent) {
  _inherits$5(Weekdays, _PureComponent);

  function Weekdays() {
    _classCallCheck$6(this, Weekdays);

    return _possibleConstructorReturn$5(this, _PureComponent.apply(this, arguments));
  }

  Weekdays.prototype.render = function render() {
    var _props = this.props,
        weekdays = _props.weekdays,
        weekStartsOn = _props.weekStartsOn,
        theme = _props.theme;

    var orderedWeekdays = [].concat(weekdays.slice(weekStartsOn, 7), weekdays.slice(0, weekStartsOn));

    return React.createElement(
      'ul',
      {
        className: styles$5.root,
        style: {
          backgroundColor: theme.weekdayColor,
          color: theme.textColor.active,
          paddingRight: scrollbarSize
        },
        'aria-hidden': true
      },
      orderedWeekdays.map(function (val, index) {
        return React.createElement(
          'li',
          { key: 'Weekday-' + index, className: styles$5.day },
          val
        );
      })
    );
  };

  return Weekdays;
}(PureComponent);
process.env.NODE_ENV !== "production" ? Weekdays.propTypes = {
  locale: PropTypes.object,
  theme: PropTypes.object
} : void 0;

/**
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameMonth (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse_1(dirtyDateLeft);
  var dateRight = parse_1(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getMonth() === dateRight.getMonth()
}

var is_same_month = isSameMonth;

var _class$2, _temp$2;

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$6(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$6(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var styles$6 = {
  'root': 'Cal__Years__root',
  'list': 'Cal__Years__list',
  'center': 'Cal__Years__center',
  'year': 'Cal__Years__year',
  'withMonths': 'Cal__Years__withMonths',
  'currentMonth': 'Cal__Years__currentMonth',
  'selected': 'Cal__Years__selected',
  'disabled': 'Cal__Years__disabled',
  'active': 'Cal__Years__active',
  'currentYear': 'Cal__Years__currentYear',
  'first': 'Cal__Years__first',
  'last': 'Cal__Years__last'
};


var SPACING = 40;

var Years = (_temp$2 = _class$2 = function (_Component) {
  _inherits$6(Years, _Component);

  function Years() {
    _classCallCheck$7(this, Years);

    return _possibleConstructorReturn$6(this, _Component.apply(this, arguments));
  }

  Years.prototype.handleClick = function handleClick(date, e) {
    var _props = this.props,
        hideOnSelect = _props.hideOnSelect,
        onSelect = _props.onSelect,
        setDisplay = _props.setDisplay,
        scrollToDate = _props.scrollToDate;


    onSelect(date, e, function (date) {
      return scrollToDate(date);
    });

    if (hideOnSelect) {
      window.requestAnimationFrame(function () {
        return setDisplay('days');
      });
    }
  };

  Years.prototype.renderMonths = function renderMonths(year) {
    var _this2 = this;

    var _props2 = this.props,
        locale = _props2.locale.locale,
        selected = _props2.selected,
        theme = _props2.theme,
        today = _props2.today,
        min = _props2.min,
        max = _props2.max,
        minDate = _props2.minDate,
        maxDate = _props2.maxDate;

    var months = getMonthsForYear(year, selected.getDate());

    return React.createElement(
      'ol',
      null,
      months.map(function (date, index) {
        var _classNames;

        var isSelected = is_same_month(date, selected);
        var isCurrentMonth = is_same_month(date, today);
        var isDisabled = is_before(date, min) || is_before(date, minDate) || is_after(date, max) || is_after(date, maxDate);
        var style = Object.assign({}, isSelected && {
          backgroundColor: typeof theme.selectionColor === 'function' ? theme.selectionColor(date) : theme.selectionColor
        }, isCurrentMonth && {
          borderColor: theme.todayColor
        });

        return React.createElement(
          'li',
          {
            key: index,
            onClick: function onClick(e) {
              e.stopPropagation();

              if (!isDisabled) {
                _this2.handleClick(date, e);
              }
            },
            className: classnames(styles$6.month, (_classNames = {}, _classNames[styles$6.selected] = isSelected, _classNames[styles$6.currentMonth] = isCurrentMonth, _classNames[styles$6.disabled] = isDisabled, _classNames)),
            style: style,
            title: 'Set date to ' + format_1(date, 'MMMM Do, YYYY')
          },
          format_1(date, 'MMM', { locale: locale })
        );
      })
    );
  };

  Years.prototype.render = function render() {
    var _this3 = this;

    var _props3 = this.props,
        height = _props3.height,
        selected = _props3.selected,
        showMonths = _props3.showMonths,
        theme = _props3.theme,
        today = _props3.today,
        width = _props3.width;

    var currentYear = today.getFullYear();
    var years = this.props.years.slice(0, this.props.years.length);
    var selectedYearIndex = years.indexOf(selected.getFullYear());
    var rowHeight = showMonths ? 110 : 50;
    var heights = years.map(function (val, index) {
      return index === 0 || index === years.length - 1 ? rowHeight + SPACING : rowHeight;
    });
    var containerHeight = years.length * rowHeight < height + 50 ? years.length * rowHeight : height + 50;

    return React.createElement(
      'div',
      {
        className: styles$6.root,
        style: { color: theme.selectionColor, height: height + 50 }
      },
      React.createElement(VirtualList, {
        ref: 'List',
        className: styles$6.list,
        width: width,
        height: containerHeight,
        itemCount: years.length,
        estimatedItemSize: rowHeight,
        itemSize: function itemSize(index) {
          return heights[index];
        },
        scrollToIndex: selectedYearIndex !== -1 ? selectedYearIndex : null,
        scrollToAlignment: 'center',
        renderItem: function renderItem(_ref) {
          var _classNames2;

          var index = _ref.index,
              style = _ref.style;

          var year = years[index];
          var isActive = index === selectedYearIndex;

          return React.createElement(
            'div',
            {
              key: index,
              className: classnames(styles$6.year, (_classNames2 = {}, _classNames2[styles$6.active] = !showMonths && isActive, _classNames2[styles$6.currentYear] = !showMonths && year === currentYear, _classNames2[styles$6.withMonths] = showMonths, _classNames2[styles$6.first] = index === 0, _classNames2[styles$6.last] = index === years.length - 1, _classNames2)),
              onClick: function onClick() {
                return _this3.handleClick(new Date(selected).setYear(year));
              },
              title: 'Set year to ' + year,
              'data-year': year,
              style: Object.assign({}, style, {
                color: typeof theme.selectionColor === 'function' ? theme.selectionColor(new Date(year, 0, 1)) : theme.selectionColor
              })
            },
            React.createElement(
              'label',
              null,
              React.createElement(
                'span',
                {
                  style: !showMonths && year === currentYear ? { borderColor: theme.todayColor } : null
                },
                year
              )
            ),
            showMonths && _this3.renderMonths(year)
          );
        }
      })
    );
  };

  return Years;
}(Component), _class$2.defaultProps = {
  onSelect: emptyFn,
  showMonths: true
}, _temp$2);
process.env.NODE_ENV !== "production" ? Years.propTypes = {
  height: PropTypes.number,
  hideOnSelect: PropTypes.bool,
  locale: PropTypes.object,
  max: PropTypes.object,
  maxDate: PropTypes.object,
  min: PropTypes.object,
  minDate: PropTypes.object,
  onSelect: PropTypes.func,
  scrollToDate: PropTypes.func,
  selectedYear: PropTypes.number,
  setDisplay: PropTypes.func,
  theme: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  years: PropTypes.array
} : void 0;

var _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$7(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$7(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var styles$7 = {
  'root': 'Cal__Day__root',
  'enabled': 'Cal__Day__enabled',
  'highlighted': 'Cal__Day__highlighted',
  'today': 'Cal__Day__today',
  'disabled': 'Cal__Day__disabled',
  'selected': 'Cal__Day__selected',
  'month': 'Cal__Day__month',
  'year': 'Cal__Day__year',
  'selection': 'Cal__Day__selection',
  'day': 'Cal__Day__day',
  'range': 'Cal__Day__range',
  'start': 'Cal__Day__start',
  'end': 'Cal__Day__end',
  'betweenRange': 'Cal__Day__betweenRange'
};

var Day = function (_PureComponent) {
  _inherits$7(Day, _PureComponent);

  function Day() {
    var _temp, _this, _ret;

    _classCallCheck$8(this, Day);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$7(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.handleClick = function () {
      var _this$props = _this.props,
          date = _this$props.date,
          isDisabled = _this$props.isDisabled,
          onClick = _this$props.onClick;


      if (!isDisabled && typeof onClick === 'function') {
        onClick(parse_1(date));
      }
    }, _temp), _possibleConstructorReturn$7(_this, _ret);
  }

  Day.prototype.renderSelection = function renderSelection(selectionColor) {
    var _props = this.props,
        day = _props.day,
        date = _props.date,
        isToday = _props.isToday,
        todayLabel = _props.locale.todayLabel,
        monthShort = _props.monthShort,
        textColor = _props.theme.textColor,
        selectionStyle = _props.selectionStyle;


    return React.createElement(
      'div',
      {
        className: styles$7.selection,
        'data-date': date,
        style: _extends$y({
          backgroundColor: this.selectionColor,
          color: textColor.active
        }, selectionStyle)
      },
      React.createElement(
        'span',
        { className: styles$7.month },
        isToday ? todayLabel.short || todayLabel.long : monthShort
      ),
      React.createElement(
        'span',
        { className: styles$7.day },
        day
      )
    );
  };

  Day.prototype.render = function render() {
    var _classNames;

    var _props2 = this.props,
        className = _props2.className,
        currentYear = _props2.currentYear,
        date = _props2.date,
        day = _props2.day,
        handlers = _props2.handlers,
        isDisabled = _props2.isDisabled,
        isHighlighted = _props2.isHighlighted,
        isToday = _props2.isToday,
        isSelected = _props2.isSelected,
        monthShort = _props2.monthShort,
        _props2$theme = _props2.theme,
        selectionColor = _props2$theme.selectionColor,
        todayColor = _props2$theme.todayColor,
        year = _props2.year;

    var color = void 0;

    if (isSelected) {
      color = this.selectionColor = typeof selectionColor === 'function' ? selectionColor(date) : selectionColor;
    } else if (isToday) {
      color = todayColor;
    }

    return React.createElement(
      'li',
      _extends$y({
        style: color ? { color: color } : null,
        className: classnames(styles$7.root, (_classNames = {}, _classNames[styles$7.today] = isToday, _classNames[styles$7.highlighted] = isHighlighted, _classNames[styles$7.selected] = isSelected, _classNames[styles$7.disabled] = isDisabled, _classNames[styles$7.enabled] = !isDisabled, _classNames), className),
        onClick: this.handleClick,
        'data-date': date
      }, handlers),
      day === 1 && React.createElement(
        'span',
        { className: styles$7.month },
        monthShort
      ),
      isToday ? React.createElement(
        'span',
        null,
        day
      ) : day,
      day === 1 && currentYear !== year && React.createElement(
        'span',
        { className: styles$7.year },
        year
      ),
      isSelected && this.renderSelection()
    );
  };

  return Day;
}(PureComponent);

var _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$8(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$8(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles$8 = {
  container: {
    'root': 'Cal__Container__root',
    'landscape': 'Cal__Container__landscape',
    'wrapper': 'Cal__Container__wrapper',
    'listWrapper': 'Cal__Container__listWrapper'
  },
  day: {
    'root': 'Cal__Day__root',
    'enabled': 'Cal__Day__enabled',
    'highlighted': 'Cal__Day__highlighted',
    'today': 'Cal__Day__today',
    'disabled': 'Cal__Day__disabled',
    'selected': 'Cal__Day__selected',
    'month': 'Cal__Day__month',
    'year': 'Cal__Day__year',
    'selection': 'Cal__Day__selection',
    'day': 'Cal__Day__day',
    'range': 'Cal__Day__range',
    'start': 'Cal__Day__start',
    'end': 'Cal__Day__end',
    'betweenRange': 'Cal__Day__betweenRange'
  }
};

var withDefaultProps = _defaultProps({
  autoFocus: true,
  DayComponent: Day,
  display: 'days',
  displayOptions: {},
  HeaderComponent: Header,
  height: 500,
  keyboardSupport: true,
  max: new Date(2050, 11, 31),
  maxDate: new Date(2050, 11, 31),
  min: new Date(1980, 0, 1),
  minDate: new Date(1980, 0, 1),
  onHighlightedDateChange: emptyFn,
  onScroll: emptyFn,
  onScrollEnd: emptyFn,
  onSelect: emptyFn,
  passThrough: {},
  rowHeight: 56,
  tabIndex: 1,
  width: 400,
  YearsComponent: Years
});

var Calendar = function (_Component) {
  _inherits$8(Calendar, _Component);

  function Calendar(props) {
    _classCallCheck$9(this, Calendar);

    var _this = _possibleConstructorReturn$8(this, _Component.apply(this, arguments));

    _this._displayOptions = {};
    _this._locale = {};
    _this._theme = {};

    _this.getCurrentOffset = function () {
      return _this.scrollTop;
    };

    _this.getDateOffset = function (date) {
      return _this._MonthList && _this._MonthList.getDateOffset(date);
    };

    _this.scrollTo = function (offset) {
      return _this._MonthList && _this._MonthList.scrollTo(offset);
    };

    _this.scrollToDate = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
      var offset = arguments[1];
      var shouldAnimate = arguments[2];
      var display = _this.props.display;


      return _this._MonthList && _this._MonthList.scrollToDate(date, offset, shouldAnimate && display === 'days', function () {
        return _this.setState({ isScrolling: false });
      });
    };

    _this.getScrollSpeed = new ScrollSpeed().getScrollSpeed;

    _this.handleScroll = function (scrollTop, e) {
      var _this$props = _this.props,
          onScroll = _this$props.onScroll,
          rowHeight = _this$props.rowHeight;
      var isScrolling = _this.state.isScrolling;

      var _this$getDisplayOptio = _this.getDisplayOptions(),
          showTodayHelper = _this$getDisplayOptio.showTodayHelper,
          showOverlay = _this$getDisplayOptio.showOverlay;

      var scrollSpeed = _this.scrollSpeed = Math.abs(_this.getScrollSpeed(scrollTop));
      _this.scrollTop = scrollTop;

      // We only want to display the months overlay if the user is rapidly scrolling
      if (showOverlay && scrollSpeed > rowHeight && !isScrolling) {
        _this.setState({
          isScrolling: true
        });
      }

      if (showTodayHelper) {
        _this.updateTodayHelperPosition(scrollSpeed);
      }

      onScroll(scrollTop, e);
      _this.handleScrollEnd();
    };

    _this.handleScrollEnd = debounce(function () {
      var onScrollEnd = _this.props.onScrollEnd;
      var isScrolling = _this.state.isScrolling;

      var _this$getDisplayOptio2 = _this.getDisplayOptions(),
          showTodayHelper = _this$getDisplayOptio2.showTodayHelper;

      if (isScrolling) {
        _this.setState({ isScrolling: false });
      }

      if (showTodayHelper) {
        _this.updateTodayHelperPosition(0);
      }

      onScrollEnd(_this.scrollTop);
    }, 150);

    _this.updateTodayHelperPosition = function (scrollSpeed) {
      var today = _this.today;
      var scrollTop = _this.scrollTop;
      var showToday = _this.state.showToday;
      var _this$props2 = _this.props,
          height = _this$props2.height,
          rowHeight = _this$props2.rowHeight;

      var _this$getDisplayOptio3 = _this.getDisplayOptions(),
          todayHelperRowOffset = _this$getDisplayOptio3.todayHelperRowOffset;

      var newState = void 0;

      if (!_this._todayOffset) {
        _this._todayOffset = _this.getDateOffset(today);
      }

      // Today is above the fold
      if (scrollTop >= _this._todayOffset + (height - rowHeight) / 2 + rowHeight * todayHelperRowOffset) {
        if (showToday !== DIRECTION_UP) newState = DIRECTION_UP;
      }
      // Today is below the fold
      else if (scrollTop <= _this._todayOffset - height / 2 - rowHeight * (todayHelperRowOffset + 1)) {
          if (showToday !== DIRECTION_DOWN) newState = DIRECTION_DOWN;
        } else if (showToday && scrollSpeed <= 1) {
          newState = false;
        }

      if (scrollTop === 0) {
        newState = false;
      }

      if (newState != null) {
        _this.setState({ showToday: newState });
      }
    };

    _this.setDisplay = function (display) {
      _this.setState({ display: display });
    };

    _this.updateYears(props);

    _this.state = {
      display: props.display
    };
    return _this;
  }

  Calendar.prototype.componentDidMount = function componentDidMount() {
    var autoFocus = this.props.autoFocus;


    if (autoFocus) {
      this.node.focus();
    }
  };

  Calendar.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
    var _props = this.props,
        min = _props.min,
        minDate = _props.minDate,
        max = _props.max,
        maxDate = _props.maxDate;


    if (nextProps.min !== min || nextProps.minDate !== minDate || nextProps.max !== max || nextProps.maxDate !== maxDate) {
      this.updateYears(nextProps);
    }

    if (nextProps.display !== this.props.display) {
      this.setState({ display: nextProps.display });
    }
  };

  Calendar.prototype.updateYears = function updateYears() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

    this._min = parse_1(props.min);
    this._max = parse_1(props.max);
    this._minDate = parse_1(props.minDate);
    this._maxDate = parse_1(props.maxDate);

    var min = this._min.getFullYear();
    var minMonth = this._min.getMonth();
    var max = this._max.getFullYear();
    var maxMonth = this._max.getMonth();

    var months = [];
    var year = void 0,
        month = void 0;
    for (year = min; year <= max; year++) {
      for (month = 0; month < 12; month++) {
        if (year === min && month < minMonth || year === max && month > maxMonth) {
          continue;
        }

        months.push({ month: month, year: year });
      }
    }

    this.months = months;
  };

  Calendar.prototype.getDisabledDates = function getDisabledDates(disabledDates) {
    return disabledDates && disabledDates.map(function (date) {
      return format_1(parse_1(date), 'YYYY-MM-DD');
    });
  };

  Calendar.prototype.getDisplayOptions = function getDisplayOptions() {
    var displayOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.displayOptions;

    return Object.assign(this._displayOptions, defaultDisplayOptions, displayOptions);
  };

  Calendar.prototype.getLocale = function getLocale() {
    return Object.assign(this._locale, defaultLocale, this.props.locale);
  };

  Calendar.prototype.getTheme = function getTheme() {
    return Object.assign(this._theme, defaultTheme$2, this.props.theme);
  };

  Calendar.prototype.render = function render() {
    var _classNames,
        _this2 = this;

    var _props2 = this.props,
        className = _props2.className,
        passThrough = _props2.passThrough,
        DayComponent = _props2.DayComponent,
        disabledDays = _props2.disabledDays,
        displayDate = _props2.displayDate,
        height = _props2.height,
        HeaderComponent = _props2.HeaderComponent,
        rowHeight = _props2.rowHeight,
        scrollDate = _props2.scrollDate,
        selected = _props2.selected,
        tabIndex = _props2.tabIndex,
        width = _props2.width,
        YearsComponent = _props2.YearsComponent;

    var _getDisplayOptions = this.getDisplayOptions(),
        hideYearsOnSelect = _getDisplayOptions.hideYearsOnSelect,
        layout = _getDisplayOptions.layout,
        overscanMonthCount = _getDisplayOptions.overscanMonthCount,
        shouldHeaderAnimate = _getDisplayOptions.shouldHeaderAnimate,
        showHeader = _getDisplayOptions.showHeader,
        showMonthsForYears = _getDisplayOptions.showMonthsForYears,
        showOverlay = _getDisplayOptions.showOverlay,
        showTodayHelper = _getDisplayOptions.showTodayHelper,
        showWeekdays = _getDisplayOptions.showWeekdays;

    var _state = this.state,
        display = _state.display,
        isScrolling = _state.isScrolling,
        showToday = _state.showToday;

    var disabledDates = this.getDisabledDates(this.props.disabledDates);
    var locale = this.getLocale();
    var theme = this.getTheme();
    var today = this.today = start_of_day(new Date());

    return React.createElement(
      'div',
      _extends$z({
        tabIndex: tabIndex,
        className: classnames(className, styles$8.container.root, (_classNames = {}, _classNames[styles$8.container.landscape] = layout === 'landscape', _classNames)),
        style: { color: theme.textColor.default, width: width },
        'aria-label': 'Calendar',
        ref: function ref(node) {
          _this2.node = node;
        }
      }, passThrough.rootNode),
      showHeader && React.createElement(HeaderComponent, _extends$z({
        selected: selected,
        shouldAnimate: Boolean(shouldHeaderAnimate && display !== 'years'),
        layout: layout,
        theme: theme,
        locale: locale,
        scrollToDate: this.scrollToDate,
        setDisplay: this.setDisplay,
        dateFormat: locale.headerFormat,
        display: display,
        displayDate: displayDate
      }, passThrough.Header)),
      React.createElement(
        'div',
        { className: styles$8.container.wrapper },
        showWeekdays && React.createElement(Weekdays, { weekdays: locale.weekdays, weekStartsOn: locale.weekStartsOn, theme: theme }),
        React.createElement(
          'div',
          { className: styles$8.container.listWrapper },
          showTodayHelper && React.createElement(Today, {
            scrollToDate: this.scrollToDate,
            show: showToday,
            today: today,
            theme: theme,
            todayLabel: locale.todayLabel.long
          }),
          React.createElement(MonthList, {
            ref: function ref(instance) {
              _this2._MonthList = instance;
            },
            DayComponent: DayComponent,
            disabledDates: disabledDates,
            disabledDays: disabledDays,
            height: height,
            isScrolling: isScrolling,
            locale: locale,
            maxDate: this._maxDate,
            min: this._min,
            minDate: this._minDate,
            months: this.months,
            onScroll: this.handleScroll,
            overscanMonthCount: overscanMonthCount,
            passThrough: passThrough,
            theme: theme,
            today: today,
            rowHeight: rowHeight,
            selected: selected,
            scrollDate: scrollDate,
            showOverlay: showOverlay,
            width: width
          })
        ),
        display === 'years' && React.createElement(YearsComponent, _extends$z({
          ref: function ref(instance) {
            _this2._Years = instance;
          },
          height: height,
          hideOnSelect: hideYearsOnSelect,
          locale: locale,
          max: this._max,
          maxDate: this._maxDate,
          min: this._min,
          minDate: this._minDate,
          scrollToDate: this.scrollToDate,
          selected: selected,
          setDisplay: this.setDisplay,
          showMonths: showMonthsForYears,
          theme: theme,
          today: today,
          width: width,
          years: range(this._min.getFullYear(), this._max.getFullYear() + 1)
        }, passThrough.Years))
      )
    );
  };

  return Calendar;
}(Component);
process.env.NODE_ENV !== "production" ? Calendar.propTypes = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  DayComponent: PropTypes.func,
  disabledDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  disabledDays: PropTypes.arrayOf(PropTypes.number),
  display: PropTypes.oneOf(['years', 'days']),
  displayOptions: PropTypes.shape({
    hideYearsOnSelect: PropTypes.bool,
    layout: PropTypes.oneOf(['portrait', 'landscape']),
    overscanMonthCount: PropTypes.number,
    shouldHeaderAnimate: PropTypes.bool,
    showHeader: PropTypes.bool,
    showMonthsForYears: PropTypes.bool,
    showOverlay: PropTypes.bool,
    showTodayHelper: PropTypes.bool,
    showWeekdays: PropTypes.bool,
    todayHelperRowOffset: PropTypes.number
  }),
  height: PropTypes.number,
  keyboardSupport: PropTypes.bool,
  locale: PropTypes.shape({
    blank: PropTypes.string,
    headerFormat: PropTypes.string,
    todayLabel: PropTypes.shape({
      long: PropTypes.string,
      short: PropTypes.string
    }),
    weekdays: PropTypes.arrayOf(PropTypes.string),
    weekStartsOn: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6])
  }),
  max: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  min: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  onScroll: PropTypes.func,
  onScrollEnd: PropTypes.func,
  onSelect: PropTypes.func,
  rowHeight: PropTypes.number,
  tabIndex: PropTypes.number,
  theme: PropTypes.shape({
    floatingNav: PropTypes.shape({
      background: PropTypes.string,
      chevron: PropTypes.string,
      color: PropTypes.string
    }),
    headerColor: PropTypes.string,
    selectionColor: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    textColor: PropTypes.shape({
      active: PropTypes.string,
      default: PropTypes.string
    }),
    todayColor: PropTypes.string,
    weekdayColor: PropTypes.string
  }),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  YearsComponent: PropTypes.func
} : void 0;

var withState_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var _createHelper2 = _interopRequireDefault(createHelper_1);



var _createEagerFactory2 = _interopRequireDefault(createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return function (_Component) {
      _inherits(_class2, _Component);

      function _class2() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _class2.prototype.render = function render() {
        var _extends2;

        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
      };

      return _class2;
    }(React.Component);
  };
};

exports.default = (0, _createHelper2.default)(withState, 'withState');
});

var _withState = unwrapExports(withState_1);

var mapProps_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;



var _createHelper2 = _interopRequireDefault(createHelper_1);



var _createEagerFactory2 = _interopRequireDefault(createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return function (props) {
      return factory(propsMapper(props));
    };
  };
};

exports.default = (0, _createHelper2.default)(mapProps, 'mapProps');
});

unwrapExports(mapProps_1);

var withProps_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _createHelper2 = _interopRequireDefault(createHelper_1);



var _mapProps2 = _interopRequireDefault(mapProps_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withProps = function withProps(input) {
  return (0, _mapProps2.default)(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
};

exports.default = (0, _createHelper2.default)(withProps, 'withProps');
});

var _withProps = unwrapExports(withProps_1);

var compose_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
exports.default = compose;
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}
});

var _compose = unwrapExports(compose_1);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var enhanceDay = _withPropsOnChange(['selected'], function (props) {
  return {
    isSelected: props.selected === props.date
  };
});

var enhanceYear = _withPropsOnChange(['selected'], function (_ref) {
  var selected = _ref.selected;
  return {
    selected: parse_1(selected)
  };
});

// Enhancer to handle selecting and displaying a single date
var withDateSelection = _compose(withDefaultProps, withImmutableProps(function (_ref2) {
  var DayComponent = _ref2.DayComponent,
      onSelect = _ref2.onSelect,
      setScrollDate = _ref2.setScrollDate,
      YearsComponent = _ref2.YearsComponent;
  return {
    DayComponent: enhanceDay(DayComponent),
    YearsComponent: enhanceYear(YearsComponent)
  };
}), _withState('scrollDate', 'setScrollDate', function (props) {
  return props.selected || new Date();
}), _withProps(function (_ref3) {
  var _onSelect = _ref3.onSelect,
      setScrollDate = _ref3.setScrollDate,
      props = _objectWithoutProperties(_ref3, ['onSelect', 'setScrollDate']);

  var selected = sanitizeDate(props.selected, props);

  return {
    passThrough: {
      Day: {
        onClick: _onSelect
      },
      Years: {
        onSelect: function onSelect(year) {
          return handleYearSelect(year, { onSelect: _onSelect, selected: selected, setScrollDate: setScrollDate });
        }
      }
    },
    selected: selected && format_1(selected, 'YYYY-MM-DD')
  };
}));
function handleYearSelect(date, _ref4) {
  var setScrollDate = _ref4.setScrollDate,
      selected = _ref4.selected,
      onSelect = _ref4.onSelect;

  var newDate = parse_1(date);

  onSelect(newDate);
  setScrollDate(newDate);
}

var withHandlers_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var _createEagerFactory2 = _interopRequireDefault(createEagerFactory);



var _createHelper2 = _interopRequireDefault(createHelper_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapValues = function mapValues(obj, func$$1) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func$$1(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var _class, _temp2, _initialiseProps;

    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return _temp2 = _class = function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
      }

      _class.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      _class.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return _class;
    }(React.Component), _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (process.env.NODE_ENV !== 'production' && typeof handler !== 'function') {
            console.error( // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    }, _temp2;
  };
};

exports.default = (0, _createHelper2.default)(withHandlers, 'withHandlers');
});

var _withHandlers = unwrapExports(withHandlers_1);

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse_1(dirtyDate);
  var amount = Number(dirtyAmount);
  date.setDate(date.getDate() + amount);
  return date
}

var add_days = addDays;

var _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var enhanceDay$1 = _withProps(function (props) {
  return {
    isHighlighted: props.highlightedDate === props.date
  };
});

var withKeyboardSupport = _compose(_withState('highlightedDate', 'setHighlight'), withImmutableProps(function (_ref) {
  var DayComponent = _ref.DayComponent;
  return {
    DayComponent: enhanceDay$1(DayComponent)
  };
}), _withHandlers({
  onKeyDown: function onKeyDown(props) {
    return function (e) {
      return handleKeyDown(e, props);
    };
  }
}), _withProps(function (_ref2) {
  var highlightedDate = _ref2.highlightedDate,
      onKeyDown = _ref2.onKeyDown,
      onSelect = _ref2.onSelect,
      passThrough = _ref2.passThrough,
      setHighlight = _ref2.setHighlight;
  return {
    passThrough: _extends$A({}, passThrough, {
      Day: _extends$A({}, passThrough.Day, {
        highlightedDate: format_1(highlightedDate, 'YYYY-MM-DD'),
        onClick: function onClick(date) {
          setHighlight(null);
          passThrough.Day.onClick(date);
        }
      }),
      rootNode: { onKeyDown: onKeyDown }
    })
  };
}));

function handleKeyDown(e, props) {
  var minDate = props.minDate,
      maxDate = props.maxDate,
      onClick = props.passThrough.Day.onClick,
      setScrollDate = props.setScrollDate,
      setHighlight = props.setHighlight;

  var highlightedDate = getInitialDate(props);
  var delta = 0;

  if ([keyCodes.left, keyCodes.up, keyCodes.right, keyCodes.down].indexOf(e.keyCode) > -1 && typeof e.preventDefault === 'function') {
    e.preventDefault();
  }

  switch (e.keyCode) {
    case keyCodes.enter:
      onClick && onClick(highlightedDate);
      return;
    case keyCodes.left:
      delta = -1;
      break;
    case keyCodes.right:
      delta = +1;
      break;
    case keyCodes.down:
      delta = +7;
      break;
    case keyCodes.up:
      delta = -7;
      break;
    default:
      delta = 0;
  }

  if (delta) {
    var newHighlightedDate = add_days(highlightedDate, delta);

    // Make sure the new highlighted date isn't before min / max
    if (is_before(newHighlightedDate, minDate)) {
      newHighlightedDate = new Date(minDate);
    } else if (is_after(newHighlightedDate, maxDate)) {
      newHighlightedDate = new Date(maxDate);
    }

    setScrollDate(newHighlightedDate);
    setHighlight(newHighlightedDate);
  }
}

function getInitialDate(_ref3) {
  var highlightedDate = _ref3.highlightedDate,
      selected = _ref3.selected,
      displayDate = _ref3.displayDate;

  return highlightedDate || selected.start || displayDate || selected || new Date();
}

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$9(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$9(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var styles$9 = {
  'root': 'Cal__Slider__root',
  'slide': 'Cal__Slider__slide',
  'wrapper': 'Cal__Slider__wrapper',
  'arrow': 'Cal__Slider__arrow',
  'arrowRight': 'Cal__Slider__arrowRight',
  'arrowLeft': 'Cal__Slider__arrowLeft'
};
var transition = {
  'enter': 'Cal__transition__enter',
  'enterActive': 'Cal__transition__enterActive',
  'leave': 'Cal__transition__leave',
  'leaveActive': 'Cal__transition__leaveActive'
};


var DIRECTIONS = {
  LEFT: 0,
  RIGHT: 1
};

var Arrow = function Arrow(_ref) {
  var _classNames;

  var direction = _ref.direction,
      _onClick = _ref.onClick;
  return React.createElement(
    'div',
    {
      className: classnames(styles$9.arrow, (_classNames = {}, _classNames[styles$9.arrowLeft] = direction === DIRECTIONS.LEFT, _classNames[styles$9.arrowRight] = direction === DIRECTIONS.RIGHT, _classNames)),
      onClick: function onClick() {
        return _onClick(direction);
      }
    },
    React.createElement(
      'svg',
      {
        x: '0px',
        y: '0px',
        viewBox: '0 0 26 46'
      },
      React.createElement('path', { d: 'M31.232233,34.767767 C32.2085438,35.7440777 33.7914562,35.7440777 34.767767,34.767767 C35.7440777,33.7914562 35.7440777,32.2085438 34.767767,31.232233 L14.767767,11.232233 C13.7914562,10.2559223 12.2085438,10.2559223 11.232233,11.232233 L-8.767767,31.232233 C-9.7440777,32.2085438 -9.7440777,33.7914562 -8.767767,34.767767 C-7.7914562,35.7440777 -6.2085438,35.7440777 -5.232233,34.767767 L12.9997921,16.5357418 L31.232233,34.767767 Z', id: 'Shape', fill: '#FFF', transform: 'translate(13.000000, 23.000000) rotate(90.000000) translate(-13.000000, -23.000000) ' })
    )
  );
};

var Slider = function (_PureComponent) {
  _inherits$9(Slider, _PureComponent);

  function Slider() {
    var _temp, _this, _ret;

    _classCallCheck$a(this, Slider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$9(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.handleClick = function (direction) {
      var _this$props = _this.props,
          children = _this$props.children,
          index = _this$props.index,
          onChange = _this$props.onChange;


      switch (direction) {
        case DIRECTIONS.LEFT:
          index = Math.max(0, index - 1);
          break;
        case DIRECTIONS.RIGHT:
          index = Math.min(index + 1, children.length);
          break;
        default:
          return;
      }

      onChange(index);
    }, _temp), _possibleConstructorReturn$9(_this, _ret);
  }

  Slider.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        index = _props.index;


    return React.createElement(
      'div',
      { className: styles$9.root },
      index !== 0 && React.createElement(Arrow, { onClick: this.handleClick, direction: DIRECTIONS.LEFT }),
      React.createElement(
        CSSTransitionGroup,
        {
          className: styles$9.wrapper,
          component: 'div',
          style: {
            transform: 'translate3d(-' + 100 * index + '%, 0, 0)'
          },
          transitionName: transition,
          transitionEnterTimeout: 300,
          transitionLeaveTimeout: 300
        },
        Children.map(children, function (child, i) {
          return React.createElement(
            'div',
            {
              key: i,
              className: styles$9.slide,
              style: { transform: 'translateX(' + 100 * i + '%)' }
            },
            child
          );
        })
      ),
      index !== children.length - 1 && React.createElement(Arrow, { onClick: this.handleClick, direction: DIRECTIONS.RIGHT })
    );
  };

  return Slider;
}(PureComponent);

var _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var enhanceHeader = withImmutableProps(function (_ref) {
  var renderSelection = _ref.renderSelection,
      setDisplayDate = _ref.setDisplayDate;
  return {
    renderSelection: function renderSelection(values, _ref2) {
      var scrollToDate = _ref2.scrollToDate,
          displayDate = _ref2.displayDate,
          props = _objectWithoutProperties$1(_ref2, ['scrollToDate', 'displayDate']);

      if (!values.length) {
        return null;
      }

      var dates = values.sort();
      var index = values.indexOf(format_1(parse_1(displayDate), 'YYYY-MM-DD'));

      return React.createElement(
        Slider,
        {
          index: index !== -1 ? index : dates.length - 1,
          onChange: function onChange(index) {
            return setDisplayDate(dates[index], function () {
              return setTimeout(function () {
                return scrollToDate(dates[index], 0, true);
              }, 50);
            });
          }
        },
        dates.map(function (value) {
          return defaultSelectionRenderer(value, _extends$B({}, props, {
            key: index,
            scrollToDate: scrollToDate,
            shouldAnimate: false
          }));
        })
      );
    }
  };
});

function _objectWithoutProperties$2(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Enhance Day component to display selected state based on an array of selected dates
var enhanceDay$2 = _withPropsOnChange(['selected'], function (props) {
  return {
    isSelected: props.selected.indexOf(props.date) !== -1
  };
});

// Enhance year component
var enhanceYears = _withProps(function (_ref) {
  var displayDate = _ref.displayDate;
  return {
    selected: displayDate ? parse_1(displayDate) : null
  };
});

// Enhancer to handle selecting and displaying multiple dates
var withMultipleDates = _compose(withDefaultProps, _withState('scrollDate', 'setScrollDate', getInitialDate$1), _withState('displayDate', 'setDisplayDate', getInitialDate$1), withImmutableProps(function (_ref2) {
  var DayComponent = _ref2.DayComponent,
      HeaderComponent = _ref2.HeaderComponent,
      YearsComponent = _ref2.YearsComponent;
  return {
    DayComponent: enhanceDay$2(DayComponent),
    HeaderComponent: enhanceHeader(HeaderComponent),
    YearsComponent: enhanceYears(YearsComponent)
  };
}), _withProps(function (_ref3) {
  var displayDate = _ref3.displayDate,
      onSelect = _ref3.onSelect,
      setDisplayDate = _ref3.setDisplayDate,
      scrollToDate = _ref3.scrollToDate,
      props = _objectWithoutProperties$2(_ref3, ['displayDate', 'onSelect', 'setDisplayDate', 'scrollToDate']);

  return {
    passThrough: {
      Day: {
        onClick: function onClick(date) {
          return handleSelect(date, { onSelect: onSelect, setDisplayDate: setDisplayDate });
        }
      },
      Header: {
        setDisplayDate: setDisplayDate
      },
      Years: {
        displayDate: displayDate,
        onSelect: function onSelect(year, e, callback) {
          return handleYearSelect$1(year, callback);
        },
        selected: displayDate
      }
    },
    selected: props.selected.filter(function (date) {
      return sanitizeDate(date, props);
    }).map(function (date) {
      return format_1(date, 'YYYY-MM-DD');
    })
  };
}));
function handleSelect(date, _ref4) {
  var onSelect = _ref4.onSelect,
      setDisplayDate = _ref4.setDisplayDate;

  onSelect(date);
  setDisplayDate(date);
}

function handleYearSelect$1(date, callback) {
  callback(parse_1(date));
}

function getInitialDate$1(_ref5) {
  var selected = _ref5.selected;

  return selected.length ? selected[0] : new Date();
}

var _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
var styles$a = {
  'root': 'Cal__Header__root',
  'landscape': 'Cal__Header__landscape',
  'dateWrapper': 'Cal__Header__dateWrapper',
  'day': 'Cal__Header__day',
  'wrapper': 'Cal__Header__wrapper',
  'blank': 'Cal__Header__blank',
  'active': 'Cal__Header__active',
  'year': 'Cal__Header__year',
  'date': 'Cal__Header__date',
  'range': 'Cal__Header__range'
};


var enhanceHeader$1 = withImmutableProps(function (_ref) {
  var renderSelection = _ref.renderSelection;
  return {
    renderSelection: function renderSelection(values, props) {
      if (!values || !values.start && !values.end) {
        return null;
      }
      if (values.start === values.end) {
        return defaultSelectionRenderer(values.start, props);
      }

      var dateFormat = props.locale && props.locale.headerFormat || 'MMM Do';

      return React.createElement(
        'div',
        { className: styles$a.range, style: { color: props.theme.headerColor } },
        defaultSelectionRenderer(values.start, _extends$C({}, props, { dateFormat: dateFormat, key: 'start', shouldAnimate: false })),
        defaultSelectionRenderer(values.end, _extends$C({}, props, { dateFormat: dateFormat, key: 'end', shouldAnimate: false }))
      );
    }
  };
});

var _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties$3(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
var styles$b = {
  'root': 'Cal__Day__root',
  'enabled': 'Cal__Day__enabled',
  'highlighted': 'Cal__Day__highlighted',
  'today': 'Cal__Day__today',
  'disabled': 'Cal__Day__disabled',
  'selected': 'Cal__Day__selected',
  'month': 'Cal__Day__month',
  'year': 'Cal__Day__year',
  'selection': 'Cal__Day__selection',
  'day': 'Cal__Day__day',
  'range': 'Cal__Day__range',
  'start': 'Cal__Day__start',
  'end': 'Cal__Day__end',
  'betweenRange': 'Cal__Day__betweenRange'
};


var isTouchDevice = false;

var EVENT_TYPE = {
  END: 3,
  HOVER: 2,
  START: 1
};

// Enhance Day component to display selected state based on an array of selected dates
var enhanceDay$3 = _withPropsOnChange(['selected'], function (_ref) {
  var _classNames;

  var date = _ref.date,
      selected = _ref.selected,
      theme = _ref.theme;

  var isSelected = date >= selected.start && date <= selected.end;
  var isStart = date === selected.start;
  var isEnd = date === selected.end;
  var isRange = !(isStart && isEnd);
  var style = isRange && (isStart && { backgroundColor: theme.accentColor } || isEnd && { borderColor: theme.accentColor });

  return {
    className: isSelected && isRange && classnames(styles$b.range, (_classNames = {}, _classNames[styles$b.start] = isStart, _classNames[styles$b.betweenRange] = !isStart && !isEnd, _classNames[styles$b.end] = isEnd, _classNames)),
    isSelected: isSelected,
    selectionStyle: style
  };
});

// Enhancer to handle selecting and displaying multiple dates
var withRange = _compose(withDefaultProps, _withState('scrollDate', 'setScrollDate', getInitialDate$2), _withState('displayKey', 'setDisplayKey', getInitialDate$2), _withState('selectionStart', 'setSelectionStart', null), withImmutableProps(function (_ref2) {
  var DayComponent = _ref2.DayComponent,
      HeaderComponent = _ref2.HeaderComponent,
      YearsComponent = _ref2.YearsComponent;
  return {
    DayComponent: enhanceDay$3(DayComponent),
    HeaderComponent: enhanceHeader$1(HeaderComponent)
  };
}), _withProps(function (_ref3) {
  var displayKey = _ref3.displayKey,
      passThrough = _ref3.passThrough,
      selected = _ref3.selected,
      setDisplayKey = _ref3.setDisplayKey,
      props = _objectWithoutProperties$3(_ref3, ['displayKey', 'passThrough', 'selected', 'setDisplayKey']);

  return {
    /* eslint-disable sort-keys */
    passThrough: _extends$D({}, passThrough, {
      Day: {
        onClick: function onClick(date) {
          return handleSelect$1(date, _extends$D({ selected: selected }, props));
        },
        handlers: {
          onMouseOver: !isTouchDevice && props.selectionStart ? function (e) {
            return handleMouseOver(e, _extends$D({ selected: selected }, props));
          } : null
        }
      },
      Years: {
        selected: selected && selected[displayKey],
        onSelect: function onSelect(date) {
          return handleYearSelect$2(date, _extends$D({ displayKey: displayKey, selected: selected }, props));
        }
      },
      Header: {
        onYearClick: function onYearClick(date, e, key) {
          return setDisplayKey(key || 'start');
        }
      }
    }),
    selected: {
      start: selected && format_1(selected.start, 'YYYY-MM-DD'),
      end: selected && format_1(selected.end, 'YYYY-MM-DD')
    }
  };
}));
function getSortedSelection(_ref4) {
  var start = _ref4.start,
      end = _ref4.end;

  return is_before(start, end) ? { start: start, end: end } : { start: end, end: start };
}

function handleSelect$1(date, _ref5) {
  var onSelect = _ref5.onSelect,
      selected = _ref5.selected,
      selectionStart = _ref5.selectionStart,
      setSelectionStart = _ref5.setSelectionStart;

  if (selectionStart) {
    onSelect(_extends$D({
      eventType: EVENT_TYPE.END
    }, getSortedSelection({
      start: selectionStart,
      end: date
    })));
    setSelectionStart(null);
  } else {
    onSelect({ eventType: EVENT_TYPE.START, start: date, end: date });
    setSelectionStart(date);
  }
}

function handleMouseOver(e, _ref6) {
  var onSelect = _ref6.onSelect,
      selectionStart = _ref6.selectionStart;

  var dateStr = e.target.getAttribute('data-date');
  var date = dateStr && parse_1(dateStr);

  if (!date) {
    return;
  }

  onSelect(_extends$D({
    eventType: EVENT_TYPE.HOVER
  }, getSortedSelection({
    start: selectionStart,
    end: date
  })));
}

function handleYearSelect$2(date, _ref7) {
  var _Object$assign;

  var displayKey = _ref7.displayKey,
      onSelect = _ref7.onSelect,
      selected = _ref7.selected,
      setScrollDate = _ref7.setScrollDate;


  setScrollDate(date);
  onSelect(getSortedSelection(Object.assign({}, selected, (_Object$assign = {}, _Object$assign[displayKey] = parse_1(date), _Object$assign))));
}

function getInitialDate$2(_ref8) {
  var selected = _ref8.selected;

  return selected && selected.start || new Date();
}

if (typeof window !== 'undefined') {
  window.addEventListener('touchstart', function onTouch() {
    isTouchDevice = true;

    window.removeEventListener('touchstart', onTouch, false);
  });
}

var _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class$3, _temp2;

function _objectWithoutProperties$4(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$a(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$a(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * By default, Calendar is a controlled component.
 * Export a sensible default for minimal setup
 */
var DefaultCalendar = (_temp2 = _class$3 = function (_Component) {
  _inherits$a(DefaultCalendar, _Component);

  function DefaultCalendar() {
    var _temp, _this, _ret;

    _classCallCheck$b(this, DefaultCalendar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$a(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      selected: typeof _this.props.selected !== 'undefined' ? _this.props.selected : new Date()
    }, _this.handleSelect = function (selected) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          interpolateSelection = _this$props.interpolateSelection;


      if (typeof onSelect === 'function') {
        onSelect(selected);
      }

      _this.setState({ selected: interpolateSelection(selected, _this.state.selected) });
    }, _temp), _possibleConstructorReturn$a(_this, _ret);
  }

  DefaultCalendar.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var selected = _ref.selected;

    if (selected !== this.props.selected) {
      this.setState({ selected: selected });
    }
  };

  DefaultCalendar.prototype.render = function render() {
    // eslint-disable-next-line no-unused-vars
    var _props = this.props,
        Component$$1 = _props.Component,
        interpolateSelection = _props.interpolateSelection,
        props = _objectWithoutProperties$4(_props, ['Component', 'interpolateSelection']);

    return React.createElement(Component$$1, _extends$E({}, props, {
      onSelect: this.handleSelect,
      selected: this.state.selected
    }));
  };

  return DefaultCalendar;
}(Component), _class$3.defaultProps = {
  Component: withDateSelection(Calendar),
  interpolateSelection: function interpolateSelection(selected) {
    return selected;
  }
}, _temp2);

var css$2 = ".styles_Cal__Day__root__13P2L {\n  display: inline-block;\n  box-sizing: border-box;\n  width: 14.28571%;\n  list-style: none;\n  font-size: 16px;\n  text-align: center;\n  cursor: pointer;\n  user-select: none; }\n  .styles_Cal__Day__root__13P2L.styles_Cal__Day__enabled__13cXS.styles_Cal__Day__highlighted__2ooKa, .styles_Cal__Day__root__13P2L.styles_Cal__Day__enabled__13cXS:active, .styles_Cal__Day__root__13P2L.styles_Cal__Day__enabled__13cXS:hover {\n    position: relative;\n    z-index: 1; }\n    .styles_Cal__Day__root__13P2L.styles_Cal__Day__enabled__13cXS.styles_Cal__Day__highlighted__2ooKa:before, .styles_Cal__Day__root__13P2L.styles_Cal__Day__enabled__13cXS:active:before, .styles_Cal__Day__root__13P2L.styles_Cal__Day__enabled__13cXS:hover:before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: 52px;\n      height: 52px;\n      margin-top: -26px;\n      margin-left: -26px;\n      border-radius: 50%;\n      background-color: #EFEFEF;\n      z-index: -1; }\n  .styles_Cal__Day__root__13P2L.styles_Cal__Day__enabled__13cXS:hover:before {\n    opacity: 0.5; }\n  .styles_Cal__Day__root__13P2L.styles_Cal__Day__enabled__13cXS.styles_Cal__Day__highlighted__2ooKa:before, .styles_Cal__Day__root__13P2L.styles_Cal__Day__enabled__13cXS:active:before {\n    opacity: 1; }\n  .styles_Cal__Day__root__13P2L:first-child {\n    position: relative; }\n  .styles_Cal__Day__root__13P2L.styles_Cal__Day__today__hVHhP {\n    position: relative;\n    z-index: 2; }\n    .styles_Cal__Day__root__13P2L.styles_Cal__Day__today__hVHhP > span {\n      color: #3d3d3d; }\n    .styles_Cal__Day__root__13P2L.styles_Cal__Day__today__hVHhP.styles_Cal__Day__disabled__YikHL > span {\n      color: #AAA; }\n    .styles_Cal__Day__root__13P2L.styles_Cal__Day__today__hVHhP:before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: 52px;\n      height: 52px;\n      margin-top: -26px;\n      margin-left: -26px;\n      border-radius: 50%;\n      box-shadow: inset 0 0 0 1px;\n      z-index: -1; }\n    .styles_Cal__Day__root__13P2L.styles_Cal__Day__today__hVHhP.styles_Cal__Day__disabled__YikHL:before {\n      box-shadow: inset 0 0 0 1px #BBB; }\n  .styles_Cal__Day__root__13P2L.styles_Cal__Day__selected__2_sUS {\n    position: relative; }\n    .styles_Cal__Day__root__13P2L.styles_Cal__Day__selected__2_sUS > .styles_Cal__Day__month__29uOd, .styles_Cal__Day__root__13P2L.styles_Cal__Day__selected__2_sUS > .styles_Cal__Day__year__fjeB5 {\n      display: none; }\n    .styles_Cal__Day__root__13P2L.styles_Cal__Day__selected__2_sUS:before {\n      display: none; }\n    .styles_Cal__Day__root__13P2L.styles_Cal__Day__selected__2_sUS .styles_Cal__Day__selection__20N-k {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: 52px;\n      height: 52px;\n      margin-top: -26px;\n      margin-left: -26px;\n      border-radius: 50%;\n      line-height: 56px;\n      z-index: 2; }\n      .styles_Cal__Day__root__13P2L.styles_Cal__Day__selected__2_sUS .styles_Cal__Day__selection__20N-k .styles_Cal__Day__month__29uOd {\n        top: 9px; }\n      .styles_Cal__Day__root__13P2L.styles_Cal__Day__selected__2_sUS .styles_Cal__Day__selection__20N-k .styles_Cal__Day__day__1H393 {\n        position: relative;\n        top: 5px;\n        font-weight: bold;\n        font-size: 18px; }\n  .styles_Cal__Day__root__13P2L.styles_Cal__Day__disabled__YikHL {\n    color: #AAA;\n    cursor: not-allowed; }\n\n.styles_Cal__Day__month__29uOd, .styles_Cal__Day__year__fjeB5 {\n  position: absolute;\n  left: 0;\n  right: 0;\n  font-size: 12px;\n  line-height: 12px;\n  text-transform: capitalize; }\n\n.styles_Cal__Day__month__29uOd {\n  top: 5px; }\n\n.styles_Cal__Day__year__fjeB5 {\n  bottom: 5px; }\n\n/*\n * Range selection styles\n */\n.styles_Cal__Day__range__3y6He.styles_Cal__Day__selected__2_sUS.styles_Cal__Day__start__7NbzB:after, .styles_Cal__Day__range__3y6He.styles_Cal__Day__selected__2_sUS.styles_Cal__Day__end__3yKrk:after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  width: 50%;\n  height: 52px;\n  margin-top: -26px;\n  box-shadow: inset 56px 56px; }\n\n.styles_Cal__Day__range__3y6He.styles_Cal__Day__selected__2_sUS.styles_Cal__Day__disabled__YikHL .styles_Cal__Day__selection__20N-k.styles_Cal__Day__selection__20N-k {\n  background-color: #EEE !important; }\n  .styles_Cal__Day__range__3y6He.styles_Cal__Day__selected__2_sUS.styles_Cal__Day__disabled__YikHL .styles_Cal__Day__selection__20N-k.styles_Cal__Day__selection__20N-k .styles_Cal__Day__day__1H393, .styles_Cal__Day__range__3y6He.styles_Cal__Day__selected__2_sUS.styles_Cal__Day__disabled__YikHL .styles_Cal__Day__selection__20N-k.styles_Cal__Day__selection__20N-k .styles_Cal__Day__month__29uOd {\n    color: #AAA;\n    font-weight: 300; }\n\n.styles_Cal__Day__range__3y6He.styles_Cal__Day__selected__2_sUS.styles_Cal__Day__start__7NbzB .styles_Cal__Day__selection__20N-k {\n  border-top-left-radius: 50%;\n  border-bottom-left-radius: 50%; }\n\n.styles_Cal__Day__range__3y6He.styles_Cal__Day__selected__2_sUS.styles_Cal__Day__start__7NbzB:after {\n  right: 0; }\n\n.styles_Cal__Day__range__3y6He.styles_Cal__Day__selected__2_sUS.styles_Cal__Day__start__7NbzB.styles_Cal__Day__end__3yKrk:after {\n  display: none; }\n\n.styles_Cal__Day__range__3y6He.styles_Cal__Day__selected__2_sUS.styles_Cal__Day__betweenRange__13PX3 .styles_Cal__Day__selection__20N-k {\n  left: 0;\n  right: 0;\n  width: 100%;\n  margin-left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 0; }\n\n.styles_Cal__Day__range__3y6He.styles_Cal__Day__selected__2_sUS.styles_Cal__Day__betweenRange__13PX3 .styles_Cal__Day__day__1H393 {\n  top: 0;\n  font-size: 16px; }\n\n.styles_Cal__Day__range__3y6He.styles_Cal__Day__selected__2_sUS.styles_Cal__Day__betweenRange__13PX3 .styles_Cal__Day__month__29uOd {\n  display: none; }\n\n.styles_Cal__Day__range__3y6He.styles_Cal__Day__selected__2_sUS.styles_Cal__Day__end__3yKrk:after {\n  left: 0; }\n\n.styles_Cal__Day__range__3y6He.styles_Cal__Day__selected__2_sUS.styles_Cal__Day__end__3yKrk .styles_Cal__Day__selection__20N-k {\n  border-top-right-radius: 50%;\n  border-bottom-right-radius: 50%;\n  color: inherit !important;\n  background-color: #FFF !important;\n  border: 2px solid;\n  box-sizing: border-box; }\n  .styles_Cal__Day__range__3y6He.styles_Cal__Day__selected__2_sUS.styles_Cal__Day__end__3yKrk .styles_Cal__Day__selection__20N-k .styles_Cal__Day__day__1H393 {\n    top: 4px; }\n.styles_Cal__Container__root__2gXkU {\n  position: relative;\n  display: table;\n  z-index: 1;\n  font: 14px 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  line-height: 1.4em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: 300;\n  outline: none;\n  text-align: left; }\n  .styles_Cal__Container__root__2gXkU.styles_Cal__Container__landscape__28wxG {\n    display: flex;\n    flex-direction: row; }\n    .styles_Cal__Container__root__2gXkU.styles_Cal__Container__landscape__28wxG .styles_Cal__Container__wrapper__2EeLV {\n      position: relative;\n      flex-grow: 1;\n      overflow: hidden;\n      z-index: 1;\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px; }\n\n.styles_Cal__Container__listWrapper__3qo3X {\n  position: relative;\n  overflow: hidden;\n  background-color: #FFF; }\n.styles_Cal__Header__root__1hshP {\n  position: relative;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  overflow: hidden;\n  min-height: 98px;\n  padding: 20px;\n  line-height: 1.3;\n  font-weight: 400;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px; }\n  .styles_Cal__Header__root__1hshP.styles_Cal__Header__landscape__3M-AQ {\n    align-items: flex-start;\n    min-width: 200px;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: 3px; }\n    .styles_Cal__Header__root__1hshP.styles_Cal__Header__landscape__3M-AQ .styles_Cal__Header__dateWrapper__1KIGm.styles_Cal__Header__day__2uu4h {\n      flex-grow: 1;\n      height: 76px; }\n\n.styles_Cal__Header__wrapper__bczju {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  cursor: pointer; }\n  .styles_Cal__Header__wrapper__bczju.styles_Cal__Header__blank__2BQTF {\n    height: 58px;\n    line-height: 58px;\n    color: rgba(255, 255, 255, 0.5);\n    font-size: 18px;\n    cursor: default; }\n\n.styles_Cal__Header__dateWrapper__1KIGm {\n  position: relative;\n  display: block;\n  overflow: hidden;\n  color: rgba(255, 255, 255, 0.5);\n  transition: color 0.3s ease; }\n  .styles_Cal__Header__dateWrapper__1KIGm.styles_Cal__Header__active__p_d5v {\n    color: white; }\n  .styles_Cal__Header__dateWrapper__1KIGm.styles_Cal__Header__day__2uu4h {\n    height: 38px;\n    font-size: 36px;\n    line-height: 36px;\n    text-transform: capitalize; }\n  .styles_Cal__Header__dateWrapper__1KIGm.styles_Cal__Header__year__WP9jZ {\n    height: 20px;\n    font-size: 18px;\n    line-height: 18px; }\n\n.styles_Cal__Header__date__3RHDZ {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n\n.styles_Cal__Header__range__1xAS_ {\n  display: flex;\n  flex-grow: 1; }\n  .styles_Cal__Header__range__1xAS_ .styles_Cal__Header__dateWrapper__1KIGm {\n    overflow: visible; }\n  .styles_Cal__Header__range__1xAS_ .styles_Cal__Header__wrapper__bczju:first-child:before, .styles_Cal__Header__range__1xAS_ .styles_Cal__Header__wrapper__bczju:first-child:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    width: 0;\n    height: 0;\n    margin-top: -50px;\n    margin-left: -50px;\n    border-top: 100px solid transparent;\n    border-bottom: 100px solid transparent;\n    border-left: 60px solid; }\n  .styles_Cal__Header__range__1xAS_ .styles_Cal__Header__wrapper__bczju:first-child:before {\n    color: rgba(255, 255, 255, 0.15);\n    transform: translateX(1px); }\n  .styles_Cal__Header__range__1xAS_ .styles_Cal__Header__wrapper__bczju:last-child {\n    margin-left: 60px; }\n  .styles_Cal__Header__range__1xAS_ .styles_Cal__Header__wrapper__bczju .styles_Cal__Header__date__3RHDZ {\n    white-space: nowrap;\n    z-index: 1; }\n.styles_Cal__Today__root__OMqqi {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  padding: 6px;\n  box-sizing: border-box;\n  transform: translate3d(0, -100%, 0);\n  font-weight: 500;\n  line-height: 0;\n  z-index: 10;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  transition-delay: 0.3s; }\n  .styles_Cal__Today__root__OMqqi.styles_Cal__Today__show__26fpA {\n    transform: translate3d(0, 0, 0);\n    transition-delay: 0s; }\n    .styles_Cal__Today__root__OMqqi.styles_Cal__Today__show__26fpA .styles_Cal__Today__chevron__WzTg- {\n      transition: transform 0.3s ease; }\n  .styles_Cal__Today__root__OMqqi .styles_Cal__Today__chevron__WzTg- {\n    position: absolute;\n    top: 50%;\n    margin-top: -6px;\n    margin-left: 5px;\n    transform: rotate(270deg);\n    transition: transform 0.3s ease; }\n  .styles_Cal__Today__root__OMqqi.styles_Cal__Today__chevronUp__1VtcQ .styles_Cal__Today__chevron__WzTg- {\n    transform: rotate(180deg); }\n  .styles_Cal__Today__root__OMqqi.styles_Cal__Today__chevronDown__1Uk-4 .styles_Cal__Today__chevron__WzTg- {\n    transform: rotate(360deg); }\n.styles_Cal__MonthList__root__3EaZy {\n  width: 100% !important;\n  background-color: #FFF;\n  -webkit-overflow-scrolling: touch; }\n  .styles_Cal__MonthList__root__3EaZy.styles_Cal__MonthList__scrolling__2iugC > div {\n    pointer-events: none; }\n  .styles_Cal__MonthList__root__3EaZy.styles_Cal__MonthList__scrolling__2iugC label {\n    opacity: 1; }\n.styles_Cal__Weekdays__root__17lQg {\n  position: relative;\n  z-index: 5;\n  display: flex;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.04); }\n\n.styles_Cal__Weekdays__day__2aMoL {\n  padding: 15px 0;\n  flex-basis: 14.28571%;\n  flex-grow: 1;\n  font-weight: 500;\n  text-align: center; }\n.styles_Cal__Years__root__3o8ir {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #F9F9F9; }\n  .styles_Cal__Years__root__3o8ir:before, .styles_Cal__Years__root__3o8ir:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    height: 50px;\n    pointer-events: none;\n    z-index: 1; }\n  .styles_Cal__Years__root__3o8ir:before {\n    top: 0;\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 100%); }\n  .styles_Cal__Years__root__3o8ir:after {\n    bottom: 0;\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 100%); }\n\n.styles_Cal__Years__list__1PZph {\n  box-sizing: border-box; }\n  .styles_Cal__Years__list__1PZph.styles_Cal__Years__center__d63Hn {\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n\n.styles_Cal__Years__year__1ORY9 {\n  display: flex;\n  padding: 0 20px;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 500;\n  text-align: center;\n  cursor: pointer;\n  -webkit-user-select: none;\n  box-sizing: border-box; }\n  .styles_Cal__Years__year__1ORY9.styles_Cal__Years__withMonths__3d3hW {\n    border-bottom: 1px solid #E9E9E9; }\n    .styles_Cal__Years__year__1ORY9.styles_Cal__Years__withMonths__3d3hW label {\n      height: 88px;\n      padding-top: 12px;\n      box-sizing: border-box; }\n  .styles_Cal__Years__year__1ORY9 label {\n    flex-basis: 42%; }\n    .styles_Cal__Years__year__1ORY9 label span {\n      flex-shrink: 0;\n      color: #333; }\n  .styles_Cal__Years__year__1ORY9 ol {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0;\n    padding: 0;\n    font-size: 14px; }\n    .styles_Cal__Years__year__1ORY9 ol li {\n      display: flex;\n      width: 44px;\n      height: 44px;\n      flex-shrink: 0;\n      align-items: center;\n      justify-content: center;\n      list-style: none;\n      border-radius: 50%;\n      box-sizing: border-box;\n      color: #444;\n      font-weight: 400;\n      text-transform: capitalize; }\n      .styles_Cal__Years__year__1ORY9 ol li.styles_Cal__Years__currentMonth__1z-l1 {\n        border: 1px solid; }\n      .styles_Cal__Years__year__1ORY9 ol li.styles_Cal__Years__selected__3ff2B {\n        position: relative;\n        z-index: 1;\n        background-color: blue;\n        color: #FFF !important;\n        border: 0; }\n      .styles_Cal__Years__year__1ORY9 ol li.styles_Cal__Years__disabled__2Nux3 {\n        cursor: not-allowed;\n        color: #AAA; }\n        .styles_Cal__Years__year__1ORY9 ol li.styles_Cal__Years__disabled__2Nux3:hover {\n          background-color: inherit; }\n      .styles_Cal__Years__year__1ORY9 ol li:hover {\n        background-color: #EFEFEF; }\n  .styles_Cal__Years__year__1ORY9:hover label > span, .styles_Cal__Years__year__1ORY9.styles_Cal__Years__active__2v_iC label > span {\n    color: inherit; }\n  .styles_Cal__Years__year__1ORY9:hover, .styles_Cal__Years__year__1ORY9.styles_Cal__Years__active__2v_iC {\n    position: relative;\n    z-index: 2; }\n  .styles_Cal__Years__year__1ORY9.styles_Cal__Years__active__2v_iC {\n    font-size: 32px; }\n  .styles_Cal__Years__year__1ORY9.styles_Cal__Years__currentYear__1z93o {\n    position: relative; }\n    .styles_Cal__Years__year__1ORY9.styles_Cal__Years__currentYear__1z93o label > span {\n      min-width: 50px;\n      padding-bottom: 5px;\n      border-bottom: 3px solid; }\n    .styles_Cal__Years__year__1ORY9.styles_Cal__Years__currentYear__1z93o.styles_Cal__Years__active__2v_iC label > span {\n      min-width: 85px; }\n  .styles_Cal__Years__year__1ORY9.styles_Cal__Years__first__23QDI {\n    padding-top: 40px; }\n  .styles_Cal__Years__year__1ORY9.styles_Cal__Years__last__1wR9y {\n    padding-bottom: 40px; }\n.styles_Cal__Animation__enter__17A4x {\n  opacity: 0;\n  transform: translate3d(0, -100%, 0);\n  transition: 0.25s ease; }\n\n.styles_Cal__Animation__enter__17A4x.styles_Cal__Animation__enterActive__3FC6p {\n  opacity: 1;\n  transform: translate3d(0, 0, 0); }\n\n.styles_Cal__Animation__leave__iyCDF {\n  transform: translate3d(0, 0, 0);\n  transition: 0.25s ease; }\n\n.styles_Cal__Animation__leave__iyCDF.styles_Cal__Animation__leaveActive__2EUcP {\n  opacity: 0;\n  transform: translate3d(0, 100%, 0); }\n.styles_Cal__Slider__root__1lHln, .styles_Cal__Slider__slide__1INfG {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n\n.styles_Cal__Slider__root__1lHln {\n  overflow: hidden; }\n\n.styles_Cal__Slider__slide__1INfG {\n  padding: 20px 65px; }\n  .styles_Cal__Slider__slide__1INfG:first-child {\n    padding-left: 20px; }\n\n.styles_Cal__Slider__wrapper__5bsTN {\n  height: 100%;\n  transition: transform 0.3s ease; }\n\n.styles_Cal__Slider__arrow__JxcRk {\n  position: absolute;\n  top: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 100%;\n  opacity: 0.7;\n  cursor: pointer;\n  border-left: 1px solid rgba(255, 255, 255, 0.1); }\n  .styles_Cal__Slider__arrow__JxcRk svg {\n    width: 15px; }\n  .styles_Cal__Slider__arrow__JxcRk:hover {\n    opacity: 1; }\n\n.styles_Cal__Slider__arrowRight__1AbnD {\n  right: 0; }\n\n.styles_Cal__Slider__arrowLeft__3MwMz {\n  left: 0;\n  transform: scaleX(-1); }\n.styles_Cal__transition__enter__2ryQw {\n  opacity: 0; }\n\n.styles_Cal__transition__enterActive__2rgFs {\n  opacity: 1;\n  transition: opacity 0.3s ease; }\n\n.styles_Cal__transition__leave__37WbL {\n  opacity: 1; }\n\n.styles_Cal__transition__leaveActive__1Qvb2 {\n  opacity: 0;\n  transition: opacity 0.3s ease; }\n.styles_Cal__Month__rows__2Mx-Y {\n  position: relative;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 0.05) 100%); }\n\n.styles_Cal__Month__row__2zd1w {\n  padding: 0;\n  margin: 0; }\n  .styles_Cal__Month__row__2zd1w:first-child {\n    text-align: right; }\n    .styles_Cal__Month__row__2zd1w:first-child li {\n      background-color: #FFF;\n      box-shadow: 0 -1px 0 #E9E9E9; }\n  .styles_Cal__Month__row__2zd1w:nth-child(2) {\n    box-shadow: 0 -1px 0 #E9E9E9; }\n  .styles_Cal__Month__row__2zd1w.styles_Cal__Month__partial__1xg1o:first-child li:first-child {\n    box-shadow: 0px -1px 0 #E9E9E9, inset 1px 0 0 #E9E9E9; }\n  .styles_Cal__Month__row__2zd1w.styles_Cal__Month__partial__1xg1o:last-of-type li {\n    position: relative;\n    z-index: 1; }\n\n.styles_Cal__Month__label__1qKwe {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: 0;\n  font-size: 30px;\n  font-weight: 500;\n  z-index: 3;\n  pointer-events: none;\n  background-color: rgba(255, 255, 255, 0.6);\n  opacity: 0;\n  transition: opacity 0.3s ease; }\n  .styles_Cal__Month__label__1qKwe > span {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 56px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-transform: capitalize; }\n  .styles_Cal__Month__label__1qKwe.styles_Cal__Month__partialFirstRow__1_uXd {\n    top: 56px; }\n";
styleInject(css$2);

function buildDistanceInWordsLocale$1 () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'mindre end et sekund',
      other: 'mindre end {{count}} sekunder'
    },

    xSeconds: {
      one: '1 sekund',
      other: '{{count}} sekunder'
    },

    halfAMinute: 'et halvt minut',

    lessThanXMinutes: {
      one: 'mindre end et minut',
      other: 'mindre end {{count}} minutter'
    },

    xMinutes: {
      one: '1 minut',
      other: '{{count}} minutter'
    },

    aboutXHours: {
      one: 'cirka 1 time',
      other: 'cirka {{count}} timer'
    },

    xHours: {
      one: '1 time',
      other: '{{count}} timer'
    },

    xDays: {
      one: '1 dag',
      other: '{{count}} dage'
    },

    aboutXMonths: {
      one: 'cirka 1 måned',
      other: 'cirka {{count}} måneder'
    },

    xMonths: {
      one: '1 måned',
      other: '{{count}} måneder'
    },

    aboutXYears: {
      one: 'cirka 1 år',
      other: 'cirka {{count}} år'
    },

    xYears: {
      one: '1 år',
      other: '{{count}} år'
    },

    overXYears: {
      one: 'over 1 år',
      other: 'over {{count}} år'
    },

    almostXYears: {
      one: 'næsten 1 år',
      other: 'næsten {{count}} år'
    }
  };

  function localize (token, count, options) {
    options = options || {};

    var result;
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token];
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one;
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count);
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'om ' + result
      } else {
        return result + ' siden'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

var build_distance_in_words_locale$1 = buildDistanceInWordsLocale$1;

function buildFormatLocale$1 () {
  var months3char = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var monthsFull = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'];
  var weekdays2char = ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'];
  var weekdays3char = ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'];
  var weekdaysFull = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
  var meridiemUppercase = ['AM', 'PM'];
  var meridiemLowercase = ['am', 'pm'];
  var meridiemFull = ['a.m.', 'p.m.'];

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  };

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W'];
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal$1(formatters[formatterToken](date))
    };
  });

  return {
    formatters: formatters,
    formattingTokensRegExp: build_formatting_tokens_reg_exp(formatters)
  }
}

function ordinal$1 (number$$1) {
  return number$$1 + '.'
}

var build_format_locale$1 = buildFormatLocale$1;

/**
 * @category Locales
 * @summary Danish locale.
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 */
var da$1 = {
  distanceInWords: build_distance_in_words_locale$1(),
  format: build_format_locale$1()
};

var _templateObject$D = taggedTemplateLiteral(['\n    max-width: calc(50% - 8px);\n'], ['\n    max-width: calc(50% - 8px);\n']),
    _templateObject2$u = taggedTemplateLiteral(['\n    max-width: calc(50% - 8px);\n\n    &:disabled {\n        opacity: 0.5;\n    }\n'], ['\n    max-width: calc(50% - 8px);\n\n    &:disabled {\n        opacity: 0.5;\n    }\n']);

var CancelButton$1 = styled(Button$1)(_templateObject$D);

var AcceptButton$1 = styled(Button$1)(_templateObject2$u);

var AcceptAndCancelButtons = function AcceptAndCancelButtons(_ref) {
    var theme = _ref.theme,
        _ref$cancelAction = _ref.cancelAction,
        cancelAction = _ref$cancelAction === undefined ? function () {} : _ref$cancelAction,
        _ref$acceptAction = _ref.acceptAction,
        acceptAction = _ref$acceptAction === undefined ? function () {} : _ref$acceptAction,
        _ref$disableAcceptBut = _ref.disableAcceptButton,
        disableAcceptButton = _ref$disableAcceptBut === undefined ? false : _ref$disableAcceptBut,
        _ref$cancelLabel = _ref.cancelLabel,
        cancelLabel = _ref$cancelLabel === undefined ? 'Annuller' : _ref$cancelLabel,
        _ref$acceptLabel = _ref.acceptLabel,
        acceptLabel = _ref$acceptLabel === undefined ? 'Vis' : _ref$acceptLabel,
        _ref$position = _ref.position,
        position = _ref$position === undefined ? 'absolute' : _ref$position,
        borderRadius = _ref.borderRadius;

    return React.createElement(
        ButtonsArea$1,
        { position: position, borderRadius: borderRadius },
        React.createElement(
            CancelButton$1,
            {
                bgColor: theme.colors.colorBackgroundSurfacePrimaryDefault,
                bgColorHover: theme.colors.colorBackgroundSurfacePrimaryDefault,
                borderColor: theme.colors.colorBorderPrimaryDefault,
                onClick: cancelAction
            },
            cancelLabel
        ),
        React.createElement(
            AcceptButton$1,
            { onClick: acceptAction, disabled: disableAcceptButton },
            acceptLabel
        )
    );
};

AcceptAndCancelButtons.propTypes = {};

var AcceptAndCancelButtons$1 = withTheme(AcceptAndCancelButtons);

var _templateObject$E = taggedTemplateLiteral(['\n    height: ', ';\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    padding: ', ';\n    overflow-y: ', ';\n    justify-content: ', ';\n    box-sizing: border-box;\n'], ['\n    height: ', ';\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    padding: ', ';\n    overflow-y: ', ';\n    justify-content: ', ';\n    box-sizing: border-box;\n']),
    _templateObject2$v = taggedTemplateLiteral(['\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: ', ';\n    box-sizing: border-box;\n    background: rgba(0, 0, 0, 0.5);\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    z-index: 13;\n'], ['\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: ', ';\n    box-sizing: border-box;\n    background: rgba(0, 0, 0, 0.5);\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    z-index: 13;\n']),
    _templateObject3$n = taggedTemplateLiteral(['\n    height: auto;\n    width: ', ';\n    border-radius: ', ';\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    box-sizing: border-box;\n    background-color: ', ';\n    position: relative;\n    z-index: 14;\n'], ['\n    height: auto;\n    width: ', ';\n    border-radius: ', ';\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    box-sizing: border-box;\n    background-color: ', ';\n    position: relative;\n    z-index: 14;\n']),
    _templateObject4$k = taggedTemplateLiteral(['\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    border-top: ', ';\n'], ['\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    border-top: ', ';\n']),
    _templateObject5$i = taggedTemplateLiteral(['\n    height: ', ';\n    width: 100%;\n    padding: 0 16px;\n    display: flex;\n    flex-direction: row;\n    align-items: ', ';\n    justify-content: space-between;\n    box-sizing: border-box;\n    margin: ', ';\n'], ['\n    height: ', ';\n    width: 100%;\n    padding: 0 16px;\n    display: flex;\n    flex-direction: row;\n    align-items: ', ';\n    justify-content: space-between;\n    box-sizing: border-box;\n    margin: ', ';\n']),
    _templateObject6$e = taggedTemplateLiteral(['\n    display: block;\n    box-sizing: border-box;\n    position: absolute;\n    right: 16px;\n    top: 16px;\n    z-index: 6;\n'], ['\n    display: block;\n    box-sizing: border-box;\n    position: absolute;\n    right: 16px;\n    top: 16px;\n    z-index: 6;\n']),
    _templateObject7$c = taggedTemplateLiteral(['\n    display: block;\n    width: ', ';\n    box-sizing: border-box;\n'], ['\n    display: block;\n    width: ', ';\n    box-sizing: border-box;\n']),
    _templateObject8$b = taggedTemplateLiteral(['\n    height: auto;\n    width: 100%;\n    margin: 5px 0 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px;\n    border-radius: 8px;\n    background-color: ', ';\n    border: 1px solid ', ';\n    box-sizing: border-box;\n    cursor: pointer;\n    position: relative;\n    z-index: 12;\n'], ['\n    height: auto;\n    width: 100%;\n    margin: 5px 0 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px;\n    border-radius: 8px;\n    background-color: ', ';\n    border: 1px solid ', ';\n    box-sizing: border-box;\n    cursor: pointer;\n    position: relative;\n    z-index: 12;\n']),
    _templateObject9$9 = taggedTemplateLiteral(['\n    height: auto;\n    width: 100%;\n    display: block;\n    box-sizing: border-box;\n    padding: 0;\n    overflow: hidden;\n    border-radius: 8px;\n'], ['\n    height: auto;\n    width: 100%;\n    display: block;\n    box-sizing: border-box;\n    padding: 0;\n    overflow: hidden;\n    border-radius: 8px;\n']),
    _templateObject10$6 = taggedTemplateLiteral(['\n    overflow: hidden;\n    margin: 0;\n    padding: 0;\n    border-radius: ', ';\n    background-color: ', ';\n\n    li.Cal__Day__root {\n        height: 100%;\n    }\n\n    .Cal__Day__month {\n        top: 11px;\n    }\n\n    .Cal__Today__root .Cal__Today__chevron {\n        position: relative;\n        top: 28%;\n    }\n'], ['\n    overflow: hidden;\n    margin: 0;\n    padding: 0;\n    border-radius: ', ';\n    background-color: ', ';\n\n    li.Cal__Day__root {\n        height: 100%;\n    }\n\n    .Cal__Day__month {\n        top: 11px;\n    }\n\n    .Cal__Today__root .Cal__Today__chevron {\n        position: relative;\n        top: 28%;\n    }\n']);

var Wrapper$b = styled.div(_templateObject$E, function (_ref) {
    var height = _ref.height;
    return '' + height || 'auto';
}, function (_ref2) {
    var padding = _ref2.padding;
    return '' + padding || ' 0 24px 70px';
}, function (_ref3) {
    var overflowY = _ref3.overflowY;
    return '' + overflowY || 'auto';
}, function (_ref4) {
    var justify = _ref4.justify;
    return '' + justify || 'flex-start';
});

var ChooseDatePageWrapper = styled.div(_templateObject2$v, detectMobile() ? 'flex-end' : 'center');
var ChooseDateWrapper = styled.div(_templateObject3$n, detectMobile() ? '100%' : 'auto', detectMobile() ? '8px 8px 0 0' : ' 8px', function (props) {
    return '' + props.bgColor || props.theme.colors.colorBackgroundSurfacePrimaryDefault;
});

var HR$1 = styled.div(_templateObject4$k, function (_ref5) {
    var height = _ref5.height,
        type = _ref5.type,
        color = _ref5.color;
    return height + ' ' + type + ' ' + color || '1px solid #DFE5ED';
});
var DateRangeWrapper = styled.div(_templateObject5$i, detectMobile() ? 'calc(100% - 130px)' : 'calc(100% - 134px)', detectMobile() ? 'center' : 'center', function (_ref6) {
    var margin = _ref6.margin;
    return '' + margin || '0';
});

var WrapperCloseIcon = styled.div(_templateObject6$e);
var DateRangeItem = styled.div(_templateObject7$c, detectMobile ? 'calc(50% - 8px)' : '100%');
var DateRangeInput = styled.div(_templateObject8$b, function (_ref7) {
    var bgColor = _ref7.bgColor;
    return '' + bgColor || '#fff';
}, function (_ref8) {
    var borderColor = _ref8.borderColor;
    return '' + borderColor || '#DFE5ED';
});

var DatePickerPage = styled.div(_templateObject9$9);

var DatePickerWrapper = styled.div(_templateObject10$6, detectMobile() ? '8px 8px 0 0' : '8px', function (props) {
    return '' + props.bgColor || 'none';
});

var DatePicker = function DatePicker(_ref) {
    var theme = _ref.theme,
        _ref$onDateSelected = _ref.onDateSelected,
        onDateSelected = _ref$onDateSelected === undefined ? function () {} : _ref$onDateSelected,
        propsDate = _ref.propsDate,
        selectedDate = _ref.selectedDate,
        minDateProps = _ref.minDateProps,
        maxDateProps = _ref.maxDateProps,
        _ref$datePickerTheme = _ref.datePickerTheme,
        datePickerTheme = _ref$datePickerTheme === undefined ? {} : _ref$datePickerTheme,
        _ref$closeDatepicker = _ref.closeDatepicker,
        closeDatepicker = _ref$closeDatepicker === undefined ? function () {} : _ref$closeDatepicker;

    var _useState = useState(new Date()),
        _useState2 = slicedToArray(_useState, 2),
        date = _useState2[0],
        setDate = _useState2[1];

    var defaultMinDate = new Date(1980, 0, 1); // default infinite scroll value
    var defaultMaxDate = new Date(2030, 11, 31);

    var _useState3 = useState(minDateProps || defaultMinDate),
        _useState4 = slicedToArray(_useState3, 2),
        minDate = _useState4[0],
        setMinDate = _useState4[1];

    var _useState5 = useState(maxDateProps || defaultMaxDate),
        _useState6 = slicedToArray(_useState5, 2),
        maxDate = _useState6[0],
        setMaxDate = _useState6[1];

    var chooseDate = function chooseDate() {
        onDateSelected(date);
    };

    var onSelectHandler = function onSelectHandler(date) {
        setDate(date);
    };

    useEffect(function () {
        if (selectedDate) {
            setDate(propsDate);
        } else {
            setDate(propsDate);
        }
    }, []);

    var rangeConfigs = !selectedDate ? {
        minDate: minDate ? minDate : new Date(moment().format()),

        maxDate: maxDate ? maxDate : new Date(moment().add(6, 'days').format())
    } : {
        minDate: minDate ? minDate : defaultMinDate,
        maxDate: maxDate ? maxDate : defaultMaxDate
    };

    return React.createElement(
        DatePickerPage,
        null,
        React.createElement(
            Wrapper$b,
            { overflowY: 'hidden', padding: '0' },
            React.createElement(
                DatePickerWrapper,
                null,
                React.createElement(DefaultCalendar, _extends({}, rangeConfigs, {
                    selected: date,
                    onSelect: onSelectHandler,
                    theme: datePickerTheme || DATEPICKER_THEME_CONFIG,
                    width: detectMobile() ? window.innerWidth : 516,
                    height: detectMobile() ? 307 : 418,
                    rowHeight: 70,
                    locale: {
                        locale: da$1,
                        blank: 'Vælg en dato ...',
                        headerFormat: 'ddd, MMM DD',
                        todayLabel: {
                            long: 'I dag'
                        },
                        months: 'januar, februar, marts, april, maj, juni, juli, august, september, oktober, november, december'.split(','),
                        monthsShort: 'jan,feb,mar2,apr2,maj,jun,jul,aug,sep,okt,nov,dec'.split(','),
                        weekdays: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
                        weekStartsOn: 0
                    }
                }))
            )
        ),
        React.createElement(AcceptAndCancelButtons$1, {
            cancelAction: function cancelAction() {
                closeDatepicker();
            },
            position: 'relative',
            acceptAction: chooseDate,
            acceptLabel: 'Vælg dato',
            disableAcceptButton: moment(new Date()).isBefore(date)
        })
    );
};

var ChooseDate = function ChooseDate(_ref) {
    var _ref$closeChooseDate = _ref.closeChooseDate,
        closeChooseDate = _ref$closeChooseDate === undefined ? function () {} : _ref$closeChooseDate,
        _ref$datePickerTheme = _ref.datePickerTheme,
        datePickerTheme = _ref$datePickerTheme === undefined ? {} : _ref$datePickerTheme,
        _ref$currentTheme = _ref.currentTheme,
        currentTheme = _ref$currentTheme === undefined ? 'default' : _ref$currentTheme,
        _ref$sendChosenDate = _ref.sendChosenDate,
        sendChosenDate = _ref$sendChosenDate === undefined ? function () {} : _ref$sendChosenDate;

    var currentDate = moment().format('DD.MM.YYYY');

    var _useState = useState(false),
        _useState2 = slicedToArray(_useState, 2),
        showDatePicker = _useState2[0],
        setShowDatePicker = _useState2[1];

    var _useState3 = useState(''),
        _useState4 = slicedToArray(_useState3, 2),
        selectedMode = _useState4[0],
        setSelectedMode = _useState4[1];

    var theme = themesMap$6[currentTheme];

    var _useState5 = useState(true),
        _useState6 = slicedToArray(_useState5, 2),
        disableShowButton = _useState6[0],
        setDisableShowButton = _useState6[1];

    var _useState7 = useState('dd.mm.åååå'),
        _useState8 = slicedToArray(_useState7, 2),
        dateFrom = _useState8[0],
        setDateFrom = _useState8[1];

    var _useState9 = useState(currentDate),
        _useState10 = slicedToArray(_useState9, 2),
        dateTo = _useState10[0],
        setDateTo = _useState10[1];

    var formatDateToRequest = function formatDateToRequest(date) {
        return moment(date, 'DD.MM.YYYY').format('DDMMYYYY');
    };

    var openDatePicker = function openDatePicker(mode) {
        if (mode === 'dateFrom') {
            setSelectedMode('dateFrom');
        } else {
            setSelectedMode('dateTo');
        }
        setShowDatePicker(true);
    };

    var _onDateSelected = function _onDateSelected(mode, date) {
        var dateFormatted = moment(date).format('DD.MM.YYYY');
        if (mode === 'dateFrom') {
            setDateFrom(dateFormatted);
            setDisableShowButton(moment(dateFormatted).isAfter(dateTo));
        } else {
            setDateTo(dateFormatted);
            setDisableShowButton(moment(dateFormatted).isBefore(dateFrom));
        }
        setShowDatePicker(false);
    };

    return React.createElement(
        ThemeProvider,
        { theme: theme },
        React.createElement(
            Wrapper$b,
            {
                height: '100%',
                justify: detectMobile() ? 'flex-end' : 'center',
                onClick: function onClick(e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            React.createElement(
                ChooseDateWrapper,
                null,
                showDatePicker ? React.createElement(
                    DatePickerWrapper,
                    {
                        bgColor: theme.colors.colorBackgroundDefault
                    },
                    React.createElement(DatePicker, {
                        maxDate: new Date(),
                        onDateSelected: function onDateSelected(date) {
                            _onDateSelected(selectedMode, date);
                            setShowDatePicker(false);
                        },
                        theme: theme,
                        datePickerTheme: datePickerTheme,
                        closeDatepicker: function closeDatepicker() {
                            return setShowDatePicker(false);
                        }
                    })
                ) : React.createElement(
                    Flex,
                    {
                        justify: 'flex-start',
                        align: 'center',
                        direction: 'column',
                        height: detectMobile() ? '310px' : '297px',
                        width: detectMobile() ? '100%' : '520px',
                        position: 'relative',
                        borderRadius: '8px',
                        bgColor: theme.colors.colorBackgroundDefault
                    },
                    detectMobile() && React.createElement(
                        WrapperCloseIcon,
                        { onClick: closeChooseDate },
                        React.createElement(Icon, {
                            height: '24px',
                            width: '24px',
                            src: CloseIcon$1,
                            color: theme.colors.colorIconSecondaryDefault
                        })
                    ),
                    React.createElement(
                        Text,
                        {
                            margin: '0',
                            size: 18,
                            bold: true,
                            boxSizing: 'border-box',
                            maxWidth: '100%',
                            padding: '16px',
                            width: '100%',
                            align: 'center',
                            color: theme.colors.colorTextPrimaryDefault
                        },
                        'V\xE6lg periode'
                    ),
                    React.createElement(HR$1, {
                        type: 'solid',
                        height: '1px',
                        color: theme.colors.colorBackgroundSurfaceTertiaryDefault
                    }),
                    React.createElement(
                        DateRangeWrapper,
                        { margin: '0' },
                        React.createElement(
                            DateRangeItem,
                            null,
                            React.createElement(
                                Text,
                                {
                                    size: 13,
                                    margin: '0',
                                    padding: '0 0 0 13px',
                                    color: theme.colors.basic,
                                    boxSizing: 'border-box',
                                    maxWidth: '100%'
                                },
                                'V\xE6lg startdato'
                            ),
                            React.createElement(
                                DateRangeInput,
                                {
                                    borderColor: theme.colors.colorBackgroundSurfaceTertiaryDefault,
                                    bgColor: theme.colors.colorBackgroundSurfacePrimaryDefault,
                                    onClick: function onClick() {
                                        return openDatePicker('dateFrom');
                                    }
                                },
                                React.createElement(
                                    Text,
                                    {
                                        size: 16,
                                        width: '100%',
                                        margin: '0',
                                        color: dateFrom === 'dd.mm.åååå' ? theme.colors.colorTextTertiaryDefault : theme.colors.basic,
                                        boxSizing: 'border-box',
                                        maxWidth: '100%'
                                    },
                                    dateFrom
                                ),
                                React.createElement(Icon, {
                                    height: '17px',
                                    width: '20px',
                                    ml: 1,
                                    src: calendarIcon,
                                    color: theme.colors.colorTextPrimaryDefault,
                                    alt: 'calendar'
                                })
                            )
                        ),
                        !detectMobile() && React.createElement(
                            Text,
                            {
                                width: 'auto',
                                margin: '0',
                                padding: '18px 16px 0'
                            },
                            '-'
                        ),
                        React.createElement(
                            DateRangeItem,
                            null,
                            React.createElement(
                                Text,
                                {
                                    size: 13,
                                    margin: '0',
                                    padding: '0 0 0 13px',
                                    color: theme.colors.basic,
                                    boxSizing: 'border-box',
                                    maxWidth: '100%'
                                },
                                'V\xE6lg slutdato'
                            ),
                            React.createElement(
                                DateRangeInput,
                                {
                                    borderColor: theme.colors.colorBackgroundSurfaceTertiaryDefault,
                                    bgColor: theme.colors.colorBackgroundSurfacePrimaryDefault,
                                    onClick: function onClick() {
                                        return openDatePicker('dateTo');
                                    }
                                },
                                React.createElement(
                                    Text,
                                    {
                                        width: '100%',
                                        margin: '0',
                                        color: dateTo === 'dd.mm.åååå' ? theme.colors.colorTextTertiaryDefault : theme.colors.basic,
                                        boxSizing: 'border-box',
                                        maxWidth: '100%',
                                        size: 16
                                    },
                                    dateTo
                                ),
                                React.createElement(Icon, {
                                    height: '17px',
                                    ml: 1,
                                    width: '20px',
                                    src: calendarIcon,
                                    color: theme.colors.colorTextPrimaryDefault,
                                    alt: 'calendar'
                                })
                            )
                        )
                    ),
                    React.createElement(AcceptAndCancelButtons$1, {
                        position: 'relative',
                        cancelAction: closeChooseDate,
                        disableAcceptButton: dateFrom === 'dd.mm.åååå' || disableShowButton,
                        acceptAction: function acceptAction() {
                            sendChosenDate({
                                dateFrom: formatDateToRequest(dateFrom),
                                dateTo: formatDateToRequest(dateTo)
                            });
                        },
                        borderRadius: detectMobile() ? '0' : '0 0 8px 8px'
                    })
                )
            )
        )
    );
};

ChooseDate.propTypes = {};

var _ref$t =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_32620_2710)"
}, React.createElement("path", {
  d: "M12 21c-4.915 0-9-4.085-9-9 0-4.924 4.076-9 8.991-9C16.915 3 21 7.076 21 12c0 4.915-4.076 9-9 9zm-.988-4.685c.3 0 .556-.142.74-.433l4.148-6.53c.106-.184.22-.387.22-.581 0-.415-.361-.68-.75-.68-.229 0-.458.141-.626.406l-3.768 6.053-1.79-2.312c-.221-.29-.415-.37-.671-.37a.712.712 0 00-.706.723c0 .203.08.397.212.574l2.214 2.717c.23.31.477.433.777.433z",
  fill: "#2C3036"
}));

var _ref2$g =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_32620_2710"
}, React.createElement("path", {
  fill: "#fff",
  transform: "translate(3 3)",
  d: "M0 0h18v18H0z"
})));

var defaultSuccessIconSrc = 'data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_32620_2710%29%22%3E%3Cpath%20d%3D%22M12%2021C7.08529%2021%203%2016.9147%203%2012C3%207.07647%207.07647%203%2011.9912%203C16.9147%203%2021%207.07647%2021%2012C21%2016.9147%2016.9235%2021%2012%2021ZM11.0118%2016.3147C11.3118%2016.3147%2011.5676%2016.1735%2011.7529%2015.8824L15.9%209.35294C16.0059%209.16765%2016.1206%208.96471%2016.1206%208.77059C16.1206%208.35588%2015.7588%208.09118%2015.3706%208.09118C15.1412%208.09118%2014.9118%208.23235%2014.7441%208.49706L10.9765%2014.55L9.18529%2012.2382C8.96471%2011.9471%208.77059%2011.8676%208.51471%2011.8676C8.11765%2011.8676%207.80882%2012.1941%207.80882%2012.5912C7.80882%2012.7941%207.88824%2012.9882%208.02059%2013.1647L10.2353%2015.8824C10.4647%2016.1912%2010.7118%2016.3147%2011.0118%2016.3147Z%22%20fill%3D%22%232C3036%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_32620_2710%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%20transform%3D%22translate%283%203%29%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E';

var SuccessModal = function SuccessModal(_ref) {
    var title = _ref.title,
        text = _ref.text,
        iconSrc = _ref.iconSrc,
        renderIcon = _ref.renderIcon,
        renderContent = _ref.renderContent,
        _ref$closeModal = _ref.closeModal,
        closeModal = _ref$closeModal === undefined ? function () {} : _ref$closeModal,
        _ref$currentTheme = _ref.currentTheme,
        currentTheme = _ref$currentTheme === undefined ? 'default' : _ref$currentTheme;

    var theme = themesMap$6[currentTheme];

    return React.createElement(
        ThemeProvider,
        { theme: theme },
        React.createElement(
            PopupContainer,
            {
                height: '100%',
                justify: detectMobile() ? 'flex-end' : 'center',
                direction: 'column',
                onClick: function onClick(e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            React.createElement(
                SuccessPopupContent,
                null,
                React.createElement(CloseButtonIcon$1, { click: closeModal, top: '36px' }),
                React.createElement(
                    SuccessPopupIconBlock,
                    null,
                    renderIcon ? renderIcon() : React.createElement(Icon, {
                        src: iconSrc || defaultSuccessIconSrc,
                        height: '112px',
                        width: '112px'
                    })
                ),
                title && React.createElement(
                    Text,
                    {
                        margin: '0',
                        padding: '0',
                        size: 18,
                        lineHeight: '28px',
                        bold: true,
                        color: theme.colors.colorTextPrimaryDefault,
                        align: 'center'
                    },
                    title
                ),
                text && !renderContent && React.createElement(
                    Text,
                    {
                        size: 13,
                        lineHeight: '20px',
                        margin: '16px 0 0',
                        padding: '0',
                        color: theme.colors.colorTextSecondaryDefault,
                        align: 'center'
                    },
                    text
                ),
                renderContent && renderContent(),
                React.createElement('hr', null),
                React.createElement(
                    Button$1,
                    {
                        color: theme.colors.colorTextPrimaryDefault,
                        radius: '4px',
                        onClick: closeModal
                    },
                    'OK'
                )
            )
        )
    );
};

/**
 * @param string {string}
 */
var prepareString = function prepareString(string$$1) {
    return string$$1.toLowerCase().trim();
};

/**
 * @param string {string}
 * @returns {string[]}
 */
var prepareArray = function prepareArray(string$$1) {
    return prepareString(string$$1).split(' ');
};

/**
 * @param arr {array}
 * @returns {boolean}
 */
var duplicatedValues = function duplicatedValues(arr) {
    return new Set(arr).size !== arr.length;
};

/**
 * @param field1 {string}
 * @param field2 {string}
 * @returns {boolean}
 */
var duplicatedTwoFields = function duplicatedTwoFields(field1, field2) {
    var prepareField1 = prepareArray(field1);
    var prepareField2 = prepareArray(field2);
    return duplicatedValues(prepareField1.concat(prepareField2));
};

/**
 * Checking match if at least `allowedTyposNumber` character wrong or length of words differs by 1 character or one of character were missed
 * @param original {string} Original word
 * @param stringToCompare {string} Copy word
 * @param allowedTyposNumber {number} Maximum amount of characters that can be match before throwing error
 * @returns {boolean}
 */
var compareStrings = function compareStrings(original, stringToCompare, allowedTyposNumber) {
    var shifted = false;

    var prepareLetters = function prepareLetters(word) {
        return word.replace(/[^\w]/g, '').toLowerCase().split('');
    };

    var originalValue = prepareLetters(original);
    var valueToCompare = prepareLetters(stringToCompare);

    var unmatchedChars = originalValue.filter(function (x, i) {
        if (valueToCompare[i] !== x && !shifted && allowedTyposNumber !== 0) {
            if (valueToCompare[i - 1] === x) {
                shifted = -1;
            } else if (valueToCompare[i + 1] === x) {
                shifted = 1;
            }
        }
        return valueToCompare[i + shifted] !== x;
    });

    return unmatchedChars.length <= allowedTyposNumber && Math.abs(originalValue.length - valueToCompare.length) <= allowedTyposNumber;
};

/**
 * Return result of comparing
 * @param nemIdValue {string} Original value from CPR
 * @param userValue {string} User value
 * @param allowedTyposNumber {number} Maximum amount of characters that can be match before throwing error
 * @param strictMode {boolean}
 * @returns {boolean}
 */
var compareWords = function compareWords(nemIdValue, userValue, allowedTyposNumber) {
    var strictMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    var nemIdInputWords = prepareArray(nemIdValue);
    var userInputWords = prepareArray(userValue);

    if (strictMode && duplicatedValues(userInputWords)) {
        return false;
    }

    var isValid = userInputWords.filter(function (userWord) {
        return !!nemIdInputWords.filter(function (nemIdWord) {
            return compareStrings(nemIdWord, userWord, allowedTyposNumber);
        }).length;
    });
    return strictMode ? !!isValid.length && userInputWords.length === isValid.length : !!isValid.length;
};

/**
 * @param nemIDAddress {string}
 * @param userAddress {string}
 * @param allowedTyposNumber {number}
 * @returns {boolean}
 */
var addressValidate = function addressValidate(nemIDAddress, userAddress, allowedTyposNumber) {
    var addressNumber = nemIDAddress.split(' ').find(function (x) {
        return x.match(/\d/);
    }).replace(/\D/g, ' ');
    var userAddressNumber = userAddress.split(' ').filter(function (x) {
        return x.match(/\d/);
    }).join(' ').replace(/\D/g, ' ');
    var addressNumberIndex = nemIDAddress.search(/\d/);
    var originalAddress = nemIDAddress.slice(0, addressNumberIndex).replace(/[,.]/g, ' ');

    var isAddressValid = compareWords(originalAddress, userAddress.replace(/[,.]/g, ' '), allowedTyposNumber, false);
    var isAddressNumberValid = compareWords(addressNumber, userAddressNumber, 0, false);

    return isAddressValid && isAddressNumberValid;
};

/**
 * Collecting errorFields object which contain fields with wrong data
 * @param nemIdData {object} Object with data provided by CPR
 * @param userData {object} Object from signup form
 * @param allowedTyposNumber {number} Maximum amount of characters that can be match before throwing error
 * @returns {object}
 */
var userDataValidation = function userDataValidation(nemIdData, userData, allowedTyposNumber) {
    var errorFields = {
        firstName: false,
        lastName: false,
        address: false,
        zip: false

        /**
         *  Detecting middle name that can be present in "firstName" and "lastName" fields
         */
    };var firstName = nemIdData.firstName;
    var middleName = firstName.split(' ').slice(1, firstName.length).join(' ');
    var lastName = middleName + ' ' + nemIdData.lastName;

    Object.keys(nemIdData).map(function (key) {
        switch (key) {
            case 'firstName':
                errorFields[key] = !compareWords(firstName, userData[key], allowedTyposNumber);
                break;
            case 'lastName':
                errorFields[key] = !compareWords(lastName, userData[key], allowedTyposNumber);
                break;
            case 'address':
                errorFields[key] = !addressValidate(nemIdData[key], userData[key], allowedTyposNumber);
                break;
            case 'zip':
                errorFields[key] = prepareString(nemIdData[key]) !== prepareString(userData[key]);
                break;
            default:
                break;
        }
    });

    /**
     *  Comparing two fields on duplicating names
     */
    if (!errorFields.firstName && !errorFields.lastName) {
        var duplicated = duplicatedTwoFields(userData.firstName, userData.lastName);
        errorFields.firstName = duplicated;
        errorFields.lastName = duplicated;
    }
    return errorFields;
};

// HOC

export { Sort, WithClock, WithTimer, WithClearSafariPageCache, Card, CardWrapper, FastDepositLimitForm, Input, LabeledInput, LastGamesCard, ProductsTransitionBar, DigitalClock, DigitalDisplay, DigitalTimer, Flex, Icon, Img, Spinner$1 as Spinner, Text, TopBar, Login, ForgotPassword, RestorePassword, LoginDesktop, CPRConfirmation, Withdraw, ActiveBonuses, ConfirmModal as RemoveBonusConfirm, TransferMoneyModal, UserHistory, ProfilePage as Profile, TransactionDetails, ChooseDate, ValidatingInput, SuccessModal, AnsvarligtSpil, thousandsDots, numberWithCommasAndDots, stripTrailinSymbol, trimBoth, saveJSONparsing, compareStrings, compareWords, addressValidate, userDataValidation, sizing, spacing, useFilteredState };
//# sourceMappingURL=index.es.js.map
